function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}
var $parcel$global =
typeof globalThis !== 'undefined'
  ? globalThis
  : typeof self !== 'undefined'
  ? self
  : typeof window !== 'undefined'
  ? window
  : typeof global !== 'undefined'
  ? global
  : {};
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire588d"];
if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire588d"] = parcelRequire;
}
parcelRequire.register("1b2ls", function(module, exports) {

$parcel$export(module.exports, "Fragment", () => $0db8a335f84591c1$export$ffb0004e005737fa, (v) => $0db8a335f84591c1$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "jsx", () => $0db8a335f84591c1$export$34b9dba7ce09269b, (v) => $0db8a335f84591c1$export$34b9dba7ce09269b = v);
$parcel$export(module.exports, "jsxs", () => $0db8a335f84591c1$export$25062201e9e25d76, (v) => $0db8a335f84591c1$export$25062201e9e25d76 = v);
/** @license React v17.0.2
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $0db8a335f84591c1$export$ffb0004e005737fa;
var $0db8a335f84591c1$export$34b9dba7ce09269b;
var $0db8a335f84591c1$export$25062201e9e25d76;
"use strict";
parcelRequire("8coUR");

var $acw62 = parcelRequire("acw62");
var $0db8a335f84591c1$var$g = 60103;
$0db8a335f84591c1$export$ffb0004e005737fa = 60107;
if ("function" === typeof Symbol && Symbol.for) {
    var $0db8a335f84591c1$var$h = Symbol.for;
    $0db8a335f84591c1$var$g = $0db8a335f84591c1$var$h("react.element");
    $0db8a335f84591c1$export$ffb0004e005737fa = $0db8a335f84591c1$var$h("react.fragment");
}
var $0db8a335f84591c1$var$m = $acw62.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, $0db8a335f84591c1$var$n = Object.prototype.hasOwnProperty, $0db8a335f84591c1$var$p = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $0db8a335f84591c1$var$q(c, a, k) {
    var b, d = {}, e = null, l = null;
    void 0 !== k && (e = "" + k);
    void 0 !== a.key && (e = "" + a.key);
    void 0 !== a.ref && (l = a.ref);
    for(b in a)$0db8a335f84591c1$var$n.call(a, b) && !$0db8a335f84591c1$var$p.hasOwnProperty(b) && (d[b] = a[b]);
    if (c && c.defaultProps) for(b in a = c.defaultProps, a)void 0 === d[b] && (d[b] = a[b]);
    return {
        $$typeof: $0db8a335f84591c1$var$g,
        type: c,
        key: e,
        ref: l,
        props: d,
        _owner: $0db8a335f84591c1$var$m.current
    };
}
$0db8a335f84591c1$export$34b9dba7ce09269b = $0db8a335f84591c1$var$q;
$0db8a335f84591c1$export$25062201e9e25d76 = $0db8a335f84591c1$var$q;

});
parcelRequire.register("8coUR", function(module, exports) {
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/ "use strict";
/* eslint-disable no-unused-vars */ var $5f82c58e3d599bd6$var$getOwnPropertySymbols = Object.getOwnPropertySymbols;
var $5f82c58e3d599bd6$var$hasOwnProperty = Object.prototype.hasOwnProperty;
var $5f82c58e3d599bd6$var$propIsEnumerable = Object.prototype.propertyIsEnumerable;
function $5f82c58e3d599bd6$var$toObject(val) {
    if (val === null || val === undefined) throw new TypeError("Object.assign cannot be called with null or undefined");
    return Object(val);
}
function $5f82c58e3d599bd6$var$shouldUseNative() {
    try {
        if (!Object.assign) return false;
        // Detect buggy property enumeration order in older V8 versions.
        // https://bugs.chromium.org/p/v8/issues/detail?id=4118
        var test1 = new String("abc"); // eslint-disable-line no-new-wrappers
        test1[5] = "de";
        if (Object.getOwnPropertyNames(test1)[0] === "5") return false;
        // https://bugs.chromium.org/p/v8/issues/detail?id=3056
        var test2 = {};
        for(var i = 0; i < 10; i++)test2["_" + String.fromCharCode(i)] = i;
        var order2 = Object.getOwnPropertyNames(test2).map(function(n) {
            return test2[n];
        });
        if (order2.join("") !== "0123456789") return false;
        // https://bugs.chromium.org/p/v8/issues/detail?id=3056
        var test3 = {};
        "abcdefghijklmnopqrst".split("").forEach(function(letter) {
            test3[letter] = letter;
        });
        if (Object.keys(Object.assign({}, test3)).join("") !== "abcdefghijklmnopqrst") return false;
        return true;
    } catch (err) {
        // We don't expect any of the above to throw, but better to be safe.
        return false;
    }
}
module.exports = $5f82c58e3d599bd6$var$shouldUseNative() ? Object.assign : function(target, source) {
    var from;
    var to = $5f82c58e3d599bd6$var$toObject(target);
    var symbols;
    for(var s = 1; s < arguments.length; s++){
        from = Object(arguments[s]);
        for(var key in from)if ($5f82c58e3d599bd6$var$hasOwnProperty.call(from, key)) to[key] = from[key];
        if ($5f82c58e3d599bd6$var$getOwnPropertySymbols) {
            symbols = $5f82c58e3d599bd6$var$getOwnPropertySymbols(from);
            for(var i = 0; i < symbols.length; i++)if ($5f82c58e3d599bd6$var$propIsEnumerable.call(from, symbols[i])) to[symbols[i]] = from[symbols[i]];
        }
    }
    return to;
};

});

parcelRequire.register("acw62", function(module, exports) {
"use strict";

module.exports = (parcelRequire("2pUnB"));

});
parcelRequire.register("2pUnB", function(module, exports) {

$parcel$export(module.exports, "Fragment", () => $1c29a66706a62afd$export$ffb0004e005737fa, (v) => $1c29a66706a62afd$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "StrictMode", () => $1c29a66706a62afd$export$5f8d39834fd61797, (v) => $1c29a66706a62afd$export$5f8d39834fd61797 = v);
$parcel$export(module.exports, "Profiler", () => $1c29a66706a62afd$export$e2c29f18771995cb, (v) => $1c29a66706a62afd$export$e2c29f18771995cb = v);
$parcel$export(module.exports, "Suspense", () => $1c29a66706a62afd$export$74bf444e3cd11ea5, (v) => $1c29a66706a62afd$export$74bf444e3cd11ea5 = v);
$parcel$export(module.exports, "Children", () => $1c29a66706a62afd$export$dca3b0875bd9a954, (v) => $1c29a66706a62afd$export$dca3b0875bd9a954 = v);
$parcel$export(module.exports, "Component", () => $1c29a66706a62afd$export$16fa2f45be04daa8, (v) => $1c29a66706a62afd$export$16fa2f45be04daa8 = v);
$parcel$export(module.exports, "PureComponent", () => $1c29a66706a62afd$export$221d75b3f55bb0bd, (v) => $1c29a66706a62afd$export$221d75b3f55bb0bd = v);
$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", () => $1c29a66706a62afd$export$ae55be85d98224ed, (v) => $1c29a66706a62afd$export$ae55be85d98224ed = v);
$parcel$export(module.exports, "cloneElement", () => $1c29a66706a62afd$export$e530037191fcd5d7, (v) => $1c29a66706a62afd$export$e530037191fcd5d7 = v);
$parcel$export(module.exports, "createContext", () => $1c29a66706a62afd$export$fd42f52fd3ae1109, (v) => $1c29a66706a62afd$export$fd42f52fd3ae1109 = v);
$parcel$export(module.exports, "createElement", () => $1c29a66706a62afd$export$c8a8987d4410bf2d, (v) => $1c29a66706a62afd$export$c8a8987d4410bf2d = v);
$parcel$export(module.exports, "createFactory", () => $1c29a66706a62afd$export$d38cd72104c1f0e9, (v) => $1c29a66706a62afd$export$d38cd72104c1f0e9 = v);
$parcel$export(module.exports, "createRef", () => $1c29a66706a62afd$export$7d1e3a5e95ceca43, (v) => $1c29a66706a62afd$export$7d1e3a5e95ceca43 = v);
$parcel$export(module.exports, "forwardRef", () => $1c29a66706a62afd$export$257a8862b851cb5b, (v) => $1c29a66706a62afd$export$257a8862b851cb5b = v);
$parcel$export(module.exports, "isValidElement", () => $1c29a66706a62afd$export$a8257692ac88316c, (v) => $1c29a66706a62afd$export$a8257692ac88316c = v);
$parcel$export(module.exports, "lazy", () => $1c29a66706a62afd$export$488013bae63b21da, (v) => $1c29a66706a62afd$export$488013bae63b21da = v);
$parcel$export(module.exports, "memo", () => $1c29a66706a62afd$export$7c73462e0d25e514, (v) => $1c29a66706a62afd$export$7c73462e0d25e514 = v);
$parcel$export(module.exports, "useCallback", () => $1c29a66706a62afd$export$35808ee640e87ca7, (v) => $1c29a66706a62afd$export$35808ee640e87ca7 = v);
$parcel$export(module.exports, "useContext", () => $1c29a66706a62afd$export$fae74005e78b1a27, (v) => $1c29a66706a62afd$export$fae74005e78b1a27 = v);
$parcel$export(module.exports, "useDebugValue", () => $1c29a66706a62afd$export$dc8fbce3eb94dc1e, (v) => $1c29a66706a62afd$export$dc8fbce3eb94dc1e = v);
$parcel$export(module.exports, "useEffect", () => $1c29a66706a62afd$export$6d9c69b0de29b591, (v) => $1c29a66706a62afd$export$6d9c69b0de29b591 = v);
$parcel$export(module.exports, "useImperativeHandle", () => $1c29a66706a62afd$export$d5a552a76deda3c2, (v) => $1c29a66706a62afd$export$d5a552a76deda3c2 = v);
$parcel$export(module.exports, "useLayoutEffect", () => $1c29a66706a62afd$export$e5c5a5f917a5871c, (v) => $1c29a66706a62afd$export$e5c5a5f917a5871c = v);
$parcel$export(module.exports, "useMemo", () => $1c29a66706a62afd$export$1538c33de8887b59, (v) => $1c29a66706a62afd$export$1538c33de8887b59 = v);
$parcel$export(module.exports, "useReducer", () => $1c29a66706a62afd$export$13e3392192263954, (v) => $1c29a66706a62afd$export$13e3392192263954 = v);
$parcel$export(module.exports, "useRef", () => $1c29a66706a62afd$export$b8f5890fc79d6aca, (v) => $1c29a66706a62afd$export$b8f5890fc79d6aca = v);
$parcel$export(module.exports, "useState", () => $1c29a66706a62afd$export$60241385465d0a34, (v) => $1c29a66706a62afd$export$60241385465d0a34 = v);
$parcel$export(module.exports, "version", () => $1c29a66706a62afd$export$83d89fbfd8236492, (v) => $1c29a66706a62afd$export$83d89fbfd8236492 = v);
/** @license React v17.0.2
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $1c29a66706a62afd$export$ffb0004e005737fa;
var $1c29a66706a62afd$export$5f8d39834fd61797;
var $1c29a66706a62afd$export$e2c29f18771995cb;
var $1c29a66706a62afd$export$74bf444e3cd11ea5;
var $1c29a66706a62afd$export$dca3b0875bd9a954;
var $1c29a66706a62afd$export$16fa2f45be04daa8;
var $1c29a66706a62afd$export$221d75b3f55bb0bd;
var $1c29a66706a62afd$export$ae55be85d98224ed;
var $1c29a66706a62afd$export$e530037191fcd5d7;
var $1c29a66706a62afd$export$fd42f52fd3ae1109;
var $1c29a66706a62afd$export$c8a8987d4410bf2d;
var $1c29a66706a62afd$export$d38cd72104c1f0e9;
var $1c29a66706a62afd$export$7d1e3a5e95ceca43;
var $1c29a66706a62afd$export$257a8862b851cb5b;
var $1c29a66706a62afd$export$a8257692ac88316c;
var $1c29a66706a62afd$export$488013bae63b21da;
var $1c29a66706a62afd$export$7c73462e0d25e514;
var $1c29a66706a62afd$export$35808ee640e87ca7;
var $1c29a66706a62afd$export$fae74005e78b1a27;
var $1c29a66706a62afd$export$dc8fbce3eb94dc1e;
var $1c29a66706a62afd$export$6d9c69b0de29b591;
var $1c29a66706a62afd$export$d5a552a76deda3c2;
var $1c29a66706a62afd$export$e5c5a5f917a5871c;
var $1c29a66706a62afd$export$1538c33de8887b59;
var $1c29a66706a62afd$export$13e3392192263954;
var $1c29a66706a62afd$export$b8f5890fc79d6aca;
var $1c29a66706a62afd$export$60241385465d0a34;
var $1c29a66706a62afd$export$83d89fbfd8236492;
"use strict";

var $8coUR = parcelRequire("8coUR");
var $1c29a66706a62afd$var$n = 60103, $1c29a66706a62afd$var$p = 60106;
$1c29a66706a62afd$export$ffb0004e005737fa = 60107;
$1c29a66706a62afd$export$5f8d39834fd61797 = 60108;
$1c29a66706a62afd$export$e2c29f18771995cb = 60114;
var $1c29a66706a62afd$var$q = 60109, $1c29a66706a62afd$var$r = 60110, $1c29a66706a62afd$var$t = 60112;
$1c29a66706a62afd$export$74bf444e3cd11ea5 = 60113;
var $1c29a66706a62afd$var$u = 60115, $1c29a66706a62afd$var$v = 60116;
if ("function" === typeof Symbol && Symbol.for) {
    var $1c29a66706a62afd$var$w = Symbol.for;
    $1c29a66706a62afd$var$n = $1c29a66706a62afd$var$w("react.element");
    $1c29a66706a62afd$var$p = $1c29a66706a62afd$var$w("react.portal");
    $1c29a66706a62afd$export$ffb0004e005737fa = $1c29a66706a62afd$var$w("react.fragment");
    $1c29a66706a62afd$export$5f8d39834fd61797 = $1c29a66706a62afd$var$w("react.strict_mode");
    $1c29a66706a62afd$export$e2c29f18771995cb = $1c29a66706a62afd$var$w("react.profiler");
    $1c29a66706a62afd$var$q = $1c29a66706a62afd$var$w("react.provider");
    $1c29a66706a62afd$var$r = $1c29a66706a62afd$var$w("react.context");
    $1c29a66706a62afd$var$t = $1c29a66706a62afd$var$w("react.forward_ref");
    $1c29a66706a62afd$export$74bf444e3cd11ea5 = $1c29a66706a62afd$var$w("react.suspense");
    $1c29a66706a62afd$var$u = $1c29a66706a62afd$var$w("react.memo");
    $1c29a66706a62afd$var$v = $1c29a66706a62afd$var$w("react.lazy");
}
var $1c29a66706a62afd$var$x = "function" === typeof Symbol && Symbol.iterator;
function $1c29a66706a62afd$var$y(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $1c29a66706a62afd$var$x && a[$1c29a66706a62afd$var$x] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
function $1c29a66706a62afd$var$z(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
var $1c29a66706a62afd$var$A = {
    isMounted: function() {
        return !1;
    },
    enqueueForceUpdate: function() {},
    enqueueReplaceState: function() {},
    enqueueSetState: function() {}
}, $1c29a66706a62afd$var$B = {};
function $1c29a66706a62afd$var$C(a, b, c) {
    this.props = a;
    this.context = b;
    this.refs = $1c29a66706a62afd$var$B;
    this.updater = c || $1c29a66706a62afd$var$A;
}
$1c29a66706a62afd$var$C.prototype.isReactComponent = {};
$1c29a66706a62afd$var$C.prototype.setState = function(a, b) {
    if ("object" !== typeof a && "function" !== typeof a && null != a) throw Error($1c29a66706a62afd$var$z(85));
    this.updater.enqueueSetState(this, a, b, "setState");
};
$1c29a66706a62afd$var$C.prototype.forceUpdate = function(a) {
    this.updater.enqueueForceUpdate(this, a, "forceUpdate");
};
function $1c29a66706a62afd$var$D() {}
$1c29a66706a62afd$var$D.prototype = $1c29a66706a62afd$var$C.prototype;
function $1c29a66706a62afd$var$E(a, b, c) {
    this.props = a;
    this.context = b;
    this.refs = $1c29a66706a62afd$var$B;
    this.updater = c || $1c29a66706a62afd$var$A;
}
var $1c29a66706a62afd$var$F = $1c29a66706a62afd$var$E.prototype = new $1c29a66706a62afd$var$D;
$1c29a66706a62afd$var$F.constructor = $1c29a66706a62afd$var$E;
$8coUR($1c29a66706a62afd$var$F, $1c29a66706a62afd$var$C.prototype);
$1c29a66706a62afd$var$F.isPureReactComponent = !0;
var $1c29a66706a62afd$var$G = {
    current: null
}, $1c29a66706a62afd$var$H = Object.prototype.hasOwnProperty, $1c29a66706a62afd$var$I = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $1c29a66706a62afd$var$J(a, b, c) {
    var e, d = {}, k = null, h = null;
    if (null != b) for(e in void 0 !== b.ref && (h = b.ref), void 0 !== b.key && (k = "" + b.key), b)$1c29a66706a62afd$var$H.call(b, e) && !$1c29a66706a62afd$var$I.hasOwnProperty(e) && (d[e] = b[e]);
    var g = arguments.length - 2;
    if (1 === g) d.children = c;
    else if (1 < g) {
        for(var f = Array(g), m = 0; m < g; m++)f[m] = arguments[m + 2];
        d.children = f;
    }
    if (a && a.defaultProps) for(e in g = a.defaultProps, g)void 0 === d[e] && (d[e] = g[e]);
    return {
        $$typeof: $1c29a66706a62afd$var$n,
        type: a,
        key: k,
        ref: h,
        props: d,
        _owner: $1c29a66706a62afd$var$G.current
    };
}
function $1c29a66706a62afd$var$K(a, b) {
    return {
        $$typeof: $1c29a66706a62afd$var$n,
        type: a.type,
        key: b,
        ref: a.ref,
        props: a.props,
        _owner: a._owner
    };
}
function $1c29a66706a62afd$var$L(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $1c29a66706a62afd$var$n;
}
function $1c29a66706a62afd$var$escape(a) {
    var b = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + a.replace(/[=:]/g, function(a) {
        return b[a];
    });
}
var $1c29a66706a62afd$var$M = /\/+/g;
function $1c29a66706a62afd$var$N(a, b) {
    return "object" === typeof a && null !== a && null != a.key ? $1c29a66706a62afd$var$escape("" + a.key) : b.toString(36);
}
function $1c29a66706a62afd$var$O(a, b, c, e, d) {
    var k = typeof a;
    if ("undefined" === k || "boolean" === k) a = null;
    var h = !1;
    if (null === a) h = !0;
    else switch(k){
        case "string":
        case "number":
            h = !0;
            break;
        case "object":
            switch(a.$$typeof){
                case $1c29a66706a62afd$var$n:
                case $1c29a66706a62afd$var$p:
                    h = !0;
            }
    }
    if (h) return h = a, d = d(h), a = "" === e ? "." + $1c29a66706a62afd$var$N(h, 0) : e, Array.isArray(d) ? (c = "", null != a && (c = a.replace($1c29a66706a62afd$var$M, "$&/") + "/"), $1c29a66706a62afd$var$O(d, b, c, "", function(a) {
        return a;
    })) : null != d && ($1c29a66706a62afd$var$L(d) && (d = $1c29a66706a62afd$var$K(d, c + (!d.key || h && h.key === d.key ? "" : ("" + d.key).replace($1c29a66706a62afd$var$M, "$&/") + "/") + a)), b.push(d)), 1;
    h = 0;
    e = "" === e ? "." : e + ":";
    if (Array.isArray(a)) for(var g = 0; g < a.length; g++){
        k = a[g];
        var f = e + $1c29a66706a62afd$var$N(k, g);
        h += $1c29a66706a62afd$var$O(k, b, c, f, d);
    }
    else if (f = $1c29a66706a62afd$var$y(a), "function" === typeof f) for(a = f.call(a), g = 0; !(k = a.next()).done;)k = k.value, f = e + $1c29a66706a62afd$var$N(k, g++), h += $1c29a66706a62afd$var$O(k, b, c, f, d);
    else if ("object" === k) throw b = "" + a, Error($1c29a66706a62afd$var$z(31, "[object Object]" === b ? "object with keys {" + Object.keys(a).join(", ") + "}" : b));
    return h;
}
function $1c29a66706a62afd$var$P(a, b, c) {
    if (null == a) return a;
    var e = [], d = 0;
    $1c29a66706a62afd$var$O(a, e, "", "", function(a) {
        return b.call(c, a, d++);
    });
    return e;
}
function $1c29a66706a62afd$var$Q(a) {
    if (-1 === a._status) {
        var b = a._result;
        b = b();
        a._status = 0;
        a._result = b;
        b.then(function(b) {
            0 === a._status && (b = b.default, a._status = 1, a._result = b);
        }, function(b) {
            0 === a._status && (a._status = 2, a._result = b);
        });
    }
    if (1 === a._status) return a._result;
    throw a._result;
}
var $1c29a66706a62afd$var$R = {
    current: null
};
function $1c29a66706a62afd$var$S() {
    var a = $1c29a66706a62afd$var$R.current;
    if (null === a) throw Error($1c29a66706a62afd$var$z(321));
    return a;
}
var $1c29a66706a62afd$var$T = {
    ReactCurrentDispatcher: $1c29a66706a62afd$var$R,
    ReactCurrentBatchConfig: {
        transition: 0
    },
    ReactCurrentOwner: $1c29a66706a62afd$var$G,
    IsSomeRendererActing: {
        current: !1
    },
    assign: $8coUR
};
$1c29a66706a62afd$export$dca3b0875bd9a954 = {
    map: $1c29a66706a62afd$var$P,
    forEach: function(a, b, c) {
        $1c29a66706a62afd$var$P(a, function() {
            b.apply(this, arguments);
        }, c);
    },
    count: function(a) {
        var b = 0;
        $1c29a66706a62afd$var$P(a, function() {
            b++;
        });
        return b;
    },
    toArray: function(a) {
        return $1c29a66706a62afd$var$P(a, function(a) {
            return a;
        }) || [];
    },
    only: function(a) {
        if (!$1c29a66706a62afd$var$L(a)) throw Error($1c29a66706a62afd$var$z(143));
        return a;
    }
};
$1c29a66706a62afd$export$16fa2f45be04daa8 = $1c29a66706a62afd$var$C;
$1c29a66706a62afd$export$221d75b3f55bb0bd = $1c29a66706a62afd$var$E;
$1c29a66706a62afd$export$ae55be85d98224ed = $1c29a66706a62afd$var$T;
$1c29a66706a62afd$export$e530037191fcd5d7 = function(a, b, c) {
    if (null === a || void 0 === a) throw Error($1c29a66706a62afd$var$z(267, a));
    var e = $8coUR({}, a.props), d = a.key, k = a.ref, h = a._owner;
    if (null != b) {
        void 0 !== b.ref && (k = b.ref, h = $1c29a66706a62afd$var$G.current);
        void 0 !== b.key && (d = "" + b.key);
        if (a.type && a.type.defaultProps) var g = a.type.defaultProps;
        for(f in b)$1c29a66706a62afd$var$H.call(b, f) && !$1c29a66706a62afd$var$I.hasOwnProperty(f) && (e[f] = void 0 === b[f] && void 0 !== g ? g[f] : b[f]);
    }
    var f = arguments.length - 2;
    if (1 === f) e.children = c;
    else if (1 < f) {
        g = Array(f);
        for(var m = 0; m < f; m++)g[m] = arguments[m + 2];
        e.children = g;
    }
    return {
        $$typeof: $1c29a66706a62afd$var$n,
        type: a.type,
        key: d,
        ref: k,
        props: e,
        _owner: h
    };
};
$1c29a66706a62afd$export$fd42f52fd3ae1109 = function(a, b) {
    void 0 === b && (b = null);
    a = {
        $$typeof: $1c29a66706a62afd$var$r,
        _calculateChangedBits: b,
        _currentValue: a,
        _currentValue2: a,
        _threadCount: 0,
        Provider: null,
        Consumer: null
    };
    a.Provider = {
        $$typeof: $1c29a66706a62afd$var$q,
        _context: a
    };
    return a.Consumer = a;
};
$1c29a66706a62afd$export$c8a8987d4410bf2d = $1c29a66706a62afd$var$J;
$1c29a66706a62afd$export$d38cd72104c1f0e9 = function(a) {
    var b = $1c29a66706a62afd$var$J.bind(null, a);
    b.type = a;
    return b;
};
$1c29a66706a62afd$export$7d1e3a5e95ceca43 = function() {
    return {
        current: null
    };
};
$1c29a66706a62afd$export$257a8862b851cb5b = function(a) {
    return {
        $$typeof: $1c29a66706a62afd$var$t,
        render: a
    };
};
$1c29a66706a62afd$export$a8257692ac88316c = $1c29a66706a62afd$var$L;
$1c29a66706a62afd$export$488013bae63b21da = function(a) {
    return {
        $$typeof: $1c29a66706a62afd$var$v,
        _payload: {
            _status: -1,
            _result: a
        },
        _init: $1c29a66706a62afd$var$Q
    };
};
$1c29a66706a62afd$export$7c73462e0d25e514 = function(a, b) {
    return {
        $$typeof: $1c29a66706a62afd$var$u,
        type: a,
        compare: void 0 === b ? null : b
    };
};
$1c29a66706a62afd$export$35808ee640e87ca7 = function(a, b) {
    return $1c29a66706a62afd$var$S().useCallback(a, b);
};
$1c29a66706a62afd$export$fae74005e78b1a27 = function(a, b) {
    return $1c29a66706a62afd$var$S().useContext(a, b);
};
$1c29a66706a62afd$export$dc8fbce3eb94dc1e = function() {};
$1c29a66706a62afd$export$6d9c69b0de29b591 = function(a, b) {
    return $1c29a66706a62afd$var$S().useEffect(a, b);
};
$1c29a66706a62afd$export$d5a552a76deda3c2 = function(a, b, c) {
    return $1c29a66706a62afd$var$S().useImperativeHandle(a, b, c);
};
$1c29a66706a62afd$export$e5c5a5f917a5871c = function(a, b) {
    return $1c29a66706a62afd$var$S().useLayoutEffect(a, b);
};
$1c29a66706a62afd$export$1538c33de8887b59 = function(a, b) {
    return $1c29a66706a62afd$var$S().useMemo(a, b);
};
$1c29a66706a62afd$export$13e3392192263954 = function(a, b, c) {
    return $1c29a66706a62afd$var$S().useReducer(a, b, c);
};
$1c29a66706a62afd$export$b8f5890fc79d6aca = function(a) {
    return $1c29a66706a62afd$var$S().useRef(a);
};
$1c29a66706a62afd$export$60241385465d0a34 = function(a) {
    return $1c29a66706a62afd$var$S().useState(a);
};
$1c29a66706a62afd$export$83d89fbfd8236492 = "17.0.2";

});



parcelRequire.register("Xw6Mv", function(module, exports) {

$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", () => $0b2e6adb871a3b94$export$ae55be85d98224ed, (v) => $0b2e6adb871a3b94$export$ae55be85d98224ed = v);
$parcel$export(module.exports, "createPortal", () => $0b2e6adb871a3b94$export$d39a5bbd09211389, (v) => $0b2e6adb871a3b94$export$d39a5bbd09211389 = v);
$parcel$export(module.exports, "findDOMNode", () => $0b2e6adb871a3b94$export$466bfc07425424d5, (v) => $0b2e6adb871a3b94$export$466bfc07425424d5 = v);
$parcel$export(module.exports, "flushSync", () => $0b2e6adb871a3b94$export$cd75ccfd720a3cd4, (v) => $0b2e6adb871a3b94$export$cd75ccfd720a3cd4 = v);
$parcel$export(module.exports, "hydrate", () => $0b2e6adb871a3b94$export$fa8d919ba61d84db, (v) => $0b2e6adb871a3b94$export$fa8d919ba61d84db = v);
$parcel$export(module.exports, "render", () => $0b2e6adb871a3b94$export$b3890eb0ae9dca99, (v) => $0b2e6adb871a3b94$export$b3890eb0ae9dca99 = v);
$parcel$export(module.exports, "unmountComponentAtNode", () => $0b2e6adb871a3b94$export$502457920280e6be, (v) => $0b2e6adb871a3b94$export$502457920280e6be = v);
$parcel$export(module.exports, "unstable_batchedUpdates", () => $0b2e6adb871a3b94$export$c78a37762a8d58e1, (v) => $0b2e6adb871a3b94$export$c78a37762a8d58e1 = v);
$parcel$export(module.exports, "unstable_createPortal", () => $0b2e6adb871a3b94$export$2577ef5d2565d52f, (v) => $0b2e6adb871a3b94$export$2577ef5d2565d52f = v);
$parcel$export(module.exports, "unstable_renderSubtreeIntoContainer", () => $0b2e6adb871a3b94$export$dc54d992c10e8a18, (v) => $0b2e6adb871a3b94$export$dc54d992c10e8a18 = v);
$parcel$export(module.exports, "version", () => $0b2e6adb871a3b94$export$83d89fbfd8236492, (v) => $0b2e6adb871a3b94$export$83d89fbfd8236492 = v);
/** @license React v17.0.2
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ var $0b2e6adb871a3b94$export$ae55be85d98224ed;
var $0b2e6adb871a3b94$export$d39a5bbd09211389;
var $0b2e6adb871a3b94$export$466bfc07425424d5;
var $0b2e6adb871a3b94$export$cd75ccfd720a3cd4;
var $0b2e6adb871a3b94$export$fa8d919ba61d84db;
var $0b2e6adb871a3b94$export$b3890eb0ae9dca99;
var $0b2e6adb871a3b94$export$502457920280e6be;
var $0b2e6adb871a3b94$export$c78a37762a8d58e1;
var $0b2e6adb871a3b94$export$2577ef5d2565d52f;
var $0b2e6adb871a3b94$export$dc54d992c10e8a18;
var $0b2e6adb871a3b94$export$83d89fbfd8236492;
"use strict";

var $acw62 = parcelRequire("acw62");

var $8coUR = parcelRequire("8coUR");

var $fO90s = parcelRequire("fO90s");
function $0b2e6adb871a3b94$var$y(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
if (!$acw62) throw Error($0b2e6adb871a3b94$var$y(227));
var $0b2e6adb871a3b94$var$ba = new Set, $0b2e6adb871a3b94$var$ca = {};
function $0b2e6adb871a3b94$var$da(a, b) {
    $0b2e6adb871a3b94$var$ea(a, b);
    $0b2e6adb871a3b94$var$ea(a + "Capture", b);
}
function $0b2e6adb871a3b94$var$ea(a, b) {
    $0b2e6adb871a3b94$var$ca[a] = b;
    for(a = 0; a < b.length; a++)$0b2e6adb871a3b94$var$ba.add(b[a]);
}
var $0b2e6adb871a3b94$var$fa = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), $0b2e6adb871a3b94$var$ha = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, $0b2e6adb871a3b94$var$ia = Object.prototype.hasOwnProperty, $0b2e6adb871a3b94$var$ja = {}, $0b2e6adb871a3b94$var$ka = {};
function $0b2e6adb871a3b94$var$la(a) {
    if ($0b2e6adb871a3b94$var$ia.call($0b2e6adb871a3b94$var$ka, a)) return !0;
    if ($0b2e6adb871a3b94$var$ia.call($0b2e6adb871a3b94$var$ja, a)) return !1;
    if ($0b2e6adb871a3b94$var$ha.test(a)) return $0b2e6adb871a3b94$var$ka[a] = !0;
    $0b2e6adb871a3b94$var$ja[a] = !0;
    return !1;
}
function $0b2e6adb871a3b94$var$ma(a, b, c, d) {
    if (null !== c && 0 === c.type) return !1;
    switch(typeof b){
        case "function":
        case "symbol":
            return !0;
        case "boolean":
            if (d) return !1;
            if (null !== c) return !c.acceptsBooleans;
            a = a.toLowerCase().slice(0, 5);
            return "data-" !== a && "aria-" !== a;
        default:
            return !1;
    }
}
function $0b2e6adb871a3b94$var$na(a, b, c, d) {
    if (null === b || "undefined" === typeof b || $0b2e6adb871a3b94$var$ma(a, b, c, d)) return !0;
    if (d) return !1;
    if (null !== c) switch(c.type){
        case 3:
            return !b;
        case 4:
            return !1 === b;
        case 5:
            return isNaN(b);
        case 6:
            return isNaN(b) || 1 > b;
    }
    return !1;
}
function $0b2e6adb871a3b94$var$B(a, b, c, d, e, f, g) {
    this.acceptsBooleans = 2 === b || 3 === b || 4 === b;
    this.attributeName = d;
    this.attributeNamespace = e;
    this.mustUseProperty = c;
    this.propertyName = a;
    this.type = b;
    this.sanitizeURL = f;
    this.removeEmptyString = g;
}
var $0b2e6adb871a3b94$var$D = {};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a) {
    $0b2e6adb871a3b94$var$D[a] = new $0b2e6adb871a3b94$var$B(a, 0, !1, a, null, !1, !1);
});
[
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "className",
        "class"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ]
].forEach(function(a) {
    var b = a[0];
    $0b2e6adb871a3b94$var$D[b] = new $0b2e6adb871a3b94$var$B(b, 1, !1, a[1], null, !1, !1);
});
[
    "contentEditable",
    "draggable",
    "spellCheck",
    "value"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$D[a] = new $0b2e6adb871a3b94$var$B(a, 2, !1, a.toLowerCase(), null, !1, !1);
});
[
    "autoReverse",
    "externalResourcesRequired",
    "focusable",
    "preserveAlpha"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$D[a] = new $0b2e6adb871a3b94$var$B(a, 2, !1, a, null, !1, !1);
});
"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a) {
    $0b2e6adb871a3b94$var$D[a] = new $0b2e6adb871a3b94$var$B(a, 3, !1, a.toLowerCase(), null, !1, !1);
});
[
    "checked",
    "multiple",
    "muted",
    "selected"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$D[a] = new $0b2e6adb871a3b94$var$B(a, 3, !0, a, null, !1, !1);
});
[
    "capture",
    "download"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$D[a] = new $0b2e6adb871a3b94$var$B(a, 4, !1, a, null, !1, !1);
});
[
    "cols",
    "rows",
    "size",
    "span"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$D[a] = new $0b2e6adb871a3b94$var$B(a, 6, !1, a, null, !1, !1);
});
[
    "rowSpan",
    "start"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$D[a] = new $0b2e6adb871a3b94$var$B(a, 5, !1, a.toLowerCase(), null, !1, !1);
});
var $0b2e6adb871a3b94$var$oa = /[\-:]([a-z])/g;
function $0b2e6adb871a3b94$var$pa(a) {
    return a[1].toUpperCase();
}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a) {
    var b = a.replace($0b2e6adb871a3b94$var$oa, $0b2e6adb871a3b94$var$pa);
    $0b2e6adb871a3b94$var$D[b] = new $0b2e6adb871a3b94$var$B(b, 1, !1, a, null, !1, !1);
});
"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a) {
    var b = a.replace($0b2e6adb871a3b94$var$oa, $0b2e6adb871a3b94$var$pa);
    $0b2e6adb871a3b94$var$D[b] = new $0b2e6adb871a3b94$var$B(b, 1, !1, a, "http://www.w3.org/1999/xlink", !1, !1);
});
[
    "xml:base",
    "xml:lang",
    "xml:space"
].forEach(function(a) {
    var b = a.replace($0b2e6adb871a3b94$var$oa, $0b2e6adb871a3b94$var$pa);
    $0b2e6adb871a3b94$var$D[b] = new $0b2e6adb871a3b94$var$B(b, 1, !1, a, "http://www.w3.org/XML/1998/namespace", !1, !1);
});
[
    "tabIndex",
    "crossOrigin"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$D[a] = new $0b2e6adb871a3b94$var$B(a, 1, !1, a.toLowerCase(), null, !1, !1);
});
$0b2e6adb871a3b94$var$D.xlinkHref = new $0b2e6adb871a3b94$var$B("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0, !1);
[
    "src",
    "href",
    "action",
    "formAction"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$D[a] = new $0b2e6adb871a3b94$var$B(a, 1, !1, a.toLowerCase(), null, !0, !0);
});
function $0b2e6adb871a3b94$var$qa(a, b, c, d) {
    var e = $0b2e6adb871a3b94$var$D.hasOwnProperty(b) ? $0b2e6adb871a3b94$var$D[b] : null;
    var f = null !== e ? 0 === e.type : d ? !1 : !(2 < b.length) || "o" !== b[0] && "O" !== b[0] || "n" !== b[1] && "N" !== b[1] ? !1 : !0;
    f || ($0b2e6adb871a3b94$var$na(b, c, e, d) && (c = null), d || null === e ? $0b2e6adb871a3b94$var$la(b) && (null === c ? a.removeAttribute(b) : a.setAttribute(b, "" + c)) : e.mustUseProperty ? a[e.propertyName] = null === c ? 3 === e.type ? !1 : "" : c : (b = e.attributeName, d = e.attributeNamespace, null === c ? a.removeAttribute(b) : (e = e.type, c = 3 === e || 4 === e && !0 === c ? "" : "" + c, d ? a.setAttributeNS(d, b, c) : a.setAttribute(b, c))));
}
var $0b2e6adb871a3b94$var$ra = $acw62.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED, $0b2e6adb871a3b94$var$sa = 60103, $0b2e6adb871a3b94$var$ta = 60106, $0b2e6adb871a3b94$var$ua = 60107, $0b2e6adb871a3b94$var$wa = 60108, $0b2e6adb871a3b94$var$xa = 60114, $0b2e6adb871a3b94$var$ya = 60109, $0b2e6adb871a3b94$var$za = 60110, $0b2e6adb871a3b94$var$Aa = 60112, $0b2e6adb871a3b94$var$Ba = 60113, $0b2e6adb871a3b94$var$Ca = 60120, $0b2e6adb871a3b94$var$Da = 60115, $0b2e6adb871a3b94$var$Ea = 60116, $0b2e6adb871a3b94$var$Fa = 60121, $0b2e6adb871a3b94$var$Ga = 60128, $0b2e6adb871a3b94$var$Ha = 60129, $0b2e6adb871a3b94$var$Ia = 60130, $0b2e6adb871a3b94$var$Ja = 60131;
if ("function" === typeof Symbol && Symbol.for) {
    var $0b2e6adb871a3b94$var$E = Symbol.for;
    $0b2e6adb871a3b94$var$sa = $0b2e6adb871a3b94$var$E("react.element");
    $0b2e6adb871a3b94$var$ta = $0b2e6adb871a3b94$var$E("react.portal");
    $0b2e6adb871a3b94$var$ua = $0b2e6adb871a3b94$var$E("react.fragment");
    $0b2e6adb871a3b94$var$wa = $0b2e6adb871a3b94$var$E("react.strict_mode");
    $0b2e6adb871a3b94$var$xa = $0b2e6adb871a3b94$var$E("react.profiler");
    $0b2e6adb871a3b94$var$ya = $0b2e6adb871a3b94$var$E("react.provider");
    $0b2e6adb871a3b94$var$za = $0b2e6adb871a3b94$var$E("react.context");
    $0b2e6adb871a3b94$var$Aa = $0b2e6adb871a3b94$var$E("react.forward_ref");
    $0b2e6adb871a3b94$var$Ba = $0b2e6adb871a3b94$var$E("react.suspense");
    $0b2e6adb871a3b94$var$Ca = $0b2e6adb871a3b94$var$E("react.suspense_list");
    $0b2e6adb871a3b94$var$Da = $0b2e6adb871a3b94$var$E("react.memo");
    $0b2e6adb871a3b94$var$Ea = $0b2e6adb871a3b94$var$E("react.lazy");
    $0b2e6adb871a3b94$var$Fa = $0b2e6adb871a3b94$var$E("react.block");
    $0b2e6adb871a3b94$var$E("react.scope");
    $0b2e6adb871a3b94$var$Ga = $0b2e6adb871a3b94$var$E("react.opaque.id");
    $0b2e6adb871a3b94$var$Ha = $0b2e6adb871a3b94$var$E("react.debug_trace_mode");
    $0b2e6adb871a3b94$var$Ia = $0b2e6adb871a3b94$var$E("react.offscreen");
    $0b2e6adb871a3b94$var$Ja = $0b2e6adb871a3b94$var$E("react.legacy_hidden");
}
var $0b2e6adb871a3b94$var$Ka = "function" === typeof Symbol && Symbol.iterator;
function $0b2e6adb871a3b94$var$La(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $0b2e6adb871a3b94$var$Ka && a[$0b2e6adb871a3b94$var$Ka] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $0b2e6adb871a3b94$var$Ma;
function $0b2e6adb871a3b94$var$Na(a) {
    if (void 0 === $0b2e6adb871a3b94$var$Ma) try {
        throw Error();
    } catch (c) {
        var b = c.stack.trim().match(/\n( *(at )?)/);
        $0b2e6adb871a3b94$var$Ma = b && b[1] || "";
    }
    return "\n" + $0b2e6adb871a3b94$var$Ma + a;
}
var $0b2e6adb871a3b94$var$Oa = !1;
function $0b2e6adb871a3b94$var$Pa(a, b) {
    if (!a || $0b2e6adb871a3b94$var$Oa) return "";
    $0b2e6adb871a3b94$var$Oa = !0;
    var c = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
        if (b) {
            if (b = function() {
                throw Error();
            }, Object.defineProperty(b.prototype, "props", {
                set: function() {
                    throw Error();
                }
            }), "object" === typeof Reflect && Reflect.construct) {
                try {
                    Reflect.construct(b, []);
                } catch (k) {
                    var d = k;
                }
                Reflect.construct(a, [], b);
            } else {
                try {
                    b.call();
                } catch (k) {
                    d = k;
                }
                a.call(b.prototype);
            }
        } else {
            try {
                throw Error();
            } catch (k) {
                d = k;
            }
            a();
        }
    } catch (k) {
        if (k && d && "string" === typeof k.stack) {
            for(var e = k.stack.split("\n"), f = d.stack.split("\n"), g = e.length - 1, h = f.length - 1; 1 <= g && 0 <= h && e[g] !== f[h];)h--;
            for(; 1 <= g && 0 <= h; g--, h--)if (e[g] !== f[h]) {
                if (1 !== g || 1 !== h) {
                    do if (g--, h--, 0 > h || e[g] !== f[h]) return "\n" + e[g].replace(" at new ", " at ");
                    while (1 <= g && 0 <= h);
                }
                break;
            }
        }
    } finally{
        $0b2e6adb871a3b94$var$Oa = !1, Error.prepareStackTrace = c;
    }
    return (a = a ? a.displayName || a.name : "") ? $0b2e6adb871a3b94$var$Na(a) : "";
}
function $0b2e6adb871a3b94$var$Qa(a) {
    switch(a.tag){
        case 5:
            return $0b2e6adb871a3b94$var$Na(a.type);
        case 16:
            return $0b2e6adb871a3b94$var$Na("Lazy");
        case 13:
            return $0b2e6adb871a3b94$var$Na("Suspense");
        case 19:
            return $0b2e6adb871a3b94$var$Na("SuspenseList");
        case 0:
        case 2:
        case 15:
            return a = $0b2e6adb871a3b94$var$Pa(a.type, !1), a;
        case 11:
            return a = $0b2e6adb871a3b94$var$Pa(a.type.render, !1), a;
        case 22:
            return a = $0b2e6adb871a3b94$var$Pa(a.type._render, !1), a;
        case 1:
            return a = $0b2e6adb871a3b94$var$Pa(a.type, !0), a;
        default:
            return "";
    }
}
function $0b2e6adb871a3b94$var$Ra(a) {
    if (null == a) return null;
    if ("function" === typeof a) return a.displayName || a.name || null;
    if ("string" === typeof a) return a;
    switch(a){
        case $0b2e6adb871a3b94$var$ua:
            return "Fragment";
        case $0b2e6adb871a3b94$var$ta:
            return "Portal";
        case $0b2e6adb871a3b94$var$xa:
            return "Profiler";
        case $0b2e6adb871a3b94$var$wa:
            return "StrictMode";
        case $0b2e6adb871a3b94$var$Ba:
            return "Suspense";
        case $0b2e6adb871a3b94$var$Ca:
            return "SuspenseList";
    }
    if ("object" === typeof a) switch(a.$$typeof){
        case $0b2e6adb871a3b94$var$za:
            return (a.displayName || "Context") + ".Consumer";
        case $0b2e6adb871a3b94$var$ya:
            return (a._context.displayName || "Context") + ".Provider";
        case $0b2e6adb871a3b94$var$Aa:
            var b = a.render;
            b = b.displayName || b.name || "";
            return a.displayName || ("" !== b ? "ForwardRef(" + b + ")" : "ForwardRef");
        case $0b2e6adb871a3b94$var$Da:
            return $0b2e6adb871a3b94$var$Ra(a.type);
        case $0b2e6adb871a3b94$var$Fa:
            return $0b2e6adb871a3b94$var$Ra(a._render);
        case $0b2e6adb871a3b94$var$Ea:
            b = a._payload;
            a = a._init;
            try {
                return $0b2e6adb871a3b94$var$Ra(a(b));
            } catch (c) {}
    }
    return null;
}
function $0b2e6adb871a3b94$var$Sa(a) {
    switch(typeof a){
        case "boolean":
        case "number":
        case "object":
        case "string":
        case "undefined":
            return a;
        default:
            return "";
    }
}
function $0b2e6adb871a3b94$var$Ta(a) {
    var b = a.type;
    return (a = a.nodeName) && "input" === a.toLowerCase() && ("checkbox" === b || "radio" === b);
}
function $0b2e6adb871a3b94$var$Ua(a) {
    var b = $0b2e6adb871a3b94$var$Ta(a) ? "checked" : "value", c = Object.getOwnPropertyDescriptor(a.constructor.prototype, b), d = "" + a[b];
    if (!a.hasOwnProperty(b) && "undefined" !== typeof c && "function" === typeof c.get && "function" === typeof c.set) {
        var e = c.get, f = c.set;
        Object.defineProperty(a, b, {
            configurable: !0,
            get: function() {
                return e.call(this);
            },
            set: function(a) {
                d = "" + a;
                f.call(this, a);
            }
        });
        Object.defineProperty(a, b, {
            enumerable: c.enumerable
        });
        return {
            getValue: function() {
                return d;
            },
            setValue: function(a) {
                d = "" + a;
            },
            stopTracking: function() {
                a._valueTracker = null;
                delete a[b];
            }
        };
    }
}
function $0b2e6adb871a3b94$var$Va(a) {
    a._valueTracker || (a._valueTracker = $0b2e6adb871a3b94$var$Ua(a));
}
function $0b2e6adb871a3b94$var$Wa(a) {
    if (!a) return !1;
    var b = a._valueTracker;
    if (!b) return !0;
    var c = b.getValue();
    var d = "";
    a && (d = $0b2e6adb871a3b94$var$Ta(a) ? a.checked ? "true" : "false" : a.value);
    a = d;
    return a !== c ? (b.setValue(a), !0) : !1;
}
function $0b2e6adb871a3b94$var$Xa(a) {
    a = a || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof a) return null;
    try {
        return a.activeElement || a.body;
    } catch (b) {
        return a.body;
    }
}
function $0b2e6adb871a3b94$var$Ya(a, b) {
    var c = b.checked;
    return $8coUR({}, b, {
        defaultChecked: void 0,
        defaultValue: void 0,
        value: void 0,
        checked: null != c ? c : a._wrapperState.initialChecked
    });
}
function $0b2e6adb871a3b94$var$Za(a, b) {
    var c = null == b.defaultValue ? "" : b.defaultValue, d = null != b.checked ? b.checked : b.defaultChecked;
    c = $0b2e6adb871a3b94$var$Sa(null != b.value ? b.value : c);
    a._wrapperState = {
        initialChecked: d,
        initialValue: c,
        controlled: "checkbox" === b.type || "radio" === b.type ? null != b.checked : null != b.value
    };
}
function $0b2e6adb871a3b94$var$$a(a, b) {
    b = b.checked;
    null != b && $0b2e6adb871a3b94$var$qa(a, "checked", b, !1);
}
function $0b2e6adb871a3b94$var$ab(a, b) {
    $0b2e6adb871a3b94$var$$a(a, b);
    var c = $0b2e6adb871a3b94$var$Sa(b.value), d = b.type;
    if (null != c) {
        if ("number" === d) {
            if (0 === c && "" === a.value || a.value != c) a.value = "" + c;
        } else a.value !== "" + c && (a.value = "" + c);
    } else if ("submit" === d || "reset" === d) {
        a.removeAttribute("value");
        return;
    }
    b.hasOwnProperty("value") ? $0b2e6adb871a3b94$var$bb(a, b.type, c) : b.hasOwnProperty("defaultValue") && $0b2e6adb871a3b94$var$bb(a, b.type, $0b2e6adb871a3b94$var$Sa(b.defaultValue));
    null == b.checked && null != b.defaultChecked && (a.defaultChecked = !!b.defaultChecked);
}
function $0b2e6adb871a3b94$var$cb(a, b, c) {
    if (b.hasOwnProperty("value") || b.hasOwnProperty("defaultValue")) {
        var d = b.type;
        if (!("submit" !== d && "reset" !== d || void 0 !== b.value && null !== b.value)) return;
        b = "" + a._wrapperState.initialValue;
        c || b === a.value || (a.value = b);
        a.defaultValue = b;
    }
    c = a.name;
    "" !== c && (a.name = "");
    a.defaultChecked = !!a._wrapperState.initialChecked;
    "" !== c && (a.name = c);
}
function $0b2e6adb871a3b94$var$bb(a, b, c) {
    if ("number" !== b || $0b2e6adb871a3b94$var$Xa(a.ownerDocument) !== a) null == c ? a.defaultValue = "" + a._wrapperState.initialValue : a.defaultValue !== "" + c && (a.defaultValue = "" + c);
}
function $0b2e6adb871a3b94$var$db(a) {
    var b = "";
    $acw62.Children.forEach(a, function(a) {
        null != a && (b += a);
    });
    return b;
}
function $0b2e6adb871a3b94$var$eb(a, b) {
    a = $8coUR({
        children: void 0
    }, b);
    if (b = $0b2e6adb871a3b94$var$db(b.children)) a.children = b;
    return a;
}
function $0b2e6adb871a3b94$var$fb(a, b, c, d) {
    a = a.options;
    if (b) {
        b = {};
        for(var e = 0; e < c.length; e++)b["$" + c[e]] = !0;
        for(c = 0; c < a.length; c++)e = b.hasOwnProperty("$" + a[c].value), a[c].selected !== e && (a[c].selected = e), e && d && (a[c].defaultSelected = !0);
    } else {
        c = "" + $0b2e6adb871a3b94$var$Sa(c);
        b = null;
        for(e = 0; e < a.length; e++){
            if (a[e].value === c) {
                a[e].selected = !0;
                d && (a[e].defaultSelected = !0);
                return;
            }
            null !== b || a[e].disabled || (b = a[e]);
        }
        null !== b && (b.selected = !0);
    }
}
function $0b2e6adb871a3b94$var$gb(a, b) {
    if (null != b.dangerouslySetInnerHTML) throw Error($0b2e6adb871a3b94$var$y(91));
    return $8coUR({}, b, {
        value: void 0,
        defaultValue: void 0,
        children: "" + a._wrapperState.initialValue
    });
}
function $0b2e6adb871a3b94$var$hb(a, b) {
    var c = b.value;
    if (null == c) {
        c = b.children;
        b = b.defaultValue;
        if (null != c) {
            if (null != b) throw Error($0b2e6adb871a3b94$var$y(92));
            if (Array.isArray(c)) {
                if (!(1 >= c.length)) throw Error($0b2e6adb871a3b94$var$y(93));
                c = c[0];
            }
            b = c;
        }
        null == b && (b = "");
        c = b;
    }
    a._wrapperState = {
        initialValue: $0b2e6adb871a3b94$var$Sa(c)
    };
}
function $0b2e6adb871a3b94$var$ib(a, b) {
    var c = $0b2e6adb871a3b94$var$Sa(b.value), d = $0b2e6adb871a3b94$var$Sa(b.defaultValue);
    null != c && (c = "" + c, c !== a.value && (a.value = c), null == b.defaultValue && a.defaultValue !== c && (a.defaultValue = c));
    null != d && (a.defaultValue = "" + d);
}
function $0b2e6adb871a3b94$var$jb(a) {
    var b = a.textContent;
    b === a._wrapperState.initialValue && "" !== b && null !== b && (a.value = b);
}
var $0b2e6adb871a3b94$var$kb = {
    html: "http://www.w3.org/1999/xhtml",
    mathml: "http://www.w3.org/1998/Math/MathML",
    svg: "http://www.w3.org/2000/svg"
};
function $0b2e6adb871a3b94$var$lb(a) {
    switch(a){
        case "svg":
            return "http://www.w3.org/2000/svg";
        case "math":
            return "http://www.w3.org/1998/Math/MathML";
        default:
            return "http://www.w3.org/1999/xhtml";
    }
}
function $0b2e6adb871a3b94$var$mb(a, b) {
    return null == a || "http://www.w3.org/1999/xhtml" === a ? $0b2e6adb871a3b94$var$lb(b) : "http://www.w3.org/2000/svg" === a && "foreignObject" === b ? "http://www.w3.org/1999/xhtml" : a;
}
var $0b2e6adb871a3b94$var$nb, $0b2e6adb871a3b94$var$ob = function(a) {
    return "undefined" !== typeof MSApp && MSApp.execUnsafeLocalFunction ? function(b, c, d, e) {
        MSApp.execUnsafeLocalFunction(function() {
            return a(b, c, d, e);
        });
    } : a;
}(function(a, b) {
    if (a.namespaceURI !== $0b2e6adb871a3b94$var$kb.svg || "innerHTML" in a) a.innerHTML = b;
    else {
        $0b2e6adb871a3b94$var$nb = $0b2e6adb871a3b94$var$nb || document.createElement("div");
        $0b2e6adb871a3b94$var$nb.innerHTML = "<svg>" + b.valueOf().toString() + "</svg>";
        for(b = $0b2e6adb871a3b94$var$nb.firstChild; a.firstChild;)a.removeChild(a.firstChild);
        for(; b.firstChild;)a.appendChild(b.firstChild);
    }
});
function $0b2e6adb871a3b94$var$pb(a, b) {
    if (b) {
        var c = a.firstChild;
        if (c && c === a.lastChild && 3 === c.nodeType) {
            c.nodeValue = b;
            return;
        }
    }
    a.textContent = b;
}
var $0b2e6adb871a3b94$var$qb = {
    animationIterationCount: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridArea: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
}, $0b2e6adb871a3b94$var$rb = [
    "Webkit",
    "ms",
    "Moz",
    "O"
];
Object.keys($0b2e6adb871a3b94$var$qb).forEach(function(a) {
    $0b2e6adb871a3b94$var$rb.forEach(function(b) {
        b = b + a.charAt(0).toUpperCase() + a.substring(1);
        $0b2e6adb871a3b94$var$qb[b] = $0b2e6adb871a3b94$var$qb[a];
    });
});
function $0b2e6adb871a3b94$var$sb(a, b, c) {
    return null == b || "boolean" === typeof b || "" === b ? "" : c || "number" !== typeof b || 0 === b || $0b2e6adb871a3b94$var$qb.hasOwnProperty(a) && $0b2e6adb871a3b94$var$qb[a] ? ("" + b).trim() : b + "px";
}
function $0b2e6adb871a3b94$var$tb(a, b) {
    a = a.style;
    for(var c in b)if (b.hasOwnProperty(c)) {
        var d = 0 === c.indexOf("--"), e = $0b2e6adb871a3b94$var$sb(c, b[c], d);
        "float" === c && (c = "cssFloat");
        d ? a.setProperty(c, e) : a[c] = e;
    }
}
var $0b2e6adb871a3b94$var$ub = $8coUR({
    menuitem: !0
}, {
    area: !0,
    base: !0,
    br: !0,
    col: !0,
    embed: !0,
    hr: !0,
    img: !0,
    input: !0,
    keygen: !0,
    link: !0,
    meta: !0,
    param: !0,
    source: !0,
    track: !0,
    wbr: !0
});
function $0b2e6adb871a3b94$var$vb(a, b) {
    if (b) {
        if ($0b2e6adb871a3b94$var$ub[a] && (null != b.children || null != b.dangerouslySetInnerHTML)) throw Error($0b2e6adb871a3b94$var$y(137, a));
        if (null != b.dangerouslySetInnerHTML) {
            if (null != b.children) throw Error($0b2e6adb871a3b94$var$y(60));
            if (!("object" === typeof b.dangerouslySetInnerHTML && "__html" in b.dangerouslySetInnerHTML)) throw Error($0b2e6adb871a3b94$var$y(61));
        }
        if (null != b.style && "object" !== typeof b.style) throw Error($0b2e6adb871a3b94$var$y(62));
    }
}
function $0b2e6adb871a3b94$var$wb(a, b) {
    if (-1 === a.indexOf("-")) return "string" === typeof b.is;
    switch(a){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
function $0b2e6adb871a3b94$var$xb(a) {
    a = a.target || a.srcElement || window;
    a.correspondingUseElement && (a = a.correspondingUseElement);
    return 3 === a.nodeType ? a.parentNode : a;
}
var $0b2e6adb871a3b94$var$yb = null, $0b2e6adb871a3b94$var$zb = null, $0b2e6adb871a3b94$var$Ab = null;
function $0b2e6adb871a3b94$var$Bb(a) {
    if (a = $0b2e6adb871a3b94$var$Cb(a)) {
        if ("function" !== typeof $0b2e6adb871a3b94$var$yb) throw Error($0b2e6adb871a3b94$var$y(280));
        var b = a.stateNode;
        b && (b = $0b2e6adb871a3b94$var$Db(b), $0b2e6adb871a3b94$var$yb(a.stateNode, a.type, b));
    }
}
function $0b2e6adb871a3b94$var$Eb(a) {
    $0b2e6adb871a3b94$var$zb ? $0b2e6adb871a3b94$var$Ab ? $0b2e6adb871a3b94$var$Ab.push(a) : $0b2e6adb871a3b94$var$Ab = [
        a
    ] : $0b2e6adb871a3b94$var$zb = a;
}
function $0b2e6adb871a3b94$var$Fb() {
    if ($0b2e6adb871a3b94$var$zb) {
        var a = $0b2e6adb871a3b94$var$zb, b = $0b2e6adb871a3b94$var$Ab;
        $0b2e6adb871a3b94$var$Ab = $0b2e6adb871a3b94$var$zb = null;
        $0b2e6adb871a3b94$var$Bb(a);
        if (b) for(a = 0; a < b.length; a++)$0b2e6adb871a3b94$var$Bb(b[a]);
    }
}
function $0b2e6adb871a3b94$var$Gb(a, b) {
    return a(b);
}
function $0b2e6adb871a3b94$var$Hb(a, b, c, d, e) {
    return a(b, c, d, e);
}
function $0b2e6adb871a3b94$var$Ib() {}
var $0b2e6adb871a3b94$var$Jb = $0b2e6adb871a3b94$var$Gb, $0b2e6adb871a3b94$var$Kb = !1, $0b2e6adb871a3b94$var$Lb = !1;
function $0b2e6adb871a3b94$var$Mb() {
    if (null !== $0b2e6adb871a3b94$var$zb || null !== $0b2e6adb871a3b94$var$Ab) $0b2e6adb871a3b94$var$Ib(), $0b2e6adb871a3b94$var$Fb();
}
function $0b2e6adb871a3b94$var$Nb(a, b, c) {
    if ($0b2e6adb871a3b94$var$Lb) return a(b, c);
    $0b2e6adb871a3b94$var$Lb = !0;
    try {
        return $0b2e6adb871a3b94$var$Jb(a, b, c);
    } finally{
        $0b2e6adb871a3b94$var$Lb = !1, $0b2e6adb871a3b94$var$Mb();
    }
}
function $0b2e6adb871a3b94$var$Ob(a, b) {
    var c = a.stateNode;
    if (null === c) return null;
    var d = $0b2e6adb871a3b94$var$Db(c);
    if (null === d) return null;
    c = d[b];
    a: switch(b){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (d = !d.disabled) || (a = a.type, d = !("button" === a || "input" === a || "select" === a || "textarea" === a));
            a = !d;
            break a;
        default:
            a = !1;
    }
    if (a) return null;
    if (c && "function" !== typeof c) throw Error($0b2e6adb871a3b94$var$y(231, b, typeof c));
    return c;
}
var $0b2e6adb871a3b94$var$Pb = !1;
if ($0b2e6adb871a3b94$var$fa) try {
    var $0b2e6adb871a3b94$var$Qb = {};
    Object.defineProperty($0b2e6adb871a3b94$var$Qb, "passive", {
        get: function() {
            $0b2e6adb871a3b94$var$Pb = !0;
        }
    });
    window.addEventListener("test", $0b2e6adb871a3b94$var$Qb, $0b2e6adb871a3b94$var$Qb);
    window.removeEventListener("test", $0b2e6adb871a3b94$var$Qb, $0b2e6adb871a3b94$var$Qb);
} catch (a) {
    $0b2e6adb871a3b94$var$Pb = !1;
}
function $0b2e6adb871a3b94$var$Rb(a, b, c, d, e, f, g, h, k) {
    var l = Array.prototype.slice.call(arguments, 3);
    try {
        b.apply(c, l);
    } catch (n) {
        this.onError(n);
    }
}
var $0b2e6adb871a3b94$var$Sb = !1, $0b2e6adb871a3b94$var$Tb = null, $0b2e6adb871a3b94$var$Ub = !1, $0b2e6adb871a3b94$var$Vb = null, $0b2e6adb871a3b94$var$Wb = {
    onError: function(a) {
        $0b2e6adb871a3b94$var$Sb = !0;
        $0b2e6adb871a3b94$var$Tb = a;
    }
};
function $0b2e6adb871a3b94$var$Xb(a, b, c, d, e, f, g, h, k) {
    $0b2e6adb871a3b94$var$Sb = !1;
    $0b2e6adb871a3b94$var$Tb = null;
    $0b2e6adb871a3b94$var$Rb.apply($0b2e6adb871a3b94$var$Wb, arguments);
}
function $0b2e6adb871a3b94$var$Yb(a, b, c, d, e, f, g, h, k) {
    $0b2e6adb871a3b94$var$Xb.apply(this, arguments);
    if ($0b2e6adb871a3b94$var$Sb) {
        if ($0b2e6adb871a3b94$var$Sb) {
            var l = $0b2e6adb871a3b94$var$Tb;
            $0b2e6adb871a3b94$var$Sb = !1;
            $0b2e6adb871a3b94$var$Tb = null;
        } else throw Error($0b2e6adb871a3b94$var$y(198));
        $0b2e6adb871a3b94$var$Ub || ($0b2e6adb871a3b94$var$Ub = !0, $0b2e6adb871a3b94$var$Vb = l);
    }
}
function $0b2e6adb871a3b94$var$Zb(a) {
    var b = a, c = a;
    if (a.alternate) for(; b.return;)b = b.return;
    else {
        a = b;
        do b = a, 0 !== (b.flags & 1026) && (c = b.return), a = b.return;
        while (a);
    }
    return 3 === b.tag ? c : null;
}
function $0b2e6adb871a3b94$var$$b(a) {
    if (13 === a.tag) {
        var b = a.memoizedState;
        null === b && (a = a.alternate, null !== a && (b = a.memoizedState));
        if (null !== b) return b.dehydrated;
    }
    return null;
}
function $0b2e6adb871a3b94$var$ac(a) {
    if ($0b2e6adb871a3b94$var$Zb(a) !== a) throw Error($0b2e6adb871a3b94$var$y(188));
}
function $0b2e6adb871a3b94$var$bc(a) {
    var b = a.alternate;
    if (!b) {
        b = $0b2e6adb871a3b94$var$Zb(a);
        if (null === b) throw Error($0b2e6adb871a3b94$var$y(188));
        return b !== a ? null : a;
    }
    for(var c = a, d = b;;){
        var e = c.return;
        if (null === e) break;
        var f = e.alternate;
        if (null === f) {
            d = e.return;
            if (null !== d) {
                c = d;
                continue;
            }
            break;
        }
        if (e.child === f.child) {
            for(f = e.child; f;){
                if (f === c) return $0b2e6adb871a3b94$var$ac(e), a;
                if (f === d) return $0b2e6adb871a3b94$var$ac(e), b;
                f = f.sibling;
            }
            throw Error($0b2e6adb871a3b94$var$y(188));
        }
        if (c.return !== d.return) c = e, d = f;
        else {
            for(var g = !1, h = e.child; h;){
                if (h === c) {
                    g = !0;
                    c = e;
                    d = f;
                    break;
                }
                if (h === d) {
                    g = !0;
                    d = e;
                    c = f;
                    break;
                }
                h = h.sibling;
            }
            if (!g) {
                for(h = f.child; h;){
                    if (h === c) {
                        g = !0;
                        c = f;
                        d = e;
                        break;
                    }
                    if (h === d) {
                        g = !0;
                        d = f;
                        c = e;
                        break;
                    }
                    h = h.sibling;
                }
                if (!g) throw Error($0b2e6adb871a3b94$var$y(189));
            }
        }
        if (c.alternate !== d) throw Error($0b2e6adb871a3b94$var$y(190));
    }
    if (3 !== c.tag) throw Error($0b2e6adb871a3b94$var$y(188));
    return c.stateNode.current === c ? a : b;
}
function $0b2e6adb871a3b94$var$cc(a) {
    a = $0b2e6adb871a3b94$var$bc(a);
    if (!a) return null;
    for(var b = a;;){
        if (5 === b.tag || 6 === b.tag) return b;
        if (b.child) b.child.return = b, b = b.child;
        else {
            if (b === a) break;
            for(; !b.sibling;){
                if (!b.return || b.return === a) return null;
                b = b.return;
            }
            b.sibling.return = b.return;
            b = b.sibling;
        }
    }
    return null;
}
function $0b2e6adb871a3b94$var$dc(a, b) {
    for(var c = a.alternate; null !== b;){
        if (b === a || b === c) return !0;
        b = b.return;
    }
    return !1;
}
var $0b2e6adb871a3b94$var$ec, $0b2e6adb871a3b94$var$fc, $0b2e6adb871a3b94$var$gc, $0b2e6adb871a3b94$var$hc, $0b2e6adb871a3b94$var$ic = !1, $0b2e6adb871a3b94$var$jc = [], $0b2e6adb871a3b94$var$kc = null, $0b2e6adb871a3b94$var$lc = null, $0b2e6adb871a3b94$var$mc = null, $0b2e6adb871a3b94$var$nc = new Map, $0b2e6adb871a3b94$var$oc = new Map, $0b2e6adb871a3b94$var$pc = [], $0b2e6adb871a3b94$var$qc = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset submit".split(" ");
function $0b2e6adb871a3b94$var$rc(a, b, c, d, e) {
    return {
        blockedOn: a,
        domEventName: b,
        eventSystemFlags: c | 16,
        nativeEvent: e,
        targetContainers: [
            d
        ]
    };
}
function $0b2e6adb871a3b94$var$sc(a, b) {
    switch(a){
        case "focusin":
        case "focusout":
            $0b2e6adb871a3b94$var$kc = null;
            break;
        case "dragenter":
        case "dragleave":
            $0b2e6adb871a3b94$var$lc = null;
            break;
        case "mouseover":
        case "mouseout":
            $0b2e6adb871a3b94$var$mc = null;
            break;
        case "pointerover":
        case "pointerout":
            $0b2e6adb871a3b94$var$nc.delete(b.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            $0b2e6adb871a3b94$var$oc.delete(b.pointerId);
    }
}
function $0b2e6adb871a3b94$var$tc(a, b, c, d, e, f) {
    if (null === a || a.nativeEvent !== f) return a = $0b2e6adb871a3b94$var$rc(b, c, d, e, f), null !== b && (b = $0b2e6adb871a3b94$var$Cb(b), null !== b && $0b2e6adb871a3b94$var$fc(b)), a;
    a.eventSystemFlags |= d;
    b = a.targetContainers;
    null !== e && -1 === b.indexOf(e) && b.push(e);
    return a;
}
function $0b2e6adb871a3b94$var$uc(a, b, c, d, e) {
    switch(b){
        case "focusin":
            return $0b2e6adb871a3b94$var$kc = $0b2e6adb871a3b94$var$tc($0b2e6adb871a3b94$var$kc, a, b, c, d, e), !0;
        case "dragenter":
            return $0b2e6adb871a3b94$var$lc = $0b2e6adb871a3b94$var$tc($0b2e6adb871a3b94$var$lc, a, b, c, d, e), !0;
        case "mouseover":
            return $0b2e6adb871a3b94$var$mc = $0b2e6adb871a3b94$var$tc($0b2e6adb871a3b94$var$mc, a, b, c, d, e), !0;
        case "pointerover":
            var f = e.pointerId;
            $0b2e6adb871a3b94$var$nc.set(f, $0b2e6adb871a3b94$var$tc($0b2e6adb871a3b94$var$nc.get(f) || null, a, b, c, d, e));
            return !0;
        case "gotpointercapture":
            return f = e.pointerId, $0b2e6adb871a3b94$var$oc.set(f, $0b2e6adb871a3b94$var$tc($0b2e6adb871a3b94$var$oc.get(f) || null, a, b, c, d, e)), !0;
    }
    return !1;
}
function $0b2e6adb871a3b94$var$vc(a) {
    var b = $0b2e6adb871a3b94$var$wc(a.target);
    if (null !== b) {
        var c = $0b2e6adb871a3b94$var$Zb(b);
        if (null !== c) {
            if (b = c.tag, 13 === b) {
                if (b = $0b2e6adb871a3b94$var$$b(c), null !== b) {
                    a.blockedOn = b;
                    $0b2e6adb871a3b94$var$hc(a.lanePriority, function() {
                        $fO90s.unstable_runWithPriority(a.priority, function() {
                            $0b2e6adb871a3b94$var$gc(c);
                        });
                    });
                    return;
                }
            } else if (3 === b && c.stateNode.hydrate) {
                a.blockedOn = 3 === c.tag ? c.stateNode.containerInfo : null;
                return;
            }
        }
    }
    a.blockedOn = null;
}
function $0b2e6adb871a3b94$var$xc(a) {
    if (null !== a.blockedOn) return !1;
    for(var b = a.targetContainers; 0 < b.length;){
        var c = $0b2e6adb871a3b94$var$yc(a.domEventName, a.eventSystemFlags, b[0], a.nativeEvent);
        if (null !== c) return b = $0b2e6adb871a3b94$var$Cb(c), null !== b && $0b2e6adb871a3b94$var$fc(b), a.blockedOn = c, !1;
        b.shift();
    }
    return !0;
}
function $0b2e6adb871a3b94$var$zc(a, b, c) {
    $0b2e6adb871a3b94$var$xc(a) && c.delete(b);
}
function $0b2e6adb871a3b94$var$Ac() {
    for($0b2e6adb871a3b94$var$ic = !1; 0 < $0b2e6adb871a3b94$var$jc.length;){
        var a = $0b2e6adb871a3b94$var$jc[0];
        if (null !== a.blockedOn) {
            a = $0b2e6adb871a3b94$var$Cb(a.blockedOn);
            null !== a && $0b2e6adb871a3b94$var$ec(a);
            break;
        }
        for(var b = a.targetContainers; 0 < b.length;){
            var c = $0b2e6adb871a3b94$var$yc(a.domEventName, a.eventSystemFlags, b[0], a.nativeEvent);
            if (null !== c) {
                a.blockedOn = c;
                break;
            }
            b.shift();
        }
        null === a.blockedOn && $0b2e6adb871a3b94$var$jc.shift();
    }
    null !== $0b2e6adb871a3b94$var$kc && $0b2e6adb871a3b94$var$xc($0b2e6adb871a3b94$var$kc) && ($0b2e6adb871a3b94$var$kc = null);
    null !== $0b2e6adb871a3b94$var$lc && $0b2e6adb871a3b94$var$xc($0b2e6adb871a3b94$var$lc) && ($0b2e6adb871a3b94$var$lc = null);
    null !== $0b2e6adb871a3b94$var$mc && $0b2e6adb871a3b94$var$xc($0b2e6adb871a3b94$var$mc) && ($0b2e6adb871a3b94$var$mc = null);
    $0b2e6adb871a3b94$var$nc.forEach($0b2e6adb871a3b94$var$zc);
    $0b2e6adb871a3b94$var$oc.forEach($0b2e6adb871a3b94$var$zc);
}
function $0b2e6adb871a3b94$var$Bc(a, b) {
    a.blockedOn === b && (a.blockedOn = null, $0b2e6adb871a3b94$var$ic || ($0b2e6adb871a3b94$var$ic = !0, $fO90s.unstable_scheduleCallback($fO90s.unstable_NormalPriority, $0b2e6adb871a3b94$var$Ac)));
}
function $0b2e6adb871a3b94$var$Cc(a) {
    function b(b) {
        return $0b2e6adb871a3b94$var$Bc(b, a);
    }
    if (0 < $0b2e6adb871a3b94$var$jc.length) {
        $0b2e6adb871a3b94$var$Bc($0b2e6adb871a3b94$var$jc[0], a);
        for(var c = 1; c < $0b2e6adb871a3b94$var$jc.length; c++){
            var d = $0b2e6adb871a3b94$var$jc[c];
            d.blockedOn === a && (d.blockedOn = null);
        }
    }
    null !== $0b2e6adb871a3b94$var$kc && $0b2e6adb871a3b94$var$Bc($0b2e6adb871a3b94$var$kc, a);
    null !== $0b2e6adb871a3b94$var$lc && $0b2e6adb871a3b94$var$Bc($0b2e6adb871a3b94$var$lc, a);
    null !== $0b2e6adb871a3b94$var$mc && $0b2e6adb871a3b94$var$Bc($0b2e6adb871a3b94$var$mc, a);
    $0b2e6adb871a3b94$var$nc.forEach(b);
    $0b2e6adb871a3b94$var$oc.forEach(b);
    for(c = 0; c < $0b2e6adb871a3b94$var$pc.length; c++)d = $0b2e6adb871a3b94$var$pc[c], d.blockedOn === a && (d.blockedOn = null);
    for(; 0 < $0b2e6adb871a3b94$var$pc.length && (c = $0b2e6adb871a3b94$var$pc[0], null === c.blockedOn);)$0b2e6adb871a3b94$var$vc(c), null === c.blockedOn && $0b2e6adb871a3b94$var$pc.shift();
}
function $0b2e6adb871a3b94$var$Dc(a, b) {
    var c = {};
    c[a.toLowerCase()] = b.toLowerCase();
    c["Webkit" + a] = "webkit" + b;
    c["Moz" + a] = "moz" + b;
    return c;
}
var $0b2e6adb871a3b94$var$Ec = {
    animationend: $0b2e6adb871a3b94$var$Dc("Animation", "AnimationEnd"),
    animationiteration: $0b2e6adb871a3b94$var$Dc("Animation", "AnimationIteration"),
    animationstart: $0b2e6adb871a3b94$var$Dc("Animation", "AnimationStart"),
    transitionend: $0b2e6adb871a3b94$var$Dc("Transition", "TransitionEnd")
}, $0b2e6adb871a3b94$var$Fc = {}, $0b2e6adb871a3b94$var$Gc = {};
$0b2e6adb871a3b94$var$fa && ($0b2e6adb871a3b94$var$Gc = document.createElement("div").style, "AnimationEvent" in window || (delete $0b2e6adb871a3b94$var$Ec.animationend.animation, delete $0b2e6adb871a3b94$var$Ec.animationiteration.animation, delete $0b2e6adb871a3b94$var$Ec.animationstart.animation), "TransitionEvent" in window || delete $0b2e6adb871a3b94$var$Ec.transitionend.transition);
function $0b2e6adb871a3b94$var$Hc(a) {
    if ($0b2e6adb871a3b94$var$Fc[a]) return $0b2e6adb871a3b94$var$Fc[a];
    if (!$0b2e6adb871a3b94$var$Ec[a]) return a;
    var b = $0b2e6adb871a3b94$var$Ec[a], c;
    for(c in b)if (b.hasOwnProperty(c) && c in $0b2e6adb871a3b94$var$Gc) return $0b2e6adb871a3b94$var$Fc[a] = b[c];
    return a;
}
var $0b2e6adb871a3b94$var$Ic = $0b2e6adb871a3b94$var$Hc("animationend"), $0b2e6adb871a3b94$var$Jc = $0b2e6adb871a3b94$var$Hc("animationiteration"), $0b2e6adb871a3b94$var$Kc = $0b2e6adb871a3b94$var$Hc("animationstart"), $0b2e6adb871a3b94$var$Lc = $0b2e6adb871a3b94$var$Hc("transitionend"), $0b2e6adb871a3b94$var$Mc = new Map, $0b2e6adb871a3b94$var$Nc = new Map, $0b2e6adb871a3b94$var$Oc = [
    "abort",
    "abort",
    $0b2e6adb871a3b94$var$Ic,
    "animationEnd",
    $0b2e6adb871a3b94$var$Jc,
    "animationIteration",
    $0b2e6adb871a3b94$var$Kc,
    "animationStart",
    "canplay",
    "canPlay",
    "canplaythrough",
    "canPlayThrough",
    "durationchange",
    "durationChange",
    "emptied",
    "emptied",
    "encrypted",
    "encrypted",
    "ended",
    "ended",
    "error",
    "error",
    "gotpointercapture",
    "gotPointerCapture",
    "load",
    "load",
    "loadeddata",
    "loadedData",
    "loadedmetadata",
    "loadedMetadata",
    "loadstart",
    "loadStart",
    "lostpointercapture",
    "lostPointerCapture",
    "playing",
    "playing",
    "progress",
    "progress",
    "seeking",
    "seeking",
    "stalled",
    "stalled",
    "suspend",
    "suspend",
    "timeupdate",
    "timeUpdate",
    $0b2e6adb871a3b94$var$Lc,
    "transitionEnd",
    "waiting",
    "waiting"
];
function $0b2e6adb871a3b94$var$Pc(a, b) {
    for(var c = 0; c < a.length; c += 2){
        var d = a[c], e = a[c + 1];
        e = "on" + (e[0].toUpperCase() + e.slice(1));
        $0b2e6adb871a3b94$var$Nc.set(d, b);
        $0b2e6adb871a3b94$var$Mc.set(d, e);
        $0b2e6adb871a3b94$var$da(e, [
            d
        ]);
    }
}
var $0b2e6adb871a3b94$var$Qc = $fO90s.unstable_now;
$0b2e6adb871a3b94$var$Qc();
var $0b2e6adb871a3b94$var$F = 8;
function $0b2e6adb871a3b94$var$Rc(a) {
    if (0 !== (1 & a)) return $0b2e6adb871a3b94$var$F = 15, 1;
    if (0 !== (2 & a)) return $0b2e6adb871a3b94$var$F = 14, 2;
    if (0 !== (4 & a)) return $0b2e6adb871a3b94$var$F = 13, 4;
    var b = 24 & a;
    if (0 !== b) return $0b2e6adb871a3b94$var$F = 12, b;
    if (0 !== (a & 32)) return $0b2e6adb871a3b94$var$F = 11, 32;
    b = 192 & a;
    if (0 !== b) return $0b2e6adb871a3b94$var$F = 10, b;
    if (0 !== (a & 256)) return $0b2e6adb871a3b94$var$F = 9, 256;
    b = 3584 & a;
    if (0 !== b) return $0b2e6adb871a3b94$var$F = 8, b;
    if (0 !== (a & 4096)) return $0b2e6adb871a3b94$var$F = 7, 4096;
    b = 4186112 & a;
    if (0 !== b) return $0b2e6adb871a3b94$var$F = 6, b;
    b = 62914560 & a;
    if (0 !== b) return $0b2e6adb871a3b94$var$F = 5, b;
    if (a & 67108864) return $0b2e6adb871a3b94$var$F = 4, 67108864;
    if (0 !== (a & 134217728)) return $0b2e6adb871a3b94$var$F = 3, 134217728;
    b = 805306368 & a;
    if (0 !== b) return $0b2e6adb871a3b94$var$F = 2, b;
    if (0 !== (1073741824 & a)) return $0b2e6adb871a3b94$var$F = 1, 1073741824;
    $0b2e6adb871a3b94$var$F = 8;
    return a;
}
function $0b2e6adb871a3b94$var$Sc(a) {
    switch(a){
        case 99:
            return 15;
        case 98:
            return 10;
        case 97:
        case 96:
            return 8;
        case 95:
            return 2;
        default:
            return 0;
    }
}
function $0b2e6adb871a3b94$var$Tc(a) {
    switch(a){
        case 15:
        case 14:
            return 99;
        case 13:
        case 12:
        case 11:
        case 10:
            return 98;
        case 9:
        case 8:
        case 7:
        case 6:
        case 4:
        case 5:
            return 97;
        case 3:
        case 2:
        case 1:
            return 95;
        case 0:
            return 90;
        default:
            throw Error($0b2e6adb871a3b94$var$y(358, a));
    }
}
function $0b2e6adb871a3b94$var$Uc(a, b) {
    var c = a.pendingLanes;
    if (0 === c) return $0b2e6adb871a3b94$var$F = 0;
    var d = 0, e = 0, f = a.expiredLanes, g = a.suspendedLanes, h = a.pingedLanes;
    if (0 !== f) d = f, e = $0b2e6adb871a3b94$var$F = 15;
    else if (f = c & 134217727, 0 !== f) {
        var k = f & ~g;
        0 !== k ? (d = $0b2e6adb871a3b94$var$Rc(k), e = $0b2e6adb871a3b94$var$F) : (h &= f, 0 !== h && (d = $0b2e6adb871a3b94$var$Rc(h), e = $0b2e6adb871a3b94$var$F));
    } else f = c & ~g, 0 !== f ? (d = $0b2e6adb871a3b94$var$Rc(f), e = $0b2e6adb871a3b94$var$F) : 0 !== h && (d = $0b2e6adb871a3b94$var$Rc(h), e = $0b2e6adb871a3b94$var$F);
    if (0 === d) return 0;
    d = 31 - $0b2e6adb871a3b94$var$Vc(d);
    d = c & ((0 > d ? 0 : 1 << d) << 1) - 1;
    if (0 !== b && b !== d && 0 === (b & g)) {
        $0b2e6adb871a3b94$var$Rc(b);
        if (e <= $0b2e6adb871a3b94$var$F) return b;
        $0b2e6adb871a3b94$var$F = e;
    }
    b = a.entangledLanes;
    if (0 !== b) for(a = a.entanglements, b &= d; 0 < b;)c = 31 - $0b2e6adb871a3b94$var$Vc(b), e = 1 << c, d |= a[c], b &= ~e;
    return d;
}
function $0b2e6adb871a3b94$var$Wc(a) {
    a = a.pendingLanes & -1073741825;
    return 0 !== a ? a : a & 1073741824 ? 1073741824 : 0;
}
function $0b2e6adb871a3b94$var$Xc(a, b) {
    switch(a){
        case 15:
            return 1;
        case 14:
            return 2;
        case 12:
            return a = $0b2e6adb871a3b94$var$Yc(24 & ~b), 0 === a ? $0b2e6adb871a3b94$var$Xc(10, b) : a;
        case 10:
            return a = $0b2e6adb871a3b94$var$Yc(192 & ~b), 0 === a ? $0b2e6adb871a3b94$var$Xc(8, b) : a;
        case 8:
            return a = $0b2e6adb871a3b94$var$Yc(3584 & ~b), 0 === a && (a = $0b2e6adb871a3b94$var$Yc(4186112 & ~b), 0 === a && (a = 512)), a;
        case 2:
            return b = $0b2e6adb871a3b94$var$Yc(805306368 & ~b), 0 === b && (b = 268435456), b;
    }
    throw Error($0b2e6adb871a3b94$var$y(358, a));
}
function $0b2e6adb871a3b94$var$Yc(a) {
    return a & -a;
}
function $0b2e6adb871a3b94$var$Zc(a) {
    for(var b = [], c = 0; 31 > c; c++)b.push(a);
    return b;
}
function $0b2e6adb871a3b94$var$$c(a, b, c) {
    a.pendingLanes |= b;
    var d = b - 1;
    a.suspendedLanes &= d;
    a.pingedLanes &= d;
    a = a.eventTimes;
    b = 31 - $0b2e6adb871a3b94$var$Vc(b);
    a[b] = c;
}
var $0b2e6adb871a3b94$var$Vc = Math.clz32 ? Math.clz32 : $0b2e6adb871a3b94$var$ad, $0b2e6adb871a3b94$var$bd = Math.log, $0b2e6adb871a3b94$var$cd = Math.LN2;
function $0b2e6adb871a3b94$var$ad(a) {
    return 0 === a ? 32 : 31 - ($0b2e6adb871a3b94$var$bd(a) / $0b2e6adb871a3b94$var$cd | 0) | 0;
}
var $0b2e6adb871a3b94$var$dd = $fO90s.unstable_UserBlockingPriority, $0b2e6adb871a3b94$var$ed = $fO90s.unstable_runWithPriority, $0b2e6adb871a3b94$var$fd = !0;
function $0b2e6adb871a3b94$var$gd(a, b, c, d) {
    $0b2e6adb871a3b94$var$Kb || $0b2e6adb871a3b94$var$Ib();
    var e = $0b2e6adb871a3b94$var$hd, f = $0b2e6adb871a3b94$var$Kb;
    $0b2e6adb871a3b94$var$Kb = !0;
    try {
        $0b2e6adb871a3b94$var$Hb(e, a, b, c, d);
    } finally{
        ($0b2e6adb871a3b94$var$Kb = f) || $0b2e6adb871a3b94$var$Mb();
    }
}
function $0b2e6adb871a3b94$var$id(a, b, c, d) {
    $0b2e6adb871a3b94$var$ed($0b2e6adb871a3b94$var$dd, $0b2e6adb871a3b94$var$hd.bind(null, a, b, c, d));
}
function $0b2e6adb871a3b94$var$hd(a, b, c, d) {
    if ($0b2e6adb871a3b94$var$fd) {
        var e;
        if ((e = 0 === (b & 4)) && 0 < $0b2e6adb871a3b94$var$jc.length && -1 < $0b2e6adb871a3b94$var$qc.indexOf(a)) a = $0b2e6adb871a3b94$var$rc(null, a, b, c, d), $0b2e6adb871a3b94$var$jc.push(a);
        else {
            var f = $0b2e6adb871a3b94$var$yc(a, b, c, d);
            if (null === f) e && $0b2e6adb871a3b94$var$sc(a, d);
            else {
                if (e) {
                    if (-1 < $0b2e6adb871a3b94$var$qc.indexOf(a)) {
                        a = $0b2e6adb871a3b94$var$rc(f, a, b, c, d);
                        $0b2e6adb871a3b94$var$jc.push(a);
                        return;
                    }
                    if ($0b2e6adb871a3b94$var$uc(f, a, b, c, d)) return;
                    $0b2e6adb871a3b94$var$sc(a, d);
                }
                $0b2e6adb871a3b94$var$jd(a, b, d, null, c);
            }
        }
    }
}
function $0b2e6adb871a3b94$var$yc(a, b, c, d) {
    var e = $0b2e6adb871a3b94$var$xb(d);
    e = $0b2e6adb871a3b94$var$wc(e);
    if (null !== e) {
        var f = $0b2e6adb871a3b94$var$Zb(e);
        if (null === f) e = null;
        else {
            var g = f.tag;
            if (13 === g) {
                e = $0b2e6adb871a3b94$var$$b(f);
                if (null !== e) return e;
                e = null;
            } else if (3 === g) {
                if (f.stateNode.hydrate) return 3 === f.tag ? f.stateNode.containerInfo : null;
                e = null;
            } else f !== e && (e = null);
        }
    }
    $0b2e6adb871a3b94$var$jd(a, b, d, e, c);
    return null;
}
var $0b2e6adb871a3b94$var$kd = null, $0b2e6adb871a3b94$var$ld = null, $0b2e6adb871a3b94$var$md = null;
function $0b2e6adb871a3b94$var$nd() {
    if ($0b2e6adb871a3b94$var$md) return $0b2e6adb871a3b94$var$md;
    var a, b = $0b2e6adb871a3b94$var$ld, c = b.length, d, e = "value" in $0b2e6adb871a3b94$var$kd ? $0b2e6adb871a3b94$var$kd.value : $0b2e6adb871a3b94$var$kd.textContent, f = e.length;
    for(a = 0; a < c && b[a] === e[a]; a++);
    var g = c - a;
    for(d = 1; d <= g && b[c - d] === e[f - d]; d++);
    return $0b2e6adb871a3b94$var$md = e.slice(a, 1 < d ? 1 - d : void 0);
}
function $0b2e6adb871a3b94$var$od(a) {
    var b = a.keyCode;
    "charCode" in a ? (a = a.charCode, 0 === a && 13 === b && (a = 13)) : a = b;
    10 === a && (a = 13);
    return 32 <= a || 13 === a ? a : 0;
}
function $0b2e6adb871a3b94$var$pd() {
    return !0;
}
function $0b2e6adb871a3b94$var$qd() {
    return !1;
}
function $0b2e6adb871a3b94$var$rd(a) {
    function b(b, d, e, f, g) {
        this._reactName = b;
        this._targetInst = e;
        this.type = d;
        this.nativeEvent = f;
        this.target = g;
        this.currentTarget = null;
        for(var c in a)a.hasOwnProperty(c) && (b = a[c], this[c] = b ? b(f) : f[c]);
        this.isDefaultPrevented = (null != f.defaultPrevented ? f.defaultPrevented : !1 === f.returnValue) ? $0b2e6adb871a3b94$var$pd : $0b2e6adb871a3b94$var$qd;
        this.isPropagationStopped = $0b2e6adb871a3b94$var$qd;
        return this;
    }
    $8coUR(b.prototype, {
        preventDefault: function() {
            this.defaultPrevented = !0;
            var a = this.nativeEvent;
            a && (a.preventDefault ? a.preventDefault() : "unknown" !== typeof a.returnValue && (a.returnValue = !1), this.isDefaultPrevented = $0b2e6adb871a3b94$var$pd);
        },
        stopPropagation: function() {
            var a = this.nativeEvent;
            a && (a.stopPropagation ? a.stopPropagation() : "unknown" !== typeof a.cancelBubble && (a.cancelBubble = !0), this.isPropagationStopped = $0b2e6adb871a3b94$var$pd);
        },
        persist: function() {},
        isPersistent: $0b2e6adb871a3b94$var$pd
    });
    return b;
}
var $0b2e6adb871a3b94$var$sd = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function(a) {
        return a.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
}, $0b2e6adb871a3b94$var$td = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$sd), $0b2e6adb871a3b94$var$ud = $8coUR({}, $0b2e6adb871a3b94$var$sd, {
    view: 0,
    detail: 0
}), $0b2e6adb871a3b94$var$vd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$ud), $0b2e6adb871a3b94$var$wd, $0b2e6adb871a3b94$var$xd, $0b2e6adb871a3b94$var$yd, $0b2e6adb871a3b94$var$Ad = $8coUR({}, $0b2e6adb871a3b94$var$ud, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: $0b2e6adb871a3b94$var$zd,
    button: 0,
    buttons: 0,
    relatedTarget: function(a) {
        return void 0 === a.relatedTarget ? a.fromElement === a.srcElement ? a.toElement : a.fromElement : a.relatedTarget;
    },
    movementX: function(a) {
        if ("movementX" in a) return a.movementX;
        a !== $0b2e6adb871a3b94$var$yd && ($0b2e6adb871a3b94$var$yd && "mousemove" === a.type ? ($0b2e6adb871a3b94$var$wd = a.screenX - $0b2e6adb871a3b94$var$yd.screenX, $0b2e6adb871a3b94$var$xd = a.screenY - $0b2e6adb871a3b94$var$yd.screenY) : $0b2e6adb871a3b94$var$xd = $0b2e6adb871a3b94$var$wd = 0, $0b2e6adb871a3b94$var$yd = a);
        return $0b2e6adb871a3b94$var$wd;
    },
    movementY: function(a) {
        return "movementY" in a ? a.movementY : $0b2e6adb871a3b94$var$xd;
    }
}), $0b2e6adb871a3b94$var$Bd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Ad), $0b2e6adb871a3b94$var$Cd = $8coUR({}, $0b2e6adb871a3b94$var$Ad, {
    dataTransfer: 0
}), $0b2e6adb871a3b94$var$Dd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Cd), $0b2e6adb871a3b94$var$Ed = $8coUR({}, $0b2e6adb871a3b94$var$ud, {
    relatedTarget: 0
}), $0b2e6adb871a3b94$var$Fd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Ed), $0b2e6adb871a3b94$var$Gd = $8coUR({}, $0b2e6adb871a3b94$var$sd, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $0b2e6adb871a3b94$var$Hd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Gd), $0b2e6adb871a3b94$var$Id = $8coUR({}, $0b2e6adb871a3b94$var$sd, {
    clipboardData: function(a) {
        return "clipboardData" in a ? a.clipboardData : window.clipboardData;
    }
}), $0b2e6adb871a3b94$var$Jd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Id), $0b2e6adb871a3b94$var$Kd = $8coUR({}, $0b2e6adb871a3b94$var$sd, {
    data: 0
}), $0b2e6adb871a3b94$var$Ld = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Kd), $0b2e6adb871a3b94$var$Md = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, $0b2e6adb871a3b94$var$Nd = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, $0b2e6adb871a3b94$var$Od = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function $0b2e6adb871a3b94$var$Pd(a) {
    var b = this.nativeEvent;
    return b.getModifierState ? b.getModifierState(a) : (a = $0b2e6adb871a3b94$var$Od[a]) ? !!b[a] : !1;
}
function $0b2e6adb871a3b94$var$zd() {
    return $0b2e6adb871a3b94$var$Pd;
}
var $0b2e6adb871a3b94$var$Qd = $8coUR({}, $0b2e6adb871a3b94$var$ud, {
    key: function(a) {
        if (a.key) {
            var b = $0b2e6adb871a3b94$var$Md[a.key] || a.key;
            if ("Unidentified" !== b) return b;
        }
        return "keypress" === a.type ? (a = $0b2e6adb871a3b94$var$od(a), 13 === a ? "Enter" : String.fromCharCode(a)) : "keydown" === a.type || "keyup" === a.type ? $0b2e6adb871a3b94$var$Nd[a.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: $0b2e6adb871a3b94$var$zd,
    charCode: function(a) {
        return "keypress" === a.type ? $0b2e6adb871a3b94$var$od(a) : 0;
    },
    keyCode: function(a) {
        return "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    },
    which: function(a) {
        return "keypress" === a.type ? $0b2e6adb871a3b94$var$od(a) : "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    }
}), $0b2e6adb871a3b94$var$Rd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Qd), $0b2e6adb871a3b94$var$Sd = $8coUR({}, $0b2e6adb871a3b94$var$Ad, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
}), $0b2e6adb871a3b94$var$Td = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Sd), $0b2e6adb871a3b94$var$Ud = $8coUR({}, $0b2e6adb871a3b94$var$ud, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: $0b2e6adb871a3b94$var$zd
}), $0b2e6adb871a3b94$var$Vd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Ud), $0b2e6adb871a3b94$var$Wd = $8coUR({}, $0b2e6adb871a3b94$var$sd, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $0b2e6adb871a3b94$var$Xd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Wd), $0b2e6adb871a3b94$var$Yd = $8coUR({}, $0b2e6adb871a3b94$var$Ad, {
    deltaX: function(a) {
        return "deltaX" in a ? a.deltaX : "wheelDeltaX" in a ? -a.wheelDeltaX : 0;
    },
    deltaY: function(a) {
        return "deltaY" in a ? a.deltaY : "wheelDeltaY" in a ? -a.wheelDeltaY : "wheelDelta" in a ? -a.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
}), $0b2e6adb871a3b94$var$Zd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Yd), $0b2e6adb871a3b94$var$$d = [
    9,
    13,
    27,
    32
], $0b2e6adb871a3b94$var$ae = $0b2e6adb871a3b94$var$fa && "CompositionEvent" in window, $0b2e6adb871a3b94$var$be = null;
$0b2e6adb871a3b94$var$fa && "documentMode" in document && ($0b2e6adb871a3b94$var$be = document.documentMode);
var $0b2e6adb871a3b94$var$ce = $0b2e6adb871a3b94$var$fa && "TextEvent" in window && !$0b2e6adb871a3b94$var$be, $0b2e6adb871a3b94$var$de = $0b2e6adb871a3b94$var$fa && (!$0b2e6adb871a3b94$var$ae || $0b2e6adb871a3b94$var$be && 8 < $0b2e6adb871a3b94$var$be && 11 >= $0b2e6adb871a3b94$var$be), $0b2e6adb871a3b94$var$ee = String.fromCharCode(32), $0b2e6adb871a3b94$var$fe = !1;
function $0b2e6adb871a3b94$var$ge(a, b) {
    switch(a){
        case "keyup":
            return -1 !== $0b2e6adb871a3b94$var$$d.indexOf(b.keyCode);
        case "keydown":
            return 229 !== b.keyCode;
        case "keypress":
        case "mousedown":
        case "focusout":
            return !0;
        default:
            return !1;
    }
}
function $0b2e6adb871a3b94$var$he(a) {
    a = a.detail;
    return "object" === typeof a && "data" in a ? a.data : null;
}
var $0b2e6adb871a3b94$var$ie = !1;
function $0b2e6adb871a3b94$var$je(a, b) {
    switch(a){
        case "compositionend":
            return $0b2e6adb871a3b94$var$he(b);
        case "keypress":
            if (32 !== b.which) return null;
            $0b2e6adb871a3b94$var$fe = !0;
            return $0b2e6adb871a3b94$var$ee;
        case "textInput":
            return a = b.data, a === $0b2e6adb871a3b94$var$ee && $0b2e6adb871a3b94$var$fe ? null : a;
        default:
            return null;
    }
}
function $0b2e6adb871a3b94$var$ke(a, b) {
    if ($0b2e6adb871a3b94$var$ie) return "compositionend" === a || !$0b2e6adb871a3b94$var$ae && $0b2e6adb871a3b94$var$ge(a, b) ? (a = $0b2e6adb871a3b94$var$nd(), $0b2e6adb871a3b94$var$md = $0b2e6adb871a3b94$var$ld = $0b2e6adb871a3b94$var$kd = null, $0b2e6adb871a3b94$var$ie = !1, a) : null;
    switch(a){
        case "paste":
            return null;
        case "keypress":
            if (!(b.ctrlKey || b.altKey || b.metaKey) || b.ctrlKey && b.altKey) {
                if (b.char && 1 < b.char.length) return b.char;
                if (b.which) return String.fromCharCode(b.which);
            }
            return null;
        case "compositionend":
            return $0b2e6adb871a3b94$var$de && "ko" !== b.locale ? null : b.data;
        default:
            return null;
    }
}
var $0b2e6adb871a3b94$var$le = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function $0b2e6adb871a3b94$var$me(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return "input" === b ? !!$0b2e6adb871a3b94$var$le[a.type] : "textarea" === b ? !0 : !1;
}
function $0b2e6adb871a3b94$var$ne(a, b, c, d) {
    $0b2e6adb871a3b94$var$Eb(d);
    b = $0b2e6adb871a3b94$var$oe(b, "onChange");
    0 < b.length && (c = new $0b2e6adb871a3b94$var$td("onChange", "change", null, c, d), a.push({
        event: c,
        listeners: b
    }));
}
var $0b2e6adb871a3b94$var$pe = null, $0b2e6adb871a3b94$var$qe = null;
function $0b2e6adb871a3b94$var$re(a) {
    $0b2e6adb871a3b94$var$se(a, 0);
}
function $0b2e6adb871a3b94$var$te(a) {
    var b = $0b2e6adb871a3b94$var$ue(a);
    if ($0b2e6adb871a3b94$var$Wa(b)) return a;
}
function $0b2e6adb871a3b94$var$ve(a, b) {
    if ("change" === a) return b;
}
var $0b2e6adb871a3b94$var$we = !1;
if ($0b2e6adb871a3b94$var$fa) {
    var $0b2e6adb871a3b94$var$xe;
    if ($0b2e6adb871a3b94$var$fa) {
        var $0b2e6adb871a3b94$var$ye = "oninput" in document;
        if (!$0b2e6adb871a3b94$var$ye) {
            var $0b2e6adb871a3b94$var$ze = document.createElement("div");
            $0b2e6adb871a3b94$var$ze.setAttribute("oninput", "return;");
            $0b2e6adb871a3b94$var$ye = "function" === typeof $0b2e6adb871a3b94$var$ze.oninput;
        }
        $0b2e6adb871a3b94$var$xe = $0b2e6adb871a3b94$var$ye;
    } else $0b2e6adb871a3b94$var$xe = !1;
    $0b2e6adb871a3b94$var$we = $0b2e6adb871a3b94$var$xe && (!document.documentMode || 9 < document.documentMode);
}
function $0b2e6adb871a3b94$var$Ae() {
    $0b2e6adb871a3b94$var$pe && ($0b2e6adb871a3b94$var$pe.detachEvent("onpropertychange", $0b2e6adb871a3b94$var$Be), $0b2e6adb871a3b94$var$qe = $0b2e6adb871a3b94$var$pe = null);
}
function $0b2e6adb871a3b94$var$Be(a) {
    if ("value" === a.propertyName && $0b2e6adb871a3b94$var$te($0b2e6adb871a3b94$var$qe)) {
        var b = [];
        $0b2e6adb871a3b94$var$ne(b, $0b2e6adb871a3b94$var$qe, a, $0b2e6adb871a3b94$var$xb(a));
        a = $0b2e6adb871a3b94$var$re;
        if ($0b2e6adb871a3b94$var$Kb) a(b);
        else {
            $0b2e6adb871a3b94$var$Kb = !0;
            try {
                $0b2e6adb871a3b94$var$Gb(a, b);
            } finally{
                $0b2e6adb871a3b94$var$Kb = !1, $0b2e6adb871a3b94$var$Mb();
            }
        }
    }
}
function $0b2e6adb871a3b94$var$Ce(a, b, c) {
    "focusin" === a ? ($0b2e6adb871a3b94$var$Ae(), $0b2e6adb871a3b94$var$pe = b, $0b2e6adb871a3b94$var$qe = c, $0b2e6adb871a3b94$var$pe.attachEvent("onpropertychange", $0b2e6adb871a3b94$var$Be)) : "focusout" === a && $0b2e6adb871a3b94$var$Ae();
}
function $0b2e6adb871a3b94$var$De(a) {
    if ("selectionchange" === a || "keyup" === a || "keydown" === a) return $0b2e6adb871a3b94$var$te($0b2e6adb871a3b94$var$qe);
}
function $0b2e6adb871a3b94$var$Ee(a, b) {
    if ("click" === a) return $0b2e6adb871a3b94$var$te(b);
}
function $0b2e6adb871a3b94$var$Fe(a, b) {
    if ("input" === a || "change" === a) return $0b2e6adb871a3b94$var$te(b);
}
function $0b2e6adb871a3b94$var$Ge(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $0b2e6adb871a3b94$var$He = "function" === typeof Object.is ? Object.is : $0b2e6adb871a3b94$var$Ge, $0b2e6adb871a3b94$var$Ie = Object.prototype.hasOwnProperty;
function $0b2e6adb871a3b94$var$Je(a, b) {
    if ($0b2e6adb871a3b94$var$He(a, b)) return !0;
    if ("object" !== typeof a || null === a || "object" !== typeof b || null === b) return !1;
    var c = Object.keys(a), d = Object.keys(b);
    if (c.length !== d.length) return !1;
    for(d = 0; d < c.length; d++)if (!$0b2e6adb871a3b94$var$Ie.call(b, c[d]) || !$0b2e6adb871a3b94$var$He(a[c[d]], b[c[d]])) return !1;
    return !0;
}
function $0b2e6adb871a3b94$var$Ke(a) {
    for(; a && a.firstChild;)a = a.firstChild;
    return a;
}
function $0b2e6adb871a3b94$var$Le(a, b) {
    var c = $0b2e6adb871a3b94$var$Ke(a);
    a = 0;
    for(var d; c;){
        if (3 === c.nodeType) {
            d = a + c.textContent.length;
            if (a <= b && d >= b) return {
                node: c,
                offset: b - a
            };
            a = d;
        }
        a: {
            for(; c;){
                if (c.nextSibling) {
                    c = c.nextSibling;
                    break a;
                }
                c = c.parentNode;
            }
            c = void 0;
        }
        c = $0b2e6adb871a3b94$var$Ke(c);
    }
}
function $0b2e6adb871a3b94$var$Me(a, b) {
    return a && b ? a === b ? !0 : a && 3 === a.nodeType ? !1 : b && 3 === b.nodeType ? $0b2e6adb871a3b94$var$Me(a, b.parentNode) : "contains" in a ? a.contains(b) : a.compareDocumentPosition ? !!(a.compareDocumentPosition(b) & 16) : !1 : !1;
}
function $0b2e6adb871a3b94$var$Ne() {
    for(var a = window, b = $0b2e6adb871a3b94$var$Xa(); b instanceof a.HTMLIFrameElement;){
        try {
            var c = "string" === typeof b.contentWindow.location.href;
        } catch (d) {
            c = !1;
        }
        if (c) a = b.contentWindow;
        else break;
        b = $0b2e6adb871a3b94$var$Xa(a.document);
    }
    return b;
}
function $0b2e6adb871a3b94$var$Oe(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return b && ("input" === b && ("text" === a.type || "search" === a.type || "tel" === a.type || "url" === a.type || "password" === a.type) || "textarea" === b || "true" === a.contentEditable);
}
var $0b2e6adb871a3b94$var$Pe = $0b2e6adb871a3b94$var$fa && "documentMode" in document && 11 >= document.documentMode, $0b2e6adb871a3b94$var$Qe = null, $0b2e6adb871a3b94$var$Re = null, $0b2e6adb871a3b94$var$Se = null, $0b2e6adb871a3b94$var$Te = !1;
function $0b2e6adb871a3b94$var$Ue(a, b, c) {
    var d = c.window === c ? c.document : 9 === c.nodeType ? c : c.ownerDocument;
    $0b2e6adb871a3b94$var$Te || null == $0b2e6adb871a3b94$var$Qe || $0b2e6adb871a3b94$var$Qe !== $0b2e6adb871a3b94$var$Xa(d) || (d = $0b2e6adb871a3b94$var$Qe, "selectionStart" in d && $0b2e6adb871a3b94$var$Oe(d) ? d = {
        start: d.selectionStart,
        end: d.selectionEnd
    } : (d = (d.ownerDocument && d.ownerDocument.defaultView || window).getSelection(), d = {
        anchorNode: d.anchorNode,
        anchorOffset: d.anchorOffset,
        focusNode: d.focusNode,
        focusOffset: d.focusOffset
    }), $0b2e6adb871a3b94$var$Se && $0b2e6adb871a3b94$var$Je($0b2e6adb871a3b94$var$Se, d) || ($0b2e6adb871a3b94$var$Se = d, d = $0b2e6adb871a3b94$var$oe($0b2e6adb871a3b94$var$Re, "onSelect"), 0 < d.length && (b = new $0b2e6adb871a3b94$var$td("onSelect", "select", null, b, c), a.push({
        event: b,
        listeners: d
    }), b.target = $0b2e6adb871a3b94$var$Qe)));
}
$0b2e6adb871a3b94$var$Pc("cancel cancel click click close close contextmenu contextMenu copy copy cut cut auxclick auxClick dblclick doubleClick dragend dragEnd dragstart dragStart drop drop focusin focus focusout blur input input invalid invalid keydown keyDown keypress keyPress keyup keyUp mousedown mouseDown mouseup mouseUp paste paste pause pause play play pointercancel pointerCancel pointerdown pointerDown pointerup pointerUp ratechange rateChange reset reset seeked seeked submit submit touchcancel touchCancel touchend touchEnd touchstart touchStart volumechange volumeChange".split(" "), 0);
$0b2e6adb871a3b94$var$Pc("drag drag dragenter dragEnter dragexit dragExit dragleave dragLeave dragover dragOver mousemove mouseMove mouseout mouseOut mouseover mouseOver pointermove pointerMove pointerout pointerOut pointerover pointerOver scroll scroll toggle toggle touchmove touchMove wheel wheel".split(" "), 1);
$0b2e6adb871a3b94$var$Pc($0b2e6adb871a3b94$var$Oc, 2);
for(var $0b2e6adb871a3b94$var$Ve = "change selectionchange textInput compositionstart compositionend compositionupdate".split(" "), $0b2e6adb871a3b94$var$We = 0; $0b2e6adb871a3b94$var$We < $0b2e6adb871a3b94$var$Ve.length; $0b2e6adb871a3b94$var$We++)$0b2e6adb871a3b94$var$Nc.set($0b2e6adb871a3b94$var$Ve[$0b2e6adb871a3b94$var$We], 0);
$0b2e6adb871a3b94$var$ea("onMouseEnter", [
    "mouseout",
    "mouseover"
]);
$0b2e6adb871a3b94$var$ea("onMouseLeave", [
    "mouseout",
    "mouseover"
]);
$0b2e6adb871a3b94$var$ea("onPointerEnter", [
    "pointerout",
    "pointerover"
]);
$0b2e6adb871a3b94$var$ea("onPointerLeave", [
    "pointerout",
    "pointerover"
]);
$0b2e6adb871a3b94$var$da("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
$0b2e6adb871a3b94$var$da("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
$0b2e6adb871a3b94$var$da("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
]);
$0b2e6adb871a3b94$var$da("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
$0b2e6adb871a3b94$var$da("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
$0b2e6adb871a3b94$var$da("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var $0b2e6adb871a3b94$var$Xe = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), $0b2e6adb871a3b94$var$Ye = new Set("cancel close invalid load scroll toggle".split(" ").concat($0b2e6adb871a3b94$var$Xe));
function $0b2e6adb871a3b94$var$Ze(a, b, c) {
    var d = a.type || "unknown-event";
    a.currentTarget = c;
    $0b2e6adb871a3b94$var$Yb(d, b, void 0, a);
    a.currentTarget = null;
}
function $0b2e6adb871a3b94$var$se(a, b) {
    b = 0 !== (b & 4);
    for(var c = 0; c < a.length; c++){
        var d = a[c], e = d.event;
        d = d.listeners;
        a: {
            var f = void 0;
            if (b) for(var g = d.length - 1; 0 <= g; g--){
                var h = d[g], k = h.instance, l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $0b2e6adb871a3b94$var$Ze(e, h, l);
                f = k;
            }
            else for(g = 0; g < d.length; g++){
                h = d[g];
                k = h.instance;
                l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $0b2e6adb871a3b94$var$Ze(e, h, l);
                f = k;
            }
        }
    }
    if ($0b2e6adb871a3b94$var$Ub) throw a = $0b2e6adb871a3b94$var$Vb, $0b2e6adb871a3b94$var$Ub = !1, $0b2e6adb871a3b94$var$Vb = null, a;
}
function $0b2e6adb871a3b94$var$G(a, b) {
    var c = $0b2e6adb871a3b94$var$$e(b), d = a + "__bubble";
    c.has(d) || ($0b2e6adb871a3b94$var$af(b, a, 2, !1), c.add(d));
}
var $0b2e6adb871a3b94$var$bf = "_reactListening" + Math.random().toString(36).slice(2);
function $0b2e6adb871a3b94$var$cf(a) {
    a[$0b2e6adb871a3b94$var$bf] || (a[$0b2e6adb871a3b94$var$bf] = !0, $0b2e6adb871a3b94$var$ba.forEach(function(b) {
        $0b2e6adb871a3b94$var$Ye.has(b) || $0b2e6adb871a3b94$var$df(b, !1, a, null);
        $0b2e6adb871a3b94$var$df(b, !0, a, null);
    }));
}
function $0b2e6adb871a3b94$var$df(a, b, c, d) {
    var e = 4 < arguments.length && void 0 !== arguments[4] ? arguments[4] : 0, f = c;
    "selectionchange" === a && 9 !== c.nodeType && (f = c.ownerDocument);
    if (null !== d && !b && $0b2e6adb871a3b94$var$Ye.has(a)) {
        if ("scroll" !== a) return;
        e |= 2;
        f = d;
    }
    var g = $0b2e6adb871a3b94$var$$e(f), h = a + "__" + (b ? "capture" : "bubble");
    g.has(h) || (b && (e |= 4), $0b2e6adb871a3b94$var$af(f, a, e, b), g.add(h));
}
function $0b2e6adb871a3b94$var$af(a, b, c, d) {
    var e = $0b2e6adb871a3b94$var$Nc.get(b);
    switch(void 0 === e ? 2 : e){
        case 0:
            e = $0b2e6adb871a3b94$var$gd;
            break;
        case 1:
            e = $0b2e6adb871a3b94$var$id;
            break;
        default:
            e = $0b2e6adb871a3b94$var$hd;
    }
    c = e.bind(null, b, c, a);
    e = void 0;
    !$0b2e6adb871a3b94$var$Pb || "touchstart" !== b && "touchmove" !== b && "wheel" !== b || (e = !0);
    d ? void 0 !== e ? a.addEventListener(b, c, {
        capture: !0,
        passive: e
    }) : a.addEventListener(b, c, !0) : void 0 !== e ? a.addEventListener(b, c, {
        passive: e
    }) : a.addEventListener(b, c, !1);
}
function $0b2e6adb871a3b94$var$jd(a, b, c, d, e) {
    var f = d;
    if (0 === (b & 1) && 0 === (b & 2) && null !== d) a: for(;;){
        if (null === d) return;
        var g = d.tag;
        if (3 === g || 4 === g) {
            var h = d.stateNode.containerInfo;
            if (h === e || 8 === h.nodeType && h.parentNode === e) break;
            if (4 === g) for(g = d.return; null !== g;){
                var k = g.tag;
                if (3 === k || 4 === k) {
                    if (k = g.stateNode.containerInfo, k === e || 8 === k.nodeType && k.parentNode === e) return;
                }
                g = g.return;
            }
            for(; null !== h;){
                g = $0b2e6adb871a3b94$var$wc(h);
                if (null === g) return;
                k = g.tag;
                if (5 === k || 6 === k) {
                    d = f = g;
                    continue a;
                }
                h = h.parentNode;
            }
        }
        d = d.return;
    }
    $0b2e6adb871a3b94$var$Nb(function() {
        var d = f, e = $0b2e6adb871a3b94$var$xb(c), g = [];
        a: {
            var h = $0b2e6adb871a3b94$var$Mc.get(a);
            if (void 0 !== h) {
                var k = $0b2e6adb871a3b94$var$td, x = a;
                switch(a){
                    case "keypress":
                        if (0 === $0b2e6adb871a3b94$var$od(c)) break a;
                    case "keydown":
                    case "keyup":
                        k = $0b2e6adb871a3b94$var$Rd;
                        break;
                    case "focusin":
                        x = "focus";
                        k = $0b2e6adb871a3b94$var$Fd;
                        break;
                    case "focusout":
                        x = "blur";
                        k = $0b2e6adb871a3b94$var$Fd;
                        break;
                    case "beforeblur":
                    case "afterblur":
                        k = $0b2e6adb871a3b94$var$Fd;
                        break;
                    case "click":
                        if (2 === c.button) break a;
                    case "auxclick":
                    case "dblclick":
                    case "mousedown":
                    case "mousemove":
                    case "mouseup":
                    case "mouseout":
                    case "mouseover":
                    case "contextmenu":
                        k = $0b2e6adb871a3b94$var$Bd;
                        break;
                    case "drag":
                    case "dragend":
                    case "dragenter":
                    case "dragexit":
                    case "dragleave":
                    case "dragover":
                    case "dragstart":
                    case "drop":
                        k = $0b2e6adb871a3b94$var$Dd;
                        break;
                    case "touchcancel":
                    case "touchend":
                    case "touchmove":
                    case "touchstart":
                        k = $0b2e6adb871a3b94$var$Vd;
                        break;
                    case $0b2e6adb871a3b94$var$Ic:
                    case $0b2e6adb871a3b94$var$Jc:
                    case $0b2e6adb871a3b94$var$Kc:
                        k = $0b2e6adb871a3b94$var$Hd;
                        break;
                    case $0b2e6adb871a3b94$var$Lc:
                        k = $0b2e6adb871a3b94$var$Xd;
                        break;
                    case "scroll":
                        k = $0b2e6adb871a3b94$var$vd;
                        break;
                    case "wheel":
                        k = $0b2e6adb871a3b94$var$Zd;
                        break;
                    case "copy":
                    case "cut":
                    case "paste":
                        k = $0b2e6adb871a3b94$var$Jd;
                        break;
                    case "gotpointercapture":
                    case "lostpointercapture":
                    case "pointercancel":
                    case "pointerdown":
                    case "pointermove":
                    case "pointerout":
                    case "pointerover":
                    case "pointerup":
                        k = $0b2e6adb871a3b94$var$Td;
                }
                var w = 0 !== (b & 4), z = !w && "scroll" === a, u = w ? null !== h ? h + "Capture" : null : h;
                w = [];
                for(var t = d, q; null !== t;){
                    q = t;
                    var v = q.stateNode;
                    5 === q.tag && null !== v && (q = v, null !== u && (v = $0b2e6adb871a3b94$var$Ob(t, u), null != v && w.push($0b2e6adb871a3b94$var$ef(t, v, q))));
                    if (z) break;
                    t = t.return;
                }
                0 < w.length && (h = new k(h, x, null, c, e), g.push({
                    event: h,
                    listeners: w
                }));
            }
        }
        if (0 === (b & 7)) {
            a: {
                h = "mouseover" === a || "pointerover" === a;
                k = "mouseout" === a || "pointerout" === a;
                if (h && 0 === (b & 16) && (x = c.relatedTarget || c.fromElement) && ($0b2e6adb871a3b94$var$wc(x) || x[$0b2e6adb871a3b94$var$ff])) break a;
                if (k || h) {
                    h = e.window === e ? e : (h = e.ownerDocument) ? h.defaultView || h.parentWindow : window;
                    if (k) {
                        if (x = c.relatedTarget || c.toElement, k = d, x = x ? $0b2e6adb871a3b94$var$wc(x) : null, null !== x && (z = $0b2e6adb871a3b94$var$Zb(x), x !== z || 5 !== x.tag && 6 !== x.tag)) x = null;
                    } else k = null, x = d;
                    if (k !== x) {
                        w = $0b2e6adb871a3b94$var$Bd;
                        v = "onMouseLeave";
                        u = "onMouseEnter";
                        t = "mouse";
                        if ("pointerout" === a || "pointerover" === a) w = $0b2e6adb871a3b94$var$Td, v = "onPointerLeave", u = "onPointerEnter", t = "pointer";
                        z = null == k ? h : $0b2e6adb871a3b94$var$ue(k);
                        q = null == x ? h : $0b2e6adb871a3b94$var$ue(x);
                        h = new w(v, t + "leave", k, c, e);
                        h.target = z;
                        h.relatedTarget = q;
                        v = null;
                        $0b2e6adb871a3b94$var$wc(e) === d && (w = new w(u, t + "enter", x, c, e), w.target = q, w.relatedTarget = z, v = w);
                        z = v;
                        if (k && x) b: {
                            w = k;
                            u = x;
                            t = 0;
                            for(q = w; q; q = $0b2e6adb871a3b94$var$gf(q))t++;
                            q = 0;
                            for(v = u; v; v = $0b2e6adb871a3b94$var$gf(v))q++;
                            for(; 0 < t - q;)w = $0b2e6adb871a3b94$var$gf(w), t--;
                            for(; 0 < q - t;)u = $0b2e6adb871a3b94$var$gf(u), q--;
                            for(; t--;){
                                if (w === u || null !== u && w === u.alternate) break b;
                                w = $0b2e6adb871a3b94$var$gf(w);
                                u = $0b2e6adb871a3b94$var$gf(u);
                            }
                            w = null;
                        }
                        else w = null;
                        null !== k && $0b2e6adb871a3b94$var$hf(g, h, k, w, !1);
                        null !== x && null !== z && $0b2e6adb871a3b94$var$hf(g, z, x, w, !0);
                    }
                }
            }
            a: {
                h = d ? $0b2e6adb871a3b94$var$ue(d) : window;
                k = h.nodeName && h.nodeName.toLowerCase();
                if ("select" === k || "input" === k && "file" === h.type) var J = $0b2e6adb871a3b94$var$ve;
                else if ($0b2e6adb871a3b94$var$me(h)) {
                    if ($0b2e6adb871a3b94$var$we) J = $0b2e6adb871a3b94$var$Fe;
                    else {
                        J = $0b2e6adb871a3b94$var$De;
                        var K = $0b2e6adb871a3b94$var$Ce;
                    }
                } else (k = h.nodeName) && "input" === k.toLowerCase() && ("checkbox" === h.type || "radio" === h.type) && (J = $0b2e6adb871a3b94$var$Ee);
                if (J && (J = J(a, d))) {
                    $0b2e6adb871a3b94$var$ne(g, J, c, e);
                    break a;
                }
                K && K(a, h, d);
                "focusout" === a && (K = h._wrapperState) && K.controlled && "number" === h.type && $0b2e6adb871a3b94$var$bb(h, "number", h.value);
            }
            K = d ? $0b2e6adb871a3b94$var$ue(d) : window;
            switch(a){
                case "focusin":
                    if ($0b2e6adb871a3b94$var$me(K) || "true" === K.contentEditable) $0b2e6adb871a3b94$var$Qe = K, $0b2e6adb871a3b94$var$Re = d, $0b2e6adb871a3b94$var$Se = null;
                    break;
                case "focusout":
                    $0b2e6adb871a3b94$var$Se = $0b2e6adb871a3b94$var$Re = $0b2e6adb871a3b94$var$Qe = null;
                    break;
                case "mousedown":
                    $0b2e6adb871a3b94$var$Te = !0;
                    break;
                case "contextmenu":
                case "mouseup":
                case "dragend":
                    $0b2e6adb871a3b94$var$Te = !1;
                    $0b2e6adb871a3b94$var$Ue(g, c, e);
                    break;
                case "selectionchange":
                    if ($0b2e6adb871a3b94$var$Pe) break;
                case "keydown":
                case "keyup":
                    $0b2e6adb871a3b94$var$Ue(g, c, e);
            }
            var Q;
            if ($0b2e6adb871a3b94$var$ae) b: {
                switch(a){
                    case "compositionstart":
                        var L = "onCompositionStart";
                        break b;
                    case "compositionend":
                        L = "onCompositionEnd";
                        break b;
                    case "compositionupdate":
                        L = "onCompositionUpdate";
                        break b;
                }
                L = void 0;
            }
            else $0b2e6adb871a3b94$var$ie ? $0b2e6adb871a3b94$var$ge(a, c) && (L = "onCompositionEnd") : "keydown" === a && 229 === c.keyCode && (L = "onCompositionStart");
            L && ($0b2e6adb871a3b94$var$de && "ko" !== c.locale && ($0b2e6adb871a3b94$var$ie || "onCompositionStart" !== L ? "onCompositionEnd" === L && $0b2e6adb871a3b94$var$ie && (Q = $0b2e6adb871a3b94$var$nd()) : ($0b2e6adb871a3b94$var$kd = e, $0b2e6adb871a3b94$var$ld = "value" in $0b2e6adb871a3b94$var$kd ? $0b2e6adb871a3b94$var$kd.value : $0b2e6adb871a3b94$var$kd.textContent, $0b2e6adb871a3b94$var$ie = !0)), K = $0b2e6adb871a3b94$var$oe(d, L), 0 < K.length && (L = new $0b2e6adb871a3b94$var$Ld(L, a, null, c, e), g.push({
                event: L,
                listeners: K
            }), Q ? L.data = Q : (Q = $0b2e6adb871a3b94$var$he(c), null !== Q && (L.data = Q))));
            if (Q = $0b2e6adb871a3b94$var$ce ? $0b2e6adb871a3b94$var$je(a, c) : $0b2e6adb871a3b94$var$ke(a, c)) d = $0b2e6adb871a3b94$var$oe(d, "onBeforeInput"), 0 < d.length && (e = new $0b2e6adb871a3b94$var$Ld("onBeforeInput", "beforeinput", null, c, e), g.push({
                event: e,
                listeners: d
            }), e.data = Q);
        }
        $0b2e6adb871a3b94$var$se(g, b);
    });
}
function $0b2e6adb871a3b94$var$ef(a, b, c) {
    return {
        instance: a,
        listener: b,
        currentTarget: c
    };
}
function $0b2e6adb871a3b94$var$oe(a, b) {
    for(var c = b + "Capture", d = []; null !== a;){
        var e = a, f = e.stateNode;
        5 === e.tag && null !== f && (e = f, f = $0b2e6adb871a3b94$var$Ob(a, c), null != f && d.unshift($0b2e6adb871a3b94$var$ef(a, f, e)), f = $0b2e6adb871a3b94$var$Ob(a, b), null != f && d.push($0b2e6adb871a3b94$var$ef(a, f, e)));
        a = a.return;
    }
    return d;
}
function $0b2e6adb871a3b94$var$gf(a) {
    if (null === a) return null;
    do a = a.return;
    while (a && 5 !== a.tag);
    return a ? a : null;
}
function $0b2e6adb871a3b94$var$hf(a, b, c, d, e) {
    for(var f = b._reactName, g = []; null !== c && c !== d;){
        var h = c, k = h.alternate, l = h.stateNode;
        if (null !== k && k === d) break;
        5 === h.tag && null !== l && (h = l, e ? (k = $0b2e6adb871a3b94$var$Ob(c, f), null != k && g.unshift($0b2e6adb871a3b94$var$ef(c, k, h))) : e || (k = $0b2e6adb871a3b94$var$Ob(c, f), null != k && g.push($0b2e6adb871a3b94$var$ef(c, k, h))));
        c = c.return;
    }
    0 !== g.length && a.push({
        event: b,
        listeners: g
    });
}
function $0b2e6adb871a3b94$var$jf() {}
var $0b2e6adb871a3b94$var$kf = null, $0b2e6adb871a3b94$var$lf = null;
function $0b2e6adb871a3b94$var$mf(a, b) {
    switch(a){
        case "button":
        case "input":
        case "select":
        case "textarea":
            return !!b.autoFocus;
    }
    return !1;
}
function $0b2e6adb871a3b94$var$nf(a, b) {
    return "textarea" === a || "option" === a || "noscript" === a || "string" === typeof b.children || "number" === typeof b.children || "object" === typeof b.dangerouslySetInnerHTML && null !== b.dangerouslySetInnerHTML && null != b.dangerouslySetInnerHTML.__html;
}
var $0b2e6adb871a3b94$var$of = "function" === typeof setTimeout ? setTimeout : void 0, $0b2e6adb871a3b94$var$pf = "function" === typeof clearTimeout ? clearTimeout : void 0;
function $0b2e6adb871a3b94$var$qf(a) {
    1 === a.nodeType ? a.textContent = "" : 9 === a.nodeType && (a = a.body, null != a && (a.textContent = ""));
}
function $0b2e6adb871a3b94$var$rf(a) {
    for(; null != a; a = a.nextSibling){
        var b = a.nodeType;
        if (1 === b || 3 === b) break;
    }
    return a;
}
function $0b2e6adb871a3b94$var$sf(a) {
    a = a.previousSibling;
    for(var b = 0; a;){
        if (8 === a.nodeType) {
            var c = a.data;
            if ("$" === c || "$!" === c || "$?" === c) {
                if (0 === b) return a;
                b--;
            } else "/$" === c && b++;
        }
        a = a.previousSibling;
    }
    return null;
}
var $0b2e6adb871a3b94$var$tf = 0;
function $0b2e6adb871a3b94$var$uf(a) {
    return {
        $$typeof: $0b2e6adb871a3b94$var$Ga,
        toString: a,
        valueOf: a
    };
}
var $0b2e6adb871a3b94$var$vf = Math.random().toString(36).slice(2), $0b2e6adb871a3b94$var$wf = "__reactFiber$" + $0b2e6adb871a3b94$var$vf, $0b2e6adb871a3b94$var$xf = "__reactProps$" + $0b2e6adb871a3b94$var$vf, $0b2e6adb871a3b94$var$ff = "__reactContainer$" + $0b2e6adb871a3b94$var$vf, $0b2e6adb871a3b94$var$yf = "__reactEvents$" + $0b2e6adb871a3b94$var$vf;
function $0b2e6adb871a3b94$var$wc(a) {
    var b = a[$0b2e6adb871a3b94$var$wf];
    if (b) return b;
    for(var c = a.parentNode; c;){
        if (b = c[$0b2e6adb871a3b94$var$ff] || c[$0b2e6adb871a3b94$var$wf]) {
            c = b.alternate;
            if (null !== b.child || null !== c && null !== c.child) for(a = $0b2e6adb871a3b94$var$sf(a); null !== a;){
                if (c = a[$0b2e6adb871a3b94$var$wf]) return c;
                a = $0b2e6adb871a3b94$var$sf(a);
            }
            return b;
        }
        a = c;
        c = a.parentNode;
    }
    return null;
}
function $0b2e6adb871a3b94$var$Cb(a) {
    a = a[$0b2e6adb871a3b94$var$wf] || a[$0b2e6adb871a3b94$var$ff];
    return !a || 5 !== a.tag && 6 !== a.tag && 13 !== a.tag && 3 !== a.tag ? null : a;
}
function $0b2e6adb871a3b94$var$ue(a) {
    if (5 === a.tag || 6 === a.tag) return a.stateNode;
    throw Error($0b2e6adb871a3b94$var$y(33));
}
function $0b2e6adb871a3b94$var$Db(a) {
    return a[$0b2e6adb871a3b94$var$xf] || null;
}
function $0b2e6adb871a3b94$var$$e(a) {
    var b = a[$0b2e6adb871a3b94$var$yf];
    void 0 === b && (b = a[$0b2e6adb871a3b94$var$yf] = new Set);
    return b;
}
var $0b2e6adb871a3b94$var$zf = [], $0b2e6adb871a3b94$var$Af = -1;
function $0b2e6adb871a3b94$var$Bf(a) {
    return {
        current: a
    };
}
function $0b2e6adb871a3b94$var$H(a) {
    0 > $0b2e6adb871a3b94$var$Af || (a.current = $0b2e6adb871a3b94$var$zf[$0b2e6adb871a3b94$var$Af], $0b2e6adb871a3b94$var$zf[$0b2e6adb871a3b94$var$Af] = null, $0b2e6adb871a3b94$var$Af--);
}
function $0b2e6adb871a3b94$var$I(a, b) {
    $0b2e6adb871a3b94$var$Af++;
    $0b2e6adb871a3b94$var$zf[$0b2e6adb871a3b94$var$Af] = a.current;
    a.current = b;
}
var $0b2e6adb871a3b94$var$Cf = {}, $0b2e6adb871a3b94$var$M = $0b2e6adb871a3b94$var$Bf($0b2e6adb871a3b94$var$Cf), $0b2e6adb871a3b94$var$N = $0b2e6adb871a3b94$var$Bf(!1), $0b2e6adb871a3b94$var$Df = $0b2e6adb871a3b94$var$Cf;
function $0b2e6adb871a3b94$var$Ef(a, b) {
    var c = a.type.contextTypes;
    if (!c) return $0b2e6adb871a3b94$var$Cf;
    var d = a.stateNode;
    if (d && d.__reactInternalMemoizedUnmaskedChildContext === b) return d.__reactInternalMemoizedMaskedChildContext;
    var e = {}, f;
    for(f in c)e[f] = b[f];
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = b, a.__reactInternalMemoizedMaskedChildContext = e);
    return e;
}
function $0b2e6adb871a3b94$var$Ff(a) {
    a = a.childContextTypes;
    return null !== a && void 0 !== a;
}
function $0b2e6adb871a3b94$var$Gf() {
    $0b2e6adb871a3b94$var$H($0b2e6adb871a3b94$var$N);
    $0b2e6adb871a3b94$var$H($0b2e6adb871a3b94$var$M);
}
function $0b2e6adb871a3b94$var$Hf(a, b, c) {
    if ($0b2e6adb871a3b94$var$M.current !== $0b2e6adb871a3b94$var$Cf) throw Error($0b2e6adb871a3b94$var$y(168));
    $0b2e6adb871a3b94$var$I($0b2e6adb871a3b94$var$M, b);
    $0b2e6adb871a3b94$var$I($0b2e6adb871a3b94$var$N, c);
}
function $0b2e6adb871a3b94$var$If(a, b, c) {
    var d = a.stateNode;
    a = b.childContextTypes;
    if ("function" !== typeof d.getChildContext) return c;
    d = d.getChildContext();
    for(var e in d)if (!(e in a)) throw Error($0b2e6adb871a3b94$var$y(108, $0b2e6adb871a3b94$var$Ra(b) || "Unknown", e));
    return $8coUR({}, c, d);
}
function $0b2e6adb871a3b94$var$Jf(a) {
    a = (a = a.stateNode) && a.__reactInternalMemoizedMergedChildContext || $0b2e6adb871a3b94$var$Cf;
    $0b2e6adb871a3b94$var$Df = $0b2e6adb871a3b94$var$M.current;
    $0b2e6adb871a3b94$var$I($0b2e6adb871a3b94$var$M, a);
    $0b2e6adb871a3b94$var$I($0b2e6adb871a3b94$var$N, $0b2e6adb871a3b94$var$N.current);
    return !0;
}
function $0b2e6adb871a3b94$var$Kf(a, b, c) {
    var d = a.stateNode;
    if (!d) throw Error($0b2e6adb871a3b94$var$y(169));
    c ? (a = $0b2e6adb871a3b94$var$If(a, b, $0b2e6adb871a3b94$var$Df), d.__reactInternalMemoizedMergedChildContext = a, $0b2e6adb871a3b94$var$H($0b2e6adb871a3b94$var$N), $0b2e6adb871a3b94$var$H($0b2e6adb871a3b94$var$M), $0b2e6adb871a3b94$var$I($0b2e6adb871a3b94$var$M, a)) : $0b2e6adb871a3b94$var$H($0b2e6adb871a3b94$var$N);
    $0b2e6adb871a3b94$var$I($0b2e6adb871a3b94$var$N, c);
}
var $0b2e6adb871a3b94$var$Lf = null, $0b2e6adb871a3b94$var$Mf = null, $0b2e6adb871a3b94$var$Nf = $fO90s.unstable_runWithPriority, $0b2e6adb871a3b94$var$Of = $fO90s.unstable_scheduleCallback, $0b2e6adb871a3b94$var$Pf = $fO90s.unstable_cancelCallback, $0b2e6adb871a3b94$var$Qf = $fO90s.unstable_shouldYield, $0b2e6adb871a3b94$var$Rf = $fO90s.unstable_requestPaint, $0b2e6adb871a3b94$var$Sf = $fO90s.unstable_now, $0b2e6adb871a3b94$var$Tf = $fO90s.unstable_getCurrentPriorityLevel, $0b2e6adb871a3b94$var$Uf = $fO90s.unstable_ImmediatePriority, $0b2e6adb871a3b94$var$Vf = $fO90s.unstable_UserBlockingPriority, $0b2e6adb871a3b94$var$Wf = $fO90s.unstable_NormalPriority, $0b2e6adb871a3b94$var$Xf = $fO90s.unstable_LowPriority, $0b2e6adb871a3b94$var$Yf = $fO90s.unstable_IdlePriority, $0b2e6adb871a3b94$var$Zf = {}, $0b2e6adb871a3b94$var$$f = void 0 !== $0b2e6adb871a3b94$var$Rf ? $0b2e6adb871a3b94$var$Rf : function() {}, $0b2e6adb871a3b94$var$ag = null, $0b2e6adb871a3b94$var$bg = null, $0b2e6adb871a3b94$var$cg = !1, $0b2e6adb871a3b94$var$dg = $0b2e6adb871a3b94$var$Sf(), $0b2e6adb871a3b94$var$O = 1E4 > $0b2e6adb871a3b94$var$dg ? $0b2e6adb871a3b94$var$Sf : function() {
    return $0b2e6adb871a3b94$var$Sf() - $0b2e6adb871a3b94$var$dg;
};
function $0b2e6adb871a3b94$var$eg() {
    switch($0b2e6adb871a3b94$var$Tf()){
        case $0b2e6adb871a3b94$var$Uf:
            return 99;
        case $0b2e6adb871a3b94$var$Vf:
            return 98;
        case $0b2e6adb871a3b94$var$Wf:
            return 97;
        case $0b2e6adb871a3b94$var$Xf:
            return 96;
        case $0b2e6adb871a3b94$var$Yf:
            return 95;
        default:
            throw Error($0b2e6adb871a3b94$var$y(332));
    }
}
function $0b2e6adb871a3b94$var$fg(a) {
    switch(a){
        case 99:
            return $0b2e6adb871a3b94$var$Uf;
        case 98:
            return $0b2e6adb871a3b94$var$Vf;
        case 97:
            return $0b2e6adb871a3b94$var$Wf;
        case 96:
            return $0b2e6adb871a3b94$var$Xf;
        case 95:
            return $0b2e6adb871a3b94$var$Yf;
        default:
            throw Error($0b2e6adb871a3b94$var$y(332));
    }
}
function $0b2e6adb871a3b94$var$gg(a, b) {
    a = $0b2e6adb871a3b94$var$fg(a);
    return $0b2e6adb871a3b94$var$Nf(a, b);
}
function $0b2e6adb871a3b94$var$hg(a, b, c) {
    a = $0b2e6adb871a3b94$var$fg(a);
    return $0b2e6adb871a3b94$var$Of(a, b, c);
}
function $0b2e6adb871a3b94$var$ig() {
    if (null !== $0b2e6adb871a3b94$var$bg) {
        var a = $0b2e6adb871a3b94$var$bg;
        $0b2e6adb871a3b94$var$bg = null;
        $0b2e6adb871a3b94$var$Pf(a);
    }
    $0b2e6adb871a3b94$var$jg();
}
function $0b2e6adb871a3b94$var$jg() {
    if (!$0b2e6adb871a3b94$var$cg && null !== $0b2e6adb871a3b94$var$ag) {
        $0b2e6adb871a3b94$var$cg = !0;
        var a = 0;
        try {
            var b = $0b2e6adb871a3b94$var$ag;
            $0b2e6adb871a3b94$var$gg(99, function() {
                for(; a < b.length; a++){
                    var c = b[a];
                    do c = c(!0);
                    while (null !== c);
                }
            });
            $0b2e6adb871a3b94$var$ag = null;
        } catch (c) {
            throw null !== $0b2e6adb871a3b94$var$ag && ($0b2e6adb871a3b94$var$ag = $0b2e6adb871a3b94$var$ag.slice(a + 1)), $0b2e6adb871a3b94$var$Of($0b2e6adb871a3b94$var$Uf, $0b2e6adb871a3b94$var$ig), c;
        } finally{
            $0b2e6adb871a3b94$var$cg = !1;
        }
    }
}
var $0b2e6adb871a3b94$var$kg = $0b2e6adb871a3b94$var$ra.ReactCurrentBatchConfig;
function $0b2e6adb871a3b94$var$lg(a, b) {
    if (a && a.defaultProps) {
        b = $8coUR({}, b);
        a = a.defaultProps;
        for(var c in a)void 0 === b[c] && (b[c] = a[c]);
        return b;
    }
    return b;
}
var $0b2e6adb871a3b94$var$mg = $0b2e6adb871a3b94$var$Bf(null), $0b2e6adb871a3b94$var$ng = null, $0b2e6adb871a3b94$var$og = null, $0b2e6adb871a3b94$var$pg = null;
function $0b2e6adb871a3b94$var$qg() {
    $0b2e6adb871a3b94$var$pg = $0b2e6adb871a3b94$var$og = $0b2e6adb871a3b94$var$ng = null;
}
function $0b2e6adb871a3b94$var$rg(a) {
    var b = $0b2e6adb871a3b94$var$mg.current;
    $0b2e6adb871a3b94$var$H($0b2e6adb871a3b94$var$mg);
    a.type._context._currentValue = b;
}
function $0b2e6adb871a3b94$var$sg(a, b) {
    for(; null !== a;){
        var c = a.alternate;
        if ((a.childLanes & b) === b) {
            if (null === c || (c.childLanes & b) === b) break;
            else c.childLanes |= b;
        } else a.childLanes |= b, null !== c && (c.childLanes |= b);
        a = a.return;
    }
}
function $0b2e6adb871a3b94$var$tg(a, b) {
    $0b2e6adb871a3b94$var$ng = a;
    $0b2e6adb871a3b94$var$pg = $0b2e6adb871a3b94$var$og = null;
    a = a.dependencies;
    null !== a && null !== a.firstContext && (0 !== (a.lanes & b) && ($0b2e6adb871a3b94$var$ug = !0), a.firstContext = null);
}
function $0b2e6adb871a3b94$var$vg(a, b) {
    if ($0b2e6adb871a3b94$var$pg !== a && !1 !== b && 0 !== b) {
        if ("number" !== typeof b || 1073741823 === b) $0b2e6adb871a3b94$var$pg = a, b = 1073741823;
        b = {
            context: a,
            observedBits: b,
            next: null
        };
        if (null === $0b2e6adb871a3b94$var$og) {
            if (null === $0b2e6adb871a3b94$var$ng) throw Error($0b2e6adb871a3b94$var$y(308));
            $0b2e6adb871a3b94$var$og = b;
            $0b2e6adb871a3b94$var$ng.dependencies = {
                lanes: 0,
                firstContext: b,
                responders: null
            };
        } else $0b2e6adb871a3b94$var$og = $0b2e6adb871a3b94$var$og.next = b;
    }
    return a._currentValue;
}
var $0b2e6adb871a3b94$var$wg = !1;
function $0b2e6adb871a3b94$var$xg(a) {
    a.updateQueue = {
        baseState: a.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
            pending: null
        },
        effects: null
    };
}
function $0b2e6adb871a3b94$var$yg(a, b) {
    a = a.updateQueue;
    b.updateQueue === a && (b.updateQueue = {
        baseState: a.baseState,
        firstBaseUpdate: a.firstBaseUpdate,
        lastBaseUpdate: a.lastBaseUpdate,
        shared: a.shared,
        effects: a.effects
    });
}
function $0b2e6adb871a3b94$var$zg(a, b) {
    return {
        eventTime: a,
        lane: b,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
}
function $0b2e6adb871a3b94$var$Ag(a, b) {
    a = a.updateQueue;
    if (null !== a) {
        a = a.shared;
        var c = a.pending;
        null === c ? b.next = b : (b.next = c.next, c.next = b);
        a.pending = b;
    }
}
function $0b2e6adb871a3b94$var$Bg(a, b) {
    var c = a.updateQueue, d = a.alternate;
    if (null !== d && (d = d.updateQueue, c === d)) {
        var e = null, f = null;
        c = c.firstBaseUpdate;
        if (null !== c) {
            do {
                var g = {
                    eventTime: c.eventTime,
                    lane: c.lane,
                    tag: c.tag,
                    payload: c.payload,
                    callback: c.callback,
                    next: null
                };
                null === f ? e = f = g : f = f.next = g;
                c = c.next;
            }while (null !== c);
            null === f ? e = f = b : f = f.next = b;
        } else e = f = b;
        c = {
            baseState: d.baseState,
            firstBaseUpdate: e,
            lastBaseUpdate: f,
            shared: d.shared,
            effects: d.effects
        };
        a.updateQueue = c;
        return;
    }
    a = c.lastBaseUpdate;
    null === a ? c.firstBaseUpdate = b : a.next = b;
    c.lastBaseUpdate = b;
}
function $0b2e6adb871a3b94$var$Cg(a, b, c, d) {
    var e = a.updateQueue;
    $0b2e6adb871a3b94$var$wg = !1;
    var f = e.firstBaseUpdate, g = e.lastBaseUpdate, h = e.shared.pending;
    if (null !== h) {
        e.shared.pending = null;
        var k = h, l = k.next;
        k.next = null;
        null === g ? f = l : g.next = l;
        g = k;
        var n = a.alternate;
        if (null !== n) {
            n = n.updateQueue;
            var A = n.lastBaseUpdate;
            A !== g && (null === A ? n.firstBaseUpdate = l : A.next = l, n.lastBaseUpdate = k);
        }
    }
    if (null !== f) {
        A = e.baseState;
        g = 0;
        n = l = k = null;
        do {
            h = f.lane;
            var p = f.eventTime;
            if ((d & h) === h) {
                null !== n && (n = n.next = {
                    eventTime: p,
                    lane: 0,
                    tag: f.tag,
                    payload: f.payload,
                    callback: f.callback,
                    next: null
                });
                a: {
                    var C = a, x = f;
                    h = b;
                    p = c;
                    switch(x.tag){
                        case 1:
                            C = x.payload;
                            if ("function" === typeof C) {
                                A = C.call(p, A, h);
                                break a;
                            }
                            A = C;
                            break a;
                        case 3:
                            C.flags = C.flags & -4097 | 64;
                        case 0:
                            C = x.payload;
                            h = "function" === typeof C ? C.call(p, A, h) : C;
                            if (null === h || void 0 === h) break a;
                            A = $8coUR({}, A, h);
                            break a;
                        case 2:
                            $0b2e6adb871a3b94$var$wg = !0;
                    }
                }
                null !== f.callback && (a.flags |= 32, h = e.effects, null === h ? e.effects = [
                    f
                ] : h.push(f));
            } else p = {
                eventTime: p,
                lane: h,
                tag: f.tag,
                payload: f.payload,
                callback: f.callback,
                next: null
            }, null === n ? (l = n = p, k = A) : n = n.next = p, g |= h;
            f = f.next;
            if (null === f) {
                if (h = e.shared.pending, null === h) break;
                else f = h.next, h.next = null, e.lastBaseUpdate = h, e.shared.pending = null;
            }
        }while (1);
        null === n && (k = A);
        e.baseState = k;
        e.firstBaseUpdate = l;
        e.lastBaseUpdate = n;
        $0b2e6adb871a3b94$var$Dg |= g;
        a.lanes = g;
        a.memoizedState = A;
    }
}
function $0b2e6adb871a3b94$var$Eg(a, b, c) {
    a = b.effects;
    b.effects = null;
    if (null !== a) for(b = 0; b < a.length; b++){
        var d = a[b], e = d.callback;
        if (null !== e) {
            d.callback = null;
            d = c;
            if ("function" !== typeof e) throw Error($0b2e6adb871a3b94$var$y(191, e));
            e.call(d);
        }
    }
}
var $0b2e6adb871a3b94$var$Fg = (new $acw62.Component).refs;
function $0b2e6adb871a3b94$var$Gg(a, b, c, d) {
    b = a.memoizedState;
    c = c(d, b);
    c = null === c || void 0 === c ? b : $8coUR({}, b, c);
    a.memoizedState = c;
    0 === a.lanes && (a.updateQueue.baseState = c);
}
var $0b2e6adb871a3b94$var$Kg = {
    isMounted: function(a) {
        return (a = a._reactInternals) ? $0b2e6adb871a3b94$var$Zb(a) === a : !1;
    },
    enqueueSetState: function(a, b, c) {
        a = a._reactInternals;
        var d = $0b2e6adb871a3b94$var$Hg(), e = $0b2e6adb871a3b94$var$Ig(a), f = $0b2e6adb871a3b94$var$zg(d, e);
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        $0b2e6adb871a3b94$var$Ag(a, f);
        $0b2e6adb871a3b94$var$Jg(a, e, d);
    },
    enqueueReplaceState: function(a, b, c) {
        a = a._reactInternals;
        var d = $0b2e6adb871a3b94$var$Hg(), e = $0b2e6adb871a3b94$var$Ig(a), f = $0b2e6adb871a3b94$var$zg(d, e);
        f.tag = 1;
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        $0b2e6adb871a3b94$var$Ag(a, f);
        $0b2e6adb871a3b94$var$Jg(a, e, d);
    },
    enqueueForceUpdate: function(a, b) {
        a = a._reactInternals;
        var c = $0b2e6adb871a3b94$var$Hg(), d = $0b2e6adb871a3b94$var$Ig(a), e = $0b2e6adb871a3b94$var$zg(c, d);
        e.tag = 2;
        void 0 !== b && null !== b && (e.callback = b);
        $0b2e6adb871a3b94$var$Ag(a, e);
        $0b2e6adb871a3b94$var$Jg(a, d, c);
    }
};
function $0b2e6adb871a3b94$var$Lg(a, b, c, d, e, f, g) {
    a = a.stateNode;
    return "function" === typeof a.shouldComponentUpdate ? a.shouldComponentUpdate(d, f, g) : b.prototype && b.prototype.isPureReactComponent ? !$0b2e6adb871a3b94$var$Je(c, d) || !$0b2e6adb871a3b94$var$Je(e, f) : !0;
}
function $0b2e6adb871a3b94$var$Mg(a, b, c) {
    var d = !1, e = $0b2e6adb871a3b94$var$Cf;
    var f = b.contextType;
    "object" === typeof f && null !== f ? f = $0b2e6adb871a3b94$var$vg(f) : (e = $0b2e6adb871a3b94$var$Ff(b) ? $0b2e6adb871a3b94$var$Df : $0b2e6adb871a3b94$var$M.current, d = b.contextTypes, f = (d = null !== d && void 0 !== d) ? $0b2e6adb871a3b94$var$Ef(a, e) : $0b2e6adb871a3b94$var$Cf);
    b = new b(c, f);
    a.memoizedState = null !== b.state && void 0 !== b.state ? b.state : null;
    b.updater = $0b2e6adb871a3b94$var$Kg;
    a.stateNode = b;
    b._reactInternals = a;
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = e, a.__reactInternalMemoizedMaskedChildContext = f);
    return b;
}
function $0b2e6adb871a3b94$var$Ng(a, b, c, d) {
    a = b.state;
    "function" === typeof b.componentWillReceiveProps && b.componentWillReceiveProps(c, d);
    "function" === typeof b.UNSAFE_componentWillReceiveProps && b.UNSAFE_componentWillReceiveProps(c, d);
    b.state !== a && $0b2e6adb871a3b94$var$Kg.enqueueReplaceState(b, b.state, null);
}
function $0b2e6adb871a3b94$var$Og(a, b, c, d) {
    var e = a.stateNode;
    e.props = c;
    e.state = a.memoizedState;
    e.refs = $0b2e6adb871a3b94$var$Fg;
    $0b2e6adb871a3b94$var$xg(a);
    var f = b.contextType;
    "object" === typeof f && null !== f ? e.context = $0b2e6adb871a3b94$var$vg(f) : (f = $0b2e6adb871a3b94$var$Ff(b) ? $0b2e6adb871a3b94$var$Df : $0b2e6adb871a3b94$var$M.current, e.context = $0b2e6adb871a3b94$var$Ef(a, f));
    $0b2e6adb871a3b94$var$Cg(a, c, e, d);
    e.state = a.memoizedState;
    f = b.getDerivedStateFromProps;
    "function" === typeof f && ($0b2e6adb871a3b94$var$Gg(a, b, f, c), e.state = a.memoizedState);
    "function" === typeof b.getDerivedStateFromProps || "function" === typeof e.getSnapshotBeforeUpdate || "function" !== typeof e.UNSAFE_componentWillMount && "function" !== typeof e.componentWillMount || (b = e.state, "function" === typeof e.componentWillMount && e.componentWillMount(), "function" === typeof e.UNSAFE_componentWillMount && e.UNSAFE_componentWillMount(), b !== e.state && $0b2e6adb871a3b94$var$Kg.enqueueReplaceState(e, e.state, null), $0b2e6adb871a3b94$var$Cg(a, c, e, d), e.state = a.memoizedState);
    "function" === typeof e.componentDidMount && (a.flags |= 4);
}
var $0b2e6adb871a3b94$var$Pg = Array.isArray;
function $0b2e6adb871a3b94$var$Qg(a, b, c) {
    a = c.ref;
    if (null !== a && "function" !== typeof a && "object" !== typeof a) {
        if (c._owner) {
            c = c._owner;
            if (c) {
                if (1 !== c.tag) throw Error($0b2e6adb871a3b94$var$y(309));
                var d = c.stateNode;
            }
            if (!d) throw Error($0b2e6adb871a3b94$var$y(147, a));
            var e = "" + a;
            if (null !== b && null !== b.ref && "function" === typeof b.ref && b.ref._stringRef === e) return b.ref;
            b = function(a) {
                var b = d.refs;
                b === $0b2e6adb871a3b94$var$Fg && (b = d.refs = {});
                null === a ? delete b[e] : b[e] = a;
            };
            b._stringRef = e;
            return b;
        }
        if ("string" !== typeof a) throw Error($0b2e6adb871a3b94$var$y(284));
        if (!c._owner) throw Error($0b2e6adb871a3b94$var$y(290, a));
    }
    return a;
}
function $0b2e6adb871a3b94$var$Rg(a, b) {
    if ("textarea" !== a.type) throw Error($0b2e6adb871a3b94$var$y(31, "[object Object]" === Object.prototype.toString.call(b) ? "object with keys {" + Object.keys(b).join(", ") + "}" : b));
}
function $0b2e6adb871a3b94$var$Sg(a) {
    function b(b, c) {
        if (a) {
            var d = b.lastEffect;
            null !== d ? (d.nextEffect = c, b.lastEffect = c) : b.firstEffect = b.lastEffect = c;
            c.nextEffect = null;
            c.flags = 8;
        }
    }
    function c(c, d) {
        if (!a) return null;
        for(; null !== d;)b(c, d), d = d.sibling;
        return null;
    }
    function d(a, b) {
        for(a = new Map; null !== b;)null !== b.key ? a.set(b.key, b) : a.set(b.index, b), b = b.sibling;
        return a;
    }
    function e(a, b) {
        a = $0b2e6adb871a3b94$var$Tg(a, b);
        a.index = 0;
        a.sibling = null;
        return a;
    }
    function f(b, c, d) {
        b.index = d;
        if (!a) return c;
        d = b.alternate;
        if (null !== d) return d = d.index, d < c ? (b.flags = 2, c) : d;
        b.flags = 2;
        return c;
    }
    function g(b) {
        a && null === b.alternate && (b.flags = 2);
        return b;
    }
    function h(a, b, c, d) {
        if (null === b || 6 !== b.tag) return b = $0b2e6adb871a3b94$var$Ug(c, a.mode, d), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function k(a, b, c, d) {
        if (null !== b && b.elementType === c.type) return d = e(b, c.props), d.ref = $0b2e6adb871a3b94$var$Qg(a, b, c), d.return = a, d;
        d = $0b2e6adb871a3b94$var$Vg(c.type, c.key, c.props, null, a.mode, d);
        d.ref = $0b2e6adb871a3b94$var$Qg(a, b, c);
        d.return = a;
        return d;
    }
    function l(a, b, c, d) {
        if (null === b || 4 !== b.tag || b.stateNode.containerInfo !== c.containerInfo || b.stateNode.implementation !== c.implementation) return b = $0b2e6adb871a3b94$var$Wg(c, a.mode, d), b.return = a, b;
        b = e(b, c.children || []);
        b.return = a;
        return b;
    }
    function n(a, b, c, d, f) {
        if (null === b || 7 !== b.tag) return b = $0b2e6adb871a3b94$var$Xg(c, a.mode, d, f), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function A(a, b, c) {
        if ("string" === typeof b || "number" === typeof b) return b = $0b2e6adb871a3b94$var$Ug("" + b, a.mode, c), b.return = a, b;
        if ("object" === typeof b && null !== b) {
            switch(b.$$typeof){
                case $0b2e6adb871a3b94$var$sa:
                    return c = $0b2e6adb871a3b94$var$Vg(b.type, b.key, b.props, null, a.mode, c), c.ref = $0b2e6adb871a3b94$var$Qg(a, null, b), c.return = a, c;
                case $0b2e6adb871a3b94$var$ta:
                    return b = $0b2e6adb871a3b94$var$Wg(b, a.mode, c), b.return = a, b;
            }
            if ($0b2e6adb871a3b94$var$Pg(b) || $0b2e6adb871a3b94$var$La(b)) return b = $0b2e6adb871a3b94$var$Xg(b, a.mode, c, null), b.return = a, b;
            $0b2e6adb871a3b94$var$Rg(a, b);
        }
        return null;
    }
    function p(a, b, c, d) {
        var e = null !== b ? b.key : null;
        if ("string" === typeof c || "number" === typeof c) return null !== e ? null : h(a, b, "" + c, d);
        if ("object" === typeof c && null !== c) {
            switch(c.$$typeof){
                case $0b2e6adb871a3b94$var$sa:
                    return c.key === e ? c.type === $0b2e6adb871a3b94$var$ua ? n(a, b, c.props.children, d, e) : k(a, b, c, d) : null;
                case $0b2e6adb871a3b94$var$ta:
                    return c.key === e ? l(a, b, c, d) : null;
            }
            if ($0b2e6adb871a3b94$var$Pg(c) || $0b2e6adb871a3b94$var$La(c)) return null !== e ? null : n(a, b, c, d, null);
            $0b2e6adb871a3b94$var$Rg(a, c);
        }
        return null;
    }
    function C(a, b, c, d, e) {
        if ("string" === typeof d || "number" === typeof d) return a = a.get(c) || null, h(b, a, "" + d, e);
        if ("object" === typeof d && null !== d) {
            switch(d.$$typeof){
                case $0b2e6adb871a3b94$var$sa:
                    return a = a.get(null === d.key ? c : d.key) || null, d.type === $0b2e6adb871a3b94$var$ua ? n(b, a, d.props.children, e, d.key) : k(b, a, d, e);
                case $0b2e6adb871a3b94$var$ta:
                    return a = a.get(null === d.key ? c : d.key) || null, l(b, a, d, e);
            }
            if ($0b2e6adb871a3b94$var$Pg(d) || $0b2e6adb871a3b94$var$La(d)) return a = a.get(c) || null, n(b, a, d, e, null);
            $0b2e6adb871a3b94$var$Rg(b, d);
        }
        return null;
    }
    function x(e, g, h, k) {
        for(var l = null, t = null, u = g, z = g = 0, q = null; null !== u && z < h.length; z++){
            u.index > z ? (q = u, u = null) : q = u.sibling;
            var n = p(e, u, h[z], k);
            if (null === n) {
                null === u && (u = q);
                break;
            }
            a && u && null === n.alternate && b(e, u);
            g = f(n, g, z);
            null === t ? l = n : t.sibling = n;
            t = n;
            u = q;
        }
        if (z === h.length) return c(e, u), l;
        if (null === u) {
            for(; z < h.length; z++)u = A(e, h[z], k), null !== u && (g = f(u, g, z), null === t ? l = u : t.sibling = u, t = u);
            return l;
        }
        for(u = d(e, u); z < h.length; z++)q = C(u, e, z, h[z], k), null !== q && (a && null !== q.alternate && u.delete(null === q.key ? z : q.key), g = f(q, g, z), null === t ? l = q : t.sibling = q, t = q);
        a && u.forEach(function(a) {
            return b(e, a);
        });
        return l;
    }
    function w(e, g, h, k) {
        var l = $0b2e6adb871a3b94$var$La(h);
        if ("function" !== typeof l) throw Error($0b2e6adb871a3b94$var$y(150));
        h = l.call(h);
        if (null == h) throw Error($0b2e6adb871a3b94$var$y(151));
        for(var t = l = null, u = g, z = g = 0, q = null, n = h.next(); null !== u && !n.done; z++, n = h.next()){
            u.index > z ? (q = u, u = null) : q = u.sibling;
            var w = p(e, u, n.value, k);
            if (null === w) {
                null === u && (u = q);
                break;
            }
            a && u && null === w.alternate && b(e, u);
            g = f(w, g, z);
            null === t ? l = w : t.sibling = w;
            t = w;
            u = q;
        }
        if (n.done) return c(e, u), l;
        if (null === u) {
            for(; !n.done; z++, n = h.next())n = A(e, n.value, k), null !== n && (g = f(n, g, z), null === t ? l = n : t.sibling = n, t = n);
            return l;
        }
        for(u = d(e, u); !n.done; z++, n = h.next())n = C(u, e, z, n.value, k), null !== n && (a && null !== n.alternate && u.delete(null === n.key ? z : n.key), g = f(n, g, z), null === t ? l = n : t.sibling = n, t = n);
        a && u.forEach(function(a) {
            return b(e, a);
        });
        return l;
    }
    return function(a, d, f, h) {
        var k = "object" === typeof f && null !== f && f.type === $0b2e6adb871a3b94$var$ua && null === f.key;
        k && (f = f.props.children);
        var l = "object" === typeof f && null !== f;
        if (l) switch(f.$$typeof){
            case $0b2e6adb871a3b94$var$sa:
                a: {
                    l = f.key;
                    for(k = d; null !== k;){
                        if (k.key === l) {
                            switch(k.tag){
                                case 7:
                                    if (f.type === $0b2e6adb871a3b94$var$ua) {
                                        c(a, k.sibling);
                                        d = e(k, f.props.children);
                                        d.return = a;
                                        a = d;
                                        break a;
                                    }
                                    break;
                                default:
                                    if (k.elementType === f.type) {
                                        c(a, k.sibling);
                                        d = e(k, f.props);
                                        d.ref = $0b2e6adb871a3b94$var$Qg(a, k, f);
                                        d.return = a;
                                        a = d;
                                        break a;
                                    }
                            }
                            c(a, k);
                            break;
                        } else b(a, k);
                        k = k.sibling;
                    }
                    f.type === $0b2e6adb871a3b94$var$ua ? (d = $0b2e6adb871a3b94$var$Xg(f.props.children, a.mode, h, f.key), d.return = a, a = d) : (h = $0b2e6adb871a3b94$var$Vg(f.type, f.key, f.props, null, a.mode, h), h.ref = $0b2e6adb871a3b94$var$Qg(a, d, f), h.return = a, a = h);
                }
                return g(a);
            case $0b2e6adb871a3b94$var$ta:
                a: {
                    for(k = f.key; null !== d;){
                        if (d.key === k) {
                            if (4 === d.tag && d.stateNode.containerInfo === f.containerInfo && d.stateNode.implementation === f.implementation) {
                                c(a, d.sibling);
                                d = e(d, f.children || []);
                                d.return = a;
                                a = d;
                                break a;
                            } else {
                                c(a, d);
                                break;
                            }
                        } else b(a, d);
                        d = d.sibling;
                    }
                    d = $0b2e6adb871a3b94$var$Wg(f, a.mode, h);
                    d.return = a;
                    a = d;
                }
                return g(a);
        }
        if ("string" === typeof f || "number" === typeof f) return f = "" + f, null !== d && 6 === d.tag ? (c(a, d.sibling), d = e(d, f), d.return = a, a = d) : (c(a, d), d = $0b2e6adb871a3b94$var$Ug(f, a.mode, h), d.return = a, a = d), g(a);
        if ($0b2e6adb871a3b94$var$Pg(f)) return x(a, d, f, h);
        if ($0b2e6adb871a3b94$var$La(f)) return w(a, d, f, h);
        l && $0b2e6adb871a3b94$var$Rg(a, f);
        if ("undefined" === typeof f && !k) switch(a.tag){
            case 1:
            case 22:
            case 0:
            case 11:
            case 15:
                throw Error($0b2e6adb871a3b94$var$y(152, $0b2e6adb871a3b94$var$Ra(a.type) || "Component"));
        }
        return c(a, d);
    };
}
var $0b2e6adb871a3b94$var$Yg = $0b2e6adb871a3b94$var$Sg(!0), $0b2e6adb871a3b94$var$Zg = $0b2e6adb871a3b94$var$Sg(!1), $0b2e6adb871a3b94$var$$g = {}, $0b2e6adb871a3b94$var$ah = $0b2e6adb871a3b94$var$Bf($0b2e6adb871a3b94$var$$g), $0b2e6adb871a3b94$var$bh = $0b2e6adb871a3b94$var$Bf($0b2e6adb871a3b94$var$$g), $0b2e6adb871a3b94$var$ch = $0b2e6adb871a3b94$var$Bf($0b2e6adb871a3b94$var$$g);
function $0b2e6adb871a3b94$var$dh(a) {
    if (a === $0b2e6adb871a3b94$var$$g) throw Error($0b2e6adb871a3b94$var$y(174));
    return a;
}
function $0b2e6adb871a3b94$var$eh(a, b) {
    $0b2e6adb871a3b94$var$I($0b2e6adb871a3b94$var$ch, b);
    $0b2e6adb871a3b94$var$I($0b2e6adb871a3b94$var$bh, a);
    $0b2e6adb871a3b94$var$I($0b2e6adb871a3b94$var$ah, $0b2e6adb871a3b94$var$$g);
    a = b.nodeType;
    switch(a){
        case 9:
        case 11:
            b = (b = b.documentElement) ? b.namespaceURI : $0b2e6adb871a3b94$var$mb(null, "");
            break;
        default:
            a = 8 === a ? b.parentNode : b, b = a.namespaceURI || null, a = a.tagName, b = $0b2e6adb871a3b94$var$mb(b, a);
    }
    $0b2e6adb871a3b94$var$H($0b2e6adb871a3b94$var$ah);
    $0b2e6adb871a3b94$var$I($0b2e6adb871a3b94$var$ah, b);
}
function $0b2e6adb871a3b94$var$fh() {
    $0b2e6adb871a3b94$var$H($0b2e6adb871a3b94$var$ah);
    $0b2e6adb871a3b94$var$H($0b2e6adb871a3b94$var$bh);
    $0b2e6adb871a3b94$var$H($0b2e6adb871a3b94$var$ch);
}
function $0b2e6adb871a3b94$var$gh(a) {
    $0b2e6adb871a3b94$var$dh($0b2e6adb871a3b94$var$ch.current);
    var b = $0b2e6adb871a3b94$var$dh($0b2e6adb871a3b94$var$ah.current);
    var c = $0b2e6adb871a3b94$var$mb(b, a.type);
    b !== c && ($0b2e6adb871a3b94$var$I($0b2e6adb871a3b94$var$bh, a), $0b2e6adb871a3b94$var$I($0b2e6adb871a3b94$var$ah, c));
}
function $0b2e6adb871a3b94$var$hh(a) {
    $0b2e6adb871a3b94$var$bh.current === a && ($0b2e6adb871a3b94$var$H($0b2e6adb871a3b94$var$ah), $0b2e6adb871a3b94$var$H($0b2e6adb871a3b94$var$bh));
}
var $0b2e6adb871a3b94$var$P = $0b2e6adb871a3b94$var$Bf(0);
function $0b2e6adb871a3b94$var$ih(a) {
    for(var b = a; null !== b;){
        if (13 === b.tag) {
            var c = b.memoizedState;
            if (null !== c && (c = c.dehydrated, null === c || "$?" === c.data || "$!" === c.data)) return b;
        } else if (19 === b.tag && void 0 !== b.memoizedProps.revealOrder) {
            if (0 !== (b.flags & 64)) return b;
        } else if (null !== b.child) {
            b.child.return = b;
            b = b.child;
            continue;
        }
        if (b === a) break;
        for(; null === b.sibling;){
            if (null === b.return || b.return === a) return null;
            b = b.return;
        }
        b.sibling.return = b.return;
        b = b.sibling;
    }
    return null;
}
var $0b2e6adb871a3b94$var$jh = null, $0b2e6adb871a3b94$var$kh = null, $0b2e6adb871a3b94$var$lh = !1;
function $0b2e6adb871a3b94$var$mh(a, b) {
    var c = $0b2e6adb871a3b94$var$nh(5, null, null, 0);
    c.elementType = "DELETED";
    c.type = "DELETED";
    c.stateNode = b;
    c.return = a;
    c.flags = 8;
    null !== a.lastEffect ? (a.lastEffect.nextEffect = c, a.lastEffect = c) : a.firstEffect = a.lastEffect = c;
}
function $0b2e6adb871a3b94$var$oh(a, b) {
    switch(a.tag){
        case 5:
            var c = a.type;
            b = 1 !== b.nodeType || c.toLowerCase() !== b.nodeName.toLowerCase() ? null : b;
            return null !== b ? (a.stateNode = b, !0) : !1;
        case 6:
            return b = "" === a.pendingProps || 3 !== b.nodeType ? null : b, null !== b ? (a.stateNode = b, !0) : !1;
        case 13:
            return !1;
        default:
            return !1;
    }
}
function $0b2e6adb871a3b94$var$ph(a) {
    if ($0b2e6adb871a3b94$var$lh) {
        var b = $0b2e6adb871a3b94$var$kh;
        if (b) {
            var c = b;
            if (!$0b2e6adb871a3b94$var$oh(a, b)) {
                b = $0b2e6adb871a3b94$var$rf(c.nextSibling);
                if (!b || !$0b2e6adb871a3b94$var$oh(a, b)) {
                    a.flags = a.flags & -1025 | 2;
                    $0b2e6adb871a3b94$var$lh = !1;
                    $0b2e6adb871a3b94$var$jh = a;
                    return;
                }
                $0b2e6adb871a3b94$var$mh($0b2e6adb871a3b94$var$jh, c);
            }
            $0b2e6adb871a3b94$var$jh = a;
            $0b2e6adb871a3b94$var$kh = $0b2e6adb871a3b94$var$rf(b.firstChild);
        } else a.flags = a.flags & -1025 | 2, $0b2e6adb871a3b94$var$lh = !1, $0b2e6adb871a3b94$var$jh = a;
    }
}
function $0b2e6adb871a3b94$var$qh(a) {
    for(a = a.return; null !== a && 5 !== a.tag && 3 !== a.tag && 13 !== a.tag;)a = a.return;
    $0b2e6adb871a3b94$var$jh = a;
}
function $0b2e6adb871a3b94$var$rh(a) {
    if (a !== $0b2e6adb871a3b94$var$jh) return !1;
    if (!$0b2e6adb871a3b94$var$lh) return $0b2e6adb871a3b94$var$qh(a), $0b2e6adb871a3b94$var$lh = !0, !1;
    var b = a.type;
    if (5 !== a.tag || "head" !== b && "body" !== b && !$0b2e6adb871a3b94$var$nf(b, a.memoizedProps)) for(b = $0b2e6adb871a3b94$var$kh; b;)$0b2e6adb871a3b94$var$mh(a, b), b = $0b2e6adb871a3b94$var$rf(b.nextSibling);
    $0b2e6adb871a3b94$var$qh(a);
    if (13 === a.tag) {
        a = a.memoizedState;
        a = null !== a ? a.dehydrated : null;
        if (!a) throw Error($0b2e6adb871a3b94$var$y(317));
        a: {
            a = a.nextSibling;
            for(b = 0; a;){
                if (8 === a.nodeType) {
                    var c = a.data;
                    if ("/$" === c) {
                        if (0 === b) {
                            $0b2e6adb871a3b94$var$kh = $0b2e6adb871a3b94$var$rf(a.nextSibling);
                            break a;
                        }
                        b--;
                    } else "$" !== c && "$!" !== c && "$?" !== c || b++;
                }
                a = a.nextSibling;
            }
            $0b2e6adb871a3b94$var$kh = null;
        }
    } else $0b2e6adb871a3b94$var$kh = $0b2e6adb871a3b94$var$jh ? $0b2e6adb871a3b94$var$rf(a.stateNode.nextSibling) : null;
    return !0;
}
function $0b2e6adb871a3b94$var$sh() {
    $0b2e6adb871a3b94$var$kh = $0b2e6adb871a3b94$var$jh = null;
    $0b2e6adb871a3b94$var$lh = !1;
}
var $0b2e6adb871a3b94$var$th = [];
function $0b2e6adb871a3b94$var$uh() {
    for(var a = 0; a < $0b2e6adb871a3b94$var$th.length; a++)$0b2e6adb871a3b94$var$th[a]._workInProgressVersionPrimary = null;
    $0b2e6adb871a3b94$var$th.length = 0;
}
var $0b2e6adb871a3b94$var$vh = $0b2e6adb871a3b94$var$ra.ReactCurrentDispatcher, $0b2e6adb871a3b94$var$wh = $0b2e6adb871a3b94$var$ra.ReactCurrentBatchConfig, $0b2e6adb871a3b94$var$xh = 0, $0b2e6adb871a3b94$var$R = null, $0b2e6adb871a3b94$var$S = null, $0b2e6adb871a3b94$var$T = null, $0b2e6adb871a3b94$var$yh = !1, $0b2e6adb871a3b94$var$zh = !1;
function $0b2e6adb871a3b94$var$Ah() {
    throw Error($0b2e6adb871a3b94$var$y(321));
}
function $0b2e6adb871a3b94$var$Bh(a, b) {
    if (null === b) return !1;
    for(var c = 0; c < b.length && c < a.length; c++)if (!$0b2e6adb871a3b94$var$He(a[c], b[c])) return !1;
    return !0;
}
function $0b2e6adb871a3b94$var$Ch(a, b, c, d, e, f) {
    $0b2e6adb871a3b94$var$xh = f;
    $0b2e6adb871a3b94$var$R = b;
    b.memoizedState = null;
    b.updateQueue = null;
    b.lanes = 0;
    $0b2e6adb871a3b94$var$vh.current = null === a || null === a.memoizedState ? $0b2e6adb871a3b94$var$Dh : $0b2e6adb871a3b94$var$Eh;
    a = c(d, e);
    if ($0b2e6adb871a3b94$var$zh) {
        f = 0;
        do {
            $0b2e6adb871a3b94$var$zh = !1;
            if (!(25 > f)) throw Error($0b2e6adb871a3b94$var$y(301));
            f += 1;
            $0b2e6adb871a3b94$var$T = $0b2e6adb871a3b94$var$S = null;
            b.updateQueue = null;
            $0b2e6adb871a3b94$var$vh.current = $0b2e6adb871a3b94$var$Fh;
            a = c(d, e);
        }while ($0b2e6adb871a3b94$var$zh);
    }
    $0b2e6adb871a3b94$var$vh.current = $0b2e6adb871a3b94$var$Gh;
    b = null !== $0b2e6adb871a3b94$var$S && null !== $0b2e6adb871a3b94$var$S.next;
    $0b2e6adb871a3b94$var$xh = 0;
    $0b2e6adb871a3b94$var$T = $0b2e6adb871a3b94$var$S = $0b2e6adb871a3b94$var$R = null;
    $0b2e6adb871a3b94$var$yh = !1;
    if (b) throw Error($0b2e6adb871a3b94$var$y(300));
    return a;
}
function $0b2e6adb871a3b94$var$Hh() {
    var a = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === $0b2e6adb871a3b94$var$T ? $0b2e6adb871a3b94$var$R.memoizedState = $0b2e6adb871a3b94$var$T = a : $0b2e6adb871a3b94$var$T = $0b2e6adb871a3b94$var$T.next = a;
    return $0b2e6adb871a3b94$var$T;
}
function $0b2e6adb871a3b94$var$Ih() {
    if (null === $0b2e6adb871a3b94$var$S) {
        var a = $0b2e6adb871a3b94$var$R.alternate;
        a = null !== a ? a.memoizedState : null;
    } else a = $0b2e6adb871a3b94$var$S.next;
    var b = null === $0b2e6adb871a3b94$var$T ? $0b2e6adb871a3b94$var$R.memoizedState : $0b2e6adb871a3b94$var$T.next;
    if (null !== b) $0b2e6adb871a3b94$var$T = b, $0b2e6adb871a3b94$var$S = a;
    else {
        if (null === a) throw Error($0b2e6adb871a3b94$var$y(310));
        $0b2e6adb871a3b94$var$S = a;
        a = {
            memoizedState: $0b2e6adb871a3b94$var$S.memoizedState,
            baseState: $0b2e6adb871a3b94$var$S.baseState,
            baseQueue: $0b2e6adb871a3b94$var$S.baseQueue,
            queue: $0b2e6adb871a3b94$var$S.queue,
            next: null
        };
        null === $0b2e6adb871a3b94$var$T ? $0b2e6adb871a3b94$var$R.memoizedState = $0b2e6adb871a3b94$var$T = a : $0b2e6adb871a3b94$var$T = $0b2e6adb871a3b94$var$T.next = a;
    }
    return $0b2e6adb871a3b94$var$T;
}
function $0b2e6adb871a3b94$var$Jh(a, b) {
    return "function" === typeof b ? b(a) : b;
}
function $0b2e6adb871a3b94$var$Kh(a) {
    var b = $0b2e6adb871a3b94$var$Ih(), c = b.queue;
    if (null === c) throw Error($0b2e6adb871a3b94$var$y(311));
    c.lastRenderedReducer = a;
    var d = $0b2e6adb871a3b94$var$S, e = d.baseQueue, f = c.pending;
    if (null !== f) {
        if (null !== e) {
            var g = e.next;
            e.next = f.next;
            f.next = g;
        }
        d.baseQueue = e = f;
        c.pending = null;
    }
    if (null !== e) {
        e = e.next;
        d = d.baseState;
        var h = g = f = null, k = e;
        do {
            var l = k.lane;
            if (($0b2e6adb871a3b94$var$xh & l) === l) null !== h && (h = h.next = {
                lane: 0,
                action: k.action,
                eagerReducer: k.eagerReducer,
                eagerState: k.eagerState,
                next: null
            }), d = k.eagerReducer === a ? k.eagerState : a(d, k.action);
            else {
                var n = {
                    lane: l,
                    action: k.action,
                    eagerReducer: k.eagerReducer,
                    eagerState: k.eagerState,
                    next: null
                };
                null === h ? (g = h = n, f = d) : h = h.next = n;
                $0b2e6adb871a3b94$var$R.lanes |= l;
                $0b2e6adb871a3b94$var$Dg |= l;
            }
            k = k.next;
        }while (null !== k && k !== e);
        null === h ? f = d : h.next = g;
        $0b2e6adb871a3b94$var$He(d, b.memoizedState) || ($0b2e6adb871a3b94$var$ug = !0);
        b.memoizedState = d;
        b.baseState = f;
        b.baseQueue = h;
        c.lastRenderedState = d;
    }
    return [
        b.memoizedState,
        c.dispatch
    ];
}
function $0b2e6adb871a3b94$var$Lh(a) {
    var b = $0b2e6adb871a3b94$var$Ih(), c = b.queue;
    if (null === c) throw Error($0b2e6adb871a3b94$var$y(311));
    c.lastRenderedReducer = a;
    var d = c.dispatch, e = c.pending, f = b.memoizedState;
    if (null !== e) {
        c.pending = null;
        var g = e = e.next;
        do f = a(f, g.action), g = g.next;
        while (g !== e);
        $0b2e6adb871a3b94$var$He(f, b.memoizedState) || ($0b2e6adb871a3b94$var$ug = !0);
        b.memoizedState = f;
        null === b.baseQueue && (b.baseState = f);
        c.lastRenderedState = f;
    }
    return [
        f,
        d
    ];
}
function $0b2e6adb871a3b94$var$Mh(a, b, c) {
    var d = b._getVersion;
    d = d(b._source);
    var e = b._workInProgressVersionPrimary;
    if (null !== e) a = e === d;
    else if (a = a.mutableReadLanes, a = ($0b2e6adb871a3b94$var$xh & a) === a) b._workInProgressVersionPrimary = d, $0b2e6adb871a3b94$var$th.push(b);
    if (a) return c(b._source);
    $0b2e6adb871a3b94$var$th.push(b);
    throw Error($0b2e6adb871a3b94$var$y(350));
}
function $0b2e6adb871a3b94$var$Nh(a, b, c, d) {
    var e = $0b2e6adb871a3b94$var$U;
    if (null === e) throw Error($0b2e6adb871a3b94$var$y(349));
    var f = b._getVersion, g = f(b._source), h = $0b2e6adb871a3b94$var$vh.current, k = h.useState(function() {
        return $0b2e6adb871a3b94$var$Mh(e, b, c);
    }), l = k[1], n = k[0];
    k = $0b2e6adb871a3b94$var$T;
    var A = a.memoizedState, p = A.refs, C = p.getSnapshot, x = A.source;
    A = A.subscribe;
    var w = $0b2e6adb871a3b94$var$R;
    a.memoizedState = {
        refs: p,
        source: b,
        subscribe: d
    };
    h.useEffect(function() {
        p.getSnapshot = c;
        p.setSnapshot = l;
        var a = f(b._source);
        if (!$0b2e6adb871a3b94$var$He(g, a)) {
            a = c(b._source);
            $0b2e6adb871a3b94$var$He(n, a) || (l(a), a = $0b2e6adb871a3b94$var$Ig(w), e.mutableReadLanes |= a & e.pendingLanes);
            a = e.mutableReadLanes;
            e.entangledLanes |= a;
            for(var d = e.entanglements, h = a; 0 < h;){
                var k = 31 - $0b2e6adb871a3b94$var$Vc(h), v = 1 << k;
                d[k] |= a;
                h &= ~v;
            }
        }
    }, [
        c,
        b,
        d
    ]);
    h.useEffect(function() {
        return d(b._source, function() {
            var a = p.getSnapshot, c = p.setSnapshot;
            try {
                c(a(b._source));
                var d = $0b2e6adb871a3b94$var$Ig(w);
                e.mutableReadLanes |= d & e.pendingLanes;
            } catch (q) {
                c(function() {
                    throw q;
                });
            }
        });
    }, [
        b,
        d
    ]);
    $0b2e6adb871a3b94$var$He(C, c) && $0b2e6adb871a3b94$var$He(x, b) && $0b2e6adb871a3b94$var$He(A, d) || (a = {
        pending: null,
        dispatch: null,
        lastRenderedReducer: $0b2e6adb871a3b94$var$Jh,
        lastRenderedState: n
    }, a.dispatch = l = $0b2e6adb871a3b94$var$Oh.bind(null, $0b2e6adb871a3b94$var$R, a), k.queue = a, k.baseQueue = null, n = $0b2e6adb871a3b94$var$Mh(e, b, c), k.memoizedState = k.baseState = n);
    return n;
}
function $0b2e6adb871a3b94$var$Ph(a, b, c) {
    var d = $0b2e6adb871a3b94$var$Ih();
    return $0b2e6adb871a3b94$var$Nh(d, a, b, c);
}
function $0b2e6adb871a3b94$var$Qh(a) {
    var b = $0b2e6adb871a3b94$var$Hh();
    "function" === typeof a && (a = a());
    b.memoizedState = b.baseState = a;
    a = b.queue = {
        pending: null,
        dispatch: null,
        lastRenderedReducer: $0b2e6adb871a3b94$var$Jh,
        lastRenderedState: a
    };
    a = a.dispatch = $0b2e6adb871a3b94$var$Oh.bind(null, $0b2e6adb871a3b94$var$R, a);
    return [
        b.memoizedState,
        a
    ];
}
function $0b2e6adb871a3b94$var$Rh(a, b, c, d) {
    a = {
        tag: a,
        create: b,
        destroy: c,
        deps: d,
        next: null
    };
    b = $0b2e6adb871a3b94$var$R.updateQueue;
    null === b ? (b = {
        lastEffect: null
    }, $0b2e6adb871a3b94$var$R.updateQueue = b, b.lastEffect = a.next = a) : (c = b.lastEffect, null === c ? b.lastEffect = a.next = a : (d = c.next, c.next = a, a.next = d, b.lastEffect = a));
    return a;
}
function $0b2e6adb871a3b94$var$Sh(a) {
    var b = $0b2e6adb871a3b94$var$Hh();
    a = {
        current: a
    };
    return b.memoizedState = a;
}
function $0b2e6adb871a3b94$var$Th() {
    return $0b2e6adb871a3b94$var$Ih().memoizedState;
}
function $0b2e6adb871a3b94$var$Uh(a, b, c, d) {
    var e = $0b2e6adb871a3b94$var$Hh();
    $0b2e6adb871a3b94$var$R.flags |= a;
    e.memoizedState = $0b2e6adb871a3b94$var$Rh(1 | b, c, void 0, void 0 === d ? null : d);
}
function $0b2e6adb871a3b94$var$Vh(a, b, c, d) {
    var e = $0b2e6adb871a3b94$var$Ih();
    d = void 0 === d ? null : d;
    var f = void 0;
    if (null !== $0b2e6adb871a3b94$var$S) {
        var g = $0b2e6adb871a3b94$var$S.memoizedState;
        f = g.destroy;
        if (null !== d && $0b2e6adb871a3b94$var$Bh(d, g.deps)) {
            $0b2e6adb871a3b94$var$Rh(b, c, f, d);
            return;
        }
    }
    $0b2e6adb871a3b94$var$R.flags |= a;
    e.memoizedState = $0b2e6adb871a3b94$var$Rh(1 | b, c, f, d);
}
function $0b2e6adb871a3b94$var$Wh(a, b) {
    return $0b2e6adb871a3b94$var$Uh(516, 4, a, b);
}
function $0b2e6adb871a3b94$var$Xh(a, b) {
    return $0b2e6adb871a3b94$var$Vh(516, 4, a, b);
}
function $0b2e6adb871a3b94$var$Yh(a, b) {
    return $0b2e6adb871a3b94$var$Vh(4, 2, a, b);
}
function $0b2e6adb871a3b94$var$Zh(a, b) {
    if ("function" === typeof b) return a = a(), b(a), function() {
        b(null);
    };
    if (null !== b && void 0 !== b) return a = a(), b.current = a, function() {
        b.current = null;
    };
}
function $0b2e6adb871a3b94$var$$h(a, b, c) {
    c = null !== c && void 0 !== c ? c.concat([
        a
    ]) : null;
    return $0b2e6adb871a3b94$var$Vh(4, 2, $0b2e6adb871a3b94$var$Zh.bind(null, b, a), c);
}
function $0b2e6adb871a3b94$var$ai() {}
function $0b2e6adb871a3b94$var$bi(a, b) {
    var c = $0b2e6adb871a3b94$var$Ih();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $0b2e6adb871a3b94$var$Bh(b, d[1])) return d[0];
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $0b2e6adb871a3b94$var$ci(a, b) {
    var c = $0b2e6adb871a3b94$var$Ih();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $0b2e6adb871a3b94$var$Bh(b, d[1])) return d[0];
    a = a();
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $0b2e6adb871a3b94$var$di(a, b) {
    var c = $0b2e6adb871a3b94$var$eg();
    $0b2e6adb871a3b94$var$gg(98 > c ? 98 : c, function() {
        a(!0);
    });
    $0b2e6adb871a3b94$var$gg(97 < c ? 97 : c, function() {
        var c = $0b2e6adb871a3b94$var$wh.transition;
        $0b2e6adb871a3b94$var$wh.transition = 1;
        try {
            a(!1), b();
        } finally{
            $0b2e6adb871a3b94$var$wh.transition = c;
        }
    });
}
function $0b2e6adb871a3b94$var$Oh(a, b, c) {
    var d = $0b2e6adb871a3b94$var$Hg(), e = $0b2e6adb871a3b94$var$Ig(a), f = {
        lane: e,
        action: c,
        eagerReducer: null,
        eagerState: null,
        next: null
    }, g = b.pending;
    null === g ? f.next = f : (f.next = g.next, g.next = f);
    b.pending = f;
    g = a.alternate;
    if (a === $0b2e6adb871a3b94$var$R || null !== g && g === $0b2e6adb871a3b94$var$R) $0b2e6adb871a3b94$var$zh = $0b2e6adb871a3b94$var$yh = !0;
    else {
        if (0 === a.lanes && (null === g || 0 === g.lanes) && (g = b.lastRenderedReducer, null !== g)) try {
            var h = b.lastRenderedState, k = g(h, c);
            f.eagerReducer = g;
            f.eagerState = k;
            if ($0b2e6adb871a3b94$var$He(k, h)) return;
        } catch (l) {} finally{}
        $0b2e6adb871a3b94$var$Jg(a, e, d);
    }
}
var $0b2e6adb871a3b94$var$Gh = {
    readContext: $0b2e6adb871a3b94$var$vg,
    useCallback: $0b2e6adb871a3b94$var$Ah,
    useContext: $0b2e6adb871a3b94$var$Ah,
    useEffect: $0b2e6adb871a3b94$var$Ah,
    useImperativeHandle: $0b2e6adb871a3b94$var$Ah,
    useLayoutEffect: $0b2e6adb871a3b94$var$Ah,
    useMemo: $0b2e6adb871a3b94$var$Ah,
    useReducer: $0b2e6adb871a3b94$var$Ah,
    useRef: $0b2e6adb871a3b94$var$Ah,
    useState: $0b2e6adb871a3b94$var$Ah,
    useDebugValue: $0b2e6adb871a3b94$var$Ah,
    useDeferredValue: $0b2e6adb871a3b94$var$Ah,
    useTransition: $0b2e6adb871a3b94$var$Ah,
    useMutableSource: $0b2e6adb871a3b94$var$Ah,
    useOpaqueIdentifier: $0b2e6adb871a3b94$var$Ah,
    unstable_isNewReconciler: !1
}, $0b2e6adb871a3b94$var$Dh = {
    readContext: $0b2e6adb871a3b94$var$vg,
    useCallback: function(a, b) {
        $0b2e6adb871a3b94$var$Hh().memoizedState = [
            a,
            void 0 === b ? null : b
        ];
        return a;
    },
    useContext: $0b2e6adb871a3b94$var$vg,
    useEffect: $0b2e6adb871a3b94$var$Wh,
    useImperativeHandle: function(a, b, c) {
        c = null !== c && void 0 !== c ? c.concat([
            a
        ]) : null;
        return $0b2e6adb871a3b94$var$Uh(4, 2, $0b2e6adb871a3b94$var$Zh.bind(null, b, a), c);
    },
    useLayoutEffect: function(a, b) {
        return $0b2e6adb871a3b94$var$Uh(4, 2, a, b);
    },
    useMemo: function(a, b) {
        var c = $0b2e6adb871a3b94$var$Hh();
        b = void 0 === b ? null : b;
        a = a();
        c.memoizedState = [
            a,
            b
        ];
        return a;
    },
    useReducer: function(a, b, c) {
        var d = $0b2e6adb871a3b94$var$Hh();
        b = void 0 !== c ? c(b) : b;
        d.memoizedState = d.baseState = b;
        a = d.queue = {
            pending: null,
            dispatch: null,
            lastRenderedReducer: a,
            lastRenderedState: b
        };
        a = a.dispatch = $0b2e6adb871a3b94$var$Oh.bind(null, $0b2e6adb871a3b94$var$R, a);
        return [
            d.memoizedState,
            a
        ];
    },
    useRef: $0b2e6adb871a3b94$var$Sh,
    useState: $0b2e6adb871a3b94$var$Qh,
    useDebugValue: $0b2e6adb871a3b94$var$ai,
    useDeferredValue: function(a) {
        var b = $0b2e6adb871a3b94$var$Qh(a), c = b[0], d = b[1];
        $0b2e6adb871a3b94$var$Wh(function() {
            var b = $0b2e6adb871a3b94$var$wh.transition;
            $0b2e6adb871a3b94$var$wh.transition = 1;
            try {
                d(a);
            } finally{
                $0b2e6adb871a3b94$var$wh.transition = b;
            }
        }, [
            a
        ]);
        return c;
    },
    useTransition: function() {
        var a = $0b2e6adb871a3b94$var$Qh(!1), b = a[0];
        a = $0b2e6adb871a3b94$var$di.bind(null, a[1]);
        $0b2e6adb871a3b94$var$Sh(a);
        return [
            a,
            b
        ];
    },
    useMutableSource: function(a, b, c) {
        var d = $0b2e6adb871a3b94$var$Hh();
        d.memoizedState = {
            refs: {
                getSnapshot: b,
                setSnapshot: null
            },
            source: a,
            subscribe: c
        };
        return $0b2e6adb871a3b94$var$Nh(d, a, b, c);
    },
    useOpaqueIdentifier: function() {
        if ($0b2e6adb871a3b94$var$lh) {
            var a = !1, b = $0b2e6adb871a3b94$var$uf(function() {
                a || (a = !0, c("r:" + ($0b2e6adb871a3b94$var$tf++).toString(36)));
                throw Error($0b2e6adb871a3b94$var$y(355));
            }), c = $0b2e6adb871a3b94$var$Qh(b)[1];
            0 === ($0b2e6adb871a3b94$var$R.mode & 2) && ($0b2e6adb871a3b94$var$R.flags |= 516, $0b2e6adb871a3b94$var$Rh(5, function() {
                c("r:" + ($0b2e6adb871a3b94$var$tf++).toString(36));
            }, void 0, null));
            return b;
        }
        b = "r:" + ($0b2e6adb871a3b94$var$tf++).toString(36);
        $0b2e6adb871a3b94$var$Qh(b);
        return b;
    },
    unstable_isNewReconciler: !1
}, $0b2e6adb871a3b94$var$Eh = {
    readContext: $0b2e6adb871a3b94$var$vg,
    useCallback: $0b2e6adb871a3b94$var$bi,
    useContext: $0b2e6adb871a3b94$var$vg,
    useEffect: $0b2e6adb871a3b94$var$Xh,
    useImperativeHandle: $0b2e6adb871a3b94$var$$h,
    useLayoutEffect: $0b2e6adb871a3b94$var$Yh,
    useMemo: $0b2e6adb871a3b94$var$ci,
    useReducer: $0b2e6adb871a3b94$var$Kh,
    useRef: $0b2e6adb871a3b94$var$Th,
    useState: function() {
        return $0b2e6adb871a3b94$var$Kh($0b2e6adb871a3b94$var$Jh);
    },
    useDebugValue: $0b2e6adb871a3b94$var$ai,
    useDeferredValue: function(a) {
        var b = $0b2e6adb871a3b94$var$Kh($0b2e6adb871a3b94$var$Jh), c = b[0], d = b[1];
        $0b2e6adb871a3b94$var$Xh(function() {
            var b = $0b2e6adb871a3b94$var$wh.transition;
            $0b2e6adb871a3b94$var$wh.transition = 1;
            try {
                d(a);
            } finally{
                $0b2e6adb871a3b94$var$wh.transition = b;
            }
        }, [
            a
        ]);
        return c;
    },
    useTransition: function() {
        var a = $0b2e6adb871a3b94$var$Kh($0b2e6adb871a3b94$var$Jh)[0];
        return [
            $0b2e6adb871a3b94$var$Th().current,
            a
        ];
    },
    useMutableSource: $0b2e6adb871a3b94$var$Ph,
    useOpaqueIdentifier: function() {
        return $0b2e6adb871a3b94$var$Kh($0b2e6adb871a3b94$var$Jh)[0];
    },
    unstable_isNewReconciler: !1
}, $0b2e6adb871a3b94$var$Fh = {
    readContext: $0b2e6adb871a3b94$var$vg,
    useCallback: $0b2e6adb871a3b94$var$bi,
    useContext: $0b2e6adb871a3b94$var$vg,
    useEffect: $0b2e6adb871a3b94$var$Xh,
    useImperativeHandle: $0b2e6adb871a3b94$var$$h,
    useLayoutEffect: $0b2e6adb871a3b94$var$Yh,
    useMemo: $0b2e6adb871a3b94$var$ci,
    useReducer: $0b2e6adb871a3b94$var$Lh,
    useRef: $0b2e6adb871a3b94$var$Th,
    useState: function() {
        return $0b2e6adb871a3b94$var$Lh($0b2e6adb871a3b94$var$Jh);
    },
    useDebugValue: $0b2e6adb871a3b94$var$ai,
    useDeferredValue: function(a) {
        var b = $0b2e6adb871a3b94$var$Lh($0b2e6adb871a3b94$var$Jh), c = b[0], d = b[1];
        $0b2e6adb871a3b94$var$Xh(function() {
            var b = $0b2e6adb871a3b94$var$wh.transition;
            $0b2e6adb871a3b94$var$wh.transition = 1;
            try {
                d(a);
            } finally{
                $0b2e6adb871a3b94$var$wh.transition = b;
            }
        }, [
            a
        ]);
        return c;
    },
    useTransition: function() {
        var a = $0b2e6adb871a3b94$var$Lh($0b2e6adb871a3b94$var$Jh)[0];
        return [
            $0b2e6adb871a3b94$var$Th().current,
            a
        ];
    },
    useMutableSource: $0b2e6adb871a3b94$var$Ph,
    useOpaqueIdentifier: function() {
        return $0b2e6adb871a3b94$var$Lh($0b2e6adb871a3b94$var$Jh)[0];
    },
    unstable_isNewReconciler: !1
}, $0b2e6adb871a3b94$var$ei = $0b2e6adb871a3b94$var$ra.ReactCurrentOwner, $0b2e6adb871a3b94$var$ug = !1;
function $0b2e6adb871a3b94$var$fi(a, b, c, d) {
    b.child = null === a ? $0b2e6adb871a3b94$var$Zg(b, null, c, d) : $0b2e6adb871a3b94$var$Yg(b, a.child, c, d);
}
function $0b2e6adb871a3b94$var$gi(a, b, c, d, e) {
    c = c.render;
    var f = b.ref;
    $0b2e6adb871a3b94$var$tg(b, e);
    d = $0b2e6adb871a3b94$var$Ch(a, b, c, d, f, e);
    if (null !== a && !$0b2e6adb871a3b94$var$ug) return b.updateQueue = a.updateQueue, b.flags &= -517, a.lanes &= ~e, $0b2e6adb871a3b94$var$hi(a, b, e);
    b.flags |= 1;
    $0b2e6adb871a3b94$var$fi(a, b, d, e);
    return b.child;
}
function $0b2e6adb871a3b94$var$ii(a, b, c, d, e, f) {
    if (null === a) {
        var g = c.type;
        if ("function" === typeof g && !$0b2e6adb871a3b94$var$ji(g) && void 0 === g.defaultProps && null === c.compare && void 0 === c.defaultProps) return b.tag = 15, b.type = g, $0b2e6adb871a3b94$var$ki(a, b, g, d, e, f);
        a = $0b2e6adb871a3b94$var$Vg(c.type, null, d, b, b.mode, f);
        a.ref = b.ref;
        a.return = b;
        return b.child = a;
    }
    g = a.child;
    if (0 === (e & f) && (e = g.memoizedProps, c = c.compare, c = null !== c ? c : $0b2e6adb871a3b94$var$Je, c(e, d) && a.ref === b.ref)) return $0b2e6adb871a3b94$var$hi(a, b, f);
    b.flags |= 1;
    a = $0b2e6adb871a3b94$var$Tg(g, d);
    a.ref = b.ref;
    a.return = b;
    return b.child = a;
}
function $0b2e6adb871a3b94$var$ki(a, b, c, d, e, f) {
    if (null !== a && $0b2e6adb871a3b94$var$Je(a.memoizedProps, d) && a.ref === b.ref) {
        if ($0b2e6adb871a3b94$var$ug = !1, 0 !== (f & e)) 0 !== (a.flags & 16384) && ($0b2e6adb871a3b94$var$ug = !0);
        else return b.lanes = a.lanes, $0b2e6adb871a3b94$var$hi(a, b, f);
    }
    return $0b2e6adb871a3b94$var$li(a, b, c, d, f);
}
function $0b2e6adb871a3b94$var$mi(a, b, c) {
    var d = b.pendingProps, e = d.children, f = null !== a ? a.memoizedState : null;
    if ("hidden" === d.mode || "unstable-defer-without-hiding" === d.mode) {
        if (0 === (b.mode & 4)) b.memoizedState = {
            baseLanes: 0
        }, $0b2e6adb871a3b94$var$ni(b, c);
        else if (0 !== (c & 1073741824)) b.memoizedState = {
            baseLanes: 0
        }, $0b2e6adb871a3b94$var$ni(b, null !== f ? f.baseLanes : c);
        else return a = null !== f ? f.baseLanes | c : c, b.lanes = b.childLanes = 1073741824, b.memoizedState = {
            baseLanes: a
        }, $0b2e6adb871a3b94$var$ni(b, a), null;
    } else null !== f ? (d = f.baseLanes | c, b.memoizedState = null) : d = c, $0b2e6adb871a3b94$var$ni(b, d);
    $0b2e6adb871a3b94$var$fi(a, b, e, c);
    return b.child;
}
function $0b2e6adb871a3b94$var$oi(a, b) {
    var c = b.ref;
    if (null === a && null !== c || null !== a && a.ref !== c) b.flags |= 128;
}
function $0b2e6adb871a3b94$var$li(a, b, c, d, e) {
    var f = $0b2e6adb871a3b94$var$Ff(c) ? $0b2e6adb871a3b94$var$Df : $0b2e6adb871a3b94$var$M.current;
    f = $0b2e6adb871a3b94$var$Ef(b, f);
    $0b2e6adb871a3b94$var$tg(b, e);
    c = $0b2e6adb871a3b94$var$Ch(a, b, c, d, f, e);
    if (null !== a && !$0b2e6adb871a3b94$var$ug) return b.updateQueue = a.updateQueue, b.flags &= -517, a.lanes &= ~e, $0b2e6adb871a3b94$var$hi(a, b, e);
    b.flags |= 1;
    $0b2e6adb871a3b94$var$fi(a, b, c, e);
    return b.child;
}
function $0b2e6adb871a3b94$var$pi(a, b, c, d, e) {
    if ($0b2e6adb871a3b94$var$Ff(c)) {
        var f = !0;
        $0b2e6adb871a3b94$var$Jf(b);
    } else f = !1;
    $0b2e6adb871a3b94$var$tg(b, e);
    if (null === b.stateNode) null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2), $0b2e6adb871a3b94$var$Mg(b, c, d), $0b2e6adb871a3b94$var$Og(b, c, d, e), d = !0;
    else if (null === a) {
        var g = b.stateNode, h = b.memoizedProps;
        g.props = h;
        var k = g.context, l = c.contextType;
        "object" === typeof l && null !== l ? l = $0b2e6adb871a3b94$var$vg(l) : (l = $0b2e6adb871a3b94$var$Ff(c) ? $0b2e6adb871a3b94$var$Df : $0b2e6adb871a3b94$var$M.current, l = $0b2e6adb871a3b94$var$Ef(b, l));
        var n = c.getDerivedStateFromProps, A = "function" === typeof n || "function" === typeof g.getSnapshotBeforeUpdate;
        A || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== d || k !== l) && $0b2e6adb871a3b94$var$Ng(b, g, d, l);
        $0b2e6adb871a3b94$var$wg = !1;
        var p = b.memoizedState;
        g.state = p;
        $0b2e6adb871a3b94$var$Cg(b, d, g, e);
        k = b.memoizedState;
        h !== d || p !== k || $0b2e6adb871a3b94$var$N.current || $0b2e6adb871a3b94$var$wg ? ("function" === typeof n && ($0b2e6adb871a3b94$var$Gg(b, c, n, d), k = b.memoizedState), (h = $0b2e6adb871a3b94$var$wg || $0b2e6adb871a3b94$var$Lg(b, c, h, d, p, k, l)) ? (A || "function" !== typeof g.UNSAFE_componentWillMount && "function" !== typeof g.componentWillMount || ("function" === typeof g.componentWillMount && g.componentWillMount(), "function" === typeof g.UNSAFE_componentWillMount && g.UNSAFE_componentWillMount()), "function" === typeof g.componentDidMount && (b.flags |= 4)) : ("function" === typeof g.componentDidMount && (b.flags |= 4), b.memoizedProps = d, b.memoizedState = k), g.props = d, g.state = k, g.context = l, d = h) : ("function" === typeof g.componentDidMount && (b.flags |= 4), d = !1);
    } else {
        g = b.stateNode;
        $0b2e6adb871a3b94$var$yg(a, b);
        h = b.memoizedProps;
        l = b.type === b.elementType ? h : $0b2e6adb871a3b94$var$lg(b.type, h);
        g.props = l;
        A = b.pendingProps;
        p = g.context;
        k = c.contextType;
        "object" === typeof k && null !== k ? k = $0b2e6adb871a3b94$var$vg(k) : (k = $0b2e6adb871a3b94$var$Ff(c) ? $0b2e6adb871a3b94$var$Df : $0b2e6adb871a3b94$var$M.current, k = $0b2e6adb871a3b94$var$Ef(b, k));
        var C = c.getDerivedStateFromProps;
        (n = "function" === typeof C || "function" === typeof g.getSnapshotBeforeUpdate) || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== A || p !== k) && $0b2e6adb871a3b94$var$Ng(b, g, d, k);
        $0b2e6adb871a3b94$var$wg = !1;
        p = b.memoizedState;
        g.state = p;
        $0b2e6adb871a3b94$var$Cg(b, d, g, e);
        var x = b.memoizedState;
        h !== A || p !== x || $0b2e6adb871a3b94$var$N.current || $0b2e6adb871a3b94$var$wg ? ("function" === typeof C && ($0b2e6adb871a3b94$var$Gg(b, c, C, d), x = b.memoizedState), (l = $0b2e6adb871a3b94$var$wg || $0b2e6adb871a3b94$var$Lg(b, c, l, d, p, x, k)) ? (n || "function" !== typeof g.UNSAFE_componentWillUpdate && "function" !== typeof g.componentWillUpdate || ("function" === typeof g.componentWillUpdate && g.componentWillUpdate(d, x, k), "function" === typeof g.UNSAFE_componentWillUpdate && g.UNSAFE_componentWillUpdate(d, x, k)), "function" === typeof g.componentDidUpdate && (b.flags |= 4), "function" === typeof g.getSnapshotBeforeUpdate && (b.flags |= 256)) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && p === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && p === a.memoizedState || (b.flags |= 256), b.memoizedProps = d, b.memoizedState = x), g.props = d, g.state = x, g.context = k, d = l) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && p === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && p === a.memoizedState || (b.flags |= 256), d = !1);
    }
    return $0b2e6adb871a3b94$var$qi(a, b, c, d, f, e);
}
function $0b2e6adb871a3b94$var$qi(a, b, c, d, e, f) {
    $0b2e6adb871a3b94$var$oi(a, b);
    var g = 0 !== (b.flags & 64);
    if (!d && !g) return e && $0b2e6adb871a3b94$var$Kf(b, c, !1), $0b2e6adb871a3b94$var$hi(a, b, f);
    d = b.stateNode;
    $0b2e6adb871a3b94$var$ei.current = b;
    var h = g && "function" !== typeof c.getDerivedStateFromError ? null : d.render();
    b.flags |= 1;
    null !== a && g ? (b.child = $0b2e6adb871a3b94$var$Yg(b, a.child, null, f), b.child = $0b2e6adb871a3b94$var$Yg(b, null, h, f)) : $0b2e6adb871a3b94$var$fi(a, b, h, f);
    b.memoizedState = d.state;
    e && $0b2e6adb871a3b94$var$Kf(b, c, !0);
    return b.child;
}
function $0b2e6adb871a3b94$var$ri(a) {
    var b = a.stateNode;
    b.pendingContext ? $0b2e6adb871a3b94$var$Hf(a, b.pendingContext, b.pendingContext !== b.context) : b.context && $0b2e6adb871a3b94$var$Hf(a, b.context, !1);
    $0b2e6adb871a3b94$var$eh(a, b.containerInfo);
}
var $0b2e6adb871a3b94$var$si = {
    dehydrated: null,
    retryLane: 0
};
function $0b2e6adb871a3b94$var$ti(a, b, c) {
    var d = b.pendingProps, e = $0b2e6adb871a3b94$var$P.current, f = !1, g;
    (g = 0 !== (b.flags & 64)) || (g = null !== a && null === a.memoizedState ? !1 : 0 !== (e & 2));
    g ? (f = !0, b.flags &= -65) : null !== a && null === a.memoizedState || void 0 === d.fallback || !0 === d.unstable_avoidThisFallback || (e |= 1);
    $0b2e6adb871a3b94$var$I($0b2e6adb871a3b94$var$P, e & 1);
    if (null === a) {
        void 0 !== d.fallback && $0b2e6adb871a3b94$var$ph(b);
        a = d.children;
        e = d.fallback;
        if (f) return a = $0b2e6adb871a3b94$var$ui(b, a, e, c), b.child.memoizedState = {
            baseLanes: c
        }, b.memoizedState = $0b2e6adb871a3b94$var$si, a;
        if ("number" === typeof d.unstable_expectedLoadTime) return a = $0b2e6adb871a3b94$var$ui(b, a, e, c), b.child.memoizedState = {
            baseLanes: c
        }, b.memoizedState = $0b2e6adb871a3b94$var$si, b.lanes = 33554432, a;
        c = $0b2e6adb871a3b94$var$vi({
            mode: "visible",
            children: a
        }, b.mode, c, null);
        c.return = b;
        return b.child = c;
    }
    if (null !== a.memoizedState) {
        if (f) return d = $0b2e6adb871a3b94$var$wi(a, b, d.children, d.fallback, c), f = b.child, e = a.child.memoizedState, f.memoizedState = null === e ? {
            baseLanes: c
        } : {
            baseLanes: e.baseLanes | c
        }, f.childLanes = a.childLanes & ~c, b.memoizedState = $0b2e6adb871a3b94$var$si, d;
        c = $0b2e6adb871a3b94$var$xi(a, b, d.children, c);
        b.memoizedState = null;
        return c;
    }
    if (f) return d = $0b2e6adb871a3b94$var$wi(a, b, d.children, d.fallback, c), f = b.child, e = a.child.memoizedState, f.memoizedState = null === e ? {
        baseLanes: c
    } : {
        baseLanes: e.baseLanes | c
    }, f.childLanes = a.childLanes & ~c, b.memoizedState = $0b2e6adb871a3b94$var$si, d;
    c = $0b2e6adb871a3b94$var$xi(a, b, d.children, c);
    b.memoizedState = null;
    return c;
}
function $0b2e6adb871a3b94$var$ui(a, b, c, d) {
    var e = a.mode, f = a.child;
    b = {
        mode: "hidden",
        children: b
    };
    0 === (e & 2) && null !== f ? (f.childLanes = 0, f.pendingProps = b) : f = $0b2e6adb871a3b94$var$vi(b, e, 0, null);
    c = $0b2e6adb871a3b94$var$Xg(c, e, d, null);
    f.return = a;
    c.return = a;
    f.sibling = c;
    a.child = f;
    return c;
}
function $0b2e6adb871a3b94$var$xi(a, b, c, d) {
    var e = a.child;
    a = e.sibling;
    c = $0b2e6adb871a3b94$var$Tg(e, {
        mode: "visible",
        children: c
    });
    0 === (b.mode & 2) && (c.lanes = d);
    c.return = b;
    c.sibling = null;
    null !== a && (a.nextEffect = null, a.flags = 8, b.firstEffect = b.lastEffect = a);
    return b.child = c;
}
function $0b2e6adb871a3b94$var$wi(a, b, c, d, e) {
    var f = b.mode, g = a.child;
    a = g.sibling;
    var h = {
        mode: "hidden",
        children: c
    };
    0 === (f & 2) && b.child !== g ? (c = b.child, c.childLanes = 0, c.pendingProps = h, g = c.lastEffect, null !== g ? (b.firstEffect = c.firstEffect, b.lastEffect = g, g.nextEffect = null) : b.firstEffect = b.lastEffect = null) : c = $0b2e6adb871a3b94$var$Tg(g, h);
    null !== a ? d = $0b2e6adb871a3b94$var$Tg(a, d) : (d = $0b2e6adb871a3b94$var$Xg(d, f, e, null), d.flags |= 2);
    d.return = b;
    c.return = b;
    c.sibling = d;
    b.child = c;
    return d;
}
function $0b2e6adb871a3b94$var$yi(a, b) {
    a.lanes |= b;
    var c = a.alternate;
    null !== c && (c.lanes |= b);
    $0b2e6adb871a3b94$var$sg(a.return, b);
}
function $0b2e6adb871a3b94$var$zi(a, b, c, d, e, f) {
    var g = a.memoizedState;
    null === g ? a.memoizedState = {
        isBackwards: b,
        rendering: null,
        renderingStartTime: 0,
        last: d,
        tail: c,
        tailMode: e,
        lastEffect: f
    } : (g.isBackwards = b, g.rendering = null, g.renderingStartTime = 0, g.last = d, g.tail = c, g.tailMode = e, g.lastEffect = f);
}
function $0b2e6adb871a3b94$var$Ai(a, b, c) {
    var d = b.pendingProps, e = d.revealOrder, f = d.tail;
    $0b2e6adb871a3b94$var$fi(a, b, d.children, c);
    d = $0b2e6adb871a3b94$var$P.current;
    if (0 !== (d & 2)) d = d & 1 | 2, b.flags |= 64;
    else {
        if (null !== a && 0 !== (a.flags & 64)) a: for(a = b.child; null !== a;){
            if (13 === a.tag) null !== a.memoizedState && $0b2e6adb871a3b94$var$yi(a, c);
            else if (19 === a.tag) $0b2e6adb871a3b94$var$yi(a, c);
            else if (null !== a.child) {
                a.child.return = a;
                a = a.child;
                continue;
            }
            if (a === b) break a;
            for(; null === a.sibling;){
                if (null === a.return || a.return === b) break a;
                a = a.return;
            }
            a.sibling.return = a.return;
            a = a.sibling;
        }
        d &= 1;
    }
    $0b2e6adb871a3b94$var$I($0b2e6adb871a3b94$var$P, d);
    if (0 === (b.mode & 2)) b.memoizedState = null;
    else switch(e){
        case "forwards":
            c = b.child;
            for(e = null; null !== c;)a = c.alternate, null !== a && null === $0b2e6adb871a3b94$var$ih(a) && (e = c), c = c.sibling;
            c = e;
            null === c ? (e = b.child, b.child = null) : (e = c.sibling, c.sibling = null);
            $0b2e6adb871a3b94$var$zi(b, !1, e, c, f, b.lastEffect);
            break;
        case "backwards":
            c = null;
            e = b.child;
            for(b.child = null; null !== e;){
                a = e.alternate;
                if (null !== a && null === $0b2e6adb871a3b94$var$ih(a)) {
                    b.child = e;
                    break;
                }
                a = e.sibling;
                e.sibling = c;
                c = e;
                e = a;
            }
            $0b2e6adb871a3b94$var$zi(b, !0, c, null, f, b.lastEffect);
            break;
        case "together":
            $0b2e6adb871a3b94$var$zi(b, !1, null, null, void 0, b.lastEffect);
            break;
        default:
            b.memoizedState = null;
    }
    return b.child;
}
function $0b2e6adb871a3b94$var$hi(a, b, c) {
    null !== a && (b.dependencies = a.dependencies);
    $0b2e6adb871a3b94$var$Dg |= b.lanes;
    if (0 !== (c & b.childLanes)) {
        if (null !== a && b.child !== a.child) throw Error($0b2e6adb871a3b94$var$y(153));
        if (null !== b.child) {
            a = b.child;
            c = $0b2e6adb871a3b94$var$Tg(a, a.pendingProps);
            b.child = c;
            for(c.return = b; null !== a.sibling;)a = a.sibling, c = c.sibling = $0b2e6adb871a3b94$var$Tg(a, a.pendingProps), c.return = b;
            c.sibling = null;
        }
        return b.child;
    }
    return null;
}
var $0b2e6adb871a3b94$var$Bi, $0b2e6adb871a3b94$var$Ci, $0b2e6adb871a3b94$var$Di, $0b2e6adb871a3b94$var$Ei;
$0b2e6adb871a3b94$var$Bi = function(a, b) {
    for(var c = b.child; null !== c;){
        if (5 === c.tag || 6 === c.tag) a.appendChild(c.stateNode);
        else if (4 !== c.tag && null !== c.child) {
            c.child.return = c;
            c = c.child;
            continue;
        }
        if (c === b) break;
        for(; null === c.sibling;){
            if (null === c.return || c.return === b) return;
            c = c.return;
        }
        c.sibling.return = c.return;
        c = c.sibling;
    }
};
$0b2e6adb871a3b94$var$Ci = function() {};
$0b2e6adb871a3b94$var$Di = function(a, b, c, d) {
    var e = a.memoizedProps;
    if (e !== d) {
        a = b.stateNode;
        $0b2e6adb871a3b94$var$dh($0b2e6adb871a3b94$var$ah.current);
        var f = null;
        switch(c){
            case "input":
                e = $0b2e6adb871a3b94$var$Ya(a, e);
                d = $0b2e6adb871a3b94$var$Ya(a, d);
                f = [];
                break;
            case "option":
                e = $0b2e6adb871a3b94$var$eb(a, e);
                d = $0b2e6adb871a3b94$var$eb(a, d);
                f = [];
                break;
            case "select":
                e = $8coUR({}, e, {
                    value: void 0
                });
                d = $8coUR({}, d, {
                    value: void 0
                });
                f = [];
                break;
            case "textarea":
                e = $0b2e6adb871a3b94$var$gb(a, e);
                d = $0b2e6adb871a3b94$var$gb(a, d);
                f = [];
                break;
            default:
                "function" !== typeof e.onClick && "function" === typeof d.onClick && (a.onclick = $0b2e6adb871a3b94$var$jf);
        }
        $0b2e6adb871a3b94$var$vb(c, d);
        var g;
        c = null;
        for(l in e)if (!d.hasOwnProperty(l) && e.hasOwnProperty(l) && null != e[l]) {
            if ("style" === l) {
                var h = e[l];
                for(g in h)h.hasOwnProperty(g) && (c || (c = {}), c[g] = "");
            } else "dangerouslySetInnerHTML" !== l && "children" !== l && "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && "autoFocus" !== l && ($0b2e6adb871a3b94$var$ca.hasOwnProperty(l) ? f || (f = []) : (f = f || []).push(l, null));
        }
        for(l in d){
            var k = d[l];
            h = null != e ? e[l] : void 0;
            if (d.hasOwnProperty(l) && k !== h && (null != k || null != h)) {
                if ("style" === l) {
                    if (h) {
                        for(g in h)!h.hasOwnProperty(g) || k && k.hasOwnProperty(g) || (c || (c = {}), c[g] = "");
                        for(g in k)k.hasOwnProperty(g) && h[g] !== k[g] && (c || (c = {}), c[g] = k[g]);
                    } else c || (f || (f = []), f.push(l, c)), c = k;
                } else "dangerouslySetInnerHTML" === l ? (k = k ? k.__html : void 0, h = h ? h.__html : void 0, null != k && h !== k && (f = f || []).push(l, k)) : "children" === l ? "string" !== typeof k && "number" !== typeof k || (f = f || []).push(l, "" + k) : "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && ($0b2e6adb871a3b94$var$ca.hasOwnProperty(l) ? (null != k && "onScroll" === l && $0b2e6adb871a3b94$var$G("scroll", a), f || h === k || (f = [])) : "object" === typeof k && null !== k && k.$$typeof === $0b2e6adb871a3b94$var$Ga ? k.toString() : (f = f || []).push(l, k));
            }
        }
        c && (f = f || []).push("style", c);
        var l = f;
        if (b.updateQueue = l) b.flags |= 4;
    }
};
$0b2e6adb871a3b94$var$Ei = function(a, b, c, d) {
    c !== d && (b.flags |= 4);
};
function $0b2e6adb871a3b94$var$Fi(a, b) {
    if (!$0b2e6adb871a3b94$var$lh) switch(a.tailMode){
        case "hidden":
            b = a.tail;
            for(var c = null; null !== b;)null !== b.alternate && (c = b), b = b.sibling;
            null === c ? a.tail = null : c.sibling = null;
            break;
        case "collapsed":
            c = a.tail;
            for(var d = null; null !== c;)null !== c.alternate && (d = c), c = c.sibling;
            null === d ? b || null === a.tail ? a.tail = null : a.tail.sibling = null : d.sibling = null;
    }
}
function $0b2e6adb871a3b94$var$Gi(a, b, c) {
    var d = b.pendingProps;
    switch(b.tag){
        case 2:
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return null;
        case 1:
            return $0b2e6adb871a3b94$var$Ff(b.type) && $0b2e6adb871a3b94$var$Gf(), null;
        case 3:
            $0b2e6adb871a3b94$var$fh();
            $0b2e6adb871a3b94$var$H($0b2e6adb871a3b94$var$N);
            $0b2e6adb871a3b94$var$H($0b2e6adb871a3b94$var$M);
            $0b2e6adb871a3b94$var$uh();
            d = b.stateNode;
            d.pendingContext && (d.context = d.pendingContext, d.pendingContext = null);
            if (null === a || null === a.child) $0b2e6adb871a3b94$var$rh(b) ? b.flags |= 4 : d.hydrate || (b.flags |= 256);
            $0b2e6adb871a3b94$var$Ci(b);
            return null;
        case 5:
            $0b2e6adb871a3b94$var$hh(b);
            var e = $0b2e6adb871a3b94$var$dh($0b2e6adb871a3b94$var$ch.current);
            c = b.type;
            if (null !== a && null != b.stateNode) $0b2e6adb871a3b94$var$Di(a, b, c, d, e), a.ref !== b.ref && (b.flags |= 128);
            else {
                if (!d) {
                    if (null === b.stateNode) throw Error($0b2e6adb871a3b94$var$y(166));
                    return null;
                }
                a = $0b2e6adb871a3b94$var$dh($0b2e6adb871a3b94$var$ah.current);
                if ($0b2e6adb871a3b94$var$rh(b)) {
                    d = b.stateNode;
                    c = b.type;
                    var f = b.memoizedProps;
                    d[$0b2e6adb871a3b94$var$wf] = b;
                    d[$0b2e6adb871a3b94$var$xf] = f;
                    switch(c){
                        case "dialog":
                            $0b2e6adb871a3b94$var$G("cancel", d);
                            $0b2e6adb871a3b94$var$G("close", d);
                            break;
                        case "iframe":
                        case "object":
                        case "embed":
                            $0b2e6adb871a3b94$var$G("load", d);
                            break;
                        case "video":
                        case "audio":
                            for(a = 0; a < $0b2e6adb871a3b94$var$Xe.length; a++)$0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$Xe[a], d);
                            break;
                        case "source":
                            $0b2e6adb871a3b94$var$G("error", d);
                            break;
                        case "img":
                        case "image":
                        case "link":
                            $0b2e6adb871a3b94$var$G("error", d);
                            $0b2e6adb871a3b94$var$G("load", d);
                            break;
                        case "details":
                            $0b2e6adb871a3b94$var$G("toggle", d);
                            break;
                        case "input":
                            $0b2e6adb871a3b94$var$Za(d, f);
                            $0b2e6adb871a3b94$var$G("invalid", d);
                            break;
                        case "select":
                            d._wrapperState = {
                                wasMultiple: !!f.multiple
                            };
                            $0b2e6adb871a3b94$var$G("invalid", d);
                            break;
                        case "textarea":
                            $0b2e6adb871a3b94$var$hb(d, f), $0b2e6adb871a3b94$var$G("invalid", d);
                    }
                    $0b2e6adb871a3b94$var$vb(c, f);
                    a = null;
                    for(var g in f)f.hasOwnProperty(g) && (e = f[g], "children" === g ? "string" === typeof e ? d.textContent !== e && (a = [
                        "children",
                        e
                    ]) : "number" === typeof e && d.textContent !== "" + e && (a = [
                        "children",
                        "" + e
                    ]) : $0b2e6adb871a3b94$var$ca.hasOwnProperty(g) && null != e && "onScroll" === g && $0b2e6adb871a3b94$var$G("scroll", d));
                    switch(c){
                        case "input":
                            $0b2e6adb871a3b94$var$Va(d);
                            $0b2e6adb871a3b94$var$cb(d, f, !0);
                            break;
                        case "textarea":
                            $0b2e6adb871a3b94$var$Va(d);
                            $0b2e6adb871a3b94$var$jb(d);
                            break;
                        case "select":
                        case "option":
                            break;
                        default:
                            "function" === typeof f.onClick && (d.onclick = $0b2e6adb871a3b94$var$jf);
                    }
                    d = a;
                    b.updateQueue = d;
                    null !== d && (b.flags |= 4);
                } else {
                    g = 9 === e.nodeType ? e : e.ownerDocument;
                    a === $0b2e6adb871a3b94$var$kb.html && (a = $0b2e6adb871a3b94$var$lb(c));
                    a === $0b2e6adb871a3b94$var$kb.html ? "script" === c ? (a = g.createElement("div"), a.innerHTML = "<script></script>", a = a.removeChild(a.firstChild)) : "string" === typeof d.is ? a = g.createElement(c, {
                        is: d.is
                    }) : (a = g.createElement(c), "select" === c && (g = a, d.multiple ? g.multiple = !0 : d.size && (g.size = d.size))) : a = g.createElementNS(a, c);
                    a[$0b2e6adb871a3b94$var$wf] = b;
                    a[$0b2e6adb871a3b94$var$xf] = d;
                    $0b2e6adb871a3b94$var$Bi(a, b, !1, !1);
                    b.stateNode = a;
                    g = $0b2e6adb871a3b94$var$wb(c, d);
                    switch(c){
                        case "dialog":
                            $0b2e6adb871a3b94$var$G("cancel", a);
                            $0b2e6adb871a3b94$var$G("close", a);
                            e = d;
                            break;
                        case "iframe":
                        case "object":
                        case "embed":
                            $0b2e6adb871a3b94$var$G("load", a);
                            e = d;
                            break;
                        case "video":
                        case "audio":
                            for(e = 0; e < $0b2e6adb871a3b94$var$Xe.length; e++)$0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$Xe[e], a);
                            e = d;
                            break;
                        case "source":
                            $0b2e6adb871a3b94$var$G("error", a);
                            e = d;
                            break;
                        case "img":
                        case "image":
                        case "link":
                            $0b2e6adb871a3b94$var$G("error", a);
                            $0b2e6adb871a3b94$var$G("load", a);
                            e = d;
                            break;
                        case "details":
                            $0b2e6adb871a3b94$var$G("toggle", a);
                            e = d;
                            break;
                        case "input":
                            $0b2e6adb871a3b94$var$Za(a, d);
                            e = $0b2e6adb871a3b94$var$Ya(a, d);
                            $0b2e6adb871a3b94$var$G("invalid", a);
                            break;
                        case "option":
                            e = $0b2e6adb871a3b94$var$eb(a, d);
                            break;
                        case "select":
                            a._wrapperState = {
                                wasMultiple: !!d.multiple
                            };
                            e = $8coUR({}, d, {
                                value: void 0
                            });
                            $0b2e6adb871a3b94$var$G("invalid", a);
                            break;
                        case "textarea":
                            $0b2e6adb871a3b94$var$hb(a, d);
                            e = $0b2e6adb871a3b94$var$gb(a, d);
                            $0b2e6adb871a3b94$var$G("invalid", a);
                            break;
                        default:
                            e = d;
                    }
                    $0b2e6adb871a3b94$var$vb(c, e);
                    var h = e;
                    for(f in h)if (h.hasOwnProperty(f)) {
                        var k = h[f];
                        "style" === f ? $0b2e6adb871a3b94$var$tb(a, k) : "dangerouslySetInnerHTML" === f ? (k = k ? k.__html : void 0, null != k && $0b2e6adb871a3b94$var$ob(a, k)) : "children" === f ? "string" === typeof k ? ("textarea" !== c || "" !== k) && $0b2e6adb871a3b94$var$pb(a, k) : "number" === typeof k && $0b2e6adb871a3b94$var$pb(a, "" + k) : "suppressContentEditableWarning" !== f && "suppressHydrationWarning" !== f && "autoFocus" !== f && ($0b2e6adb871a3b94$var$ca.hasOwnProperty(f) ? null != k && "onScroll" === f && $0b2e6adb871a3b94$var$G("scroll", a) : null != k && $0b2e6adb871a3b94$var$qa(a, f, k, g));
                    }
                    switch(c){
                        case "input":
                            $0b2e6adb871a3b94$var$Va(a);
                            $0b2e6adb871a3b94$var$cb(a, d, !1);
                            break;
                        case "textarea":
                            $0b2e6adb871a3b94$var$Va(a);
                            $0b2e6adb871a3b94$var$jb(a);
                            break;
                        case "option":
                            null != d.value && a.setAttribute("value", "" + $0b2e6adb871a3b94$var$Sa(d.value));
                            break;
                        case "select":
                            a.multiple = !!d.multiple;
                            f = d.value;
                            null != f ? $0b2e6adb871a3b94$var$fb(a, !!d.multiple, f, !1) : null != d.defaultValue && $0b2e6adb871a3b94$var$fb(a, !!d.multiple, d.defaultValue, !0);
                            break;
                        default:
                            "function" === typeof e.onClick && (a.onclick = $0b2e6adb871a3b94$var$jf);
                    }
                    $0b2e6adb871a3b94$var$mf(c, d) && (b.flags |= 4);
                }
                null !== b.ref && (b.flags |= 128);
            }
            return null;
        case 6:
            if (a && null != b.stateNode) $0b2e6adb871a3b94$var$Ei(a, b, a.memoizedProps, d);
            else {
                if ("string" !== typeof d && null === b.stateNode) throw Error($0b2e6adb871a3b94$var$y(166));
                c = $0b2e6adb871a3b94$var$dh($0b2e6adb871a3b94$var$ch.current);
                $0b2e6adb871a3b94$var$dh($0b2e6adb871a3b94$var$ah.current);
                $0b2e6adb871a3b94$var$rh(b) ? (d = b.stateNode, c = b.memoizedProps, d[$0b2e6adb871a3b94$var$wf] = b, d.nodeValue !== c && (b.flags |= 4)) : (d = (9 === c.nodeType ? c : c.ownerDocument).createTextNode(d), d[$0b2e6adb871a3b94$var$wf] = b, b.stateNode = d);
            }
            return null;
        case 13:
            $0b2e6adb871a3b94$var$H($0b2e6adb871a3b94$var$P);
            d = b.memoizedState;
            if (0 !== (b.flags & 64)) return b.lanes = c, b;
            d = null !== d;
            c = !1;
            null === a ? void 0 !== b.memoizedProps.fallback && $0b2e6adb871a3b94$var$rh(b) : c = null !== a.memoizedState;
            if (d && !c && 0 !== (b.mode & 2)) {
                if (null === a && !0 !== b.memoizedProps.unstable_avoidThisFallback || 0 !== ($0b2e6adb871a3b94$var$P.current & 1)) 0 === $0b2e6adb871a3b94$var$V && ($0b2e6adb871a3b94$var$V = 3);
                else {
                    if (0 === $0b2e6adb871a3b94$var$V || 3 === $0b2e6adb871a3b94$var$V) $0b2e6adb871a3b94$var$V = 4;
                    null === $0b2e6adb871a3b94$var$U || 0 === ($0b2e6adb871a3b94$var$Dg & 134217727) && 0 === ($0b2e6adb871a3b94$var$Hi & 134217727) || $0b2e6adb871a3b94$var$Ii($0b2e6adb871a3b94$var$U, $0b2e6adb871a3b94$var$W);
                }
            }
            if (d || c) b.flags |= 4;
            return null;
        case 4:
            return $0b2e6adb871a3b94$var$fh(), $0b2e6adb871a3b94$var$Ci(b), null === a && $0b2e6adb871a3b94$var$cf(b.stateNode.containerInfo), null;
        case 10:
            return $0b2e6adb871a3b94$var$rg(b), null;
        case 17:
            return $0b2e6adb871a3b94$var$Ff(b.type) && $0b2e6adb871a3b94$var$Gf(), null;
        case 19:
            $0b2e6adb871a3b94$var$H($0b2e6adb871a3b94$var$P);
            d = b.memoizedState;
            if (null === d) return null;
            f = 0 !== (b.flags & 64);
            g = d.rendering;
            if (null === g) {
                if (f) $0b2e6adb871a3b94$var$Fi(d, !1);
                else {
                    if (0 !== $0b2e6adb871a3b94$var$V || null !== a && 0 !== (a.flags & 64)) for(a = b.child; null !== a;){
                        g = $0b2e6adb871a3b94$var$ih(a);
                        if (null !== g) {
                            b.flags |= 64;
                            $0b2e6adb871a3b94$var$Fi(d, !1);
                            f = g.updateQueue;
                            null !== f && (b.updateQueue = f, b.flags |= 4);
                            null === d.lastEffect && (b.firstEffect = null);
                            b.lastEffect = d.lastEffect;
                            d = c;
                            for(c = b.child; null !== c;)f = c, a = d, f.flags &= 2, f.nextEffect = null, f.firstEffect = null, f.lastEffect = null, g = f.alternate, null === g ? (f.childLanes = 0, f.lanes = a, f.child = null, f.memoizedProps = null, f.memoizedState = null, f.updateQueue = null, f.dependencies = null, f.stateNode = null) : (f.childLanes = g.childLanes, f.lanes = g.lanes, f.child = g.child, f.memoizedProps = g.memoizedProps, f.memoizedState = g.memoizedState, f.updateQueue = g.updateQueue, f.type = g.type, a = g.dependencies, f.dependencies = null === a ? null : {
                                lanes: a.lanes,
                                firstContext: a.firstContext
                            }), c = c.sibling;
                            $0b2e6adb871a3b94$var$I($0b2e6adb871a3b94$var$P, $0b2e6adb871a3b94$var$P.current & 1 | 2);
                            return b.child;
                        }
                        a = a.sibling;
                    }
                    null !== d.tail && $0b2e6adb871a3b94$var$O() > $0b2e6adb871a3b94$var$Ji && (b.flags |= 64, f = !0, $0b2e6adb871a3b94$var$Fi(d, !1), b.lanes = 33554432);
                }
            } else {
                if (!f) {
                    if (a = $0b2e6adb871a3b94$var$ih(g), null !== a) {
                        if (b.flags |= 64, f = !0, c = a.updateQueue, null !== c && (b.updateQueue = c, b.flags |= 4), $0b2e6adb871a3b94$var$Fi(d, !0), null === d.tail && "hidden" === d.tailMode && !g.alternate && !$0b2e6adb871a3b94$var$lh) return b = b.lastEffect = d.lastEffect, null !== b && (b.nextEffect = null), null;
                    } else 2 * $0b2e6adb871a3b94$var$O() - d.renderingStartTime > $0b2e6adb871a3b94$var$Ji && 1073741824 !== c && (b.flags |= 64, f = !0, $0b2e6adb871a3b94$var$Fi(d, !1), b.lanes = 33554432);
                }
                d.isBackwards ? (g.sibling = b.child, b.child = g) : (c = d.last, null !== c ? c.sibling = g : b.child = g, d.last = g);
            }
            return null !== d.tail ? (c = d.tail, d.rendering = c, d.tail = c.sibling, d.lastEffect = b.lastEffect, d.renderingStartTime = $0b2e6adb871a3b94$var$O(), c.sibling = null, b = $0b2e6adb871a3b94$var$P.current, $0b2e6adb871a3b94$var$I($0b2e6adb871a3b94$var$P, f ? b & 1 | 2 : b & 1), c) : null;
        case 23:
        case 24:
            return $0b2e6adb871a3b94$var$Ki(), null !== a && null !== a.memoizedState !== (null !== b.memoizedState) && "unstable-defer-without-hiding" !== d.mode && (b.flags |= 4), null;
    }
    throw Error($0b2e6adb871a3b94$var$y(156, b.tag));
}
function $0b2e6adb871a3b94$var$Li(a) {
    switch(a.tag){
        case 1:
            $0b2e6adb871a3b94$var$Ff(a.type) && $0b2e6adb871a3b94$var$Gf();
            var b = a.flags;
            return b & 4096 ? (a.flags = b & -4097 | 64, a) : null;
        case 3:
            $0b2e6adb871a3b94$var$fh();
            $0b2e6adb871a3b94$var$H($0b2e6adb871a3b94$var$N);
            $0b2e6adb871a3b94$var$H($0b2e6adb871a3b94$var$M);
            $0b2e6adb871a3b94$var$uh();
            b = a.flags;
            if (0 !== (b & 64)) throw Error($0b2e6adb871a3b94$var$y(285));
            a.flags = b & -4097 | 64;
            return a;
        case 5:
            return $0b2e6adb871a3b94$var$hh(a), null;
        case 13:
            return $0b2e6adb871a3b94$var$H($0b2e6adb871a3b94$var$P), b = a.flags, b & 4096 ? (a.flags = b & -4097 | 64, a) : null;
        case 19:
            return $0b2e6adb871a3b94$var$H($0b2e6adb871a3b94$var$P), null;
        case 4:
            return $0b2e6adb871a3b94$var$fh(), null;
        case 10:
            return $0b2e6adb871a3b94$var$rg(a), null;
        case 23:
        case 24:
            return $0b2e6adb871a3b94$var$Ki(), null;
        default:
            return null;
    }
}
function $0b2e6adb871a3b94$var$Mi(a, b) {
    try {
        var c = "", d = b;
        do c += $0b2e6adb871a3b94$var$Qa(d), d = d.return;
        while (d);
        var e = c;
    } catch (f) {
        e = "\nError generating stack: " + f.message + "\n" + f.stack;
    }
    return {
        value: a,
        source: b,
        stack: e
    };
}
function $0b2e6adb871a3b94$var$Ni(a, b) {
    try {
        console.error(b.value);
    } catch (c) {
        setTimeout(function() {
            throw c;
        });
    }
}
var $0b2e6adb871a3b94$var$Oi = "function" === typeof WeakMap ? WeakMap : Map;
function $0b2e6adb871a3b94$var$Pi(a, b, c) {
    c = $0b2e6adb871a3b94$var$zg(-1, c);
    c.tag = 3;
    c.payload = {
        element: null
    };
    var d = b.value;
    c.callback = function() {
        $0b2e6adb871a3b94$var$Qi || ($0b2e6adb871a3b94$var$Qi = !0, $0b2e6adb871a3b94$var$Ri = d);
        $0b2e6adb871a3b94$var$Ni(a, b);
    };
    return c;
}
function $0b2e6adb871a3b94$var$Si(a, b, c) {
    c = $0b2e6adb871a3b94$var$zg(-1, c);
    c.tag = 3;
    var d = a.type.getDerivedStateFromError;
    if ("function" === typeof d) {
        var e = b.value;
        c.payload = function() {
            $0b2e6adb871a3b94$var$Ni(a, b);
            return d(e);
        };
    }
    var f = a.stateNode;
    null !== f && "function" === typeof f.componentDidCatch && (c.callback = function() {
        "function" !== typeof d && (null === $0b2e6adb871a3b94$var$Ti ? $0b2e6adb871a3b94$var$Ti = new Set([
            this
        ]) : $0b2e6adb871a3b94$var$Ti.add(this), $0b2e6adb871a3b94$var$Ni(a, b));
        var c = b.stack;
        this.componentDidCatch(b.value, {
            componentStack: null !== c ? c : ""
        });
    });
    return c;
}
var $0b2e6adb871a3b94$var$Ui = "function" === typeof WeakSet ? WeakSet : Set;
function $0b2e6adb871a3b94$var$Vi(a) {
    var b = a.ref;
    if (null !== b) {
        if ("function" === typeof b) try {
            b(null);
        } catch (c) {
            $0b2e6adb871a3b94$var$Wi(a, c);
        }
        else b.current = null;
    }
}
function $0b2e6adb871a3b94$var$Xi(a, b) {
    switch(b.tag){
        case 0:
        case 11:
        case 15:
        case 22:
            return;
        case 1:
            if (b.flags & 256 && null !== a) {
                var c = a.memoizedProps, d = a.memoizedState;
                a = b.stateNode;
                b = a.getSnapshotBeforeUpdate(b.elementType === b.type ? c : $0b2e6adb871a3b94$var$lg(b.type, c), d);
                a.__reactInternalSnapshotBeforeUpdate = b;
            }
            return;
        case 3:
            b.flags & 256 && $0b2e6adb871a3b94$var$qf(b.stateNode.containerInfo);
            return;
        case 5:
        case 6:
        case 4:
        case 17:
            return;
    }
    throw Error($0b2e6adb871a3b94$var$y(163));
}
function $0b2e6adb871a3b94$var$Yi(a, b, c) {
    switch(c.tag){
        case 0:
        case 11:
        case 15:
        case 22:
            b = c.updateQueue;
            b = null !== b ? b.lastEffect : null;
            if (null !== b) {
                a = b = b.next;
                do {
                    if (3 === (a.tag & 3)) {
                        var d = a.create;
                        a.destroy = d();
                    }
                    a = a.next;
                }while (a !== b);
            }
            b = c.updateQueue;
            b = null !== b ? b.lastEffect : null;
            if (null !== b) {
                a = b = b.next;
                do {
                    var e = a;
                    d = e.next;
                    e = e.tag;
                    0 !== (e & 4) && 0 !== (e & 1) && ($0b2e6adb871a3b94$var$Zi(c, a), $0b2e6adb871a3b94$var$$i(c, a));
                    a = d;
                }while (a !== b);
            }
            return;
        case 1:
            a = c.stateNode;
            c.flags & 4 && (null === b ? a.componentDidMount() : (d = c.elementType === c.type ? b.memoizedProps : $0b2e6adb871a3b94$var$lg(c.type, b.memoizedProps), a.componentDidUpdate(d, b.memoizedState, a.__reactInternalSnapshotBeforeUpdate)));
            b = c.updateQueue;
            null !== b && $0b2e6adb871a3b94$var$Eg(c, b, a);
            return;
        case 3:
            b = c.updateQueue;
            if (null !== b) {
                a = null;
                if (null !== c.child) switch(c.child.tag){
                    case 5:
                        a = c.child.stateNode;
                        break;
                    case 1:
                        a = c.child.stateNode;
                }
                $0b2e6adb871a3b94$var$Eg(c, b, a);
            }
            return;
        case 5:
            a = c.stateNode;
            null === b && c.flags & 4 && $0b2e6adb871a3b94$var$mf(c.type, c.memoizedProps) && a.focus();
            return;
        case 6:
            return;
        case 4:
            return;
        case 12:
            return;
        case 13:
            null === c.memoizedState && (c = c.alternate, null !== c && (c = c.memoizedState, null !== c && (c = c.dehydrated, null !== c && $0b2e6adb871a3b94$var$Cc(c))));
            return;
        case 19:
        case 17:
        case 20:
        case 21:
        case 23:
        case 24:
            return;
    }
    throw Error($0b2e6adb871a3b94$var$y(163));
}
function $0b2e6adb871a3b94$var$aj(a, b) {
    for(var c = a;;){
        if (5 === c.tag) {
            var d = c.stateNode;
            if (b) d = d.style, "function" === typeof d.setProperty ? d.setProperty("display", "none", "important") : d.display = "none";
            else {
                d = c.stateNode;
                var e = c.memoizedProps.style;
                e = void 0 !== e && null !== e && e.hasOwnProperty("display") ? e.display : null;
                d.style.display = $0b2e6adb871a3b94$var$sb("display", e);
            }
        } else if (6 === c.tag) c.stateNode.nodeValue = b ? "" : c.memoizedProps;
        else if ((23 !== c.tag && 24 !== c.tag || null === c.memoizedState || c === a) && null !== c.child) {
            c.child.return = c;
            c = c.child;
            continue;
        }
        if (c === a) break;
        for(; null === c.sibling;){
            if (null === c.return || c.return === a) return;
            c = c.return;
        }
        c.sibling.return = c.return;
        c = c.sibling;
    }
}
function $0b2e6adb871a3b94$var$bj(a, b) {
    if ($0b2e6adb871a3b94$var$Mf && "function" === typeof $0b2e6adb871a3b94$var$Mf.onCommitFiberUnmount) try {
        $0b2e6adb871a3b94$var$Mf.onCommitFiberUnmount($0b2e6adb871a3b94$var$Lf, b);
    } catch (f) {}
    switch(b.tag){
        case 0:
        case 11:
        case 14:
        case 15:
        case 22:
            a = b.updateQueue;
            if (null !== a && (a = a.lastEffect, null !== a)) {
                var c = a = a.next;
                do {
                    var d = c, e = d.destroy;
                    d = d.tag;
                    if (void 0 !== e) {
                        if (0 !== (d & 4)) $0b2e6adb871a3b94$var$Zi(b, c);
                        else {
                            d = b;
                            try {
                                e();
                            } catch (f) {
                                $0b2e6adb871a3b94$var$Wi(d, f);
                            }
                        }
                    }
                    c = c.next;
                }while (c !== a);
            }
            break;
        case 1:
            $0b2e6adb871a3b94$var$Vi(b);
            a = b.stateNode;
            if ("function" === typeof a.componentWillUnmount) try {
                a.props = b.memoizedProps, a.state = b.memoizedState, a.componentWillUnmount();
            } catch (f) {
                $0b2e6adb871a3b94$var$Wi(b, f);
            }
            break;
        case 5:
            $0b2e6adb871a3b94$var$Vi(b);
            break;
        case 4:
            $0b2e6adb871a3b94$var$cj(a, b);
    }
}
function $0b2e6adb871a3b94$var$dj(a) {
    a.alternate = null;
    a.child = null;
    a.dependencies = null;
    a.firstEffect = null;
    a.lastEffect = null;
    a.memoizedProps = null;
    a.memoizedState = null;
    a.pendingProps = null;
    a.return = null;
    a.updateQueue = null;
}
function $0b2e6adb871a3b94$var$ej(a) {
    return 5 === a.tag || 3 === a.tag || 4 === a.tag;
}
function $0b2e6adb871a3b94$var$fj(a) {
    a: {
        for(var b = a.return; null !== b;){
            if ($0b2e6adb871a3b94$var$ej(b)) break a;
            b = b.return;
        }
        throw Error($0b2e6adb871a3b94$var$y(160));
    }
    var c = b;
    b = c.stateNode;
    switch(c.tag){
        case 5:
            var d = !1;
            break;
        case 3:
            b = b.containerInfo;
            d = !0;
            break;
        case 4:
            b = b.containerInfo;
            d = !0;
            break;
        default:
            throw Error($0b2e6adb871a3b94$var$y(161));
    }
    c.flags & 16 && ($0b2e6adb871a3b94$var$pb(b, ""), c.flags &= -17);
    a: b: for(c = a;;){
        for(; null === c.sibling;){
            if (null === c.return || $0b2e6adb871a3b94$var$ej(c.return)) {
                c = null;
                break a;
            }
            c = c.return;
        }
        c.sibling.return = c.return;
        for(c = c.sibling; 5 !== c.tag && 6 !== c.tag && 18 !== c.tag;){
            if (c.flags & 2) continue b;
            if (null === c.child || 4 === c.tag) continue b;
            else c.child.return = c, c = c.child;
        }
        if (!(c.flags & 2)) {
            c = c.stateNode;
            break a;
        }
    }
    d ? $0b2e6adb871a3b94$var$gj(a, c, b) : $0b2e6adb871a3b94$var$hj(a, c, b);
}
function $0b2e6adb871a3b94$var$gj(a, b, c) {
    var d = a.tag, e = 5 === d || 6 === d;
    if (e) a = e ? a.stateNode : a.stateNode.instance, b ? 8 === c.nodeType ? c.parentNode.insertBefore(a, b) : c.insertBefore(a, b) : (8 === c.nodeType ? (b = c.parentNode, b.insertBefore(a, c)) : (b = c, b.appendChild(a)), c = c._reactRootContainer, null !== c && void 0 !== c || null !== b.onclick || (b.onclick = $0b2e6adb871a3b94$var$jf));
    else if (4 !== d && (a = a.child, null !== a)) for($0b2e6adb871a3b94$var$gj(a, b, c), a = a.sibling; null !== a;)$0b2e6adb871a3b94$var$gj(a, b, c), a = a.sibling;
}
function $0b2e6adb871a3b94$var$hj(a, b, c) {
    var d = a.tag, e = 5 === d || 6 === d;
    if (e) a = e ? a.stateNode : a.stateNode.instance, b ? c.insertBefore(a, b) : c.appendChild(a);
    else if (4 !== d && (a = a.child, null !== a)) for($0b2e6adb871a3b94$var$hj(a, b, c), a = a.sibling; null !== a;)$0b2e6adb871a3b94$var$hj(a, b, c), a = a.sibling;
}
function $0b2e6adb871a3b94$var$cj(a, b) {
    for(var c = b, d = !1, e, f;;){
        if (!d) {
            d = c.return;
            a: for(;;){
                if (null === d) throw Error($0b2e6adb871a3b94$var$y(160));
                e = d.stateNode;
                switch(d.tag){
                    case 5:
                        f = !1;
                        break a;
                    case 3:
                        e = e.containerInfo;
                        f = !0;
                        break a;
                    case 4:
                        e = e.containerInfo;
                        f = !0;
                        break a;
                }
                d = d.return;
            }
            d = !0;
        }
        if (5 === c.tag || 6 === c.tag) {
            a: for(var g = a, h = c, k = h;;)if ($0b2e6adb871a3b94$var$bj(g, k), null !== k.child && 4 !== k.tag) k.child.return = k, k = k.child;
            else {
                if (k === h) break a;
                for(; null === k.sibling;){
                    if (null === k.return || k.return === h) break a;
                    k = k.return;
                }
                k.sibling.return = k.return;
                k = k.sibling;
            }
            f ? (g = e, h = c.stateNode, 8 === g.nodeType ? g.parentNode.removeChild(h) : g.removeChild(h)) : e.removeChild(c.stateNode);
        } else if (4 === c.tag) {
            if (null !== c.child) {
                e = c.stateNode.containerInfo;
                f = !0;
                c.child.return = c;
                c = c.child;
                continue;
            }
        } else if ($0b2e6adb871a3b94$var$bj(a, c), null !== c.child) {
            c.child.return = c;
            c = c.child;
            continue;
        }
        if (c === b) break;
        for(; null === c.sibling;){
            if (null === c.return || c.return === b) return;
            c = c.return;
            4 === c.tag && (d = !1);
        }
        c.sibling.return = c.return;
        c = c.sibling;
    }
}
function $0b2e6adb871a3b94$var$ij(a, b) {
    switch(b.tag){
        case 0:
        case 11:
        case 14:
        case 15:
        case 22:
            var c = b.updateQueue;
            c = null !== c ? c.lastEffect : null;
            if (null !== c) {
                var d = c = c.next;
                do 3 === (d.tag & 3) && (a = d.destroy, d.destroy = void 0, void 0 !== a && a()), d = d.next;
                while (d !== c);
            }
            return;
        case 1:
            return;
        case 5:
            c = b.stateNode;
            if (null != c) {
                d = b.memoizedProps;
                var e = null !== a ? a.memoizedProps : d;
                a = b.type;
                var f = b.updateQueue;
                b.updateQueue = null;
                if (null !== f) {
                    c[$0b2e6adb871a3b94$var$xf] = d;
                    "input" === a && "radio" === d.type && null != d.name && $0b2e6adb871a3b94$var$$a(c, d);
                    $0b2e6adb871a3b94$var$wb(a, e);
                    b = $0b2e6adb871a3b94$var$wb(a, d);
                    for(e = 0; e < f.length; e += 2){
                        var g = f[e], h = f[e + 1];
                        "style" === g ? $0b2e6adb871a3b94$var$tb(c, h) : "dangerouslySetInnerHTML" === g ? $0b2e6adb871a3b94$var$ob(c, h) : "children" === g ? $0b2e6adb871a3b94$var$pb(c, h) : $0b2e6adb871a3b94$var$qa(c, g, h, b);
                    }
                    switch(a){
                        case "input":
                            $0b2e6adb871a3b94$var$ab(c, d);
                            break;
                        case "textarea":
                            $0b2e6adb871a3b94$var$ib(c, d);
                            break;
                        case "select":
                            a = c._wrapperState.wasMultiple, c._wrapperState.wasMultiple = !!d.multiple, f = d.value, null != f ? $0b2e6adb871a3b94$var$fb(c, !!d.multiple, f, !1) : a !== !!d.multiple && (null != d.defaultValue ? $0b2e6adb871a3b94$var$fb(c, !!d.multiple, d.defaultValue, !0) : $0b2e6adb871a3b94$var$fb(c, !!d.multiple, d.multiple ? [] : "", !1));
                    }
                }
            }
            return;
        case 6:
            if (null === b.stateNode) throw Error($0b2e6adb871a3b94$var$y(162));
            b.stateNode.nodeValue = b.memoizedProps;
            return;
        case 3:
            c = b.stateNode;
            c.hydrate && (c.hydrate = !1, $0b2e6adb871a3b94$var$Cc(c.containerInfo));
            return;
        case 12:
            return;
        case 13:
            null !== b.memoizedState && ($0b2e6adb871a3b94$var$jj = $0b2e6adb871a3b94$var$O(), $0b2e6adb871a3b94$var$aj(b.child, !0));
            $0b2e6adb871a3b94$var$kj(b);
            return;
        case 19:
            $0b2e6adb871a3b94$var$kj(b);
            return;
        case 17:
            return;
        case 23:
        case 24:
            $0b2e6adb871a3b94$var$aj(b, null !== b.memoizedState);
            return;
    }
    throw Error($0b2e6adb871a3b94$var$y(163));
}
function $0b2e6adb871a3b94$var$kj(a) {
    var b = a.updateQueue;
    if (null !== b) {
        a.updateQueue = null;
        var c = a.stateNode;
        null === c && (c = a.stateNode = new $0b2e6adb871a3b94$var$Ui);
        b.forEach(function(b) {
            var d = $0b2e6adb871a3b94$var$lj.bind(null, a, b);
            c.has(b) || (c.add(b), b.then(d, d));
        });
    }
}
function $0b2e6adb871a3b94$var$mj(a, b) {
    return null !== a && (a = a.memoizedState, null === a || null !== a.dehydrated) ? (b = b.memoizedState, null !== b && null === b.dehydrated) : !1;
}
var $0b2e6adb871a3b94$var$nj = Math.ceil, $0b2e6adb871a3b94$var$oj = $0b2e6adb871a3b94$var$ra.ReactCurrentDispatcher, $0b2e6adb871a3b94$var$pj = $0b2e6adb871a3b94$var$ra.ReactCurrentOwner, $0b2e6adb871a3b94$var$X = 0, $0b2e6adb871a3b94$var$U = null, $0b2e6adb871a3b94$var$Y = null, $0b2e6adb871a3b94$var$W = 0, $0b2e6adb871a3b94$var$qj = 0, $0b2e6adb871a3b94$var$rj = $0b2e6adb871a3b94$var$Bf(0), $0b2e6adb871a3b94$var$V = 0, $0b2e6adb871a3b94$var$sj = null, $0b2e6adb871a3b94$var$tj = 0, $0b2e6adb871a3b94$var$Dg = 0, $0b2e6adb871a3b94$var$Hi = 0, $0b2e6adb871a3b94$var$uj = 0, $0b2e6adb871a3b94$var$vj = null, $0b2e6adb871a3b94$var$jj = 0, $0b2e6adb871a3b94$var$Ji = Infinity;
function $0b2e6adb871a3b94$var$wj() {
    $0b2e6adb871a3b94$var$Ji = $0b2e6adb871a3b94$var$O() + 500;
}
var $0b2e6adb871a3b94$var$Z = null, $0b2e6adb871a3b94$var$Qi = !1, $0b2e6adb871a3b94$var$Ri = null, $0b2e6adb871a3b94$var$Ti = null, $0b2e6adb871a3b94$var$xj = !1, $0b2e6adb871a3b94$var$yj = null, $0b2e6adb871a3b94$var$zj = 90, $0b2e6adb871a3b94$var$Aj = [], $0b2e6adb871a3b94$var$Bj = [], $0b2e6adb871a3b94$var$Cj = null, $0b2e6adb871a3b94$var$Dj = 0, $0b2e6adb871a3b94$var$Ej = null, $0b2e6adb871a3b94$var$Fj = -1, $0b2e6adb871a3b94$var$Gj = 0, $0b2e6adb871a3b94$var$Hj = 0, $0b2e6adb871a3b94$var$Ij = null, $0b2e6adb871a3b94$var$Jj = !1;
function $0b2e6adb871a3b94$var$Hg() {
    return 0 !== ($0b2e6adb871a3b94$var$X & 48) ? $0b2e6adb871a3b94$var$O() : -1 !== $0b2e6adb871a3b94$var$Fj ? $0b2e6adb871a3b94$var$Fj : $0b2e6adb871a3b94$var$Fj = $0b2e6adb871a3b94$var$O();
}
function $0b2e6adb871a3b94$var$Ig(a) {
    a = a.mode;
    if (0 === (a & 2)) return 1;
    if (0 === (a & 4)) return 99 === $0b2e6adb871a3b94$var$eg() ? 1 : 2;
    0 === $0b2e6adb871a3b94$var$Gj && ($0b2e6adb871a3b94$var$Gj = $0b2e6adb871a3b94$var$tj);
    if (0 !== $0b2e6adb871a3b94$var$kg.transition) {
        0 !== $0b2e6adb871a3b94$var$Hj && ($0b2e6adb871a3b94$var$Hj = null !== $0b2e6adb871a3b94$var$vj ? $0b2e6adb871a3b94$var$vj.pendingLanes : 0);
        a = $0b2e6adb871a3b94$var$Gj;
        var b = 4186112 & ~$0b2e6adb871a3b94$var$Hj;
        b &= -b;
        0 === b && (a = 4186112 & ~a, b = a & -a, 0 === b && (b = 8192));
        return b;
    }
    a = $0b2e6adb871a3b94$var$eg();
    0 !== ($0b2e6adb871a3b94$var$X & 4) && 98 === a ? a = $0b2e6adb871a3b94$var$Xc(12, $0b2e6adb871a3b94$var$Gj) : (a = $0b2e6adb871a3b94$var$Sc(a), a = $0b2e6adb871a3b94$var$Xc(a, $0b2e6adb871a3b94$var$Gj));
    return a;
}
function $0b2e6adb871a3b94$var$Jg(a, b, c) {
    if (50 < $0b2e6adb871a3b94$var$Dj) throw $0b2e6adb871a3b94$var$Dj = 0, $0b2e6adb871a3b94$var$Ej = null, Error($0b2e6adb871a3b94$var$y(185));
    a = $0b2e6adb871a3b94$var$Kj(a, b);
    if (null === a) return null;
    $0b2e6adb871a3b94$var$$c(a, b, c);
    a === $0b2e6adb871a3b94$var$U && ($0b2e6adb871a3b94$var$Hi |= b, 4 === $0b2e6adb871a3b94$var$V && $0b2e6adb871a3b94$var$Ii(a, $0b2e6adb871a3b94$var$W));
    var d = $0b2e6adb871a3b94$var$eg();
    1 === b ? 0 !== ($0b2e6adb871a3b94$var$X & 8) && 0 === ($0b2e6adb871a3b94$var$X & 48) ? $0b2e6adb871a3b94$var$Lj(a) : ($0b2e6adb871a3b94$var$Mj(a, c), 0 === $0b2e6adb871a3b94$var$X && ($0b2e6adb871a3b94$var$wj(), $0b2e6adb871a3b94$var$ig())) : (0 === ($0b2e6adb871a3b94$var$X & 4) || 98 !== d && 99 !== d || (null === $0b2e6adb871a3b94$var$Cj ? $0b2e6adb871a3b94$var$Cj = new Set([
        a
    ]) : $0b2e6adb871a3b94$var$Cj.add(a)), $0b2e6adb871a3b94$var$Mj(a, c));
    $0b2e6adb871a3b94$var$vj = a;
}
function $0b2e6adb871a3b94$var$Kj(a, b) {
    a.lanes |= b;
    var c = a.alternate;
    null !== c && (c.lanes |= b);
    c = a;
    for(a = a.return; null !== a;)a.childLanes |= b, c = a.alternate, null !== c && (c.childLanes |= b), c = a, a = a.return;
    return 3 === c.tag ? c.stateNode : null;
}
function $0b2e6adb871a3b94$var$Mj(a, b) {
    for(var c = a.callbackNode, d = a.suspendedLanes, e = a.pingedLanes, f = a.expirationTimes, g = a.pendingLanes; 0 < g;){
        var h = 31 - $0b2e6adb871a3b94$var$Vc(g), k = 1 << h, l = f[h];
        if (-1 === l) {
            if (0 === (k & d) || 0 !== (k & e)) {
                l = b;
                $0b2e6adb871a3b94$var$Rc(k);
                var n = $0b2e6adb871a3b94$var$F;
                f[h] = 10 <= n ? l + 250 : 6 <= n ? l + 5E3 : -1;
            }
        } else l <= b && (a.expiredLanes |= k);
        g &= ~k;
    }
    d = $0b2e6adb871a3b94$var$Uc(a, a === $0b2e6adb871a3b94$var$U ? $0b2e6adb871a3b94$var$W : 0);
    b = $0b2e6adb871a3b94$var$F;
    if (0 === d) null !== c && (c !== $0b2e6adb871a3b94$var$Zf && $0b2e6adb871a3b94$var$Pf(c), a.callbackNode = null, a.callbackPriority = 0);
    else {
        if (null !== c) {
            if (a.callbackPriority === b) return;
            c !== $0b2e6adb871a3b94$var$Zf && $0b2e6adb871a3b94$var$Pf(c);
        }
        15 === b ? (c = $0b2e6adb871a3b94$var$Lj.bind(null, a), null === $0b2e6adb871a3b94$var$ag ? ($0b2e6adb871a3b94$var$ag = [
            c
        ], $0b2e6adb871a3b94$var$bg = $0b2e6adb871a3b94$var$Of($0b2e6adb871a3b94$var$Uf, $0b2e6adb871a3b94$var$jg)) : $0b2e6adb871a3b94$var$ag.push(c), c = $0b2e6adb871a3b94$var$Zf) : 14 === b ? c = $0b2e6adb871a3b94$var$hg(99, $0b2e6adb871a3b94$var$Lj.bind(null, a)) : (c = $0b2e6adb871a3b94$var$Tc(b), c = $0b2e6adb871a3b94$var$hg(c, $0b2e6adb871a3b94$var$Nj.bind(null, a)));
        a.callbackPriority = b;
        a.callbackNode = c;
    }
}
function $0b2e6adb871a3b94$var$Nj(a) {
    $0b2e6adb871a3b94$var$Fj = -1;
    $0b2e6adb871a3b94$var$Hj = $0b2e6adb871a3b94$var$Gj = 0;
    if (0 !== ($0b2e6adb871a3b94$var$X & 48)) throw Error($0b2e6adb871a3b94$var$y(327));
    var b = a.callbackNode;
    if ($0b2e6adb871a3b94$var$Oj() && a.callbackNode !== b) return null;
    var c = $0b2e6adb871a3b94$var$Uc(a, a === $0b2e6adb871a3b94$var$U ? $0b2e6adb871a3b94$var$W : 0);
    if (0 === c) return null;
    var d = c;
    var e = $0b2e6adb871a3b94$var$X;
    $0b2e6adb871a3b94$var$X |= 16;
    var f = $0b2e6adb871a3b94$var$Pj();
    if ($0b2e6adb871a3b94$var$U !== a || $0b2e6adb871a3b94$var$W !== d) $0b2e6adb871a3b94$var$wj(), $0b2e6adb871a3b94$var$Qj(a, d);
    for(;;)try {
        $0b2e6adb871a3b94$var$Rj();
        break;
    } catch (h) {
        $0b2e6adb871a3b94$var$Sj(a, h);
    }
    $0b2e6adb871a3b94$var$qg();
    $0b2e6adb871a3b94$var$oj.current = f;
    $0b2e6adb871a3b94$var$X = e;
    null !== $0b2e6adb871a3b94$var$Y ? d = 0 : ($0b2e6adb871a3b94$var$U = null, $0b2e6adb871a3b94$var$W = 0, d = $0b2e6adb871a3b94$var$V);
    if (0 !== ($0b2e6adb871a3b94$var$tj & $0b2e6adb871a3b94$var$Hi)) $0b2e6adb871a3b94$var$Qj(a, 0);
    else if (0 !== d) {
        2 === d && ($0b2e6adb871a3b94$var$X |= 64, a.hydrate && (a.hydrate = !1, $0b2e6adb871a3b94$var$qf(a.containerInfo)), c = $0b2e6adb871a3b94$var$Wc(a), 0 !== c && (d = $0b2e6adb871a3b94$var$Tj(a, c)));
        if (1 === d) throw b = $0b2e6adb871a3b94$var$sj, $0b2e6adb871a3b94$var$Qj(a, 0), $0b2e6adb871a3b94$var$Ii(a, c), $0b2e6adb871a3b94$var$Mj(a, $0b2e6adb871a3b94$var$O()), b;
        a.finishedWork = a.current.alternate;
        a.finishedLanes = c;
        switch(d){
            case 0:
            case 1:
                throw Error($0b2e6adb871a3b94$var$y(345));
            case 2:
                $0b2e6adb871a3b94$var$Uj(a);
                break;
            case 3:
                $0b2e6adb871a3b94$var$Ii(a, c);
                if ((c & 62914560) === c && (d = $0b2e6adb871a3b94$var$jj + 500 - $0b2e6adb871a3b94$var$O(), 10 < d)) {
                    if (0 !== $0b2e6adb871a3b94$var$Uc(a, 0)) break;
                    e = a.suspendedLanes;
                    if ((e & c) !== c) {
                        $0b2e6adb871a3b94$var$Hg();
                        a.pingedLanes |= a.suspendedLanes & e;
                        break;
                    }
                    a.timeoutHandle = $0b2e6adb871a3b94$var$of($0b2e6adb871a3b94$var$Uj.bind(null, a), d);
                    break;
                }
                $0b2e6adb871a3b94$var$Uj(a);
                break;
            case 4:
                $0b2e6adb871a3b94$var$Ii(a, c);
                if ((c & 4186112) === c) break;
                d = a.eventTimes;
                for(e = -1; 0 < c;){
                    var g = 31 - $0b2e6adb871a3b94$var$Vc(c);
                    f = 1 << g;
                    g = d[g];
                    g > e && (e = g);
                    c &= ~f;
                }
                c = e;
                c = $0b2e6adb871a3b94$var$O() - c;
                c = (120 > c ? 120 : 480 > c ? 480 : 1080 > c ? 1080 : 1920 > c ? 1920 : 3E3 > c ? 3E3 : 4320 > c ? 4320 : 1960 * $0b2e6adb871a3b94$var$nj(c / 1960)) - c;
                if (10 < c) {
                    a.timeoutHandle = $0b2e6adb871a3b94$var$of($0b2e6adb871a3b94$var$Uj.bind(null, a), c);
                    break;
                }
                $0b2e6adb871a3b94$var$Uj(a);
                break;
            case 5:
                $0b2e6adb871a3b94$var$Uj(a);
                break;
            default:
                throw Error($0b2e6adb871a3b94$var$y(329));
        }
    }
    $0b2e6adb871a3b94$var$Mj(a, $0b2e6adb871a3b94$var$O());
    return a.callbackNode === b ? $0b2e6adb871a3b94$var$Nj.bind(null, a) : null;
}
function $0b2e6adb871a3b94$var$Ii(a, b) {
    b &= ~$0b2e6adb871a3b94$var$uj;
    b &= ~$0b2e6adb871a3b94$var$Hi;
    a.suspendedLanes |= b;
    a.pingedLanes &= ~b;
    for(a = a.expirationTimes; 0 < b;){
        var c = 31 - $0b2e6adb871a3b94$var$Vc(b), d = 1 << c;
        a[c] = -1;
        b &= ~d;
    }
}
function $0b2e6adb871a3b94$var$Lj(a) {
    if (0 !== ($0b2e6adb871a3b94$var$X & 48)) throw Error($0b2e6adb871a3b94$var$y(327));
    $0b2e6adb871a3b94$var$Oj();
    if (a === $0b2e6adb871a3b94$var$U && 0 !== (a.expiredLanes & $0b2e6adb871a3b94$var$W)) {
        var b = $0b2e6adb871a3b94$var$W;
        var c = $0b2e6adb871a3b94$var$Tj(a, b);
        0 !== ($0b2e6adb871a3b94$var$tj & $0b2e6adb871a3b94$var$Hi) && (b = $0b2e6adb871a3b94$var$Uc(a, b), c = $0b2e6adb871a3b94$var$Tj(a, b));
    } else b = $0b2e6adb871a3b94$var$Uc(a, 0), c = $0b2e6adb871a3b94$var$Tj(a, b);
    0 !== a.tag && 2 === c && ($0b2e6adb871a3b94$var$X |= 64, a.hydrate && (a.hydrate = !1, $0b2e6adb871a3b94$var$qf(a.containerInfo)), b = $0b2e6adb871a3b94$var$Wc(a), 0 !== b && (c = $0b2e6adb871a3b94$var$Tj(a, b)));
    if (1 === c) throw c = $0b2e6adb871a3b94$var$sj, $0b2e6adb871a3b94$var$Qj(a, 0), $0b2e6adb871a3b94$var$Ii(a, b), $0b2e6adb871a3b94$var$Mj(a, $0b2e6adb871a3b94$var$O()), c;
    a.finishedWork = a.current.alternate;
    a.finishedLanes = b;
    $0b2e6adb871a3b94$var$Uj(a);
    $0b2e6adb871a3b94$var$Mj(a, $0b2e6adb871a3b94$var$O());
    return null;
}
function $0b2e6adb871a3b94$var$Vj() {
    if (null !== $0b2e6adb871a3b94$var$Cj) {
        var a = $0b2e6adb871a3b94$var$Cj;
        $0b2e6adb871a3b94$var$Cj = null;
        a.forEach(function(a) {
            a.expiredLanes |= 24 & a.pendingLanes;
            $0b2e6adb871a3b94$var$Mj(a, $0b2e6adb871a3b94$var$O());
        });
    }
    $0b2e6adb871a3b94$var$ig();
}
function $0b2e6adb871a3b94$var$Wj(a, b) {
    var c = $0b2e6adb871a3b94$var$X;
    $0b2e6adb871a3b94$var$X |= 1;
    try {
        return a(b);
    } finally{
        $0b2e6adb871a3b94$var$X = c, 0 === $0b2e6adb871a3b94$var$X && ($0b2e6adb871a3b94$var$wj(), $0b2e6adb871a3b94$var$ig());
    }
}
function $0b2e6adb871a3b94$var$Xj(a, b) {
    var c = $0b2e6adb871a3b94$var$X;
    $0b2e6adb871a3b94$var$X &= -2;
    $0b2e6adb871a3b94$var$X |= 8;
    try {
        return a(b);
    } finally{
        $0b2e6adb871a3b94$var$X = c, 0 === $0b2e6adb871a3b94$var$X && ($0b2e6adb871a3b94$var$wj(), $0b2e6adb871a3b94$var$ig());
    }
}
function $0b2e6adb871a3b94$var$ni(a, b) {
    $0b2e6adb871a3b94$var$I($0b2e6adb871a3b94$var$rj, $0b2e6adb871a3b94$var$qj);
    $0b2e6adb871a3b94$var$qj |= b;
    $0b2e6adb871a3b94$var$tj |= b;
}
function $0b2e6adb871a3b94$var$Ki() {
    $0b2e6adb871a3b94$var$qj = $0b2e6adb871a3b94$var$rj.current;
    $0b2e6adb871a3b94$var$H($0b2e6adb871a3b94$var$rj);
}
function $0b2e6adb871a3b94$var$Qj(a, b) {
    a.finishedWork = null;
    a.finishedLanes = 0;
    var c = a.timeoutHandle;
    -1 !== c && (a.timeoutHandle = -1, $0b2e6adb871a3b94$var$pf(c));
    if (null !== $0b2e6adb871a3b94$var$Y) for(c = $0b2e6adb871a3b94$var$Y.return; null !== c;){
        var d = c;
        switch(d.tag){
            case 1:
                d = d.type.childContextTypes;
                null !== d && void 0 !== d && $0b2e6adb871a3b94$var$Gf();
                break;
            case 3:
                $0b2e6adb871a3b94$var$fh();
                $0b2e6adb871a3b94$var$H($0b2e6adb871a3b94$var$N);
                $0b2e6adb871a3b94$var$H($0b2e6adb871a3b94$var$M);
                $0b2e6adb871a3b94$var$uh();
                break;
            case 5:
                $0b2e6adb871a3b94$var$hh(d);
                break;
            case 4:
                $0b2e6adb871a3b94$var$fh();
                break;
            case 13:
                $0b2e6adb871a3b94$var$H($0b2e6adb871a3b94$var$P);
                break;
            case 19:
                $0b2e6adb871a3b94$var$H($0b2e6adb871a3b94$var$P);
                break;
            case 10:
                $0b2e6adb871a3b94$var$rg(d);
                break;
            case 23:
            case 24:
                $0b2e6adb871a3b94$var$Ki();
        }
        c = c.return;
    }
    $0b2e6adb871a3b94$var$U = a;
    $0b2e6adb871a3b94$var$Y = $0b2e6adb871a3b94$var$Tg(a.current, null);
    $0b2e6adb871a3b94$var$W = $0b2e6adb871a3b94$var$qj = $0b2e6adb871a3b94$var$tj = b;
    $0b2e6adb871a3b94$var$V = 0;
    $0b2e6adb871a3b94$var$sj = null;
    $0b2e6adb871a3b94$var$uj = $0b2e6adb871a3b94$var$Hi = $0b2e6adb871a3b94$var$Dg = 0;
}
function $0b2e6adb871a3b94$var$Sj(a, b) {
    do {
        var c = $0b2e6adb871a3b94$var$Y;
        try {
            $0b2e6adb871a3b94$var$qg();
            $0b2e6adb871a3b94$var$vh.current = $0b2e6adb871a3b94$var$Gh;
            if ($0b2e6adb871a3b94$var$yh) {
                for(var d = $0b2e6adb871a3b94$var$R.memoizedState; null !== d;){
                    var e = d.queue;
                    null !== e && (e.pending = null);
                    d = d.next;
                }
                $0b2e6adb871a3b94$var$yh = !1;
            }
            $0b2e6adb871a3b94$var$xh = 0;
            $0b2e6adb871a3b94$var$T = $0b2e6adb871a3b94$var$S = $0b2e6adb871a3b94$var$R = null;
            $0b2e6adb871a3b94$var$zh = !1;
            $0b2e6adb871a3b94$var$pj.current = null;
            if (null === c || null === c.return) {
                $0b2e6adb871a3b94$var$V = 1;
                $0b2e6adb871a3b94$var$sj = b;
                $0b2e6adb871a3b94$var$Y = null;
                break;
            }
            a: {
                var f = a, g = c.return, h = c, k = b;
                b = $0b2e6adb871a3b94$var$W;
                h.flags |= 2048;
                h.firstEffect = h.lastEffect = null;
                if (null !== k && "object" === typeof k && "function" === typeof k.then) {
                    var l = k;
                    if (0 === (h.mode & 2)) {
                        var n = h.alternate;
                        n ? (h.updateQueue = n.updateQueue, h.memoizedState = n.memoizedState, h.lanes = n.lanes) : (h.updateQueue = null, h.memoizedState = null);
                    }
                    var A = 0 !== ($0b2e6adb871a3b94$var$P.current & 1), p = g;
                    do {
                        var C;
                        if (C = 13 === p.tag) {
                            var x = p.memoizedState;
                            if (null !== x) C = null !== x.dehydrated ? !0 : !1;
                            else {
                                var w = p.memoizedProps;
                                C = void 0 === w.fallback ? !1 : !0 !== w.unstable_avoidThisFallback ? !0 : A ? !1 : !0;
                            }
                        }
                        if (C) {
                            var z = p.updateQueue;
                            if (null === z) {
                                var u = new Set;
                                u.add(l);
                                p.updateQueue = u;
                            } else z.add(l);
                            if (0 === (p.mode & 2)) {
                                p.flags |= 64;
                                h.flags |= 16384;
                                h.flags &= -2981;
                                if (1 === h.tag) {
                                    if (null === h.alternate) h.tag = 17;
                                    else {
                                        var t = $0b2e6adb871a3b94$var$zg(-1, 1);
                                        t.tag = 2;
                                        $0b2e6adb871a3b94$var$Ag(h, t);
                                    }
                                }
                                h.lanes |= 1;
                                break a;
                            }
                            k = void 0;
                            h = b;
                            var q = f.pingCache;
                            null === q ? (q = f.pingCache = new $0b2e6adb871a3b94$var$Oi, k = new Set, q.set(l, k)) : (k = q.get(l), void 0 === k && (k = new Set, q.set(l, k)));
                            if (!k.has(h)) {
                                k.add(h);
                                var v = $0b2e6adb871a3b94$var$Yj.bind(null, f, l, h);
                                l.then(v, v);
                            }
                            p.flags |= 4096;
                            p.lanes = b;
                            break a;
                        }
                        p = p.return;
                    }while (null !== p);
                    k = Error(($0b2e6adb871a3b94$var$Ra(h.type) || "A React component") + " suspended while rendering, but no fallback UI was specified.\n\nAdd a <Suspense fallback=...> component higher in the tree to provide a loading indicator or placeholder to display.");
                }
                5 !== $0b2e6adb871a3b94$var$V && ($0b2e6adb871a3b94$var$V = 2);
                k = $0b2e6adb871a3b94$var$Mi(k, h);
                p = g;
                do {
                    switch(p.tag){
                        case 3:
                            f = k;
                            p.flags |= 4096;
                            b &= -b;
                            p.lanes |= b;
                            var J = $0b2e6adb871a3b94$var$Pi(p, f, b);
                            $0b2e6adb871a3b94$var$Bg(p, J);
                            break a;
                        case 1:
                            f = k;
                            var K = p.type, Q = p.stateNode;
                            if (0 === (p.flags & 64) && ("function" === typeof K.getDerivedStateFromError || null !== Q && "function" === typeof Q.componentDidCatch && (null === $0b2e6adb871a3b94$var$Ti || !$0b2e6adb871a3b94$var$Ti.has(Q)))) {
                                p.flags |= 4096;
                                b &= -b;
                                p.lanes |= b;
                                var L = $0b2e6adb871a3b94$var$Si(p, f, b);
                                $0b2e6adb871a3b94$var$Bg(p, L);
                                break a;
                            }
                    }
                    p = p.return;
                }while (null !== p);
            }
            $0b2e6adb871a3b94$var$Zj(c);
        } catch (va) {
            b = va;
            $0b2e6adb871a3b94$var$Y === c && null !== c && ($0b2e6adb871a3b94$var$Y = c = c.return);
            continue;
        }
        break;
    }while (1);
}
function $0b2e6adb871a3b94$var$Pj() {
    var a = $0b2e6adb871a3b94$var$oj.current;
    $0b2e6adb871a3b94$var$oj.current = $0b2e6adb871a3b94$var$Gh;
    return null === a ? $0b2e6adb871a3b94$var$Gh : a;
}
function $0b2e6adb871a3b94$var$Tj(a, b) {
    var c = $0b2e6adb871a3b94$var$X;
    $0b2e6adb871a3b94$var$X |= 16;
    var d = $0b2e6adb871a3b94$var$Pj();
    $0b2e6adb871a3b94$var$U === a && $0b2e6adb871a3b94$var$W === b || $0b2e6adb871a3b94$var$Qj(a, b);
    for(;;)try {
        $0b2e6adb871a3b94$var$ak();
        break;
    } catch (e) {
        $0b2e6adb871a3b94$var$Sj(a, e);
    }
    $0b2e6adb871a3b94$var$qg();
    $0b2e6adb871a3b94$var$X = c;
    $0b2e6adb871a3b94$var$oj.current = d;
    if (null !== $0b2e6adb871a3b94$var$Y) throw Error($0b2e6adb871a3b94$var$y(261));
    $0b2e6adb871a3b94$var$U = null;
    $0b2e6adb871a3b94$var$W = 0;
    return $0b2e6adb871a3b94$var$V;
}
function $0b2e6adb871a3b94$var$ak() {
    for(; null !== $0b2e6adb871a3b94$var$Y;)$0b2e6adb871a3b94$var$bk($0b2e6adb871a3b94$var$Y);
}
function $0b2e6adb871a3b94$var$Rj() {
    for(; null !== $0b2e6adb871a3b94$var$Y && !$0b2e6adb871a3b94$var$Qf();)$0b2e6adb871a3b94$var$bk($0b2e6adb871a3b94$var$Y);
}
function $0b2e6adb871a3b94$var$bk(a) {
    var b = $0b2e6adb871a3b94$var$ck(a.alternate, a, $0b2e6adb871a3b94$var$qj);
    a.memoizedProps = a.pendingProps;
    null === b ? $0b2e6adb871a3b94$var$Zj(a) : $0b2e6adb871a3b94$var$Y = b;
    $0b2e6adb871a3b94$var$pj.current = null;
}
function $0b2e6adb871a3b94$var$Zj(a) {
    var b = a;
    do {
        var c = b.alternate;
        a = b.return;
        if (0 === (b.flags & 2048)) {
            c = $0b2e6adb871a3b94$var$Gi(c, b, $0b2e6adb871a3b94$var$qj);
            if (null !== c) {
                $0b2e6adb871a3b94$var$Y = c;
                return;
            }
            c = b;
            if (24 !== c.tag && 23 !== c.tag || null === c.memoizedState || 0 !== ($0b2e6adb871a3b94$var$qj & 1073741824) || 0 === (c.mode & 4)) {
                for(var d = 0, e = c.child; null !== e;)d |= e.lanes | e.childLanes, e = e.sibling;
                c.childLanes = d;
            }
            null !== a && 0 === (a.flags & 2048) && (null === a.firstEffect && (a.firstEffect = b.firstEffect), null !== b.lastEffect && (null !== a.lastEffect && (a.lastEffect.nextEffect = b.firstEffect), a.lastEffect = b.lastEffect), 1 < b.flags && (null !== a.lastEffect ? a.lastEffect.nextEffect = b : a.firstEffect = b, a.lastEffect = b));
        } else {
            c = $0b2e6adb871a3b94$var$Li(b);
            if (null !== c) {
                c.flags &= 2047;
                $0b2e6adb871a3b94$var$Y = c;
                return;
            }
            null !== a && (a.firstEffect = a.lastEffect = null, a.flags |= 2048);
        }
        b = b.sibling;
        if (null !== b) {
            $0b2e6adb871a3b94$var$Y = b;
            return;
        }
        $0b2e6adb871a3b94$var$Y = b = a;
    }while (null !== b);
    0 === $0b2e6adb871a3b94$var$V && ($0b2e6adb871a3b94$var$V = 5);
}
function $0b2e6adb871a3b94$var$Uj(a) {
    var b = $0b2e6adb871a3b94$var$eg();
    $0b2e6adb871a3b94$var$gg(99, $0b2e6adb871a3b94$var$dk.bind(null, a, b));
    return null;
}
function $0b2e6adb871a3b94$var$dk(a, b) {
    do $0b2e6adb871a3b94$var$Oj();
    while (null !== $0b2e6adb871a3b94$var$yj);
    if (0 !== ($0b2e6adb871a3b94$var$X & 48)) throw Error($0b2e6adb871a3b94$var$y(327));
    var c = a.finishedWork;
    if (null === c) return null;
    a.finishedWork = null;
    a.finishedLanes = 0;
    if (c === a.current) throw Error($0b2e6adb871a3b94$var$y(177));
    a.callbackNode = null;
    var d = c.lanes | c.childLanes, e = d, f = a.pendingLanes & ~e;
    a.pendingLanes = e;
    a.suspendedLanes = 0;
    a.pingedLanes = 0;
    a.expiredLanes &= e;
    a.mutableReadLanes &= e;
    a.entangledLanes &= e;
    e = a.entanglements;
    for(var g = a.eventTimes, h = a.expirationTimes; 0 < f;){
        var k = 31 - $0b2e6adb871a3b94$var$Vc(f), l = 1 << k;
        e[k] = 0;
        g[k] = -1;
        h[k] = -1;
        f &= ~l;
    }
    null !== $0b2e6adb871a3b94$var$Cj && 0 === (d & 24) && $0b2e6adb871a3b94$var$Cj.has(a) && $0b2e6adb871a3b94$var$Cj.delete(a);
    a === $0b2e6adb871a3b94$var$U && ($0b2e6adb871a3b94$var$Y = $0b2e6adb871a3b94$var$U = null, $0b2e6adb871a3b94$var$W = 0);
    1 < c.flags ? null !== c.lastEffect ? (c.lastEffect.nextEffect = c, d = c.firstEffect) : d = c : d = c.firstEffect;
    if (null !== d) {
        e = $0b2e6adb871a3b94$var$X;
        $0b2e6adb871a3b94$var$X |= 32;
        $0b2e6adb871a3b94$var$pj.current = null;
        $0b2e6adb871a3b94$var$kf = $0b2e6adb871a3b94$var$fd;
        g = $0b2e6adb871a3b94$var$Ne();
        if ($0b2e6adb871a3b94$var$Oe(g)) {
            if ("selectionStart" in g) h = {
                start: g.selectionStart,
                end: g.selectionEnd
            };
            else a: if (h = (h = g.ownerDocument) && h.defaultView || window, (l = h.getSelection && h.getSelection()) && 0 !== l.rangeCount) {
                h = l.anchorNode;
                f = l.anchorOffset;
                k = l.focusNode;
                l = l.focusOffset;
                try {
                    h.nodeType, k.nodeType;
                } catch (va) {
                    h = null;
                    break a;
                }
                var n = 0, A = -1, p = -1, C = 0, x = 0, w = g, z = null;
                b: for(;;){
                    for(var u;;){
                        w !== h || 0 !== f && 3 !== w.nodeType || (A = n + f);
                        w !== k || 0 !== l && 3 !== w.nodeType || (p = n + l);
                        3 === w.nodeType && (n += w.nodeValue.length);
                        if (null === (u = w.firstChild)) break;
                        z = w;
                        w = u;
                    }
                    for(;;){
                        if (w === g) break b;
                        z === h && ++C === f && (A = n);
                        z === k && ++x === l && (p = n);
                        if (null !== (u = w.nextSibling)) break;
                        w = z;
                        z = w.parentNode;
                    }
                    w = u;
                }
                h = -1 === A || -1 === p ? null : {
                    start: A,
                    end: p
                };
            } else h = null;
            h = h || {
                start: 0,
                end: 0
            };
        } else h = null;
        $0b2e6adb871a3b94$var$lf = {
            focusedElem: g,
            selectionRange: h
        };
        $0b2e6adb871a3b94$var$fd = !1;
        $0b2e6adb871a3b94$var$Ij = null;
        $0b2e6adb871a3b94$var$Jj = !1;
        $0b2e6adb871a3b94$var$Z = d;
        do try {
            $0b2e6adb871a3b94$var$ek();
        } catch (va) {
            if (null === $0b2e6adb871a3b94$var$Z) throw Error($0b2e6adb871a3b94$var$y(330));
            $0b2e6adb871a3b94$var$Wi($0b2e6adb871a3b94$var$Z, va);
            $0b2e6adb871a3b94$var$Z = $0b2e6adb871a3b94$var$Z.nextEffect;
        }
        while (null !== $0b2e6adb871a3b94$var$Z);
        $0b2e6adb871a3b94$var$Ij = null;
        $0b2e6adb871a3b94$var$Z = d;
        do try {
            for(g = a; null !== $0b2e6adb871a3b94$var$Z;){
                var t = $0b2e6adb871a3b94$var$Z.flags;
                t & 16 && $0b2e6adb871a3b94$var$pb($0b2e6adb871a3b94$var$Z.stateNode, "");
                if (t & 128) {
                    var q = $0b2e6adb871a3b94$var$Z.alternate;
                    if (null !== q) {
                        var v = q.ref;
                        null !== v && ("function" === typeof v ? v(null) : v.current = null);
                    }
                }
                switch(t & 1038){
                    case 2:
                        $0b2e6adb871a3b94$var$fj($0b2e6adb871a3b94$var$Z);
                        $0b2e6adb871a3b94$var$Z.flags &= -3;
                        break;
                    case 6:
                        $0b2e6adb871a3b94$var$fj($0b2e6adb871a3b94$var$Z);
                        $0b2e6adb871a3b94$var$Z.flags &= -3;
                        $0b2e6adb871a3b94$var$ij($0b2e6adb871a3b94$var$Z.alternate, $0b2e6adb871a3b94$var$Z);
                        break;
                    case 1024:
                        $0b2e6adb871a3b94$var$Z.flags &= -1025;
                        break;
                    case 1028:
                        $0b2e6adb871a3b94$var$Z.flags &= -1025;
                        $0b2e6adb871a3b94$var$ij($0b2e6adb871a3b94$var$Z.alternate, $0b2e6adb871a3b94$var$Z);
                        break;
                    case 4:
                        $0b2e6adb871a3b94$var$ij($0b2e6adb871a3b94$var$Z.alternate, $0b2e6adb871a3b94$var$Z);
                        break;
                    case 8:
                        h = $0b2e6adb871a3b94$var$Z;
                        $0b2e6adb871a3b94$var$cj(g, h);
                        var J = h.alternate;
                        $0b2e6adb871a3b94$var$dj(h);
                        null !== J && $0b2e6adb871a3b94$var$dj(J);
                }
                $0b2e6adb871a3b94$var$Z = $0b2e6adb871a3b94$var$Z.nextEffect;
            }
        } catch (va) {
            if (null === $0b2e6adb871a3b94$var$Z) throw Error($0b2e6adb871a3b94$var$y(330));
            $0b2e6adb871a3b94$var$Wi($0b2e6adb871a3b94$var$Z, va);
            $0b2e6adb871a3b94$var$Z = $0b2e6adb871a3b94$var$Z.nextEffect;
        }
        while (null !== $0b2e6adb871a3b94$var$Z);
        v = $0b2e6adb871a3b94$var$lf;
        q = $0b2e6adb871a3b94$var$Ne();
        t = v.focusedElem;
        g = v.selectionRange;
        if (q !== t && t && t.ownerDocument && $0b2e6adb871a3b94$var$Me(t.ownerDocument.documentElement, t)) {
            null !== g && $0b2e6adb871a3b94$var$Oe(t) && (q = g.start, v = g.end, void 0 === v && (v = q), "selectionStart" in t ? (t.selectionStart = q, t.selectionEnd = Math.min(v, t.value.length)) : (v = (q = t.ownerDocument || document) && q.defaultView || window, v.getSelection && (v = v.getSelection(), h = t.textContent.length, J = Math.min(g.start, h), g = void 0 === g.end ? J : Math.min(g.end, h), !v.extend && J > g && (h = g, g = J, J = h), h = $0b2e6adb871a3b94$var$Le(t, J), f = $0b2e6adb871a3b94$var$Le(t, g), h && f && (1 !== v.rangeCount || v.anchorNode !== h.node || v.anchorOffset !== h.offset || v.focusNode !== f.node || v.focusOffset !== f.offset) && (q = q.createRange(), q.setStart(h.node, h.offset), v.removeAllRanges(), J > g ? (v.addRange(q), v.extend(f.node, f.offset)) : (q.setEnd(f.node, f.offset), v.addRange(q))))));
            q = [];
            for(v = t; v = v.parentNode;)1 === v.nodeType && q.push({
                element: v,
                left: v.scrollLeft,
                top: v.scrollTop
            });
            "function" === typeof t.focus && t.focus();
            for(t = 0; t < q.length; t++)v = q[t], v.element.scrollLeft = v.left, v.element.scrollTop = v.top;
        }
        $0b2e6adb871a3b94$var$fd = !!$0b2e6adb871a3b94$var$kf;
        $0b2e6adb871a3b94$var$lf = $0b2e6adb871a3b94$var$kf = null;
        a.current = c;
        $0b2e6adb871a3b94$var$Z = d;
        do try {
            for(t = a; null !== $0b2e6adb871a3b94$var$Z;){
                var K = $0b2e6adb871a3b94$var$Z.flags;
                K & 36 && $0b2e6adb871a3b94$var$Yi(t, $0b2e6adb871a3b94$var$Z.alternate, $0b2e6adb871a3b94$var$Z);
                if (K & 128) {
                    q = void 0;
                    var Q = $0b2e6adb871a3b94$var$Z.ref;
                    if (null !== Q) {
                        var L = $0b2e6adb871a3b94$var$Z.stateNode;
                        switch($0b2e6adb871a3b94$var$Z.tag){
                            case 5:
                                q = L;
                                break;
                            default:
                                q = L;
                        }
                        "function" === typeof Q ? Q(q) : Q.current = q;
                    }
                }
                $0b2e6adb871a3b94$var$Z = $0b2e6adb871a3b94$var$Z.nextEffect;
            }
        } catch (va) {
            if (null === $0b2e6adb871a3b94$var$Z) throw Error($0b2e6adb871a3b94$var$y(330));
            $0b2e6adb871a3b94$var$Wi($0b2e6adb871a3b94$var$Z, va);
            $0b2e6adb871a3b94$var$Z = $0b2e6adb871a3b94$var$Z.nextEffect;
        }
        while (null !== $0b2e6adb871a3b94$var$Z);
        $0b2e6adb871a3b94$var$Z = null;
        $0b2e6adb871a3b94$var$$f();
        $0b2e6adb871a3b94$var$X = e;
    } else a.current = c;
    if ($0b2e6adb871a3b94$var$xj) $0b2e6adb871a3b94$var$xj = !1, $0b2e6adb871a3b94$var$yj = a, $0b2e6adb871a3b94$var$zj = b;
    else for($0b2e6adb871a3b94$var$Z = d; null !== $0b2e6adb871a3b94$var$Z;)b = $0b2e6adb871a3b94$var$Z.nextEffect, $0b2e6adb871a3b94$var$Z.nextEffect = null, $0b2e6adb871a3b94$var$Z.flags & 8 && (K = $0b2e6adb871a3b94$var$Z, K.sibling = null, K.stateNode = null), $0b2e6adb871a3b94$var$Z = b;
    d = a.pendingLanes;
    0 === d && ($0b2e6adb871a3b94$var$Ti = null);
    1 === d ? a === $0b2e6adb871a3b94$var$Ej ? $0b2e6adb871a3b94$var$Dj++ : ($0b2e6adb871a3b94$var$Dj = 0, $0b2e6adb871a3b94$var$Ej = a) : $0b2e6adb871a3b94$var$Dj = 0;
    c = c.stateNode;
    if ($0b2e6adb871a3b94$var$Mf && "function" === typeof $0b2e6adb871a3b94$var$Mf.onCommitFiberRoot) try {
        $0b2e6adb871a3b94$var$Mf.onCommitFiberRoot($0b2e6adb871a3b94$var$Lf, c, void 0, 64 === (c.current.flags & 64));
    } catch (va) {}
    $0b2e6adb871a3b94$var$Mj(a, $0b2e6adb871a3b94$var$O());
    if ($0b2e6adb871a3b94$var$Qi) throw $0b2e6adb871a3b94$var$Qi = !1, a = $0b2e6adb871a3b94$var$Ri, $0b2e6adb871a3b94$var$Ri = null, a;
    if (0 !== ($0b2e6adb871a3b94$var$X & 8)) return null;
    $0b2e6adb871a3b94$var$ig();
    return null;
}
function $0b2e6adb871a3b94$var$ek() {
    for(; null !== $0b2e6adb871a3b94$var$Z;){
        var a = $0b2e6adb871a3b94$var$Z.alternate;
        $0b2e6adb871a3b94$var$Jj || null === $0b2e6adb871a3b94$var$Ij || (0 !== ($0b2e6adb871a3b94$var$Z.flags & 8) ? $0b2e6adb871a3b94$var$dc($0b2e6adb871a3b94$var$Z, $0b2e6adb871a3b94$var$Ij) && ($0b2e6adb871a3b94$var$Jj = !0) : 13 === $0b2e6adb871a3b94$var$Z.tag && $0b2e6adb871a3b94$var$mj(a, $0b2e6adb871a3b94$var$Z) && $0b2e6adb871a3b94$var$dc($0b2e6adb871a3b94$var$Z, $0b2e6adb871a3b94$var$Ij) && ($0b2e6adb871a3b94$var$Jj = !0));
        var b = $0b2e6adb871a3b94$var$Z.flags;
        0 !== (b & 256) && $0b2e6adb871a3b94$var$Xi(a, $0b2e6adb871a3b94$var$Z);
        0 === (b & 512) || $0b2e6adb871a3b94$var$xj || ($0b2e6adb871a3b94$var$xj = !0, $0b2e6adb871a3b94$var$hg(97, function() {
            $0b2e6adb871a3b94$var$Oj();
            return null;
        }));
        $0b2e6adb871a3b94$var$Z = $0b2e6adb871a3b94$var$Z.nextEffect;
    }
}
function $0b2e6adb871a3b94$var$Oj() {
    if (90 !== $0b2e6adb871a3b94$var$zj) {
        var a = 97 < $0b2e6adb871a3b94$var$zj ? 97 : $0b2e6adb871a3b94$var$zj;
        $0b2e6adb871a3b94$var$zj = 90;
        return $0b2e6adb871a3b94$var$gg(a, $0b2e6adb871a3b94$var$fk);
    }
    return !1;
}
function $0b2e6adb871a3b94$var$$i(a, b) {
    $0b2e6adb871a3b94$var$Aj.push(b, a);
    $0b2e6adb871a3b94$var$xj || ($0b2e6adb871a3b94$var$xj = !0, $0b2e6adb871a3b94$var$hg(97, function() {
        $0b2e6adb871a3b94$var$Oj();
        return null;
    }));
}
function $0b2e6adb871a3b94$var$Zi(a, b) {
    $0b2e6adb871a3b94$var$Bj.push(b, a);
    $0b2e6adb871a3b94$var$xj || ($0b2e6adb871a3b94$var$xj = !0, $0b2e6adb871a3b94$var$hg(97, function() {
        $0b2e6adb871a3b94$var$Oj();
        return null;
    }));
}
function $0b2e6adb871a3b94$var$fk() {
    if (null === $0b2e6adb871a3b94$var$yj) return !1;
    var a = $0b2e6adb871a3b94$var$yj;
    $0b2e6adb871a3b94$var$yj = null;
    if (0 !== ($0b2e6adb871a3b94$var$X & 48)) throw Error($0b2e6adb871a3b94$var$y(331));
    var b = $0b2e6adb871a3b94$var$X;
    $0b2e6adb871a3b94$var$X |= 32;
    var c = $0b2e6adb871a3b94$var$Bj;
    $0b2e6adb871a3b94$var$Bj = [];
    for(var d = 0; d < c.length; d += 2){
        var e = c[d], f = c[d + 1], g = e.destroy;
        e.destroy = void 0;
        if ("function" === typeof g) try {
            g();
        } catch (k) {
            if (null === f) throw Error($0b2e6adb871a3b94$var$y(330));
            $0b2e6adb871a3b94$var$Wi(f, k);
        }
    }
    c = $0b2e6adb871a3b94$var$Aj;
    $0b2e6adb871a3b94$var$Aj = [];
    for(d = 0; d < c.length; d += 2){
        e = c[d];
        f = c[d + 1];
        try {
            var h = e.create;
            e.destroy = h();
        } catch (k) {
            if (null === f) throw Error($0b2e6adb871a3b94$var$y(330));
            $0b2e6adb871a3b94$var$Wi(f, k);
        }
    }
    for(h = a.current.firstEffect; null !== h;)a = h.nextEffect, h.nextEffect = null, h.flags & 8 && (h.sibling = null, h.stateNode = null), h = a;
    $0b2e6adb871a3b94$var$X = b;
    $0b2e6adb871a3b94$var$ig();
    return !0;
}
function $0b2e6adb871a3b94$var$gk(a, b, c) {
    b = $0b2e6adb871a3b94$var$Mi(c, b);
    b = $0b2e6adb871a3b94$var$Pi(a, b, 1);
    $0b2e6adb871a3b94$var$Ag(a, b);
    b = $0b2e6adb871a3b94$var$Hg();
    a = $0b2e6adb871a3b94$var$Kj(a, 1);
    null !== a && ($0b2e6adb871a3b94$var$$c(a, 1, b), $0b2e6adb871a3b94$var$Mj(a, b));
}
function $0b2e6adb871a3b94$var$Wi(a, b) {
    if (3 === a.tag) $0b2e6adb871a3b94$var$gk(a, a, b);
    else for(var c = a.return; null !== c;){
        if (3 === c.tag) {
            $0b2e6adb871a3b94$var$gk(c, a, b);
            break;
        } else if (1 === c.tag) {
            var d = c.stateNode;
            if ("function" === typeof c.type.getDerivedStateFromError || "function" === typeof d.componentDidCatch && (null === $0b2e6adb871a3b94$var$Ti || !$0b2e6adb871a3b94$var$Ti.has(d))) {
                a = $0b2e6adb871a3b94$var$Mi(b, a);
                var e = $0b2e6adb871a3b94$var$Si(c, a, 1);
                $0b2e6adb871a3b94$var$Ag(c, e);
                e = $0b2e6adb871a3b94$var$Hg();
                c = $0b2e6adb871a3b94$var$Kj(c, 1);
                if (null !== c) $0b2e6adb871a3b94$var$$c(c, 1, e), $0b2e6adb871a3b94$var$Mj(c, e);
                else if ("function" === typeof d.componentDidCatch && (null === $0b2e6adb871a3b94$var$Ti || !$0b2e6adb871a3b94$var$Ti.has(d))) try {
                    d.componentDidCatch(b, a);
                } catch (f) {}
                break;
            }
        }
        c = c.return;
    }
}
function $0b2e6adb871a3b94$var$Yj(a, b, c) {
    var d = a.pingCache;
    null !== d && d.delete(b);
    b = $0b2e6adb871a3b94$var$Hg();
    a.pingedLanes |= a.suspendedLanes & c;
    $0b2e6adb871a3b94$var$U === a && ($0b2e6adb871a3b94$var$W & c) === c && (4 === $0b2e6adb871a3b94$var$V || 3 === $0b2e6adb871a3b94$var$V && ($0b2e6adb871a3b94$var$W & 62914560) === $0b2e6adb871a3b94$var$W && 500 > $0b2e6adb871a3b94$var$O() - $0b2e6adb871a3b94$var$jj ? $0b2e6adb871a3b94$var$Qj(a, 0) : $0b2e6adb871a3b94$var$uj |= c);
    $0b2e6adb871a3b94$var$Mj(a, b);
}
function $0b2e6adb871a3b94$var$lj(a, b) {
    var c = a.stateNode;
    null !== c && c.delete(b);
    b = 0;
    0 === b && (b = a.mode, 0 === (b & 2) ? b = 1 : 0 === (b & 4) ? b = 99 === $0b2e6adb871a3b94$var$eg() ? 1 : 2 : (0 === $0b2e6adb871a3b94$var$Gj && ($0b2e6adb871a3b94$var$Gj = $0b2e6adb871a3b94$var$tj), b = $0b2e6adb871a3b94$var$Yc(62914560 & ~$0b2e6adb871a3b94$var$Gj), 0 === b && (b = 4194304)));
    c = $0b2e6adb871a3b94$var$Hg();
    a = $0b2e6adb871a3b94$var$Kj(a, b);
    null !== a && ($0b2e6adb871a3b94$var$$c(a, b, c), $0b2e6adb871a3b94$var$Mj(a, c));
}
var $0b2e6adb871a3b94$var$ck;
$0b2e6adb871a3b94$var$ck = function(a, b, c) {
    var d = b.lanes;
    if (null !== a) {
        if (a.memoizedProps !== b.pendingProps || $0b2e6adb871a3b94$var$N.current) $0b2e6adb871a3b94$var$ug = !0;
        else if (0 !== (c & d)) $0b2e6adb871a3b94$var$ug = 0 !== (a.flags & 16384) ? !0 : !1;
        else {
            $0b2e6adb871a3b94$var$ug = !1;
            switch(b.tag){
                case 3:
                    $0b2e6adb871a3b94$var$ri(b);
                    $0b2e6adb871a3b94$var$sh();
                    break;
                case 5:
                    $0b2e6adb871a3b94$var$gh(b);
                    break;
                case 1:
                    $0b2e6adb871a3b94$var$Ff(b.type) && $0b2e6adb871a3b94$var$Jf(b);
                    break;
                case 4:
                    $0b2e6adb871a3b94$var$eh(b, b.stateNode.containerInfo);
                    break;
                case 10:
                    d = b.memoizedProps.value;
                    var e = b.type._context;
                    $0b2e6adb871a3b94$var$I($0b2e6adb871a3b94$var$mg, e._currentValue);
                    e._currentValue = d;
                    break;
                case 13:
                    if (null !== b.memoizedState) {
                        if (0 !== (c & b.child.childLanes)) return $0b2e6adb871a3b94$var$ti(a, b, c);
                        $0b2e6adb871a3b94$var$I($0b2e6adb871a3b94$var$P, $0b2e6adb871a3b94$var$P.current & 1);
                        b = $0b2e6adb871a3b94$var$hi(a, b, c);
                        return null !== b ? b.sibling : null;
                    }
                    $0b2e6adb871a3b94$var$I($0b2e6adb871a3b94$var$P, $0b2e6adb871a3b94$var$P.current & 1);
                    break;
                case 19:
                    d = 0 !== (c & b.childLanes);
                    if (0 !== (a.flags & 64)) {
                        if (d) return $0b2e6adb871a3b94$var$Ai(a, b, c);
                        b.flags |= 64;
                    }
                    e = b.memoizedState;
                    null !== e && (e.rendering = null, e.tail = null, e.lastEffect = null);
                    $0b2e6adb871a3b94$var$I($0b2e6adb871a3b94$var$P, $0b2e6adb871a3b94$var$P.current);
                    if (d) break;
                    else return null;
                case 23:
                case 24:
                    return b.lanes = 0, $0b2e6adb871a3b94$var$mi(a, b, c);
            }
            return $0b2e6adb871a3b94$var$hi(a, b, c);
        }
    } else $0b2e6adb871a3b94$var$ug = !1;
    b.lanes = 0;
    switch(b.tag){
        case 2:
            d = b.type;
            null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2);
            a = b.pendingProps;
            e = $0b2e6adb871a3b94$var$Ef(b, $0b2e6adb871a3b94$var$M.current);
            $0b2e6adb871a3b94$var$tg(b, c);
            e = $0b2e6adb871a3b94$var$Ch(null, b, d, a, e, c);
            b.flags |= 1;
            if ("object" === typeof e && null !== e && "function" === typeof e.render && void 0 === e.$$typeof) {
                b.tag = 1;
                b.memoizedState = null;
                b.updateQueue = null;
                if ($0b2e6adb871a3b94$var$Ff(d)) {
                    var f = !0;
                    $0b2e6adb871a3b94$var$Jf(b);
                } else f = !1;
                b.memoizedState = null !== e.state && void 0 !== e.state ? e.state : null;
                $0b2e6adb871a3b94$var$xg(b);
                var g = d.getDerivedStateFromProps;
                "function" === typeof g && $0b2e6adb871a3b94$var$Gg(b, d, g, a);
                e.updater = $0b2e6adb871a3b94$var$Kg;
                b.stateNode = e;
                e._reactInternals = b;
                $0b2e6adb871a3b94$var$Og(b, d, a, c);
                b = $0b2e6adb871a3b94$var$qi(null, b, d, !0, f, c);
            } else b.tag = 0, $0b2e6adb871a3b94$var$fi(null, b, e, c), b = b.child;
            return b;
        case 16:
            e = b.elementType;
            a: {
                null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2);
                a = b.pendingProps;
                f = e._init;
                e = f(e._payload);
                b.type = e;
                f = b.tag = $0b2e6adb871a3b94$var$hk(e);
                a = $0b2e6adb871a3b94$var$lg(e, a);
                switch(f){
                    case 0:
                        b = $0b2e6adb871a3b94$var$li(null, b, e, a, c);
                        break a;
                    case 1:
                        b = $0b2e6adb871a3b94$var$pi(null, b, e, a, c);
                        break a;
                    case 11:
                        b = $0b2e6adb871a3b94$var$gi(null, b, e, a, c);
                        break a;
                    case 14:
                        b = $0b2e6adb871a3b94$var$ii(null, b, e, $0b2e6adb871a3b94$var$lg(e.type, a), d, c);
                        break a;
                }
                throw Error($0b2e6adb871a3b94$var$y(306, e, ""));
            }
            return b;
        case 0:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $0b2e6adb871a3b94$var$lg(d, e), $0b2e6adb871a3b94$var$li(a, b, d, e, c);
        case 1:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $0b2e6adb871a3b94$var$lg(d, e), $0b2e6adb871a3b94$var$pi(a, b, d, e, c);
        case 3:
            $0b2e6adb871a3b94$var$ri(b);
            d = b.updateQueue;
            if (null === a || null === d) throw Error($0b2e6adb871a3b94$var$y(282));
            d = b.pendingProps;
            e = b.memoizedState;
            e = null !== e ? e.element : null;
            $0b2e6adb871a3b94$var$yg(a, b);
            $0b2e6adb871a3b94$var$Cg(b, d, null, c);
            d = b.memoizedState.element;
            if (d === e) $0b2e6adb871a3b94$var$sh(), b = $0b2e6adb871a3b94$var$hi(a, b, c);
            else {
                e = b.stateNode;
                if (f = e.hydrate) $0b2e6adb871a3b94$var$kh = $0b2e6adb871a3b94$var$rf(b.stateNode.containerInfo.firstChild), $0b2e6adb871a3b94$var$jh = b, f = $0b2e6adb871a3b94$var$lh = !0;
                if (f) {
                    a = e.mutableSourceEagerHydrationData;
                    if (null != a) for(e = 0; e < a.length; e += 2)f = a[e], f._workInProgressVersionPrimary = a[e + 1], $0b2e6adb871a3b94$var$th.push(f);
                    c = $0b2e6adb871a3b94$var$Zg(b, null, d, c);
                    for(b.child = c; c;)c.flags = c.flags & -3 | 1024, c = c.sibling;
                } else $0b2e6adb871a3b94$var$fi(a, b, d, c), $0b2e6adb871a3b94$var$sh();
                b = b.child;
            }
            return b;
        case 5:
            return $0b2e6adb871a3b94$var$gh(b), null === a && $0b2e6adb871a3b94$var$ph(b), d = b.type, e = b.pendingProps, f = null !== a ? a.memoizedProps : null, g = e.children, $0b2e6adb871a3b94$var$nf(d, e) ? g = null : null !== f && $0b2e6adb871a3b94$var$nf(d, f) && (b.flags |= 16), $0b2e6adb871a3b94$var$oi(a, b), $0b2e6adb871a3b94$var$fi(a, b, g, c), b.child;
        case 6:
            return null === a && $0b2e6adb871a3b94$var$ph(b), null;
        case 13:
            return $0b2e6adb871a3b94$var$ti(a, b, c);
        case 4:
            return $0b2e6adb871a3b94$var$eh(b, b.stateNode.containerInfo), d = b.pendingProps, null === a ? b.child = $0b2e6adb871a3b94$var$Yg(b, null, d, c) : $0b2e6adb871a3b94$var$fi(a, b, d, c), b.child;
        case 11:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $0b2e6adb871a3b94$var$lg(d, e), $0b2e6adb871a3b94$var$gi(a, b, d, e, c);
        case 7:
            return $0b2e6adb871a3b94$var$fi(a, b, b.pendingProps, c), b.child;
        case 8:
            return $0b2e6adb871a3b94$var$fi(a, b, b.pendingProps.children, c), b.child;
        case 12:
            return $0b2e6adb871a3b94$var$fi(a, b, b.pendingProps.children, c), b.child;
        case 10:
            a: {
                d = b.type._context;
                e = b.pendingProps;
                g = b.memoizedProps;
                f = e.value;
                var h = b.type._context;
                $0b2e6adb871a3b94$var$I($0b2e6adb871a3b94$var$mg, h._currentValue);
                h._currentValue = f;
                if (null !== g) {
                    if (h = g.value, f = $0b2e6adb871a3b94$var$He(h, f) ? 0 : ("function" === typeof d._calculateChangedBits ? d._calculateChangedBits(h, f) : 1073741823) | 0, 0 === f) {
                        if (g.children === e.children && !$0b2e6adb871a3b94$var$N.current) {
                            b = $0b2e6adb871a3b94$var$hi(a, b, c);
                            break a;
                        }
                    } else for(h = b.child, null !== h && (h.return = b); null !== h;){
                        var k = h.dependencies;
                        if (null !== k) {
                            g = h.child;
                            for(var l = k.firstContext; null !== l;){
                                if (l.context === d && 0 !== (l.observedBits & f)) {
                                    1 === h.tag && (l = $0b2e6adb871a3b94$var$zg(-1, c & -c), l.tag = 2, $0b2e6adb871a3b94$var$Ag(h, l));
                                    h.lanes |= c;
                                    l = h.alternate;
                                    null !== l && (l.lanes |= c);
                                    $0b2e6adb871a3b94$var$sg(h.return, c);
                                    k.lanes |= c;
                                    break;
                                }
                                l = l.next;
                            }
                        } else g = 10 === h.tag ? h.type === b.type ? null : h.child : h.child;
                        if (null !== g) g.return = h;
                        else for(g = h; null !== g;){
                            if (g === b) {
                                g = null;
                                break;
                            }
                            h = g.sibling;
                            if (null !== h) {
                                h.return = g.return;
                                g = h;
                                break;
                            }
                            g = g.return;
                        }
                        h = g;
                    }
                }
                $0b2e6adb871a3b94$var$fi(a, b, e.children, c);
                b = b.child;
            }
            return b;
        case 9:
            return e = b.type, f = b.pendingProps, d = f.children, $0b2e6adb871a3b94$var$tg(b, c), e = $0b2e6adb871a3b94$var$vg(e, f.unstable_observedBits), d = d(e), b.flags |= 1, $0b2e6adb871a3b94$var$fi(a, b, d, c), b.child;
        case 14:
            return e = b.type, f = $0b2e6adb871a3b94$var$lg(e, b.pendingProps), f = $0b2e6adb871a3b94$var$lg(e.type, f), $0b2e6adb871a3b94$var$ii(a, b, e, f, d, c);
        case 15:
            return $0b2e6adb871a3b94$var$ki(a, b, b.type, b.pendingProps, d, c);
        case 17:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $0b2e6adb871a3b94$var$lg(d, e), null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2), b.tag = 1, $0b2e6adb871a3b94$var$Ff(d) ? (a = !0, $0b2e6adb871a3b94$var$Jf(b)) : a = !1, $0b2e6adb871a3b94$var$tg(b, c), $0b2e6adb871a3b94$var$Mg(b, d, e), $0b2e6adb871a3b94$var$Og(b, d, e, c), $0b2e6adb871a3b94$var$qi(null, b, d, !0, a, c);
        case 19:
            return $0b2e6adb871a3b94$var$Ai(a, b, c);
        case 23:
            return $0b2e6adb871a3b94$var$mi(a, b, c);
        case 24:
            return $0b2e6adb871a3b94$var$mi(a, b, c);
    }
    throw Error($0b2e6adb871a3b94$var$y(156, b.tag));
};
function $0b2e6adb871a3b94$var$ik(a, b, c, d) {
    this.tag = a;
    this.key = c;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.ref = null;
    this.pendingProps = b;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = d;
    this.flags = 0;
    this.lastEffect = this.firstEffect = this.nextEffect = null;
    this.childLanes = this.lanes = 0;
    this.alternate = null;
}
function $0b2e6adb871a3b94$var$nh(a, b, c, d) {
    return new $0b2e6adb871a3b94$var$ik(a, b, c, d);
}
function $0b2e6adb871a3b94$var$ji(a) {
    a = a.prototype;
    return !(!a || !a.isReactComponent);
}
function $0b2e6adb871a3b94$var$hk(a) {
    if ("function" === typeof a) return $0b2e6adb871a3b94$var$ji(a) ? 1 : 0;
    if (void 0 !== a && null !== a) {
        a = a.$$typeof;
        if (a === $0b2e6adb871a3b94$var$Aa) return 11;
        if (a === $0b2e6adb871a3b94$var$Da) return 14;
    }
    return 2;
}
function $0b2e6adb871a3b94$var$Tg(a, b) {
    var c = a.alternate;
    null === c ? (c = $0b2e6adb871a3b94$var$nh(a.tag, b, a.key, a.mode), c.elementType = a.elementType, c.type = a.type, c.stateNode = a.stateNode, c.alternate = a, a.alternate = c) : (c.pendingProps = b, c.type = a.type, c.flags = 0, c.nextEffect = null, c.firstEffect = null, c.lastEffect = null);
    c.childLanes = a.childLanes;
    c.lanes = a.lanes;
    c.child = a.child;
    c.memoizedProps = a.memoizedProps;
    c.memoizedState = a.memoizedState;
    c.updateQueue = a.updateQueue;
    b = a.dependencies;
    c.dependencies = null === b ? null : {
        lanes: b.lanes,
        firstContext: b.firstContext
    };
    c.sibling = a.sibling;
    c.index = a.index;
    c.ref = a.ref;
    return c;
}
function $0b2e6adb871a3b94$var$Vg(a, b, c, d, e, f) {
    var g = 2;
    d = a;
    if ("function" === typeof a) $0b2e6adb871a3b94$var$ji(a) && (g = 1);
    else if ("string" === typeof a) g = 5;
    else a: switch(a){
        case $0b2e6adb871a3b94$var$ua:
            return $0b2e6adb871a3b94$var$Xg(c.children, e, f, b);
        case $0b2e6adb871a3b94$var$Ha:
            g = 8;
            e |= 16;
            break;
        case $0b2e6adb871a3b94$var$wa:
            g = 8;
            e |= 1;
            break;
        case $0b2e6adb871a3b94$var$xa:
            return a = $0b2e6adb871a3b94$var$nh(12, c, b, e | 8), a.elementType = $0b2e6adb871a3b94$var$xa, a.type = $0b2e6adb871a3b94$var$xa, a.lanes = f, a;
        case $0b2e6adb871a3b94$var$Ba:
            return a = $0b2e6adb871a3b94$var$nh(13, c, b, e), a.type = $0b2e6adb871a3b94$var$Ba, a.elementType = $0b2e6adb871a3b94$var$Ba, a.lanes = f, a;
        case $0b2e6adb871a3b94$var$Ca:
            return a = $0b2e6adb871a3b94$var$nh(19, c, b, e), a.elementType = $0b2e6adb871a3b94$var$Ca, a.lanes = f, a;
        case $0b2e6adb871a3b94$var$Ia:
            return $0b2e6adb871a3b94$var$vi(c, e, f, b);
        case $0b2e6adb871a3b94$var$Ja:
            return a = $0b2e6adb871a3b94$var$nh(24, c, b, e), a.elementType = $0b2e6adb871a3b94$var$Ja, a.lanes = f, a;
        default:
            if ("object" === typeof a && null !== a) switch(a.$$typeof){
                case $0b2e6adb871a3b94$var$ya:
                    g = 10;
                    break a;
                case $0b2e6adb871a3b94$var$za:
                    g = 9;
                    break a;
                case $0b2e6adb871a3b94$var$Aa:
                    g = 11;
                    break a;
                case $0b2e6adb871a3b94$var$Da:
                    g = 14;
                    break a;
                case $0b2e6adb871a3b94$var$Ea:
                    g = 16;
                    d = null;
                    break a;
                case $0b2e6adb871a3b94$var$Fa:
                    g = 22;
                    break a;
            }
            throw Error($0b2e6adb871a3b94$var$y(130, null == a ? a : typeof a, ""));
    }
    b = $0b2e6adb871a3b94$var$nh(g, c, b, e);
    b.elementType = a;
    b.type = d;
    b.lanes = f;
    return b;
}
function $0b2e6adb871a3b94$var$Xg(a, b, c, d) {
    a = $0b2e6adb871a3b94$var$nh(7, a, d, b);
    a.lanes = c;
    return a;
}
function $0b2e6adb871a3b94$var$vi(a, b, c, d) {
    a = $0b2e6adb871a3b94$var$nh(23, a, d, b);
    a.elementType = $0b2e6adb871a3b94$var$Ia;
    a.lanes = c;
    return a;
}
function $0b2e6adb871a3b94$var$Ug(a, b, c) {
    a = $0b2e6adb871a3b94$var$nh(6, a, null, b);
    a.lanes = c;
    return a;
}
function $0b2e6adb871a3b94$var$Wg(a, b, c) {
    b = $0b2e6adb871a3b94$var$nh(4, null !== a.children ? a.children : [], a.key, b);
    b.lanes = c;
    b.stateNode = {
        containerInfo: a.containerInfo,
        pendingChildren: null,
        implementation: a.implementation
    };
    return b;
}
function $0b2e6adb871a3b94$var$jk(a, b, c) {
    this.tag = b;
    this.containerInfo = a;
    this.finishedWork = this.pingCache = this.current = this.pendingChildren = null;
    this.timeoutHandle = -1;
    this.pendingContext = this.context = null;
    this.hydrate = c;
    this.callbackNode = null;
    this.callbackPriority = 0;
    this.eventTimes = $0b2e6adb871a3b94$var$Zc(0);
    this.expirationTimes = $0b2e6adb871a3b94$var$Zc(-1);
    this.entangledLanes = this.finishedLanes = this.mutableReadLanes = this.expiredLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
    this.entanglements = $0b2e6adb871a3b94$var$Zc(0);
    this.mutableSourceEagerHydrationData = null;
}
function $0b2e6adb871a3b94$var$kk(a, b, c) {
    var d = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: $0b2e6adb871a3b94$var$ta,
        key: null == d ? null : "" + d,
        children: a,
        containerInfo: b,
        implementation: c
    };
}
function $0b2e6adb871a3b94$var$lk(a, b, c, d) {
    var e = b.current, f = $0b2e6adb871a3b94$var$Hg(), g = $0b2e6adb871a3b94$var$Ig(e);
    a: if (c) {
        c = c._reactInternals;
        b: {
            if ($0b2e6adb871a3b94$var$Zb(c) !== c || 1 !== c.tag) throw Error($0b2e6adb871a3b94$var$y(170));
            var h = c;
            do {
                switch(h.tag){
                    case 3:
                        h = h.stateNode.context;
                        break b;
                    case 1:
                        if ($0b2e6adb871a3b94$var$Ff(h.type)) {
                            h = h.stateNode.__reactInternalMemoizedMergedChildContext;
                            break b;
                        }
                }
                h = h.return;
            }while (null !== h);
            throw Error($0b2e6adb871a3b94$var$y(171));
        }
        if (1 === c.tag) {
            var k = c.type;
            if ($0b2e6adb871a3b94$var$Ff(k)) {
                c = $0b2e6adb871a3b94$var$If(c, k, h);
                break a;
            }
        }
        c = h;
    } else c = $0b2e6adb871a3b94$var$Cf;
    null === b.context ? b.context = c : b.pendingContext = c;
    b = $0b2e6adb871a3b94$var$zg(f, g);
    b.payload = {
        element: a
    };
    d = void 0 === d ? null : d;
    null !== d && (b.callback = d);
    $0b2e6adb871a3b94$var$Ag(e, b);
    $0b2e6adb871a3b94$var$Jg(e, g, f);
    return g;
}
function $0b2e6adb871a3b94$var$mk(a) {
    a = a.current;
    if (!a.child) return null;
    switch(a.child.tag){
        case 5:
            return a.child.stateNode;
        default:
            return a.child.stateNode;
    }
}
function $0b2e6adb871a3b94$var$nk(a, b) {
    a = a.memoizedState;
    if (null !== a && null !== a.dehydrated) {
        var c = a.retryLane;
        a.retryLane = 0 !== c && c < b ? c : b;
    }
}
function $0b2e6adb871a3b94$var$ok(a, b) {
    $0b2e6adb871a3b94$var$nk(a, b);
    (a = a.alternate) && $0b2e6adb871a3b94$var$nk(a, b);
}
function $0b2e6adb871a3b94$var$pk() {
    return null;
}
function $0b2e6adb871a3b94$var$qk(a, b, c) {
    var d = null != c && null != c.hydrationOptions && c.hydrationOptions.mutableSources || null;
    c = new $0b2e6adb871a3b94$var$jk(a, b, null != c && !0 === c.hydrate);
    b = $0b2e6adb871a3b94$var$nh(3, null, null, 2 === b ? 7 : 1 === b ? 3 : 0);
    c.current = b;
    b.stateNode = c;
    $0b2e6adb871a3b94$var$xg(b);
    a[$0b2e6adb871a3b94$var$ff] = c.current;
    $0b2e6adb871a3b94$var$cf(8 === a.nodeType ? a.parentNode : a);
    if (d) for(a = 0; a < d.length; a++){
        b = d[a];
        var e = b._getVersion;
        e = e(b._source);
        null == c.mutableSourceEagerHydrationData ? c.mutableSourceEagerHydrationData = [
            b,
            e
        ] : c.mutableSourceEagerHydrationData.push(b, e);
    }
    this._internalRoot = c;
}
$0b2e6adb871a3b94$var$qk.prototype.render = function(a) {
    $0b2e6adb871a3b94$var$lk(a, this._internalRoot, null, null);
};
$0b2e6adb871a3b94$var$qk.prototype.unmount = function() {
    var a = this._internalRoot, b = a.containerInfo;
    $0b2e6adb871a3b94$var$lk(null, a, null, function() {
        b[$0b2e6adb871a3b94$var$ff] = null;
    });
};
function $0b2e6adb871a3b94$var$rk(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType && (8 !== a.nodeType || " react-mount-point-unstable " !== a.nodeValue));
}
function $0b2e6adb871a3b94$var$sk(a, b) {
    b || (b = a ? 9 === a.nodeType ? a.documentElement : a.firstChild : null, b = !(!b || 1 !== b.nodeType || !b.hasAttribute("data-reactroot")));
    if (!b) for(var c; c = a.lastChild;)a.removeChild(c);
    return new $0b2e6adb871a3b94$var$qk(a, 0, b ? {
        hydrate: !0
    } : void 0);
}
function $0b2e6adb871a3b94$var$tk(a, b, c, d, e) {
    var f = c._reactRootContainer;
    if (f) {
        var g = f._internalRoot;
        if ("function" === typeof e) {
            var h = e;
            e = function() {
                var a = $0b2e6adb871a3b94$var$mk(g);
                h.call(a);
            };
        }
        $0b2e6adb871a3b94$var$lk(b, g, a, e);
    } else {
        f = c._reactRootContainer = $0b2e6adb871a3b94$var$sk(c, d);
        g = f._internalRoot;
        if ("function" === typeof e) {
            var k = e;
            e = function() {
                var a = $0b2e6adb871a3b94$var$mk(g);
                k.call(a);
            };
        }
        $0b2e6adb871a3b94$var$Xj(function() {
            $0b2e6adb871a3b94$var$lk(b, g, a, e);
        });
    }
    return $0b2e6adb871a3b94$var$mk(g);
}
$0b2e6adb871a3b94$var$ec = function(a) {
    if (13 === a.tag) {
        var b = $0b2e6adb871a3b94$var$Hg();
        $0b2e6adb871a3b94$var$Jg(a, 4, b);
        $0b2e6adb871a3b94$var$ok(a, 4);
    }
};
$0b2e6adb871a3b94$var$fc = function(a) {
    if (13 === a.tag) {
        var b = $0b2e6adb871a3b94$var$Hg();
        $0b2e6adb871a3b94$var$Jg(a, 67108864, b);
        $0b2e6adb871a3b94$var$ok(a, 67108864);
    }
};
$0b2e6adb871a3b94$var$gc = function(a) {
    if (13 === a.tag) {
        var b = $0b2e6adb871a3b94$var$Hg(), c = $0b2e6adb871a3b94$var$Ig(a);
        $0b2e6adb871a3b94$var$Jg(a, c, b);
        $0b2e6adb871a3b94$var$ok(a, c);
    }
};
$0b2e6adb871a3b94$var$hc = function(a, b) {
    return b();
};
$0b2e6adb871a3b94$var$yb = function(a, b, c) {
    switch(b){
        case "input":
            $0b2e6adb871a3b94$var$ab(a, c);
            b = c.name;
            if ("radio" === c.type && null != b) {
                for(c = a; c.parentNode;)c = c.parentNode;
                c = c.querySelectorAll("input[name=" + JSON.stringify("" + b) + '][type="radio"]');
                for(b = 0; b < c.length; b++){
                    var d = c[b];
                    if (d !== a && d.form === a.form) {
                        var e = $0b2e6adb871a3b94$var$Db(d);
                        if (!e) throw Error($0b2e6adb871a3b94$var$y(90));
                        $0b2e6adb871a3b94$var$Wa(d);
                        $0b2e6adb871a3b94$var$ab(d, e);
                    }
                }
            }
            break;
        case "textarea":
            $0b2e6adb871a3b94$var$ib(a, c);
            break;
        case "select":
            b = c.value, null != b && $0b2e6adb871a3b94$var$fb(a, !!c.multiple, b, !1);
    }
};
$0b2e6adb871a3b94$var$Gb = $0b2e6adb871a3b94$var$Wj;
$0b2e6adb871a3b94$var$Hb = function(a, b, c, d, e) {
    var f = $0b2e6adb871a3b94$var$X;
    $0b2e6adb871a3b94$var$X |= 4;
    try {
        return $0b2e6adb871a3b94$var$gg(98, a.bind(null, b, c, d, e));
    } finally{
        $0b2e6adb871a3b94$var$X = f, 0 === $0b2e6adb871a3b94$var$X && ($0b2e6adb871a3b94$var$wj(), $0b2e6adb871a3b94$var$ig());
    }
};
$0b2e6adb871a3b94$var$Ib = function() {
    0 === ($0b2e6adb871a3b94$var$X & 49) && ($0b2e6adb871a3b94$var$Vj(), $0b2e6adb871a3b94$var$Oj());
};
$0b2e6adb871a3b94$var$Jb = function(a, b) {
    var c = $0b2e6adb871a3b94$var$X;
    $0b2e6adb871a3b94$var$X |= 2;
    try {
        return a(b);
    } finally{
        $0b2e6adb871a3b94$var$X = c, 0 === $0b2e6adb871a3b94$var$X && ($0b2e6adb871a3b94$var$wj(), $0b2e6adb871a3b94$var$ig());
    }
};
function $0b2e6adb871a3b94$var$uk(a, b) {
    var c = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!$0b2e6adb871a3b94$var$rk(b)) throw Error($0b2e6adb871a3b94$var$y(200));
    return $0b2e6adb871a3b94$var$kk(a, b, null, c);
}
var $0b2e6adb871a3b94$var$vk = {
    Events: [
        $0b2e6adb871a3b94$var$Cb,
        $0b2e6adb871a3b94$var$ue,
        $0b2e6adb871a3b94$var$Db,
        $0b2e6adb871a3b94$var$Eb,
        $0b2e6adb871a3b94$var$Fb,
        $0b2e6adb871a3b94$var$Oj,
        {
            current: !1
        }
    ]
}, $0b2e6adb871a3b94$var$wk = {
    findFiberByHostInstance: $0b2e6adb871a3b94$var$wc,
    bundleType: 0,
    version: "17.0.2",
    rendererPackageName: "react-dom"
};
var $0b2e6adb871a3b94$var$xk = {
    bundleType: $0b2e6adb871a3b94$var$wk.bundleType,
    version: $0b2e6adb871a3b94$var$wk.version,
    rendererPackageName: $0b2e6adb871a3b94$var$wk.rendererPackageName,
    rendererConfig: $0b2e6adb871a3b94$var$wk.rendererConfig,
    overrideHookState: null,
    overrideHookStateDeletePath: null,
    overrideHookStateRenamePath: null,
    overrideProps: null,
    overridePropsDeletePath: null,
    overridePropsRenamePath: null,
    setSuspenseHandler: null,
    scheduleUpdate: null,
    currentDispatcherRef: $0b2e6adb871a3b94$var$ra.ReactCurrentDispatcher,
    findHostInstanceByFiber: function(a) {
        a = $0b2e6adb871a3b94$var$cc(a);
        return null === a ? null : a.stateNode;
    },
    findFiberByHostInstance: $0b2e6adb871a3b94$var$wk.findFiberByHostInstance || $0b2e6adb871a3b94$var$pk,
    findHostInstancesForRefresh: null,
    scheduleRefresh: null,
    scheduleRoot: null,
    setRefreshHandler: null,
    getCurrentFiber: null
};
if ("undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
    var $0b2e6adb871a3b94$var$yk = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!$0b2e6adb871a3b94$var$yk.isDisabled && $0b2e6adb871a3b94$var$yk.supportsFiber) try {
        $0b2e6adb871a3b94$var$Lf = $0b2e6adb871a3b94$var$yk.inject($0b2e6adb871a3b94$var$xk), $0b2e6adb871a3b94$var$Mf = $0b2e6adb871a3b94$var$yk;
    } catch (a) {}
}
$0b2e6adb871a3b94$export$ae55be85d98224ed = $0b2e6adb871a3b94$var$vk;
$0b2e6adb871a3b94$export$d39a5bbd09211389 = $0b2e6adb871a3b94$var$uk;
$0b2e6adb871a3b94$export$466bfc07425424d5 = function(a) {
    if (null == a) return null;
    if (1 === a.nodeType) return a;
    var b = a._reactInternals;
    if (void 0 === b) {
        if ("function" === typeof a.render) throw Error($0b2e6adb871a3b94$var$y(188));
        throw Error($0b2e6adb871a3b94$var$y(268, Object.keys(a)));
    }
    a = $0b2e6adb871a3b94$var$cc(b);
    a = null === a ? null : a.stateNode;
    return a;
};
$0b2e6adb871a3b94$export$cd75ccfd720a3cd4 = function(a, b) {
    var c = $0b2e6adb871a3b94$var$X;
    if (0 !== (c & 48)) return a(b);
    $0b2e6adb871a3b94$var$X |= 1;
    try {
        if (a) return $0b2e6adb871a3b94$var$gg(99, a.bind(null, b));
    } finally{
        $0b2e6adb871a3b94$var$X = c, $0b2e6adb871a3b94$var$ig();
    }
};
$0b2e6adb871a3b94$export$fa8d919ba61d84db = function(a, b, c) {
    if (!$0b2e6adb871a3b94$var$rk(b)) throw Error($0b2e6adb871a3b94$var$y(200));
    return $0b2e6adb871a3b94$var$tk(null, a, b, !0, c);
};
$0b2e6adb871a3b94$export$b3890eb0ae9dca99 = function(a, b, c) {
    if (!$0b2e6adb871a3b94$var$rk(b)) throw Error($0b2e6adb871a3b94$var$y(200));
    return $0b2e6adb871a3b94$var$tk(null, a, b, !1, c);
};
$0b2e6adb871a3b94$export$502457920280e6be = function(a) {
    if (!$0b2e6adb871a3b94$var$rk(a)) throw Error($0b2e6adb871a3b94$var$y(40));
    return a._reactRootContainer ? ($0b2e6adb871a3b94$var$Xj(function() {
        $0b2e6adb871a3b94$var$tk(null, null, a, !1, function() {
            a._reactRootContainer = null;
            a[$0b2e6adb871a3b94$var$ff] = null;
        });
    }), !0) : !1;
};
$0b2e6adb871a3b94$export$c78a37762a8d58e1 = $0b2e6adb871a3b94$var$Wj;
$0b2e6adb871a3b94$export$2577ef5d2565d52f = function(a, b) {
    return $0b2e6adb871a3b94$var$uk(a, b, 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null);
};
$0b2e6adb871a3b94$export$dc54d992c10e8a18 = function(a, b, c, d) {
    if (!$0b2e6adb871a3b94$var$rk(c)) throw Error($0b2e6adb871a3b94$var$y(200));
    if (null == a || void 0 === a._reactInternals) throw Error($0b2e6adb871a3b94$var$y(38));
    return $0b2e6adb871a3b94$var$tk(a, b, c, !1, d);
};
$0b2e6adb871a3b94$export$83d89fbfd8236492 = "17.0.2";

});
parcelRequire.register("fO90s", function(module, exports) {
"use strict";

module.exports = (parcelRequire("gcnCG"));

});
parcelRequire.register("gcnCG", function(module, exports) {

$parcel$export(module.exports, "unstable_now", () => $bcb017604639e9d7$export$c4744153514ff05d, (v) => $bcb017604639e9d7$export$c4744153514ff05d = v);
$parcel$export(module.exports, "unstable_shouldYield", () => $bcb017604639e9d7$export$b5836b71941fa3ed, (v) => $bcb017604639e9d7$export$b5836b71941fa3ed = v);
$parcel$export(module.exports, "unstable_forceFrameRate", () => $bcb017604639e9d7$export$d66a1c1c77bd778b, (v) => $bcb017604639e9d7$export$d66a1c1c77bd778b = v);
$parcel$export(module.exports, "unstable_IdlePriority", () => $bcb017604639e9d7$export$3e506c1ccc9cc1a7, (v) => $bcb017604639e9d7$export$3e506c1ccc9cc1a7 = v);
$parcel$export(module.exports, "unstable_ImmediatePriority", () => $bcb017604639e9d7$export$e26fe2ed2fa76875, (v) => $bcb017604639e9d7$export$e26fe2ed2fa76875 = v);
$parcel$export(module.exports, "unstable_LowPriority", () => $bcb017604639e9d7$export$502329bbf4b505b1, (v) => $bcb017604639e9d7$export$502329bbf4b505b1 = v);
$parcel$export(module.exports, "unstable_NormalPriority", () => $bcb017604639e9d7$export$6e3807111c4874c4, (v) => $bcb017604639e9d7$export$6e3807111c4874c4 = v);
$parcel$export(module.exports, "unstable_Profiling", () => $bcb017604639e9d7$export$c27134553091fb3a, (v) => $bcb017604639e9d7$export$c27134553091fb3a = v);
$parcel$export(module.exports, "unstable_UserBlockingPriority", () => $bcb017604639e9d7$export$33ee1acdc04fd2a2, (v) => $bcb017604639e9d7$export$33ee1acdc04fd2a2 = v);
$parcel$export(module.exports, "unstable_cancelCallback", () => $bcb017604639e9d7$export$b00a404bbd5edef2, (v) => $bcb017604639e9d7$export$b00a404bbd5edef2 = v);
$parcel$export(module.exports, "unstable_continueExecution", () => $bcb017604639e9d7$export$8352ce38b91d0c62, (v) => $bcb017604639e9d7$export$8352ce38b91d0c62 = v);
$parcel$export(module.exports, "unstable_getCurrentPriorityLevel", () => $bcb017604639e9d7$export$d3dfb8e4810cb555, (v) => $bcb017604639e9d7$export$d3dfb8e4810cb555 = v);
$parcel$export(module.exports, "unstable_getFirstCallbackNode", () => $bcb017604639e9d7$export$839f9183b0465a69, (v) => $bcb017604639e9d7$export$839f9183b0465a69 = v);
$parcel$export(module.exports, "unstable_next", () => $bcb017604639e9d7$export$72fdf0e06517287b, (v) => $bcb017604639e9d7$export$72fdf0e06517287b = v);
$parcel$export(module.exports, "unstable_pauseExecution", () => $bcb017604639e9d7$export$4b844e58a3e414b4, (v) => $bcb017604639e9d7$export$4b844e58a3e414b4 = v);
$parcel$export(module.exports, "unstable_requestPaint", () => $bcb017604639e9d7$export$816d2913ae6b83b1, (v) => $bcb017604639e9d7$export$816d2913ae6b83b1 = v);
$parcel$export(module.exports, "unstable_runWithPriority", () => $bcb017604639e9d7$export$61bcfe829111a1d0, (v) => $bcb017604639e9d7$export$61bcfe829111a1d0 = v);
$parcel$export(module.exports, "unstable_scheduleCallback", () => $bcb017604639e9d7$export$7ee8c9beb337bc3f, (v) => $bcb017604639e9d7$export$7ee8c9beb337bc3f = v);
$parcel$export(module.exports, "unstable_wrapCallback", () => $bcb017604639e9d7$export$cf845f2c119da08a, (v) => $bcb017604639e9d7$export$cf845f2c119da08a = v);
/** @license React v0.20.2
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $bcb017604639e9d7$export$c4744153514ff05d;
var $bcb017604639e9d7$export$b5836b71941fa3ed;
var $bcb017604639e9d7$export$d66a1c1c77bd778b;
var $bcb017604639e9d7$export$3e506c1ccc9cc1a7;
var $bcb017604639e9d7$export$e26fe2ed2fa76875;
var $bcb017604639e9d7$export$502329bbf4b505b1;
var $bcb017604639e9d7$export$6e3807111c4874c4;
var $bcb017604639e9d7$export$c27134553091fb3a;
var $bcb017604639e9d7$export$33ee1acdc04fd2a2;
var $bcb017604639e9d7$export$b00a404bbd5edef2;
var $bcb017604639e9d7$export$8352ce38b91d0c62;
var $bcb017604639e9d7$export$d3dfb8e4810cb555;
var $bcb017604639e9d7$export$839f9183b0465a69;
var $bcb017604639e9d7$export$72fdf0e06517287b;
var $bcb017604639e9d7$export$4b844e58a3e414b4;
var $bcb017604639e9d7$export$816d2913ae6b83b1;
var $bcb017604639e9d7$export$61bcfe829111a1d0;
var $bcb017604639e9d7$export$7ee8c9beb337bc3f;
var $bcb017604639e9d7$export$cf845f2c119da08a;
"use strict";
var $bcb017604639e9d7$var$f, $bcb017604639e9d7$var$g, $bcb017604639e9d7$var$h, $bcb017604639e9d7$var$k;
if ("object" === typeof performance && "function" === typeof performance.now) {
    var $bcb017604639e9d7$var$l = performance;
    $bcb017604639e9d7$export$c4744153514ff05d = function() {
        return $bcb017604639e9d7$var$l.now();
    };
} else {
    var $bcb017604639e9d7$var$p = Date, $bcb017604639e9d7$var$q = $bcb017604639e9d7$var$p.now();
    $bcb017604639e9d7$export$c4744153514ff05d = function() {
        return $bcb017604639e9d7$var$p.now() - $bcb017604639e9d7$var$q;
    };
}
if ("undefined" === typeof window || "function" !== typeof MessageChannel) {
    var $bcb017604639e9d7$var$t = null, $bcb017604639e9d7$var$u = null, $bcb017604639e9d7$var$w = function() {
        if (null !== $bcb017604639e9d7$var$t) try {
            var a = $bcb017604639e9d7$export$c4744153514ff05d();
            $bcb017604639e9d7$var$t(!0, a);
            $bcb017604639e9d7$var$t = null;
        } catch (b) {
            throw setTimeout($bcb017604639e9d7$var$w, 0), b;
        }
    };
    $bcb017604639e9d7$var$f = function(a) {
        null !== $bcb017604639e9d7$var$t ? setTimeout($bcb017604639e9d7$var$f, 0, a) : ($bcb017604639e9d7$var$t = a, setTimeout($bcb017604639e9d7$var$w, 0));
    };
    $bcb017604639e9d7$var$g = function(a, b) {
        $bcb017604639e9d7$var$u = setTimeout(a, b);
    };
    $bcb017604639e9d7$var$h = function() {
        clearTimeout($bcb017604639e9d7$var$u);
    };
    $bcb017604639e9d7$export$b5836b71941fa3ed = function() {
        return !1;
    };
    $bcb017604639e9d7$var$k = $bcb017604639e9d7$export$d66a1c1c77bd778b = function() {};
} else {
    var $bcb017604639e9d7$var$x = window.setTimeout, $bcb017604639e9d7$var$y = window.clearTimeout;
    if ("undefined" !== typeof console) {
        var $bcb017604639e9d7$var$z = window.cancelAnimationFrame;
        "function" !== typeof window.requestAnimationFrame && console.error("This browser doesn't support requestAnimationFrame. Make sure that you load a polyfill in older browsers. https://reactjs.org/link/react-polyfills");
        "function" !== typeof $bcb017604639e9d7$var$z && console.error("This browser doesn't support cancelAnimationFrame. Make sure that you load a polyfill in older browsers. https://reactjs.org/link/react-polyfills");
    }
    var $bcb017604639e9d7$var$A = !1, $bcb017604639e9d7$var$B = null, $bcb017604639e9d7$var$C = -1, $bcb017604639e9d7$var$D = 5, $bcb017604639e9d7$var$E = 0;
    $bcb017604639e9d7$export$b5836b71941fa3ed = function() {
        return $bcb017604639e9d7$export$c4744153514ff05d() >= $bcb017604639e9d7$var$E;
    };
    $bcb017604639e9d7$var$k = function() {};
    $bcb017604639e9d7$export$d66a1c1c77bd778b = function(a) {
        0 > a || 125 < a ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : $bcb017604639e9d7$var$D = 0 < a ? Math.floor(1E3 / a) : 5;
    };
    var $bcb017604639e9d7$var$F = new MessageChannel, $bcb017604639e9d7$var$G = $bcb017604639e9d7$var$F.port2;
    $bcb017604639e9d7$var$F.port1.onmessage = function() {
        if (null !== $bcb017604639e9d7$var$B) {
            var a = $bcb017604639e9d7$export$c4744153514ff05d();
            $bcb017604639e9d7$var$E = a + $bcb017604639e9d7$var$D;
            try {
                $bcb017604639e9d7$var$B(!0, a) ? $bcb017604639e9d7$var$G.postMessage(null) : ($bcb017604639e9d7$var$A = !1, $bcb017604639e9d7$var$B = null);
            } catch (b) {
                throw $bcb017604639e9d7$var$G.postMessage(null), b;
            }
        } else $bcb017604639e9d7$var$A = !1;
    };
    $bcb017604639e9d7$var$f = function(a) {
        $bcb017604639e9d7$var$B = a;
        $bcb017604639e9d7$var$A || ($bcb017604639e9d7$var$A = !0, $bcb017604639e9d7$var$G.postMessage(null));
    };
    $bcb017604639e9d7$var$g = function(a, b) {
        $bcb017604639e9d7$var$C = $bcb017604639e9d7$var$x(function() {
            a($bcb017604639e9d7$export$c4744153514ff05d());
        }, b);
    };
    $bcb017604639e9d7$var$h = function() {
        $bcb017604639e9d7$var$y($bcb017604639e9d7$var$C);
        $bcb017604639e9d7$var$C = -1;
    };
}
function $bcb017604639e9d7$var$H(a, b) {
    var c = a.length;
    a.push(b);
    a: for(;;){
        var d = c - 1 >>> 1, e = a[d];
        if (void 0 !== e && 0 < $bcb017604639e9d7$var$I(e, b)) a[d] = b, a[c] = e, c = d;
        else break a;
    }
}
function $bcb017604639e9d7$var$J(a) {
    a = a[0];
    return void 0 === a ? null : a;
}
function $bcb017604639e9d7$var$K(a) {
    var b = a[0];
    if (void 0 !== b) {
        var c = a.pop();
        if (c !== b) {
            a[0] = c;
            a: for(var d = 0, e = a.length; d < e;){
                var m = 2 * (d + 1) - 1, n = a[m], v = m + 1, r = a[v];
                if (void 0 !== n && 0 > $bcb017604639e9d7$var$I(n, c)) void 0 !== r && 0 > $bcb017604639e9d7$var$I(r, n) ? (a[d] = r, a[v] = c, d = v) : (a[d] = n, a[m] = c, d = m);
                else if (void 0 !== r && 0 > $bcb017604639e9d7$var$I(r, c)) a[d] = r, a[v] = c, d = v;
                else break a;
            }
        }
        return b;
    }
    return null;
}
function $bcb017604639e9d7$var$I(a, b) {
    var c = a.sortIndex - b.sortIndex;
    return 0 !== c ? c : a.id - b.id;
}
var $bcb017604639e9d7$var$L = [], $bcb017604639e9d7$var$M = [], $bcb017604639e9d7$var$N = 1, $bcb017604639e9d7$var$O = null, $bcb017604639e9d7$var$P = 3, $bcb017604639e9d7$var$Q = !1, $bcb017604639e9d7$var$R = !1, $bcb017604639e9d7$var$S = !1;
function $bcb017604639e9d7$var$T(a) {
    for(var b = $bcb017604639e9d7$var$J($bcb017604639e9d7$var$M); null !== b;){
        if (null === b.callback) $bcb017604639e9d7$var$K($bcb017604639e9d7$var$M);
        else if (b.startTime <= a) $bcb017604639e9d7$var$K($bcb017604639e9d7$var$M), b.sortIndex = b.expirationTime, $bcb017604639e9d7$var$H($bcb017604639e9d7$var$L, b);
        else break;
        b = $bcb017604639e9d7$var$J($bcb017604639e9d7$var$M);
    }
}
function $bcb017604639e9d7$var$U(a) {
    $bcb017604639e9d7$var$S = !1;
    $bcb017604639e9d7$var$T(a);
    if (!$bcb017604639e9d7$var$R) {
        if (null !== $bcb017604639e9d7$var$J($bcb017604639e9d7$var$L)) $bcb017604639e9d7$var$R = !0, $bcb017604639e9d7$var$f($bcb017604639e9d7$var$V);
        else {
            var b = $bcb017604639e9d7$var$J($bcb017604639e9d7$var$M);
            null !== b && $bcb017604639e9d7$var$g($bcb017604639e9d7$var$U, b.startTime - a);
        }
    }
}
function $bcb017604639e9d7$var$V(a, b) {
    $bcb017604639e9d7$var$R = !1;
    $bcb017604639e9d7$var$S && ($bcb017604639e9d7$var$S = !1, $bcb017604639e9d7$var$h());
    $bcb017604639e9d7$var$Q = !0;
    var c = $bcb017604639e9d7$var$P;
    try {
        $bcb017604639e9d7$var$T(b);
        for($bcb017604639e9d7$var$O = $bcb017604639e9d7$var$J($bcb017604639e9d7$var$L); null !== $bcb017604639e9d7$var$O && (!($bcb017604639e9d7$var$O.expirationTime > b) || a && !$bcb017604639e9d7$export$b5836b71941fa3ed());){
            var d = $bcb017604639e9d7$var$O.callback;
            if ("function" === typeof d) {
                $bcb017604639e9d7$var$O.callback = null;
                $bcb017604639e9d7$var$P = $bcb017604639e9d7$var$O.priorityLevel;
                var e = d($bcb017604639e9d7$var$O.expirationTime <= b);
                b = $bcb017604639e9d7$export$c4744153514ff05d();
                "function" === typeof e ? $bcb017604639e9d7$var$O.callback = e : $bcb017604639e9d7$var$O === $bcb017604639e9d7$var$J($bcb017604639e9d7$var$L) && $bcb017604639e9d7$var$K($bcb017604639e9d7$var$L);
                $bcb017604639e9d7$var$T(b);
            } else $bcb017604639e9d7$var$K($bcb017604639e9d7$var$L);
            $bcb017604639e9d7$var$O = $bcb017604639e9d7$var$J($bcb017604639e9d7$var$L);
        }
        if (null !== $bcb017604639e9d7$var$O) var m = !0;
        else {
            var n = $bcb017604639e9d7$var$J($bcb017604639e9d7$var$M);
            null !== n && $bcb017604639e9d7$var$g($bcb017604639e9d7$var$U, n.startTime - b);
            m = !1;
        }
        return m;
    } finally{
        $bcb017604639e9d7$var$O = null, $bcb017604639e9d7$var$P = c, $bcb017604639e9d7$var$Q = !1;
    }
}
var $bcb017604639e9d7$var$W = $bcb017604639e9d7$var$k;
$bcb017604639e9d7$export$3e506c1ccc9cc1a7 = 5;
$bcb017604639e9d7$export$e26fe2ed2fa76875 = 1;
$bcb017604639e9d7$export$502329bbf4b505b1 = 4;
$bcb017604639e9d7$export$6e3807111c4874c4 = 3;
$bcb017604639e9d7$export$c27134553091fb3a = null;
$bcb017604639e9d7$export$33ee1acdc04fd2a2 = 2;
$bcb017604639e9d7$export$b00a404bbd5edef2 = function(a) {
    a.callback = null;
};
$bcb017604639e9d7$export$8352ce38b91d0c62 = function() {
    $bcb017604639e9d7$var$R || $bcb017604639e9d7$var$Q || ($bcb017604639e9d7$var$R = !0, $bcb017604639e9d7$var$f($bcb017604639e9d7$var$V));
};
$bcb017604639e9d7$export$d3dfb8e4810cb555 = function() {
    return $bcb017604639e9d7$var$P;
};
$bcb017604639e9d7$export$839f9183b0465a69 = function() {
    return $bcb017604639e9d7$var$J($bcb017604639e9d7$var$L);
};
$bcb017604639e9d7$export$72fdf0e06517287b = function(a) {
    switch($bcb017604639e9d7$var$P){
        case 1:
        case 2:
        case 3:
            var b = 3;
            break;
        default:
            b = $bcb017604639e9d7$var$P;
    }
    var c = $bcb017604639e9d7$var$P;
    $bcb017604639e9d7$var$P = b;
    try {
        return a();
    } finally{
        $bcb017604639e9d7$var$P = c;
    }
};
$bcb017604639e9d7$export$4b844e58a3e414b4 = function() {};
$bcb017604639e9d7$export$816d2913ae6b83b1 = $bcb017604639e9d7$var$W;
$bcb017604639e9d7$export$61bcfe829111a1d0 = function(a, b) {
    switch(a){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            a = 3;
    }
    var c = $bcb017604639e9d7$var$P;
    $bcb017604639e9d7$var$P = a;
    try {
        return b();
    } finally{
        $bcb017604639e9d7$var$P = c;
    }
};
$bcb017604639e9d7$export$7ee8c9beb337bc3f = function(a, b, c) {
    var d = $bcb017604639e9d7$export$c4744153514ff05d();
    "object" === typeof c && null !== c ? (c = c.delay, c = "number" === typeof c && 0 < c ? d + c : d) : c = d;
    switch(a){
        case 1:
            var e = -1;
            break;
        case 2:
            e = 250;
            break;
        case 5:
            e = 1073741823;
            break;
        case 4:
            e = 1E4;
            break;
        default:
            e = 5E3;
    }
    e = c + e;
    a = {
        id: $bcb017604639e9d7$var$N++,
        callback: b,
        priorityLevel: a,
        startTime: c,
        expirationTime: e,
        sortIndex: -1
    };
    c > d ? (a.sortIndex = c, $bcb017604639e9d7$var$H($bcb017604639e9d7$var$M, a), null === $bcb017604639e9d7$var$J($bcb017604639e9d7$var$L) && a === $bcb017604639e9d7$var$J($bcb017604639e9d7$var$M) && ($bcb017604639e9d7$var$S ? $bcb017604639e9d7$var$h() : $bcb017604639e9d7$var$S = !0, $bcb017604639e9d7$var$g($bcb017604639e9d7$var$U, c - d))) : (a.sortIndex = e, $bcb017604639e9d7$var$H($bcb017604639e9d7$var$L, a), $bcb017604639e9d7$var$R || $bcb017604639e9d7$var$Q || ($bcb017604639e9d7$var$R = !0, $bcb017604639e9d7$var$f($bcb017604639e9d7$var$V)));
    return a;
};
$bcb017604639e9d7$export$cf845f2c119da08a = function(a) {
    var b = $bcb017604639e9d7$var$P;
    return function() {
        var c = $bcb017604639e9d7$var$P;
        $bcb017604639e9d7$var$P = b;
        try {
            return a.apply(this, arguments);
        } finally{
            $bcb017604639e9d7$var$P = c;
        }
    };
};

});



parcelRequire.register("glDqU", function(module, exports) {
/**
 * @license
 * Lodash <https://lodash.com/>
 * Copyright OpenJS Foundation and other contributors <https://openjsf.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */ (function() {
    function n(n, t, r) {
        switch(r.length){
            case 0:
                return n.call(t);
            case 1:
                return n.call(t, r[0]);
            case 2:
                return n.call(t, r[0], r[1]);
            case 3:
                return n.call(t, r[0], r[1], r[2]);
        }
        return n.apply(t, r);
    }
    function t(n, t, r, e) {
        for(var u = -1, i = null == n ? 0 : n.length; ++u < i;){
            var o = n[u];
            t(e, o, r(o), n);
        }
        return e;
    }
    function r(n, t) {
        for(var r = -1, e = null == n ? 0 : n.length; ++r < e && t(n[r], r, n) !== !1;);
        return n;
    }
    function e(n, t) {
        for(var r = null == n ? 0 : n.length; r-- && t(n[r], r, n) !== !1;);
        return n;
    }
    function u(n, t) {
        for(var r = -1, e = null == n ? 0 : n.length; ++r < e;)if (!t(n[r], r, n)) return !1;
        return !0;
    }
    function i(n, t) {
        for(var r = -1, e = null == n ? 0 : n.length, u = 0, i = []; ++r < e;){
            var o = n[r];
            t(o, r, n) && (i[u++] = o);
        }
        return i;
    }
    function o(n, t) {
        return !!(null == n ? 0 : n.length) && y(n, t, 0) > -1;
    }
    function f(n, t, r) {
        for(var e = -1, u = null == n ? 0 : n.length; ++e < u;)if (r(t, n[e])) return !0;
        return !1;
    }
    function c(n, t) {
        for(var r = -1, e = null == n ? 0 : n.length, u = Array(e); ++r < e;)u[r] = t(n[r], r, n);
        return u;
    }
    function a(n, t) {
        for(var r = -1, e = t.length, u = n.length; ++r < e;)n[u + r] = t[r];
        return n;
    }
    function l(n, t, r, e) {
        var u = -1, i = null == n ? 0 : n.length;
        for(e && i && (r = n[++u]); ++u < i;)r = t(r, n[u], u, n);
        return r;
    }
    function s(n, t, r, e) {
        var u = null == n ? 0 : n.length;
        for(e && u && (r = n[--u]); u--;)r = t(r, n[u], u, n);
        return r;
    }
    function h(n, t) {
        for(var r = -1, e = null == n ? 0 : n.length; ++r < e;)if (t(n[r], r, n)) return !0;
        return !1;
    }
    function p(n) {
        return n.split("");
    }
    function _(n) {
        return n.match($t) || [];
    }
    function v(n, t, r) {
        var e;
        return r(n, function(n, r, u) {
            if (t(n, r, u)) return e = r, !1;
        }), e;
    }
    function g(n, t, r, e) {
        for(var u = n.length, i = r + (e ? 1 : -1); e ? i-- : ++i < u;)if (t(n[i], i, n)) return i;
        return -1;
    }
    function y(n, t, r) {
        return t === t ? Z(n, t, r) : g(n, b, r);
    }
    function d(n, t, r, e) {
        for(var u = r - 1, i = n.length; ++u < i;)if (e(n[u], t)) return u;
        return -1;
    }
    function b(n) {
        return n !== n;
    }
    function w(n, t) {
        var r = null == n ? 0 : n.length;
        return r ? k(n, t) / r : Cn;
    }
    function m(n) {
        return function(t) {
            return null == t ? X : t[n];
        };
    }
    function x(n) {
        return function(t) {
            return null == n ? X : n[t];
        };
    }
    function j(n, t, r, e, u) {
        return u(n, function(n, u, i) {
            r = e ? (e = !1, n) : t(r, n, u, i);
        }), r;
    }
    function A(n, t) {
        var r = n.length;
        for(n.sort(t); r--;)n[r] = n[r].value;
        return n;
    }
    function k(n, t) {
        for(var r, e = -1, u = n.length; ++e < u;){
            var i = t(n[e]);
            i !== X && (r = r === X ? i : r + i);
        }
        return r;
    }
    function O(n, t) {
        for(var r = -1, e = Array(n); ++r < n;)e[r] = t(r);
        return e;
    }
    function I(n, t) {
        return c(t, function(t) {
            return [
                t,
                n[t]
            ];
        });
    }
    function R(n) {
        return n ? n.slice(0, H(n) + 1).replace(Lt, "") : n;
    }
    function z(n) {
        return function(t) {
            return n(t);
        };
    }
    function E(n, t) {
        return c(t, function(t) {
            return n[t];
        });
    }
    function S(n, t) {
        return n.has(t);
    }
    function W(n, t) {
        for(var r = -1, e = n.length; ++r < e && y(t, n[r], 0) > -1;);
        return r;
    }
    function L(n, t) {
        for(var r = n.length; r-- && y(t, n[r], 0) > -1;);
        return r;
    }
    function C(n, t) {
        for(var r = n.length, e = 0; r--;)n[r] === t && ++e;
        return e;
    }
    function U(n) {
        return "\\" + Yr[n];
    }
    function B(n, t) {
        return null == n ? X : n[t];
    }
    function T(n) {
        return Nr.test(n);
    }
    function $(n) {
        return Pr.test(n);
    }
    function D(n) {
        for(var t, r = []; !(t = n.next()).done;)r.push(t.value);
        return r;
    }
    function M(n) {
        var t = -1, r = Array(n.size);
        return n.forEach(function(n, e) {
            r[++t] = [
                e,
                n
            ];
        }), r;
    }
    function F(n, t) {
        return function(r) {
            return n(t(r));
        };
    }
    function N(n, t) {
        for(var r = -1, e = n.length, u = 0, i = []; ++r < e;){
            var o = n[r];
            o !== t && o !== cn || (n[r] = cn, i[u++] = r);
        }
        return i;
    }
    function P(n) {
        var t = -1, r = Array(n.size);
        return n.forEach(function(n) {
            r[++t] = n;
        }), r;
    }
    function q(n) {
        var t = -1, r = Array(n.size);
        return n.forEach(function(n) {
            r[++t] = [
                n,
                n
            ];
        }), r;
    }
    function Z(n, t, r) {
        for(var e = r - 1, u = n.length; ++e < u;)if (n[e] === t) return e;
        return -1;
    }
    function K(n, t, r) {
        for(var e = r + 1; e--;)if (n[e] === t) return e;
        return e;
    }
    function V(n) {
        return T(n) ? J(n) : _e(n);
    }
    function G(n) {
        return T(n) ? Y(n) : p(n);
    }
    function H(n) {
        for(var t = n.length; t-- && Ct.test(n.charAt(t)););
        return t;
    }
    function J(n) {
        for(var t = Mr.lastIndex = 0; Mr.test(n);)++t;
        return t;
    }
    function Y(n) {
        return n.match(Mr) || [];
    }
    function Q(n) {
        return n.match(Fr) || [];
    }
    var X, nn = "4.17.21", tn = 200, rn = "Unsupported core-js use. Try https://npms.io/search?q=ponyfill.", en = "Expected a function", un = "Invalid `variable` option passed into `_.template`", on = "__lodash_hash_undefined__", fn = 500, cn = "__lodash_placeholder__", an = 1, ln = 2, sn = 4, hn = 1, pn = 2, _n = 1, vn = 2, gn = 4, yn = 8, dn = 16, bn = 32, wn = 64, mn = 128, xn = 256, jn = 512, An = 30, kn = "...", On = 800, In = 16, Rn = 1, zn = 2, En = 3, Sn = 1 / 0, Wn = 9007199254740991, Ln = 1.7976931348623157e308, Cn = NaN, Un = 4294967295, Bn = Un - 1, Tn = Un >>> 1, $n = [
        [
            "ary",
            mn
        ],
        [
            "bind",
            _n
        ],
        [
            "bindKey",
            vn
        ],
        [
            "curry",
            yn
        ],
        [
            "curryRight",
            dn
        ],
        [
            "flip",
            jn
        ],
        [
            "partial",
            bn
        ],
        [
            "partialRight",
            wn
        ],
        [
            "rearg",
            xn
        ]
    ], Dn = "[object Arguments]", Mn = "[object Array]", Fn = "[object AsyncFunction]", Nn = "[object Boolean]", Pn = "[object Date]", qn = "[object DOMException]", Zn = "[object Error]", Kn = "[object Function]", Vn = "[object GeneratorFunction]", Gn = "[object Map]", Hn = "[object Number]", Jn = "[object Null]", Yn = "[object Object]", Qn = "[object Promise]", Xn = "[object Proxy]", nt = "[object RegExp]", tt = "[object Set]", rt = "[object String]", et = "[object Symbol]", ut = "[object Undefined]", it = "[object WeakMap]", ot = "[object WeakSet]", ft = "[object ArrayBuffer]", ct = "[object DataView]", at = "[object Float32Array]", lt = "[object Float64Array]", st = "[object Int8Array]", ht = "[object Int16Array]", pt = "[object Int32Array]", _t = "[object Uint8Array]", vt = "[object Uint8ClampedArray]", gt = "[object Uint16Array]", yt = "[object Uint32Array]", dt = /\b__p \+= '';/g, bt = /\b(__p \+=) '' \+/g, wt = /(__e\(.*?\)|\b__t\)) \+\n'';/g, mt = /&(?:amp|lt|gt|quot|#39);/g, xt = /[&<>"']/g, jt = RegExp(mt.source), At = RegExp(xt.source), kt = /<%-([\s\S]+?)%>/g, Ot = /<%([\s\S]+?)%>/g, It = /<%=([\s\S]+?)%>/g, Rt = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, zt = /^\w*$/, Et = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g, St = /[\\^$.*+?()[\]{}|]/g, Wt = RegExp(St.source), Lt = /^\s+/, Ct = /\s/, Ut = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/, Bt = /\{\n\/\* \[wrapped with (.+)\] \*/, Tt = /,? & /, $t = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g, Dt = /[()=,{}\[\]\/\s]/, Mt = /\\(\\)?/g, Ft = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g, Nt = /\w*$/, Pt = /^[-+]0x[0-9a-f]+$/i, qt = /^0b[01]+$/i, Zt = /^\[object .+?Constructor\]$/, Kt = /^0o[0-7]+$/i, Vt = /^(?:0|[1-9]\d*)$/, Gt = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g, Ht = /($^)/, Jt = /['\n\r\u2028\u2029\\]/g, Yt = "\ud800-\udfff", Qt = "\\u0300-\\u036f", Xt = "\\ufe20-\\ufe2f", nr = "\\u20d0-\\u20ff", tr = Qt + Xt + nr, rr = "\\u2700-\\u27bf", er = "a-z\\xdf-\\xf6\\xf8-\\xff", ur = "\\xac\\xb1\\xd7\\xf7", ir = "\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf", or = "\\u2000-\\u206f", fr = " \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000", cr = "A-Z\\xc0-\\xd6\\xd8-\\xde", ar = "\\ufe0e\\ufe0f", lr = ur + ir + or + fr, sr = "['’]", hr = "[" + Yt + "]", pr = "[" + lr + "]", _r = "[" + tr + "]", vr = "\\d+", gr = "[" + rr + "]", yr = "[" + er + "]", dr = "[^" + Yt + lr + vr + rr + er + cr + "]", br = "\ud83c[\udffb-\udfff]", wr = "(?:" + _r + "|" + br + ")", mr = "[^" + Yt + "]", xr = "(?:\ud83c[\udde6-\uddff]){2}", jr = "[\ud800-\udbff][\udc00-\udfff]", Ar = "[" + cr + "]", kr = "\\u200d", Or = "(?:" + yr + "|" + dr + ")", Ir = "(?:" + Ar + "|" + dr + ")", Rr = "(?:" + sr + "(?:d|ll|m|re|s|t|ve))?", zr = "(?:" + sr + "(?:D|LL|M|RE|S|T|VE))?", Er = wr + "?", Sr = "[" + ar + "]?", Wr = "(?:" + kr + "(?:" + [
        mr,
        xr,
        jr
    ].join("|") + ")" + Sr + Er + ")*", Lr = "\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])", Cr = "\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])", Ur = Sr + Er + Wr, Br = "(?:" + [
        gr,
        xr,
        jr
    ].join("|") + ")" + Ur, Tr = "(?:" + [
        mr + _r + "?",
        _r,
        xr,
        jr,
        hr
    ].join("|") + ")", $r = RegExp(sr, "g"), Dr = RegExp(_r, "g"), Mr = RegExp(br + "(?=" + br + ")|" + Tr + Ur, "g"), Fr = RegExp([
        Ar + "?" + yr + "+" + Rr + "(?=" + [
            pr,
            Ar,
            "$"
        ].join("|") + ")",
        Ir + "+" + zr + "(?=" + [
            pr,
            Ar + Or,
            "$"
        ].join("|") + ")",
        Ar + "?" + Or + "+" + Rr,
        Ar + "+" + zr,
        Cr,
        Lr,
        vr,
        Br
    ].join("|"), "g"), Nr = RegExp("[" + kr + Yt + tr + ar + "]"), Pr = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/, qr = [
        "Array",
        "Buffer",
        "DataView",
        "Date",
        "Error",
        "Float32Array",
        "Float64Array",
        "Function",
        "Int8Array",
        "Int16Array",
        "Int32Array",
        "Map",
        "Math",
        "Object",
        "Promise",
        "RegExp",
        "Set",
        "String",
        "Symbol",
        "TypeError",
        "Uint8Array",
        "Uint8ClampedArray",
        "Uint16Array",
        "Uint32Array",
        "WeakMap",
        "_",
        "clearTimeout",
        "isFinite",
        "parseInt",
        "setTimeout"
    ], Zr = -1, Kr = {};
    Kr[at] = Kr[lt] = Kr[st] = Kr[ht] = Kr[pt] = Kr[_t] = Kr[vt] = Kr[gt] = Kr[yt] = !0, Kr[Dn] = Kr[Mn] = Kr[ft] = Kr[Nn] = Kr[ct] = Kr[Pn] = Kr[Zn] = Kr[Kn] = Kr[Gn] = Kr[Hn] = Kr[Yn] = Kr[nt] = Kr[tt] = Kr[rt] = Kr[it] = !1;
    var Vr = {};
    Vr[Dn] = Vr[Mn] = Vr[ft] = Vr[ct] = Vr[Nn] = Vr[Pn] = Vr[at] = Vr[lt] = Vr[st] = Vr[ht] = Vr[pt] = Vr[Gn] = Vr[Hn] = Vr[Yn] = Vr[nt] = Vr[tt] = Vr[rt] = Vr[et] = Vr[_t] = Vr[vt] = Vr[gt] = Vr[yt] = !0, Vr[Zn] = Vr[Kn] = Vr[it] = !1;
    var Gr = {
        "\xc0": "A",
        "\xc1": "A",
        "\xc2": "A",
        "\xc3": "A",
        "\xc4": "A",
        "\xc5": "A",
        "\xe0": "a",
        "\xe1": "a",
        "\xe2": "a",
        "\xe3": "a",
        "\xe4": "a",
        "\xe5": "a",
        "\xc7": "C",
        "\xe7": "c",
        "\xd0": "D",
        "\xf0": "d",
        "\xc8": "E",
        "\xc9": "E",
        "\xca": "E",
        "\xcb": "E",
        "\xe8": "e",
        "\xe9": "e",
        "\xea": "e",
        "\xeb": "e",
        "\xcc": "I",
        "\xcd": "I",
        "\xce": "I",
        "\xcf": "I",
        "\xec": "i",
        "\xed": "i",
        "\xee": "i",
        "\xef": "i",
        "\xd1": "N",
        "\xf1": "n",
        "\xd2": "O",
        "\xd3": "O",
        "\xd4": "O",
        "\xd5": "O",
        "\xd6": "O",
        "\xd8": "O",
        "\xf2": "o",
        "\xf3": "o",
        "\xf4": "o",
        "\xf5": "o",
        "\xf6": "o",
        "\xf8": "o",
        "\xd9": "U",
        "\xda": "U",
        "\xdb": "U",
        "\xdc": "U",
        "\xf9": "u",
        "\xfa": "u",
        "\xfb": "u",
        "\xfc": "u",
        "\xdd": "Y",
        "\xfd": "y",
        "\xff": "y",
        "\xc6": "Ae",
        "\xe6": "ae",
        "\xde": "Th",
        "\xfe": "th",
        "\xdf": "ss",
        "Ā": "A",
        "Ă": "A",
        "Ą": "A",
        "ā": "a",
        "ă": "a",
        "ą": "a",
        "Ć": "C",
        "Ĉ": "C",
        "Ċ": "C",
        "Č": "C",
        "ć": "c",
        "ĉ": "c",
        "ċ": "c",
        "č": "c",
        "Ď": "D",
        "Đ": "D",
        "ď": "d",
        "đ": "d",
        "Ē": "E",
        "Ĕ": "E",
        "Ė": "E",
        "Ę": "E",
        "Ě": "E",
        "ē": "e",
        "ĕ": "e",
        "ė": "e",
        "ę": "e",
        "ě": "e",
        "Ĝ": "G",
        "Ğ": "G",
        "Ġ": "G",
        "Ģ": "G",
        "ĝ": "g",
        "ğ": "g",
        "ġ": "g",
        "ģ": "g",
        "Ĥ": "H",
        "Ħ": "H",
        "ĥ": "h",
        "ħ": "h",
        "Ĩ": "I",
        "Ī": "I",
        "Ĭ": "I",
        "Į": "I",
        "İ": "I",
        "ĩ": "i",
        "ī": "i",
        "ĭ": "i",
        "į": "i",
        "ı": "i",
        "Ĵ": "J",
        "ĵ": "j",
        "Ķ": "K",
        "ķ": "k",
        "ĸ": "k",
        "Ĺ": "L",
        "Ļ": "L",
        "Ľ": "L",
        "Ŀ": "L",
        "Ł": "L",
        "ĺ": "l",
        "ļ": "l",
        "ľ": "l",
        "ŀ": "l",
        "ł": "l",
        "Ń": "N",
        "Ņ": "N",
        "Ň": "N",
        "Ŋ": "N",
        "ń": "n",
        "ņ": "n",
        "ň": "n",
        "ŋ": "n",
        "Ō": "O",
        "Ŏ": "O",
        "Ő": "O",
        "ō": "o",
        "ŏ": "o",
        "ő": "o",
        "Ŕ": "R",
        "Ŗ": "R",
        "Ř": "R",
        "ŕ": "r",
        "ŗ": "r",
        "ř": "r",
        "Ś": "S",
        "Ŝ": "S",
        "Ş": "S",
        "Š": "S",
        "ś": "s",
        "ŝ": "s",
        "ş": "s",
        "š": "s",
        "Ţ": "T",
        "Ť": "T",
        "Ŧ": "T",
        "ţ": "t",
        "ť": "t",
        "ŧ": "t",
        "Ũ": "U",
        "Ū": "U",
        "Ŭ": "U",
        "Ů": "U",
        "Ű": "U",
        "Ų": "U",
        "ũ": "u",
        "ū": "u",
        "ŭ": "u",
        "ů": "u",
        "ű": "u",
        "ų": "u",
        "Ŵ": "W",
        "ŵ": "w",
        "Ŷ": "Y",
        "ŷ": "y",
        "Ÿ": "Y",
        "Ź": "Z",
        "Ż": "Z",
        "Ž": "Z",
        "ź": "z",
        "ż": "z",
        "ž": "z",
        "Ĳ": "IJ",
        "ĳ": "ij",
        "Œ": "Oe",
        "œ": "oe",
        "ŉ": "'n",
        "ſ": "s"
    }, Hr = {
        "&": "&amp;",
        "<": "&lt;",
        ">": "&gt;",
        '"': "&quot;",
        "'": "&#39;"
    }, Jr = {
        "&amp;": "&",
        "&lt;": "<",
        "&gt;": ">",
        "&quot;": '"',
        "&#39;": "'"
    }, Yr = {
        "\\": "\\",
        "'": "'",
        "\n": "n",
        "\r": "r",
        "\u2028": "u2028",
        "\u2029": "u2029"
    }, Qr = parseFloat, Xr = parseInt, ne = "object" == typeof $parcel$global && $parcel$global && $parcel$global.Object === Object && $parcel$global, te = "object" == typeof self && self && self.Object === Object && self, re = ne || te || Function("return this")(), ee = exports && !exports.nodeType && exports, ue = ee && true && module && !module.nodeType && module, ie = ue && ue.exports === ee, oe = ie && ne.process, fe = function() {
        try {
            var n = ue && ue.require && ue.require("util").types;
            return n ? n : oe && oe.binding && oe.binding("util");
        } catch (n) {}
    }(), ce = fe && fe.isArrayBuffer, ae = fe && fe.isDate, le = fe && fe.isMap, se = fe && fe.isRegExp, he = fe && fe.isSet, pe = fe && fe.isTypedArray, _e = m("length"), ve = x(Gr), ge = x(Hr), ye = x(Jr), de = function p(x) {
        function Z(n) {
            if (cc(n) && !bh(n) && !(n instanceof Ct)) {
                if (n instanceof Y) return n;
                if (bl.call(n, "__wrapped__")) return eo(n);
            }
            return new Y(n);
        }
        function J() {}
        function Y(n, t) {
            this.__wrapped__ = n, this.__actions__ = [], this.__chain__ = !!t, this.__index__ = 0, this.__values__ = X;
        }
        function Ct(n) {
            this.__wrapped__ = n, this.__actions__ = [], this.__dir__ = 1, this.__filtered__ = !1, this.__iteratees__ = [], this.__takeCount__ = Un, this.__views__ = [];
        }
        function $t() {
            var n = new Ct(this.__wrapped__);
            return n.__actions__ = Tu(this.__actions__), n.__dir__ = this.__dir__, n.__filtered__ = this.__filtered__, n.__iteratees__ = Tu(this.__iteratees__), n.__takeCount__ = this.__takeCount__, n.__views__ = Tu(this.__views__), n;
        }
        function Yt() {
            if (this.__filtered__) {
                var n = new Ct(this);
                n.__dir__ = -1, n.__filtered__ = !0;
            } else n = this.clone(), n.__dir__ *= -1;
            return n;
        }
        function Qt() {
            var n = this.__wrapped__.value(), t = this.__dir__, r = bh(n), e = t < 0, u = r ? n.length : 0, i = Oi(0, u, this.__views__), o = i.start, f = i.end, c = f - o, a = e ? f : o - 1, l = this.__iteratees__, s = l.length, h = 0, p = Hl(c, this.__takeCount__);
            if (!r || !e && u == c && p == c) return wu(n, this.__actions__);
            var _ = [];
            n: for(; c-- && h < p;){
                a += t;
                for(var v = -1, g = n[a]; ++v < s;){
                    var y = l[v], d = y.iteratee, b = y.type, w = d(g);
                    if (b == zn) g = w;
                    else if (!w) {
                        if (b == Rn) continue n;
                        break n;
                    }
                }
                _[h++] = g;
            }
            return _;
        }
        function Xt(n) {
            var t = -1, r = null == n ? 0 : n.length;
            for(this.clear(); ++t < r;){
                var e = n[t];
                this.set(e[0], e[1]);
            }
        }
        function nr() {
            this.__data__ = is ? is(null) : {}, this.size = 0;
        }
        function tr(n) {
            var t = this.has(n) && delete this.__data__[n];
            return this.size -= t ? 1 : 0, t;
        }
        function rr(n) {
            var t = this.__data__;
            if (is) {
                var r = t[n];
                return r === on ? X : r;
            }
            return bl.call(t, n) ? t[n] : X;
        }
        function er(n) {
            var t = this.__data__;
            return is ? t[n] !== X : bl.call(t, n);
        }
        function ur(n, t) {
            var r = this.__data__;
            return this.size += this.has(n) ? 0 : 1, r[n] = is && t === X ? on : t, this;
        }
        function ir(n) {
            var t = -1, r = null == n ? 0 : n.length;
            for(this.clear(); ++t < r;){
                var e = n[t];
                this.set(e[0], e[1]);
            }
        }
        function or() {
            this.__data__ = [], this.size = 0;
        }
        function fr(n) {
            var t = this.__data__, r = Wr(t, n);
            return !(r < 0) && (r == t.length - 1 ? t.pop() : Ll.call(t, r, 1), --this.size, !0);
        }
        function cr(n) {
            var t = this.__data__, r = Wr(t, n);
            return r < 0 ? X : t[r][1];
        }
        function ar(n) {
            return Wr(this.__data__, n) > -1;
        }
        function lr(n, t) {
            var r = this.__data__, e = Wr(r, n);
            return e < 0 ? (++this.size, r.push([
                n,
                t
            ])) : r[e][1] = t, this;
        }
        function sr(n) {
            var t = -1, r = null == n ? 0 : n.length;
            for(this.clear(); ++t < r;){
                var e = n[t];
                this.set(e[0], e[1]);
            }
        }
        function hr() {
            this.size = 0, this.__data__ = {
                hash: new Xt(),
                map: new (ts || ir)(),
                string: new Xt()
            };
        }
        function pr(n) {
            var t = xi(this, n).delete(n);
            return this.size -= t ? 1 : 0, t;
        }
        function _r(n) {
            return xi(this, n).get(n);
        }
        function vr(n) {
            return xi(this, n).has(n);
        }
        function gr(n, t) {
            var r = xi(this, n), e = r.size;
            return r.set(n, t), this.size += r.size == e ? 0 : 1, this;
        }
        function yr(n) {
            var t = -1, r = null == n ? 0 : n.length;
            for(this.__data__ = new sr(); ++t < r;)this.add(n[t]);
        }
        function dr(n) {
            return this.__data__.set(n, on), this;
        }
        function br(n) {
            return this.__data__.has(n);
        }
        function wr(n) {
            this.size = (this.__data__ = new ir(n)).size;
        }
        function mr() {
            this.__data__ = new ir(), this.size = 0;
        }
        function xr(n) {
            var t = this.__data__, r = t.delete(n);
            return this.size = t.size, r;
        }
        function jr(n) {
            return this.__data__.get(n);
        }
        function Ar(n) {
            return this.__data__.has(n);
        }
        function kr(n, t) {
            var r = this.__data__;
            if (r instanceof ir) {
                var e = r.__data__;
                if (!ts || e.length < tn - 1) return e.push([
                    n,
                    t
                ]), this.size = ++r.size, this;
                r = this.__data__ = new sr(e);
            }
            return r.set(n, t), this.size = r.size, this;
        }
        function Or(n, t) {
            var r = bh(n), e = !r && dh(n), u = !r && !e && mh(n), i = !r && !e && !u && Oh(n), o = r || e || u || i, f = o ? O(n.length, hl) : [], c = f.length;
            for(var a in n)!t && !bl.call(n, a) || o && ("length" == a || u && ("offset" == a || "parent" == a) || i && ("buffer" == a || "byteLength" == a || "byteOffset" == a) || Ci(a, c)) || f.push(a);
            return f;
        }
        function Ir(n) {
            var t = n.length;
            return t ? n[tu(0, t - 1)] : X;
        }
        function Rr(n, t) {
            return Xi(Tu(n), Mr(t, 0, n.length));
        }
        function zr(n) {
            return Xi(Tu(n));
        }
        function Er(n, t, r) {
            (r === X || Gf(n[t], r)) && (r !== X || t in n) || Br(n, t, r);
        }
        function Sr(n, t, r) {
            var e = n[t];
            bl.call(n, t) && Gf(e, r) && (r !== X || t in n) || Br(n, t, r);
        }
        function Wr(n, t) {
            for(var r = n.length; r--;)if (Gf(n[r][0], t)) return r;
            return -1;
        }
        function Lr(n, t, r, e) {
            return ys(n, function(n, u, i) {
                t(e, n, r(n), i);
            }), e;
        }
        function Cr(n, t) {
            return n && $u(t, Pc(t), n);
        }
        function Ur(n, t) {
            return n && $u(t, qc(t), n);
        }
        function Br(n, t, r) {
            "__proto__" == t && Tl ? Tl(n, t, {
                configurable: !0,
                enumerable: !0,
                value: r,
                writable: !0
            }) : n[t] = r;
        }
        function Tr(n, t) {
            for(var r = -1, e = t.length, u = il(e), i = null == n; ++r < e;)u[r] = i ? X : Mc(n, t[r]);
            return u;
        }
        function Mr(n, t, r) {
            return n === n && (r !== X && (n = n <= r ? n : r), t !== X && (n = n >= t ? n : t)), n;
        }
        function Fr(n, t, e, u, i, o) {
            var f, c = t & an, a = t & ln, l = t & sn;
            if (e && (f = i ? e(n, u, i, o) : e(n)), f !== X) return f;
            if (!fc(n)) return n;
            var s = bh(n);
            if (s) {
                if (f = zi(n), !c) return Tu(n, f);
            } else {
                var h = zs(n), p = h == Kn || h == Vn;
                if (mh(n)) return Iu(n, c);
                if (h == Yn || h == Dn || p && !i) {
                    if (f = a || p ? {} : Ei(n), !c) return a ? Mu(n, Ur(f, n)) : Du(n, Cr(f, n));
                } else {
                    if (!Vr[h]) return i ? n : {};
                    f = Si(n, h, c);
                }
            }
            o || (o = new wr());
            var _ = o.get(n);
            if (_) return _;
            o.set(n, f), kh(n) ? n.forEach(function(r) {
                f.add(Fr(r, t, e, r, n, o));
            }) : jh(n) && n.forEach(function(r, u) {
                f.set(u, Fr(r, t, e, u, n, o));
            });
            var v = l ? a ? di : yi : a ? qc : Pc, g = s ? X : v(n);
            return r(g || n, function(r, u) {
                g && (u = r, r = n[u]), Sr(f, u, Fr(r, t, e, u, n, o));
            }), f;
        }
        function Nr(n) {
            var t = Pc(n);
            return function(r) {
                return Pr(r, n, t);
            };
        }
        function Pr(n, t, r) {
            var e = r.length;
            if (null == n) return !e;
            for(n = ll(n); e--;){
                var u = r[e], i = t[u], o = n[u];
                if (o === X && !(u in n) || !i(o)) return !1;
            }
            return !0;
        }
        function Gr(n, t, r) {
            if ("function" != typeof n) throw new pl(en);
            return Ws(function() {
                n.apply(X, r);
            }, t);
        }
        function Hr(n, t, r, e) {
            var u = -1, i = o, a = !0, l = n.length, s = [], h = t.length;
            if (!l) return s;
            r && (t = c(t, z(r))), e ? (i = f, a = !1) : t.length >= tn && (i = S, a = !1, t = new yr(t));
            n: for(; ++u < l;){
                var p = n[u], _ = null == r ? p : r(p);
                if (p = e || 0 !== p ? p : 0, a && _ === _) {
                    for(var v = h; v--;)if (t[v] === _) continue n;
                    s.push(p);
                } else i(t, _, e) || s.push(p);
            }
            return s;
        }
        function Jr(n, t) {
            var r = !0;
            return ys(n, function(n, e, u) {
                return r = !!t(n, e, u);
            }), r;
        }
        function Yr(n, t, r) {
            for(var e = -1, u = n.length; ++e < u;){
                var i = n[e], o = t(i);
                if (null != o && (f === X ? o === o && !bc(o) : r(o, f))) var f = o, c = i;
            }
            return c;
        }
        function ne(n, t, r, e) {
            var u = n.length;
            for(r = kc(r), r < 0 && (r = -r > u ? 0 : u + r), e = e === X || e > u ? u : kc(e), e < 0 && (e += u), e = r > e ? 0 : Oc(e); r < e;)n[r++] = t;
            return n;
        }
        function te(n, t) {
            var r = [];
            return ys(n, function(n, e, u) {
                t(n, e, u) && r.push(n);
            }), r;
        }
        function ee(n, t, r, e, u) {
            var i = -1, o = n.length;
            for(r || (r = Li), u || (u = []); ++i < o;){
                var f = n[i];
                t > 0 && r(f) ? t > 1 ? ee(f, t - 1, r, e, u) : a(u, f) : e || (u[u.length] = f);
            }
            return u;
        }
        function ue(n, t) {
            return n && bs(n, t, Pc);
        }
        function oe(n, t) {
            return n && ws(n, t, Pc);
        }
        function fe(n, t) {
            return i(t, function(t) {
                return uc(n[t]);
            });
        }
        function _e(n, t) {
            t = ku(t, n);
            for(var r = 0, e = t.length; null != n && r < e;)n = n[no(t[r++])];
            return r && r == e ? n : X;
        }
        function de(n, t, r) {
            var e = t(n);
            return bh(n) ? e : a(e, r(n));
        }
        function we(n) {
            return null == n ? n === X ? ut : Jn : Bl && Bl in ll(n) ? ki(n) : Ki(n);
        }
        function me(n, t) {
            return n > t;
        }
        function xe(n, t) {
            return null != n && bl.call(n, t);
        }
        function je(n, t) {
            return null != n && t in ll(n);
        }
        function Ae(n, t, r) {
            return n >= Hl(t, r) && n < Gl(t, r);
        }
        function ke(n, t, r) {
            for(var e = r ? f : o, u = n[0].length, i = n.length, a = i, l = il(i), s = 1 / 0, h = []; a--;){
                var p = n[a];
                a && t && (p = c(p, z(t))), s = Hl(p.length, s), l[a] = !r && (t || u >= 120 && p.length >= 120) ? new yr(a && p) : X;
            }
            p = n[0];
            var _ = -1, v = l[0];
            n: for(; ++_ < u && h.length < s;){
                var g = p[_], y = t ? t(g) : g;
                if (g = r || 0 !== g ? g : 0, !(v ? S(v, y) : e(h, y, r))) {
                    for(a = i; --a;){
                        var d = l[a];
                        if (!(d ? S(d, y) : e(n[a], y, r))) continue n;
                    }
                    v && v.push(y), h.push(g);
                }
            }
            return h;
        }
        function Oe(n, t, r, e) {
            return ue(n, function(n, u, i) {
                t(e, r(n), u, i);
            }), e;
        }
        function Ie(t, r, e) {
            r = ku(r, t), t = Gi(t, r);
            var u = null == t ? t : t[no(jo(r))];
            return null == u ? X : n(u, t, e);
        }
        function Re(n) {
            return cc(n) && we(n) == Dn;
        }
        function ze(n) {
            return cc(n) && we(n) == ft;
        }
        function Ee(n) {
            return cc(n) && we(n) == Pn;
        }
        function Se(n, t, r, e, u) {
            return n === t || (null == n || null == t || !cc(n) && !cc(t) ? n !== n && t !== t : We(n, t, r, e, Se, u));
        }
        function We(n, t, r, e, u, i) {
            var o = bh(n), f = bh(t), c = o ? Mn : zs(n), a = f ? Mn : zs(t);
            c = c == Dn ? Yn : c, a = a == Dn ? Yn : a;
            var l = c == Yn, s = a == Yn, h = c == a;
            if (h && mh(n)) {
                if (!mh(t)) return !1;
                o = !0, l = !1;
            }
            if (h && !l) return i || (i = new wr()), o || Oh(n) ? pi(n, t, r, e, u, i) : _i(n, t, c, r, e, u, i);
            if (!(r & hn)) {
                var p = l && bl.call(n, "__wrapped__"), _ = s && bl.call(t, "__wrapped__");
                if (p || _) {
                    var v = p ? n.value() : n, g = _ ? t.value() : t;
                    return i || (i = new wr()), u(v, g, r, e, i);
                }
            }
            return !!h && (i || (i = new wr()), vi(n, t, r, e, u, i));
        }
        function Le(n) {
            return cc(n) && zs(n) == Gn;
        }
        function Ce(n, t, r, e) {
            var u = r.length, i = u, o = !e;
            if (null == n) return !i;
            for(n = ll(n); u--;){
                var f = r[u];
                if (o && f[2] ? f[1] !== n[f[0]] : !(f[0] in n)) return !1;
            }
            for(; ++u < i;){
                f = r[u];
                var c = f[0], a = n[c], l = f[1];
                if (o && f[2]) {
                    if (a === X && !(c in n)) return !1;
                } else {
                    var s = new wr();
                    if (e) var h = e(a, l, c, n, t, s);
                    if (!(h === X ? Se(l, a, hn | pn, e, s) : h)) return !1;
                }
            }
            return !0;
        }
        function Ue(n) {
            return !(!fc(n) || Di(n)) && (uc(n) ? kl : Zt).test(to(n));
        }
        function Be(n) {
            return cc(n) && we(n) == nt;
        }
        function Te(n) {
            return cc(n) && zs(n) == tt;
        }
        function $e(n) {
            return cc(n) && oc(n.length) && !!Kr[we(n)];
        }
        function De(n) {
            return "function" == typeof n ? n : null == n ? La : "object" == typeof n ? bh(n) ? Ze(n[0], n[1]) : qe(n) : Fa(n);
        }
        function Me(n) {
            if (!Mi(n)) return Vl(n);
            var t = [];
            for(var r in ll(n))bl.call(n, r) && "constructor" != r && t.push(r);
            return t;
        }
        function Fe(n) {
            if (!fc(n)) return Zi(n);
            var t = Mi(n), r = [];
            for(var e in n)("constructor" != e || !t && bl.call(n, e)) && r.push(e);
            return r;
        }
        function Ne(n, t) {
            return n < t;
        }
        function Pe(n, t) {
            var r = -1, e = Hf(n) ? il(n.length) : [];
            return ys(n, function(n, u, i) {
                e[++r] = t(n, u, i);
            }), e;
        }
        function qe(n) {
            var t = ji(n);
            return 1 == t.length && t[0][2] ? Ni(t[0][0], t[0][1]) : function(r) {
                return r === n || Ce(r, n, t);
            };
        }
        function Ze(n, t) {
            return Bi(n) && Fi(t) ? Ni(no(n), t) : function(r) {
                var e = Mc(r, n);
                return e === X && e === t ? Nc(r, n) : Se(t, e, hn | pn);
            };
        }
        function Ke(n, t, r, e, u) {
            n !== t && bs(t, function(i, o) {
                if (u || (u = new wr()), fc(i)) Ve(n, t, o, r, Ke, e, u);
                else {
                    var f = e ? e(Ji(n, o), i, o + "", n, t, u) : X;
                    f === X && (f = i), Er(n, o, f);
                }
            }, qc);
        }
        function Ve(n, t, r, e, u, i, o) {
            var f = Ji(n, r), c = Ji(t, r), a = o.get(c);
            if (a) return Er(n, r, a), X;
            var l = i ? i(f, c, r + "", n, t, o) : X, s = l === X;
            if (s) {
                var h = bh(c), p = !h && mh(c), _ = !h && !p && Oh(c);
                l = c, h || p || _ ? bh(f) ? l = f : Jf(f) ? l = Tu(f) : p ? (s = !1, l = Iu(c, !0)) : _ ? (s = !1, l = Wu(c, !0)) : l = [] : gc(c) || dh(c) ? (l = f, dh(f) ? l = Rc(f) : fc(f) && !uc(f) || (l = Ei(c))) : s = !1;
            }
            s && (o.set(c, l), u(l, c, e, i, o), o.delete(c)), Er(n, r, l);
        }
        function Ge(n, t) {
            var r = n.length;
            if (r) return t += t < 0 ? r : 0, Ci(t, r) ? n[t] : X;
        }
        function He(n, t, r) {
            t = t.length ? c(t, function(n) {
                return bh(n) ? function(t) {
                    return _e(t, 1 === n.length ? n[0] : n);
                } : n;
            }) : [
                La
            ];
            var e = -1;
            return t = c(t, z(mi())), A(Pe(n, function(n, r, u) {
                return {
                    criteria: c(t, function(t) {
                        return t(n);
                    }),
                    index: ++e,
                    value: n
                };
            }), function(n, t) {
                return Cu(n, t, r);
            });
        }
        function Je(n, t) {
            return Ye(n, t, function(t, r) {
                return Nc(n, r);
            });
        }
        function Ye(n, t, r) {
            for(var e = -1, u = t.length, i = {}; ++e < u;){
                var o = t[e], f = _e(n, o);
                r(f, o) && fu(i, ku(o, n), f);
            }
            return i;
        }
        function Qe(n) {
            return function(t) {
                return _e(t, n);
            };
        }
        function Xe(n, t, r, e) {
            var u = e ? d : y, i = -1, o = t.length, f = n;
            for(n === t && (t = Tu(t)), r && (f = c(n, z(r))); ++i < o;)for(var a = 0, l = t[i], s = r ? r(l) : l; (a = u(f, s, a, e)) > -1;)f !== n && Ll.call(f, a, 1), Ll.call(n, a, 1);
            return n;
        }
        function nu(n, t) {
            for(var r = n ? t.length : 0, e = r - 1; r--;){
                var u = t[r];
                if (r == e || u !== i) {
                    var i = u;
                    Ci(u) ? Ll.call(n, u, 1) : yu(n, u);
                }
            }
            return n;
        }
        function tu(n, t) {
            return n + Nl(Ql() * (t - n + 1));
        }
        function ru(n, t, r, e) {
            for(var u = -1, i = Gl(Fl((t - n) / (r || 1)), 0), o = il(i); i--;)o[e ? i : ++u] = n, n += r;
            return o;
        }
        function eu(n, t) {
            var r = "";
            if (!n || t < 1 || t > Wn) return r;
            do t % 2 && (r += n), t = Nl(t / 2), t && (n += n);
            while (t);
            return r;
        }
        function uu(n, t) {
            return Ls(Vi(n, t, La), n + "");
        }
        function iu(n) {
            return Ir(ra(n));
        }
        function ou(n, t) {
            var r = ra(n);
            return Xi(r, Mr(t, 0, r.length));
        }
        function fu(n, t, r, e) {
            if (!fc(n)) return n;
            t = ku(t, n);
            for(var u = -1, i = t.length, o = i - 1, f = n; null != f && ++u < i;){
                var c = no(t[u]), a = r;
                if ("__proto__" === c || "constructor" === c || "prototype" === c) return n;
                if (u != o) {
                    var l = f[c];
                    a = e ? e(l, c, f) : X, a === X && (a = fc(l) ? l : Ci(t[u + 1]) ? [] : {});
                }
                Sr(f, c, a), f = f[c];
            }
            return n;
        }
        function cu(n) {
            return Xi(ra(n));
        }
        function au(n, t, r) {
            var e = -1, u = n.length;
            t < 0 && (t = -t > u ? 0 : u + t), r = r > u ? u : r, r < 0 && (r += u), u = t > r ? 0 : r - t >>> 0, t >>>= 0;
            for(var i = il(u); ++e < u;)i[e] = n[e + t];
            return i;
        }
        function lu(n, t) {
            var r;
            return ys(n, function(n, e, u) {
                return r = t(n, e, u), !r;
            }), !!r;
        }
        function su(n, t, r) {
            var e = 0, u = null == n ? e : n.length;
            if ("number" == typeof t && t === t && u <= Tn) {
                for(; e < u;){
                    var i = e + u >>> 1, o = n[i];
                    null !== o && !bc(o) && (r ? o <= t : o < t) ? e = i + 1 : u = i;
                }
                return u;
            }
            return hu(n, t, La, r);
        }
        function hu(n, t, r, e) {
            var u = 0, i = null == n ? 0 : n.length;
            if (0 === i) return 0;
            t = r(t);
            for(var o = t !== t, f = null === t, c = bc(t), a = t === X; u < i;){
                var l = Nl((u + i) / 2), s = r(n[l]), h = s !== X, p = null === s, _ = s === s, v = bc(s);
                if (o) var g = e || _;
                else g = a ? _ && (e || h) : f ? _ && h && (e || !p) : c ? _ && h && !p && (e || !v) : !p && !v && (e ? s <= t : s < t);
                g ? u = l + 1 : i = l;
            }
            return Hl(i, Bn);
        }
        function pu(n, t) {
            for(var r = -1, e = n.length, u = 0, i = []; ++r < e;){
                var o = n[r], f = t ? t(o) : o;
                if (!r || !Gf(f, c)) {
                    var c = f;
                    i[u++] = 0 === o ? 0 : o;
                }
            }
            return i;
        }
        function _u(n) {
            return "number" == typeof n ? n : bc(n) ? Cn : +n;
        }
        function vu(n) {
            if ("string" == typeof n) return n;
            if (bh(n)) return c(n, vu) + "";
            if (bc(n)) return vs ? vs.call(n) : "";
            var t = n + "";
            return "0" == t && 1 / n == -Sn ? "-0" : t;
        }
        function gu(n, t, r) {
            var e = -1, u = o, i = n.length, c = !0, a = [], l = a;
            if (r) c = !1, u = f;
            else if (i >= tn) {
                var s = t ? null : ks(n);
                if (s) return P(s);
                c = !1, u = S, l = new yr();
            } else l = t ? [] : a;
            n: for(; ++e < i;){
                var h = n[e], p = t ? t(h) : h;
                if (h = r || 0 !== h ? h : 0, c && p === p) {
                    for(var _ = l.length; _--;)if (l[_] === p) continue n;
                    t && l.push(p), a.push(h);
                } else u(l, p, r) || (l !== a && l.push(p), a.push(h));
            }
            return a;
        }
        function yu(n, t) {
            return t = ku(t, n), n = Gi(n, t), null == n || delete n[no(jo(t))];
        }
        function du(n, t, r, e) {
            return fu(n, t, r(_e(n, t)), e);
        }
        function bu(n, t, r, e) {
            for(var u = n.length, i = e ? u : -1; (e ? i-- : ++i < u) && t(n[i], i, n););
            return r ? au(n, e ? 0 : i, e ? i + 1 : u) : au(n, e ? i + 1 : 0, e ? u : i);
        }
        function wu(n, t) {
            var r = n;
            return r instanceof Ct && (r = r.value()), l(t, function(n, t) {
                return t.func.apply(t.thisArg, a([
                    n
                ], t.args));
            }, r);
        }
        function mu(n, t, r) {
            var e = n.length;
            if (e < 2) return e ? gu(n[0]) : [];
            for(var u = -1, i = il(e); ++u < e;)for(var o = n[u], f = -1; ++f < e;)f != u && (i[u] = Hr(i[u] || o, n[f], t, r));
            return gu(ee(i, 1), t, r);
        }
        function xu(n, t, r) {
            for(var e = -1, u = n.length, i = t.length, o = {}; ++e < u;)r(o, n[e], e < i ? t[e] : X);
            return o;
        }
        function ju(n) {
            return Jf(n) ? n : [];
        }
        function Au(n) {
            return "function" == typeof n ? n : La;
        }
        function ku(n, t) {
            return bh(n) ? n : Bi(n, t) ? [
                n
            ] : Cs(Ec(n));
        }
        function Ou(n, t, r) {
            var e = n.length;
            return r = r === X ? e : r, !t && r >= e ? n : au(n, t, r);
        }
        function Iu(n, t) {
            if (t) return n.slice();
            var r = n.length, e = zl ? zl(r) : new n.constructor(r);
            return n.copy(e), e;
        }
        function Ru(n) {
            var t = new n.constructor(n.byteLength);
            return new Rl(t).set(new Rl(n)), t;
        }
        function zu(n, t) {
            return new n.constructor(t ? Ru(n.buffer) : n.buffer, n.byteOffset, n.byteLength);
        }
        function Eu(n) {
            var t = new n.constructor(n.source, Nt.exec(n));
            return t.lastIndex = n.lastIndex, t;
        }
        function Su(n) {
            return _s ? ll(_s.call(n)) : {};
        }
        function Wu(n, t) {
            return new n.constructor(t ? Ru(n.buffer) : n.buffer, n.byteOffset, n.length);
        }
        function Lu(n, t) {
            if (n !== t) {
                var r = n !== X, e = null === n, u = n === n, i = bc(n), o = t !== X, f = null === t, c = t === t, a = bc(t);
                if (!f && !a && !i && n > t || i && o && c && !f && !a || e && o && c || !r && c || !u) return 1;
                if (!e && !i && !a && n < t || a && r && u && !e && !i || f && r && u || !o && u || !c) return -1;
            }
            return 0;
        }
        function Cu(n, t, r) {
            for(var e = -1, u = n.criteria, i = t.criteria, o = u.length, f = r.length; ++e < o;){
                var c = Lu(u[e], i[e]);
                if (c) {
                    if (e >= f) return c;
                    return c * ("desc" == r[e] ? -1 : 1);
                }
            }
            return n.index - t.index;
        }
        function Uu(n, t, r, e) {
            for(var u = -1, i = n.length, o = r.length, f = -1, c = t.length, a = Gl(i - o, 0), l = il(c + a), s = !e; ++f < c;)l[f] = t[f];
            for(; ++u < o;)(s || u < i) && (l[r[u]] = n[u]);
            for(; a--;)l[f++] = n[u++];
            return l;
        }
        function Bu(n, t, r, e) {
            for(var u = -1, i = n.length, o = -1, f = r.length, c = -1, a = t.length, l = Gl(i - f, 0), s = il(l + a), h = !e; ++u < l;)s[u] = n[u];
            for(var p = u; ++c < a;)s[p + c] = t[c];
            for(; ++o < f;)(h || u < i) && (s[p + r[o]] = n[u++]);
            return s;
        }
        function Tu(n, t) {
            var r = -1, e = n.length;
            for(t || (t = il(e)); ++r < e;)t[r] = n[r];
            return t;
        }
        function $u(n, t, r, e) {
            var u = !r;
            r || (r = {});
            for(var i = -1, o = t.length; ++i < o;){
                var f = t[i], c = e ? e(r[f], n[f], f, r, n) : X;
                c === X && (c = n[f]), u ? Br(r, f, c) : Sr(r, f, c);
            }
            return r;
        }
        function Du(n, t) {
            return $u(n, Is(n), t);
        }
        function Mu(n, t) {
            return $u(n, Rs(n), t);
        }
        function Fu(n, r) {
            return function(e, u) {
                var i = bh(e) ? t : Lr, o = r ? r() : {};
                return i(e, n, mi(u, 2), o);
            };
        }
        function Nu(n) {
            return uu(function(t, r) {
                var e = -1, u = r.length, i = u > 1 ? r[u - 1] : X, o = u > 2 ? r[2] : X;
                for(i = n.length > 3 && "function" == typeof i ? (u--, i) : X, o && Ui(r[0], r[1], o) && (i = u < 3 ? X : i, u = 1), t = ll(t); ++e < u;){
                    var f = r[e];
                    f && n(t, f, e, i);
                }
                return t;
            });
        }
        function Pu(n, t) {
            return function(r, e) {
                if (null == r) return r;
                if (!Hf(r)) return n(r, e);
                for(var u = r.length, i = t ? u : -1, o = ll(r); (t ? i-- : ++i < u) && e(o[i], i, o) !== !1;);
                return r;
            };
        }
        function qu(n) {
            return function(t, r, e) {
                for(var u = -1, i = ll(t), o = e(t), f = o.length; f--;){
                    var c = o[n ? f : ++u];
                    if (r(i[c], c, i) === !1) break;
                }
                return t;
            };
        }
        function Zu(n, t, r) {
            function e() {
                return (this && this !== re && this instanceof e ? i : n).apply(u ? r : this, arguments);
            }
            var u = t & _n, i = Gu(n);
            return e;
        }
        function Ku(n) {
            return function(t) {
                t = Ec(t);
                var r = T(t) ? G(t) : X, e = r ? r[0] : t.charAt(0), u = r ? Ou(r, 1).join("") : t.slice(1);
                return e[n]() + u;
            };
        }
        function Vu(n) {
            return function(t) {
                return l(Ra(ca(t).replace($r, "")), n, "");
            };
        }
        function Gu(n) {
            return function() {
                var t = arguments;
                switch(t.length){
                    case 0:
                        return new n();
                    case 1:
                        return new n(t[0]);
                    case 2:
                        return new n(t[0], t[1]);
                    case 3:
                        return new n(t[0], t[1], t[2]);
                    case 4:
                        return new n(t[0], t[1], t[2], t[3]);
                    case 5:
                        return new n(t[0], t[1], t[2], t[3], t[4]);
                    case 6:
                        return new n(t[0], t[1], t[2], t[3], t[4], t[5]);
                    case 7:
                        return new n(t[0], t[1], t[2], t[3], t[4], t[5], t[6]);
                }
                var r = gs(n.prototype), e = n.apply(r, t);
                return fc(e) ? e : r;
            };
        }
        function Hu(t, r, e) {
            function u() {
                for(var o = arguments.length, f = il(o), c = o, a = wi(u); c--;)f[c] = arguments[c];
                var l = o < 3 && f[0] !== a && f[o - 1] !== a ? [] : N(f, a);
                return o -= l.length, o < e ? oi(t, r, Qu, u.placeholder, X, f, l, X, X, e - o) : n(this && this !== re && this instanceof u ? i : t, this, f);
            }
            var i = Gu(t);
            return u;
        }
        function Ju(n) {
            return function(t, r, e) {
                var u = ll(t);
                if (!Hf(t)) {
                    var i = mi(r, 3);
                    t = Pc(t), r = function(n) {
                        return i(u[n], n, u);
                    };
                }
                var o = n(t, r, e);
                return o > -1 ? u[i ? t[o] : o] : X;
            };
        }
        function Yu(n) {
            return gi(function(t) {
                var r = t.length, e = r, u = Y.prototype.thru;
                for(n && t.reverse(); e--;){
                    var i = t[e];
                    if ("function" != typeof i) throw new pl(en);
                    if (u && !o && "wrapper" == bi(i)) var o = new Y([], !0);
                }
                for(e = o ? e : r; ++e < r;){
                    i = t[e];
                    var f = bi(i), c = "wrapper" == f ? Os(i) : X;
                    o = c && $i(c[0]) && c[1] == (mn | yn | bn | xn) && !c[4].length && 1 == c[9] ? o[bi(c[0])].apply(o, c[3]) : 1 == i.length && $i(i) ? o[f]() : o.thru(i);
                }
                return function() {
                    var n = arguments, e = n[0];
                    if (o && 1 == n.length && bh(e)) return o.plant(e).value();
                    for(var u = 0, i = r ? t[u].apply(this, n) : e; ++u < r;)i = t[u].call(this, i);
                    return i;
                };
            });
        }
        function Qu(n, t, r, e, u, i, o, f, c, a) {
            function l() {
                for(var y = arguments.length, d = il(y), b = y; b--;)d[b] = arguments[b];
                if (_) var w = wi(l), m = C(d, w);
                if (e && (d = Uu(d, e, u, _)), i && (d = Bu(d, i, o, _)), y -= m, _ && y < a) return oi(n, t, Qu, l.placeholder, r, d, N(d, w), f, c, a - y);
                var x = h ? r : this, j = p ? x[n] : n;
                return y = d.length, f ? d = Hi(d, f) : v && y > 1 && d.reverse(), s && c < y && (d.length = c), this && this !== re && this instanceof l && (j = g || Gu(j)), j.apply(x, d);
            }
            var s = t & mn, h = t & _n, p = t & vn, _ = t & (yn | dn), v = t & jn, g = p ? X : Gu(n);
            return l;
        }
        function Xu(n, t) {
            return function(r, e) {
                return Oe(r, n, t(e), {});
            };
        }
        function ni(n, t) {
            return function(r, e) {
                var u;
                if (r === X && e === X) return t;
                if (r !== X && (u = r), e !== X) {
                    if (u === X) return e;
                    "string" == typeof r || "string" == typeof e ? (r = vu(r), e = vu(e)) : (r = _u(r), e = _u(e)), u = n(r, e);
                }
                return u;
            };
        }
        function ti(t) {
            return gi(function(r) {
                return r = c(r, z(mi())), uu(function(e) {
                    var u = this;
                    return t(r, function(t) {
                        return n(t, u, e);
                    });
                });
            });
        }
        function ri(n, t) {
            t = t === X ? " " : vu(t);
            var r = t.length;
            if (r < 2) return r ? eu(t, n) : t;
            var e = eu(t, Fl(n / V(t)));
            return T(t) ? Ou(G(e), 0, n).join("") : e.slice(0, n);
        }
        function ei(t, r, e, u) {
            function i() {
                for(var r = -1, c = arguments.length, a = -1, l = u.length, s = il(l + c), h = this && this !== re && this instanceof i ? f : t; ++a < l;)s[a] = u[a];
                for(; c--;)s[a++] = arguments[++r];
                return n(h, o ? e : this, s);
            }
            var o = r & _n, f = Gu(t);
            return i;
        }
        function ui(n) {
            return function(t, r, e) {
                return e && "number" != typeof e && Ui(t, r, e) && (r = e = X), t = Ac(t), r === X ? (r = t, t = 0) : r = Ac(r), e = e === X ? t < r ? 1 : -1 : Ac(e), ru(t, r, e, n);
            };
        }
        function ii(n) {
            return function(t, r) {
                return "string" == typeof t && "string" == typeof r || (t = Ic(t), r = Ic(r)), n(t, r);
            };
        }
        function oi(n, t, r, e, u, i, o, f, c, a) {
            var l = t & yn, s = l ? o : X, h = l ? X : o, p = l ? i : X, _ = l ? X : i;
            t |= l ? bn : wn, t &= ~(l ? wn : bn), t & gn || (t &= ~(_n | vn));
            var v = [
                n,
                t,
                u,
                p,
                s,
                _,
                h,
                f,
                c,
                a
            ], g = r.apply(X, v);
            return $i(n) && Ss(g, v), g.placeholder = e, Yi(g, n, t);
        }
        function fi(n) {
            var t = al[n];
            return function(n, r) {
                if (n = Ic(n), r = null == r ? 0 : Hl(kc(r), 292), r && Zl(n)) {
                    var e = (Ec(n) + "e").split("e");
                    return e = (Ec(t(e[0] + "e" + (+e[1] + r))) + "e").split("e"), +(e[0] + "e" + (+e[1] - r));
                }
                return t(n);
            };
        }
        function ci(n) {
            return function(t) {
                var r = zs(t);
                return r == Gn ? M(t) : r == tt ? q(t) : I(t, n(t));
            };
        }
        function ai(n, t, r, e, u, i, o, f) {
            var c = t & vn;
            if (!c && "function" != typeof n) throw new pl(en);
            var a = e ? e.length : 0;
            if (a || (t &= ~(bn | wn), e = u = X), o = o === X ? o : Gl(kc(o), 0), f = f === X ? f : kc(f), a -= u ? u.length : 0, t & wn) {
                var l = e, s = u;
                e = u = X;
            }
            var h = c ? X : Os(n), p = [
                n,
                t,
                r,
                e,
                u,
                l,
                s,
                i,
                o,
                f
            ];
            if (h && qi(p, h), n = p[0], t = p[1], r = p[2], e = p[3], u = p[4], f = p[9] = p[9] === X ? c ? 0 : n.length : Gl(p[9] - a, 0), !f && t & (yn | dn) && (t &= ~(yn | dn)), t && t != _n) _ = t == yn || t == dn ? Hu(n, t, f) : t != bn && t != (_n | bn) || u.length ? Qu.apply(X, p) : ei(n, t, r, e);
            else var _ = Zu(n, t, r);
            return Yi((h ? ms : Ss)(_, p), n, t);
        }
        function li(n, t, r, e) {
            return n === X || Gf(n, gl[r]) && !bl.call(e, r) ? t : n;
        }
        function si(n, t, r, e, u, i) {
            return fc(n) && fc(t) && (i.set(t, n), Ke(n, t, X, si, i), i.delete(t)), n;
        }
        function hi(n) {
            return gc(n) ? X : n;
        }
        function pi(n, t, r, e, u, i) {
            var o = r & hn, f = n.length, c = t.length;
            if (f != c && !(o && c > f)) return !1;
            var a = i.get(n), l = i.get(t);
            if (a && l) return a == t && l == n;
            var s = -1, p = !0, _ = r & pn ? new yr() : X;
            for(i.set(n, t), i.set(t, n); ++s < f;){
                var v = n[s], g = t[s];
                if (e) var y = o ? e(g, v, s, t, n, i) : e(v, g, s, n, t, i);
                if (y !== X) {
                    if (y) continue;
                    p = !1;
                    break;
                }
                if (_) {
                    if (!h(t, function(n, t) {
                        if (!S(_, t) && (v === n || u(v, n, r, e, i))) return _.push(t);
                    })) {
                        p = !1;
                        break;
                    }
                } else if (v !== g && !u(v, g, r, e, i)) {
                    p = !1;
                    break;
                }
            }
            return i.delete(n), i.delete(t), p;
        }
        function _i(n, t, r, e, u, i, o) {
            switch(r){
                case ct:
                    if (n.byteLength != t.byteLength || n.byteOffset != t.byteOffset) return !1;
                    n = n.buffer, t = t.buffer;
                case ft:
                    return !(n.byteLength != t.byteLength || !i(new Rl(n), new Rl(t)));
                case Nn:
                case Pn:
                case Hn:
                    return Gf(+n, +t);
                case Zn:
                    return n.name == t.name && n.message == t.message;
                case nt:
                case rt:
                    return n == t + "";
                case Gn:
                    var f = M;
                case tt:
                    var c = e & hn;
                    if (f || (f = P), n.size != t.size && !c) return !1;
                    var a = o.get(n);
                    if (a) return a == t;
                    e |= pn, o.set(n, t);
                    var l = pi(f(n), f(t), e, u, i, o);
                    return o.delete(n), l;
                case et:
                    if (_s) return _s.call(n) == _s.call(t);
            }
            return !1;
        }
        function vi(n, t, r, e, u, i) {
            var o = r & hn, f = yi(n), c = f.length;
            if (c != yi(t).length && !o) return !1;
            for(var a = c; a--;){
                var l = f[a];
                if (!(o ? l in t : bl.call(t, l))) return !1;
            }
            var s = i.get(n), h = i.get(t);
            if (s && h) return s == t && h == n;
            var p = !0;
            i.set(n, t), i.set(t, n);
            for(var _ = o; ++a < c;){
                l = f[a];
                var v = n[l], g = t[l];
                if (e) var y = o ? e(g, v, l, t, n, i) : e(v, g, l, n, t, i);
                if (!(y === X ? v === g || u(v, g, r, e, i) : y)) {
                    p = !1;
                    break;
                }
                _ || (_ = "constructor" == l);
            }
            if (p && !_) {
                var d = n.constructor, b = t.constructor;
                d != b && "constructor" in n && "constructor" in t && !("function" == typeof d && d instanceof d && "function" == typeof b && b instanceof b) && (p = !1);
            }
            return i.delete(n), i.delete(t), p;
        }
        function gi(n) {
            return Ls(Vi(n, X, _o), n + "");
        }
        function yi(n) {
            return de(n, Pc, Is);
        }
        function di(n) {
            return de(n, qc, Rs);
        }
        function bi(n) {
            for(var t = n.name + "", r = fs[t], e = bl.call(fs, t) ? r.length : 0; e--;){
                var u = r[e], i = u.func;
                if (null == i || i == n) return u.name;
            }
            return t;
        }
        function wi(n) {
            return (bl.call(Z, "placeholder") ? Z : n).placeholder;
        }
        function mi() {
            var n = Z.iteratee || Ca;
            return n = n === Ca ? De : n, arguments.length ? n(arguments[0], arguments[1]) : n;
        }
        function xi(n, t) {
            var r = n.__data__;
            return Ti(t) ? r["string" == typeof t ? "string" : "hash"] : r.map;
        }
        function ji(n) {
            for(var t = Pc(n), r = t.length; r--;){
                var e = t[r], u = n[e];
                t[r] = [
                    e,
                    u,
                    Fi(u)
                ];
            }
            return t;
        }
        function Ai(n, t) {
            var r = B(n, t);
            return Ue(r) ? r : X;
        }
        function ki(n) {
            var t = bl.call(n, Bl), r = n[Bl];
            try {
                n[Bl] = X;
                var e = !0;
            } catch (n) {}
            var u = xl.call(n);
            return e && (t ? n[Bl] = r : delete n[Bl]), u;
        }
        function Oi(n, t, r) {
            for(var e = -1, u = r.length; ++e < u;){
                var i = r[e], o = i.size;
                switch(i.type){
                    case "drop":
                        n += o;
                        break;
                    case "dropRight":
                        t -= o;
                        break;
                    case "take":
                        t = Hl(t, n + o);
                        break;
                    case "takeRight":
                        n = Gl(n, t - o);
                }
            }
            return {
                start: n,
                end: t
            };
        }
        function Ii(n) {
            var t = n.match(Bt);
            return t ? t[1].split(Tt) : [];
        }
        function Ri(n, t, r) {
            t = ku(t, n);
            for(var e = -1, u = t.length, i = !1; ++e < u;){
                var o = no(t[e]);
                if (!(i = null != n && r(n, o))) break;
                n = n[o];
            }
            return i || ++e != u ? i : (u = null == n ? 0 : n.length, !!u && oc(u) && Ci(o, u) && (bh(n) || dh(n)));
        }
        function zi(n) {
            var t = n.length, r = new n.constructor(t);
            return t && "string" == typeof n[0] && bl.call(n, "index") && (r.index = n.index, r.input = n.input), r;
        }
        function Ei(n) {
            return "function" != typeof n.constructor || Mi(n) ? {} : gs(El(n));
        }
        function Si(n, t, r) {
            var e = n.constructor;
            switch(t){
                case ft:
                    return Ru(n);
                case Nn:
                case Pn:
                    return new e(+n);
                case ct:
                    return zu(n, r);
                case at:
                case lt:
                case st:
                case ht:
                case pt:
                case _t:
                case vt:
                case gt:
                case yt:
                    return Wu(n, r);
                case Gn:
                    return new e();
                case Hn:
                case rt:
                    return new e(n);
                case nt:
                    return Eu(n);
                case tt:
                    return new e();
                case et:
                    return Su(n);
            }
        }
        function Wi(n, t) {
            var r = t.length;
            if (!r) return n;
            var e = r - 1;
            return t[e] = (r > 1 ? "& " : "") + t[e], t = t.join(r > 2 ? ", " : " "), n.replace(Ut, "{\n/* [wrapped with " + t + "] */\n");
        }
        function Li(n) {
            return bh(n) || dh(n) || !!(Cl && n && n[Cl]);
        }
        function Ci(n, t) {
            var r = typeof n;
            return t = null == t ? Wn : t, !!t && ("number" == r || "symbol" != r && Vt.test(n)) && n > -1 && n % 1 == 0 && n < t;
        }
        function Ui(n, t, r) {
            if (!fc(r)) return !1;
            var e = typeof t;
            return !!("number" == e ? Hf(r) && Ci(t, r.length) : "string" == e && t in r) && Gf(r[t], n);
        }
        function Bi(n, t) {
            if (bh(n)) return !1;
            var r = typeof n;
            return !("number" != r && "symbol" != r && "boolean" != r && null != n && !bc(n)) || zt.test(n) || !Rt.test(n) || null != t && n in ll(t);
        }
        function Ti(n) {
            var t = typeof n;
            return "string" == t || "number" == t || "symbol" == t || "boolean" == t ? "__proto__" !== n : null === n;
        }
        function $i(n) {
            var t = bi(n), r = Z[t];
            if ("function" != typeof r || !(t in Ct.prototype)) return !1;
            if (n === r) return !0;
            var e = Os(r);
            return !!e && n === e[0];
        }
        function Di(n) {
            return !!ml && ml in n;
        }
        function Mi(n) {
            var t = n && n.constructor;
            return n === ("function" == typeof t && t.prototype || gl);
        }
        function Fi(n) {
            return n === n && !fc(n);
        }
        function Ni(n, t) {
            return function(r) {
                return null != r && r[n] === t && (t !== X || n in ll(r));
            };
        }
        function Pi(n) {
            var t = Cf(n, function(n) {
                return r.size === fn && r.clear(), n;
            }), r = t.cache;
            return t;
        }
        function qi(n, t) {
            var r = n[1], e = t[1], u = r | e, i = u < (_n | vn | mn), o = e == mn && r == yn || e == mn && r == xn && n[7].length <= t[8] || e == (mn | xn) && t[7].length <= t[8] && r == yn;
            if (!i && !o) return n;
            e & _n && (n[2] = t[2], u |= r & _n ? 0 : gn);
            var f = t[3];
            if (f) {
                var c = n[3];
                n[3] = c ? Uu(c, f, t[4]) : f, n[4] = c ? N(n[3], cn) : t[4];
            }
            return f = t[5], f && (c = n[5], n[5] = c ? Bu(c, f, t[6]) : f, n[6] = c ? N(n[5], cn) : t[6]), f = t[7], f && (n[7] = f), e & mn && (n[8] = null == n[8] ? t[8] : Hl(n[8], t[8])), null == n[9] && (n[9] = t[9]), n[0] = t[0], n[1] = u, n;
        }
        function Zi(n) {
            var t = [];
            if (null != n) for(var r in ll(n))t.push(r);
            return t;
        }
        function Ki(n) {
            return xl.call(n);
        }
        function Vi(t, r, e) {
            return r = Gl(r === X ? t.length - 1 : r, 0), function() {
                for(var u = arguments, i = -1, o = Gl(u.length - r, 0), f = il(o); ++i < o;)f[i] = u[r + i];
                i = -1;
                for(var c = il(r + 1); ++i < r;)c[i] = u[i];
                return c[r] = e(f), n(t, this, c);
            };
        }
        function Gi(n, t) {
            return t.length < 2 ? n : _e(n, au(t, 0, -1));
        }
        function Hi(n, t) {
            for(var r = n.length, e = Hl(t.length, r), u = Tu(n); e--;){
                var i = t[e];
                n[e] = Ci(i, r) ? u[i] : X;
            }
            return n;
        }
        function Ji(n, t) {
            if (("constructor" !== t || "function" != typeof n[t]) && "__proto__" != t) return n[t];
        }
        function Yi(n, t, r) {
            var e = t + "";
            return Ls(n, Wi(e, ro(Ii(e), r)));
        }
        function Qi(n) {
            var t = 0, r = 0;
            return function() {
                var e = Jl(), u = In - (e - r);
                if (r = e, u > 0) {
                    if (++t >= On) return arguments[0];
                } else t = 0;
                return n.apply(X, arguments);
            };
        }
        function Xi(n, t) {
            var r = -1, e = n.length, u = e - 1;
            for(t = t === X ? e : t; ++r < t;){
                var i = tu(r, u), o = n[i];
                n[i] = n[r], n[r] = o;
            }
            return n.length = t, n;
        }
        function no(n) {
            if ("string" == typeof n || bc(n)) return n;
            var t = n + "";
            return "0" == t && 1 / n == -Sn ? "-0" : t;
        }
        function to(n) {
            if (null != n) {
                try {
                    return dl.call(n);
                } catch (n) {}
                try {
                    return n + "";
                } catch (n) {}
            }
            return "";
        }
        function ro(n, t) {
            return r($n, function(r) {
                var e = "_." + r[0];
                t & r[1] && !o(n, e) && n.push(e);
            }), n.sort();
        }
        function eo(n) {
            if (n instanceof Ct) return n.clone();
            var t = new Y(n.__wrapped__, n.__chain__);
            return t.__actions__ = Tu(n.__actions__), t.__index__ = n.__index__, t.__values__ = n.__values__, t;
        }
        function uo(n, t, r) {
            t = (r ? Ui(n, t, r) : t === X) ? 1 : Gl(kc(t), 0);
            var e = null == n ? 0 : n.length;
            if (!e || t < 1) return [];
            for(var u = 0, i = 0, o = il(Fl(e / t)); u < e;)o[i++] = au(n, u, u += t);
            return o;
        }
        function io(n) {
            for(var t = -1, r = null == n ? 0 : n.length, e = 0, u = []; ++t < r;){
                var i = n[t];
                i && (u[e++] = i);
            }
            return u;
        }
        function oo() {
            var n = arguments.length;
            if (!n) return [];
            for(var t = il(n - 1), r = arguments[0], e = n; e--;)t[e - 1] = arguments[e];
            return a(bh(r) ? Tu(r) : [
                r
            ], ee(t, 1));
        }
        function fo(n, t, r) {
            var e = null == n ? 0 : n.length;
            return e ? (t = r || t === X ? 1 : kc(t), au(n, t < 0 ? 0 : t, e)) : [];
        }
        function co(n, t, r) {
            var e = null == n ? 0 : n.length;
            return e ? (t = r || t === X ? 1 : kc(t), t = e - t, au(n, 0, t < 0 ? 0 : t)) : [];
        }
        function ao(n, t) {
            return n && n.length ? bu(n, mi(t, 3), !0, !0) : [];
        }
        function lo(n, t) {
            return n && n.length ? bu(n, mi(t, 3), !0) : [];
        }
        function so(n, t, r, e) {
            var u = null == n ? 0 : n.length;
            return u ? (r && "number" != typeof r && Ui(n, t, r) && (r = 0, e = u), ne(n, t, r, e)) : [];
        }
        function ho(n, t, r) {
            var e = null == n ? 0 : n.length;
            if (!e) return -1;
            var u = null == r ? 0 : kc(r);
            return u < 0 && (u = Gl(e + u, 0)), g(n, mi(t, 3), u);
        }
        function po(n, t, r) {
            var e = null == n ? 0 : n.length;
            if (!e) return -1;
            var u = e - 1;
            return r !== X && (u = kc(r), u = r < 0 ? Gl(e + u, 0) : Hl(u, e - 1)), g(n, mi(t, 3), u, !0);
        }
        function _o(n) {
            return (null == n ? 0 : n.length) ? ee(n, 1) : [];
        }
        function vo(n) {
            return (null == n ? 0 : n.length) ? ee(n, Sn) : [];
        }
        function go(n, t) {
            return (null == n ? 0 : n.length) ? (t = t === X ? 1 : kc(t), ee(n, t)) : [];
        }
        function yo(n) {
            for(var t = -1, r = null == n ? 0 : n.length, e = {}; ++t < r;){
                var u = n[t];
                e[u[0]] = u[1];
            }
            return e;
        }
        function bo(n) {
            return n && n.length ? n[0] : X;
        }
        function wo(n, t, r) {
            var e = null == n ? 0 : n.length;
            if (!e) return -1;
            var u = null == r ? 0 : kc(r);
            return u < 0 && (u = Gl(e + u, 0)), y(n, t, u);
        }
        function mo(n) {
            return (null == n ? 0 : n.length) ? au(n, 0, -1) : [];
        }
        function xo(n, t) {
            return null == n ? "" : Kl.call(n, t);
        }
        function jo(n) {
            var t = null == n ? 0 : n.length;
            return t ? n[t - 1] : X;
        }
        function Ao(n, t, r) {
            var e = null == n ? 0 : n.length;
            if (!e) return -1;
            var u = e;
            return r !== X && (u = kc(r), u = u < 0 ? Gl(e + u, 0) : Hl(u, e - 1)), t === t ? K(n, t, u) : g(n, b, u, !0);
        }
        function ko(n, t) {
            return n && n.length ? Ge(n, kc(t)) : X;
        }
        function Oo(n, t) {
            return n && n.length && t && t.length ? Xe(n, t) : n;
        }
        function Io(n, t, r) {
            return n && n.length && t && t.length ? Xe(n, t, mi(r, 2)) : n;
        }
        function Ro(n, t, r) {
            return n && n.length && t && t.length ? Xe(n, t, X, r) : n;
        }
        function zo(n, t) {
            var r = [];
            if (!n || !n.length) return r;
            var e = -1, u = [], i = n.length;
            for(t = mi(t, 3); ++e < i;){
                var o = n[e];
                t(o, e, n) && (r.push(o), u.push(e));
            }
            return nu(n, u), r;
        }
        function Eo(n) {
            return null == n ? n : Xl.call(n);
        }
        function So(n, t, r) {
            var e = null == n ? 0 : n.length;
            return e ? (r && "number" != typeof r && Ui(n, t, r) ? (t = 0, r = e) : (t = null == t ? 0 : kc(t), r = r === X ? e : kc(r)), au(n, t, r)) : [];
        }
        function Wo(n, t) {
            return su(n, t);
        }
        function Lo(n, t, r) {
            return hu(n, t, mi(r, 2));
        }
        function Co(n, t) {
            var r = null == n ? 0 : n.length;
            if (r) {
                var e = su(n, t);
                if (e < r && Gf(n[e], t)) return e;
            }
            return -1;
        }
        function Uo(n, t) {
            return su(n, t, !0);
        }
        function Bo(n, t, r) {
            return hu(n, t, mi(r, 2), !0);
        }
        function To(n, t) {
            if (null == n ? 0 : n.length) {
                var r = su(n, t, !0) - 1;
                if (Gf(n[r], t)) return r;
            }
            return -1;
        }
        function $o(n) {
            return n && n.length ? pu(n) : [];
        }
        function Do(n, t) {
            return n && n.length ? pu(n, mi(t, 2)) : [];
        }
        function Mo(n) {
            var t = null == n ? 0 : n.length;
            return t ? au(n, 1, t) : [];
        }
        function Fo(n, t, r) {
            return n && n.length ? (t = r || t === X ? 1 : kc(t), au(n, 0, t < 0 ? 0 : t)) : [];
        }
        function No(n, t, r) {
            var e = null == n ? 0 : n.length;
            return e ? (t = r || t === X ? 1 : kc(t), t = e - t, au(n, t < 0 ? 0 : t, e)) : [];
        }
        function Po(n, t) {
            return n && n.length ? bu(n, mi(t, 3), !1, !0) : [];
        }
        function qo(n, t) {
            return n && n.length ? bu(n, mi(t, 3)) : [];
        }
        function Zo(n) {
            return n && n.length ? gu(n) : [];
        }
        function Ko(n, t) {
            return n && n.length ? gu(n, mi(t, 2)) : [];
        }
        function Vo(n, t) {
            return t = "function" == typeof t ? t : X, n && n.length ? gu(n, X, t) : [];
        }
        function Go(n) {
            if (!n || !n.length) return [];
            var t = 0;
            return n = i(n, function(n) {
                if (Jf(n)) return t = Gl(n.length, t), !0;
            }), O(t, function(t) {
                return c(n, m(t));
            });
        }
        function Ho(t, r) {
            if (!t || !t.length) return [];
            var e = Go(t);
            return null == r ? e : c(e, function(t) {
                return n(r, X, t);
            });
        }
        function Jo(n, t) {
            return xu(n || [], t || [], Sr);
        }
        function Yo(n, t) {
            return xu(n || [], t || [], fu);
        }
        function Qo(n) {
            var t = Z(n);
            return t.__chain__ = !0, t;
        }
        function Xo(n, t) {
            return t(n), n;
        }
        function nf(n, t) {
            return t(n);
        }
        function tf() {
            return Qo(this);
        }
        function rf() {
            return new Y(this.value(), this.__chain__);
        }
        function ef() {
            this.__values__ === X && (this.__values__ = jc(this.value()));
            var n = this.__index__ >= this.__values__.length;
            return {
                done: n,
                value: n ? X : this.__values__[this.__index__++]
            };
        }
        function uf() {
            return this;
        }
        function of(n) {
            for(var t, r = this; r instanceof J;){
                var e = eo(r);
                e.__index__ = 0, e.__values__ = X, t ? u.__wrapped__ = e : t = e;
                var u = e;
                r = r.__wrapped__;
            }
            return u.__wrapped__ = n, t;
        }
        function ff() {
            var n = this.__wrapped__;
            if (n instanceof Ct) {
                var t = n;
                return this.__actions__.length && (t = new Ct(this)), t = t.reverse(), t.__actions__.push({
                    func: nf,
                    args: [
                        Eo
                    ],
                    thisArg: X
                }), new Y(t, this.__chain__);
            }
            return this.thru(Eo);
        }
        function cf() {
            return wu(this.__wrapped__, this.__actions__);
        }
        function af(n, t, r) {
            var e = bh(n) ? u : Jr;
            return r && Ui(n, t, r) && (t = X), e(n, mi(t, 3));
        }
        function lf(n, t) {
            return (bh(n) ? i : te)(n, mi(t, 3));
        }
        function sf(n, t) {
            return ee(yf(n, t), 1);
        }
        function hf(n, t) {
            return ee(yf(n, t), Sn);
        }
        function pf(n, t, r) {
            return r = r === X ? 1 : kc(r), ee(yf(n, t), r);
        }
        function _f(n, t) {
            return (bh(n) ? r : ys)(n, mi(t, 3));
        }
        function vf(n, t) {
            return (bh(n) ? e : ds)(n, mi(t, 3));
        }
        function gf(n, t, r, e) {
            n = Hf(n) ? n : ra(n), r = r && !e ? kc(r) : 0;
            var u = n.length;
            return r < 0 && (r = Gl(u + r, 0)), dc(n) ? r <= u && n.indexOf(t, r) > -1 : !!u && y(n, t, r) > -1;
        }
        function yf(n, t) {
            return (bh(n) ? c : Pe)(n, mi(t, 3));
        }
        function df(n, t, r, e) {
            return null == n ? [] : (bh(t) || (t = null == t ? [] : [
                t
            ]), r = e ? X : r, bh(r) || (r = null == r ? [] : [
                r
            ]), He(n, t, r));
        }
        function bf(n, t, r) {
            var e = bh(n) ? l : j, u = arguments.length < 3;
            return e(n, mi(t, 4), r, u, ys);
        }
        function wf(n, t, r) {
            var e = bh(n) ? s : j, u = arguments.length < 3;
            return e(n, mi(t, 4), r, u, ds);
        }
        function mf(n, t) {
            return (bh(n) ? i : te)(n, Uf(mi(t, 3)));
        }
        function xf(n) {
            return (bh(n) ? Ir : iu)(n);
        }
        function jf(n, t, r) {
            return t = (r ? Ui(n, t, r) : t === X) ? 1 : kc(t), (bh(n) ? Rr : ou)(n, t);
        }
        function Af(n) {
            return (bh(n) ? zr : cu)(n);
        }
        function kf(n) {
            if (null == n) return 0;
            if (Hf(n)) return dc(n) ? V(n) : n.length;
            var t = zs(n);
            return t == Gn || t == tt ? n.size : Me(n).length;
        }
        function Of(n, t, r) {
            var e = bh(n) ? h : lu;
            return r && Ui(n, t, r) && (t = X), e(n, mi(t, 3));
        }
        function If(n, t) {
            if ("function" != typeof t) throw new pl(en);
            return n = kc(n), function() {
                if (--n < 1) return t.apply(this, arguments);
            };
        }
        function Rf(n, t, r) {
            return t = r ? X : t, t = n && null == t ? n.length : t, ai(n, mn, X, X, X, X, t);
        }
        function zf(n, t) {
            var r;
            if ("function" != typeof t) throw new pl(en);
            return n = kc(n), function() {
                return --n > 0 && (r = t.apply(this, arguments)), n <= 1 && (t = X), r;
            };
        }
        function Ef(n, t, r) {
            t = r ? X : t;
            var e = ai(n, yn, X, X, X, X, X, t);
            return e.placeholder = Ef.placeholder, e;
        }
        function Sf(n, t, r) {
            t = r ? X : t;
            var e = ai(n, dn, X, X, X, X, X, t);
            return e.placeholder = Sf.placeholder, e;
        }
        function Wf(n, t, r) {
            function e(t) {
                var r = h, e = p;
                return h = p = X, d = t, v = n.apply(e, r);
            }
            function u(n) {
                return d = n, g = Ws(f, t), b ? e(n) : v;
            }
            function i(n) {
                var r = n - y, e = n - d, u = t - r;
                return w ? Hl(u, _ - e) : u;
            }
            function o(n) {
                var r = n - y, e = n - d;
                return y === X || r >= t || r < 0 || w && e >= _;
            }
            function f() {
                var n = fh();
                return o(n) ? c(n) : (g = Ws(f, i(n)), X);
            }
            function c(n) {
                return g = X, m && h ? e(n) : (h = p = X, v);
            }
            function a() {
                g !== X && As(g), d = 0, h = y = p = g = X;
            }
            function l() {
                return g === X ? v : c(fh());
            }
            function s() {
                var n = fh(), r = o(n);
                if (h = arguments, p = this, y = n, r) {
                    if (g === X) return u(y);
                    if (w) return As(g), g = Ws(f, t), e(y);
                }
                return g === X && (g = Ws(f, t)), v;
            }
            var h, p, _, v, g, y, d = 0, b = !1, w = !1, m = !0;
            if ("function" != typeof n) throw new pl(en);
            return t = Ic(t) || 0, fc(r) && (b = !!r.leading, w = "maxWait" in r, _ = w ? Gl(Ic(r.maxWait) || 0, t) : _, m = "trailing" in r ? !!r.trailing : m), s.cancel = a, s.flush = l, s;
        }
        function Lf(n) {
            return ai(n, jn);
        }
        function Cf(n, t) {
            if ("function" != typeof n || null != t && "function" != typeof t) throw new pl(en);
            var r = function() {
                var e = arguments, u = t ? t.apply(this, e) : e[0], i = r.cache;
                if (i.has(u)) return i.get(u);
                var o = n.apply(this, e);
                return r.cache = i.set(u, o) || i, o;
            };
            return r.cache = new (Cf.Cache || sr)(), r;
        }
        function Uf(n) {
            if ("function" != typeof n) throw new pl(en);
            return function() {
                var t = arguments;
                switch(t.length){
                    case 0:
                        return !n.call(this);
                    case 1:
                        return !n.call(this, t[0]);
                    case 2:
                        return !n.call(this, t[0], t[1]);
                    case 3:
                        return !n.call(this, t[0], t[1], t[2]);
                }
                return !n.apply(this, t);
            };
        }
        function Bf(n) {
            return zf(2, n);
        }
        function Tf(n, t) {
            if ("function" != typeof n) throw new pl(en);
            return t = t === X ? t : kc(t), uu(n, t);
        }
        function $f(t, r) {
            if ("function" != typeof t) throw new pl(en);
            return r = null == r ? 0 : Gl(kc(r), 0), uu(function(e) {
                var u = e[r], i = Ou(e, 0, r);
                return u && a(i, u), n(t, this, i);
            });
        }
        function Df(n, t, r) {
            var e = !0, u = !0;
            if ("function" != typeof n) throw new pl(en);
            return fc(r) && (e = "leading" in r ? !!r.leading : e, u = "trailing" in r ? !!r.trailing : u), Wf(n, t, {
                leading: e,
                maxWait: t,
                trailing: u
            });
        }
        function Mf(n) {
            return Rf(n, 1);
        }
        function Ff(n, t) {
            return ph(Au(t), n);
        }
        function Nf() {
            if (!arguments.length) return [];
            var n = arguments[0];
            return bh(n) ? n : [
                n
            ];
        }
        function Pf(n) {
            return Fr(n, sn);
        }
        function qf(n, t) {
            return t = "function" == typeof t ? t : X, Fr(n, sn, t);
        }
        function Zf(n) {
            return Fr(n, an | sn);
        }
        function Kf(n, t) {
            return t = "function" == typeof t ? t : X, Fr(n, an | sn, t);
        }
        function Vf(n, t) {
            return null == t || Pr(n, t, Pc(t));
        }
        function Gf(n, t) {
            return n === t || n !== n && t !== t;
        }
        function Hf(n) {
            return null != n && oc(n.length) && !uc(n);
        }
        function Jf(n) {
            return cc(n) && Hf(n);
        }
        function Yf(n) {
            return n === !0 || n === !1 || cc(n) && we(n) == Nn;
        }
        function Qf(n) {
            return cc(n) && 1 === n.nodeType && !gc(n);
        }
        function Xf(n) {
            if (null == n) return !0;
            if (Hf(n) && (bh(n) || "string" == typeof n || "function" == typeof n.splice || mh(n) || Oh(n) || dh(n))) return !n.length;
            var t = zs(n);
            if (t == Gn || t == tt) return !n.size;
            if (Mi(n)) return !Me(n).length;
            for(var r in n)if (bl.call(n, r)) return !1;
            return !0;
        }
        function nc(n, t) {
            return Se(n, t);
        }
        function tc(n, t, r) {
            r = "function" == typeof r ? r : X;
            var e = r ? r(n, t) : X;
            return e === X ? Se(n, t, X, r) : !!e;
        }
        function rc(n) {
            if (!cc(n)) return !1;
            var t = we(n);
            return t == Zn || t == qn || "string" == typeof n.message && "string" == typeof n.name && !gc(n);
        }
        function ec(n) {
            return "number" == typeof n && Zl(n);
        }
        function uc(n) {
            if (!fc(n)) return !1;
            var t = we(n);
            return t == Kn || t == Vn || t == Fn || t == Xn;
        }
        function ic(n) {
            return "number" == typeof n && n == kc(n);
        }
        function oc(n) {
            return "number" == typeof n && n > -1 && n % 1 == 0 && n <= Wn;
        }
        function fc(n) {
            var t = typeof n;
            return null != n && ("object" == t || "function" == t);
        }
        function cc(n) {
            return null != n && "object" == typeof n;
        }
        function ac(n, t) {
            return n === t || Ce(n, t, ji(t));
        }
        function lc(n, t, r) {
            return r = "function" == typeof r ? r : X, Ce(n, t, ji(t), r);
        }
        function sc(n) {
            return vc(n) && n != +n;
        }
        function hc(n) {
            if (Es(n)) throw new fl(rn);
            return Ue(n);
        }
        function pc(n) {
            return null === n;
        }
        function _c(n) {
            return null == n;
        }
        function vc(n) {
            return "number" == typeof n || cc(n) && we(n) == Hn;
        }
        function gc(n) {
            if (!cc(n) || we(n) != Yn) return !1;
            var t = El(n);
            if (null === t) return !0;
            var r = bl.call(t, "constructor") && t.constructor;
            return "function" == typeof r && r instanceof r && dl.call(r) == jl;
        }
        function yc(n) {
            return ic(n) && n >= -Wn && n <= Wn;
        }
        function dc(n) {
            return "string" == typeof n || !bh(n) && cc(n) && we(n) == rt;
        }
        function bc(n) {
            return "symbol" == typeof n || cc(n) && we(n) == et;
        }
        function wc(n) {
            return n === X;
        }
        function mc(n) {
            return cc(n) && zs(n) == it;
        }
        function xc(n) {
            return cc(n) && we(n) == ot;
        }
        function jc(n) {
            if (!n) return [];
            if (Hf(n)) return dc(n) ? G(n) : Tu(n);
            if (Ul && n[Ul]) return D(n[Ul]());
            var t = zs(n);
            return (t == Gn ? M : t == tt ? P : ra)(n);
        }
        function Ac(n) {
            if (!n) return 0 === n ? n : 0;
            if (n = Ic(n), n === Sn || n === -Sn) return (n < 0 ? -1 : 1) * Ln;
            return n === n ? n : 0;
        }
        function kc(n) {
            var t = Ac(n), r = t % 1;
            return t === t ? r ? t - r : t : 0;
        }
        function Oc(n) {
            return n ? Mr(kc(n), 0, Un) : 0;
        }
        function Ic(n) {
            if ("number" == typeof n) return n;
            if (bc(n)) return Cn;
            if (fc(n)) {
                var t = "function" == typeof n.valueOf ? n.valueOf() : n;
                n = fc(t) ? t + "" : t;
            }
            if ("string" != typeof n) return 0 === n ? n : +n;
            n = R(n);
            var r = qt.test(n);
            return r || Kt.test(n) ? Xr(n.slice(2), r ? 2 : 8) : Pt.test(n) ? Cn : +n;
        }
        function Rc(n) {
            return $u(n, qc(n));
        }
        function zc(n) {
            return n ? Mr(kc(n), -Wn, Wn) : 0 === n ? n : 0;
        }
        function Ec(n) {
            return null == n ? "" : vu(n);
        }
        function Sc(n, t) {
            var r = gs(n);
            return null == t ? r : Cr(r, t);
        }
        function Wc(n, t) {
            return v(n, mi(t, 3), ue);
        }
        function Lc(n, t) {
            return v(n, mi(t, 3), oe);
        }
        function Cc(n, t) {
            return null == n ? n : bs(n, mi(t, 3), qc);
        }
        function Uc(n, t) {
            return null == n ? n : ws(n, mi(t, 3), qc);
        }
        function Bc(n, t) {
            return n && ue(n, mi(t, 3));
        }
        function Tc(n, t) {
            return n && oe(n, mi(t, 3));
        }
        function $c(n) {
            return null == n ? [] : fe(n, Pc(n));
        }
        function Dc(n) {
            return null == n ? [] : fe(n, qc(n));
        }
        function Mc(n, t, r) {
            var e = null == n ? X : _e(n, t);
            return e === X ? r : e;
        }
        function Fc(n, t) {
            return null != n && Ri(n, t, xe);
        }
        function Nc(n, t) {
            return null != n && Ri(n, t, je);
        }
        function Pc(n) {
            return Hf(n) ? Or(n) : Me(n);
        }
        function qc(n) {
            return Hf(n) ? Or(n, !0) : Fe(n);
        }
        function Zc(n, t) {
            var r = {};
            return t = mi(t, 3), ue(n, function(n, e, u) {
                Br(r, t(n, e, u), n);
            }), r;
        }
        function Kc(n, t) {
            var r = {};
            return t = mi(t, 3), ue(n, function(n, e, u) {
                Br(r, e, t(n, e, u));
            }), r;
        }
        function Vc(n, t) {
            return Gc(n, Uf(mi(t)));
        }
        function Gc(n, t) {
            if (null == n) return {};
            var r = c(di(n), function(n) {
                return [
                    n
                ];
            });
            return t = mi(t), Ye(n, r, function(n, r) {
                return t(n, r[0]);
            });
        }
        function Hc(n, t, r) {
            t = ku(t, n);
            var e = -1, u = t.length;
            for(u || (u = 1, n = X); ++e < u;){
                var i = null == n ? X : n[no(t[e])];
                i === X && (e = u, i = r), n = uc(i) ? i.call(n) : i;
            }
            return n;
        }
        function Jc(n, t, r) {
            return null == n ? n : fu(n, t, r);
        }
        function Yc(n, t, r, e) {
            return e = "function" == typeof e ? e : X, null == n ? n : fu(n, t, r, e);
        }
        function Qc(n, t, e) {
            var u = bh(n), i = u || mh(n) || Oh(n);
            if (t = mi(t, 4), null == e) {
                var o = n && n.constructor;
                e = i ? u ? new o() : [] : fc(n) && uc(o) ? gs(El(n)) : {};
            }
            return (i ? r : ue)(n, function(n, r, u) {
                return t(e, n, r, u);
            }), e;
        }
        function Xc(n, t) {
            return null == n || yu(n, t);
        }
        function na(n, t, r) {
            return null == n ? n : du(n, t, Au(r));
        }
        function ta(n, t, r, e) {
            return e = "function" == typeof e ? e : X, null == n ? n : du(n, t, Au(r), e);
        }
        function ra(n) {
            return null == n ? [] : E(n, Pc(n));
        }
        function ea(n) {
            return null == n ? [] : E(n, qc(n));
        }
        function ua(n, t, r) {
            return r === X && (r = t, t = X), r !== X && (r = Ic(r), r = r === r ? r : 0), t !== X && (t = Ic(t), t = t === t ? t : 0), Mr(Ic(n), t, r);
        }
        function ia(n, t, r) {
            return t = Ac(t), r === X ? (r = t, t = 0) : r = Ac(r), n = Ic(n), Ae(n, t, r);
        }
        function oa(n, t, r) {
            if (r && "boolean" != typeof r && Ui(n, t, r) && (t = r = X), r === X && ("boolean" == typeof t ? (r = t, t = X) : "boolean" == typeof n && (r = n, n = X)), n === X && t === X ? (n = 0, t = 1) : (n = Ac(n), t === X ? (t = n, n = 0) : t = Ac(t)), n > t) {
                var e = n;
                n = t, t = e;
            }
            if (r || n % 1 || t % 1) {
                var u = Ql();
                return Hl(n + u * (t - n + Qr("1e-" + ((u + "").length - 1))), t);
            }
            return tu(n, t);
        }
        function fa(n) {
            return Qh(Ec(n).toLowerCase());
        }
        function ca(n) {
            return n = Ec(n), n && n.replace(Gt, ve).replace(Dr, "");
        }
        function aa(n, t, r) {
            n = Ec(n), t = vu(t);
            var e = n.length;
            r = r === X ? e : Mr(kc(r), 0, e);
            var u = r;
            return r -= t.length, r >= 0 && n.slice(r, u) == t;
        }
        function la(n) {
            return n = Ec(n), n && At.test(n) ? n.replace(xt, ge) : n;
        }
        function sa(n) {
            return n = Ec(n), n && Wt.test(n) ? n.replace(St, "\\$&") : n;
        }
        function ha(n, t, r) {
            n = Ec(n), t = kc(t);
            var e = t ? V(n) : 0;
            if (!t || e >= t) return n;
            var u = (t - e) / 2;
            return ri(Nl(u), r) + n + ri(Fl(u), r);
        }
        function pa(n, t, r) {
            n = Ec(n), t = kc(t);
            var e = t ? V(n) : 0;
            return t && e < t ? n + ri(t - e, r) : n;
        }
        function _a(n, t, r) {
            n = Ec(n), t = kc(t);
            var e = t ? V(n) : 0;
            return t && e < t ? ri(t - e, r) + n : n;
        }
        function va(n, t, r) {
            return r || null == t ? t = 0 : t && (t = +t), Yl(Ec(n).replace(Lt, ""), t || 0);
        }
        function ga(n, t, r) {
            return t = (r ? Ui(n, t, r) : t === X) ? 1 : kc(t), eu(Ec(n), t);
        }
        function ya() {
            var n = arguments, t = Ec(n[0]);
            return n.length < 3 ? t : t.replace(n[1], n[2]);
        }
        function da(n, t, r) {
            return r && "number" != typeof r && Ui(n, t, r) && (t = r = X), (r = r === X ? Un : r >>> 0) ? (n = Ec(n), n && ("string" == typeof t || null != t && !Ah(t)) && (t = vu(t), !t && T(n)) ? Ou(G(n), 0, r) : n.split(t, r)) : [];
        }
        function ba(n, t, r) {
            return n = Ec(n), r = null == r ? 0 : Mr(kc(r), 0, n.length), t = vu(t), n.slice(r, r + t.length) == t;
        }
        function wa(n, t, r) {
            var e = Z.templateSettings;
            r && Ui(n, t, r) && (t = X), n = Ec(n), t = Sh({}, t, e, li);
            var u, i, o = Sh({}, t.imports, e.imports, li), f = Pc(o), c = E(o, f), a = 0, l = t.interpolate || Ht, s = "__p += '", h = sl((t.escape || Ht).source + "|" + l.source + "|" + (l === It ? Ft : Ht).source + "|" + (t.evaluate || Ht).source + "|$", "g"), p = "//# sourceURL=" + (bl.call(t, "sourceURL") ? (t.sourceURL + "").replace(/\s/g, " ") : "lodash.templateSources[" + ++Zr + "]") + "\n";
            n.replace(h, function(t, r, e, o, f, c) {
                return e || (e = o), s += n.slice(a, c).replace(Jt, U), r && (u = !0, s += "' +\n__e(" + r + ") +\n'"), f && (i = !0, s += "';\n" + f + ";\n__p += '"), e && (s += "' +\n((__t = (" + e + ")) == null ? '' : __t) +\n'"), a = c + t.length, t;
            }), s += "';\n";
            var _ = bl.call(t, "variable") && t.variable;
            if (_) {
                if (Dt.test(_)) throw new fl(un);
            } else s = "with (obj) {\n" + s + "\n}\n";
            s = (i ? s.replace(dt, "") : s).replace(bt, "$1").replace(wt, "$1;"), s = "function(" + (_ || "obj") + ") {\n" + (_ ? "" : "obj || (obj = {});\n") + "var __t, __p = ''" + (u ? ", __e = _.escape" : "") + (i ? ", __j = Array.prototype.join;\nfunction print() { __p += __j.call(arguments, '') }\n" : ";\n") + s + "return __p\n}";
            var v = Xh(function() {
                return cl(f, p + "return " + s).apply(X, c);
            });
            if (v.source = s, rc(v)) throw v;
            return v;
        }
        function ma(n) {
            return Ec(n).toLowerCase();
        }
        function xa(n) {
            return Ec(n).toUpperCase();
        }
        function ja(n, t, r) {
            if (n = Ec(n), n && (r || t === X)) return R(n);
            if (!n || !(t = vu(t))) return n;
            var e = G(n), u = G(t);
            return Ou(e, W(e, u), L(e, u) + 1).join("");
        }
        function Aa(n, t, r) {
            if (n = Ec(n), n && (r || t === X)) return n.slice(0, H(n) + 1);
            if (!n || !(t = vu(t))) return n;
            var e = G(n);
            return Ou(e, 0, L(e, G(t)) + 1).join("");
        }
        function ka(n, t, r) {
            if (n = Ec(n), n && (r || t === X)) return n.replace(Lt, "");
            if (!n || !(t = vu(t))) return n;
            var e = G(n);
            return Ou(e, W(e, G(t))).join("");
        }
        function Oa(n, t) {
            var r = An, e = kn;
            if (fc(t)) {
                var u = "separator" in t ? t.separator : u;
                r = "length" in t ? kc(t.length) : r, e = "omission" in t ? vu(t.omission) : e;
            }
            n = Ec(n);
            var i = n.length;
            if (T(n)) {
                var o = G(n);
                i = o.length;
            }
            if (r >= i) return n;
            var f = r - V(e);
            if (f < 1) return e;
            var c = o ? Ou(o, 0, f).join("") : n.slice(0, f);
            if (u === X) return c + e;
            if (o && (f += c.length - f), Ah(u)) {
                if (n.slice(f).search(u)) {
                    var a, l = c;
                    for(u.global || (u = sl(u.source, Ec(Nt.exec(u)) + "g")), u.lastIndex = 0; a = u.exec(l);)var s = a.index;
                    c = c.slice(0, s === X ? f : s);
                }
            } else if (n.indexOf(vu(u), f) != f) {
                var h = c.lastIndexOf(u);
                h > -1 && (c = c.slice(0, h));
            }
            return c + e;
        }
        function Ia(n) {
            return n = Ec(n), n && jt.test(n) ? n.replace(mt, ye) : n;
        }
        function Ra(n, t, r) {
            return n = Ec(n), t = r ? X : t, t === X ? $(n) ? Q(n) : _(n) : n.match(t) || [];
        }
        function za(t) {
            var r = null == t ? 0 : t.length, e = mi();
            return t = r ? c(t, function(n) {
                if ("function" != typeof n[1]) throw new pl(en);
                return [
                    e(n[0]),
                    n[1]
                ];
            }) : [], uu(function(e) {
                for(var u = -1; ++u < r;){
                    var i = t[u];
                    if (n(i[0], this, e)) return n(i[1], this, e);
                }
            });
        }
        function Ea(n) {
            return Nr(Fr(n, an));
        }
        function Sa(n) {
            return function() {
                return n;
            };
        }
        function Wa(n, t) {
            return null == n || n !== n ? t : n;
        }
        function La(n) {
            return n;
        }
        function Ca(n) {
            return De("function" == typeof n ? n : Fr(n, an));
        }
        function Ua(n) {
            return qe(Fr(n, an));
        }
        function Ba(n, t) {
            return Ze(n, Fr(t, an));
        }
        function Ta(n, t, e) {
            var u = Pc(t), i = fe(t, u);
            null != e || fc(t) && (i.length || !u.length) || (e = t, t = n, n = this, i = fe(t, Pc(t)));
            var o = !(fc(e) && "chain" in e && !e.chain), f = uc(n);
            return r(i, function(r) {
                var e = t[r];
                n[r] = e, f && (n.prototype[r] = function() {
                    var t = this.__chain__;
                    if (o || t) {
                        var r = n(this.__wrapped__);
                        return (r.__actions__ = Tu(this.__actions__)).push({
                            func: e,
                            args: arguments,
                            thisArg: n
                        }), r.__chain__ = t, r;
                    }
                    return e.apply(n, a([
                        this.value()
                    ], arguments));
                });
            }), n;
        }
        function $a() {
            return re._ === this && (re._ = Al), this;
        }
        function Da() {}
        function Ma(n) {
            return n = kc(n), uu(function(t) {
                return Ge(t, n);
            });
        }
        function Fa(n) {
            return Bi(n) ? m(no(n)) : Qe(n);
        }
        function Na(n) {
            return function(t) {
                return null == n ? X : _e(n, t);
            };
        }
        function Pa() {
            return [];
        }
        function qa() {
            return !1;
        }
        function Za() {
            return {};
        }
        function Ka() {
            return "";
        }
        function Va() {
            return !0;
        }
        function Ga(n, t) {
            if (n = kc(n), n < 1 || n > Wn) return [];
            var r = Un, e = Hl(n, Un);
            t = mi(t), n -= Un;
            for(var u = O(e, t); ++r < n;)t(r);
            return u;
        }
        function Ha(n) {
            return bh(n) ? c(n, no) : bc(n) ? [
                n
            ] : Tu(Cs(Ec(n)));
        }
        function Ja(n) {
            var t = ++wl;
            return Ec(n) + t;
        }
        function Ya(n) {
            return n && n.length ? Yr(n, La, me) : X;
        }
        function Qa(n, t) {
            return n && n.length ? Yr(n, mi(t, 2), me) : X;
        }
        function Xa(n) {
            return w(n, La);
        }
        function nl(n, t) {
            return w(n, mi(t, 2));
        }
        function tl(n) {
            return n && n.length ? Yr(n, La, Ne) : X;
        }
        function rl(n, t) {
            return n && n.length ? Yr(n, mi(t, 2), Ne) : X;
        }
        function el(n) {
            return n && n.length ? k(n, La) : 0;
        }
        function ul(n, t) {
            return n && n.length ? k(n, mi(t, 2)) : 0;
        }
        x = null == x ? re : be.defaults(re.Object(), x, be.pick(re, qr));
        var il = x.Array, ol = x.Date, fl = x.Error, cl = x.Function, al = x.Math, ll = x.Object, sl = x.RegExp, hl = x.String, pl = x.TypeError, _l = il.prototype, vl = cl.prototype, gl = ll.prototype, yl = x["__core-js_shared__"], dl = vl.toString, bl = gl.hasOwnProperty, wl = 0, ml = function() {
            var n = /[^.]+$/.exec(yl && yl.keys && yl.keys.IE_PROTO || "");
            return n ? "Symbol(src)_1." + n : "";
        }(), xl = gl.toString, jl = dl.call(ll), Al = re._, kl = sl("^" + dl.call(bl).replace(St, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"), Ol = ie ? x.Buffer : X, Il = x.Symbol, Rl = x.Uint8Array, zl = Ol ? Ol.allocUnsafe : X, El = F(ll.getPrototypeOf, ll), Sl = ll.create, Wl = gl.propertyIsEnumerable, Ll = _l.splice, Cl = Il ? Il.isConcatSpreadable : X, Ul = Il ? Il.iterator : X, Bl = Il ? Il.toStringTag : X, Tl = function() {
            try {
                var n = Ai(ll, "defineProperty");
                return n({}, "", {}), n;
            } catch (n) {}
        }(), $l = x.clearTimeout !== re.clearTimeout && x.clearTimeout, Dl = ol && ol.now !== re.Date.now && ol.now, Ml = x.setTimeout !== re.setTimeout && x.setTimeout, Fl = al.ceil, Nl = al.floor, Pl = ll.getOwnPropertySymbols, ql = Ol ? Ol.isBuffer : X, Zl = x.isFinite, Kl = _l.join, Vl = F(ll.keys, ll), Gl = al.max, Hl = al.min, Jl = ol.now, Yl = x.parseInt, Ql = al.random, Xl = _l.reverse, ns = Ai(x, "DataView"), ts = Ai(x, "Map"), rs = Ai(x, "Promise"), es = Ai(x, "Set"), us = Ai(x, "WeakMap"), is = Ai(ll, "create"), os = us && new us(), fs = {}, cs = to(ns), as = to(ts), ls = to(rs), ss = to(es), hs = to(us), ps = Il ? Il.prototype : X, _s = ps ? ps.valueOf : X, vs = ps ? ps.toString : X, gs = function() {
            function n() {}
            return function(t) {
                if (!fc(t)) return {};
                if (Sl) return Sl(t);
                n.prototype = t;
                var r = new n();
                return n.prototype = X, r;
            };
        }();
        Z.templateSettings = {
            escape: kt,
            evaluate: Ot,
            interpolate: It,
            variable: "",
            imports: {
                _: Z
            }
        }, Z.prototype = J.prototype, Z.prototype.constructor = Z, Y.prototype = gs(J.prototype), Y.prototype.constructor = Y, Ct.prototype = gs(J.prototype), Ct.prototype.constructor = Ct, Xt.prototype.clear = nr, Xt.prototype.delete = tr, Xt.prototype.get = rr, Xt.prototype.has = er, Xt.prototype.set = ur, ir.prototype.clear = or, ir.prototype.delete = fr, ir.prototype.get = cr, ir.prototype.has = ar, ir.prototype.set = lr, sr.prototype.clear = hr, sr.prototype.delete = pr, sr.prototype.get = _r, sr.prototype.has = vr, sr.prototype.set = gr, yr.prototype.add = yr.prototype.push = dr, yr.prototype.has = br, wr.prototype.clear = mr, wr.prototype.delete = xr, wr.prototype.get = jr, wr.prototype.has = Ar, wr.prototype.set = kr;
        var ys = Pu(ue), ds = Pu(oe, !0), bs = qu(), ws = qu(!0), ms = os ? function(n, t) {
            return os.set(n, t), n;
        } : La, xs = Tl ? function(n, t) {
            return Tl(n, "toString", {
                configurable: !0,
                enumerable: !1,
                value: Sa(t),
                writable: !0
            });
        } : La, js = uu, As = $l || function(n) {
            return re.clearTimeout(n);
        }, ks = es && 1 / P(new es([
            ,
            -0
        ]))[1] == Sn ? function(n) {
            return new es(n);
        } : Da, Os = os ? function(n) {
            return os.get(n);
        } : Da, Is = Pl ? function(n) {
            return null == n ? [] : (n = ll(n), i(Pl(n), function(t) {
                return Wl.call(n, t);
            }));
        } : Pa, Rs = Pl ? function(n) {
            for(var t = []; n;)a(t, Is(n)), n = El(n);
            return t;
        } : Pa, zs = we;
        (ns && zs(new ns(new ArrayBuffer(1))) != ct || ts && zs(new ts()) != Gn || rs && zs(rs.resolve()) != Qn || es && zs(new es()) != tt || us && zs(new us()) != it) && (zs = function(n) {
            var t = we(n), r = t == Yn ? n.constructor : X, e = r ? to(r) : "";
            if (e) switch(e){
                case cs:
                    return ct;
                case as:
                    return Gn;
                case ls:
                    return Qn;
                case ss:
                    return tt;
                case hs:
                    return it;
            }
            return t;
        });
        var Es = yl ? uc : qa, Ss = Qi(ms), Ws = Ml || function(n, t) {
            return re.setTimeout(n, t);
        }, Ls = Qi(xs), Cs = Pi(function(n) {
            var t = [];
            return 46 === n.charCodeAt(0) && t.push(""), n.replace(Et, function(n, r, e, u) {
                t.push(e ? u.replace(Mt, "$1") : r || n);
            }), t;
        }), Us = uu(function(n, t) {
            return Jf(n) ? Hr(n, ee(t, 1, Jf, !0)) : [];
        }), Bs = uu(function(n, t) {
            var r = jo(t);
            return Jf(r) && (r = X), Jf(n) ? Hr(n, ee(t, 1, Jf, !0), mi(r, 2)) : [];
        }), Ts = uu(function(n, t) {
            var r = jo(t);
            return Jf(r) && (r = X), Jf(n) ? Hr(n, ee(t, 1, Jf, !0), X, r) : [];
        }), $s = uu(function(n) {
            var t = c(n, ju);
            return t.length && t[0] === n[0] ? ke(t) : [];
        }), Ds = uu(function(n) {
            var t = jo(n), r = c(n, ju);
            return t === jo(r) ? t = X : r.pop(), r.length && r[0] === n[0] ? ke(r, mi(t, 2)) : [];
        }), Ms = uu(function(n) {
            var t = jo(n), r = c(n, ju);
            return t = "function" == typeof t ? t : X, t && r.pop(), r.length && r[0] === n[0] ? ke(r, X, t) : [];
        }), Fs = uu(Oo), Ns = gi(function(n, t) {
            var r = null == n ? 0 : n.length, e = Tr(n, t);
            return nu(n, c(t, function(n) {
                return Ci(n, r) ? +n : n;
            }).sort(Lu)), e;
        }), Ps = uu(function(n) {
            return gu(ee(n, 1, Jf, !0));
        }), qs = uu(function(n) {
            var t = jo(n);
            return Jf(t) && (t = X), gu(ee(n, 1, Jf, !0), mi(t, 2));
        }), Zs = uu(function(n) {
            var t = jo(n);
            return t = "function" == typeof t ? t : X, gu(ee(n, 1, Jf, !0), X, t);
        }), Ks = uu(function(n, t) {
            return Jf(n) ? Hr(n, t) : [];
        }), Vs = uu(function(n) {
            return mu(i(n, Jf));
        }), Gs = uu(function(n) {
            var t = jo(n);
            return Jf(t) && (t = X), mu(i(n, Jf), mi(t, 2));
        }), Hs = uu(function(n) {
            var t = jo(n);
            return t = "function" == typeof t ? t : X, mu(i(n, Jf), X, t);
        }), Js = uu(Go), Ys = uu(function(n) {
            var t = n.length, r = t > 1 ? n[t - 1] : X;
            return r = "function" == typeof r ? (n.pop(), r) : X, Ho(n, r);
        }), Qs = gi(function(n) {
            var t = n.length, r = t ? n[0] : 0, e = this.__wrapped__, u = function(t) {
                return Tr(t, n);
            };
            return !(t > 1 || this.__actions__.length) && e instanceof Ct && Ci(r) ? (e = e.slice(r, +r + (t ? 1 : 0)), e.__actions__.push({
                func: nf,
                args: [
                    u
                ],
                thisArg: X
            }), new Y(e, this.__chain__).thru(function(n) {
                return t && !n.length && n.push(X), n;
            })) : this.thru(u);
        }), Xs = Fu(function(n, t, r) {
            bl.call(n, r) ? ++n[r] : Br(n, r, 1);
        }), nh = Ju(ho), th = Ju(po), rh = Fu(function(n, t, r) {
            bl.call(n, r) ? n[r].push(t) : Br(n, r, [
                t
            ]);
        }), eh = uu(function(t, r, e) {
            var u = -1, i = "function" == typeof r, o = Hf(t) ? il(t.length) : [];
            return ys(t, function(t) {
                o[++u] = i ? n(r, t, e) : Ie(t, r, e);
            }), o;
        }), uh = Fu(function(n, t, r) {
            Br(n, r, t);
        }), ih = Fu(function(n, t, r) {
            n[r ? 0 : 1].push(t);
        }, function() {
            return [
                [],
                []
            ];
        }), oh = uu(function(n, t) {
            if (null == n) return [];
            var r = t.length;
            return r > 1 && Ui(n, t[0], t[1]) ? t = [] : r > 2 && Ui(t[0], t[1], t[2]) && (t = [
                t[0]
            ]), He(n, ee(t, 1), []);
        }), fh = Dl || function() {
            return re.Date.now();
        }, ch = uu(function(n, t, r) {
            var e = _n;
            if (r.length) {
                var u = N(r, wi(ch));
                e |= bn;
            }
            return ai(n, e, t, r, u);
        }), ah = uu(function(n, t, r) {
            var e = _n | vn;
            if (r.length) {
                var u = N(r, wi(ah));
                e |= bn;
            }
            return ai(t, e, n, r, u);
        }), lh = uu(function(n, t) {
            return Gr(n, 1, t);
        }), sh = uu(function(n, t, r) {
            return Gr(n, Ic(t) || 0, r);
        });
        Cf.Cache = sr;
        var hh = js(function(t, r) {
            r = 1 == r.length && bh(r[0]) ? c(r[0], z(mi())) : c(ee(r, 1), z(mi()));
            var e = r.length;
            return uu(function(u) {
                for(var i = -1, o = Hl(u.length, e); ++i < o;)u[i] = r[i].call(this, u[i]);
                return n(t, this, u);
            });
        }), ph = uu(function(n, t) {
            return ai(n, bn, X, t, N(t, wi(ph)));
        }), _h = uu(function(n, t) {
            return ai(n, wn, X, t, N(t, wi(_h)));
        }), vh = gi(function(n, t) {
            return ai(n, xn, X, X, X, t);
        }), gh = ii(me), yh = ii(function(n, t) {
            return n >= t;
        }), dh = Re(function() {
            return arguments;
        }()) ? Re : function(n) {
            return cc(n) && bl.call(n, "callee") && !Wl.call(n, "callee");
        }, bh = il.isArray, wh = ce ? z(ce) : ze, mh = ql || qa, xh = ae ? z(ae) : Ee, jh = le ? z(le) : Le, Ah = se ? z(se) : Be, kh = he ? z(he) : Te, Oh = pe ? z(pe) : $e, Ih = ii(Ne), Rh = ii(function(n, t) {
            return n <= t;
        }), zh = Nu(function(n, t) {
            if (Mi(t) || Hf(t)) return $u(t, Pc(t), n), X;
            for(var r in t)bl.call(t, r) && Sr(n, r, t[r]);
        }), Eh = Nu(function(n, t) {
            $u(t, qc(t), n);
        }), Sh = Nu(function(n, t, r, e) {
            $u(t, qc(t), n, e);
        }), Wh = Nu(function(n, t, r, e) {
            $u(t, Pc(t), n, e);
        }), Lh = gi(Tr), Ch = uu(function(n, t) {
            n = ll(n);
            var r = -1, e = t.length, u = e > 2 ? t[2] : X;
            for(u && Ui(t[0], t[1], u) && (e = 1); ++r < e;)for(var i = t[r], o = qc(i), f = -1, c = o.length; ++f < c;){
                var a = o[f], l = n[a];
                (l === X || Gf(l, gl[a]) && !bl.call(n, a)) && (n[a] = i[a]);
            }
            return n;
        }), Uh = uu(function(t) {
            return t.push(X, si), n(Mh, X, t);
        }), Bh = Xu(function(n, t, r) {
            null != t && "function" != typeof t.toString && (t = xl.call(t)), n[t] = r;
        }, Sa(La)), Th = Xu(function(n, t, r) {
            null != t && "function" != typeof t.toString && (t = xl.call(t)), bl.call(n, t) ? n[t].push(r) : n[t] = [
                r
            ];
        }, mi), $h = uu(Ie), Dh = Nu(function(n, t, r) {
            Ke(n, t, r);
        }), Mh = Nu(function(n, t, r, e) {
            Ke(n, t, r, e);
        }), Fh = gi(function(n, t) {
            var r = {};
            if (null == n) return r;
            var e = !1;
            t = c(t, function(t) {
                return t = ku(t, n), e || (e = t.length > 1), t;
            }), $u(n, di(n), r), e && (r = Fr(r, an | ln | sn, hi));
            for(var u = t.length; u--;)yu(r, t[u]);
            return r;
        }), Nh = gi(function(n, t) {
            return null == n ? {} : Je(n, t);
        }), Ph = ci(Pc), qh = ci(qc), Zh = Vu(function(n, t, r) {
            return t = t.toLowerCase(), n + (r ? fa(t) : t);
        }), Kh = Vu(function(n, t, r) {
            return n + (r ? "-" : "") + t.toLowerCase();
        }), Vh = Vu(function(n, t, r) {
            return n + (r ? " " : "") + t.toLowerCase();
        }), Gh = Ku("toLowerCase"), Hh = Vu(function(n, t, r) {
            return n + (r ? "_" : "") + t.toLowerCase();
        }), Jh = Vu(function(n, t, r) {
            return n + (r ? " " : "") + Qh(t);
        }), Yh = Vu(function(n, t, r) {
            return n + (r ? " " : "") + t.toUpperCase();
        }), Qh = Ku("toUpperCase"), Xh = uu(function(t, r) {
            try {
                return n(t, X, r);
            } catch (n) {
                return rc(n) ? n : new fl(n);
            }
        }), np = gi(function(n, t) {
            return r(t, function(t) {
                t = no(t), Br(n, t, ch(n[t], n));
            }), n;
        }), tp = Yu(), rp = Yu(!0), ep = uu(function(n, t) {
            return function(r) {
                return Ie(r, n, t);
            };
        }), up = uu(function(n, t) {
            return function(r) {
                return Ie(n, r, t);
            };
        }), ip = ti(c), op = ti(u), fp = ti(h), cp = ui(), ap = ui(!0), lp = ni(function(n, t) {
            return n + t;
        }, 0), sp = fi("ceil"), hp = ni(function(n, t) {
            return n / t;
        }, 1), pp = fi("floor"), _p = ni(function(n, t) {
            return n * t;
        }, 1), vp = fi("round"), gp = ni(function(n, t) {
            return n - t;
        }, 0);
        return Z.after = If, Z.ary = Rf, Z.assign = zh, Z.assignIn = Eh, Z.assignInWith = Sh, Z.assignWith = Wh, Z.at = Lh, Z.before = zf, Z.bind = ch, Z.bindAll = np, Z.bindKey = ah, Z.castArray = Nf, Z.chain = Qo, Z.chunk = uo, Z.compact = io, Z.concat = oo, Z.cond = za, Z.conforms = Ea, Z.constant = Sa, Z.countBy = Xs, Z.create = Sc, Z.curry = Ef, Z.curryRight = Sf, Z.debounce = Wf, Z.defaults = Ch, Z.defaultsDeep = Uh, Z.defer = lh, Z.delay = sh, Z.difference = Us, Z.differenceBy = Bs, Z.differenceWith = Ts, Z.drop = fo, Z.dropRight = co, Z.dropRightWhile = ao, Z.dropWhile = lo, Z.fill = so, Z.filter = lf, Z.flatMap = sf, Z.flatMapDeep = hf, Z.flatMapDepth = pf, Z.flatten = _o, Z.flattenDeep = vo, Z.flattenDepth = go, Z.flip = Lf, Z.flow = tp, Z.flowRight = rp, Z.fromPairs = yo, Z.functions = $c, Z.functionsIn = Dc, Z.groupBy = rh, Z.initial = mo, Z.intersection = $s, Z.intersectionBy = Ds, Z.intersectionWith = Ms, Z.invert = Bh, Z.invertBy = Th, Z.invokeMap = eh, Z.iteratee = Ca, Z.keyBy = uh, Z.keys = Pc, Z.keysIn = qc, Z.map = yf, Z.mapKeys = Zc, Z.mapValues = Kc, Z.matches = Ua, Z.matchesProperty = Ba, Z.memoize = Cf, Z.merge = Dh, Z.mergeWith = Mh, Z.method = ep, Z.methodOf = up, Z.mixin = Ta, Z.negate = Uf, Z.nthArg = Ma, Z.omit = Fh, Z.omitBy = Vc, Z.once = Bf, Z.orderBy = df, Z.over = ip, Z.overArgs = hh, Z.overEvery = op, Z.overSome = fp, Z.partial = ph, Z.partialRight = _h, Z.partition = ih, Z.pick = Nh, Z.pickBy = Gc, Z.property = Fa, Z.propertyOf = Na, Z.pull = Fs, Z.pullAll = Oo, Z.pullAllBy = Io, Z.pullAllWith = Ro, Z.pullAt = Ns, Z.range = cp, Z.rangeRight = ap, Z.rearg = vh, Z.reject = mf, Z.remove = zo, Z.rest = Tf, Z.reverse = Eo, Z.sampleSize = jf, Z.set = Jc, Z.setWith = Yc, Z.shuffle = Af, Z.slice = So, Z.sortBy = oh, Z.sortedUniq = $o, Z.sortedUniqBy = Do, Z.split = da, Z.spread = $f, Z.tail = Mo, Z.take = Fo, Z.takeRight = No, Z.takeRightWhile = Po, Z.takeWhile = qo, Z.tap = Xo, Z.throttle = Df, Z.thru = nf, Z.toArray = jc, Z.toPairs = Ph, Z.toPairsIn = qh, Z.toPath = Ha, Z.toPlainObject = Rc, Z.transform = Qc, Z.unary = Mf, Z.union = Ps, Z.unionBy = qs, Z.unionWith = Zs, Z.uniq = Zo, Z.uniqBy = Ko, Z.uniqWith = Vo, Z.unset = Xc, Z.unzip = Go, Z.unzipWith = Ho, Z.update = na, Z.updateWith = ta, Z.values = ra, Z.valuesIn = ea, Z.without = Ks, Z.words = Ra, Z.wrap = Ff, Z.xor = Vs, Z.xorBy = Gs, Z.xorWith = Hs, Z.zip = Js, Z.zipObject = Jo, Z.zipObjectDeep = Yo, Z.zipWith = Ys, Z.entries = Ph, Z.entriesIn = qh, Z.extend = Eh, Z.extendWith = Sh, Ta(Z, Z), Z.add = lp, Z.attempt = Xh, Z.camelCase = Zh, Z.capitalize = fa, Z.ceil = sp, Z.clamp = ua, Z.clone = Pf, Z.cloneDeep = Zf, Z.cloneDeepWith = Kf, Z.cloneWith = qf, Z.conformsTo = Vf, Z.deburr = ca, Z.defaultTo = Wa, Z.divide = hp, Z.endsWith = aa, Z.eq = Gf, Z.escape = la, Z.escapeRegExp = sa, Z.every = af, Z.find = nh, Z.findIndex = ho, Z.findKey = Wc, Z.findLast = th, Z.findLastIndex = po, Z.findLastKey = Lc, Z.floor = pp, Z.forEach = _f, Z.forEachRight = vf, Z.forIn = Cc, Z.forInRight = Uc, Z.forOwn = Bc, Z.forOwnRight = Tc, Z.get = Mc, Z.gt = gh, Z.gte = yh, Z.has = Fc, Z.hasIn = Nc, Z.head = bo, Z.identity = La, Z.includes = gf, Z.indexOf = wo, Z.inRange = ia, Z.invoke = $h, Z.isArguments = dh, Z.isArray = bh, Z.isArrayBuffer = wh, Z.isArrayLike = Hf, Z.isArrayLikeObject = Jf, Z.isBoolean = Yf, Z.isBuffer = mh, Z.isDate = xh, Z.isElement = Qf, Z.isEmpty = Xf, Z.isEqual = nc, Z.isEqualWith = tc, Z.isError = rc, Z.isFinite = ec, Z.isFunction = uc, Z.isInteger = ic, Z.isLength = oc, Z.isMap = jh, Z.isMatch = ac, Z.isMatchWith = lc, Z.isNaN = sc, Z.isNative = hc, Z.isNil = _c, Z.isNull = pc, Z.isNumber = vc, Z.isObject = fc, Z.isObjectLike = cc, Z.isPlainObject = gc, Z.isRegExp = Ah, Z.isSafeInteger = yc, Z.isSet = kh, Z.isString = dc, Z.isSymbol = bc, Z.isTypedArray = Oh, Z.isUndefined = wc, Z.isWeakMap = mc, Z.isWeakSet = xc, Z.join = xo, Z.kebabCase = Kh, Z.last = jo, Z.lastIndexOf = Ao, Z.lowerCase = Vh, Z.lowerFirst = Gh, Z.lt = Ih, Z.lte = Rh, Z.max = Ya, Z.maxBy = Qa, Z.mean = Xa, Z.meanBy = nl, Z.min = tl, Z.minBy = rl, Z.stubArray = Pa, Z.stubFalse = qa, Z.stubObject = Za, Z.stubString = Ka, Z.stubTrue = Va, Z.multiply = _p, Z.nth = ko, Z.noConflict = $a, Z.noop = Da, Z.now = fh, Z.pad = ha, Z.padEnd = pa, Z.padStart = _a, Z.parseInt = va, Z.random = oa, Z.reduce = bf, Z.reduceRight = wf, Z.repeat = ga, Z.replace = ya, Z.result = Hc, Z.round = vp, Z.runInContext = p, Z.sample = xf, Z.size = kf, Z.snakeCase = Hh, Z.some = Of, Z.sortedIndex = Wo, Z.sortedIndexBy = Lo, Z.sortedIndexOf = Co, Z.sortedLastIndex = Uo, Z.sortedLastIndexBy = Bo, Z.sortedLastIndexOf = To, Z.startCase = Jh, Z.startsWith = ba, Z.subtract = gp, Z.sum = el, Z.sumBy = ul, Z.template = wa, Z.times = Ga, Z.toFinite = Ac, Z.toInteger = kc, Z.toLength = Oc, Z.toLower = ma, Z.toNumber = Ic, Z.toSafeInteger = zc, Z.toString = Ec, Z.toUpper = xa, Z.trim = ja, Z.trimEnd = Aa, Z.trimStart = ka, Z.truncate = Oa, Z.unescape = Ia, Z.uniqueId = Ja, Z.upperCase = Yh, Z.upperFirst = Qh, Z.each = _f, Z.eachRight = vf, Z.first = bo, Ta(Z, function() {
            var n = {};
            return ue(Z, function(t, r) {
                bl.call(Z.prototype, r) || (n[r] = t);
            }), n;
        }(), {
            chain: !1
        }), Z.VERSION = nn, r([
            "bind",
            "bindKey",
            "curry",
            "curryRight",
            "partial",
            "partialRight"
        ], function(n) {
            Z[n].placeholder = Z;
        }), r([
            "drop",
            "take"
        ], function(n, t) {
            Ct.prototype[n] = function(r) {
                r = r === X ? 1 : Gl(kc(r), 0);
                var e = this.__filtered__ && !t ? new Ct(this) : this.clone();
                return e.__filtered__ ? e.__takeCount__ = Hl(r, e.__takeCount__) : e.__views__.push({
                    size: Hl(r, Un),
                    type: n + (e.__dir__ < 0 ? "Right" : "")
                }), e;
            }, Ct.prototype[n + "Right"] = function(t) {
                return this.reverse()[n](t).reverse();
            };
        }), r([
            "filter",
            "map",
            "takeWhile"
        ], function(n, t) {
            var r = t + 1, e = r == Rn || r == En;
            Ct.prototype[n] = function(n) {
                var t = this.clone();
                return t.__iteratees__.push({
                    iteratee: mi(n, 3),
                    type: r
                }), t.__filtered__ = t.__filtered__ || e, t;
            };
        }), r([
            "head",
            "last"
        ], function(n, t) {
            var r = "take" + (t ? "Right" : "");
            Ct.prototype[n] = function() {
                return this[r](1).value()[0];
            };
        }), r([
            "initial",
            "tail"
        ], function(n, t) {
            var r = "drop" + (t ? "" : "Right");
            Ct.prototype[n] = function() {
                return this.__filtered__ ? new Ct(this) : this[r](1);
            };
        }), Ct.prototype.compact = function() {
            return this.filter(La);
        }, Ct.prototype.find = function(n) {
            return this.filter(n).head();
        }, Ct.prototype.findLast = function(n) {
            return this.reverse().find(n);
        }, Ct.prototype.invokeMap = uu(function(n, t) {
            return "function" == typeof n ? new Ct(this) : this.map(function(r) {
                return Ie(r, n, t);
            });
        }), Ct.prototype.reject = function(n) {
            return this.filter(Uf(mi(n)));
        }, Ct.prototype.slice = function(n, t) {
            n = kc(n);
            var r = this;
            return r.__filtered__ && (n > 0 || t < 0) ? new Ct(r) : (n < 0 ? r = r.takeRight(-n) : n && (r = r.drop(n)), t !== X && (t = kc(t), r = t < 0 ? r.dropRight(-t) : r.take(t - n)), r);
        }, Ct.prototype.takeRightWhile = function(n) {
            return this.reverse().takeWhile(n).reverse();
        }, Ct.prototype.toArray = function() {
            return this.take(Un);
        }, ue(Ct.prototype, function(n, t) {
            var r = /^(?:filter|find|map|reject)|While$/.test(t), e = /^(?:head|last)$/.test(t), u = Z[e ? "take" + ("last" == t ? "Right" : "") : t], i = e || /^find/.test(t);
            u && (Z.prototype[t] = function() {
                var t = this.__wrapped__, o = e ? [
                    1
                ] : arguments, f = t instanceof Ct, c = o[0], l = f || bh(t), s = function(n) {
                    var t = u.apply(Z, a([
                        n
                    ], o));
                    return e && h ? t[0] : t;
                };
                l && r && "function" == typeof c && 1 != c.length && (f = l = !1);
                var h = this.__chain__, p = !!this.__actions__.length, _ = i && !h, v = f && !p;
                if (!i && l) {
                    t = v ? t : new Ct(this);
                    var g = n.apply(t, o);
                    return g.__actions__.push({
                        func: nf,
                        args: [
                            s
                        ],
                        thisArg: X
                    }), new Y(g, h);
                }
                return _ && v ? n.apply(this, o) : (g = this.thru(s), _ ? e ? g.value()[0] : g.value() : g);
            });
        }), r([
            "pop",
            "push",
            "shift",
            "sort",
            "splice",
            "unshift"
        ], function(n) {
            var t = _l[n], r = /^(?:push|sort|unshift)$/.test(n) ? "tap" : "thru", e = /^(?:pop|shift)$/.test(n);
            Z.prototype[n] = function() {
                var n = arguments;
                if (e && !this.__chain__) {
                    var u = this.value();
                    return t.apply(bh(u) ? u : [], n);
                }
                return this[r](function(r) {
                    return t.apply(bh(r) ? r : [], n);
                });
            };
        }), ue(Ct.prototype, function(n, t) {
            var r = Z[t];
            if (r) {
                var e = r.name + "";
                bl.call(fs, e) || (fs[e] = []), fs[e].push({
                    name: t,
                    func: r
                });
            }
        }), fs[Qu(X, vn).name] = [
            {
                name: "wrapper",
                func: X
            }
        ], Ct.prototype.clone = $t, Ct.prototype.reverse = Yt, Ct.prototype.value = Qt, Z.prototype.at = Qs, Z.prototype.chain = tf, Z.prototype.commit = rf, Z.prototype.next = ef, Z.prototype.plant = of, Z.prototype.reverse = ff, Z.prototype.toJSON = Z.prototype.valueOf = Z.prototype.value = cf, Z.prototype.first = Z.prototype.head, Ul && (Z.prototype[Ul] = uf), Z;
    }, be = de();
    "function" == typeof define && "object" == typeof define.amd && define.amd ? (re._ = be, define(function() {
        return be;
    })) : ue ? ((ue.exports = be)._ = be, ee._ = be) : re._ = be;
}).call(this);

});

parcelRequire.register("R5nvG", function(module, exports) {
var global = typeof self !== "undefined" ? self : this;
var __self__ = function() {
    function F() {
        this.fetch = false;
        this.DOMException = global.DOMException;
    }
    F.prototype = global;
    return new F();
}();
(function(self1) {
    var irrelevant = function(exports1) {
        var support = {
            searchParams: "URLSearchParams" in self1,
            iterable: "Symbol" in self1 && "iterator" in Symbol,
            blob: "FileReader" in self1 && "Blob" in self1 && function() {
                try {
                    new Blob();
                    return true;
                } catch (e) {
                    return false;
                }
            }(),
            formData: "FormData" in self1,
            arrayBuffer: "ArrayBuffer" in self1
        };
        function isDataView(obj) {
            return obj && DataView.prototype.isPrototypeOf(obj);
        }
        if (support.arrayBuffer) {
            var viewClasses = [
                "[object Int8Array]",
                "[object Uint8Array]",
                "[object Uint8ClampedArray]",
                "[object Int16Array]",
                "[object Uint16Array]",
                "[object Int32Array]",
                "[object Uint32Array]",
                "[object Float32Array]",
                "[object Float64Array]"
            ];
            var isArrayBufferView = ArrayBuffer.isView || function(obj) {
                return obj && viewClasses.indexOf(Object.prototype.toString.call(obj)) > -1;
            };
        }
        function normalizeName(name) {
            if (typeof name !== "string") name = String(name);
            if (/[^a-z0-9\-#$%&'*+.^_`|~]/i.test(name)) throw new TypeError("Invalid character in header field name");
            return name.toLowerCase();
        }
        function normalizeValue(value) {
            if (typeof value !== "string") value = String(value);
            return value;
        }
        // Build a destructive iterator for the value list
        function iteratorFor(items) {
            var iterator = {
                next: function() {
                    var value = items.shift();
                    return {
                        done: value === undefined,
                        value: value
                    };
                }
            };
            if (support.iterable) iterator[Symbol.iterator] = function() {
                return iterator;
            };
            return iterator;
        }
        function Headers(headers) {
            this.map = {};
            if (headers instanceof Headers) headers.forEach(function(value, name) {
                this.append(name, value);
            }, this);
            else if (Array.isArray(headers)) headers.forEach(function(header) {
                this.append(header[0], header[1]);
            }, this);
            else if (headers) Object.getOwnPropertyNames(headers).forEach(function(name) {
                this.append(name, headers[name]);
            }, this);
        }
        Headers.prototype.append = function(name, value) {
            name = normalizeName(name);
            value = normalizeValue(value);
            var oldValue = this.map[name];
            this.map[name] = oldValue ? oldValue + ", " + value : value;
        };
        Headers.prototype["delete"] = function(name) {
            delete this.map[normalizeName(name)];
        };
        Headers.prototype.get = function(name) {
            name = normalizeName(name);
            return this.has(name) ? this.map[name] : null;
        };
        Headers.prototype.has = function(name) {
            return this.map.hasOwnProperty(normalizeName(name));
        };
        Headers.prototype.set = function(name, value) {
            this.map[normalizeName(name)] = normalizeValue(value);
        };
        Headers.prototype.forEach = function(callback, thisArg) {
            for(var name in this.map)if (this.map.hasOwnProperty(name)) callback.call(thisArg, this.map[name], name, this);
        };
        Headers.prototype.keys = function() {
            var items = [];
            this.forEach(function(value, name) {
                items.push(name);
            });
            return iteratorFor(items);
        };
        Headers.prototype.values = function() {
            var items = [];
            this.forEach(function(value) {
                items.push(value);
            });
            return iteratorFor(items);
        };
        Headers.prototype.entries = function() {
            var items = [];
            this.forEach(function(value, name) {
                items.push([
                    name,
                    value
                ]);
            });
            return iteratorFor(items);
        };
        if (support.iterable) Headers.prototype[Symbol.iterator] = Headers.prototype.entries;
        function consumed(body) {
            if (body.bodyUsed) return Promise.reject(new TypeError("Already read"));
            body.bodyUsed = true;
        }
        function fileReaderReady(reader) {
            return new Promise(function(resolve, reject) {
                reader.onload = function() {
                    resolve(reader.result);
                };
                reader.onerror = function() {
                    reject(reader.error);
                };
            });
        }
        function readBlobAsArrayBuffer(blob) {
            var reader = new FileReader();
            var promise = fileReaderReady(reader);
            reader.readAsArrayBuffer(blob);
            return promise;
        }
        function readBlobAsText(blob) {
            var reader = new FileReader();
            var promise = fileReaderReady(reader);
            reader.readAsText(blob);
            return promise;
        }
        function readArrayBufferAsText(buf) {
            var view = new Uint8Array(buf);
            var chars = new Array(view.length);
            for(var i = 0; i < view.length; i++)chars[i] = String.fromCharCode(view[i]);
            return chars.join("");
        }
        function bufferClone(buf) {
            if (buf.slice) return buf.slice(0);
            else {
                var view = new Uint8Array(buf.byteLength);
                view.set(new Uint8Array(buf));
                return view.buffer;
            }
        }
        function Body() {
            this.bodyUsed = false;
            this._initBody = function(body) {
                this._bodyInit = body;
                if (!body) this._bodyText = "";
                else if (typeof body === "string") this._bodyText = body;
                else if (support.blob && Blob.prototype.isPrototypeOf(body)) this._bodyBlob = body;
                else if (support.formData && FormData.prototype.isPrototypeOf(body)) this._bodyFormData = body;
                else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) this._bodyText = body.toString();
                else if (support.arrayBuffer && support.blob && isDataView(body)) {
                    this._bodyArrayBuffer = bufferClone(body.buffer);
                    // IE 10-11 can't handle a DataView body.
                    this._bodyInit = new Blob([
                        this._bodyArrayBuffer
                    ]);
                } else if (support.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(body) || isArrayBufferView(body))) this._bodyArrayBuffer = bufferClone(body);
                else this._bodyText = body = Object.prototype.toString.call(body);
                if (!this.headers.get("content-type")) {
                    if (typeof body === "string") this.headers.set("content-type", "text/plain;charset=UTF-8");
                    else if (this._bodyBlob && this._bodyBlob.type) this.headers.set("content-type", this._bodyBlob.type);
                    else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) this.headers.set("content-type", "application/x-www-form-urlencoded;charset=UTF-8");
                }
            };
            if (support.blob) {
                this.blob = function() {
                    var rejected = consumed(this);
                    if (rejected) return rejected;
                    if (this._bodyBlob) return Promise.resolve(this._bodyBlob);
                    else if (this._bodyArrayBuffer) return Promise.resolve(new Blob([
                        this._bodyArrayBuffer
                    ]));
                    else if (this._bodyFormData) throw new Error("could not read FormData body as blob");
                    else return Promise.resolve(new Blob([
                        this._bodyText
                    ]));
                };
                this.arrayBuffer = function() {
                    if (this._bodyArrayBuffer) return consumed(this) || Promise.resolve(this._bodyArrayBuffer);
                    else return this.blob().then(readBlobAsArrayBuffer);
                };
            }
            this.text = function() {
                var rejected = consumed(this);
                if (rejected) return rejected;
                if (this._bodyBlob) return readBlobAsText(this._bodyBlob);
                else if (this._bodyArrayBuffer) return Promise.resolve(readArrayBufferAsText(this._bodyArrayBuffer));
                else if (this._bodyFormData) throw new Error("could not read FormData body as text");
                else return Promise.resolve(this._bodyText);
            };
            if (support.formData) this.formData = function() {
                return this.text().then(decode);
            };
            this.json = function() {
                return this.text().then(JSON.parse);
            };
            return this;
        }
        // HTTP methods whose capitalization should be normalized
        var methods = [
            "DELETE",
            "GET",
            "HEAD",
            "OPTIONS",
            "POST",
            "PUT"
        ];
        function normalizeMethod(method) {
            var upcased = method.toUpperCase();
            return methods.indexOf(upcased) > -1 ? upcased : method;
        }
        function Request(input, options) {
            options = options || {};
            var body = options.body;
            if (input instanceof Request) {
                if (input.bodyUsed) throw new TypeError("Already read");
                this.url = input.url;
                this.credentials = input.credentials;
                if (!options.headers) this.headers = new Headers(input.headers);
                this.method = input.method;
                this.mode = input.mode;
                this.signal = input.signal;
                if (!body && input._bodyInit != null) {
                    body = input._bodyInit;
                    input.bodyUsed = true;
                }
            } else this.url = String(input);
            this.credentials = options.credentials || this.credentials || "same-origin";
            if (options.headers || !this.headers) this.headers = new Headers(options.headers);
            this.method = normalizeMethod(options.method || this.method || "GET");
            this.mode = options.mode || this.mode || null;
            this.signal = options.signal || this.signal;
            this.referrer = null;
            if ((this.method === "GET" || this.method === "HEAD") && body) throw new TypeError("Body not allowed for GET or HEAD requests");
            this._initBody(body);
        }
        Request.prototype.clone = function() {
            return new Request(this, {
                body: this._bodyInit
            });
        };
        function decode(body) {
            var form = new FormData();
            body.trim().split("&").forEach(function(bytes) {
                if (bytes) {
                    var split = bytes.split("=");
                    var name = split.shift().replace(/\+/g, " ");
                    var value = split.join("=").replace(/\+/g, " ");
                    form.append(decodeURIComponent(name), decodeURIComponent(value));
                }
            });
            return form;
        }
        function parseHeaders(rawHeaders) {
            var headers = new Headers();
            // Replace instances of \r\n and \n followed by at least one space or horizontal tab with a space
            // https://tools.ietf.org/html/rfc7230#section-3.2
            var preProcessedHeaders = rawHeaders.replace(/\r?\n[\t ]+/g, " ");
            preProcessedHeaders.split(/\r?\n/).forEach(function(line) {
                var parts = line.split(":");
                var key = parts.shift().trim();
                if (key) {
                    var value = parts.join(":").trim();
                    headers.append(key, value);
                }
            });
            return headers;
        }
        Body.call(Request.prototype);
        function Response(bodyInit, options) {
            if (!options) options = {};
            this.type = "default";
            this.status = options.status === undefined ? 200 : options.status;
            this.ok = this.status >= 200 && this.status < 300;
            this.statusText = "statusText" in options ? options.statusText : "OK";
            this.headers = new Headers(options.headers);
            this.url = options.url || "";
            this._initBody(bodyInit);
        }
        Body.call(Response.prototype);
        Response.prototype.clone = function() {
            return new Response(this._bodyInit, {
                status: this.status,
                statusText: this.statusText,
                headers: new Headers(this.headers),
                url: this.url
            });
        };
        Response.error = function() {
            var response = new Response(null, {
                status: 0,
                statusText: ""
            });
            response.type = "error";
            return response;
        };
        var redirectStatuses = [
            301,
            302,
            303,
            307,
            308
        ];
        Response.redirect = function(url, status) {
            if (redirectStatuses.indexOf(status) === -1) throw new RangeError("Invalid status code");
            return new Response(null, {
                status: status,
                headers: {
                    location: url
                }
            });
        };
        exports1.DOMException = self1.DOMException;
        try {
            new exports1.DOMException();
        } catch (err) {
            exports1.DOMException = function(message, name) {
                this.message = message;
                this.name = name;
                var error = Error(message);
                this.stack = error.stack;
            };
            exports1.DOMException.prototype = Object.create(Error.prototype);
            exports1.DOMException.prototype.constructor = exports1.DOMException;
        }
        function fetch(input, init) {
            return new Promise(function(resolve, reject) {
                var request = new Request(input, init);
                if (request.signal && request.signal.aborted) return reject(new exports1.DOMException("Aborted", "AbortError"));
                var xhr = new XMLHttpRequest();
                function abortXhr() {
                    xhr.abort();
                }
                xhr.onload = function() {
                    var options = {
                        status: xhr.status,
                        statusText: xhr.statusText,
                        headers: parseHeaders(xhr.getAllResponseHeaders() || "")
                    };
                    options.url = "responseURL" in xhr ? xhr.responseURL : options.headers.get("X-Request-URL");
                    var body = "response" in xhr ? xhr.response : xhr.responseText;
                    resolve(new Response(body, options));
                };
                xhr.onerror = function() {
                    reject(new TypeError("Network request failed"));
                };
                xhr.ontimeout = function() {
                    reject(new TypeError("Network request failed"));
                };
                xhr.onabort = function() {
                    reject(new exports1.DOMException("Aborted", "AbortError"));
                };
                xhr.open(request.method, request.url, true);
                if (request.credentials === "include") xhr.withCredentials = true;
                else if (request.credentials === "omit") xhr.withCredentials = false;
                if ("responseType" in xhr && support.blob) xhr.responseType = "blob";
                request.headers.forEach(function(value, name) {
                    xhr.setRequestHeader(name, value);
                });
                if (request.signal) {
                    request.signal.addEventListener("abort", abortXhr);
                    xhr.onreadystatechange = function() {
                        // DONE (success or failure)
                        if (xhr.readyState === 4) request.signal.removeEventListener("abort", abortXhr);
                    };
                }
                xhr.send(typeof request._bodyInit === "undefined" ? null : request._bodyInit);
            });
        }
        fetch.polyfill = true;
        if (!self1.fetch) {
            self1.fetch = fetch;
            self1.Headers = Headers;
            self1.Request = Request;
            self1.Response = Response;
        }
        exports1.Headers = Headers;
        exports1.Request = Request;
        exports1.Response = Response;
        exports1.fetch = fetch;
        Object.defineProperty(exports1, "__esModule", {
            value: true
        });
        return exports1;
    }({});
})(__self__);
__self__.fetch.ponyfill = true;
// Remove "polyfill" property added by whatwg-fetch
delete __self__.fetch.polyfill;
// Choose between native implementation (global) or custom implementation (__self__)
// var ctx = global.fetch ? global : __self__;
var ctx = __self__; // this line disable service worker support temporarily
exports = ctx.fetch // To enable: import fetch from 'cross-fetch'
;
exports.default = ctx.fetch // For TypeScript consumers without esModuleInterop.
;
exports.fetch = ctx.fetch // To enable: import {fetch} from 'cross-fetch'
;
exports.Headers = ctx.Headers;
exports.Request = ctx.Request;
exports.Response = ctx.Response;
module.exports = exports;

});

var $7b02d682eb115277$exports = {};
"use strict";

$7b02d682eb115277$exports = (parcelRequire("1b2ls"));


var $11492dca620dcaa5$exports = {};
"use strict";
function $11492dca620dcaa5$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === "undefined" || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== "function") return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($11492dca620dcaa5$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$11492dca620dcaa5$var$checkDCE();

$11492dca620dcaa5$exports = (parcelRequire("Xw6Mv"));




var $acw62 = parcelRequire("acw62");


var $acw62 = parcelRequire("acw62");
const $5cdc329eeebd56d0$export$1a988e7317c65621 = {
    redirectTo: "redirectTo",
    connectionkey: "filecatalystExpress.key",
    oidcClientId: "oidcClientId",
    fcloginPagePath: "fcloginpath",
    fcerrorparam: "fcerr",
    nonceCookieName: (oauthType)=>{
        return $5cdc329eeebd56d0$var$getNonceCookieName(oauthType);
    }
};
function $5cdc329eeebd56d0$var$getNonceCookieName(oauthType) {
    let cookieName = "";
    switch(oauthType){
        case "Okta":
            cookieName = "okta-oauth-nonce";
            break;
        default:
            cookieName = "okta-oauth-nonce";
            break;
    }
    return cookieName;
}



var $glDqU = parcelRequire("glDqU");
"use strict";
function $820877bea407f5fe$var$Utils() {}
$820877bea407f5fe$var$Utils.getQueryStringMap = (queryString)=>{
    var query = (queryString || self.location.search).substring(1); // delete ?
    if (!query) return false;
    return (0, $glDqU.chain)(query.split("&")).map(function(params) {
        var p = params.split("=");
        return [
            p[0],
            decodeURIComponent(p[1])
        ];
    }).fromPairs().value();
};
$820877bea407f5fe$var$Utils.parseQueryStringForRedirectTo = ()=>{
    if ($820877bea407f5fe$var$Utils.getQueryStringMap()[(0, $5cdc329eeebd56d0$export$1a988e7317c65621).redirectTo]) {
        const redirectTo = $820877bea407f5fe$var$Utils.getQueryStringMap()[(0, $5cdc329eeebd56d0$export$1a988e7317c65621).redirectTo];
        //store in the session just so
        sessionStorage.setItem((0, $5cdc329eeebd56d0$export$1a988e7317c65621).redirectTo, redirectTo);
    }
};
$820877bea407f5fe$var$Utils.getRedirectPage = ()=>{
    $820877bea407f5fe$var$Utils.parseQueryStringForRedirectTo();
    let redirectTo = sessionStorage.getItem((0, $5cdc329eeebd56d0$export$1a988e7317c65621).redirectTo);
    redirectTo = redirectTo ? redirectTo : "./express.html"; // By default navigating to express.
    return redirectTo;
};
$820877bea407f5fe$var$Utils.findConfigByClientId = (openIdConfigs, clientId)=>{
    return openIdConfigs.find((config)=>config.clientId === clientId);
};
$820877bea407f5fe$var$Utils.getCookieVal = (cookiName)=>{
    return window.document.cookie.split("; ").find((row)=>row.startsWith(`${cookiName}=`)).split("=")[1];
};
var $820877bea407f5fe$export$2e2bcd8739ae039 = $820877bea407f5fe$var$Utils;



class $1c5d27fb6ee3c0b3$export$2e2bcd8739ae039 {
    static info = async (message)=>await $1c5d27fb6ee3c0b3$export$2e2bcd8739ae039.logMessage("info", message);
    static error = async (message)=>await $1c5d27fb6ee3c0b3$export$2e2bcd8739ae039.logMessage("error", message);
    static debug = async (message)=>await $1c5d27fb6ee3c0b3$export$2e2bcd8739ae039.logMessage("debug", message);
    static basePath = "";
    static setup = (basePath)=>{
        $1c5d27fb6ee3c0b3$export$2e2bcd8739ae039.basePath = basePath;
    };
    static getLogsURL = ()=>{
        $1c5d27fb6ee3c0b3$export$2e2bcd8739ae039.basePath;
    };
    static logMessage = async (level, message)=>{
        console.log(`${level} : ${message}`);
    //   let url = `${FCLoggger.getLogsURL()}?message=${message}&level=${level}`;
    //   let fetchOptions = {
    //     method: "POST",
    //     headers: { "Content-Type": "application/json" },
    //     cache: "no-cache",
    //   };
    //   try {
    //     const response = await fetch(url, fetchOptions);
    //     console.log(`Message logged`);
    //     return response;
    //   } catch (error) {
    //     console.log(
    //       `Error trying to post logs ${error} to URL ${FCLoggger.getLogsURL()}`
    //     );
    //   }
    };
}


function $b8f57191916382d3$export$2e2bcd8739ae039(obj) {
    "@babel/helpers - typeof";
    return $b8f57191916382d3$export$2e2bcd8739ae039 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $b8f57191916382d3$export$2e2bcd8739ae039(obj);
}


function $4d35ca0862055760$export$2e2bcd8739ae039(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}




function $96eac03571e01dbf$export$2e2bcd8739ae039(input, hint) {
    if ((0, $b8f57191916382d3$export$2e2bcd8739ae039)(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ((0, $b8f57191916382d3$export$2e2bcd8739ae039)(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}


function $3a21fd50cbcd11cf$export$2e2bcd8739ae039(arg) {
    var key = (0, $96eac03571e01dbf$export$2e2bcd8739ae039)(arg, "string");
    return (0, $b8f57191916382d3$export$2e2bcd8739ae039)(key) === "symbol" ? key : String(key);
}


function $94019358ecbcf36b$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, (0, $3a21fd50cbcd11cf$export$2e2bcd8739ae039)(descriptor.key), descriptor);
    }
}
function $94019358ecbcf36b$export$2e2bcd8739ae039(Constructor, protoProps, staticProps) {
    if (protoProps) $94019358ecbcf36b$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $94019358ecbcf36b$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}


function $cd69a1d4c6210e44$export$2e2bcd8739ae039(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}


function $0ad5d8b55fe970db$export$2e2bcd8739ae039(o, p) {
    $0ad5d8b55fe970db$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $0ad5d8b55fe970db$export$2e2bcd8739ae039(o, p);
}


function $0ed648f7bbaf3aff$export$2e2bcd8739ae039(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) (0, $0ad5d8b55fe970db$export$2e2bcd8739ae039)(subClass, superClass);
}




function $6a259df8fa92dc4a$export$2e2bcd8739ae039(self, call) {
    if (call && ((0, $b8f57191916382d3$export$2e2bcd8739ae039)(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return (0, $cd69a1d4c6210e44$export$2e2bcd8739ae039)(self);
}


function $e4c5ebe502337db0$export$2e2bcd8739ae039(o) {
    $e4c5ebe502337db0$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $e4c5ebe502337db0$export$2e2bcd8739ae039(o);
}



function $f329557dcab6d0bb$export$2e2bcd8739ae039(obj, key, value) {
    key = (0, $3a21fd50cbcd11cf$export$2e2bcd8739ae039)(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}


function $1167ce760980f343$export$2e2bcd8739ae039(arr) {
    if (Array.isArray(arr)) return arr;
}


function $a0df324e6f81ee90$export$2e2bcd8739ae039(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}


function $5a337bca9556bfe7$export$2e2bcd8739ae039(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}


function $76af8a05551d5f25$export$2e2bcd8739ae039(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return (0, $5a337bca9556bfe7$export$2e2bcd8739ae039)(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return (0, $5a337bca9556bfe7$export$2e2bcd8739ae039)(o, minLen);
}


function $530b88ff20858fe6$export$2e2bcd8739ae039() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}


function $7d110e739ae14cc6$export$2e2bcd8739ae039(arr) {
    return (0, $1167ce760980f343$export$2e2bcd8739ae039)(arr) || (0, $a0df324e6f81ee90$export$2e2bcd8739ae039)(arr) || (0, $76af8a05551d5f25$export$2e2bcd8739ae039)(arr) || (0, $530b88ff20858fe6$export$2e2bcd8739ae039)();
}


function $673ff3dfc4a496de$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $673ff3dfc4a496de$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $673ff3dfc4a496de$var$ownKeys(Object(source), true).forEach(function(key) {
            (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $673ff3dfc4a496de$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
var $673ff3dfc4a496de$var$consoleLogger = {
    type: "logger",
    log: function log(args) {
        this.output("log", args);
    },
    warn: function warn(args) {
        this.output("warn", args);
    },
    error: function error(args) {
        this.output("error", args);
    },
    output: function output(type, args) {
        if (console && console[type]) console[type].apply(console, args);
    }
};
var $673ff3dfc4a496de$var$Logger = function() {
    function Logger(concreteLogger) {
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        (0, $4d35ca0862055760$export$2e2bcd8739ae039)(this, Logger);
        this.init(concreteLogger, options);
    }
    (0, $94019358ecbcf36b$export$2e2bcd8739ae039)(Logger, [
        {
            key: "init",
            value: function init(concreteLogger) {
                var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                this.prefix = options.prefix || "i18next:";
                this.logger = concreteLogger || $673ff3dfc4a496de$var$consoleLogger;
                this.options = options;
                this.debug = options.debug;
            }
        },
        {
            key: "setDebug",
            value: function setDebug(bool) {
                this.debug = bool;
            }
        },
        {
            key: "log",
            value: function log() {
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
                return this.forward(args, "log", "", true);
            }
        },
        {
            key: "warn",
            value: function warn() {
                for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
                return this.forward(args, "warn", "", true);
            }
        },
        {
            key: "error",
            value: function error() {
                for(var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++)args[_key3] = arguments[_key3];
                return this.forward(args, "error", "");
            }
        },
        {
            key: "deprecate",
            value: function deprecate() {
                for(var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++)args[_key4] = arguments[_key4];
                return this.forward(args, "warn", "WARNING DEPRECATED: ", true);
            }
        },
        {
            key: "forward",
            value: function forward(args, lvl, prefix, debugOnly) {
                if (debugOnly && !this.debug) return null;
                if (typeof args[0] === "string") args[0] = "".concat(prefix).concat(this.prefix, " ").concat(args[0]);
                return this.logger[lvl](args);
            }
        },
        {
            key: "create",
            value: function create(moduleName) {
                return new Logger(this.logger, $673ff3dfc4a496de$var$_objectSpread($673ff3dfc4a496de$var$_objectSpread({}, {
                    prefix: "".concat(this.prefix, ":").concat(moduleName, ":")
                }), this.options));
            }
        },
        {
            key: "clone",
            value: function clone(options) {
                options = options || this.options;
                options.prefix = options.prefix || this.prefix;
                return new Logger(this.logger, options);
            }
        }
    ]);
    return Logger;
}();
var $673ff3dfc4a496de$var$baseLogger = new $673ff3dfc4a496de$var$Logger();
var $673ff3dfc4a496de$var$EventEmitter = function() {
    function EventEmitter() {
        (0, $4d35ca0862055760$export$2e2bcd8739ae039)(this, EventEmitter);
        this.observers = {};
    }
    (0, $94019358ecbcf36b$export$2e2bcd8739ae039)(EventEmitter, [
        {
            key: "on",
            value: function on(events, listener) {
                var _this = this;
                events.split(" ").forEach(function(event) {
                    _this.observers[event] = _this.observers[event] || [];
                    _this.observers[event].push(listener);
                });
                return this;
            }
        },
        {
            key: "off",
            value: function off(event, listener) {
                if (!this.observers[event]) return;
                if (!listener) {
                    delete this.observers[event];
                    return;
                }
                this.observers[event] = this.observers[event].filter(function(l) {
                    return l !== listener;
                });
            }
        },
        {
            key: "emit",
            value: function emit(event) {
                for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
                if (this.observers[event]) {
                    var cloned = [].concat(this.observers[event]);
                    cloned.forEach(function(observer) {
                        observer.apply(void 0, args);
                    });
                }
                if (this.observers["*"]) {
                    var _cloned = [].concat(this.observers["*"]);
                    _cloned.forEach(function(observer) {
                        observer.apply(observer, [
                            event
                        ].concat(args));
                    });
                }
            }
        }
    ]);
    return EventEmitter;
}();
function $673ff3dfc4a496de$var$defer() {
    var res;
    var rej;
    var promise = new Promise(function(resolve, reject) {
        res = resolve;
        rej = reject;
    });
    promise.resolve = res;
    promise.reject = rej;
    return promise;
}
function $673ff3dfc4a496de$var$makeString(object) {
    if (object == null) return "";
    return "" + object;
}
function $673ff3dfc4a496de$var$copy(a, s, t) {
    a.forEach(function(m) {
        if (s[m]) t[m] = s[m];
    });
}
function $673ff3dfc4a496de$var$getLastOfPath(object, path, Empty) {
    function cleanKey(key) {
        return key && key.indexOf("###") > -1 ? key.replace(/###/g, ".") : key;
    }
    function canNotTraverseDeeper() {
        return !object || typeof object === "string";
    }
    var stack = typeof path !== "string" ? [].concat(path) : path.split(".");
    while(stack.length > 1){
        if (canNotTraverseDeeper()) return {};
        var key = cleanKey(stack.shift());
        if (!object[key] && Empty) object[key] = new Empty();
        if (Object.prototype.hasOwnProperty.call(object, key)) object = object[key];
        else object = {};
    }
    if (canNotTraverseDeeper()) return {};
    return {
        obj: object,
        k: cleanKey(stack.shift())
    };
}
function $673ff3dfc4a496de$var$setPath(object, path, newValue) {
    var _getLastOfPath = $673ff3dfc4a496de$var$getLastOfPath(object, path, Object), obj = _getLastOfPath.obj, k = _getLastOfPath.k;
    obj[k] = newValue;
}
function $673ff3dfc4a496de$var$pushPath(object, path, newValue, concat) {
    var _getLastOfPath2 = $673ff3dfc4a496de$var$getLastOfPath(object, path, Object), obj = _getLastOfPath2.obj, k = _getLastOfPath2.k;
    obj[k] = obj[k] || [];
    if (concat) obj[k] = obj[k].concat(newValue);
    if (!concat) obj[k].push(newValue);
}
function $673ff3dfc4a496de$var$getPath(object, path) {
    var _getLastOfPath3 = $673ff3dfc4a496de$var$getLastOfPath(object, path), obj = _getLastOfPath3.obj, k = _getLastOfPath3.k;
    if (!obj) return undefined;
    return obj[k];
}
function $673ff3dfc4a496de$var$getPathWithDefaults(data, defaultData, key) {
    var value = $673ff3dfc4a496de$var$getPath(data, key);
    if (value !== undefined) return value;
    return $673ff3dfc4a496de$var$getPath(defaultData, key);
}
function $673ff3dfc4a496de$var$deepExtend(target, source, overwrite) {
    for(var prop in source)if (prop !== "__proto__" && prop !== "constructor") {
        if (prop in target) {
            if (typeof target[prop] === "string" || target[prop] instanceof String || typeof source[prop] === "string" || source[prop] instanceof String) {
                if (overwrite) target[prop] = source[prop];
            } else $673ff3dfc4a496de$var$deepExtend(target[prop], source[prop], overwrite);
        } else target[prop] = source[prop];
    }
    return target;
}
function $673ff3dfc4a496de$var$regexEscape(str) {
    return str.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, "\\$&");
}
var $673ff3dfc4a496de$var$_entityMap = {
    "&": "&amp;",
    "<": "&lt;",
    ">": "&gt;",
    '"': "&quot;",
    "'": "&#39;",
    "/": "&#x2F;"
};
function $673ff3dfc4a496de$var$escape(data) {
    if (typeof data === "string") return data.replace(/[&<>"'\/]/g, function(s) {
        return $673ff3dfc4a496de$var$_entityMap[s];
    });
    return data;
}
var $673ff3dfc4a496de$var$isIE10 = typeof window !== "undefined" && window.navigator && typeof window.navigator.userAgentData === "undefined" && window.navigator.userAgent && window.navigator.userAgent.indexOf("MSIE") > -1;
var $673ff3dfc4a496de$var$chars = [
    " ",
    ",",
    "?",
    "!",
    ";"
];
function $673ff3dfc4a496de$var$looksLikeObjectPath(key, nsSeparator, keySeparator) {
    nsSeparator = nsSeparator || "";
    keySeparator = keySeparator || "";
    var possibleChars = $673ff3dfc4a496de$var$chars.filter(function(c) {
        return nsSeparator.indexOf(c) < 0 && keySeparator.indexOf(c) < 0;
    });
    if (possibleChars.length === 0) return true;
    var r = new RegExp("(".concat(possibleChars.map(function(c) {
        return c === "?" ? "\\?" : c;
    }).join("|"), ")"));
    var matched = !r.test(key);
    if (!matched) {
        var ki = key.indexOf(keySeparator);
        if (ki > 0 && !r.test(key.substring(0, ki))) matched = true;
    }
    return matched;
}
function $673ff3dfc4a496de$var$ownKeys$1(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $673ff3dfc4a496de$var$_objectSpread$1(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $673ff3dfc4a496de$var$ownKeys$1(Object(source), true).forEach(function(key) {
            (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $673ff3dfc4a496de$var$ownKeys$1(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $673ff3dfc4a496de$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $673ff3dfc4a496de$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = (0, $e4c5ebe502337db0$export$2e2bcd8739ae039)(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, $e4c5ebe502337db0$export$2e2bcd8739ae039)(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, $6a259df8fa92dc4a$export$2e2bcd8739ae039)(this, result);
    };
}
function $673ff3dfc4a496de$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $673ff3dfc4a496de$var$deepFind(obj, path) {
    var keySeparator = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : ".";
    if (!obj) return undefined;
    if (obj[path]) return obj[path];
    var paths = path.split(keySeparator);
    var current = obj;
    for(var i = 0; i < paths.length; ++i){
        if (!current) return undefined;
        if (typeof current[paths[i]] === "string" && i + 1 < paths.length) return undefined;
        if (current[paths[i]] === undefined) {
            var j = 2;
            var p = paths.slice(i, i + j).join(keySeparator);
            var mix = current[p];
            while(mix === undefined && paths.length > i + j){
                j++;
                p = paths.slice(i, i + j).join(keySeparator);
                mix = current[p];
            }
            if (mix === undefined) return undefined;
            if (mix === null) return null;
            if (path.endsWith(p)) {
                if (typeof mix === "string") return mix;
                if (p && typeof mix[p] === "string") return mix[p];
            }
            var joinedPath = paths.slice(i + j).join(keySeparator);
            if (joinedPath) return $673ff3dfc4a496de$var$deepFind(mix, joinedPath, keySeparator);
            return undefined;
        }
        current = current[paths[i]];
    }
    return current;
}
var $673ff3dfc4a496de$var$ResourceStore = function(_EventEmitter) {
    (0, $0ed648f7bbaf3aff$export$2e2bcd8739ae039)(ResourceStore, _EventEmitter);
    var _super = $673ff3dfc4a496de$var$_createSuper(ResourceStore);
    function ResourceStore(data) {
        var _this;
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
            ns: [
                "translation"
            ],
            defaultNS: "translation"
        };
        (0, $4d35ca0862055760$export$2e2bcd8739ae039)(this, ResourceStore);
        _this = _super.call(this);
        if ($673ff3dfc4a496de$var$isIE10) $673ff3dfc4a496de$var$EventEmitter.call((0, $cd69a1d4c6210e44$export$2e2bcd8739ae039)(_this));
        _this.data = data || {};
        _this.options = options;
        if (_this.options.keySeparator === undefined) _this.options.keySeparator = ".";
        if (_this.options.ignoreJSONStructure === undefined) _this.options.ignoreJSONStructure = true;
        return _this;
    }
    (0, $94019358ecbcf36b$export$2e2bcd8739ae039)(ResourceStore, [
        {
            key: "addNamespaces",
            value: function addNamespaces(ns) {
                if (this.options.ns.indexOf(ns) < 0) this.options.ns.push(ns);
            }
        },
        {
            key: "removeNamespaces",
            value: function removeNamespaces(ns) {
                var index = this.options.ns.indexOf(ns);
                if (index > -1) this.options.ns.splice(index, 1);
            }
        },
        {
            key: "getResource",
            value: function getResource(lng, ns, key) {
                var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
                var keySeparator = options.keySeparator !== undefined ? options.keySeparator : this.options.keySeparator;
                var ignoreJSONStructure = options.ignoreJSONStructure !== undefined ? options.ignoreJSONStructure : this.options.ignoreJSONStructure;
                var path = [
                    lng,
                    ns
                ];
                if (key && typeof key !== "string") path = path.concat(key);
                if (key && typeof key === "string") path = path.concat(keySeparator ? key.split(keySeparator) : key);
                if (lng.indexOf(".") > -1) path = lng.split(".");
                var result = $673ff3dfc4a496de$var$getPath(this.data, path);
                if (result || !ignoreJSONStructure || typeof key !== "string") return result;
                return $673ff3dfc4a496de$var$deepFind(this.data && this.data[lng] && this.data[lng][ns], key, keySeparator);
            }
        },
        {
            key: "addResource",
            value: function addResource(lng, ns, key, value) {
                var options = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {
                    silent: false
                };
                var keySeparator = this.options.keySeparator;
                if (keySeparator === undefined) keySeparator = ".";
                var path = [
                    lng,
                    ns
                ];
                if (key) path = path.concat(keySeparator ? key.split(keySeparator) : key);
                if (lng.indexOf(".") > -1) {
                    path = lng.split(".");
                    value = ns;
                    ns = path[1];
                }
                this.addNamespaces(ns);
                $673ff3dfc4a496de$var$setPath(this.data, path, value);
                if (!options.silent) this.emit("added", lng, ns, key, value);
            }
        },
        {
            key: "addResources",
            value: function addResources(lng, ns, resources) {
                var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {
                    silent: false
                };
                for(var m in resources)if (typeof resources[m] === "string" || Object.prototype.toString.apply(resources[m]) === "[object Array]") this.addResource(lng, ns, m, resources[m], {
                    silent: true
                });
                if (!options.silent) this.emit("added", lng, ns, resources);
            }
        },
        {
            key: "addResourceBundle",
            value: function addResourceBundle(lng, ns, resources, deep, overwrite) {
                var options = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : {
                    silent: false
                };
                var path = [
                    lng,
                    ns
                ];
                if (lng.indexOf(".") > -1) {
                    path = lng.split(".");
                    deep = resources;
                    resources = ns;
                    ns = path[1];
                }
                this.addNamespaces(ns);
                var pack = $673ff3dfc4a496de$var$getPath(this.data, path) || {};
                if (deep) $673ff3dfc4a496de$var$deepExtend(pack, resources, overwrite);
                else pack = $673ff3dfc4a496de$var$_objectSpread$1($673ff3dfc4a496de$var$_objectSpread$1({}, pack), resources);
                $673ff3dfc4a496de$var$setPath(this.data, path, pack);
                if (!options.silent) this.emit("added", lng, ns, resources);
            }
        },
        {
            key: "removeResourceBundle",
            value: function removeResourceBundle(lng, ns) {
                if (this.hasResourceBundle(lng, ns)) delete this.data[lng][ns];
                this.removeNamespaces(ns);
                this.emit("removed", lng, ns);
            }
        },
        {
            key: "hasResourceBundle",
            value: function hasResourceBundle(lng, ns) {
                return this.getResource(lng, ns) !== undefined;
            }
        },
        {
            key: "getResourceBundle",
            value: function getResourceBundle(lng, ns) {
                if (!ns) ns = this.options.defaultNS;
                if (this.options.compatibilityAPI === "v1") return $673ff3dfc4a496de$var$_objectSpread$1($673ff3dfc4a496de$var$_objectSpread$1({}, {}), this.getResource(lng, ns));
                return this.getResource(lng, ns);
            }
        },
        {
            key: "getDataByLanguage",
            value: function getDataByLanguage(lng) {
                return this.data[lng];
            }
        },
        {
            key: "hasLanguageSomeTranslations",
            value: function hasLanguageSomeTranslations(lng) {
                var data = this.getDataByLanguage(lng);
                var n = data && Object.keys(data) || [];
                return !!n.find(function(v) {
                    return data[v] && Object.keys(data[v]).length > 0;
                });
            }
        },
        {
            key: "toJSON",
            value: function toJSON() {
                return this.data;
            }
        }
    ]);
    return ResourceStore;
}($673ff3dfc4a496de$var$EventEmitter);
var $673ff3dfc4a496de$var$postProcessor = {
    processors: {},
    addPostProcessor: function addPostProcessor(module) {
        this.processors[module.name] = module;
    },
    handle: function handle(processors, value, key, options, translator) {
        var _this = this;
        processors.forEach(function(processor) {
            if (_this.processors[processor]) value = _this.processors[processor].process(value, key, options, translator);
        });
        return value;
    }
};
function $673ff3dfc4a496de$var$ownKeys$2(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $673ff3dfc4a496de$var$_objectSpread$2(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $673ff3dfc4a496de$var$ownKeys$2(Object(source), true).forEach(function(key) {
            (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $673ff3dfc4a496de$var$ownKeys$2(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $673ff3dfc4a496de$var$_createSuper$1(Derived) {
    var hasNativeReflectConstruct = $673ff3dfc4a496de$var$_isNativeReflectConstruct$1();
    return function _createSuperInternal() {
        var Super = (0, $e4c5ebe502337db0$export$2e2bcd8739ae039)(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, $e4c5ebe502337db0$export$2e2bcd8739ae039)(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, $6a259df8fa92dc4a$export$2e2bcd8739ae039)(this, result);
    };
}
function $673ff3dfc4a496de$var$_isNativeReflectConstruct$1() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
var $673ff3dfc4a496de$var$checkedLoadedFor = {};
var $673ff3dfc4a496de$var$Translator = function(_EventEmitter) {
    (0, $0ed648f7bbaf3aff$export$2e2bcd8739ae039)(Translator, _EventEmitter);
    var _super = $673ff3dfc4a496de$var$_createSuper$1(Translator);
    function Translator(services) {
        var _this;
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        (0, $4d35ca0862055760$export$2e2bcd8739ae039)(this, Translator);
        _this = _super.call(this);
        if ($673ff3dfc4a496de$var$isIE10) $673ff3dfc4a496de$var$EventEmitter.call((0, $cd69a1d4c6210e44$export$2e2bcd8739ae039)(_this));
        $673ff3dfc4a496de$var$copy([
            "resourceStore",
            "languageUtils",
            "pluralResolver",
            "interpolator",
            "backendConnector",
            "i18nFormat",
            "utils"
        ], services, (0, $cd69a1d4c6210e44$export$2e2bcd8739ae039)(_this));
        _this.options = options;
        if (_this.options.keySeparator === undefined) _this.options.keySeparator = ".";
        _this.logger = $673ff3dfc4a496de$var$baseLogger.create("translator");
        return _this;
    }
    (0, $94019358ecbcf36b$export$2e2bcd8739ae039)(Translator, [
        {
            key: "changeLanguage",
            value: function changeLanguage(lng) {
                if (lng) this.language = lng;
            }
        },
        {
            key: "exists",
            value: function exists(key) {
                var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
                    interpolation: {}
                };
                if (key === undefined || key === null) return false;
                var resolved = this.resolve(key, options);
                return resolved && resolved.res !== undefined;
            }
        },
        {
            key: "extractFromKey",
            value: function extractFromKey(key, options) {
                var nsSeparator = options.nsSeparator !== undefined ? options.nsSeparator : this.options.nsSeparator;
                if (nsSeparator === undefined) nsSeparator = ":";
                var keySeparator = options.keySeparator !== undefined ? options.keySeparator : this.options.keySeparator;
                var namespaces = options.ns || this.options.defaultNS || [];
                var wouldCheckForNsInKey = nsSeparator && key.indexOf(nsSeparator) > -1;
                var seemsNaturalLanguage = !this.options.userDefinedKeySeparator && !options.keySeparator && !this.options.userDefinedNsSeparator && !options.nsSeparator && !$673ff3dfc4a496de$var$looksLikeObjectPath(key, nsSeparator, keySeparator);
                if (wouldCheckForNsInKey && !seemsNaturalLanguage) {
                    var m = key.match(this.interpolator.nestingRegexp);
                    if (m && m.length > 0) return {
                        key: key,
                        namespaces: namespaces
                    };
                    var parts = key.split(nsSeparator);
                    if (nsSeparator !== keySeparator || nsSeparator === keySeparator && this.options.ns.indexOf(parts[0]) > -1) namespaces = parts.shift();
                    key = parts.join(keySeparator);
                }
                if (typeof namespaces === "string") namespaces = [
                    namespaces
                ];
                return {
                    key: key,
                    namespaces: namespaces
                };
            }
        },
        {
            key: "translate",
            value: function translate(keys, options, lastKey) {
                var _this2 = this;
                if ((0, $b8f57191916382d3$export$2e2bcd8739ae039)(options) !== "object" && this.options.overloadTranslationOptionHandler) options = this.options.overloadTranslationOptionHandler(arguments);
                if (!options) options = {};
                if (keys === undefined || keys === null) return "";
                if (!Array.isArray(keys)) keys = [
                    String(keys)
                ];
                var returnDetails = options.returnDetails !== undefined ? options.returnDetails : this.options.returnDetails;
                var keySeparator = options.keySeparator !== undefined ? options.keySeparator : this.options.keySeparator;
                var _this$extractFromKey = this.extractFromKey(keys[keys.length - 1], options), key = _this$extractFromKey.key, namespaces = _this$extractFromKey.namespaces;
                var namespace = namespaces[namespaces.length - 1];
                var lng = options.lng || this.language;
                var appendNamespaceToCIMode = options.appendNamespaceToCIMode || this.options.appendNamespaceToCIMode;
                if (lng && lng.toLowerCase() === "cimode") {
                    if (appendNamespaceToCIMode) {
                        var nsSeparator = options.nsSeparator || this.options.nsSeparator;
                        if (returnDetails) {
                            resolved.res = "".concat(namespace).concat(nsSeparator).concat(key);
                            return resolved;
                        }
                        return "".concat(namespace).concat(nsSeparator).concat(key);
                    }
                    if (returnDetails) {
                        resolved.res = key;
                        return resolved;
                    }
                    return key;
                }
                var resolved = this.resolve(keys, options);
                var res = resolved && resolved.res;
                var resUsedKey = resolved && resolved.usedKey || key;
                var resExactUsedKey = resolved && resolved.exactUsedKey || key;
                var resType = Object.prototype.toString.apply(res);
                var noObject = [
                    "[object Number]",
                    "[object Function]",
                    "[object RegExp]"
                ];
                var joinArrays = options.joinArrays !== undefined ? options.joinArrays : this.options.joinArrays;
                var handleAsObjectInI18nFormat = !this.i18nFormat || this.i18nFormat.handleAsObject;
                var handleAsObject = typeof res !== "string" && typeof res !== "boolean" && typeof res !== "number";
                if (handleAsObjectInI18nFormat && res && handleAsObject && noObject.indexOf(resType) < 0 && !(typeof joinArrays === "string" && resType === "[object Array]")) {
                    if (!options.returnObjects && !this.options.returnObjects) {
                        if (!this.options.returnedObjectHandler) this.logger.warn("accessing an object - but returnObjects options is not enabled!");
                        var r = this.options.returnedObjectHandler ? this.options.returnedObjectHandler(resUsedKey, res, $673ff3dfc4a496de$var$_objectSpread$2($673ff3dfc4a496de$var$_objectSpread$2({}, options), {}, {
                            ns: namespaces
                        })) : "key '".concat(key, " (").concat(this.language, ")' returned an object instead of string.");
                        if (returnDetails) {
                            resolved.res = r;
                            return resolved;
                        }
                        return r;
                    }
                    if (keySeparator) {
                        var resTypeIsArray = resType === "[object Array]";
                        var copy = resTypeIsArray ? [] : {};
                        var newKeyToUse = resTypeIsArray ? resExactUsedKey : resUsedKey;
                        for(var m in res)if (Object.prototype.hasOwnProperty.call(res, m)) {
                            var deepKey = "".concat(newKeyToUse).concat(keySeparator).concat(m);
                            copy[m] = this.translate(deepKey, $673ff3dfc4a496de$var$_objectSpread$2($673ff3dfc4a496de$var$_objectSpread$2({}, options), {
                                joinArrays: false,
                                ns: namespaces
                            }));
                            if (copy[m] === deepKey) copy[m] = res[m];
                        }
                        res = copy;
                    }
                } else if (handleAsObjectInI18nFormat && typeof joinArrays === "string" && resType === "[object Array]") {
                    res = res.join(joinArrays);
                    if (res) res = this.extendTranslation(res, keys, options, lastKey);
                } else {
                    var usedDefault = false;
                    var usedKey = false;
                    var needsPluralHandling = options.count !== undefined && typeof options.count !== "string";
                    var hasDefaultValue = Translator.hasDefaultValue(options);
                    var defaultValueSuffix = needsPluralHandling ? this.pluralResolver.getSuffix(lng, options.count, options) : "";
                    var defaultValue = options["defaultValue".concat(defaultValueSuffix)] || options.defaultValue;
                    if (!this.isValidLookup(res) && hasDefaultValue) {
                        usedDefault = true;
                        res = defaultValue;
                    }
                    if (!this.isValidLookup(res)) {
                        usedKey = true;
                        res = key;
                    }
                    var missingKeyNoValueFallbackToKey = options.missingKeyNoValueFallbackToKey || this.options.missingKeyNoValueFallbackToKey;
                    var resForMissing = missingKeyNoValueFallbackToKey && usedKey ? undefined : res;
                    var updateMissing = hasDefaultValue && defaultValue !== res && this.options.updateMissing;
                    if (usedKey || usedDefault || updateMissing) {
                        this.logger.log(updateMissing ? "updateKey" : "missingKey", lng, namespace, key, updateMissing ? defaultValue : res);
                        if (keySeparator) {
                            var fk = this.resolve(key, $673ff3dfc4a496de$var$_objectSpread$2($673ff3dfc4a496de$var$_objectSpread$2({}, options), {}, {
                                keySeparator: false
                            }));
                            if (fk && fk.res) this.logger.warn("Seems the loaded translations were in flat JSON format instead of nested. Either set keySeparator: false on init or make sure your translations are published in nested format.");
                        }
                        var lngs = [];
                        var fallbackLngs = this.languageUtils.getFallbackCodes(this.options.fallbackLng, options.lng || this.language);
                        if (this.options.saveMissingTo === "fallback" && fallbackLngs && fallbackLngs[0]) for(var i = 0; i < fallbackLngs.length; i++)lngs.push(fallbackLngs[i]);
                        else if (this.options.saveMissingTo === "all") lngs = this.languageUtils.toResolveHierarchy(options.lng || this.language);
                        else lngs.push(options.lng || this.language);
                        var send = function send(l, k, specificDefaultValue) {
                            var defaultForMissing = hasDefaultValue && specificDefaultValue !== res ? specificDefaultValue : resForMissing;
                            if (_this2.options.missingKeyHandler) _this2.options.missingKeyHandler(l, namespace, k, defaultForMissing, updateMissing, options);
                            else if (_this2.backendConnector && _this2.backendConnector.saveMissing) _this2.backendConnector.saveMissing(l, namespace, k, defaultForMissing, updateMissing, options);
                            _this2.emit("missingKey", l, namespace, k, res);
                        };
                        if (this.options.saveMissing) {
                            if (this.options.saveMissingPlurals && needsPluralHandling) lngs.forEach(function(language) {
                                _this2.pluralResolver.getSuffixes(language, options).forEach(function(suffix) {
                                    send([
                                        language
                                    ], key + suffix, options["defaultValue".concat(suffix)] || defaultValue);
                                });
                            });
                            else send(lngs, key, defaultValue);
                        }
                    }
                    res = this.extendTranslation(res, keys, options, resolved, lastKey);
                    if (usedKey && res === key && this.options.appendNamespaceToMissingKey) res = "".concat(namespace, ":").concat(key);
                    if ((usedKey || usedDefault) && this.options.parseMissingKeyHandler) {
                        if (this.options.compatibilityAPI !== "v1") res = this.options.parseMissingKeyHandler(this.options.appendNamespaceToMissingKey ? "".concat(namespace, ":").concat(key) : key, usedDefault ? res : undefined);
                        else res = this.options.parseMissingKeyHandler(res);
                    }
                }
                if (returnDetails) {
                    resolved.res = res;
                    return resolved;
                }
                return res;
            }
        },
        {
            key: "extendTranslation",
            value: function extendTranslation(res, key, options, resolved, lastKey) {
                var _this3 = this;
                if (this.i18nFormat && this.i18nFormat.parse) res = this.i18nFormat.parse(res, $673ff3dfc4a496de$var$_objectSpread$2($673ff3dfc4a496de$var$_objectSpread$2({}, this.options.interpolation.defaultVariables), options), resolved.usedLng, resolved.usedNS, resolved.usedKey, {
                    resolved: resolved
                });
                else if (!options.skipInterpolation) {
                    if (options.interpolation) this.interpolator.init($673ff3dfc4a496de$var$_objectSpread$2($673ff3dfc4a496de$var$_objectSpread$2({}, options), {
                        interpolation: $673ff3dfc4a496de$var$_objectSpread$2($673ff3dfc4a496de$var$_objectSpread$2({}, this.options.interpolation), options.interpolation)
                    }));
                    var skipOnVariables = typeof res === "string" && (options && options.interpolation && options.interpolation.skipOnVariables !== undefined ? options.interpolation.skipOnVariables : this.options.interpolation.skipOnVariables);
                    var nestBef;
                    if (skipOnVariables) {
                        var nb = res.match(this.interpolator.nestingRegexp);
                        nestBef = nb && nb.length;
                    }
                    var data = options.replace && typeof options.replace !== "string" ? options.replace : options;
                    if (this.options.interpolation.defaultVariables) data = $673ff3dfc4a496de$var$_objectSpread$2($673ff3dfc4a496de$var$_objectSpread$2({}, this.options.interpolation.defaultVariables), data);
                    res = this.interpolator.interpolate(res, data, options.lng || this.language, options);
                    if (skipOnVariables) {
                        var na = res.match(this.interpolator.nestingRegexp);
                        var nestAft = na && na.length;
                        if (nestBef < nestAft) options.nest = false;
                    }
                    if (options.nest !== false) res = this.interpolator.nest(res, function() {
                        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
                        if (lastKey && lastKey[0] === args[0] && !options.context) {
                            _this3.logger.warn("It seems you are nesting recursively key: ".concat(args[0], " in key: ").concat(key[0]));
                            return null;
                        }
                        return _this3.translate.apply(_this3, args.concat([
                            key
                        ]));
                    }, options);
                    if (options.interpolation) this.interpolator.reset();
                }
                var postProcess = options.postProcess || this.options.postProcess;
                var postProcessorNames = typeof postProcess === "string" ? [
                    postProcess
                ] : postProcess;
                if (res !== undefined && res !== null && postProcessorNames && postProcessorNames.length && options.applyPostProcessor !== false) res = $673ff3dfc4a496de$var$postProcessor.handle(postProcessorNames, res, key, this.options && this.options.postProcessPassResolved ? $673ff3dfc4a496de$var$_objectSpread$2({
                    i18nResolved: resolved
                }, options) : options, this);
                return res;
            }
        },
        {
            key: "resolve",
            value: function resolve(keys) {
                var _this4 = this;
                var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                var found;
                var usedKey;
                var exactUsedKey;
                var usedLng;
                var usedNS;
                if (typeof keys === "string") keys = [
                    keys
                ];
                keys.forEach(function(k) {
                    if (_this4.isValidLookup(found)) return;
                    var extracted = _this4.extractFromKey(k, options);
                    var key = extracted.key;
                    usedKey = key;
                    var namespaces = extracted.namespaces;
                    if (_this4.options.fallbackNS) namespaces = namespaces.concat(_this4.options.fallbackNS);
                    var needsPluralHandling = options.count !== undefined && typeof options.count !== "string";
                    var needsZeroSuffixLookup = needsPluralHandling && !options.ordinal && options.count === 0 && _this4.pluralResolver.shouldUseIntlApi();
                    var needsContextHandling = options.context !== undefined && (typeof options.context === "string" || typeof options.context === "number") && options.context !== "";
                    var codes = options.lngs ? options.lngs : _this4.languageUtils.toResolveHierarchy(options.lng || _this4.language, options.fallbackLng);
                    namespaces.forEach(function(ns) {
                        if (_this4.isValidLookup(found)) return;
                        usedNS = ns;
                        if (!$673ff3dfc4a496de$var$checkedLoadedFor["".concat(codes[0], "-").concat(ns)] && _this4.utils && _this4.utils.hasLoadedNamespace && !_this4.utils.hasLoadedNamespace(usedNS)) {
                            $673ff3dfc4a496de$var$checkedLoadedFor["".concat(codes[0], "-").concat(ns)] = true;
                            _this4.logger.warn('key "'.concat(usedKey, '" for languages "').concat(codes.join(", "), '" won\'t get resolved as namespace "').concat(usedNS, '" was not yet loaded'), "This means something IS WRONG in your setup. You access the t function before i18next.init / i18next.loadNamespace / i18next.changeLanguage was done. Wait for the callback or Promise to resolve before accessing it!!!");
                        }
                        codes.forEach(function(code) {
                            if (_this4.isValidLookup(found)) return;
                            usedLng = code;
                            var finalKeys = [
                                key
                            ];
                            if (_this4.i18nFormat && _this4.i18nFormat.addLookupKeys) _this4.i18nFormat.addLookupKeys(finalKeys, key, code, ns, options);
                            else {
                                var pluralSuffix;
                                if (needsPluralHandling) pluralSuffix = _this4.pluralResolver.getSuffix(code, options.count, options);
                                var zeroSuffix = "".concat(_this4.options.pluralSeparator, "zero");
                                if (needsPluralHandling) {
                                    finalKeys.push(key + pluralSuffix);
                                    if (needsZeroSuffixLookup) finalKeys.push(key + zeroSuffix);
                                }
                                if (needsContextHandling) {
                                    var contextKey = "".concat(key).concat(_this4.options.contextSeparator).concat(options.context);
                                    finalKeys.push(contextKey);
                                    if (needsPluralHandling) {
                                        finalKeys.push(contextKey + pluralSuffix);
                                        if (needsZeroSuffixLookup) finalKeys.push(contextKey + zeroSuffix);
                                    }
                                }
                            }
                            var possibleKey;
                            while(possibleKey = finalKeys.pop())if (!_this4.isValidLookup(found)) {
                                exactUsedKey = possibleKey;
                                found = _this4.getResource(code, ns, possibleKey, options);
                            }
                        });
                    });
                });
                return {
                    res: found,
                    usedKey: usedKey,
                    exactUsedKey: exactUsedKey,
                    usedLng: usedLng,
                    usedNS: usedNS
                };
            }
        },
        {
            key: "isValidLookup",
            value: function isValidLookup(res) {
                return res !== undefined && !(!this.options.returnNull && res === null) && !(!this.options.returnEmptyString && res === "");
            }
        },
        {
            key: "getResource",
            value: function getResource(code, ns, key) {
                var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
                if (this.i18nFormat && this.i18nFormat.getResource) return this.i18nFormat.getResource(code, ns, key, options);
                return this.resourceStore.getResource(code, ns, key, options);
            }
        }
    ], [
        {
            key: "hasDefaultValue",
            value: function hasDefaultValue(options) {
                var prefix = "defaultValue";
                for(var option in options){
                    if (Object.prototype.hasOwnProperty.call(options, option) && prefix === option.substring(0, prefix.length) && undefined !== options[option]) return true;
                }
                return false;
            }
        }
    ]);
    return Translator;
}($673ff3dfc4a496de$var$EventEmitter);
function $673ff3dfc4a496de$var$capitalize(string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
}
var $673ff3dfc4a496de$var$LanguageUtil = function() {
    function LanguageUtil(options) {
        (0, $4d35ca0862055760$export$2e2bcd8739ae039)(this, LanguageUtil);
        this.options = options;
        this.supportedLngs = this.options.supportedLngs || false;
        this.logger = $673ff3dfc4a496de$var$baseLogger.create("languageUtils");
    }
    (0, $94019358ecbcf36b$export$2e2bcd8739ae039)(LanguageUtil, [
        {
            key: "getScriptPartFromCode",
            value: function getScriptPartFromCode(code) {
                if (!code || code.indexOf("-") < 0) return null;
                var p = code.split("-");
                if (p.length === 2) return null;
                p.pop();
                if (p[p.length - 1].toLowerCase() === "x") return null;
                return this.formatLanguageCode(p.join("-"));
            }
        },
        {
            key: "getLanguagePartFromCode",
            value: function getLanguagePartFromCode(code) {
                if (!code || code.indexOf("-") < 0) return code;
                var p = code.split("-");
                return this.formatLanguageCode(p[0]);
            }
        },
        {
            key: "formatLanguageCode",
            value: function formatLanguageCode(code) {
                if (typeof code === "string" && code.indexOf("-") > -1) {
                    var specialCases = [
                        "hans",
                        "hant",
                        "latn",
                        "cyrl",
                        "cans",
                        "mong",
                        "arab"
                    ];
                    var p = code.split("-");
                    if (this.options.lowerCaseLng) p = p.map(function(part) {
                        return part.toLowerCase();
                    });
                    else if (p.length === 2) {
                        p[0] = p[0].toLowerCase();
                        p[1] = p[1].toUpperCase();
                        if (specialCases.indexOf(p[1].toLowerCase()) > -1) p[1] = $673ff3dfc4a496de$var$capitalize(p[1].toLowerCase());
                    } else if (p.length === 3) {
                        p[0] = p[0].toLowerCase();
                        if (p[1].length === 2) p[1] = p[1].toUpperCase();
                        if (p[0] !== "sgn" && p[2].length === 2) p[2] = p[2].toUpperCase();
                        if (specialCases.indexOf(p[1].toLowerCase()) > -1) p[1] = $673ff3dfc4a496de$var$capitalize(p[1].toLowerCase());
                        if (specialCases.indexOf(p[2].toLowerCase()) > -1) p[2] = $673ff3dfc4a496de$var$capitalize(p[2].toLowerCase());
                    }
                    return p.join("-");
                }
                return this.options.cleanCode || this.options.lowerCaseLng ? code.toLowerCase() : code;
            }
        },
        {
            key: "isSupportedCode",
            value: function isSupportedCode(code) {
                if (this.options.load === "languageOnly" || this.options.nonExplicitSupportedLngs) code = this.getLanguagePartFromCode(code);
                return !this.supportedLngs || !this.supportedLngs.length || this.supportedLngs.indexOf(code) > -1;
            }
        },
        {
            key: "getBestMatchFromCodes",
            value: function getBestMatchFromCodes(codes) {
                var _this = this;
                if (!codes) return null;
                var found;
                codes.forEach(function(code) {
                    if (found) return;
                    var cleanedLng = _this.formatLanguageCode(code);
                    if (!_this.options.supportedLngs || _this.isSupportedCode(cleanedLng)) found = cleanedLng;
                });
                if (!found && this.options.supportedLngs) codes.forEach(function(code) {
                    if (found) return;
                    var lngOnly = _this.getLanguagePartFromCode(code);
                    if (_this.isSupportedCode(lngOnly)) return found = lngOnly;
                    found = _this.options.supportedLngs.find(function(supportedLng) {
                        if (supportedLng.indexOf(lngOnly) === 0) return supportedLng;
                    });
                });
                if (!found) found = this.getFallbackCodes(this.options.fallbackLng)[0];
                return found;
            }
        },
        {
            key: "getFallbackCodes",
            value: function getFallbackCodes(fallbacks, code) {
                if (!fallbacks) return [];
                if (typeof fallbacks === "function") fallbacks = fallbacks(code);
                if (typeof fallbacks === "string") fallbacks = [
                    fallbacks
                ];
                if (Object.prototype.toString.apply(fallbacks) === "[object Array]") return fallbacks;
                if (!code) return fallbacks["default"] || [];
                var found = fallbacks[code];
                if (!found) found = fallbacks[this.getScriptPartFromCode(code)];
                if (!found) found = fallbacks[this.formatLanguageCode(code)];
                if (!found) found = fallbacks[this.getLanguagePartFromCode(code)];
                if (!found) found = fallbacks["default"];
                return found || [];
            }
        },
        {
            key: "toResolveHierarchy",
            value: function toResolveHierarchy(code, fallbackCode) {
                var _this2 = this;
                var fallbackCodes = this.getFallbackCodes(fallbackCode || this.options.fallbackLng || [], code);
                var codes = [];
                var addCode = function addCode(c) {
                    if (!c) return;
                    if (_this2.isSupportedCode(c)) codes.push(c);
                    else _this2.logger.warn("rejecting language code not found in supportedLngs: ".concat(c));
                };
                if (typeof code === "string" && code.indexOf("-") > -1) {
                    if (this.options.load !== "languageOnly") addCode(this.formatLanguageCode(code));
                    if (this.options.load !== "languageOnly" && this.options.load !== "currentOnly") addCode(this.getScriptPartFromCode(code));
                    if (this.options.load !== "currentOnly") addCode(this.getLanguagePartFromCode(code));
                } else if (typeof code === "string") addCode(this.formatLanguageCode(code));
                fallbackCodes.forEach(function(fc) {
                    if (codes.indexOf(fc) < 0) addCode(_this2.formatLanguageCode(fc));
                });
                return codes;
            }
        }
    ]);
    return LanguageUtil;
}();
var $673ff3dfc4a496de$var$sets = [
    {
        lngs: [
            "ach",
            "ak",
            "am",
            "arn",
            "br",
            "fil",
            "gun",
            "ln",
            "mfe",
            "mg",
            "mi",
            "oc",
            "pt",
            "pt-BR",
            "tg",
            "tl",
            "ti",
            "tr",
            "uz",
            "wa"
        ],
        nr: [
            1,
            2
        ],
        fc: 1
    },
    {
        lngs: [
            "af",
            "an",
            "ast",
            "az",
            "bg",
            "bn",
            "ca",
            "da",
            "de",
            "dev",
            "el",
            "en",
            "eo",
            "es",
            "et",
            "eu",
            "fi",
            "fo",
            "fur",
            "fy",
            "gl",
            "gu",
            "ha",
            "hi",
            "hu",
            "hy",
            "ia",
            "it",
            "kk",
            "kn",
            "ku",
            "lb",
            "mai",
            "ml",
            "mn",
            "mr",
            "nah",
            "nap",
            "nb",
            "ne",
            "nl",
            "nn",
            "no",
            "nso",
            "pa",
            "pap",
            "pms",
            "ps",
            "pt-PT",
            "rm",
            "sco",
            "se",
            "si",
            "so",
            "son",
            "sq",
            "sv",
            "sw",
            "ta",
            "te",
            "tk",
            "ur",
            "yo"
        ],
        nr: [
            1,
            2
        ],
        fc: 2
    },
    {
        lngs: [
            "ay",
            "bo",
            "cgg",
            "fa",
            "ht",
            "id",
            "ja",
            "jbo",
            "ka",
            "km",
            "ko",
            "ky",
            "lo",
            "ms",
            "sah",
            "su",
            "th",
            "tt",
            "ug",
            "vi",
            "wo",
            "zh"
        ],
        nr: [
            1
        ],
        fc: 3
    },
    {
        lngs: [
            "be",
            "bs",
            "cnr",
            "dz",
            "hr",
            "ru",
            "sr",
            "uk"
        ],
        nr: [
            1,
            2,
            5
        ],
        fc: 4
    },
    {
        lngs: [
            "ar"
        ],
        nr: [
            0,
            1,
            2,
            3,
            11,
            100
        ],
        fc: 5
    },
    {
        lngs: [
            "cs",
            "sk"
        ],
        nr: [
            1,
            2,
            5
        ],
        fc: 6
    },
    {
        lngs: [
            "csb",
            "pl"
        ],
        nr: [
            1,
            2,
            5
        ],
        fc: 7
    },
    {
        lngs: [
            "cy"
        ],
        nr: [
            1,
            2,
            3,
            8
        ],
        fc: 8
    },
    {
        lngs: [
            "fr"
        ],
        nr: [
            1,
            2
        ],
        fc: 9
    },
    {
        lngs: [
            "ga"
        ],
        nr: [
            1,
            2,
            3,
            7,
            11
        ],
        fc: 10
    },
    {
        lngs: [
            "gd"
        ],
        nr: [
            1,
            2,
            3,
            20
        ],
        fc: 11
    },
    {
        lngs: [
            "is"
        ],
        nr: [
            1,
            2
        ],
        fc: 12
    },
    {
        lngs: [
            "jv"
        ],
        nr: [
            0,
            1
        ],
        fc: 13
    },
    {
        lngs: [
            "kw"
        ],
        nr: [
            1,
            2,
            3,
            4
        ],
        fc: 14
    },
    {
        lngs: [
            "lt"
        ],
        nr: [
            1,
            2,
            10
        ],
        fc: 15
    },
    {
        lngs: [
            "lv"
        ],
        nr: [
            1,
            2,
            0
        ],
        fc: 16
    },
    {
        lngs: [
            "mk"
        ],
        nr: [
            1,
            2
        ],
        fc: 17
    },
    {
        lngs: [
            "mnk"
        ],
        nr: [
            0,
            1,
            2
        ],
        fc: 18
    },
    {
        lngs: [
            "mt"
        ],
        nr: [
            1,
            2,
            11,
            20
        ],
        fc: 19
    },
    {
        lngs: [
            "or"
        ],
        nr: [
            2,
            1
        ],
        fc: 2
    },
    {
        lngs: [
            "ro"
        ],
        nr: [
            1,
            2,
            20
        ],
        fc: 20
    },
    {
        lngs: [
            "sl"
        ],
        nr: [
            5,
            1,
            2,
            3
        ],
        fc: 21
    },
    {
        lngs: [
            "he",
            "iw"
        ],
        nr: [
            1,
            2,
            20,
            21
        ],
        fc: 22
    }
];
var $673ff3dfc4a496de$var$_rulesPluralsTypes = {
    1: function _(n) {
        return Number(n > 1);
    },
    2: function _(n) {
        return Number(n != 1);
    },
    3: function _(n) {
        return 0;
    },
    4: function _(n) {
        return Number(n % 10 == 1 && n % 100 != 11 ? 0 : n % 10 >= 2 && n % 10 <= 4 && (n % 100 < 10 || n % 100 >= 20) ? 1 : 2);
    },
    5: function _(n) {
        return Number(n == 0 ? 0 : n == 1 ? 1 : n == 2 ? 2 : n % 100 >= 3 && n % 100 <= 10 ? 3 : n % 100 >= 11 ? 4 : 5);
    },
    6: function _(n) {
        return Number(n == 1 ? 0 : n >= 2 && n <= 4 ? 1 : 2);
    },
    7: function _(n) {
        return Number(n == 1 ? 0 : n % 10 >= 2 && n % 10 <= 4 && (n % 100 < 10 || n % 100 >= 20) ? 1 : 2);
    },
    8: function _(n) {
        return Number(n == 1 ? 0 : n == 2 ? 1 : n != 8 && n != 11 ? 2 : 3);
    },
    9: function _(n) {
        return Number(n >= 2);
    },
    10: function _(n) {
        return Number(n == 1 ? 0 : n == 2 ? 1 : n < 7 ? 2 : n < 11 ? 3 : 4);
    },
    11: function _(n) {
        return Number(n == 1 || n == 11 ? 0 : n == 2 || n == 12 ? 1 : n > 2 && n < 20 ? 2 : 3);
    },
    12: function _(n) {
        return Number(n % 10 != 1 || n % 100 == 11);
    },
    13: function _(n) {
        return Number(n !== 0);
    },
    14: function _(n) {
        return Number(n == 1 ? 0 : n == 2 ? 1 : n == 3 ? 2 : 3);
    },
    15: function _(n) {
        return Number(n % 10 == 1 && n % 100 != 11 ? 0 : n % 10 >= 2 && (n % 100 < 10 || n % 100 >= 20) ? 1 : 2);
    },
    16: function _(n) {
        return Number(n % 10 == 1 && n % 100 != 11 ? 0 : n !== 0 ? 1 : 2);
    },
    17: function _(n) {
        return Number(n == 1 || n % 10 == 1 && n % 100 != 11 ? 0 : 1);
    },
    18: function _(n) {
        return Number(n == 0 ? 0 : n == 1 ? 1 : 2);
    },
    19: function _(n) {
        return Number(n == 1 ? 0 : n == 0 || n % 100 > 1 && n % 100 < 11 ? 1 : n % 100 > 10 && n % 100 < 20 ? 2 : 3);
    },
    20: function _(n) {
        return Number(n == 1 ? 0 : n == 0 || n % 100 > 0 && n % 100 < 20 ? 1 : 2);
    },
    21: function _(n) {
        return Number(n % 100 == 1 ? 1 : n % 100 == 2 ? 2 : n % 100 == 3 || n % 100 == 4 ? 3 : 0);
    },
    22: function _(n) {
        return Number(n == 1 ? 0 : n == 2 ? 1 : (n < 0 || n > 10) && n % 10 == 0 ? 2 : 3);
    }
};
var $673ff3dfc4a496de$var$deprecatedJsonVersions = [
    "v1",
    "v2",
    "v3"
];
var $673ff3dfc4a496de$var$suffixesOrder = {
    zero: 0,
    one: 1,
    two: 2,
    few: 3,
    many: 4,
    other: 5
};
function $673ff3dfc4a496de$var$createRules() {
    var rules = {};
    $673ff3dfc4a496de$var$sets.forEach(function(set) {
        set.lngs.forEach(function(l) {
            rules[l] = {
                numbers: set.nr,
                plurals: $673ff3dfc4a496de$var$_rulesPluralsTypes[set.fc]
            };
        });
    });
    return rules;
}
var $673ff3dfc4a496de$var$PluralResolver = function() {
    function PluralResolver(languageUtils) {
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        (0, $4d35ca0862055760$export$2e2bcd8739ae039)(this, PluralResolver);
        this.languageUtils = languageUtils;
        this.options = options;
        this.logger = $673ff3dfc4a496de$var$baseLogger.create("pluralResolver");
        if ((!this.options.compatibilityJSON || this.options.compatibilityJSON === "v4") && (typeof Intl === "undefined" || !Intl.PluralRules)) {
            this.options.compatibilityJSON = "v3";
            this.logger.error("Your environment seems not to be Intl API compatible, use an Intl.PluralRules polyfill. Will fallback to the compatibilityJSON v3 format handling.");
        }
        this.rules = $673ff3dfc4a496de$var$createRules();
    }
    (0, $94019358ecbcf36b$export$2e2bcd8739ae039)(PluralResolver, [
        {
            key: "addRule",
            value: function addRule(lng, obj) {
                this.rules[lng] = obj;
            }
        },
        {
            key: "getRule",
            value: function getRule(code) {
                var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                if (this.shouldUseIntlApi()) try {
                    return new Intl.PluralRules(code, {
                        type: options.ordinal ? "ordinal" : "cardinal"
                    });
                } catch (_unused) {
                    return;
                }
                return this.rules[code] || this.rules[this.languageUtils.getLanguagePartFromCode(code)];
            }
        },
        {
            key: "needsPlural",
            value: function needsPlural(code) {
                var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                var rule = this.getRule(code, options);
                if (this.shouldUseIntlApi()) return rule && rule.resolvedOptions().pluralCategories.length > 1;
                return rule && rule.numbers.length > 1;
            }
        },
        {
            key: "getPluralFormsOfKey",
            value: function getPluralFormsOfKey(code, key) {
                var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                return this.getSuffixes(code, options).map(function(suffix) {
                    return "".concat(key).concat(suffix);
                });
            }
        },
        {
            key: "getSuffixes",
            value: function getSuffixes(code) {
                var _this = this;
                var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                var rule = this.getRule(code, options);
                if (!rule) return [];
                if (this.shouldUseIntlApi()) return rule.resolvedOptions().pluralCategories.sort(function(pluralCategory1, pluralCategory2) {
                    return $673ff3dfc4a496de$var$suffixesOrder[pluralCategory1] - $673ff3dfc4a496de$var$suffixesOrder[pluralCategory2];
                }).map(function(pluralCategory) {
                    return "".concat(_this.options.prepend).concat(pluralCategory);
                });
                return rule.numbers.map(function(number) {
                    return _this.getSuffix(code, number, options);
                });
            }
        },
        {
            key: "getSuffix",
            value: function getSuffix(code, count) {
                var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                var rule = this.getRule(code, options);
                if (rule) {
                    if (this.shouldUseIntlApi()) return "".concat(this.options.prepend).concat(rule.select(count));
                    return this.getSuffixRetroCompatible(rule, count);
                }
                this.logger.warn("no plural rule found for: ".concat(code));
                return "";
            }
        },
        {
            key: "getSuffixRetroCompatible",
            value: function getSuffixRetroCompatible(rule, count) {
                var _this2 = this;
                var idx = rule.noAbs ? rule.plurals(count) : rule.plurals(Math.abs(count));
                var suffix = rule.numbers[idx];
                if (this.options.simplifyPluralSuffix && rule.numbers.length === 2 && rule.numbers[0] === 1) {
                    if (suffix === 2) suffix = "plural";
                    else if (suffix === 1) suffix = "";
                }
                var returnSuffix = function returnSuffix() {
                    return _this2.options.prepend && suffix.toString() ? _this2.options.prepend + suffix.toString() : suffix.toString();
                };
                if (this.options.compatibilityJSON === "v1") {
                    if (suffix === 1) return "";
                    if (typeof suffix === "number") return "_plural_".concat(suffix.toString());
                    return returnSuffix();
                } else if (this.options.compatibilityJSON === "v2") return returnSuffix();
                else if (this.options.simplifyPluralSuffix && rule.numbers.length === 2 && rule.numbers[0] === 1) return returnSuffix();
                return this.options.prepend && idx.toString() ? this.options.prepend + idx.toString() : idx.toString();
            }
        },
        {
            key: "shouldUseIntlApi",
            value: function shouldUseIntlApi() {
                return !$673ff3dfc4a496de$var$deprecatedJsonVersions.includes(this.options.compatibilityJSON);
            }
        }
    ]);
    return PluralResolver;
}();
function $673ff3dfc4a496de$var$ownKeys$3(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $673ff3dfc4a496de$var$_objectSpread$3(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $673ff3dfc4a496de$var$ownKeys$3(Object(source), true).forEach(function(key) {
            (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $673ff3dfc4a496de$var$ownKeys$3(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
var $673ff3dfc4a496de$var$Interpolator = function() {
    function Interpolator() {
        var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        (0, $4d35ca0862055760$export$2e2bcd8739ae039)(this, Interpolator);
        this.logger = $673ff3dfc4a496de$var$baseLogger.create("interpolator");
        this.options = options;
        this.format = options.interpolation && options.interpolation.format || function(value) {
            return value;
        };
        this.init(options);
    }
    (0, $94019358ecbcf36b$export$2e2bcd8739ae039)(Interpolator, [
        {
            key: "init",
            value: function init() {
                var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
                if (!options.interpolation) options.interpolation = {
                    escapeValue: true
                };
                var iOpts = options.interpolation;
                this.escape = iOpts.escape !== undefined ? iOpts.escape : $673ff3dfc4a496de$var$escape;
                this.escapeValue = iOpts.escapeValue !== undefined ? iOpts.escapeValue : true;
                this.useRawValueToEscape = iOpts.useRawValueToEscape !== undefined ? iOpts.useRawValueToEscape : false;
                this.prefix = iOpts.prefix ? $673ff3dfc4a496de$var$regexEscape(iOpts.prefix) : iOpts.prefixEscaped || "{{";
                this.suffix = iOpts.suffix ? $673ff3dfc4a496de$var$regexEscape(iOpts.suffix) : iOpts.suffixEscaped || "}}";
                this.formatSeparator = iOpts.formatSeparator ? iOpts.formatSeparator : iOpts.formatSeparator || ",";
                this.unescapePrefix = iOpts.unescapeSuffix ? "" : iOpts.unescapePrefix || "-";
                this.unescapeSuffix = this.unescapePrefix ? "" : iOpts.unescapeSuffix || "";
                this.nestingPrefix = iOpts.nestingPrefix ? $673ff3dfc4a496de$var$regexEscape(iOpts.nestingPrefix) : iOpts.nestingPrefixEscaped || $673ff3dfc4a496de$var$regexEscape("$t(");
                this.nestingSuffix = iOpts.nestingSuffix ? $673ff3dfc4a496de$var$regexEscape(iOpts.nestingSuffix) : iOpts.nestingSuffixEscaped || $673ff3dfc4a496de$var$regexEscape(")");
                this.nestingOptionsSeparator = iOpts.nestingOptionsSeparator ? iOpts.nestingOptionsSeparator : iOpts.nestingOptionsSeparator || ",";
                this.maxReplaces = iOpts.maxReplaces ? iOpts.maxReplaces : 1000;
                this.alwaysFormat = iOpts.alwaysFormat !== undefined ? iOpts.alwaysFormat : false;
                this.resetRegExp();
            }
        },
        {
            key: "reset",
            value: function reset() {
                if (this.options) this.init(this.options);
            }
        },
        {
            key: "resetRegExp",
            value: function resetRegExp() {
                var regexpStr = "".concat(this.prefix, "(.+?)").concat(this.suffix);
                this.regexp = new RegExp(regexpStr, "g");
                var regexpUnescapeStr = "".concat(this.prefix).concat(this.unescapePrefix, "(.+?)").concat(this.unescapeSuffix).concat(this.suffix);
                this.regexpUnescape = new RegExp(regexpUnescapeStr, "g");
                var nestingRegexpStr = "".concat(this.nestingPrefix, "(.+?)").concat(this.nestingSuffix);
                this.nestingRegexp = new RegExp(nestingRegexpStr, "g");
            }
        },
        {
            key: "interpolate",
            value: function interpolate(str, data, lng, options) {
                var _this = this;
                var match;
                var value;
                var replaces;
                var defaultData = this.options && this.options.interpolation && this.options.interpolation.defaultVariables || {};
                function regexSafe(val) {
                    return val.replace(/\$/g, "$$$$");
                }
                var handleFormat = function handleFormat(key) {
                    if (key.indexOf(_this.formatSeparator) < 0) {
                        var path = $673ff3dfc4a496de$var$getPathWithDefaults(data, defaultData, key);
                        return _this.alwaysFormat ? _this.format(path, undefined, lng, $673ff3dfc4a496de$var$_objectSpread$3($673ff3dfc4a496de$var$_objectSpread$3($673ff3dfc4a496de$var$_objectSpread$3({}, options), data), {}, {
                            interpolationkey: key
                        })) : path;
                    }
                    var p = key.split(_this.formatSeparator);
                    var k = p.shift().trim();
                    var f = p.join(_this.formatSeparator).trim();
                    return _this.format($673ff3dfc4a496de$var$getPathWithDefaults(data, defaultData, k), f, lng, $673ff3dfc4a496de$var$_objectSpread$3($673ff3dfc4a496de$var$_objectSpread$3($673ff3dfc4a496de$var$_objectSpread$3({}, options), data), {}, {
                        interpolationkey: k
                    }));
                };
                this.resetRegExp();
                var missingInterpolationHandler = options && options.missingInterpolationHandler || this.options.missingInterpolationHandler;
                var skipOnVariables = options && options.interpolation && options.interpolation.skipOnVariables !== undefined ? options.interpolation.skipOnVariables : this.options.interpolation.skipOnVariables;
                var todos = [
                    {
                        regex: this.regexpUnescape,
                        safeValue: function safeValue(val) {
                            return regexSafe(val);
                        }
                    },
                    {
                        regex: this.regexp,
                        safeValue: function safeValue(val) {
                            return _this.escapeValue ? regexSafe(_this.escape(val)) : regexSafe(val);
                        }
                    }
                ];
                todos.forEach(function(todo) {
                    replaces = 0;
                    while(match = todo.regex.exec(str)){
                        var matchedVar = match[1].trim();
                        value = handleFormat(matchedVar);
                        if (value === undefined) {
                            if (typeof missingInterpolationHandler === "function") {
                                var temp = missingInterpolationHandler(str, match, options);
                                value = typeof temp === "string" ? temp : "";
                            } else if (options && options.hasOwnProperty(matchedVar)) value = "";
                            else if (skipOnVariables) {
                                value = match[0];
                                continue;
                            } else {
                                _this.logger.warn("missed to pass in variable ".concat(matchedVar, " for interpolating ").concat(str));
                                value = "";
                            }
                        } else if (typeof value !== "string" && !_this.useRawValueToEscape) value = $673ff3dfc4a496de$var$makeString(value);
                        var safeValue = todo.safeValue(value);
                        str = str.replace(match[0], safeValue);
                        if (skipOnVariables) {
                            todo.regex.lastIndex += value.length;
                            todo.regex.lastIndex -= match[0].length;
                        } else todo.regex.lastIndex = 0;
                        replaces++;
                        if (replaces >= _this.maxReplaces) break;
                    }
                });
                return str;
            }
        },
        {
            key: "nest",
            value: function nest(str, fc) {
                var _this2 = this;
                var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                var match;
                var value;
                var clonedOptions = $673ff3dfc4a496de$var$_objectSpread$3({}, options);
                clonedOptions.applyPostProcessor = false;
                delete clonedOptions.defaultValue;
                function handleHasOptions(key, inheritedOptions) {
                    var sep = this.nestingOptionsSeparator;
                    if (key.indexOf(sep) < 0) return key;
                    var c = key.split(new RegExp("".concat(sep, "[ ]*{")));
                    var optionsString = "{".concat(c[1]);
                    key = c[0];
                    optionsString = this.interpolate(optionsString, clonedOptions);
                    var matchedSingleQuotes = optionsString.match(/'/g);
                    var matchedDoubleQuotes = optionsString.match(/"/g);
                    if (matchedSingleQuotes && matchedSingleQuotes.length % 2 === 0 && !matchedDoubleQuotes || matchedDoubleQuotes.length % 2 !== 0) optionsString = optionsString.replace(/'/g, '"');
                    try {
                        clonedOptions = JSON.parse(optionsString);
                        if (inheritedOptions) clonedOptions = $673ff3dfc4a496de$var$_objectSpread$3($673ff3dfc4a496de$var$_objectSpread$3({}, inheritedOptions), clonedOptions);
                    } catch (e) {
                        this.logger.warn("failed parsing options string in nesting for key ".concat(key), e);
                        return "".concat(key).concat(sep).concat(optionsString);
                    }
                    delete clonedOptions.defaultValue;
                    return key;
                }
                while(match = this.nestingRegexp.exec(str)){
                    var formatters = [];
                    var doReduce = false;
                    if (match[0].indexOf(this.formatSeparator) !== -1 && !/{.*}/.test(match[1])) {
                        var r = match[1].split(this.formatSeparator).map(function(elem) {
                            return elem.trim();
                        });
                        match[1] = r.shift();
                        formatters = r;
                        doReduce = true;
                    }
                    value = fc(handleHasOptions.call(this, match[1].trim(), clonedOptions), clonedOptions);
                    if (value && match[0] === str && typeof value !== "string") return value;
                    if (typeof value !== "string") value = $673ff3dfc4a496de$var$makeString(value);
                    if (!value) {
                        this.logger.warn("missed to resolve ".concat(match[1], " for nesting ").concat(str));
                        value = "";
                    }
                    if (doReduce) value = formatters.reduce(function(v, f) {
                        return _this2.format(v, f, options.lng, $673ff3dfc4a496de$var$_objectSpread$3($673ff3dfc4a496de$var$_objectSpread$3({}, options), {}, {
                            interpolationkey: match[1].trim()
                        }));
                    }, value.trim());
                    str = str.replace(match[0], value);
                    this.regexp.lastIndex = 0;
                }
                return str;
            }
        }
    ]);
    return Interpolator;
}();
function $673ff3dfc4a496de$var$ownKeys$4(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $673ff3dfc4a496de$var$_objectSpread$4(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $673ff3dfc4a496de$var$ownKeys$4(Object(source), true).forEach(function(key) {
            (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $673ff3dfc4a496de$var$ownKeys$4(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $673ff3dfc4a496de$var$parseFormatStr(formatStr) {
    var formatName = formatStr.toLowerCase().trim();
    var formatOptions = {};
    if (formatStr.indexOf("(") > -1) {
        var p = formatStr.split("(");
        formatName = p[0].toLowerCase().trim();
        var optStr = p[1].substring(0, p[1].length - 1);
        if (formatName === "currency" && optStr.indexOf(":") < 0) {
            if (!formatOptions.currency) formatOptions.currency = optStr.trim();
        } else if (formatName === "relativetime" && optStr.indexOf(":") < 0) {
            if (!formatOptions.range) formatOptions.range = optStr.trim();
        } else {
            var opts = optStr.split(";");
            opts.forEach(function(opt) {
                if (!opt) return;
                var _opt$split = opt.split(":"), _opt$split2 = (0, $7d110e739ae14cc6$export$2e2bcd8739ae039)(_opt$split), key = _opt$split2[0], rest = _opt$split2.slice(1);
                var val = rest.join(":").trim().replace(/^'+|'+$/g, "");
                if (!formatOptions[key.trim()]) formatOptions[key.trim()] = val;
                if (val === "false") formatOptions[key.trim()] = false;
                if (val === "true") formatOptions[key.trim()] = true;
                if (!isNaN(val)) formatOptions[key.trim()] = parseInt(val, 10);
            });
        }
    }
    return {
        formatName: formatName,
        formatOptions: formatOptions
    };
}
function $673ff3dfc4a496de$var$createCachedFormatter(fn) {
    var cache = {};
    return function invokeFormatter(val, lng, options) {
        var key = lng + JSON.stringify(options);
        var formatter = cache[key];
        if (!formatter) {
            formatter = fn(lng, options);
            cache[key] = formatter;
        }
        return formatter(val);
    };
}
var $673ff3dfc4a496de$var$Formatter = function() {
    function Formatter() {
        var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        (0, $4d35ca0862055760$export$2e2bcd8739ae039)(this, Formatter);
        this.logger = $673ff3dfc4a496de$var$baseLogger.create("formatter");
        this.options = options;
        this.formats = {
            number: $673ff3dfc4a496de$var$createCachedFormatter(function(lng, options) {
                var formatter = new Intl.NumberFormat(lng, options);
                return function(val) {
                    return formatter.format(val);
                };
            }),
            currency: $673ff3dfc4a496de$var$createCachedFormatter(function(lng, options) {
                var formatter = new Intl.NumberFormat(lng, $673ff3dfc4a496de$var$_objectSpread$4($673ff3dfc4a496de$var$_objectSpread$4({}, options), {}, {
                    style: "currency"
                }));
                return function(val) {
                    return formatter.format(val);
                };
            }),
            datetime: $673ff3dfc4a496de$var$createCachedFormatter(function(lng, options) {
                var formatter = new Intl.DateTimeFormat(lng, $673ff3dfc4a496de$var$_objectSpread$4({}, options));
                return function(val) {
                    return formatter.format(val);
                };
            }),
            relativetime: $673ff3dfc4a496de$var$createCachedFormatter(function(lng, options) {
                var formatter = new Intl.RelativeTimeFormat(lng, $673ff3dfc4a496de$var$_objectSpread$4({}, options));
                return function(val) {
                    return formatter.format(val, options.range || "day");
                };
            }),
            list: $673ff3dfc4a496de$var$createCachedFormatter(function(lng, options) {
                var formatter = new Intl.ListFormat(lng, $673ff3dfc4a496de$var$_objectSpread$4({}, options));
                return function(val) {
                    return formatter.format(val);
                };
            })
        };
        this.init(options);
    }
    (0, $94019358ecbcf36b$export$2e2bcd8739ae039)(Formatter, [
        {
            key: "init",
            value: function init(services) {
                var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
                    interpolation: {}
                };
                var iOpts = options.interpolation;
                this.formatSeparator = iOpts.formatSeparator ? iOpts.formatSeparator : iOpts.formatSeparator || ",";
            }
        },
        {
            key: "add",
            value: function add(name, fc) {
                this.formats[name.toLowerCase().trim()] = fc;
            }
        },
        {
            key: "addCached",
            value: function addCached(name, fc) {
                this.formats[name.toLowerCase().trim()] = $673ff3dfc4a496de$var$createCachedFormatter(fc);
            }
        },
        {
            key: "format",
            value: function format(value, _format, lng, options) {
                var _this = this;
                var formats = _format.split(this.formatSeparator);
                var result = formats.reduce(function(mem, f) {
                    var _parseFormatStr = $673ff3dfc4a496de$var$parseFormatStr(f), formatName = _parseFormatStr.formatName, formatOptions = _parseFormatStr.formatOptions;
                    if (_this.formats[formatName]) {
                        var formatted = mem;
                        try {
                            var valOptions = options && options.formatParams && options.formatParams[options.interpolationkey] || {};
                            var l = valOptions.locale || valOptions.lng || options.locale || options.lng || lng;
                            formatted = _this.formats[formatName](mem, l, $673ff3dfc4a496de$var$_objectSpread$4($673ff3dfc4a496de$var$_objectSpread$4($673ff3dfc4a496de$var$_objectSpread$4({}, formatOptions), options), valOptions));
                        } catch (error) {
                            _this.logger.warn(error);
                        }
                        return formatted;
                    } else _this.logger.warn("there was no format function for ".concat(formatName));
                    return mem;
                }, value);
                return result;
            }
        }
    ]);
    return Formatter;
}();
function $673ff3dfc4a496de$var$ownKeys$5(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $673ff3dfc4a496de$var$_objectSpread$5(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $673ff3dfc4a496de$var$ownKeys$5(Object(source), true).forEach(function(key) {
            (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $673ff3dfc4a496de$var$ownKeys$5(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $673ff3dfc4a496de$var$_createSuper$2(Derived) {
    var hasNativeReflectConstruct = $673ff3dfc4a496de$var$_isNativeReflectConstruct$2();
    return function _createSuperInternal() {
        var Super = (0, $e4c5ebe502337db0$export$2e2bcd8739ae039)(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, $e4c5ebe502337db0$export$2e2bcd8739ae039)(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, $6a259df8fa92dc4a$export$2e2bcd8739ae039)(this, result);
    };
}
function $673ff3dfc4a496de$var$_isNativeReflectConstruct$2() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $673ff3dfc4a496de$var$removePending(q, name) {
    if (q.pending[name] !== undefined) {
        delete q.pending[name];
        q.pendingCount--;
    }
}
var $673ff3dfc4a496de$var$Connector = function(_EventEmitter) {
    (0, $0ed648f7bbaf3aff$export$2e2bcd8739ae039)(Connector, _EventEmitter);
    var _super = $673ff3dfc4a496de$var$_createSuper$2(Connector);
    function Connector(backend, store, services) {
        var _this;
        var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
        (0, $4d35ca0862055760$export$2e2bcd8739ae039)(this, Connector);
        _this = _super.call(this);
        if ($673ff3dfc4a496de$var$isIE10) $673ff3dfc4a496de$var$EventEmitter.call((0, $cd69a1d4c6210e44$export$2e2bcd8739ae039)(_this));
        _this.backend = backend;
        _this.store = store;
        _this.services = services;
        _this.languageUtils = services.languageUtils;
        _this.options = options;
        _this.logger = $673ff3dfc4a496de$var$baseLogger.create("backendConnector");
        _this.waitingReads = [];
        _this.maxParallelReads = options.maxParallelReads || 10;
        _this.readingCalls = 0;
        _this.maxRetries = options.maxRetries >= 0 ? options.maxRetries : 5;
        _this.retryTimeout = options.retryTimeout >= 1 ? options.retryTimeout : 350;
        _this.state = {};
        _this.queue = [];
        if (_this.backend && _this.backend.init) _this.backend.init(services, options.backend, options);
        return _this;
    }
    (0, $94019358ecbcf36b$export$2e2bcd8739ae039)(Connector, [
        {
            key: "queueLoad",
            value: function queueLoad(languages, namespaces, options, callback) {
                var _this2 = this;
                var toLoad = {};
                var pending = {};
                var toLoadLanguages = {};
                var toLoadNamespaces = {};
                languages.forEach(function(lng) {
                    var hasAllNamespaces = true;
                    namespaces.forEach(function(ns) {
                        var name = "".concat(lng, "|").concat(ns);
                        if (!options.reload && _this2.store.hasResourceBundle(lng, ns)) _this2.state[name] = 2;
                        else if (_this2.state[name] < 0) ;
                        else if (_this2.state[name] === 1) {
                            if (pending[name] === undefined) pending[name] = true;
                        } else {
                            _this2.state[name] = 1;
                            hasAllNamespaces = false;
                            if (pending[name] === undefined) pending[name] = true;
                            if (toLoad[name] === undefined) toLoad[name] = true;
                            if (toLoadNamespaces[ns] === undefined) toLoadNamespaces[ns] = true;
                        }
                    });
                    if (!hasAllNamespaces) toLoadLanguages[lng] = true;
                });
                if (Object.keys(toLoad).length || Object.keys(pending).length) this.queue.push({
                    pending: pending,
                    pendingCount: Object.keys(pending).length,
                    loaded: {},
                    errors: [],
                    callback: callback
                });
                return {
                    toLoad: Object.keys(toLoad),
                    pending: Object.keys(pending),
                    toLoadLanguages: Object.keys(toLoadLanguages),
                    toLoadNamespaces: Object.keys(toLoadNamespaces)
                };
            }
        },
        {
            key: "loaded",
            value: function loaded(name, err, data) {
                var s = name.split("|");
                var lng = s[0];
                var ns = s[1];
                if (err) this.emit("failedLoading", lng, ns, err);
                if (data) this.store.addResourceBundle(lng, ns, data);
                this.state[name] = err ? -1 : 2;
                var loaded = {};
                this.queue.forEach(function(q) {
                    $673ff3dfc4a496de$var$pushPath(q.loaded, [
                        lng
                    ], ns);
                    $673ff3dfc4a496de$var$removePending(q, name);
                    if (err) q.errors.push(err);
                    if (q.pendingCount === 0 && !q.done) {
                        Object.keys(q.loaded).forEach(function(l) {
                            if (!loaded[l]) loaded[l] = {};
                            var loadedKeys = q.loaded[l];
                            if (loadedKeys.length) loadedKeys.forEach(function(ns) {
                                if (loaded[l][ns] === undefined) loaded[l][ns] = true;
                            });
                        });
                        q.done = true;
                        if (q.errors.length) q.callback(q.errors);
                        else q.callback();
                    }
                });
                this.emit("loaded", loaded);
                this.queue = this.queue.filter(function(q) {
                    return !q.done;
                });
            }
        },
        {
            key: "read",
            value: function read(lng, ns, fcName) {
                var _this3 = this;
                var tried = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
                var wait = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : this.retryTimeout;
                var callback = arguments.length > 5 ? arguments[5] : undefined;
                if (!lng.length) return callback(null, {});
                if (this.readingCalls >= this.maxParallelReads) {
                    this.waitingReads.push({
                        lng: lng,
                        ns: ns,
                        fcName: fcName,
                        tried: tried,
                        wait: wait,
                        callback: callback
                    });
                    return;
                }
                this.readingCalls++;
                return this.backend[fcName](lng, ns, function(err, data) {
                    _this3.readingCalls--;
                    if (_this3.waitingReads.length > 0) {
                        var next = _this3.waitingReads.shift();
                        _this3.read(next.lng, next.ns, next.fcName, next.tried, next.wait, next.callback);
                    }
                    if (err && data && tried < _this3.maxRetries) {
                        setTimeout(function() {
                            _this3.read.call(_this3, lng, ns, fcName, tried + 1, wait * 2, callback);
                        }, wait);
                        return;
                    }
                    callback(err, data);
                });
            }
        },
        {
            key: "prepareLoading",
            value: function prepareLoading(languages, namespaces) {
                var _this4 = this;
                var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                var callback = arguments.length > 3 ? arguments[3] : undefined;
                if (!this.backend) {
                    this.logger.warn("No backend was added via i18next.use. Will not load resources.");
                    return callback && callback();
                }
                if (typeof languages === "string") languages = this.languageUtils.toResolveHierarchy(languages);
                if (typeof namespaces === "string") namespaces = [
                    namespaces
                ];
                var toLoad = this.queueLoad(languages, namespaces, options, callback);
                if (!toLoad.toLoad.length) {
                    if (!toLoad.pending.length) callback();
                    return null;
                }
                toLoad.toLoad.forEach(function(name) {
                    _this4.loadOne(name);
                });
            }
        },
        {
            key: "load",
            value: function load(languages, namespaces, callback) {
                this.prepareLoading(languages, namespaces, {}, callback);
            }
        },
        {
            key: "reload",
            value: function reload(languages, namespaces, callback) {
                this.prepareLoading(languages, namespaces, {
                    reload: true
                }, callback);
            }
        },
        {
            key: "loadOne",
            value: function loadOne(name) {
                var _this5 = this;
                var prefix = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";
                var s = name.split("|");
                var lng = s[0];
                var ns = s[1];
                this.read(lng, ns, "read", undefined, undefined, function(err, data) {
                    if (err) _this5.logger.warn("".concat(prefix, "loading namespace ").concat(ns, " for language ").concat(lng, " failed"), err);
                    if (!err && data) _this5.logger.log("".concat(prefix, "loaded namespace ").concat(ns, " for language ").concat(lng), data);
                    _this5.loaded(name, err, data);
                });
            }
        },
        {
            key: "saveMissing",
            value: function saveMissing(languages, namespace, key, fallbackValue, isUpdate) {
                var options = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : {};
                if (this.services.utils && this.services.utils.hasLoadedNamespace && !this.services.utils.hasLoadedNamespace(namespace)) {
                    this.logger.warn('did not save key "'.concat(key, '" as the namespace "').concat(namespace, '" was not yet loaded'), "This means something IS WRONG in your setup. You access the t function before i18next.init / i18next.loadNamespace / i18next.changeLanguage was done. Wait for the callback or Promise to resolve before accessing it!!!");
                    return;
                }
                if (key === undefined || key === null || key === "") return;
                if (this.backend && this.backend.create) this.backend.create(languages, namespace, key, fallbackValue, null, $673ff3dfc4a496de$var$_objectSpread$5($673ff3dfc4a496de$var$_objectSpread$5({}, options), {}, {
                    isUpdate: isUpdate
                }));
                if (!languages || !languages[0]) return;
                this.store.addResource(languages[0], namespace, key, fallbackValue);
            }
        }
    ]);
    return Connector;
}($673ff3dfc4a496de$var$EventEmitter);
function $673ff3dfc4a496de$var$get() {
    return {
        debug: false,
        initImmediate: true,
        ns: [
            "translation"
        ],
        defaultNS: [
            "translation"
        ],
        fallbackLng: [
            "dev"
        ],
        fallbackNS: false,
        supportedLngs: false,
        nonExplicitSupportedLngs: false,
        load: "all",
        preload: false,
        simplifyPluralSuffix: true,
        keySeparator: ".",
        nsSeparator: ":",
        pluralSeparator: "_",
        contextSeparator: "_",
        partialBundledLanguages: false,
        saveMissing: false,
        updateMissing: false,
        saveMissingTo: "fallback",
        saveMissingPlurals: true,
        missingKeyHandler: false,
        missingInterpolationHandler: false,
        postProcess: false,
        postProcessPassResolved: false,
        returnNull: true,
        returnEmptyString: true,
        returnObjects: false,
        joinArrays: false,
        returnedObjectHandler: false,
        parseMissingKeyHandler: false,
        appendNamespaceToMissingKey: false,
        appendNamespaceToCIMode: false,
        overloadTranslationOptionHandler: function handle(args) {
            var ret = {};
            if ((0, $b8f57191916382d3$export$2e2bcd8739ae039)(args[1]) === "object") ret = args[1];
            if (typeof args[1] === "string") ret.defaultValue = args[1];
            if (typeof args[2] === "string") ret.tDescription = args[2];
            if ((0, $b8f57191916382d3$export$2e2bcd8739ae039)(args[2]) === "object" || (0, $b8f57191916382d3$export$2e2bcd8739ae039)(args[3]) === "object") {
                var options = args[3] || args[2];
                Object.keys(options).forEach(function(key) {
                    ret[key] = options[key];
                });
            }
            return ret;
        },
        interpolation: {
            escapeValue: true,
            format: function format(value, _format, lng, options) {
                return value;
            },
            prefix: "{{",
            suffix: "}}",
            formatSeparator: ",",
            unescapePrefix: "-",
            nestingPrefix: "$t(",
            nestingSuffix: ")",
            nestingOptionsSeparator: ",",
            maxReplaces: 1000,
            skipOnVariables: true
        }
    };
}
function $673ff3dfc4a496de$var$transformOptions(options) {
    if (typeof options.ns === "string") options.ns = [
        options.ns
    ];
    if (typeof options.fallbackLng === "string") options.fallbackLng = [
        options.fallbackLng
    ];
    if (typeof options.fallbackNS === "string") options.fallbackNS = [
        options.fallbackNS
    ];
    if (options.supportedLngs && options.supportedLngs.indexOf("cimode") < 0) options.supportedLngs = options.supportedLngs.concat([
        "cimode"
    ]);
    return options;
}
function $673ff3dfc4a496de$var$ownKeys$6(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $673ff3dfc4a496de$var$_objectSpread$6(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $673ff3dfc4a496de$var$ownKeys$6(Object(source), true).forEach(function(key) {
            (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $673ff3dfc4a496de$var$ownKeys$6(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $673ff3dfc4a496de$var$_createSuper$3(Derived) {
    var hasNativeReflectConstruct = $673ff3dfc4a496de$var$_isNativeReflectConstruct$3();
    return function _createSuperInternal() {
        var Super = (0, $e4c5ebe502337db0$export$2e2bcd8739ae039)(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, $e4c5ebe502337db0$export$2e2bcd8739ae039)(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, $6a259df8fa92dc4a$export$2e2bcd8739ae039)(this, result);
    };
}
function $673ff3dfc4a496de$var$_isNativeReflectConstruct$3() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $673ff3dfc4a496de$var$noop() {}
function $673ff3dfc4a496de$var$bindMemberFunctions(inst) {
    var mems = Object.getOwnPropertyNames(Object.getPrototypeOf(inst));
    mems.forEach(function(mem) {
        if (typeof inst[mem] === "function") inst[mem] = inst[mem].bind(inst);
    });
}
var $673ff3dfc4a496de$var$I18n = function(_EventEmitter) {
    (0, $0ed648f7bbaf3aff$export$2e2bcd8739ae039)(I18n, _EventEmitter);
    var _super = $673ff3dfc4a496de$var$_createSuper$3(I18n);
    function I18n() {
        var _this;
        var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        var callback = arguments.length > 1 ? arguments[1] : undefined;
        (0, $4d35ca0862055760$export$2e2bcd8739ae039)(this, I18n);
        _this = _super.call(this);
        if ($673ff3dfc4a496de$var$isIE10) $673ff3dfc4a496de$var$EventEmitter.call((0, $cd69a1d4c6210e44$export$2e2bcd8739ae039)(_this));
        _this.options = $673ff3dfc4a496de$var$transformOptions(options);
        _this.services = {};
        _this.logger = $673ff3dfc4a496de$var$baseLogger;
        _this.modules = {
            external: []
        };
        $673ff3dfc4a496de$var$bindMemberFunctions((0, $cd69a1d4c6210e44$export$2e2bcd8739ae039)(_this));
        if (callback && !_this.isInitialized && !options.isClone) {
            if (!_this.options.initImmediate) {
                _this.init(options, callback);
                return (0, $6a259df8fa92dc4a$export$2e2bcd8739ae039)(_this, (0, $cd69a1d4c6210e44$export$2e2bcd8739ae039)(_this));
            }
            setTimeout(function() {
                _this.init(options, callback);
            }, 0);
        }
        return _this;
    }
    (0, $94019358ecbcf36b$export$2e2bcd8739ae039)(I18n, [
        {
            key: "init",
            value: function init() {
                var _this2 = this;
                var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
                var callback = arguments.length > 1 ? arguments[1] : undefined;
                if (typeof options === "function") {
                    callback = options;
                    options = {};
                }
                if (!options.defaultNS && options.defaultNS !== false && options.ns) {
                    if (typeof options.ns === "string") options.defaultNS = options.ns;
                    else if (options.ns.indexOf("translation") < 0) options.defaultNS = options.ns[0];
                }
                var defOpts = $673ff3dfc4a496de$var$get();
                this.options = $673ff3dfc4a496de$var$_objectSpread$6($673ff3dfc4a496de$var$_objectSpread$6($673ff3dfc4a496de$var$_objectSpread$6({}, defOpts), this.options), $673ff3dfc4a496de$var$transformOptions(options));
                if (this.options.compatibilityAPI !== "v1") this.options.interpolation = $673ff3dfc4a496de$var$_objectSpread$6($673ff3dfc4a496de$var$_objectSpread$6({}, defOpts.interpolation), this.options.interpolation);
                if (options.keySeparator !== undefined) this.options.userDefinedKeySeparator = options.keySeparator;
                if (options.nsSeparator !== undefined) this.options.userDefinedNsSeparator = options.nsSeparator;
                function createClassOnDemand(ClassOrObject) {
                    if (!ClassOrObject) return null;
                    if (typeof ClassOrObject === "function") return new ClassOrObject();
                    return ClassOrObject;
                }
                if (!this.options.isClone) {
                    if (this.modules.logger) $673ff3dfc4a496de$var$baseLogger.init(createClassOnDemand(this.modules.logger), this.options);
                    else $673ff3dfc4a496de$var$baseLogger.init(null, this.options);
                    var formatter;
                    if (this.modules.formatter) formatter = this.modules.formatter;
                    else if (typeof Intl !== "undefined") formatter = $673ff3dfc4a496de$var$Formatter;
                    var lu = new $673ff3dfc4a496de$var$LanguageUtil(this.options);
                    this.store = new $673ff3dfc4a496de$var$ResourceStore(this.options.resources, this.options);
                    var s = this.services;
                    s.logger = $673ff3dfc4a496de$var$baseLogger;
                    s.resourceStore = this.store;
                    s.languageUtils = lu;
                    s.pluralResolver = new $673ff3dfc4a496de$var$PluralResolver(lu, {
                        prepend: this.options.pluralSeparator,
                        compatibilityJSON: this.options.compatibilityJSON,
                        simplifyPluralSuffix: this.options.simplifyPluralSuffix
                    });
                    if (formatter && (!this.options.interpolation.format || this.options.interpolation.format === defOpts.interpolation.format)) {
                        s.formatter = createClassOnDemand(formatter);
                        s.formatter.init(s, this.options);
                        this.options.interpolation.format = s.formatter.format.bind(s.formatter);
                    }
                    s.interpolator = new $673ff3dfc4a496de$var$Interpolator(this.options);
                    s.utils = {
                        hasLoadedNamespace: this.hasLoadedNamespace.bind(this)
                    };
                    s.backendConnector = new $673ff3dfc4a496de$var$Connector(createClassOnDemand(this.modules.backend), s.resourceStore, s, this.options);
                    s.backendConnector.on("*", function(event) {
                        for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
                        _this2.emit.apply(_this2, [
                            event
                        ].concat(args));
                    });
                    if (this.modules.languageDetector) {
                        s.languageDetector = createClassOnDemand(this.modules.languageDetector);
                        s.languageDetector.init(s, this.options.detection, this.options);
                    }
                    if (this.modules.i18nFormat) {
                        s.i18nFormat = createClassOnDemand(this.modules.i18nFormat);
                        if (s.i18nFormat.init) s.i18nFormat.init(this);
                    }
                    this.translator = new $673ff3dfc4a496de$var$Translator(this.services, this.options);
                    this.translator.on("*", function(event) {
                        for(var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++)args[_key2 - 1] = arguments[_key2];
                        _this2.emit.apply(_this2, [
                            event
                        ].concat(args));
                    });
                    this.modules.external.forEach(function(m) {
                        if (m.init) m.init(_this2);
                    });
                }
                this.format = this.options.interpolation.format;
                if (!callback) callback = $673ff3dfc4a496de$var$noop;
                if (this.options.fallbackLng && !this.services.languageDetector && !this.options.lng) {
                    var codes = this.services.languageUtils.getFallbackCodes(this.options.fallbackLng);
                    if (codes.length > 0 && codes[0] !== "dev") this.options.lng = codes[0];
                }
                if (!this.services.languageDetector && !this.options.lng) this.logger.warn("init: no languageDetector is used and no lng is defined");
                var storeApi = [
                    "getResource",
                    "hasResourceBundle",
                    "getResourceBundle",
                    "getDataByLanguage"
                ];
                storeApi.forEach(function(fcName) {
                    _this2[fcName] = function() {
                        var _this2$store;
                        return (_this2$store = _this2.store)[fcName].apply(_this2$store, arguments);
                    };
                });
                var storeApiChained = [
                    "addResource",
                    "addResources",
                    "addResourceBundle",
                    "removeResourceBundle"
                ];
                storeApiChained.forEach(function(fcName) {
                    _this2[fcName] = function() {
                        var _this2$store2;
                        (_this2$store2 = _this2.store)[fcName].apply(_this2$store2, arguments);
                        return _this2;
                    };
                });
                var deferred = $673ff3dfc4a496de$var$defer();
                var load = function load() {
                    var finish = function finish(err, t) {
                        if (_this2.isInitialized && !_this2.initializedStoreOnce) _this2.logger.warn("init: i18next is already initialized. You should call init just once!");
                        _this2.isInitialized = true;
                        if (!_this2.options.isClone) _this2.logger.log("initialized", _this2.options);
                        _this2.emit("initialized", _this2.options);
                        deferred.resolve(t);
                        callback(err, t);
                    };
                    if (_this2.languages && _this2.options.compatibilityAPI !== "v1" && !_this2.isInitialized) return finish(null, _this2.t.bind(_this2));
                    _this2.changeLanguage(_this2.options.lng, finish);
                };
                if (this.options.resources || !this.options.initImmediate) load();
                else setTimeout(load, 0);
                return deferred;
            }
        },
        {
            key: "loadResources",
            value: function loadResources(language) {
                var _this3 = this;
                var callback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $673ff3dfc4a496de$var$noop;
                var usedCallback = callback;
                var usedLng = typeof language === "string" ? language : this.language;
                if (typeof language === "function") usedCallback = language;
                if (!this.options.resources || this.options.partialBundledLanguages) {
                    if (usedLng && usedLng.toLowerCase() === "cimode") return usedCallback();
                    var toLoad = [];
                    var append = function append(lng) {
                        if (!lng) return;
                        var lngs = _this3.services.languageUtils.toResolveHierarchy(lng);
                        lngs.forEach(function(l) {
                            if (toLoad.indexOf(l) < 0) toLoad.push(l);
                        });
                    };
                    if (!usedLng) {
                        var fallbacks = this.services.languageUtils.getFallbackCodes(this.options.fallbackLng);
                        fallbacks.forEach(function(l) {
                            return append(l);
                        });
                    } else append(usedLng);
                    if (this.options.preload) this.options.preload.forEach(function(l) {
                        return append(l);
                    });
                    this.services.backendConnector.load(toLoad, this.options.ns, function(e) {
                        if (!e && !_this3.resolvedLanguage && _this3.language) _this3.setResolvedLanguage(_this3.language);
                        usedCallback(e);
                    });
                } else usedCallback(null);
            }
        },
        {
            key: "reloadResources",
            value: function reloadResources(lngs, ns, callback) {
                var deferred = $673ff3dfc4a496de$var$defer();
                if (!lngs) lngs = this.languages;
                if (!ns) ns = this.options.ns;
                if (!callback) callback = $673ff3dfc4a496de$var$noop;
                this.services.backendConnector.reload(lngs, ns, function(err) {
                    deferred.resolve();
                    callback(err);
                });
                return deferred;
            }
        },
        {
            key: "use",
            value: function use(module) {
                if (!module) throw new Error("You are passing an undefined module! Please check the object you are passing to i18next.use()");
                if (!module.type) throw new Error("You are passing a wrong module! Please check the object you are passing to i18next.use()");
                if (module.type === "backend") this.modules.backend = module;
                if (module.type === "logger" || module.log && module.warn && module.error) this.modules.logger = module;
                if (module.type === "languageDetector") this.modules.languageDetector = module;
                if (module.type === "i18nFormat") this.modules.i18nFormat = module;
                if (module.type === "postProcessor") $673ff3dfc4a496de$var$postProcessor.addPostProcessor(module);
                if (module.type === "formatter") this.modules.formatter = module;
                if (module.type === "3rdParty") this.modules.external.push(module);
                return this;
            }
        },
        {
            key: "setResolvedLanguage",
            value: function setResolvedLanguage(l) {
                if (!l || !this.languages) return;
                if ([
                    "cimode",
                    "dev"
                ].indexOf(l) > -1) return;
                for(var li = 0; li < this.languages.length; li++){
                    var lngInLngs = this.languages[li];
                    if ([
                        "cimode",
                        "dev"
                    ].indexOf(lngInLngs) > -1) continue;
                    if (this.store.hasLanguageSomeTranslations(lngInLngs)) {
                        this.resolvedLanguage = lngInLngs;
                        break;
                    }
                }
            }
        },
        {
            key: "changeLanguage",
            value: function changeLanguage(lng, callback) {
                var _this4 = this;
                this.isLanguageChangingTo = lng;
                var deferred = $673ff3dfc4a496de$var$defer();
                this.emit("languageChanging", lng);
                var setLngProps = function setLngProps(l) {
                    _this4.language = l;
                    _this4.languages = _this4.services.languageUtils.toResolveHierarchy(l);
                    _this4.resolvedLanguage = undefined;
                    _this4.setResolvedLanguage(l);
                };
                var done = function done(err, l) {
                    if (l) {
                        setLngProps(l);
                        _this4.translator.changeLanguage(l);
                        _this4.isLanguageChangingTo = undefined;
                        _this4.emit("languageChanged", l);
                        _this4.logger.log("languageChanged", l);
                    } else _this4.isLanguageChangingTo = undefined;
                    deferred.resolve(function() {
                        return _this4.t.apply(_this4, arguments);
                    });
                    if (callback) callback(err, function() {
                        return _this4.t.apply(_this4, arguments);
                    });
                };
                var setLng = function setLng(lngs) {
                    if (!lng && !lngs && _this4.services.languageDetector) lngs = [];
                    var l = typeof lngs === "string" ? lngs : _this4.services.languageUtils.getBestMatchFromCodes(lngs);
                    if (l) {
                        if (!_this4.language) setLngProps(l);
                        if (!_this4.translator.language) _this4.translator.changeLanguage(l);
                        if (_this4.services.languageDetector) _this4.services.languageDetector.cacheUserLanguage(l);
                    }
                    _this4.loadResources(l, function(err) {
                        done(err, l);
                    });
                };
                if (!lng && this.services.languageDetector && !this.services.languageDetector.async) setLng(this.services.languageDetector.detect());
                else if (!lng && this.services.languageDetector && this.services.languageDetector.async) this.services.languageDetector.detect(setLng);
                else setLng(lng);
                return deferred;
            }
        },
        {
            key: "getFixedT",
            value: function getFixedT(lng, ns, keyPrefix) {
                var _this5 = this;
                var fixedT = function fixedT(key, opts) {
                    var options;
                    if ((0, $b8f57191916382d3$export$2e2bcd8739ae039)(opts) !== "object") {
                        for(var _len3 = arguments.length, rest = new Array(_len3 > 2 ? _len3 - 2 : 0), _key3 = 2; _key3 < _len3; _key3++)rest[_key3 - 2] = arguments[_key3];
                        options = _this5.options.overloadTranslationOptionHandler([
                            key,
                            opts
                        ].concat(rest));
                    } else options = $673ff3dfc4a496de$var$_objectSpread$6({}, opts);
                    options.lng = options.lng || fixedT.lng;
                    options.lngs = options.lngs || fixedT.lngs;
                    options.ns = options.ns || fixedT.ns;
                    options.keyPrefix = options.keyPrefix || keyPrefix || fixedT.keyPrefix;
                    var keySeparator = _this5.options.keySeparator || ".";
                    var resultKey = options.keyPrefix ? "".concat(options.keyPrefix).concat(keySeparator).concat(key) : key;
                    return _this5.t(resultKey, options);
                };
                if (typeof lng === "string") fixedT.lng = lng;
                else fixedT.lngs = lng;
                fixedT.ns = ns;
                fixedT.keyPrefix = keyPrefix;
                return fixedT;
            }
        },
        {
            key: "t",
            value: function t() {
                var _this$translator;
                return this.translator && (_this$translator = this.translator).translate.apply(_this$translator, arguments);
            }
        },
        {
            key: "exists",
            value: function exists() {
                var _this$translator2;
                return this.translator && (_this$translator2 = this.translator).exists.apply(_this$translator2, arguments);
            }
        },
        {
            key: "setDefaultNamespace",
            value: function setDefaultNamespace(ns) {
                this.options.defaultNS = ns;
            }
        },
        {
            key: "hasLoadedNamespace",
            value: function hasLoadedNamespace(ns) {
                var _this6 = this;
                var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                if (!this.isInitialized) {
                    this.logger.warn("hasLoadedNamespace: i18next was not initialized", this.languages);
                    return false;
                }
                if (!this.languages || !this.languages.length) {
                    this.logger.warn("hasLoadedNamespace: i18n.languages were undefined or empty", this.languages);
                    return false;
                }
                var lng = this.resolvedLanguage || this.languages[0];
                var fallbackLng = this.options ? this.options.fallbackLng : false;
                var lastLng = this.languages[this.languages.length - 1];
                if (lng.toLowerCase() === "cimode") return true;
                var loadNotPending = function loadNotPending(l, n) {
                    var loadState = _this6.services.backendConnector.state["".concat(l, "|").concat(n)];
                    return loadState === -1 || loadState === 2;
                };
                if (options.precheck) {
                    var preResult = options.precheck(this, loadNotPending);
                    if (preResult !== undefined) return preResult;
                }
                if (this.hasResourceBundle(lng, ns)) return true;
                if (!this.services.backendConnector.backend || this.options.resources && !this.options.partialBundledLanguages) return true;
                if (loadNotPending(lng, ns) && (!fallbackLng || loadNotPending(lastLng, ns))) return true;
                return false;
            }
        },
        {
            key: "loadNamespaces",
            value: function loadNamespaces(ns, callback) {
                var _this7 = this;
                var deferred = $673ff3dfc4a496de$var$defer();
                if (!this.options.ns) {
                    callback && callback();
                    return Promise.resolve();
                }
                if (typeof ns === "string") ns = [
                    ns
                ];
                ns.forEach(function(n) {
                    if (_this7.options.ns.indexOf(n) < 0) _this7.options.ns.push(n);
                });
                this.loadResources(function(err) {
                    deferred.resolve();
                    if (callback) callback(err);
                });
                return deferred;
            }
        },
        {
            key: "loadLanguages",
            value: function loadLanguages(lngs, callback) {
                var deferred = $673ff3dfc4a496de$var$defer();
                if (typeof lngs === "string") lngs = [
                    lngs
                ];
                var preloaded = this.options.preload || [];
                var newLngs = lngs.filter(function(lng) {
                    return preloaded.indexOf(lng) < 0;
                });
                if (!newLngs.length) {
                    if (callback) callback();
                    return Promise.resolve();
                }
                this.options.preload = preloaded.concat(newLngs);
                this.loadResources(function(err) {
                    deferred.resolve();
                    if (callback) callback(err);
                });
                return deferred;
            }
        },
        {
            key: "dir",
            value: function dir(lng) {
                if (!lng) lng = this.resolvedLanguage || (this.languages && this.languages.length > 0 ? this.languages[0] : this.language);
                if (!lng) return "rtl";
                var rtlLngs = [
                    "ar",
                    "shu",
                    "sqr",
                    "ssh",
                    "xaa",
                    "yhd",
                    "yud",
                    "aao",
                    "abh",
                    "abv",
                    "acm",
                    "acq",
                    "acw",
                    "acx",
                    "acy",
                    "adf",
                    "ads",
                    "aeb",
                    "aec",
                    "afb",
                    "ajp",
                    "apc",
                    "apd",
                    "arb",
                    "arq",
                    "ars",
                    "ary",
                    "arz",
                    "auz",
                    "avl",
                    "ayh",
                    "ayl",
                    "ayn",
                    "ayp",
                    "bbz",
                    "pga",
                    "he",
                    "iw",
                    "ps",
                    "pbt",
                    "pbu",
                    "pst",
                    "prp",
                    "prd",
                    "ug",
                    "ur",
                    "ydd",
                    "yds",
                    "yih",
                    "ji",
                    "yi",
                    "hbo",
                    "men",
                    "xmn",
                    "fa",
                    "jpr",
                    "peo",
                    "pes",
                    "prs",
                    "dv",
                    "sam",
                    "ckb"
                ];
                return rtlLngs.indexOf(this.services.languageUtils.getLanguagePartFromCode(lng)) > -1 || lng.toLowerCase().indexOf("-arab") > 1 ? "rtl" : "ltr";
            }
        },
        {
            key: "cloneInstance",
            value: function cloneInstance() {
                var _this8 = this;
                var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
                var callback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $673ff3dfc4a496de$var$noop;
                var mergedOptions = $673ff3dfc4a496de$var$_objectSpread$6($673ff3dfc4a496de$var$_objectSpread$6($673ff3dfc4a496de$var$_objectSpread$6({}, this.options), options), {
                    isClone: true
                });
                var clone = new I18n(mergedOptions);
                if (options.debug !== undefined || options.prefix !== undefined) clone.logger = clone.logger.clone(options);
                var membersToCopy = [
                    "store",
                    "services",
                    "language"
                ];
                membersToCopy.forEach(function(m) {
                    clone[m] = _this8[m];
                });
                clone.services = $673ff3dfc4a496de$var$_objectSpread$6({}, this.services);
                clone.services.utils = {
                    hasLoadedNamespace: clone.hasLoadedNamespace.bind(clone)
                };
                clone.translator = new $673ff3dfc4a496de$var$Translator(clone.services, clone.options);
                clone.translator.on("*", function(event) {
                    for(var _len4 = arguments.length, args = new Array(_len4 > 1 ? _len4 - 1 : 0), _key4 = 1; _key4 < _len4; _key4++)args[_key4 - 1] = arguments[_key4];
                    clone.emit.apply(clone, [
                        event
                    ].concat(args));
                });
                clone.init(mergedOptions, callback);
                clone.translator.options = clone.options;
                clone.translator.backendConnector.services.utils = {
                    hasLoadedNamespace: clone.hasLoadedNamespace.bind(clone)
                };
                return clone;
            }
        },
        {
            key: "toJSON",
            value: function toJSON() {
                return {
                    options: this.options,
                    store: this.store,
                    language: this.language,
                    languages: this.languages,
                    resolvedLanguage: this.resolvedLanguage
                };
            }
        }
    ]);
    return I18n;
}($673ff3dfc4a496de$var$EventEmitter);
(0, $f329557dcab6d0bb$export$2e2bcd8739ae039)($673ff3dfc4a496de$var$I18n, "createInstance", function() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var callback = arguments.length > 1 ? arguments[1] : undefined;
    return new $673ff3dfc4a496de$var$I18n(options, callback);
});
var $673ff3dfc4a496de$var$instance = $673ff3dfc4a496de$var$I18n.createInstance();
$673ff3dfc4a496de$var$instance.createInstance = $673ff3dfc4a496de$var$I18n.createInstance;
var $673ff3dfc4a496de$export$99152e8d49ca4e7d = $673ff3dfc4a496de$var$instance.createInstance;
var $673ff3dfc4a496de$export$2cd8252107eb640b = $673ff3dfc4a496de$var$instance.init;
var $673ff3dfc4a496de$export$d3d08d944062d7e = $673ff3dfc4a496de$var$instance.loadResources;
var $673ff3dfc4a496de$export$a5d9bf5d83fcab09 = $673ff3dfc4a496de$var$instance.reloadResources;
var $673ff3dfc4a496de$export$1f96ae73734a86cc = $673ff3dfc4a496de$var$instance.use;
var $673ff3dfc4a496de$export$61465194746e7fd2 = $673ff3dfc4a496de$var$instance.changeLanguage;
var $673ff3dfc4a496de$export$f90d180fc7da3b3b = $673ff3dfc4a496de$var$instance.getFixedT;
var $673ff3dfc4a496de$export$625550452a3fa3ec = $673ff3dfc4a496de$var$instance.t;
var $673ff3dfc4a496de$export$f7e9f41ea797a17 = $673ff3dfc4a496de$var$instance.exists;
var $673ff3dfc4a496de$export$2b4b218e406d2d00 = $673ff3dfc4a496de$var$instance.setDefaultNamespace;
var $673ff3dfc4a496de$export$93d9ee97c1ad3f31 = $673ff3dfc4a496de$var$instance.hasLoadedNamespace;
var $673ff3dfc4a496de$export$83be934b53fff43b = $673ff3dfc4a496de$var$instance.loadNamespaces;
var $673ff3dfc4a496de$export$8cd7e7a54fa865bc = $673ff3dfc4a496de$var$instance.loadLanguages;
var $673ff3dfc4a496de$export$2e2bcd8739ae039 = $673ff3dfc4a496de$var$instance;


var $b45a6abf916bff88$exports = {};
function $b45a6abf916bff88$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
$b45a6abf916bff88$exports = $b45a6abf916bff88$var$_classCallCheck, $b45a6abf916bff88$exports.__esModule = true, $b45a6abf916bff88$exports["default"] = $b45a6abf916bff88$exports;


var $fe9438347a673ba6$exports = {};
var $010f4e0e13c82e16$exports = {};
var $2ef66ab8c52ac1c0$exports = {};
function $2ef66ab8c52ac1c0$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $2ef66ab8c52ac1c0$exports = $2ef66ab8c52ac1c0$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $2ef66ab8c52ac1c0$exports.__esModule = true, $2ef66ab8c52ac1c0$exports["default"] = $2ef66ab8c52ac1c0$exports, $2ef66ab8c52ac1c0$var$_typeof(obj);
}
$2ef66ab8c52ac1c0$exports = $2ef66ab8c52ac1c0$var$_typeof, $2ef66ab8c52ac1c0$exports.__esModule = true, $2ef66ab8c52ac1c0$exports["default"] = $2ef66ab8c52ac1c0$exports;


var $010f4e0e13c82e16$var$_typeof = $2ef66ab8c52ac1c0$exports.default;
var $b77c8068776c2a21$exports = {};

var $b77c8068776c2a21$var$_typeof = $2ef66ab8c52ac1c0$exports.default;
function $b77c8068776c2a21$var$_toPrimitive(input, hint) {
    if ($b77c8068776c2a21$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($b77c8068776c2a21$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
$b77c8068776c2a21$exports = $b77c8068776c2a21$var$_toPrimitive, $b77c8068776c2a21$exports.__esModule = true, $b77c8068776c2a21$exports["default"] = $b77c8068776c2a21$exports;


function $010f4e0e13c82e16$var$_toPropertyKey(arg) {
    var key = $b77c8068776c2a21$exports(arg, "string");
    return $010f4e0e13c82e16$var$_typeof(key) === "symbol" ? key : String(key);
}
$010f4e0e13c82e16$exports = $010f4e0e13c82e16$var$_toPropertyKey, $010f4e0e13c82e16$exports.__esModule = true, $010f4e0e13c82e16$exports["default"] = $010f4e0e13c82e16$exports;


function $fe9438347a673ba6$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $010f4e0e13c82e16$exports(descriptor.key), descriptor);
    }
}
function $fe9438347a673ba6$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $fe9438347a673ba6$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $fe9438347a673ba6$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
$fe9438347a673ba6$exports = $fe9438347a673ba6$var$_createClass, $fe9438347a673ba6$exports.__esModule = true, $fe9438347a673ba6$exports["default"] = $fe9438347a673ba6$exports;


var $bb7ca61ce45563c4$exports = {};

function $bb7ca61ce45563c4$var$_defineProperty(obj, key, value) {
    key = $010f4e0e13c82e16$exports(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
$bb7ca61ce45563c4$exports = $bb7ca61ce45563c4$var$_defineProperty, $bb7ca61ce45563c4$exports.__esModule = true, $bb7ca61ce45563c4$exports["default"] = $bb7ca61ce45563c4$exports;



var $acw62 = parcelRequire("acw62");
var $d7f2d92b0368699f$var$matchHtmlEntity = /&(?:amp|#38|lt|#60|gt|#62|apos|#39|quot|#34|nbsp|#160|copy|#169|reg|#174|hellip|#8230|#x2F|#47);/g;
var $d7f2d92b0368699f$var$htmlEntities = {
    "&amp;": "&",
    "&#38;": "&",
    "&lt;": "<",
    "&#60;": "<",
    "&gt;": ">",
    "&#62;": ">",
    "&apos;": "'",
    "&#39;": "'",
    "&quot;": '"',
    "&#34;": '"',
    "&nbsp;": " ",
    "&#160;": " ",
    "&copy;": "\xa9",
    "&#169;": "\xa9",
    "&reg;": "\xae",
    "&#174;": "\xae",
    "&hellip;": "…",
    "&#8230;": "…",
    "&#x2F;": "/",
    "&#47;": "/"
};
var $d7f2d92b0368699f$var$unescapeHtmlEntity = function unescapeHtmlEntity(m) {
    return $d7f2d92b0368699f$var$htmlEntities[m];
};
var $d7f2d92b0368699f$export$e8bacd2802a88316 = function unescape(text) {
    return text.replace($d7f2d92b0368699f$var$matchHtmlEntity, $d7f2d92b0368699f$var$unescapeHtmlEntity);
};


function $0636c84fe4549f1f$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $0636c84fe4549f1f$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $0636c84fe4549f1f$var$ownKeys(Object(source), true).forEach(function(key) {
            (0, (/*@__PURE__*/$parcel$interopDefault($bb7ca61ce45563c4$exports)))(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $0636c84fe4549f1f$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
var $0636c84fe4549f1f$var$defaultOptions = {
    bindI18n: "languageChanged",
    bindI18nStore: "",
    transEmptyNodeValue: "",
    transSupportBasicHtmlNodes: true,
    transWrapTextNodes: "",
    transKeepBasicHtmlNodesFor: [
        "br",
        "strong",
        "i",
        "p"
    ],
    useSuspense: true,
    unescape: (0, $d7f2d92b0368699f$export$e8bacd2802a88316)
};
var $0636c84fe4549f1f$var$i18nInstance;
var $0636c84fe4549f1f$export$5603ab5ced17ce64 = (0, $acw62.createContext)();
function $0636c84fe4549f1f$export$2e2366488d12e20d() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    $0636c84fe4549f1f$var$defaultOptions = $0636c84fe4549f1f$var$_objectSpread($0636c84fe4549f1f$var$_objectSpread({}, $0636c84fe4549f1f$var$defaultOptions), options);
}
function $0636c84fe4549f1f$export$212bb2fc580a90a8() {
    return $0636c84fe4549f1f$var$defaultOptions;
}
var $0636c84fe4549f1f$export$ea171b67e3820290 = function() {
    function ReportNamespaces() {
        (0, (/*@__PURE__*/$parcel$interopDefault($b45a6abf916bff88$exports)))(this, ReportNamespaces);
        this.usedNamespaces = {};
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($fe9438347a673ba6$exports)))(ReportNamespaces, [
        {
            key: "addUsedNamespaces",
            value: function addUsedNamespaces(namespaces) {
                var _this = this;
                namespaces.forEach(function(ns) {
                    if (!_this.usedNamespaces[ns]) _this.usedNamespaces[ns] = true;
                });
            }
        },
        {
            key: "getUsedNamespaces",
            value: function getUsedNamespaces() {
                return Object.keys(this.usedNamespaces);
            }
        }
    ]);
    return ReportNamespaces;
}();
function $0636c84fe4549f1f$export$a039134f2fc7e0(instance) {
    $0636c84fe4549f1f$var$i18nInstance = instance;
}
function $0636c84fe4549f1f$export$64af334f494c2f47() {
    return $0636c84fe4549f1f$var$i18nInstance;
}
var $0636c84fe4549f1f$export$ae7e14d40d89f296 = {
    type: "3rdParty",
    init: function init(instance) {
        $0636c84fe4549f1f$export$2e2366488d12e20d(instance.options.react);
        $0636c84fe4549f1f$export$a039134f2fc7e0(instance);
    }
};
function $0636c84fe4549f1f$export$30ff0342ccf735a(ForComponent) {
    return function(ctx) {
        return new Promise(function(resolve) {
            var i18nInitialProps = $0636c84fe4549f1f$export$704200e5d0b9e8f();
            if (ForComponent.getInitialProps) ForComponent.getInitialProps(ctx).then(function(componentsInitialProps) {
                resolve($0636c84fe4549f1f$var$_objectSpread($0636c84fe4549f1f$var$_objectSpread({}, componentsInitialProps), i18nInitialProps));
            });
            else resolve(i18nInitialProps);
        });
    };
}
function $0636c84fe4549f1f$export$704200e5d0b9e8f() {
    var i18n = $0636c84fe4549f1f$export$64af334f494c2f47();
    var namespaces = i18n.reportNamespaces ? i18n.reportNamespaces.getUsedNamespaces() : [];
    var ret = {};
    var initialI18nStore = {};
    i18n.languages.forEach(function(l) {
        initialI18nStore[l] = {};
        namespaces.forEach(function(ns) {
            initialI18nStore[l][ns] = i18n.getResourceBundle(l, ns) || {};
        });
    });
    ret.initialI18nStore = initialI18nStore;
    ret.initialLanguage = i18n.language;
    return ret;
}




var $60196a4650e96cb1$var$arr = [];
var $60196a4650e96cb1$var$each = $60196a4650e96cb1$var$arr.forEach;
var $60196a4650e96cb1$var$slice = $60196a4650e96cb1$var$arr.slice;
function $60196a4650e96cb1$var$defaults(obj) {
    $60196a4650e96cb1$var$each.call($60196a4650e96cb1$var$slice.call(arguments, 1), function(source) {
        if (source) {
            for(var prop in source)if (obj[prop] === undefined) obj[prop] = source[prop];
        }
    });
    return obj;
}
// eslint-disable-next-line no-control-regex
var $60196a4650e96cb1$var$fieldContentRegExp = /^[\u0009\u0020-\u007e\u0080-\u00ff]+$/;
var $60196a4650e96cb1$var$serializeCookie = function serializeCookie(name, val, options) {
    var opt = options || {};
    opt.path = opt.path || "/";
    var value = encodeURIComponent(val);
    var str = "".concat(name, "=").concat(value);
    if (opt.maxAge > 0) {
        var maxAge = opt.maxAge - 0;
        if (Number.isNaN(maxAge)) throw new Error("maxAge should be a Number");
        str += "; Max-Age=".concat(Math.floor(maxAge));
    }
    if (opt.domain) {
        if (!$60196a4650e96cb1$var$fieldContentRegExp.test(opt.domain)) throw new TypeError("option domain is invalid");
        str += "; Domain=".concat(opt.domain);
    }
    if (opt.path) {
        if (!$60196a4650e96cb1$var$fieldContentRegExp.test(opt.path)) throw new TypeError("option path is invalid");
        str += "; Path=".concat(opt.path);
    }
    if (opt.expires) {
        if (typeof opt.expires.toUTCString !== "function") throw new TypeError("option expires is invalid");
        str += "; Expires=".concat(opt.expires.toUTCString());
    }
    if (opt.httpOnly) str += "; HttpOnly";
    if (opt.secure) str += "; Secure";
    if (opt.sameSite) {
        var sameSite = typeof opt.sameSite === "string" ? opt.sameSite.toLowerCase() : opt.sameSite;
        switch(sameSite){
            case true:
                str += "; SameSite=Strict";
                break;
            case "lax":
                str += "; SameSite=Lax";
                break;
            case "strict":
                str += "; SameSite=Strict";
                break;
            case "none":
                str += "; SameSite=None";
                break;
            default:
                throw new TypeError("option sameSite is invalid");
        }
    }
    return str;
};
var $60196a4650e96cb1$var$cookie = {
    create: function create(name, value, minutes, domain) {
        var cookieOptions = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {
            path: "/",
            sameSite: "strict"
        };
        if (minutes) {
            cookieOptions.expires = new Date();
            cookieOptions.expires.setTime(cookieOptions.expires.getTime() + minutes * 60000);
        }
        if (domain) cookieOptions.domain = domain;
        document.cookie = $60196a4650e96cb1$var$serializeCookie(name, encodeURIComponent(value), cookieOptions);
    },
    read: function read(name) {
        var nameEQ = "".concat(name, "=");
        var ca = document.cookie.split(";");
        for(var i = 0; i < ca.length; i++){
            var c = ca[i];
            while(c.charAt(0) === " ")c = c.substring(1, c.length);
            if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
        }
        return null;
    },
    remove: function remove(name) {
        this.create(name, "", -1);
    }
};
var $60196a4650e96cb1$var$cookie$1 = {
    name: "cookie",
    lookup: function lookup(options) {
        var found;
        if (options.lookupCookie && typeof document !== "undefined") {
            var c = $60196a4650e96cb1$var$cookie.read(options.lookupCookie);
            if (c) found = c;
        }
        return found;
    },
    cacheUserLanguage: function cacheUserLanguage(lng, options) {
        if (options.lookupCookie && typeof document !== "undefined") $60196a4650e96cb1$var$cookie.create(options.lookupCookie, lng, options.cookieMinutes, options.cookieDomain, options.cookieOptions);
    }
};
var $60196a4650e96cb1$var$querystring = {
    name: "querystring",
    lookup: function lookup(options) {
        var found;
        if (typeof window !== "undefined") {
            var search = window.location.search;
            if (!window.location.search && window.location.hash && window.location.hash.indexOf("?") > -1) search = window.location.hash.substring(window.location.hash.indexOf("?"));
            var query = search.substring(1);
            var params = query.split("&");
            for(var i = 0; i < params.length; i++){
                var pos = params[i].indexOf("=");
                if (pos > 0) {
                    var key = params[i].substring(0, pos);
                    if (key === options.lookupQuerystring) found = params[i].substring(pos + 1);
                }
            }
        }
        return found;
    }
};
var $60196a4650e96cb1$var$hasLocalStorageSupport = null;
var $60196a4650e96cb1$var$localStorageAvailable = function localStorageAvailable() {
    if ($60196a4650e96cb1$var$hasLocalStorageSupport !== null) return $60196a4650e96cb1$var$hasLocalStorageSupport;
    try {
        $60196a4650e96cb1$var$hasLocalStorageSupport = window !== "undefined" && window.localStorage !== null;
        var testKey = "i18next.translate.boo";
        window.localStorage.setItem(testKey, "foo");
        window.localStorage.removeItem(testKey);
    } catch (e) {
        $60196a4650e96cb1$var$hasLocalStorageSupport = false;
    }
    return $60196a4650e96cb1$var$hasLocalStorageSupport;
};
var $60196a4650e96cb1$var$localStorage = {
    name: "localStorage",
    lookup: function lookup(options) {
        var found;
        if (options.lookupLocalStorage && $60196a4650e96cb1$var$localStorageAvailable()) {
            var lng = window.localStorage.getItem(options.lookupLocalStorage);
            if (lng) found = lng;
        }
        return found;
    },
    cacheUserLanguage: function cacheUserLanguage(lng, options) {
        if (options.lookupLocalStorage && $60196a4650e96cb1$var$localStorageAvailable()) window.localStorage.setItem(options.lookupLocalStorage, lng);
    }
};
var $60196a4650e96cb1$var$hasSessionStorageSupport = null;
var $60196a4650e96cb1$var$sessionStorageAvailable = function sessionStorageAvailable() {
    if ($60196a4650e96cb1$var$hasSessionStorageSupport !== null) return $60196a4650e96cb1$var$hasSessionStorageSupport;
    try {
        $60196a4650e96cb1$var$hasSessionStorageSupport = window !== "undefined" && window.sessionStorage !== null;
        var testKey = "i18next.translate.boo";
        window.sessionStorage.setItem(testKey, "foo");
        window.sessionStorage.removeItem(testKey);
    } catch (e) {
        $60196a4650e96cb1$var$hasSessionStorageSupport = false;
    }
    return $60196a4650e96cb1$var$hasSessionStorageSupport;
};
var $60196a4650e96cb1$var$sessionStorage = {
    name: "sessionStorage",
    lookup: function lookup(options) {
        var found;
        if (options.lookupSessionStorage && $60196a4650e96cb1$var$sessionStorageAvailable()) {
            var lng = window.sessionStorage.getItem(options.lookupSessionStorage);
            if (lng) found = lng;
        }
        return found;
    },
    cacheUserLanguage: function cacheUserLanguage(lng, options) {
        if (options.lookupSessionStorage && $60196a4650e96cb1$var$sessionStorageAvailable()) window.sessionStorage.setItem(options.lookupSessionStorage, lng);
    }
};
var $60196a4650e96cb1$var$navigator$1 = {
    name: "navigator",
    lookup: function lookup(options) {
        var found = [];
        if (typeof navigator !== "undefined") {
            if (navigator.languages) // chrome only; not an array, so can't use .push.apply instead of iterating
            for(var i = 0; i < navigator.languages.length; i++)found.push(navigator.languages[i]);
            if (navigator.userLanguage) found.push(navigator.userLanguage);
            if (navigator.language) found.push(navigator.language);
        }
        return found.length > 0 ? found : undefined;
    }
};
var $60196a4650e96cb1$var$htmlTag = {
    name: "htmlTag",
    lookup: function lookup(options) {
        var found;
        var htmlTag = options.htmlTag || (typeof document !== "undefined" ? document.documentElement : null);
        if (htmlTag && typeof htmlTag.getAttribute === "function") found = htmlTag.getAttribute("lang");
        return found;
    }
};
var $60196a4650e96cb1$var$path = {
    name: "path",
    lookup: function lookup(options) {
        var found;
        if (typeof window !== "undefined") {
            var language = window.location.pathname.match(/\/([a-zA-Z-]*)/g);
            if (language instanceof Array) {
                if (typeof options.lookupFromPathIndex === "number") {
                    if (typeof language[options.lookupFromPathIndex] !== "string") return undefined;
                    found = language[options.lookupFromPathIndex].replace("/", "");
                } else found = language[0].replace("/", "");
            }
        }
        return found;
    }
};
var $60196a4650e96cb1$var$subdomain = {
    name: "subdomain",
    lookup: function lookup(options) {
        // If given get the subdomain index else 1
        var lookupFromSubdomainIndex = typeof options.lookupFromSubdomainIndex === "number" ? options.lookupFromSubdomainIndex + 1 : 1; // get all matches if window.location. is existing
        // first item of match is the match itself and the second is the first group macht which sould be the first subdomain match
        // is the hostname no public domain get the or option of localhost
        var language = typeof window !== "undefined" && window.location && window.location.hostname && window.location.hostname.match(/^(\w{2,5})\.(([a-z0-9-]{1,63}\.[a-z]{2,6})|localhost)/i); // if there is no match (null) return undefined
        if (!language) return undefined; // return the given group match
        return language[lookupFromSubdomainIndex];
    }
};
function $60196a4650e96cb1$var$getDefaults() {
    return {
        order: [
            "querystring",
            "cookie",
            "localStorage",
            "sessionStorage",
            "navigator",
            "htmlTag"
        ],
        lookupQuerystring: "lng",
        lookupCookie: "i18next",
        lookupLocalStorage: "i18nextLng",
        lookupSessionStorage: "i18nextLng",
        // cache user language
        caches: [
            "localStorage"
        ],
        excludeCacheFor: [
            "cimode"
        ] // cookieMinutes: 10,
    };
}
var $60196a4650e96cb1$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function Browser(services) {
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        (0, $4d35ca0862055760$export$2e2bcd8739ae039)(this, Browser);
        this.type = "languageDetector";
        this.detectors = {};
        this.init(services, options);
    }
    (0, $94019358ecbcf36b$export$2e2bcd8739ae039)(Browser, [
        {
            key: "init",
            value: function init(services) {
                var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                var i18nOptions = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                this.services = services;
                this.options = $60196a4650e96cb1$var$defaults(options, this.options || {}, $60196a4650e96cb1$var$getDefaults()); // backwards compatibility
                if (this.options.lookupFromUrlIndex) this.options.lookupFromPathIndex = this.options.lookupFromUrlIndex;
                this.i18nOptions = i18nOptions;
                this.addDetector($60196a4650e96cb1$var$cookie$1);
                this.addDetector($60196a4650e96cb1$var$querystring);
                this.addDetector($60196a4650e96cb1$var$localStorage);
                this.addDetector($60196a4650e96cb1$var$sessionStorage);
                this.addDetector($60196a4650e96cb1$var$navigator$1);
                this.addDetector($60196a4650e96cb1$var$htmlTag);
                this.addDetector($60196a4650e96cb1$var$path);
                this.addDetector($60196a4650e96cb1$var$subdomain);
            }
        },
        {
            key: "addDetector",
            value: function addDetector(detector) {
                this.detectors[detector.name] = detector;
            }
        },
        {
            key: "detect",
            value: function detect(detectionOrder) {
                var _this = this;
                if (!detectionOrder) detectionOrder = this.options.order;
                var detected = [];
                detectionOrder.forEach(function(detectorName) {
                    if (_this.detectors[detectorName]) {
                        var lookup = _this.detectors[detectorName].lookup(_this.options);
                        if (lookup && typeof lookup === "string") lookup = [
                            lookup
                        ];
                        if (lookup) detected = detected.concat(lookup);
                    }
                });
                if (this.services.languageUtils.getBestMatchFromCodes) return detected; // new i18next v19.5.0
                return detected.length > 0 ? detected[0] : null; // a little backward compatibility
            }
        },
        {
            key: "cacheUserLanguage",
            value: function cacheUserLanguage(lng, caches) {
                var _this2 = this;
                if (!caches) caches = this.options.caches;
                if (!caches) return;
                if (this.options.excludeCacheFor && this.options.excludeCacheFor.indexOf(lng) > -1) return;
                caches.forEach(function(cacheName) {
                    if (_this2.detectors[cacheName]) _this2.detectors[cacheName].cacheUserLanguage(lng, _this2.options);
                });
            }
        }
    ]);
    return Browser;
}();
$60196a4650e96cb1$export$2e2bcd8739ae039.type = "languageDetector";


function $f6e8edbd6de2d1a8$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $f6e8edbd6de2d1a8$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $f6e8edbd6de2d1a8$var$_typeof(obj);
}
var $f6e8edbd6de2d1a8$var$arr = [];
var $f6e8edbd6de2d1a8$var$each = $f6e8edbd6de2d1a8$var$arr.forEach;
var $f6e8edbd6de2d1a8$var$slice = $f6e8edbd6de2d1a8$var$arr.slice;
function $f6e8edbd6de2d1a8$export$ebe90cb607ad99e(obj) {
    $f6e8edbd6de2d1a8$var$each.call($f6e8edbd6de2d1a8$var$slice.call(arguments, 1), function(source) {
        if (source) {
            for(var prop in source)if (obj[prop] === undefined) obj[prop] = source[prop];
        }
    });
    return obj;
}
function $f6e8edbd6de2d1a8$export$87022daa49baf612() {
    return typeof XMLHttpRequest === "function" || (typeof XMLHttpRequest === "undefined" ? "undefined" : $f6e8edbd6de2d1a8$var$_typeof(XMLHttpRequest)) === "object";
}
function $f6e8edbd6de2d1a8$var$isPromise(maybePromise) {
    return !!maybePromise && typeof maybePromise.then === "function";
}
function $f6e8edbd6de2d1a8$export$1625492ec82002b9(maybePromise) {
    if ($f6e8edbd6de2d1a8$var$isPromise(maybePromise)) return maybePromise;
    return Promise.resolve(maybePromise);
}



var $24c3677c8ec8d51d$exports = {};
var $24c3677c8ec8d51d$var$fetchApi;
if (typeof fetch === "function") {
    if (typeof $parcel$global !== "undefined" && $parcel$global.fetch) $24c3677c8ec8d51d$var$fetchApi = $parcel$global.fetch;
    else if (typeof window !== "undefined" && window.fetch) $24c3677c8ec8d51d$var$fetchApi = window.fetch;
    else $24c3677c8ec8d51d$var$fetchApi = fetch;
}

if (typeof window === "undefined" || typeof window.document === "undefined") {
    var $24c3677c8ec8d51d$var$f = $24c3677c8ec8d51d$var$fetchApi || (parcelRequire("R5nvG"));
    if ($24c3677c8ec8d51d$var$f.default) $24c3677c8ec8d51d$var$f = $24c3677c8ec8d51d$var$f.default;
    $24c3677c8ec8d51d$exports.default = $24c3677c8ec8d51d$var$f;
    $24c3677c8ec8d51d$exports = $24c3677c8ec8d51d$exports.default;
}


function $cad892b69e25befc$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $cad892b69e25befc$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $cad892b69e25befc$var$_typeof(obj);
}
var $cad892b69e25befc$var$fetchApi;
if (typeof fetch === "function") {
    if (typeof $parcel$global !== "undefined" && $parcel$global.fetch) $cad892b69e25befc$var$fetchApi = $parcel$global.fetch;
    else if (typeof window !== "undefined" && window.fetch) $cad892b69e25befc$var$fetchApi = window.fetch;
    else $cad892b69e25befc$var$fetchApi = fetch;
}
var $cad892b69e25befc$var$XmlHttpRequestApi;
if ((0, $f6e8edbd6de2d1a8$export$87022daa49baf612)()) {
    if (typeof $parcel$global !== "undefined" && $parcel$global.XMLHttpRequest) $cad892b69e25befc$var$XmlHttpRequestApi = $parcel$global.XMLHttpRequest;
    else if (typeof window !== "undefined" && window.XMLHttpRequest) $cad892b69e25befc$var$XmlHttpRequestApi = window.XMLHttpRequest;
}
var $cad892b69e25befc$var$ActiveXObjectApi;
if (typeof ActiveXObject === "function") {
    if (typeof $parcel$global !== "undefined" && $parcel$global.ActiveXObject) $cad892b69e25befc$var$ActiveXObjectApi = $parcel$global.ActiveXObject;
    else if (typeof window !== "undefined" && window.ActiveXObject) $cad892b69e25befc$var$ActiveXObjectApi = window.ActiveXObject;
}
if (!$cad892b69e25befc$var$fetchApi && $24c3677c8ec8d51d$exports && !$cad892b69e25befc$var$XmlHttpRequestApi && !$cad892b69e25befc$var$ActiveXObjectApi) $cad892b69e25befc$var$fetchApi = $24c3677c8ec8d51d$exports.default || $24c3677c8ec8d51d$exports;
if (typeof $cad892b69e25befc$var$fetchApi !== "function") $cad892b69e25befc$var$fetchApi = undefined;
var $cad892b69e25befc$var$addQueryString = function addQueryString(url, params) {
    if (params && $cad892b69e25befc$var$_typeof(params) === "object") {
        var queryString = "";
        for(var paramName in params)queryString += "&" + encodeURIComponent(paramName) + "=" + encodeURIComponent(params[paramName]);
        if (!queryString) return url;
        url = url + (url.indexOf("?") !== -1 ? "&" : "?") + queryString.slice(1);
    }
    return url;
};
var $cad892b69e25befc$var$fetchIt = function fetchIt(url, fetchOptions, callback) {
    $cad892b69e25befc$var$fetchApi(url, fetchOptions).then(function(response) {
        if (!response.ok) return callback(response.statusText || "Error", {
            status: response.status
        });
        response.text().then(function(data) {
            callback(null, {
                status: response.status,
                data: data
            });
        }).catch(callback);
    }).catch(callback);
};
var $cad892b69e25befc$var$omitFetchOptions = false;
var $cad892b69e25befc$var$requestWithFetch = function requestWithFetch(options, url, payload, callback) {
    if (options.queryStringParams) url = $cad892b69e25befc$var$addQueryString(url, options.queryStringParams);
    var headers = (0, $f6e8edbd6de2d1a8$export$ebe90cb607ad99e)({}, typeof options.customHeaders === "function" ? options.customHeaders() : options.customHeaders);
    if (payload) headers["Content-Type"] = "application/json";
    var reqOptions = typeof options.requestOptions === "function" ? options.requestOptions(payload) : options.requestOptions;
    var fetchOptions = (0, $f6e8edbd6de2d1a8$export$ebe90cb607ad99e)({
        method: payload ? "POST" : "GET",
        body: payload ? options.stringify(payload) : undefined,
        headers: headers
    }, $cad892b69e25befc$var$omitFetchOptions ? {} : reqOptions);
    try {
        $cad892b69e25befc$var$fetchIt(url, fetchOptions, callback);
    } catch (e) {
        if (!reqOptions || Object.keys(reqOptions).length === 0 || !e.message || e.message.indexOf("not implemented") < 0) return callback(e);
        try {
            Object.keys(reqOptions).forEach(function(opt) {
                delete fetchOptions[opt];
            });
            $cad892b69e25befc$var$fetchIt(url, fetchOptions, callback);
            $cad892b69e25befc$var$omitFetchOptions = true;
        } catch (err) {
            callback(err);
        }
    }
};
var $cad892b69e25befc$var$requestWithXmlHttpRequest = function requestWithXmlHttpRequest(options, url, payload, callback) {
    if (payload && $cad892b69e25befc$var$_typeof(payload) === "object") payload = $cad892b69e25befc$var$addQueryString("", payload).slice(1);
    if (options.queryStringParams) url = $cad892b69e25befc$var$addQueryString(url, options.queryStringParams);
    try {
        var x;
        if ($cad892b69e25befc$var$XmlHttpRequestApi) x = new $cad892b69e25befc$var$XmlHttpRequestApi();
        else x = new $cad892b69e25befc$var$ActiveXObjectApi("MSXML2.XMLHTTP.3.0");
        x.open(payload ? "POST" : "GET", url, 1);
        if (!options.crossDomain) x.setRequestHeader("X-Requested-With", "XMLHttpRequest");
        x.withCredentials = !!options.withCredentials;
        if (payload) x.setRequestHeader("Content-Type", "application/x-www-form-urlencoded");
        if (x.overrideMimeType) x.overrideMimeType("application/json");
        var h = options.customHeaders;
        h = typeof h === "function" ? h() : h;
        if (h) for(var i in h)x.setRequestHeader(i, h[i]);
        x.onreadystatechange = function() {
            x.readyState > 3 && callback(x.status >= 400 ? x.statusText : null, {
                status: x.status,
                data: x.responseText
            });
        };
        x.send(payload);
    } catch (e) {
        console && console.log(e);
    }
};
var $cad892b69e25befc$var$request = function request(options, url, payload, callback) {
    if (typeof payload === "function") {
        callback = payload;
        payload = undefined;
    }
    callback = callback || function() {};
    if ($cad892b69e25befc$var$fetchApi) return $cad892b69e25befc$var$requestWithFetch(options, url, payload, callback);
    if ((0, $f6e8edbd6de2d1a8$export$87022daa49baf612)() || typeof ActiveXObject === "function") return $cad892b69e25befc$var$requestWithXmlHttpRequest(options, url, payload, callback);
    callback(new Error("No fetch and no xhr implementation found!"));
};
var $cad892b69e25befc$export$2e2bcd8739ae039 = $cad892b69e25befc$var$request;


function $3faa45b77b2a48ba$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $3faa45b77b2a48ba$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $3faa45b77b2a48ba$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $3faa45b77b2a48ba$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $3faa45b77b2a48ba$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $3faa45b77b2a48ba$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
var $3faa45b77b2a48ba$var$getDefaults = function getDefaults() {
    return {
        loadPath: "/locales/{{lng}}/{{ns}}.json",
        addPath: "/locales/add/{{lng}}/{{ns}}",
        allowMultiLoading: false,
        parse: function parse(data) {
            return JSON.parse(data);
        },
        stringify: JSON.stringify,
        parsePayload: function parsePayload(namespace, key, fallbackValue) {
            return $3faa45b77b2a48ba$var$_defineProperty({}, key, fallbackValue || "");
        },
        request: (0, $cad892b69e25befc$export$2e2bcd8739ae039),
        reloadInterval: typeof window !== "undefined" ? false : 3600000,
        customHeaders: {},
        queryStringParams: {},
        crossDomain: false,
        withCredentials: false,
        overrideMimeType: false,
        requestOptions: {
            mode: "cors",
            credentials: "same-origin",
            cache: "default"
        }
    };
};
var $3faa45b77b2a48ba$var$Backend = function() {
    function Backend(services) {
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var allOptions = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        $3faa45b77b2a48ba$var$_classCallCheck(this, Backend);
        this.services = services;
        this.options = options;
        this.allOptions = allOptions;
        this.type = "backend";
        this.init(services, options, allOptions);
    }
    $3faa45b77b2a48ba$var$_createClass(Backend, [
        {
            key: "init",
            value: function init(services) {
                var _this = this;
                var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                var allOptions = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                this.services = services;
                this.options = (0, $f6e8edbd6de2d1a8$export$ebe90cb607ad99e)(options, this.options || {}, $3faa45b77b2a48ba$var$getDefaults());
                this.allOptions = allOptions;
                if (this.services && this.options.reloadInterval) setInterval(function() {
                    return _this.reload();
                }, this.options.reloadInterval);
            }
        },
        {
            key: "readMulti",
            value: function readMulti(languages, namespaces, callback) {
                this._readAny(languages, languages, namespaces, namespaces, callback);
            }
        },
        {
            key: "read",
            value: function read(language, namespace, callback) {
                this._readAny([
                    language
                ], language, [
                    namespace
                ], namespace, callback);
            }
        },
        {
            key: "_readAny",
            value: function _readAny(languages, loadUrlLanguages, namespaces, loadUrlNamespaces, callback) {
                var _this2 = this;
                var loadPath = this.options.loadPath;
                if (typeof this.options.loadPath === "function") loadPath = this.options.loadPath(languages, namespaces);
                loadPath = (0, $f6e8edbd6de2d1a8$export$1625492ec82002b9)(loadPath);
                loadPath.then(function(resolvedLoadPath) {
                    if (!resolvedLoadPath) return callback(null, {});
                    var url = _this2.services.interpolator.interpolate(resolvedLoadPath, {
                        lng: languages.join("+"),
                        ns: namespaces.join("+")
                    });
                    _this2.loadUrl(url, callback, loadUrlLanguages, loadUrlNamespaces);
                });
            }
        },
        {
            key: "loadUrl",
            value: function loadUrl(url, callback, languages, namespaces) {
                var _this3 = this;
                this.options.request(this.options, url, undefined, function(err, res) {
                    if (res && (res.status >= 500 && res.status < 600 || !res.status)) return callback("failed loading " + url + "; status code: " + res.status, true);
                    if (res && res.status >= 400 && res.status < 500) return callback("failed loading " + url + "; status code: " + res.status, false);
                    if (!res && err && err.message && err.message.indexOf("Failed to fetch") > -1) return callback("failed loading " + url + ": " + err.message, true);
                    if (err) return callback(err, false);
                    var ret, parseErr;
                    try {
                        if (typeof res.data === "string") ret = _this3.options.parse(res.data, languages, namespaces);
                        else ret = res.data;
                    } catch (e) {
                        parseErr = "failed parsing " + url + " to json";
                    }
                    if (parseErr) return callback(parseErr, false);
                    callback(null, ret);
                });
            }
        },
        {
            key: "create",
            value: function create(languages, namespace, key, fallbackValue, callback) {
                var _this4 = this;
                if (!this.options.addPath) return;
                if (typeof languages === "string") languages = [
                    languages
                ];
                var payload = this.options.parsePayload(namespace, key, fallbackValue);
                var finished = 0;
                var dataArray = [];
                var resArray = [];
                languages.forEach(function(lng) {
                    var addPath = _this4.options.addPath;
                    if (typeof _this4.options.addPath === "function") addPath = _this4.options.addPath(lng, namespace);
                    var url = _this4.services.interpolator.interpolate(addPath, {
                        lng: lng,
                        ns: namespace
                    });
                    _this4.options.request(_this4.options, url, payload, function(data, res) {
                        finished += 1;
                        dataArray.push(data);
                        resArray.push(res);
                        if (finished === languages.length) {
                            if (callback) callback(dataArray, resArray);
                        }
                    });
                });
            }
        },
        {
            key: "reload",
            value: function reload() {
                var _this5 = this;
                var _this$services = this.services, backendConnector = _this$services.backendConnector, languageUtils = _this$services.languageUtils, logger = _this$services.logger;
                var currentLanguage = backendConnector.language;
                if (currentLanguage && currentLanguage.toLowerCase() === "cimode") return;
                var toLoad = [];
                var append = function append(lng) {
                    var lngs = languageUtils.toResolveHierarchy(lng);
                    lngs.forEach(function(l) {
                        if (toLoad.indexOf(l) < 0) toLoad.push(l);
                    });
                };
                append(currentLanguage);
                if (this.allOptions.preload) this.allOptions.preload.forEach(function(l) {
                    return append(l);
                });
                toLoad.forEach(function(lng) {
                    _this5.allOptions.ns.forEach(function(ns) {
                        backendConnector.read(lng, ns, "read", null, null, function(err, data) {
                            if (err) logger.warn("loading namespace ".concat(ns, " for language ").concat(lng, " failed"), err);
                            if (!err && data) logger.log("loaded namespace ".concat(ns, " for language ").concat(lng), data);
                            backendConnector.loaded("".concat(lng, "|").concat(ns), err, data);
                        });
                    });
                });
            }
        }
    ]);
    return Backend;
}();
$3faa45b77b2a48ba$var$Backend.type = "backend";
var $3faa45b77b2a48ba$export$2e2bcd8739ae039 = $3faa45b77b2a48ba$var$Backend;


const $01f9c2ffd7693c68$var$i18nextOptions = {
    backend: {
        loadPath: "../i18n/{{lng}}/{{ns}}.json"
    },
    debug: false,
    interpolation: {
        escapeValue: false
    }
};
const $01f9c2ffd7693c68$export$2d3542df2a1993a = (0, $673ff3dfc4a496de$export$2e2bcd8739ae039).use((0, $3faa45b77b2a48ba$export$2e2bcd8739ae039)).use((0, $60196a4650e96cb1$export$2e2bcd8739ae039)).use((0, $0636c84fe4549f1f$export$ae7e14d40d89f296)).init($01f9c2ffd7693c68$var$i18nextOptions);
var $01f9c2ffd7693c68$export$2e2bcd8739ae039 = (0, $673ff3dfc4a496de$export$2e2bcd8739ae039);


const $faa2ca7f56fbc6f0$export$4128a78c9389121b = {
    Okta: "Okta",
    Auth0: "Auth0",
    Other: "Other"
};



var $c0c5a1734783046e$exports = {};
/*! For license information please see okta-auth-js.umd.js.LICENSE.txt */ var $63dbe9146d5df2e6$exports = {};
// shim for using process in browser
var $63dbe9146d5df2e6$var$process = $63dbe9146d5df2e6$exports = {};
// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.
var $63dbe9146d5df2e6$var$cachedSetTimeout;
var $63dbe9146d5df2e6$var$cachedClearTimeout;
function $63dbe9146d5df2e6$var$defaultSetTimout() {
    throw new Error("setTimeout has not been defined");
}
function $63dbe9146d5df2e6$var$defaultClearTimeout() {
    throw new Error("clearTimeout has not been defined");
}
(function() {
    try {
        if (typeof setTimeout === "function") $63dbe9146d5df2e6$var$cachedSetTimeout = setTimeout;
        else $63dbe9146d5df2e6$var$cachedSetTimeout = $63dbe9146d5df2e6$var$defaultSetTimout;
    } catch (e) {
        $63dbe9146d5df2e6$var$cachedSetTimeout = $63dbe9146d5df2e6$var$defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === "function") $63dbe9146d5df2e6$var$cachedClearTimeout = clearTimeout;
        else $63dbe9146d5df2e6$var$cachedClearTimeout = $63dbe9146d5df2e6$var$defaultClearTimeout;
    } catch (e) {
        $63dbe9146d5df2e6$var$cachedClearTimeout = $63dbe9146d5df2e6$var$defaultClearTimeout;
    }
})();
function $63dbe9146d5df2e6$var$runTimeout(fun) {
    if ($63dbe9146d5df2e6$var$cachedSetTimeout === setTimeout) //normal enviroments in sane situations
    return setTimeout(fun, 0);
    // if setTimeout wasn't available but was latter defined
    if (($63dbe9146d5df2e6$var$cachedSetTimeout === $63dbe9146d5df2e6$var$defaultSetTimout || !$63dbe9146d5df2e6$var$cachedSetTimeout) && setTimeout) {
        $63dbe9146d5df2e6$var$cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $63dbe9146d5df2e6$var$cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return $63dbe9146d5df2e6$var$cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return $63dbe9146d5df2e6$var$cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function $63dbe9146d5df2e6$var$runClearTimeout(marker) {
    if ($63dbe9146d5df2e6$var$cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
    return clearTimeout(marker);
    // if clearTimeout wasn't available but was latter defined
    if (($63dbe9146d5df2e6$var$cachedClearTimeout === $63dbe9146d5df2e6$var$defaultClearTimeout || !$63dbe9146d5df2e6$var$cachedClearTimeout) && clearTimeout) {
        $63dbe9146d5df2e6$var$cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $63dbe9146d5df2e6$var$cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return $63dbe9146d5df2e6$var$cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return $63dbe9146d5df2e6$var$cachedClearTimeout.call(this, marker);
        }
    }
}
var $63dbe9146d5df2e6$var$queue = [];
var $63dbe9146d5df2e6$var$draining = false;
var $63dbe9146d5df2e6$var$currentQueue;
var $63dbe9146d5df2e6$var$queueIndex = -1;
function $63dbe9146d5df2e6$var$cleanUpNextTick() {
    if (!$63dbe9146d5df2e6$var$draining || !$63dbe9146d5df2e6$var$currentQueue) return;
    $63dbe9146d5df2e6$var$draining = false;
    if ($63dbe9146d5df2e6$var$currentQueue.length) $63dbe9146d5df2e6$var$queue = $63dbe9146d5df2e6$var$currentQueue.concat($63dbe9146d5df2e6$var$queue);
    else $63dbe9146d5df2e6$var$queueIndex = -1;
    if ($63dbe9146d5df2e6$var$queue.length) $63dbe9146d5df2e6$var$drainQueue();
}
function $63dbe9146d5df2e6$var$drainQueue() {
    if ($63dbe9146d5df2e6$var$draining) return;
    var timeout = $63dbe9146d5df2e6$var$runTimeout($63dbe9146d5df2e6$var$cleanUpNextTick);
    $63dbe9146d5df2e6$var$draining = true;
    var len = $63dbe9146d5df2e6$var$queue.length;
    while(len){
        $63dbe9146d5df2e6$var$currentQueue = $63dbe9146d5df2e6$var$queue;
        $63dbe9146d5df2e6$var$queue = [];
        while(++$63dbe9146d5df2e6$var$queueIndex < len)if ($63dbe9146d5df2e6$var$currentQueue) $63dbe9146d5df2e6$var$currentQueue[$63dbe9146d5df2e6$var$queueIndex].run();
        $63dbe9146d5df2e6$var$queueIndex = -1;
        len = $63dbe9146d5df2e6$var$queue.length;
    }
    $63dbe9146d5df2e6$var$currentQueue = null;
    $63dbe9146d5df2e6$var$draining = false;
    $63dbe9146d5df2e6$var$runClearTimeout(timeout);
}
$63dbe9146d5df2e6$var$process.nextTick = function(fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    $63dbe9146d5df2e6$var$queue.push(new $63dbe9146d5df2e6$var$Item(fun, args));
    if ($63dbe9146d5df2e6$var$queue.length === 1 && !$63dbe9146d5df2e6$var$draining) $63dbe9146d5df2e6$var$runTimeout($63dbe9146d5df2e6$var$drainQueue);
};
// v8 likes predictible objects
function $63dbe9146d5df2e6$var$Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
$63dbe9146d5df2e6$var$Item.prototype.run = function() {
    this.fun.apply(null, this.array);
};
$63dbe9146d5df2e6$var$process.title = "browser";
$63dbe9146d5df2e6$var$process.browser = true;
$63dbe9146d5df2e6$var$process.env = {};
$63dbe9146d5df2e6$var$process.argv = [];
$63dbe9146d5df2e6$var$process.version = ""; // empty string to avoid regexp issues
$63dbe9146d5df2e6$var$process.versions = {};
function $63dbe9146d5df2e6$var$noop() {}
$63dbe9146d5df2e6$var$process.on = $63dbe9146d5df2e6$var$noop;
$63dbe9146d5df2e6$var$process.addListener = $63dbe9146d5df2e6$var$noop;
$63dbe9146d5df2e6$var$process.once = $63dbe9146d5df2e6$var$noop;
$63dbe9146d5df2e6$var$process.off = $63dbe9146d5df2e6$var$noop;
$63dbe9146d5df2e6$var$process.removeListener = $63dbe9146d5df2e6$var$noop;
$63dbe9146d5df2e6$var$process.removeAllListeners = $63dbe9146d5df2e6$var$noop;
$63dbe9146d5df2e6$var$process.emit = $63dbe9146d5df2e6$var$noop;
$63dbe9146d5df2e6$var$process.prependListener = $63dbe9146d5df2e6$var$noop;
$63dbe9146d5df2e6$var$process.prependOnceListener = $63dbe9146d5df2e6$var$noop;
$63dbe9146d5df2e6$var$process.listeners = function(name) {
    return [];
};
$63dbe9146d5df2e6$var$process.binding = function(name) {
    throw new Error("process.binding is not supported");
};
$63dbe9146d5df2e6$var$process.cwd = function() {
    return "/";
};
$63dbe9146d5df2e6$var$process.chdir = function(dir) {
    throw new Error("process.chdir is not supported");
};
$63dbe9146d5df2e6$var$process.umask = function() {
    return 0;
};


!function(e, t) {
    $c0c5a1734783046e$exports = t();
}(self, function() {
    return function() {
        var e = {
            6419: function(e, t, n) {
                e.exports = n(7698);
            },
            1511: function(e, t, n) {
                e.exports = n(3363);
            },
            7766: function(e, t, n) {
                e.exports = n(8065);
            },
            116: function(e, t, n) {
                e.exports = n(1955);
            },
            4473: function(e, t, n) {
                e.exports = n(1577);
            },
            8914: function(e, t, n) {
                e.exports = n(6279);
            },
            1643: function(e, t, n) {
                e.exports = n(9373);
            },
            2991: function(e, t, n) {
                e.exports = n(1798);
            },
            3649: function(e, t, n) {
                e.exports = n(2073);
            },
            9340: function(e, t, n) {
                e.exports = n(8933);
            },
            368: function(e, t, n) {
                e.exports = n(7396);
            },
            3978: function(e, t, n) {
                e.exports = n(1910);
            },
            6295: function(e, t, n) {
                e.exports = n(6209);
            },
            1306: function(e, t, n) {
                e.exports = n(3402);
            },
            4074: function(e, t, n) {
                e.exports = n(9427);
            },
            9649: function(e, t, n) {
                e.exports = n(2857);
            },
            4310: function(e, t, n) {
                e.exports = n(9534);
            },
            6902: function(e, t, n) {
                e.exports = n(3059);
            },
            3476: function(e, t, n) {
                e.exports = n(7460);
            },
            5420: function(e, t, n) {
                e.exports = n(2547);
            },
            9969: function(e, t, n) {
                e.exports = n(7641);
            },
            3592: function(e, t, n) {
                e.exports = n(7385);
            },
            8363: function(e, t, n) {
                e.exports = n(1522);
            },
            9996: function(e, t, n) {
                e.exports = n(2209);
            },
            6976: function(e, t, n) {
                e.exports = n(1258);
            },
            5683: function(e, t, n) {
                e.exports = n(9447);
            },
            5238: function(e, t, n) {
                e.exports = n(1493);
            },
            4341: function(e, t, n) {
                e.exports = n(3685);
            },
            3263: function(e, t, n) {
                e.exports = n(4710);
            },
            9356: function(e, t, n) {
                e.exports = n(3799);
            },
            9798: function(e, t, n) {
                e.exports = n(9531);
            },
            1446: function(e, t, n) {
                e.exports = n(6600);
            },
            3882: function(e, t, n) {
                e.exports = n(9759);
            },
            4243: function(e) {
                e.exports = function(e, t) {
                    (null == t || t > e.length) && (t = e.length);
                    for(var n = 0, r = new Array(t); n < t; n++)r[n] = e[n];
                    return r;
                }, e.exports.default = e.exports, e.exports.__esModule = !0;
            },
            7726: function(e, t, n) {
                var r = n(8363);
                e.exports = function(e) {
                    if (r(e)) return e;
                }, e.exports.default = e.exports, e.exports.__esModule = !0;
            },
            6868: function(e, t, n) {
                var r = n(8363), o = n(4243);
                e.exports = function(e) {
                    if (r(e)) return o(e);
                }, e.exports.default = e.exports, e.exports.__esModule = !0;
            },
            1161: function(e, t, n) {
                var r = n(9798);
                function o(e, t, n, o, i, a, u) {
                    try {
                        var s = e[a](u), c = s.value;
                    } catch (e) {
                        return void n(e);
                    }
                    s.done ? t(c) : r.resolve(c).then(o, i);
                }
                e.exports = function(e) {
                    return function() {
                        var t = this, n = arguments;
                        return new r(function(r, i) {
                            var a = e.apply(t, n);
                            function u(e) {
                                o(a, r, i, u, s, "next", e);
                            }
                            function s(e) {
                                o(a, r, i, u, s, "throw", e);
                            }
                            u(void 0);
                        });
                    };
                }, e.exports.default = e.exports, e.exports.__esModule = !0;
            },
            7672: function(e, t, n) {
                var r = n(4341);
                e.exports = function(e, t, n) {
                    return t in e ? r(e, t, {
                        value: n,
                        enumerable: !0,
                        configurable: !0,
                        writable: !0
                    }) : e[t] = n, e;
                }, e.exports.default = e.exports, e.exports.__esModule = !0;
            },
            530: function(e) {
                e.exports = function(e) {
                    return e && e.__esModule ? e : {
                        default: e
                    };
                }, e.exports.default = e.exports, e.exports.__esModule = !0;
            },
            5400: function(e, t, n) {
                var r = n(1446), o = n(9996), i = n(3592);
                e.exports = function(e) {
                    if (void 0 !== r && null != o(e) || null != e["@@iterator"]) return i(e);
                }, e.exports.default = e.exports, e.exports.__esModule = !0;
            },
            5056: function(e, t, n) {
                var r = n(1446), o = n(9996);
                e.exports = function(e, t) {
                    var n = null == e ? null : void 0 !== r && o(e) || e["@@iterator"];
                    if (null != n) {
                        var i, a, u = [], s = !0, c = !1;
                        try {
                            for(n = n.call(e); !(s = (i = n.next()).done) && (u.push(i.value), !t || u.length !== t); s = !0);
                        } catch (e) {
                            c = !0, a = e;
                        } finally{
                            try {
                                s || null == n.return || n.return();
                            } finally{
                                if (c) throw a;
                            }
                        }
                        return u;
                    }
                }, e.exports.default = e.exports, e.exports.__esModule = !0;
            },
            9736: function(e) {
                e.exports = function() {
                    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
                }, e.exports.default = e.exports, e.exports.__esModule = !0;
            },
            6670: function(e) {
                e.exports = function() {
                    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
                }, e.exports.default = e.exports, e.exports.__esModule = !0;
            },
            122: function(e, t, n) {
                var r = n(3263), o = n(5683), i = n(4590);
                e.exports = function(e, t) {
                    if (null == e) return {};
                    var n, a, u = i(e, t);
                    if (r) {
                        var s = r(e);
                        for(a = 0; a < s.length; a++)n = s[a], o(t).call(t, n) >= 0 || Object.prototype.propertyIsEnumerable.call(e, n) && (u[n] = e[n]);
                    }
                    return u;
                }, e.exports.default = e.exports, e.exports.__esModule = !0;
            },
            4590: function(e, t, n) {
                var r = n(9356), o = n(5683);
                e.exports = function(e, t) {
                    if (null == e) return {};
                    var n, i, a = {}, u = r(e);
                    for(i = 0; i < u.length; i++)n = u[i], o(t).call(t, n) >= 0 || (a[n] = e[n]);
                    return a;
                }, e.exports.default = e.exports, e.exports.__esModule = !0;
            },
            8777: function(e, t, n) {
                var r = n(7726), o = n(5056), i = n(9299), a = n(9736);
                e.exports = function(e, t) {
                    return r(e) || o(e, t) || i(e, t) || a();
                }, e.exports.default = e.exports, e.exports.__esModule = !0;
            },
            9036: function(e, t, n) {
                var r = n(6868), o = n(5400), i = n(9299), a = n(6670);
                e.exports = function(e) {
                    return r(e) || o(e) || i(e) || a();
                }, e.exports.default = e.exports, e.exports.__esModule = !0;
            },
            3765: function(e, t, n) {
                var r = n(1446), o = n(3882);
                function i(t) {
                    return "function" == typeof r && "symbol" == typeof o ? (e.exports = i = function(e) {
                        return typeof e;
                    }, e.exports.default = e.exports, e.exports.__esModule = !0) : (e.exports = i = function(e) {
                        return e && "function" == typeof r && e.constructor === r && e !== r.prototype ? "symbol" : typeof e;
                    }, e.exports.default = e.exports, e.exports.__esModule = !0), i(t);
                }
                e.exports = i, e.exports.default = e.exports, e.exports.__esModule = !0;
            },
            9299: function(e, t, n) {
                var r = n(5238), o = n(3592), i = n(4243);
                e.exports = function(e, t) {
                    var n;
                    if (e) {
                        if ("string" == typeof e) return i(e, t);
                        var a = r(n = Object.prototype.toString.call(e)).call(n, 8, -1);
                        return "Object" === a && e.constructor && (a = e.constructor.name), "Map" === a || "Set" === a ? o(e) : "Arguments" === a || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(a) ? i(e, t) : void 0;
                    }
                }, e.exports.default = e.exports, e.exports.__esModule = !0;
            },
            3109: function(e, t, n) {
                e.exports = n(5666);
            },
            1506: function(e) {
                e.exports = function(e) {
                    if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                    return e;
                }, e.exports.default = e.exports, e.exports.__esModule = !0;
            },
            4575: function(e) {
                e.exports = function(e, t) {
                    if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
                }, e.exports.default = e.exports, e.exports.__esModule = !0;
            },
            9100: function(e, t, n) {
                var r = n(9489), o = n(7067);
                function i(t, n, a) {
                    return o() ? (e.exports = i = Reflect.construct, e.exports.default = e.exports, e.exports.__esModule = !0) : (e.exports = i = function(e, t, n) {
                        var o = [
                            null
                        ];
                        o.push.apply(o, t);
                        var i = new (Function.bind.apply(e, o));
                        return n && r(i, n.prototype), i;
                    }, e.exports.default = e.exports, e.exports.__esModule = !0), i.apply(null, arguments);
                }
                e.exports = i, e.exports.default = e.exports, e.exports.__esModule = !0;
            },
            3913: function(e) {
                function t(e, t) {
                    for(var n = 0; n < t.length; n++){
                        var r = t[n];
                        r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
                    }
                }
                e.exports = function(e, n, r) {
                    return n && t(e.prototype, n), r && t(e, r), e;
                }, e.exports.default = e.exports, e.exports.__esModule = !0;
            },
            9754: function(e) {
                function t(n) {
                    return e.exports = t = Object.setPrototypeOf ? Object.getPrototypeOf : function(e) {
                        return e.__proto__ || Object.getPrototypeOf(e);
                    }, e.exports.default = e.exports, e.exports.__esModule = !0, t(n);
                }
                e.exports = t, e.exports.default = e.exports, e.exports.__esModule = !0;
            },
            2205: function(e, t, n) {
                var r = n(9489);
                e.exports = function(e, t) {
                    if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
                    e.prototype = Object.create(t && t.prototype, {
                        constructor: {
                            value: e,
                            writable: !0,
                            configurable: !0
                        }
                    }), t && r(e, t);
                }, e.exports.default = e.exports, e.exports.__esModule = !0;
            },
            430: function(e) {
                e.exports = function(e) {
                    return -1 !== Function.toString.call(e).indexOf("[native code]");
                }, e.exports.default = e.exports, e.exports.__esModule = !0;
            },
            7067: function(e) {
                e.exports = function() {
                    if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                    if (Reflect.construct.sham) return !1;
                    if ("function" == typeof Proxy) return !0;
                    try {
                        return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
                    } catch (e) {
                        return !1;
                    }
                }, e.exports.default = e.exports, e.exports.__esModule = !0;
            },
            8585: function(e, t, n) {
                var r = n(8).default, o = n(1506);
                e.exports = function(e, t) {
                    return !t || "object" !== r(t) && "function" != typeof t ? o(e) : t;
                }, e.exports.default = e.exports, e.exports.__esModule = !0;
            },
            9489: function(e) {
                function t(n, r) {
                    return e.exports = t = Object.setPrototypeOf || function(e, t) {
                        return e.__proto__ = t, e;
                    }, e.exports.default = e.exports, e.exports.__esModule = !0, t(n, r);
                }
                e.exports = t, e.exports.default = e.exports, e.exports.__esModule = !0;
            },
            8: function(e) {
                function t(n) {
                    return "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? (e.exports = t = function(e) {
                        return typeof e;
                    }, e.exports.default = e.exports, e.exports.__esModule = !0) : (e.exports = t = function(e) {
                        return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
                    }, e.exports.default = e.exports, e.exports.__esModule = !0), t(n);
                }
                e.exports = t, e.exports.default = e.exports, e.exports.__esModule = !0;
            },
            5957: function(e, t, n) {
                var r = n(9754), o = n(9489), i = n(430), a = n(9100);
                function u(t) {
                    var n = "function" == typeof Map ? new Map : void 0;
                    return e.exports = u = function(e) {
                        if (null === e || !i(e)) return e;
                        if ("function" != typeof e) throw new TypeError("Super expression must either be null or a function");
                        if (void 0 !== n) {
                            if (n.has(e)) return n.get(e);
                            n.set(e, t);
                        }
                        function t() {
                            return a(e, arguments, r(this).constructor);
                        }
                        return t.prototype = Object.create(e.prototype, {
                            constructor: {
                                value: t,
                                enumerable: !1,
                                writable: !0,
                                configurable: !0
                            }
                        }), o(t, e);
                    }, e.exports.default = e.exports, e.exports.__esModule = !0, u(t);
                }
                e.exports = u, e.exports.default = e.exports, e.exports.__esModule = !0;
            },
            7757: function(e, t, n) {
                e.exports = n(5666);
            },
            7320: function(e, t, n) {
                "use strict";
                var r = n(3978), o = n(530);
                r(t, "__esModule", {
                    value: !0
                }), t.default = void 0;
                var i = o(n(3109));
                n(9600);
                var a = o(n(8777)), u = o(n(1161)), s = o(n(3476)), c = o(n(2991)), f = o(n(6295)), l = o(n(7766)), p = n(1032), h = function(e) {
                    return e.json().then(function(e) {
                        return s.default.reject(e);
                    });
                }, d = function() {
                    var e = (0, u.default)(i.default.mark(function e(t) {
                        var n, r, o, u, s, d, v, g, y, m, b, k, w, x;
                        return i.default.wrap(function(e) {
                            for(;;)switch(e.prev = e.next){
                                case 0:
                                    return r = t.clientId, o = t.baseUrl, u = t.scopes, s = void 0 === u ? [
                                        "openid",
                                        "email"
                                    ] : u, d = t.redirectUri, v = t.codeChallenge, g = t.codeChallengeMethod, y = t.state, m = t.activationToken, b = "".concat(o, "/v1/interact"), k = {
                                        client_id: r,
                                        scope: s.join(" "),
                                        redirect_uri: d,
                                        code_challenge: v,
                                        code_challenge_method: g,
                                        state: y
                                    }, m && (k.activation_token = m), w = (0, c.default)(n = (0, f.default)(k)).call(n, function(e) {
                                        var t, n = (0, a.default)(e, 2), r = n[0], o = n[1];
                                        return (0, l.default)(t = "".concat(r, "=")).call(t, encodeURIComponent(o));
                                    }).join("&"), x = {
                                        "content-type": "application/x-www-form-urlencoded"
                                    }, e.abrupt("return", (0, p.request)(b, {
                                        headers: x,
                                        body: w
                                    }).then(function(e) {
                                        return e.ok ? e.json() : h(e);
                                    }).then(function(e) {
                                        return e.interaction_handle;
                                    }));
                                case 7:
                                case "end":
                                    return e.stop();
                            }
                        }, e);
                    }));
                    return function(t) {
                        return e.apply(this, arguments);
                    };
                }(), v = d;
                t.default = v;
            },
            1032: function(e, t, n) {
                "use strict";
                var r = n(6902), o = n(4310), i = n(116), a = n(4074), u = n(8914), s = n(9649), c = n(368), f = n(3978), l = n(530);
                f(t, "__esModule", {
                    value: !0
                }), t.request = t.HttpClient = void 0;
                var p = l(n(3109)), h = l(n(8914)), d = l(n(7672)), v = l(n(1161)), g = l(n(4098)), y = n(8082);
                function m(e, t) {
                    var n = r(e);
                    if (o) {
                        var u = o(e);
                        t && (u = i(u).call(u, function(t) {
                            return a(e, t).enumerable;
                        })), n.push.apply(n, u);
                    }
                    return n;
                }
                function b(e) {
                    for(var t = 1; t < arguments.length; t++){
                        var n, r = null != arguments[t] ? arguments[t] : {};
                        if (t % 2) u(n = m(Object(r), !0)).call(n, function(t) {
                            (0, d.default)(e, t, r[t]);
                        });
                        else if (s) c(e, s(r));
                        else {
                            var o;
                            u(o = m(Object(r))).call(o, function(t) {
                                f(e, t, a(r, t));
                            });
                        }
                    }
                    return e;
                }
                var k = {
                    interceptors: {
                        request: new function() {
                            this.handlers = [], this.use = function(e) {
                                this.handlers.push({
                                    before: e
                                });
                            }, this.clear = function() {
                                this.handlers = [];
                            };
                        }
                    }
                };
                t.HttpClient = k;
                var w = function() {
                    var e = (0, v.default)(p.default.mark(function e(t, n) {
                        var r, o, i, a, u, s, c, f, l, d;
                        return p.default.wrap(function(e) {
                            for(;;)switch(e.prev = e.next){
                                case 0:
                                    return r = n.method, o = void 0 === r ? "POST" : r, i = n.headers, a = void 0 === i ? {} : i, u = n.credentials, s = void 0 === u ? "include" : u, c = n.body, f = {
                                        url: t,
                                        method: o,
                                        headers: b(b({}, (0, y.userAgentHeaders)()), a),
                                        credentials: s,
                                        body: c
                                    }, k.interceptors && (0, h.default)(l = k.interceptors.request.handlers).call(l, function(e) {
                                        e.before(f);
                                    }), d = f.url, delete f.url, e.abrupt("return", (0, g.default)(d, f));
                                case 6:
                                case "end":
                                    return e.stop();
                            }
                        }, e);
                    }));
                    return function(t, n) {
                        return e.apply(this, arguments);
                    };
                }();
                t.request = w;
            },
            6760: function(e, t, n) {
                "use strict";
                var r = n(3978), o = n(530);
                r(t, "__esModule", {
                    value: !0
                }), t.default = void 0;
                var i = o(n(3109)), a = o(n(1643)), u = o(n(3476)), s = o(n(9969));
                n(5306), n(4916);
                var c = o(n(1161)), f = o(n(5284)), l = o(n(7320)), p = o(n(3584)), h = n(1032), d = "1.0.0", v = function() {
                    var e = (0, c.default)(i.default.mark(function e(t) {
                        var n, r, o, c, h, d, v, g, y, m, b, k, w, x, S, T, O, A, E, _, R, P, j;
                        return i.default.wrap(function(e) {
                            for(;;)switch(e.prev = e.next){
                                case 0:
                                    if (o = t.clientId, c = t.domain, h = t.issuer, d = t.stateHandle, v = t.interactionHandle, g = t.version, y = t.redirectUri, m = t.state, b = t.scopes, k = t.codeChallenge, w = t.codeChallengeMethod, x = t.stateTokenExternalId, S = t.activationToken, h = null === (n = h) || void 0 === n ? void 0 : n.replace(/\/+$/, ""), T = (null === (r = h) || void 0 === r ? void 0 : (0, a.default)(r).call(r, "/oauth2")) > 0 ? h : h + "/oauth2", O = {
                                        baseUrl: T,
                                        clientId: o,
                                        state: m
                                    }, c || h) {
                                        e.next = 6;
                                        break;
                                    }
                                    return e.abrupt("return", u.default.reject({
                                        error: "issuer is required"
                                    }));
                                case 6:
                                    if (d || o) {
                                        e.next = 8;
                                        break;
                                    }
                                    return e.abrupt("return", u.default.reject({
                                        error: "clientId is required"
                                    }));
                                case 8:
                                    if (d || y) {
                                        e.next = 10;
                                        break;
                                    }
                                    return e.abrupt("return", u.default.reject({
                                        error: "redirectUri is required"
                                    }));
                                case 10:
                                    if (d || k && w) {
                                        e.next = 12;
                                        break;
                                    }
                                    return e.abrupt("return", u.default.reject({
                                        error: "PKCE params (codeChallenge, codeChallengeMethod) are required"
                                    }));
                                case 12:
                                    if (c || (c = new s.default(h).origin), g) {
                                        e.next = 15;
                                        break;
                                    }
                                    return e.abrupt("return", u.default.reject({
                                        error: "version is required"
                                    }));
                                case 15:
                                    if ((null != g ? g : "").replace(/[^0-9a-zA-Z._-]/, "") === g && g) {
                                        e.next = 18;
                                        break;
                                    }
                                    return e.abrupt("return", u.default.reject({
                                        error: "invalid version supplied - version is required and uses semver syntax"
                                    }));
                                case 18:
                                    if (d || v) {
                                        e.next = 31;
                                        break;
                                    }
                                    return e.prev = 19, A = {
                                        clientId: o,
                                        baseUrl: T,
                                        scopes: b,
                                        redirectUri: y,
                                        codeChallenge: k,
                                        codeChallengeMethod: w,
                                        state: m,
                                        activationToken: S
                                    }, e.next = 23, (0, l.default)(A);
                                case 23:
                                    E = e.sent, v = E, O.interactionHandle = v, e.next = 31;
                                    break;
                                case 28:
                                    return e.prev = 28, e.t0 = e.catch(19), e.abrupt("return", u.default.reject({
                                        error: e.t0
                                    }));
                                case 31:
                                    return e.prev = 31, _ = (0, p.default)(g), R = _.makeIdxState, e.next = 35, (0, f.default)({
                                        domain: c,
                                        interactionHandle: v,
                                        stateHandle: d,
                                        version: g,
                                        stateTokenExternalId: x
                                    }).catch(function(e) {
                                        return u.default.reject({
                                            error: "introspect call failed",
                                            details: R(e, O)
                                        });
                                    });
                                case 35:
                                    return P = e.sent, j = R(P, O), e.abrupt("return", j);
                                case 40:
                                    return e.prev = 40, e.t1 = e.catch(31), e.abrupt("return", u.default.reject({
                                        error: e.t1
                                    }));
                                case 43:
                                case "end":
                                    return e.stop();
                            }
                        }, e, null, [
                            [
                                19,
                                28
                            ],
                            [
                                31,
                                40
                            ]
                        ]);
                    }));
                    return function(t) {
                        return e.apply(this, arguments);
                    };
                }(), g = (0, p.default)(d).makeIdxState, y = {
                    start: v,
                    introspect: f.default,
                    interact: l.default,
                    makeIdxState: g,
                    client: h.HttpClient,
                    LATEST_SUPPORTED_IDX_API_VERSION: d
                };
                t.default = y;
            },
            5284: function(e, t, n) {
                "use strict";
                var r = n(3978), o = n(530);
                r(t, "__esModule", {
                    value: !0
                }), t.default = void 0;
                var i = o(n(3109)), a = o(n(1161)), u = o(n(3476)), s = o(n(9340)), c = n(1032), f = function(e) {
                    return e.json().then(function(e) {
                        return u.default.reject(e);
                    });
                }, l = function() {
                    var e = (0, a.default)(i.default.mark(function e(t) {
                        var n, r, o, a, u, l, p, h;
                        return i.default.wrap(function(e) {
                            for(;;)switch(e.prev = e.next){
                                case 0:
                                    return n = t.domain, r = t.interactionHandle, o = t.stateHandle, a = t.version, u = t.stateTokenExternalId, l = "".concat(n, "/idp/idx/introspect"), p = o ? {
                                        stateToken: o
                                    } : {
                                        interactionHandle: r
                                    }, u && (p.stateTokenExternalId = u), h = {
                                        "content-type": "application/ion+json; okta-version=".concat(a),
                                        accept: "application/ion+json; okta-version=".concat(a)
                                    }, e.abrupt("return", (0, c.request)(l, {
                                        headers: h,
                                        body: (0, s.default)(p)
                                    }).then(function(e) {
                                        return e.ok ? e.json() : f(e);
                                    }));
                                case 6:
                                case "end":
                                    return e.stop();
                            }
                        }, e);
                    }));
                    return function(t) {
                        return e.apply(this, arguments);
                    };
                }(), p = l;
                t.default = p;
            },
            3584: function(e, t, n) {
                "use strict";
                var r = n(3978), o = n(530);
                r(t, "__esModule", {
                    value: !0
                }), t.default = void 0;
                var i = o(n(2080));
                t.default = function(e) {
                    switch(e){
                        case "1.0.0":
                            return i.default;
                        case void 0:
                        case null:
                            throw new Error("Api version is required");
                        default:
                            throw new Error("Unknown api version: ".concat(e, ".  Use an exact semver version."));
                    }
                };
            },
            8082: function(e, t, n) {
                "use strict";
                n(3978)(t, "__esModule", {
                    value: !0
                }), t.userAgentHeaders = t.getUserAgent = void 0;
                var r = function() {
                    return "okta-idx-js/".concat("0.23.0");
                };
                t.getUserAgent = r, t.userAgentHeaders = function() {
                    return {
                        "X-Okta-User-Agent-Extended": r()
                    };
                };
            },
            35: function(e, t, n) {
                "use strict";
                n(1539);
                var r = n(3649), o = n(6419), i = n(5420), a = n(9996), u = n(1511), s = n(6976), c = n(3978), f = n(530);
                c(t, "__esModule", {
                    value: !0
                }), t.divideActionParamsByMutability = void 0;
                var l = f(n(1511));
                function p(e, t) {
                    var n;
                    if (void 0 === i || null == a(e)) {
                        if (u(e) || (n = function(e, t) {
                            var n;
                            if (e) {
                                if ("string" == typeof e) return h(e, t);
                                var i = r(n = Object.prototype.toString.call(e)).call(n, 8, -1);
                                return "Object" === i && e.constructor && (i = e.constructor.name), "Map" === i || "Set" === i ? o(e) : "Arguments" === i || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(i) ? h(e, t) : void 0;
                            }
                        }(e)) || t && e && "number" == typeof e.length) {
                            n && (e = n);
                            var c = 0, f = function() {};
                            return {
                                s: f,
                                n: function() {
                                    return c >= e.length ? {
                                        done: !0
                                    } : {
                                        done: !1,
                                        value: e[c++]
                                    };
                                },
                                e: function(e) {
                                    throw e;
                                },
                                f: f
                            };
                        }
                        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
                    }
                    var l, p = !0, d = !1;
                    return {
                        s: function() {
                            n = s(e);
                        },
                        n: function() {
                            var e = n.next();
                            return p = e.done, e;
                        },
                        e: function(e) {
                            d = !0, l = e;
                        },
                        f: function() {
                            try {
                                p || null == n.return || n.return();
                            } finally{
                                if (d) throw l;
                            }
                        }
                    };
                }
                function h(e, t) {
                    (null == t || t > e.length) && (t = e.length);
                    for(var n = 0, r = new Array(t); n < t; n++)r[n] = e[n];
                    return r;
                }
                n(8309);
                var d = function(e) {
                    return !1 !== e.mutable;
                }, v = function(e) {
                    var t = {}, n = [], r = {};
                    if (!e.value) return n.push(e), {
                        defaultParamsForAction: t,
                        neededParamsForAction: n,
                        immutableParamsForAction: r
                    };
                    var o, i = p(e.value);
                    try {
                        for(i.s(); !(o = i.n()).done;){
                            var a, u, s = o.value;
                            d(s) ? (n.push(s), null !== (a = s.value) && void 0 !== a && a && (t[s.name] = s.value)) : r[s.name] = null !== (u = s.value) && void 0 !== u ? u : "";
                        }
                    } catch (e) {
                        i.e(e);
                    } finally{
                        i.f();
                    }
                    return {
                        defaultParamsForAction: t,
                        neededParamsForAction: n,
                        immutableParamsForAction: r
                    };
                };
                t.divideActionParamsByMutability = function(e) {
                    var t, n = [], r = {}, o = {}, i = p(e = (0, l.default)(e) ? e : [
                        e
                    ]);
                    try {
                        for(i.s(); !(t = i.n()).done;){
                            var a = t.value, u = v(a), s = u.defaultParamsForAction, c = u.neededParamsForAction, f = u.immutableParamsForAction;
                            n.push(c), r[a.name] = s, o[a.name] = f;
                        }
                    } catch (e) {
                        i.e(e);
                    } finally{
                        i.f();
                    }
                    return {
                        defaultParams: r,
                        neededParams: n,
                        immutableParams: o
                    };
                };
            },
            7700: function(e, t, n) {
                "use strict";
                var r = n(6902), o = n(4310), i = n(116), a = n(4074), u = n(8914), s = n(9649), c = n(368), f = n(3978), l = n(530);
                f(t, "__esModule", {
                    value: !0
                }), t.default = void 0, n(8309);
                var p = l(n(3109)), h = l(n(9340)), d = l(n(3476)), v = l(n(7672)), g = l(n(1161)), y = n(1032), m = n(35), b = l(n(4807));
                function k(e, t) {
                    var n = r(e);
                    if (o) {
                        var u = o(e);
                        t && (u = i(u).call(u, function(t) {
                            return a(e, t).enumerable;
                        })), n.push.apply(n, u);
                    }
                    return n;
                }
                function w(e) {
                    for(var t = 1; t < arguments.length; t++){
                        var n, r = null != arguments[t] ? arguments[t] : {};
                        if (t % 2) u(n = k(Object(r), !0)).call(n, function(t) {
                            (0, v.default)(e, t, r[t]);
                        });
                        else if (s) c(e, s(r));
                        else {
                            var o;
                            u(o = k(Object(r))).call(o, function(t) {
                                f(e, t, a(r, t));
                            });
                        }
                    }
                    return e;
                }
                var x = function(e) {
                    var t = e.actionDefinition, n = e.defaultParamsForAction, r = void 0 === n ? {} : n, o = e.immutableParamsForAction, i = void 0 === o ? {} : o, a = e.toPersist, u = t.href;
                    return function() {
                        var e = (0, g.default)(p.default.mark(function e(n) {
                            var o, s;
                            return p.default.wrap(function(e) {
                                for(;;)switch(e.prev = e.next){
                                    case 0:
                                        return o = {
                                            "content-type": "application/json",
                                            accept: t.accepts || "application/ion+json"
                                        }, s = (0, h.default)(w(w(w({}, r), n), i)), e.abrupt("return", (0, y.request)(u, {
                                            method: t.method,
                                            headers: o,
                                            body: s
                                        }).then(function(e) {
                                            var t = e.json();
                                            return e.ok ? t : 401 === e.status && 'Oktadevicejwt realm="Okta Device"' === e.headers.get("WWW-Authenticate") ? t.then(function(e) {
                                                var t = (0, b.default)(e, a);
                                                return t.stepUp = !0, d.default.reject(t);
                                            }) : t.then(function(e) {
                                                return d.default.reject((0, b.default)(e, a));
                                            });
                                        }).then(function(e) {
                                            return (0, b.default)(e, a);
                                        }));
                                    case 3:
                                    case "end":
                                        return e.stop();
                                }
                            }, e);
                        }));
                        return function(t) {
                            return e.apply(this, arguments);
                        };
                    }();
                };
                t.default = function(e, t) {
                    var n = x, r = (0, m.divideActionParamsByMutability)(e), o = r.defaultParams, i = r.neededParams, a = r.immutableParams, u = n({
                        actionDefinition: e,
                        defaultParamsForAction: o[e.name],
                        immutableParamsForAction: a[e.name],
                        toPersist: t
                    });
                    return u.neededParams = i, u;
                };
            },
            8440: function(e, t, n) {
                "use strict";
                var r = n(6902), o = n(4310), i = n(116), a = n(4074), u = n(8914), s = n(9649), c = n(368), f = n(3978), l = n(530);
                f(t, "__esModule", {
                    value: !0
                }), t.parseIdxResponse = t.parseNonRemediations = void 0, n(8309);
                var p, h = l(n(8777)), d = l(n(7672)), v = l(n(122)), g = l(n(3765)), y = l(n(1306)), m = l(n(2991)), b = l(n(8914)), k = l(n(116)), w = l(n(6902)), x = l(n(6295)), S = l(n(7766)), T = l(n(1511)), O = n(7689), A = l(n(7700)), E = n(5653);
                function _(e, t) {
                    var n = r(e);
                    if (o) {
                        var u = o(e);
                        t && (u = i(u).call(u, function(t) {
                            return a(e, t).enumerable;
                        })), n.push.apply(n, u);
                    }
                    return n;
                }
                function R(e) {
                    for(var t = 1; t < arguments.length; t++){
                        var n, r = null != arguments[t] ? arguments[t] : {};
                        if (t % 2) u(n = _(Object(r), !0)).call(n, function(t) {
                            (0, d.default)(e, t, r[t]);
                        });
                        else if (s) c(e, s(r));
                        else {
                            var o;
                            u(o = _(Object(r))).call(o, function(t) {
                                f(e, t, a(r, t));
                            });
                        }
                    }
                    return e;
                }
                var P = (0, y.default)((0, m.default)(p = [
                    "remediation",
                    "context"
                ]).call(p, function(e) {
                    return [
                        e,
                        !0
                    ];
                })), j = function(e) {
                    var t, n, r = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {}, o = {}, i = {};
                    return (0, b.default)(t = (0, k.default)(n = (0, w.default)(e)).call(n, function(e) {
                        return !P[e];
                    })).call(t, function(t) {
                        var n;
                        if ("object" === (0, g.default)(e[t]) && e[t]) {
                            if (e[t].rel) o[e[t].name] = (0, A.default)(e[t], r);
                            else {
                                var a = e[t], u = a.value, s = a.type, c = (0, v.default)(a, [
                                    "value",
                                    "type"
                                ]);
                                i[t] = R({
                                    type: s
                                }, c), "object" === s ? (i[t].value = {}, (0, b.default)(n = (0, x.default)(u)).call(n, function(e) {
                                    var n, a = (0, h.default)(e, 2), u = a[0], s = a[1];
                                    s.rel ? o[(0, S.default)(n = "".concat(t, "-")).call(n, u.name || u)] = (0, A.default)(s, r) : i[t].value[u] = s;
                                })) : i[t].value = u;
                            }
                        } else i[t] = e[t];
                    }), {
                        context: i,
                        actions: o
                    };
                };
                t.parseNonRemediations = j;
                var I = function e(t, n) {
                    var r;
                    (0, b.default)(r = (0, w.default)(n)).call(r, function(r) {
                        if ("relatesTo" === r) {
                            var o = (0, T.default)(n[r]) ? n[r][0] : n[r];
                            if ("string" == typeof o) {
                                var i = (0, E.JSONPath)({
                                    path: o,
                                    json: t
                                })[0];
                                if (i) return void (n[r] = i);
                            }
                        }
                        var a;
                        (0, T.default)(n[r]) && (0, b.default)(a = n[r]).call(a, function(n) {
                            return e(t, n);
                        });
                    });
                }, C = function(e, t) {
                    var n = (0, O.generateRemediationFunctions)([
                        e
                    ], t)[e.name];
                    return R(R({}, e), {}, {
                        action: n
                    });
                };
                t.parseIdxResponse = function(e) {
                    var t, n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {}, r = (null === (t = e.remediation) || void 0 === t ? void 0 : t.value) || [];
                    (0, b.default)(r).call(r, function(t) {
                        return I(e, t);
                    });
                    var o = (0, m.default)(r).call(r, function(e) {
                        return C(e, n);
                    }), i = j(e, n), a = i.context, u = i.actions;
                    return {
                        remediations: o,
                        context: a,
                        actions: u
                    };
                };
            },
            4807: function(e, t, n) {
                "use strict";
                var r = n(3978), o = n(530);
                r(t, "__esModule", {
                    value: !0
                }), t.default = void 0;
                var i = o(n(3109));
                n(8309);
                var a = o(n(4473)), u = o(n(3476)), s = o(n(1161)), c = o(n(9036)), f = n(8440);
                t.default = function(e, t) {
                    var n, r, o = e, l = (0, f.parseIdxResponse)(e, t), p = l.remediations, h = l.context, d = l.actions, v = (0, c.default)(p), g = function() {
                        var e = (0, s.default)(i.default.mark(function e(t) {
                            var n, r, o = arguments;
                            return i.default.wrap(function(e) {
                                for(;;)switch(e.prev = e.next){
                                    case 0:
                                        if (n = o.length > 1 && void 0 !== o[1] ? o[1] : {}, r = (0, a.default)(p).call(p, function(e) {
                                            return e.name === t;
                                        })) {
                                            e.next = 4;
                                            break;
                                        }
                                        return e.abrupt("return", u.default.reject("Unknown remediation choice: [".concat(t, "]")));
                                    case 4:
                                        return e.abrupt("return", r.action(n));
                                    case 5:
                                    case "end":
                                        return e.stop();
                                }
                            }, e);
                        }));
                        return function(t) {
                            return e.apply(this, arguments);
                        };
                    }(), y = null === (n = o.successWithInteractionCode) || void 0 === n ? void 0 : (0, a.default)(r = n.value).call(r, function(e) {
                        return "interaction_code" === e.name;
                    }).value;
                    return {
                        proceed: g,
                        neededToProceed: v,
                        actions: d,
                        context: h,
                        rawIdxState: o,
                        hasInteractionCode: function() {
                            return !!o.successWithInteractionCode;
                        },
                        interactionCode: y,
                        toPersist: t
                    };
                };
            },
            2080: function(e, t, n) {
                "use strict";
                var r = n(3978), o = n(530);
                r(t, "__esModule", {
                    value: !0
                }), t.default = void 0;
                var i = {
                    makeIdxState: o(n(4807)).default
                };
                t.default = i;
            },
            7689: function(e, t, n) {
                "use strict";
                var r = n(3978), o = n(530);
                r(t, "__esModule", {
                    value: !0
                }), t.generateRemediationFunctions = void 0, n(8309);
                var i = o(n(1306)), a = o(n(2991)), u = o(n(7700));
                t.generateRemediationFunctions = function(e) {
                    var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
                    return (0, i.default)((0, a.default)(e).call(e, function(e) {
                        return [
                            e.name,
                            (0, u.default)(e, t)
                        ];
                    }));
                };
            },
            3615: function(e, t, n) {
                "use strict";
                var r = n(4575), o = n(3913), i = n(2205), a = n(8585), u = n(9754);
                function s(e, t) {
                    (null == t || t > e.length) && (t = e.length);
                    for(var n = 0, r = new Array(t); n < t; n++)r[n] = e[n];
                    return r;
                }
                var c = function(e) {
                    i(c, e);
                    var t, n, s = (t = c, n = function() {
                        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                        if (Reflect.construct.sham) return !1;
                        if ("function" == typeof Proxy) return !0;
                        try {
                            return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
                        } catch (e) {
                            return !1;
                        }
                    }(), function() {
                        var e, r = u(t);
                        if (n) {
                            var o = u(this).constructor;
                            e = Reflect.construct(r, arguments, o);
                        } else e = r.apply(this, arguments);
                        return a(this, e);
                    });
                    function c(e) {
                        var t;
                        return r(this, c), (t = s.call(this, e || "Promise was canceled")).name = "CancelError", t;
                    }
                    return o(c, [
                        {
                            key: "isCanceled",
                            get: function() {
                                return !0;
                            }
                        }
                    ]), c;
                }(n(5957)(Error)), f = function() {
                    function e(t) {
                        var n = this;
                        r(this, e), this._cancelHandlers = [], this._isPending = !0, this._isCanceled = !1, this._rejectOnCancel = !0, this._promise = new Promise(function(e, r) {
                            n._reject = r;
                            var o = function(e) {
                                if (!n._isPending) throw new Error("The `onCancel` handler was attached after the promise settled.");
                                n._cancelHandlers.push(e);
                            };
                            return Object.defineProperties(o, {
                                shouldReject: {
                                    get: function() {
                                        return n._rejectOnCancel;
                                    },
                                    set: function(e) {
                                        n._rejectOnCancel = e;
                                    }
                                }
                            }), t(function(t) {
                                n._isCanceled && o.shouldReject || (n._isPending = !1, e(t));
                            }, function(e) {
                                n._isPending = !1, r(e);
                            }, o);
                        });
                    }
                    return o(e, [
                        {
                            key: "then",
                            value: function(e, t) {
                                return this._promise.then(e, t);
                            }
                        },
                        {
                            key: "catch",
                            value: function(e) {
                                return this._promise.catch(e);
                            }
                        },
                        {
                            key: "finally",
                            value: function(e) {
                                return this._promise.finally(e);
                            }
                        },
                        {
                            key: "cancel",
                            value: function(e) {
                                if (this._isPending && !this._isCanceled) {
                                    if (this._isCanceled = !0, this._cancelHandlers.length > 0) try {
                                        var t, n = function(e, t) {
                                            var n = "undefined" != typeof Symbol && e[Symbol.iterator] || e["@@iterator"];
                                            if (!n) {
                                                if (Array.isArray(e) || (n = function(e, t) {
                                                    if (e) {
                                                        if ("string" == typeof e) return s(e, t);
                                                        var n = Object.prototype.toString.call(e).slice(8, -1);
                                                        return "Object" === n && e.constructor && (n = e.constructor.name), "Map" === n || "Set" === n ? Array.from(e) : "Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? s(e, t) : void 0;
                                                    }
                                                }(e)) || t && e && "number" == typeof e.length) {
                                                    n && (e = n);
                                                    var r = 0, o = function() {};
                                                    return {
                                                        s: o,
                                                        n: function() {
                                                            return r >= e.length ? {
                                                                done: !0
                                                            } : {
                                                                done: !1,
                                                                value: e[r++]
                                                            };
                                                        },
                                                        e: function(e) {
                                                            throw e;
                                                        },
                                                        f: o
                                                    };
                                                }
                                                throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
                                            }
                                            var i, a = !0, u = !1;
                                            return {
                                                s: function() {
                                                    n = n.call(e);
                                                },
                                                n: function() {
                                                    var e = n.next();
                                                    return a = e.done, e;
                                                },
                                                e: function(e) {
                                                    u = !0, i = e;
                                                },
                                                f: function() {
                                                    try {
                                                        a || null == n.return || n.return();
                                                    } finally{
                                                        if (u) throw i;
                                                    }
                                                }
                                            };
                                        }(this._cancelHandlers);
                                        try {
                                            for(n.s(); !(t = n.n()).done;)(0, t.value)();
                                        } catch (e) {
                                            n.e(e);
                                        } finally{
                                            n.f();
                                        }
                                    } catch (e) {
                                        return void this._reject(e);
                                    }
                                    this._rejectOnCancel && this._reject(new c(e));
                                }
                            }
                        },
                        {
                            key: "isCanceled",
                            get: function() {
                                return this._isCanceled;
                            }
                        }
                    ], [
                        {
                            key: "fn",
                            value: function(t) {
                                return function() {
                                    for(var n = arguments.length, r = new Array(n), o = 0; o < n; o++)r[o] = arguments[o];
                                    return new e(function(e, n, o) {
                                        r.push(o), t.apply(void 0, r).then(e, n);
                                    });
                                };
                            }
                        }
                    ]), e;
                }();
                Object.setPrototypeOf(f.prototype, Promise.prototype), e.exports = f, e.exports.CancelError = c;
            },
            4493: function(e, t, n) {
                n(7971), n(3242);
                var r = n(4058);
                e.exports = r.Array.from;
            },
            4034: function(e, t, n) {
                n(2737);
                var r = n(4058);
                e.exports = r.Array.isArray;
            },
            5367: function(e, t, n) {
                n(5906);
                var r = n(5703);
                e.exports = r("Array").concat;
            },
            2383: function(e, t, n) {
                n(1501);
                var r = n(5703);
                e.exports = r("Array").filter;
            },
            7671: function(e, t, n) {
                n(833);
                var r = n(5703);
                e.exports = r("Array").find;
            },
            9324: function(e, t, n) {
                n(2437);
                var r = n(5703);
                e.exports = r("Array").forEach;
            },
            8700: function(e, t, n) {
                n(9076);
                var r = n(5703);
                e.exports = r("Array").indexOf;
            },
            3866: function(e, t, n) {
                n(8787);
                var r = n(5703);
                e.exports = r("Array").map;
            },
            4900: function(e, t, n) {
                n(186);
                var r = n(5703);
                e.exports = r("Array").slice;
            },
            6043: function(e, t, n) {
                var r = n(5367), o = Array.prototype;
                e.exports = function(e) {
                    var t = e.concat;
                    return e === o || e instanceof Array && t === o.concat ? r : t;
                };
            },
            2480: function(e, t, n) {
                var r = n(2383), o = Array.prototype;
                e.exports = function(e) {
                    var t = e.filter;
                    return e === o || e instanceof Array && t === o.filter ? r : t;
                };
            },
            2236: function(e, t, n) {
                var r = n(7671), o = Array.prototype;
                e.exports = function(e) {
                    var t = e.find;
                    return e === o || e instanceof Array && t === o.find ? r : t;
                };
            },
            4570: function(e, t, n) {
                var r = n(8700), o = Array.prototype;
                e.exports = function(e) {
                    var t = e.indexOf;
                    return e === o || e instanceof Array && t === o.indexOf ? r : t;
                };
            },
            8287: function(e, t, n) {
                var r = n(3866), o = Array.prototype;
                e.exports = function(e) {
                    var t = e.map;
                    return e === o || e instanceof Array && t === o.map ? r : t;
                };
            },
            9601: function(e, t, n) {
                var r = n(4900), o = Array.prototype;
                e.exports = function(e) {
                    var t = e.slice;
                    return e === o || e instanceof Array && t === o.slice ? r : t;
                };
            },
            4426: function(e, t, n) {
                n(2619);
                var r = n(4058);
                r.JSON || (r.JSON = {
                    stringify: JSON.stringify
                }), e.exports = function(e, t, n) {
                    return r.JSON.stringify.apply(null, arguments);
                };
            },
            7702: function(e, t, n) {
                n(4979);
                var r = n(4058).Object, o = e.exports = function(e, t) {
                    return r.defineProperties(e, t);
                };
                r.defineProperties.sham && (o.sham = !0);
            },
            8171: function(e, t, n) {
                n(6450);
                var r = n(4058).Object, o = e.exports = function(e, t, n) {
                    return r.defineProperty(e, t, n);
                };
                r.defineProperty.sham && (o.sham = !0);
            },
            3081: function(e, t, n) {
                n(1078);
                var r = n(4058);
                e.exports = r.Object.entries;
            },
            7699: function(e, t, n) {
                n(6274), n(8387);
                var r = n(4058);
                e.exports = r.Object.fromEntries;
            },
            286: function(e, t, n) {
                n(6924);
                var r = n(4058).Object, o = e.exports = function(e, t) {
                    return r.getOwnPropertyDescriptor(e, t);
                };
                r.getOwnPropertyDescriptor.sham && (o.sham = !0);
            },
            2766: function(e, t, n) {
                n(8482);
                var r = n(4058);
                e.exports = r.Object.getOwnPropertyDescriptors;
            },
            498: function(e, t, n) {
                n(5824);
                var r = n(4058);
                e.exports = r.Object.getOwnPropertySymbols;
            },
            8494: function(e, t, n) {
                n(1724);
                var r = n(4058);
                e.exports = r.Object.keys;
            },
            2956: function(e, t, n) {
                n(7627), n(5967), n(8881), n(4560), n(7206), n(4349), n(7971), n(7634);
                var r = n(4058);
                e.exports = r.Promise;
            },
            7473: function(e, t, n) {
                n(5906), n(5967), n(5824), n(8555), n(2615), n(1732), n(5903), n(1825), n(8394), n(5915), n(1766), n(9791), n(9911), n(4315), n(3131), n(4714), n(659), n(9120), n(5327), n(1502);
                var r = n(4058);
                e.exports = r.Symbol;
            },
            4227: function(e, t, n) {
                n(1825), n(7971), n(7634);
                var r = n(1477);
                e.exports = r.f("iterator");
            },
            7385: function(e, t, n) {
                var r = n(4493);
                e.exports = r;
            },
            1522: function(e, t, n) {
                var r = n(4034);
                e.exports = r;
            },
            2209: function(e, t, n) {
                n(7634), n(7971);
                var r = n(2902);
                e.exports = r;
            },
            1258: function(e, t, n) {
                n(7634), n(7971);
                var r = n(429);
                e.exports = r;
            },
            9447: function(e, t, n) {
                var r = n(4570);
                e.exports = r;
            },
            1493: function(e, t, n) {
                var r = n(9601);
                e.exports = r;
            },
            3685: function(e, t, n) {
                var r = n(8171);
                e.exports = r;
            },
            4710: function(e, t, n) {
                var r = n(498);
                e.exports = r;
            },
            3799: function(e, t, n) {
                var r = n(8494);
                e.exports = r;
            },
            9531: function(e, t, n) {
                var r = n(2956);
                n(9731), n(5708), n(14), n(8731), e.exports = r;
            },
            6600: function(e, t, n) {
                var r = n(7473);
                n(8783), n(3975), n(5799), n(5414), n(6774), n(620), n(6172), e.exports = r;
            },
            9759: function(e, t, n) {
                var r = n(4227);
                e.exports = r;
            },
            3916: function(e) {
                e.exports = function(e) {
                    if ("function" != typeof e) throw TypeError(String(e) + " is not a function");
                    return e;
                };
            },
            1851: function(e, t, n) {
                var r = n(941);
                e.exports = function(e) {
                    if (!r(e) && null !== e) throw TypeError("Can't set " + String(e) + " as a prototype");
                    return e;
                };
            },
            8479: function(e) {
                e.exports = function() {};
            },
            5743: function(e) {
                e.exports = function(e, t, n) {
                    if (!(e instanceof t)) throw TypeError("Incorrect " + (n ? n + " " : "") + "invocation");
                    return e;
                };
            },
            6059: function(e, t, n) {
                var r = n(941);
                e.exports = function(e) {
                    if (!r(e)) throw TypeError(String(e) + " is not an object");
                    return e;
                };
            },
            6837: function(e, t, n) {
                "use strict";
                var r = n(3610).forEach, o = n(4194)("forEach");
                e.exports = o ? [].forEach : function(e) {
                    return r(this, e, arguments.length > 1 ? arguments[1] : void 0);
                };
            },
            1354: function(e, t, n) {
                "use strict";
                var r = n(6843), o = n(9678), i = n(5196), a = n(6782), u = n(3057), s = n(5449), c = n(2902);
                e.exports = function(e) {
                    var t, n, f, l, p, h, d = o(e), v = "function" == typeof this ? this : Array, g = arguments.length, y = g > 1 ? arguments[1] : void 0, m = void 0 !== y, b = c(d), k = 0;
                    if (m && (y = r(y, g > 2 ? arguments[2] : void 0, 2)), null == b || v == Array && a(b)) for(n = new v(t = u(d.length)); t > k; k++)h = m ? y(d[k], k) : d[k], s(n, k, h);
                    else for(p = (l = b.call(d)).next, n = new v; !(f = p.call(l)).done; k++)h = m ? i(l, y, [
                        f.value,
                        k
                    ], !0) : f.value, s(n, k, h);
                    return n.length = k, n;
                };
            },
            1692: function(e, t, n) {
                var r = n(4529), o = n(3057), i = n(9413), a = function(e) {
                    return function(t, n, a) {
                        var u, s = r(t), c = o(s.length), f = i(a, c);
                        if (e && n != n) {
                            for(; c > f;)if ((u = s[f++]) != u) return !0;
                        } else for(; c > f; f++)if ((e || f in s) && s[f] === n) return e || f || 0;
                        return !e && -1;
                    };
                };
                e.exports = {
                    includes: a(!0),
                    indexOf: a(!1)
                };
            },
            3610: function(e, t, n) {
                var r = n(6843), o = n(7026), i = n(9678), a = n(3057), u = n(4692), s = [].push, c = function(e) {
                    var t = 1 == e, n = 2 == e, c = 3 == e, f = 4 == e, l = 6 == e, p = 7 == e, h = 5 == e || l;
                    return function(d, v, g, y) {
                        for(var m, b, k = i(d), w = o(k), x = r(v, g, 3), S = a(w.length), T = 0, O = y || u, A = t ? O(d, S) : n || p ? O(d, 0) : void 0; S > T; T++)if ((h || T in w) && (b = x(m = w[T], T, k), e)) {
                            if (t) A[T] = b;
                            else if (b) switch(e){
                                case 3:
                                    return !0;
                                case 5:
                                    return m;
                                case 6:
                                    return T;
                                case 2:
                                    s.call(A, m);
                            }
                            else switch(e){
                                case 4:
                                    return !1;
                                case 7:
                                    s.call(A, m);
                            }
                        }
                        return l ? -1 : c || f ? f : A;
                    };
                };
                e.exports = {
                    forEach: c(0),
                    map: c(1),
                    filter: c(2),
                    some: c(3),
                    every: c(4),
                    find: c(5),
                    findIndex: c(6),
                    filterOut: c(7)
                };
            },
            568: function(e, t, n) {
                var r = n(5981), o = n(9813), i = n(3385), a = o("species");
                e.exports = function(e) {
                    return i >= 51 || !r(function() {
                        var t = [];
                        return (t.constructor = {})[a] = function() {
                            return {
                                foo: 1
                            };
                        }, 1 !== t[e](Boolean).foo;
                    });
                };
            },
            4194: function(e, t, n) {
                "use strict";
                var r = n(5981);
                e.exports = function(e, t) {
                    var n = [][e];
                    return !!n && r(function() {
                        n.call(null, t || function() {
                            throw 1;
                        }, 1);
                    });
                };
            },
            4692: function(e, t, n) {
                var r = n(941), o = n(1052), i = n(9813)("species");
                e.exports = function(e, t) {
                    var n;
                    return o(e) && ("function" != typeof (n = e.constructor) || n !== Array && !o(n.prototype) ? r(n) && null === (n = n[i]) && (n = void 0) : n = void 0), new (void 0 === n ? Array : n)(0 === t ? 0 : t);
                };
            },
            5196: function(e, t, n) {
                var r = n(6059), o = n(7609);
                e.exports = function(e, t, n, i) {
                    try {
                        return i ? t(r(n)[0], n[1]) : t(n);
                    } catch (t) {
                        throw o(e), t;
                    }
                };
            },
            1385: function(e, t, n) {
                var r = n(9813)("iterator"), o = !1;
                try {
                    var i = 0, a = {
                        next: function() {
                            return {
                                done: !!i++
                            };
                        },
                        return: function() {
                            o = !0;
                        }
                    };
                    a[r] = function() {
                        return this;
                    }, Array.from(a, function() {
                        throw 2;
                    });
                } catch (e) {}
                e.exports = function(e, t) {
                    if (!t && !o) return !1;
                    var n = !1;
                    try {
                        var i = {};
                        i[r] = function() {
                            return {
                                next: function() {
                                    return {
                                        done: n = !0
                                    };
                                }
                            };
                        }, e(i);
                    } catch (e) {}
                    return n;
                };
            },
            2532: function(e) {
                var t = {}.toString;
                e.exports = function(e) {
                    return t.call(e).slice(8, -1);
                };
            },
            9697: function(e, t, n) {
                var r = n(2885), o = n(2532), i = n(9813)("toStringTag"), a = "Arguments" == o(function() {
                    return arguments;
                }());
                e.exports = r ? o : function(e) {
                    var t, n, r;
                    return void 0 === e ? "Undefined" : null === e ? "Null" : "string" == typeof (n = function(e, t) {
                        try {
                            return e[t];
                        } catch (e) {}
                    }(t = Object(e), i)) ? n : a ? o(t) : "Object" == (r = o(t)) && "function" == typeof t.callee ? "Arguments" : r;
                };
            },
            4160: function(e, t, n) {
                var r = n(5981);
                e.exports = !r(function() {
                    function e() {}
                    return e.prototype.constructor = null, Object.getPrototypeOf(new e) !== e.prototype;
                });
            },
            1046: function(e, t, n) {
                "use strict";
                var r = n(5143).IteratorPrototype, o = n(9290), i = n(1887), a = n(904), u = n(2077), s = function() {
                    return this;
                };
                e.exports = function(e, t, n) {
                    var c = t + " Iterator";
                    return e.prototype = o(r, {
                        next: i(1, n)
                    }), a(e, c, !1, !0), u[c] = s, e;
                };
            },
            2029: function(e, t, n) {
                var r = n(5746), o = n(5988), i = n(1887);
                e.exports = r ? function(e, t, n) {
                    return o.f(e, t, i(1, n));
                } : function(e, t, n) {
                    return e[t] = n, e;
                };
            },
            1887: function(e) {
                e.exports = function(e, t) {
                    return {
                        enumerable: !(1 & e),
                        configurable: !(2 & e),
                        writable: !(4 & e),
                        value: t
                    };
                };
            },
            5449: function(e, t, n) {
                "use strict";
                var r = n(6935), o = n(5988), i = n(1887);
                e.exports = function(e, t, n) {
                    var a = r(t);
                    a in e ? o.f(e, a, i(0, n)) : e[a] = n;
                };
            },
            7771: function(e, t, n) {
                "use strict";
                var r = n(6887), o = n(1046), i = n(249), a = n(8929), u = n(904), s = n(2029), c = n(1341), f = n(9813), l = n(2529), p = n(2077), h = n(5143), d = h.IteratorPrototype, v = h.BUGGY_SAFARI_ITERATORS, g = f("iterator"), y = "keys", m = "values", b = "entries", k = function() {
                    return this;
                };
                e.exports = function(e, t, n, f, h, w, x) {
                    o(n, t, f);
                    var S, T, O, A = function(e) {
                        if (e === h && j) return j;
                        if (!v && e in R) return R[e];
                        switch(e){
                            case y:
                            case m:
                            case b:
                                return function() {
                                    return new n(this, e);
                                };
                        }
                        return function() {
                            return new n(this);
                        };
                    }, E = t + " Iterator", _ = !1, R = e.prototype, P = R[g] || R["@@iterator"] || h && R[h], j = !v && P || A(h), I = "Array" == t && R.entries || P;
                    if (I && (S = i(I.call(new e)), d !== Object.prototype && S.next && (l || i(S) === d || (a ? a(S, d) : "function" != typeof S[g] && s(S, g, k)), u(S, E, !0, !0), l && (p[E] = k))), h == m && P && P.name !== m && (_ = !0, j = function() {
                        return P.call(this);
                    }), l && !x || R[g] === j || s(R, g, j), p[t] = j, h) {
                        if (T = {
                            values: A(m),
                            keys: w ? j : A(y),
                            entries: A(b)
                        }, x) for(O in T)(v || _ || !(O in R)) && c(R, O, T[O]);
                        else r({
                            target: t,
                            proto: !0,
                            forced: v || _
                        }, T);
                    }
                    return T;
                };
            },
            6349: function(e, t, n) {
                var r = n(4058), o = n(7457), i = n(1477), a = n(5988).f;
                e.exports = function(e) {
                    var t = r.Symbol || (r.Symbol = {});
                    o(t, e) || a(t, e, {
                        value: i.f(e)
                    });
                };
            },
            5746: function(e, t, n) {
                var r = n(5981);
                e.exports = !r(function() {
                    return 7 != Object.defineProperty({}, 1, {
                        get: function() {
                            return 7;
                        }
                    })[1];
                });
            },
            1333: function(e, t, n) {
                var r = n(1899), o = n(941), i = r.document, a = o(i) && o(i.createElement);
                e.exports = function(e) {
                    return a ? i.createElement(e) : {};
                };
            },
            3281: function(e) {
                e.exports = {
                    CSSRuleList: 0,
                    CSSStyleDeclaration: 0,
                    CSSValueList: 0,
                    ClientRectList: 0,
                    DOMRectList: 0,
                    DOMStringList: 0,
                    DOMTokenList: 1,
                    DataTransferItemList: 0,
                    FileList: 0,
                    HTMLAllCollection: 0,
                    HTMLCollection: 0,
                    HTMLFormElement: 0,
                    HTMLSelectElement: 0,
                    MediaList: 0,
                    MimeTypeArray: 0,
                    NamedNodeMap: 0,
                    NodeList: 1,
                    PaintRequestList: 0,
                    Plugin: 0,
                    PluginArray: 0,
                    SVGLengthList: 0,
                    SVGNumberList: 0,
                    SVGPathSegList: 0,
                    SVGPointList: 0,
                    SVGStringList: 0,
                    SVGTransformList: 0,
                    SourceBufferList: 0,
                    StyleSheetList: 0,
                    TextTrackCueList: 0,
                    TextTrackList: 0,
                    TouchList: 0
                };
            },
            3321: function(e) {
                e.exports = "object" == typeof window;
            },
            2749: function(e, t, n) {
                var r = n(2861);
                e.exports = /(?:iphone|ipod|ipad).*applewebkit/i.test(r);
            },
            6049: function(e, t, n) {
                var r = n(2532), o = n(1899);
                e.exports = "process" == r(o.process);
            },
            8045: function(e, t, n) {
                var r = n(2861);
                e.exports = /web0s(?!.*chrome)/i.test(r);
            },
            2861: function(e, t, n) {
                var r = n(626);
                e.exports = r("navigator", "userAgent") || "";
            },
            3385: function(e, t, n) {
                var r, o, i = n(1899), a = n(2861), u = i.process, s = u && u.versions, c = s && s.v8;
                c ? o = (r = c.split("."))[0] < 4 ? 1 : r[0] + r[1] : a && (!(r = a.match(/Edge\/(\d+)/)) || r[1] >= 74) && (r = a.match(/Chrome\/(\d+)/)) && (o = r[1]), e.exports = o && +o;
            },
            5703: function(e, t, n) {
                var r = n(4058);
                e.exports = function(e) {
                    return r[e + "Prototype"];
                };
            },
            6759: function(e) {
                e.exports = [
                    "constructor",
                    "hasOwnProperty",
                    "isPrototypeOf",
                    "propertyIsEnumerable",
                    "toLocaleString",
                    "toString",
                    "valueOf"
                ];
            },
            6887: function(e, t, n) {
                "use strict";
                var r = n(1899), o = n(9677).f, i = n(7252), a = n(4058), u = n(6843), s = n(2029), c = n(7457), f = function(e) {
                    var t = function(t, n, r) {
                        if (this instanceof e) {
                            switch(arguments.length){
                                case 0:
                                    return new e;
                                case 1:
                                    return new e(t);
                                case 2:
                                    return new e(t, n);
                            }
                            return new e(t, n, r);
                        }
                        return e.apply(this, arguments);
                    };
                    return t.prototype = e.prototype, t;
                };
                e.exports = function(e, t) {
                    var n, l, p, h, d, v, g, y, m = e.target, b = e.global, k = e.stat, w = e.proto, x = b ? r : k ? r[m] : (r[m] || {}).prototype, S = b ? a : a[m] || (a[m] = {}), T = S.prototype;
                    for(p in t)n = !i(b ? p : m + (k ? "." : "#") + p, e.forced) && x && c(x, p), d = S[p], n && (v = e.noTargetGet ? (y = o(x, p)) && y.value : x[p]), h = n && v ? v : t[p], n && typeof d == typeof h || (g = e.bind && n ? u(h, r) : e.wrap && n ? f(h) : w && "function" == typeof h ? u(Function.call, h) : h, (e.sham || h && h.sham || d && d.sham) && s(g, "sham", !0), S[p] = g, w && (c(a, l = m + "Prototype") || s(a, l, {}), a[l][p] = h, e.real && T && !T[p] && s(T, p, h)));
                };
            },
            5981: function(e) {
                e.exports = function(e) {
                    try {
                        return !!e();
                    } catch (e) {
                        return !0;
                    }
                };
            },
            6843: function(e, t, n) {
                var r = n(3916);
                e.exports = function(e, t, n) {
                    if (r(e), void 0 === t) return e;
                    switch(n){
                        case 0:
                            return function() {
                                return e.call(t);
                            };
                        case 1:
                            return function(n) {
                                return e.call(t, n);
                            };
                        case 2:
                            return function(n, r) {
                                return e.call(t, n, r);
                            };
                        case 3:
                            return function(n, r, o) {
                                return e.call(t, n, r, o);
                            };
                    }
                    return function() {
                        return e.apply(t, arguments);
                    };
                };
            },
            626: function(e, t, n) {
                var r = n(4058), o = n(1899), i = function(e) {
                    return "function" == typeof e ? e : void 0;
                };
                e.exports = function(e, t) {
                    return arguments.length < 2 ? i(r[e]) || i(o[e]) : r[e] && r[e][t] || o[e] && o[e][t];
                };
            },
            2902: function(e, t, n) {
                var r = n(9697), o = n(2077), i = n(9813)("iterator");
                e.exports = function(e) {
                    if (null != e) return e[i] || e["@@iterator"] || o[r(e)];
                };
            },
            429: function(e, t, n) {
                var r = n(6059), o = n(2902);
                e.exports = function(e) {
                    var t = o(e);
                    if ("function" != typeof t) throw TypeError(String(e) + " is not iterable");
                    return r(t.call(e));
                };
            },
            1899: function(e, t, n) {
                var r = function(e) {
                    return e && e.Math == Math && e;
                };
                e.exports = r("object" == typeof globalThis && globalThis) || r("object" == typeof window && window) || r("object" == typeof self && self) || r("object" == typeof n.g && n.g) || function() {
                    return this;
                }() || Function("return this")();
            },
            7457: function(e, t, n) {
                var r = n(9678), o = {}.hasOwnProperty;
                e.exports = Object.hasOwn || function(e, t) {
                    return o.call(r(e), t);
                };
            },
            7748: function(e) {
                e.exports = {};
            },
            4845: function(e, t, n) {
                var r = n(1899);
                e.exports = function(e, t) {
                    var n = r.console;
                    n && n.error && (1 === arguments.length ? n.error(e) : n.error(e, t));
                };
            },
            5463: function(e, t, n) {
                var r = n(626);
                e.exports = r("document", "documentElement");
            },
            2840: function(e, t, n) {
                var r = n(5746), o = n(5981), i = n(1333);
                e.exports = !r && !o(function() {
                    return 7 != Object.defineProperty(i("div"), "a", {
                        get: function() {
                            return 7;
                        }
                    }).a;
                });
            },
            7026: function(e, t, n) {
                var r = n(5981), o = n(2532), i = "".split;
                e.exports = r(function() {
                    return !Object("z").propertyIsEnumerable(0);
                }) ? function(e) {
                    return "String" == o(e) ? i.call(e, "") : Object(e);
                } : Object;
            },
            1302: function(e, t, n) {
                var r = n(3030), o = Function.toString;
                "function" != typeof r.inspectSource && (r.inspectSource = function(e) {
                    return o.call(e);
                }), e.exports = r.inspectSource;
            },
            5402: function(e, t, n) {
                var r, o, i, a = n(8019), u = n(1899), s = n(941), c = n(2029), f = n(7457), l = n(3030), p = n(4262), h = n(7748), d = "Object already initialized", v = u.WeakMap;
                if (a || l.state) {
                    var g = l.state || (l.state = new v), y = g.get, m = g.has, b = g.set;
                    r = function(e, t) {
                        if (m.call(g, e)) throw new TypeError(d);
                        return t.facade = e, b.call(g, e, t), t;
                    }, o = function(e) {
                        return y.call(g, e) || {};
                    }, i = function(e) {
                        return m.call(g, e);
                    };
                } else {
                    var k = p("state");
                    h[k] = !0, r = function(e, t) {
                        if (f(e, k)) throw new TypeError(d);
                        return t.facade = e, c(e, k, t), t;
                    }, o = function(e) {
                        return f(e, k) ? e[k] : {};
                    }, i = function(e) {
                        return f(e, k);
                    };
                }
                e.exports = {
                    set: r,
                    get: o,
                    has: i,
                    enforce: function(e) {
                        return i(e) ? o(e) : r(e, {});
                    },
                    getterFor: function(e) {
                        return function(t) {
                            var n;
                            if (!s(t) || (n = o(t)).type !== e) throw TypeError("Incompatible receiver, " + e + " required");
                            return n;
                        };
                    }
                };
            },
            6782: function(e, t, n) {
                var r = n(9813), o = n(2077), i = r("iterator"), a = Array.prototype;
                e.exports = function(e) {
                    return void 0 !== e && (o.Array === e || a[i] === e);
                };
            },
            1052: function(e, t, n) {
                var r = n(2532);
                e.exports = Array.isArray || function(e) {
                    return "Array" == r(e);
                };
            },
            7252: function(e, t, n) {
                var r = n(5981), o = /#|\.prototype\./, i = function(e, t) {
                    var n = u[a(e)];
                    return n == c || n != s && ("function" == typeof t ? r(t) : !!t);
                }, a = i.normalize = function(e) {
                    return String(e).replace(o, ".").toLowerCase();
                }, u = i.data = {}, s = i.NATIVE = "N", c = i.POLYFILL = "P";
                e.exports = i;
            },
            941: function(e) {
                e.exports = function(e) {
                    return "object" == typeof e ? null !== e : "function" == typeof e;
                };
            },
            2529: function(e) {
                e.exports = !0;
            },
            3091: function(e, t, n) {
                var r = n(6059), o = n(6782), i = n(3057), a = n(6843), u = n(2902), s = n(7609), c = function(e, t) {
                    this.stopped = e, this.result = t;
                };
                e.exports = function(e, t, n) {
                    var f, l, p, h, d, v, g, y = n && n.that, m = !(!n || !n.AS_ENTRIES), b = !(!n || !n.IS_ITERATOR), k = !(!n || !n.INTERRUPTED), w = a(t, y, 1 + m + k), x = function(e) {
                        return f && s(f), new c(!0, e);
                    }, S = function(e) {
                        return m ? (r(e), k ? w(e[0], e[1], x) : w(e[0], e[1])) : k ? w(e, x) : w(e);
                    };
                    if (b) f = e;
                    else {
                        if ("function" != typeof (l = u(e))) throw TypeError("Target is not iterable");
                        if (o(l)) {
                            for(p = 0, h = i(e.length); h > p; p++)if ((d = S(e[p])) && d instanceof c) return d;
                            return new c(!1);
                        }
                        f = l.call(e);
                    }
                    for(v = f.next; !(g = v.call(f)).done;){
                        try {
                            d = S(g.value);
                        } catch (e) {
                            throw s(f), e;
                        }
                        if ("object" == typeof d && d && d instanceof c) return d;
                    }
                    return new c(!1);
                };
            },
            7609: function(e, t, n) {
                var r = n(6059);
                e.exports = function(e) {
                    var t = e.return;
                    if (void 0 !== t) return r(t.call(e)).value;
                };
            },
            5143: function(e, t, n) {
                "use strict";
                var r, o, i, a = n(5981), u = n(249), s = n(2029), c = n(7457), f = n(9813), l = n(2529), p = f("iterator"), h = !1;
                [].keys && ("next" in (i = [].keys()) ? (o = u(u(i))) !== Object.prototype && (r = o) : h = !0);
                var d = null == r || a(function() {
                    var e = {};
                    return r[p].call(e) !== e;
                });
                d && (r = {}), l && !d || c(r, p) || s(r, p, function() {
                    return this;
                }), e.exports = {
                    IteratorPrototype: r,
                    BUGGY_SAFARI_ITERATORS: h
                };
            },
            2077: function(e) {
                e.exports = {};
            },
            6132: function(e, t, n) {
                var r, o, i, a, u, s, c, f, l = n(1899), p = n(9677).f, h = n(2941).set, d = n(2749), v = n(8045), g = n(6049), y = l.MutationObserver || l.WebKitMutationObserver, m = l.document, b = l.process, k = l.Promise, w = p(l, "queueMicrotask"), x = w && w.value;
                x || (r = function() {
                    var e, t;
                    for(g && (e = b.domain) && e.exit(); o;){
                        t = o.fn, o = o.next;
                        try {
                            t();
                        } catch (e) {
                            throw o ? a() : i = void 0, e;
                        }
                    }
                    i = void 0, e && e.enter();
                }, d || g || v || !y || !m ? k && k.resolve ? ((c = k.resolve(void 0)).constructor = k, f = c.then, a = function() {
                    f.call(c, r);
                }) : a = g ? function() {
                    b.nextTick(r);
                } : function() {
                    h.call(l, r);
                } : (u = !0, s = m.createTextNode(""), new y(r).observe(s, {
                    characterData: !0
                }), a = function() {
                    s.data = u = !u;
                })), e.exports = x || function(e) {
                    var t = {
                        fn: e,
                        next: void 0
                    };
                    i && (i.next = t), o || (o = t, a()), i = t;
                };
            },
            9297: function(e, t, n) {
                var r = n(1899);
                e.exports = r.Promise;
            },
            2497: function(e, t, n) {
                var r = n(3385), o = n(5981);
                e.exports = !!Object.getOwnPropertySymbols && !o(function() {
                    var e = Symbol();
                    return !String(e) || !(Object(e) instanceof Symbol) || !Symbol.sham && r && r < 41;
                });
            },
            8468: function(e, t, n) {
                var r = n(5981), o = n(9813), i = n(2529), a = o("iterator");
                e.exports = !r(function() {
                    var e = new URL("b?a=1&b=2&c=3", "http://a"), t = e.searchParams, n = "";
                    return e.pathname = "c%20d", t.forEach(function(e, r) {
                        t.delete("b"), n += r + e;
                    }), i && !e.toJSON || !t.sort || "http://a/c%20d?a=1&c=3" !== e.href || "3" !== t.get("c") || "a=1" !== String(new URLSearchParams("?a=1")) || !t[a] || "a" !== new URL("https://a@b").username || "b" !== new URLSearchParams(new URLSearchParams("a=b")).get("a") || "xn--e1aybc" !== new URL("http://тест").host || "#%D0%B1" !== new URL("http://a#б").hash || "a1c3" !== n || "x" !== new URL("http://x", void 0).host;
                });
            },
            8019: function(e, t, n) {
                var r = n(1899), o = n(1302), i = r.WeakMap;
                e.exports = "function" == typeof i && /native code/.test(o(i));
            },
            9520: function(e, t, n) {
                "use strict";
                var r = n(3916), o = function(e) {
                    var t, n;
                    this.promise = new e(function(e, r) {
                        if (void 0 !== t || void 0 !== n) throw TypeError("Bad Promise constructor");
                        t = e, n = r;
                    }), this.resolve = r(t), this.reject = r(n);
                };
                e.exports.f = function(e) {
                    return new o(e);
                };
            },
            4420: function(e, t, n) {
                "use strict";
                var r = n(5746), o = n(5981), i = n(4771), a = n(7857), u = n(8838), s = n(9678), c = n(7026), f = Object.assign, l = Object.defineProperty;
                e.exports = !f || o(function() {
                    if (r && 1 !== f({
                        b: 1
                    }, f(l({}, "a", {
                        enumerable: !0,
                        get: function() {
                            l(this, "b", {
                                value: 3,
                                enumerable: !1
                            });
                        }
                    }), {
                        b: 2
                    })).b) return !0;
                    var e = {}, t = {}, n = Symbol(), o = "abcdefghijklmnopqrst";
                    return e[n] = 7, o.split("").forEach(function(e) {
                        t[e] = e;
                    }), 7 != f({}, e)[n] || i(f({}, t)).join("") != o;
                }) ? function(e, t) {
                    for(var n = s(e), o = arguments.length, f = 1, l = a.f, p = u.f; o > f;)for(var h, d = c(arguments[f++]), v = l ? i(d).concat(l(d)) : i(d), g = v.length, y = 0; g > y;)h = v[y++], r && !p.call(d, h) || (n[h] = d[h]);
                    return n;
                } : f;
            },
            9290: function(e, t, n) {
                var r, o = n(6059), i = n(9938), a = n(6759), u = n(7748), s = n(5463), c = n(1333), f = n(4262)("IE_PROTO"), l = function() {}, p = function(e) {
                    return "<script>" + e + "</script>";
                }, h = function() {
                    try {
                        r = document.domain && new ActiveXObject("htmlfile");
                    } catch (e) {}
                    var e, t;
                    h = r ? function(e) {
                        e.write(p("")), e.close();
                        var t = e.parentWindow.Object;
                        return e = null, t;
                    }(r) : ((t = c("iframe")).style.display = "none", s.appendChild(t), t.src = String("javascript:"), (e = t.contentWindow.document).open(), e.write(p("document.F=Object")), e.close(), e.F);
                    for(var n = a.length; n--;)delete h.prototype[a[n]];
                    return h();
                };
                u[f] = !0, e.exports = Object.create || function(e, t) {
                    var n;
                    return null !== e ? (l.prototype = o(e), n = new l, l.prototype = null, n[f] = e) : n = h(), void 0 === t ? n : i(n, t);
                };
            },
            9938: function(e, t, n) {
                var r = n(5746), o = n(5988), i = n(6059), a = n(4771);
                e.exports = r ? Object.defineProperties : function(e, t) {
                    i(e);
                    for(var n, r = a(t), u = r.length, s = 0; u > s;)o.f(e, n = r[s++], t[n]);
                    return e;
                };
            },
            5988: function(e, t, n) {
                var r = n(5746), o = n(2840), i = n(6059), a = n(6935), u = Object.defineProperty;
                t.f = r ? u : function(e, t, n) {
                    if (i(e), t = a(t, !0), i(n), o) try {
                        return u(e, t, n);
                    } catch (e) {}
                    if ("get" in n || "set" in n) throw TypeError("Accessors not supported");
                    return "value" in n && (e[t] = n.value), e;
                };
            },
            9677: function(e, t, n) {
                var r = n(5746), o = n(8838), i = n(1887), a = n(4529), u = n(6935), s = n(7457), c = n(2840), f = Object.getOwnPropertyDescriptor;
                t.f = r ? f : function(e, t) {
                    if (e = a(e), t = u(t, !0), c) try {
                        return f(e, t);
                    } catch (e) {}
                    if (s(e, t)) return i(!o.f.call(e, t), e[t]);
                };
            },
            684: function(e, t, n) {
                var r = n(4529), o = n(946).f, i = {}.toString, a = "object" == typeof window && window && Object.getOwnPropertyNames ? Object.getOwnPropertyNames(window) : [];
                e.exports.f = function(e) {
                    return a && "[object Window]" == i.call(e) ? function(e) {
                        try {
                            return o(e);
                        } catch (e) {
                            return a.slice();
                        }
                    }(e) : o(r(e));
                };
            },
            946: function(e, t, n) {
                var r = n(5629), o = n(6759).concat("length", "prototype");
                t.f = Object.getOwnPropertyNames || function(e) {
                    return r(e, o);
                };
            },
            7857: function(e, t) {
                t.f = Object.getOwnPropertySymbols;
            },
            249: function(e, t, n) {
                var r = n(7457), o = n(9678), i = n(4262), a = n(4160), u = i("IE_PROTO"), s = Object.prototype;
                e.exports = a ? Object.getPrototypeOf : function(e) {
                    return e = o(e), r(e, u) ? e[u] : "function" == typeof e.constructor && e instanceof e.constructor ? e.constructor.prototype : e instanceof Object ? s : null;
                };
            },
            5629: function(e, t, n) {
                var r = n(7457), o = n(4529), i = n(1692).indexOf, a = n(7748);
                e.exports = function(e, t) {
                    var n, u = o(e), s = 0, c = [];
                    for(n in u)!r(a, n) && r(u, n) && c.push(n);
                    for(; t.length > s;)r(u, n = t[s++]) && (~i(c, n) || c.push(n));
                    return c;
                };
            },
            4771: function(e, t, n) {
                var r = n(5629), o = n(6759);
                e.exports = Object.keys || function(e) {
                    return r(e, o);
                };
            },
            8838: function(e, t) {
                "use strict";
                var n = {}.propertyIsEnumerable, r = Object.getOwnPropertyDescriptor, o = r && !n.call({
                    1: 2
                }, 1);
                t.f = o ? function(e) {
                    var t = r(this, e);
                    return !!t && t.enumerable;
                } : n;
            },
            8929: function(e, t, n) {
                var r = n(6059), o = n(1851);
                e.exports = Object.setPrototypeOf || ("__proto__" in {} ? function() {
                    var e, t = !1, n = {};
                    try {
                        (e = Object.getOwnPropertyDescriptor(Object.prototype, "__proto__").set).call(n, []), t = n instanceof Array;
                    } catch (e) {}
                    return function(n, i) {
                        return r(n), o(i), t ? e.call(n, i) : n.__proto__ = i, n;
                    };
                }() : void 0);
            },
            8810: function(e, t, n) {
                var r = n(5746), o = n(4771), i = n(4529), a = n(8838).f, u = function(e) {
                    return function(t) {
                        for(var n, u = i(t), s = o(u), c = s.length, f = 0, l = []; c > f;)n = s[f++], r && !a.call(u, n) || l.push(e ? [
                            n,
                            u[n]
                        ] : u[n]);
                        return l;
                    };
                };
                e.exports = {
                    entries: u(!0),
                    values: u(!1)
                };
            },
            5623: function(e, t, n) {
                "use strict";
                var r = n(2885), o = n(9697);
                e.exports = r ? ({}).toString : function() {
                    return "[object " + o(this) + "]";
                };
            },
            1136: function(e, t, n) {
                var r = n(626), o = n(946), i = n(7857), a = n(6059);
                e.exports = r("Reflect", "ownKeys") || function(e) {
                    var t = o.f(a(e)), n = i.f;
                    return n ? t.concat(n(e)) : t;
                };
            },
            4058: function(e) {
                e.exports = {};
            },
            2: function(e) {
                e.exports = function(e) {
                    try {
                        return {
                            error: !1,
                            value: e()
                        };
                    } catch (e) {
                        return {
                            error: !0,
                            value: e
                        };
                    }
                };
            },
            6584: function(e, t, n) {
                var r = n(6059), o = n(941), i = n(9520);
                e.exports = function(e, t) {
                    if (r(e), o(t) && t.constructor === e) return t;
                    var n = i.f(e);
                    return (0, n.resolve)(t), n.promise;
                };
            },
            7524: function(e, t, n) {
                var r = n(1341);
                e.exports = function(e, t, n) {
                    for(var o in t)n && n.unsafe && e[o] ? e[o] = t[o] : r(e, o, t[o], n);
                    return e;
                };
            },
            1341: function(e, t, n) {
                var r = n(2029);
                e.exports = function(e, t, n, o) {
                    o && o.enumerable ? e[t] = n : r(e, t, n);
                };
            },
            8219: function(e) {
                e.exports = function(e) {
                    if (null == e) throw TypeError("Can't call method on " + e);
                    return e;
                };
            },
            4911: function(e, t, n) {
                var r = n(1899), o = n(2029);
                e.exports = function(e, t) {
                    try {
                        o(r, e, t);
                    } catch (n) {
                        r[e] = t;
                    }
                    return t;
                };
            },
            4431: function(e, t, n) {
                "use strict";
                var r = n(626), o = n(5988), i = n(9813), a = n(5746), u = i("species");
                e.exports = function(e) {
                    var t = r(e), n = o.f;
                    a && t && !t[u] && n(t, u, {
                        configurable: !0,
                        get: function() {
                            return this;
                        }
                    });
                };
            },
            904: function(e, t, n) {
                var r = n(2885), o = n(5988).f, i = n(2029), a = n(7457), u = n(5623), s = n(9813)("toStringTag");
                e.exports = function(e, t, n, c) {
                    if (e) {
                        var f = n ? e : e.prototype;
                        a(f, s) || o(f, s, {
                            configurable: !0,
                            value: t
                        }), c && !r && i(f, "toString", u);
                    }
                };
            },
            4262: function(e, t, n) {
                var r = n(8726), o = n(9418), i = r("keys");
                e.exports = function(e) {
                    return i[e] || (i[e] = o(e));
                };
            },
            3030: function(e, t, n) {
                var r = n(1899), o = n(4911), i = "__core-js_shared__", a = r[i] || o(i, {});
                e.exports = a;
            },
            8726: function(e, t, n) {
                var r = n(2529), o = n(3030);
                (e.exports = function(e, t) {
                    return o[e] || (o[e] = void 0 !== t ? t : {});
                })("versions", []).push({
                    version: "3.15.1",
                    mode: r ? "pure" : "global",
                    copyright: "\xa9 2021 Denis Pushkarev (zloirock.ru)"
                });
            },
            487: function(e, t, n) {
                var r = n(6059), o = n(3916), i = n(9813)("species");
                e.exports = function(e, t) {
                    var n, a = r(e).constructor;
                    return void 0 === a || null == (n = r(a)[i]) ? t : o(n);
                };
            },
            4620: function(e, t, n) {
                var r = n(8459), o = n(8219), i = function(e) {
                    return function(t, n) {
                        var i, a, u = String(o(t)), s = r(n), c = u.length;
                        return s < 0 || s >= c ? e ? "" : void 0 : (i = u.charCodeAt(s)) < 55296 || i > 56319 || s + 1 === c || (a = u.charCodeAt(s + 1)) < 56320 || a > 57343 ? e ? u.charAt(s) : i : e ? u.slice(s, s + 2) : a - 56320 + (i - 55296 << 10) + 65536;
                    };
                };
                e.exports = {
                    codeAt: i(!1),
                    charAt: i(!0)
                };
            },
            3291: function(e) {
                "use strict";
                var t = 2147483647, n = /[^\0-\u007E]/, r = /[.\u3002\uFF0E\uFF61]/g, o = "Overflow: input needs wider integers to process", i = Math.floor, a = String.fromCharCode, u = function(e) {
                    return e + 22 + 75 * (e < 26);
                }, s = function(e, t, n) {
                    var r = 0;
                    for(e = n ? i(e / 700) : e >> 1, e += i(e / t); e > 455; r += 36)e = i(e / 35);
                    return i(r + 36 * e / (e + 38));
                }, c = function(e) {
                    var n = [];
                    e = function(e) {
                        for(var t = [], n = 0, r = e.length; n < r;){
                            var o = e.charCodeAt(n++);
                            if (o >= 55296 && o <= 56319 && n < r) {
                                var i = e.charCodeAt(n++);
                                56320 == (64512 & i) ? t.push(((1023 & o) << 10) + (1023 & i) + 65536) : (t.push(o), n--);
                            } else t.push(o);
                        }
                        return t;
                    }(e);
                    var r, c, f = e.length, l = 128, p = 0, h = 72;
                    for(r = 0; r < e.length; r++)(c = e[r]) < 128 && n.push(a(c));
                    var d = n.length, v = d;
                    for(d && n.push("-"); v < f;){
                        var g = t;
                        for(r = 0; r < e.length; r++)(c = e[r]) >= l && c < g && (g = c);
                        var y = v + 1;
                        if (g - l > i((t - p) / y)) throw RangeError(o);
                        for(p += (g - l) * y, l = g, r = 0; r < e.length; r++){
                            if ((c = e[r]) < l && ++p > t) throw RangeError(o);
                            if (c == l) {
                                for(var m = p, b = 36;; b += 36){
                                    var k = b <= h ? 1 : b >= h + 26 ? 26 : b - h;
                                    if (m < k) break;
                                    var w = m - k, x = 36 - k;
                                    n.push(a(u(k + w % x))), m = i(w / x);
                                }
                                n.push(a(u(m))), h = s(p, y, v == d), p = 0, ++v;
                            }
                        }
                        ++p, ++l;
                    }
                    return n.join("");
                };
                e.exports = function(e) {
                    var t, o, i = [], a = e.toLowerCase().replace(r, ".").split(".");
                    for(t = 0; t < a.length; t++)o = a[t], i.push(n.test(o) ? "xn--" + c(o) : o);
                    return i.join(".");
                };
            },
            2941: function(e, t, n) {
                var r, o, i, a = n(1899), u = n(5981), s = n(6843), c = n(5463), f = n(1333), l = n(2749), p = n(6049), h = a.location, d = a.setImmediate, v = a.clearImmediate, g = a.process, y = a.MessageChannel, m = a.Dispatch, b = 0, k = {}, w = function(e) {
                    if (k.hasOwnProperty(e)) {
                        var t = k[e];
                        delete k[e], t();
                    }
                }, x = function(e) {
                    return function() {
                        w(e);
                    };
                }, S = function(e) {
                    w(e.data);
                }, T = function(e) {
                    a.postMessage(e + "", h.protocol + "//" + h.host);
                };
                d && v || (d = function(e) {
                    for(var t = [], n = 1; arguments.length > n;)t.push(arguments[n++]);
                    return k[++b] = function() {
                        ("function" == typeof e ? e : Function(e)).apply(void 0, t);
                    }, r(b), b;
                }, v = function(e) {
                    delete k[e];
                }, p ? r = function(e) {
                    g.nextTick(x(e));
                } : m && m.now ? r = function(e) {
                    m.now(x(e));
                } : y && !l ? (i = (o = new y).port2, o.port1.onmessage = S, r = s(i.postMessage, i, 1)) : a.addEventListener && "function" == typeof postMessage && !a.importScripts && h && "file:" !== h.protocol && !u(T) ? (r = T, a.addEventListener("message", S, !1)) : r = "onreadystatechange" in f("script") ? function(e) {
                    c.appendChild(f("script")).onreadystatechange = function() {
                        c.removeChild(this), w(e);
                    };
                } : function(e) {
                    setTimeout(x(e), 0);
                }), e.exports = {
                    set: d,
                    clear: v
                };
            },
            9413: function(e, t, n) {
                var r = n(8459), o = Math.max, i = Math.min;
                e.exports = function(e, t) {
                    var n = r(e);
                    return n < 0 ? o(n + t, 0) : i(n, t);
                };
            },
            4529: function(e, t, n) {
                var r = n(7026), o = n(8219);
                e.exports = function(e) {
                    return r(o(e));
                };
            },
            8459: function(e) {
                var t = Math.ceil, n = Math.floor;
                e.exports = function(e) {
                    return isNaN(e = +e) ? 0 : (e > 0 ? n : t)(e);
                };
            },
            3057: function(e, t, n) {
                var r = n(8459), o = Math.min;
                e.exports = function(e) {
                    return e > 0 ? o(r(e), 9007199254740991) : 0;
                };
            },
            9678: function(e, t, n) {
                var r = n(8219);
                e.exports = function(e) {
                    return Object(r(e));
                };
            },
            6935: function(e, t, n) {
                var r = n(941);
                e.exports = function(e, t) {
                    if (!r(e)) return e;
                    var n, o;
                    if (t && "function" == typeof (n = e.toString) && !r(o = n.call(e))) return o;
                    if ("function" == typeof (n = e.valueOf) && !r(o = n.call(e))) return o;
                    if (!t && "function" == typeof (n = e.toString) && !r(o = n.call(e))) return o;
                    throw TypeError("Can't convert object to primitive value");
                };
            },
            2885: function(e, t, n) {
                var r = {};
                r[n(9813)("toStringTag")] = "z", e.exports = "[object z]" === String(r);
            },
            9418: function(e) {
                var t = 0, n = Math.random();
                e.exports = function(e) {
                    return "Symbol(" + String(void 0 === e ? "" : e) + ")_" + (++t + n).toString(36);
                };
            },
            2302: function(e, t, n) {
                var r = n(2497);
                e.exports = r && !Symbol.sham && "symbol" == typeof Symbol.iterator;
            },
            1477: function(e, t, n) {
                var r = n(9813);
                t.f = r;
            },
            9813: function(e, t, n) {
                var r = n(1899), o = n(8726), i = n(7457), a = n(9418), u = n(2497), s = n(2302), c = o("wks"), f = r.Symbol, l = s ? f : f && f.withoutSetter || a;
                e.exports = function(e) {
                    return i(c, e) && (u || "string" == typeof c[e]) || (u && i(f, e) ? c[e] = f[e] : c[e] = l("Symbol." + e)), c[e];
                };
            },
            7627: function(e, t, n) {
                "use strict";
                var r = n(6887), o = n(249), i = n(8929), a = n(9290), u = n(2029), s = n(1887), c = n(3091), f = function(e, t) {
                    var n = this;
                    if (!(n instanceof f)) return new f(e, t);
                    i && (n = i(new Error(void 0), o(n))), void 0 !== t && u(n, "message", String(t));
                    var r = [];
                    return c(e, r.push, {
                        that: r
                    }), u(n, "errors", r), n;
                };
                f.prototype = a(Error.prototype, {
                    constructor: s(5, f),
                    message: s(5, ""),
                    name: s(5, "AggregateError")
                }), r({
                    global: !0
                }, {
                    AggregateError: f
                });
            },
            5906: function(e, t, n) {
                "use strict";
                var r = n(6887), o = n(5981), i = n(1052), a = n(941), u = n(9678), s = n(3057), c = n(5449), f = n(4692), l = n(568), p = n(9813), h = n(3385), d = p("isConcatSpreadable"), v = 9007199254740991, g = "Maximum allowed index exceeded", y = h >= 51 || !o(function() {
                    var e = [];
                    return e[d] = !1, e.concat()[0] !== e;
                }), m = l("concat"), b = function(e) {
                    if (!a(e)) return !1;
                    var t = e[d];
                    return void 0 !== t ? !!t : i(e);
                };
                r({
                    target: "Array",
                    proto: !0,
                    forced: !y || !m
                }, {
                    concat: function(e) {
                        var t, n, r, o, i, a = u(this), l = f(a, 0), p = 0;
                        for(t = -1, r = arguments.length; t < r; t++)if (b(i = -1 === t ? a : arguments[t])) {
                            if (p + (o = s(i.length)) > v) throw TypeError(g);
                            for(n = 0; n < o; n++, p++)n in i && c(l, p, i[n]);
                        } else {
                            if (p >= v) throw TypeError(g);
                            c(l, p++, i);
                        }
                        return l.length = p, l;
                    }
                });
            },
            1501: function(e, t, n) {
                "use strict";
                var r = n(6887), o = n(3610).filter;
                r({
                    target: "Array",
                    proto: !0,
                    forced: !n(568)("filter")
                }, {
                    filter: function(e) {
                        return o(this, e, arguments.length > 1 ? arguments[1] : void 0);
                    }
                });
            },
            833: function(e, t, n) {
                "use strict";
                var r = n(6887), o = n(3610).find, i = n(8479), a = "find", u = !0;
                a in [] && Array(1).find(function() {
                    u = !1;
                }), r({
                    target: "Array",
                    proto: !0,
                    forced: u
                }, {
                    find: function(e) {
                        return o(this, e, arguments.length > 1 ? arguments[1] : void 0);
                    }
                }), i(a);
            },
            2437: function(e, t, n) {
                "use strict";
                var r = n(6887), o = n(6837);
                r({
                    target: "Array",
                    proto: !0,
                    forced: [].forEach != o
                }, {
                    forEach: o
                });
            },
            3242: function(e, t, n) {
                var r = n(6887), o = n(1354);
                r({
                    target: "Array",
                    stat: !0,
                    forced: !n(1385)(function(e) {
                        Array.from(e);
                    })
                }, {
                    from: o
                });
            },
            9076: function(e, t, n) {
                "use strict";
                var r = n(6887), o = n(1692).indexOf, i = n(4194), a = [].indexOf, u = !!a && 1 / [
                    1
                ].indexOf(1, -0) < 0, s = i("indexOf");
                r({
                    target: "Array",
                    proto: !0,
                    forced: u || !s
                }, {
                    indexOf: function(e) {
                        return u ? a.apply(this, arguments) || 0 : o(this, e, arguments.length > 1 ? arguments[1] : void 0);
                    }
                });
            },
            2737: function(e, t, n) {
                n(6887)({
                    target: "Array",
                    stat: !0
                }, {
                    isArray: n(1052)
                });
            },
            6274: function(e, t, n) {
                "use strict";
                var r = n(4529), o = n(8479), i = n(2077), a = n(5402), u = n(7771), s = "Array Iterator", c = a.set, f = a.getterFor(s);
                e.exports = u(Array, "Array", function(e, t) {
                    c(this, {
                        type: s,
                        target: r(e),
                        index: 0,
                        kind: t
                    });
                }, function() {
                    var e = f(this), t = e.target, n = e.kind, r = e.index++;
                    return !t || r >= t.length ? (e.target = void 0, {
                        value: void 0,
                        done: !0
                    }) : "keys" == n ? {
                        value: r,
                        done: !1
                    } : "values" == n ? {
                        value: t[r],
                        done: !1
                    } : {
                        value: [
                            r,
                            t[r]
                        ],
                        done: !1
                    };
                }, "values"), i.Arguments = i.Array, o("keys"), o("values"), o("entries");
            },
            8787: function(e, t, n) {
                "use strict";
                var r = n(6887), o = n(3610).map;
                r({
                    target: "Array",
                    proto: !0,
                    forced: !n(568)("map")
                }, {
                    map: function(e) {
                        return o(this, e, arguments.length > 1 ? arguments[1] : void 0);
                    }
                });
            },
            186: function(e, t, n) {
                "use strict";
                var r = n(6887), o = n(941), i = n(1052), a = n(9413), u = n(3057), s = n(4529), c = n(5449), f = n(9813), l = n(568)("slice"), p = f("species"), h = [].slice, d = Math.max;
                r({
                    target: "Array",
                    proto: !0,
                    forced: !l
                }, {
                    slice: function(e, t) {
                        var n, r, f, l = s(this), v = u(l.length), g = a(e, v), y = a(void 0 === t ? v : t, v);
                        if (i(l) && ("function" != typeof (n = l.constructor) || n !== Array && !i(n.prototype) ? o(n) && null === (n = n[p]) && (n = void 0) : n = void 0, n === Array || void 0 === n)) return h.call(l, g, y);
                        for(r = new (void 0 === n ? Array : n)(d(y - g, 0)), f = 0; g < y; g++, f++)g in l && c(r, f, l[g]);
                        return r.length = f, r;
                    }
                });
            },
            2619: function(e, t, n) {
                var r = n(6887), o = n(626), i = n(5981), a = o("JSON", "stringify"), u = /[\uD800-\uDFFF]/g, s = /^[\uD800-\uDBFF]$/, c = /^[\uDC00-\uDFFF]$/, f = function(e, t, n) {
                    var r = n.charAt(t - 1), o = n.charAt(t + 1);
                    return s.test(e) && !c.test(o) || c.test(e) && !s.test(r) ? "\\u" + e.charCodeAt(0).toString(16) : e;
                }, l = i(function() {
                    return '"\udf06\ud834"' !== a("\udf06\ud834") || '"\udead"' !== a("\udead");
                });
                a && r({
                    target: "JSON",
                    stat: !0,
                    forced: l
                }, {
                    stringify: function(e, t, n) {
                        var r = a.apply(null, arguments);
                        return "string" == typeof r ? r.replace(u, f) : r;
                    }
                });
            },
            9120: function(e, t, n) {
                var r = n(1899);
                n(904)(r.JSON, "JSON", !0);
            },
            5327: function() {},
            4979: function(e, t, n) {
                var r = n(6887), o = n(5746);
                r({
                    target: "Object",
                    stat: !0,
                    forced: !o,
                    sham: !o
                }, {
                    defineProperties: n(9938)
                });
            },
            6450: function(e, t, n) {
                var r = n(6887), o = n(5746);
                r({
                    target: "Object",
                    stat: !0,
                    forced: !o,
                    sham: !o
                }, {
                    defineProperty: n(5988).f
                });
            },
            1078: function(e, t, n) {
                var r = n(6887), o = n(8810).entries;
                r({
                    target: "Object",
                    stat: !0
                }, {
                    entries: function(e) {
                        return o(e);
                    }
                });
            },
            8387: function(e, t, n) {
                var r = n(6887), o = n(3091), i = n(5449);
                r({
                    target: "Object",
                    stat: !0
                }, {
                    fromEntries: function(e) {
                        var t = {};
                        return o(e, function(e, n) {
                            i(t, e, n);
                        }, {
                            AS_ENTRIES: !0
                        }), t;
                    }
                });
            },
            6924: function(e, t, n) {
                var r = n(6887), o = n(5981), i = n(4529), a = n(9677).f, u = n(5746), s = o(function() {
                    a(1);
                });
                r({
                    target: "Object",
                    stat: !0,
                    forced: !u || s,
                    sham: !u
                }, {
                    getOwnPropertyDescriptor: function(e, t) {
                        return a(i(e), t);
                    }
                });
            },
            8482: function(e, t, n) {
                var r = n(6887), o = n(5746), i = n(1136), a = n(4529), u = n(9677), s = n(5449);
                r({
                    target: "Object",
                    stat: !0,
                    sham: !o
                }, {
                    getOwnPropertyDescriptors: function(e) {
                        for(var t, n, r = a(e), o = u.f, c = i(r), f = {}, l = 0; c.length > l;)void 0 !== (n = o(r, t = c[l++])) && s(f, t, n);
                        return f;
                    }
                });
            },
            1724: function(e, t, n) {
                var r = n(6887), o = n(9678), i = n(4771);
                r({
                    target: "Object",
                    stat: !0,
                    forced: n(5981)(function() {
                        i(1);
                    })
                }, {
                    keys: function(e) {
                        return i(o(e));
                    }
                });
            },
            5967: function() {},
            4560: function(e, t, n) {
                "use strict";
                var r = n(6887), o = n(3916), i = n(9520), a = n(2), u = n(3091);
                r({
                    target: "Promise",
                    stat: !0
                }, {
                    allSettled: function(e) {
                        var t = this, n = i.f(t), r = n.resolve, s = n.reject, c = a(function() {
                            var n = o(t.resolve), i = [], a = 0, s = 1;
                            u(e, function(e) {
                                var o = a++, u = !1;
                                i.push(void 0), s++, n.call(t, e).then(function(e) {
                                    u || (u = !0, i[o] = {
                                        status: "fulfilled",
                                        value: e
                                    }, --s || r(i));
                                }, function(e) {
                                    u || (u = !0, i[o] = {
                                        status: "rejected",
                                        reason: e
                                    }, --s || r(i));
                                });
                            }), --s || r(i);
                        });
                        return c.error && s(c.value), n.promise;
                    }
                });
            },
            7206: function(e, t, n) {
                "use strict";
                var r = n(6887), o = n(3916), i = n(626), a = n(9520), u = n(2), s = n(3091), c = "No one promise resolved";
                r({
                    target: "Promise",
                    stat: !0
                }, {
                    any: function(e) {
                        var t = this, n = a.f(t), r = n.resolve, f = n.reject, l = u(function() {
                            var n = o(t.resolve), a = [], u = 0, l = 1, p = !1;
                            s(e, function(e) {
                                var o = u++, s = !1;
                                a.push(void 0), l++, n.call(t, e).then(function(e) {
                                    s || p || (p = !0, r(e));
                                }, function(e) {
                                    s || p || (s = !0, a[o] = e, --l || f(new (i("AggregateError"))(a, c)));
                                });
                            }), --l || f(new (i("AggregateError"))(a, c));
                        });
                        return l.error && f(l.value), n.promise;
                    }
                });
            },
            4349: function(e, t, n) {
                "use strict";
                var r = n(6887), o = n(2529), i = n(9297), a = n(5981), u = n(626), s = n(487), c = n(6584), f = n(1341);
                if (r({
                    target: "Promise",
                    proto: !0,
                    real: !0,
                    forced: !!i && a(function() {
                        i.prototype.finally.call({
                            then: function() {}
                        }, function() {});
                    })
                }, {
                    finally: function(e) {
                        var t = s(this, u("Promise")), n = "function" == typeof e;
                        return this.then(n ? function(n) {
                            return c(t, e()).then(function() {
                                return n;
                            });
                        } : e, n ? function(n) {
                            return c(t, e()).then(function() {
                                throw n;
                            });
                        } : e);
                    }
                }), !o && "function" == typeof i) {
                    var l = u("Promise").prototype.finally;
                    i.prototype.finally !== l && f(i.prototype, "finally", l, {
                        unsafe: !0
                    });
                }
            },
            8881: function(e, t, n) {
                "use strict";
                var r, o, i, a, u = n(6887), s = n(2529), c = n(1899), f = n(626), l = n(9297), p = n(1341), h = n(7524), d = n(8929), v = n(904), g = n(4431), y = n(941), m = n(3916), b = n(5743), k = n(1302), w = n(3091), x = n(1385), S = n(487), T = n(2941).set, O = n(6132), A = n(6584), E = n(4845), _ = n(9520), R = n(2), P = n(5402), j = n(7252), I = n(9813), C = n(3321), M = n(6049), U = n(3385), F = I("species"), N = "Promise", L = P.get, D = P.set, B = P.getterFor(N), q = l && l.prototype, H = l, K = q, V = c.TypeError, G = c.document, W = c.process, $ = _.f, z = $, J = !!(G && G.createEvent && c.dispatchEvent), Y = "function" == typeof PromiseRejectionEvent, X = "unhandledrejection", Q = !1, Z = j(N, function() {
                    var e = k(H) !== String(H);
                    if (!e && 66 === U) return !0;
                    if (s && !K.finally) return !0;
                    if (U >= 51 && /native code/.test(H)) return !1;
                    var t = new H(function(e) {
                        e(1);
                    }), n = function(e) {
                        e(function() {}, function() {});
                    };
                    return (t.constructor = {})[F] = n, !(Q = t.then(function() {}) instanceof n) || !e && C && !Y;
                }), ee = Z || !x(function(e) {
                    H.all(e).catch(function() {});
                }), te = function(e) {
                    var t;
                    return !(!y(e) || "function" != typeof (t = e.then)) && t;
                }, ne = function(e, t) {
                    if (!e.notified) {
                        e.notified = !0;
                        var n = e.reactions;
                        O(function() {
                            for(var r = e.value, o = 1 == e.state, i = 0; n.length > i;){
                                var a, u, s, c = n[i++], f = o ? c.ok : c.fail, l = c.resolve, p = c.reject, h = c.domain;
                                try {
                                    f ? (o || (2 === e.rejection && ae(e), e.rejection = 1), !0 === f ? a = r : (h && h.enter(), a = f(r), h && (h.exit(), s = !0)), a === c.promise ? p(V("Promise-chain cycle")) : (u = te(a)) ? u.call(a, l, p) : l(a)) : p(r);
                                } catch (e) {
                                    h && !s && h.exit(), p(e);
                                }
                            }
                            e.reactions = [], e.notified = !1, t && !e.rejection && oe(e);
                        });
                    }
                }, re = function(e, t, n) {
                    var r, o;
                    J ? ((r = G.createEvent("Event")).promise = t, r.reason = n, r.initEvent(e, !1, !0), c.dispatchEvent(r)) : r = {
                        promise: t,
                        reason: n
                    }, !Y && (o = c["on" + e]) ? o(r) : e === X && E("Unhandled promise rejection", n);
                }, oe = function(e) {
                    T.call(c, function() {
                        var t, n = e.facade, r = e.value;
                        if (ie(e) && (t = R(function() {
                            M ? W.emit("unhandledRejection", r, n) : re(X, n, r);
                        }), e.rejection = M || ie(e) ? 2 : 1, t.error)) throw t.value;
                    });
                }, ie = function(e) {
                    return 1 !== e.rejection && !e.parent;
                }, ae = function(e) {
                    T.call(c, function() {
                        var t = e.facade;
                        M ? W.emit("rejectionHandled", t) : re("rejectionhandled", t, e.value);
                    });
                }, ue = function(e, t, n) {
                    return function(r) {
                        e(t, r, n);
                    };
                }, se = function(e, t, n) {
                    e.done || (e.done = !0, n && (e = n), e.value = t, e.state = 2, ne(e, !0));
                }, ce = function(e, t, n) {
                    if (!e.done) {
                        e.done = !0, n && (e = n);
                        try {
                            if (e.facade === t) throw V("Promise can't be resolved itself");
                            var r = te(t);
                            r ? O(function() {
                                var n = {
                                    done: !1
                                };
                                try {
                                    r.call(t, ue(ce, n, e), ue(se, n, e));
                                } catch (t) {
                                    se(n, t, e);
                                }
                            }) : (e.value = t, e.state = 1, ne(e, !1));
                        } catch (t) {
                            se({
                                done: !1
                            }, t, e);
                        }
                    }
                };
                if (Z && (K = (H = function(e) {
                    b(this, H, N), m(e), r.call(this);
                    var t = L(this);
                    try {
                        e(ue(ce, t), ue(se, t));
                    } catch (e) {
                        se(t, e);
                    }
                }).prototype, (r = function(e) {
                    D(this, {
                        type: N,
                        done: !1,
                        notified: !1,
                        parent: !1,
                        reactions: [],
                        rejection: !1,
                        state: 0,
                        value: void 0
                    });
                }).prototype = h(K, {
                    then: function(e, t) {
                        var n = B(this), r = $(S(this, H));
                        return r.ok = "function" != typeof e || e, r.fail = "function" == typeof t && t, r.domain = M ? W.domain : void 0, n.parent = !0, n.reactions.push(r), 0 != n.state && ne(n, !1), r.promise;
                    },
                    catch: function(e) {
                        return this.then(void 0, e);
                    }
                }), o = function() {
                    var e = new r, t = L(e);
                    this.promise = e, this.resolve = ue(ce, t), this.reject = ue(se, t);
                }, _.f = $ = function(e) {
                    return e === H || e === i ? new o(e) : z(e);
                }, !s && "function" == typeof l && q !== Object.prototype)) {
                    a = q.then, Q || (p(q, "then", function(e, t) {
                        var n = this;
                        return new H(function(e, t) {
                            a.call(n, e, t);
                        }).then(e, t);
                    }, {
                        unsafe: !0
                    }), p(q, "catch", K.catch, {
                        unsafe: !0
                    }));
                    try {
                        delete q.constructor;
                    } catch (e) {}
                    d && d(q, K);
                }
                u({
                    global: !0,
                    wrap: !0,
                    forced: Z
                }, {
                    Promise: H
                }), v(H, N, !1, !0), g(N), i = f(N), u({
                    target: N,
                    stat: !0,
                    forced: Z
                }, {
                    reject: function(e) {
                        var t = $(this);
                        return t.reject.call(void 0, e), t.promise;
                    }
                }), u({
                    target: N,
                    stat: !0,
                    forced: s || Z
                }, {
                    resolve: function(e) {
                        return A(s && this === i ? H : this, e);
                    }
                }), u({
                    target: N,
                    stat: !0,
                    forced: ee
                }, {
                    all: function(e) {
                        var t = this, n = $(t), r = n.resolve, o = n.reject, i = R(function() {
                            var n = m(t.resolve), i = [], a = 0, u = 1;
                            w(e, function(e) {
                                var s = a++, c = !1;
                                i.push(void 0), u++, n.call(t, e).then(function(e) {
                                    c || (c = !0, i[s] = e, --u || r(i));
                                }, o);
                            }), --u || r(i);
                        });
                        return i.error && o(i.value), n.promise;
                    },
                    race: function(e) {
                        var t = this, n = $(t), r = n.reject, o = R(function() {
                            var o = m(t.resolve);
                            w(e, function(e) {
                                o.call(t, e).then(n.resolve, r);
                            });
                        });
                        return o.error && r(o.value), n.promise;
                    }
                });
            },
            1502: function() {},
            7971: function(e, t, n) {
                "use strict";
                var r = n(4620).charAt, o = n(5402), i = n(7771), a = "String Iterator", u = o.set, s = o.getterFor(a);
                i(String, "String", function(e) {
                    u(this, {
                        type: a,
                        string: String(e),
                        index: 0
                    });
                }, function() {
                    var e, t = s(this), n = t.string, o = t.index;
                    return o >= n.length ? {
                        value: void 0,
                        done: !0
                    } : (e = r(n, o), t.index += e.length, {
                        value: e,
                        done: !1
                    });
                });
            },
            8555: function(e, t, n) {
                n(6349)("asyncIterator");
            },
            2615: function() {},
            1732: function(e, t, n) {
                n(6349)("hasInstance");
            },
            5903: function(e, t, n) {
                n(6349)("isConcatSpreadable");
            },
            1825: function(e, t, n) {
                n(6349)("iterator");
            },
            5824: function(e, t, n) {
                "use strict";
                var r = n(6887), o = n(1899), i = n(626), a = n(2529), u = n(5746), s = n(2497), c = n(2302), f = n(5981), l = n(7457), p = n(1052), h = n(941), d = n(6059), v = n(9678), g = n(4529), y = n(6935), m = n(1887), b = n(9290), k = n(4771), w = n(946), x = n(684), S = n(7857), T = n(9677), O = n(5988), A = n(8838), E = n(2029), _ = n(1341), R = n(8726), P = n(4262), j = n(7748), I = n(9418), C = n(9813), M = n(1477), U = n(6349), F = n(904), N = n(5402), L = n(3610).forEach, D = P("hidden"), B = "Symbol", q = C("toPrimitive"), H = N.set, K = N.getterFor(B), V = Object.prototype, G = o.Symbol, W = i("JSON", "stringify"), $ = T.f, z = O.f, J = x.f, Y = A.f, X = R("symbols"), Q = R("op-symbols"), Z = R("string-to-symbol-registry"), ee = R("symbol-to-string-registry"), te = R("wks"), ne = o.QObject, re = !ne || !ne.prototype || !ne.prototype.findChild, oe = u && f(function() {
                    return 7 != b(z({}, "a", {
                        get: function() {
                            return z(this, "a", {
                                value: 7
                            }).a;
                        }
                    })).a;
                }) ? function(e, t, n) {
                    var r = $(V, t);
                    r && delete V[t], z(e, t, n), r && e !== V && z(V, t, r);
                } : z, ie = function(e, t) {
                    var n = X[e] = b(G.prototype);
                    return H(n, {
                        type: B,
                        tag: e,
                        description: t
                    }), u || (n.description = t), n;
                }, ae = c ? function(e) {
                    return "symbol" == typeof e;
                } : function(e) {
                    return Object(e) instanceof G;
                }, ue = function(e, t, n) {
                    e === V && ue(Q, t, n), d(e);
                    var r = y(t, !0);
                    return d(n), l(X, r) ? (n.enumerable ? (l(e, D) && e[D][r] && (e[D][r] = !1), n = b(n, {
                        enumerable: m(0, !1)
                    })) : (l(e, D) || z(e, D, m(1, {})), e[D][r] = !0), oe(e, r, n)) : z(e, r, n);
                }, se = function(e, t) {
                    d(e);
                    var n = g(t), r = k(n).concat(pe(n));
                    return L(r, function(t) {
                        u && !ce.call(n, t) || ue(e, t, n[t]);
                    }), e;
                }, ce = function(e) {
                    var t = y(e, !0), n = Y.call(this, t);
                    return !(this === V && l(X, t) && !l(Q, t)) && (!(n || !l(this, t) || !l(X, t) || l(this, D) && this[D][t]) || n);
                }, fe = function(e, t) {
                    var n = g(e), r = y(t, !0);
                    if (n !== V || !l(X, r) || l(Q, r)) {
                        var o = $(n, r);
                        return !o || !l(X, r) || l(n, D) && n[D][r] || (o.enumerable = !0), o;
                    }
                }, le = function(e) {
                    var t = J(g(e)), n = [];
                    return L(t, function(e) {
                        l(X, e) || l(j, e) || n.push(e);
                    }), n;
                }, pe = function(e) {
                    var t = e === V, n = J(t ? Q : g(e)), r = [];
                    return L(n, function(e) {
                        !l(X, e) || t && !l(V, e) || r.push(X[e]);
                    }), r;
                };
                s || (G = function() {
                    if (this instanceof G) throw TypeError("Symbol is not a constructor");
                    var e = arguments.length && void 0 !== arguments[0] ? String(arguments[0]) : void 0, t = I(e), n = function(e) {
                        this === V && n.call(Q, e), l(this, D) && l(this[D], t) && (this[D][t] = !1), oe(this, t, m(1, e));
                    };
                    return u && re && oe(V, t, {
                        configurable: !0,
                        set: n
                    }), ie(t, e);
                }, _(G.prototype, "toString", function() {
                    return K(this).tag;
                }), _(G, "withoutSetter", function(e) {
                    return ie(I(e), e);
                }), A.f = ce, O.f = ue, T.f = fe, w.f = x.f = le, S.f = pe, M.f = function(e) {
                    return ie(C(e), e);
                }, u && (z(G.prototype, "description", {
                    configurable: !0,
                    get: function() {
                        return K(this).description;
                    }
                }), a || _(V, "propertyIsEnumerable", ce, {
                    unsafe: !0
                }))), r({
                    global: !0,
                    wrap: !0,
                    forced: !s,
                    sham: !s
                }, {
                    Symbol: G
                }), L(k(te), function(e) {
                    U(e);
                }), r({
                    target: B,
                    stat: !0,
                    forced: !s
                }, {
                    for: function(e) {
                        var t = String(e);
                        if (l(Z, t)) return Z[t];
                        var n = G(t);
                        return Z[t] = n, ee[n] = t, n;
                    },
                    keyFor: function(e) {
                        if (!ae(e)) throw TypeError(e + " is not a symbol");
                        if (l(ee, e)) return ee[e];
                    },
                    useSetter: function() {
                        re = !0;
                    },
                    useSimple: function() {
                        re = !1;
                    }
                }), r({
                    target: "Object",
                    stat: !0,
                    forced: !s,
                    sham: !u
                }, {
                    create: function(e, t) {
                        return void 0 === t ? b(e) : se(b(e), t);
                    },
                    defineProperty: ue,
                    defineProperties: se,
                    getOwnPropertyDescriptor: fe
                }), r({
                    target: "Object",
                    stat: !0,
                    forced: !s
                }, {
                    getOwnPropertyNames: le,
                    getOwnPropertySymbols: pe
                }), r({
                    target: "Object",
                    stat: !0,
                    forced: f(function() {
                        S.f(1);
                    })
                }, {
                    getOwnPropertySymbols: function(e) {
                        return S.f(v(e));
                    }
                }), W && r({
                    target: "JSON",
                    stat: !0,
                    forced: !s || f(function() {
                        var e = G();
                        return "[null]" != W([
                            e
                        ]) || "{}" != W({
                            a: e
                        }) || "{}" != W(Object(e));
                    })
                }, {
                    stringify: function(e, t, n) {
                        for(var r, o = [
                            e
                        ], i = 1; arguments.length > i;)o.push(arguments[i++]);
                        if (r = t, (h(t) || void 0 !== e) && !ae(e)) return p(t) || (t = function(e, t) {
                            if ("function" == typeof r && (t = r.call(this, e, t)), !ae(t)) return t;
                        }), o[1] = t, W.apply(null, o);
                    }
                }), G.prototype[q] || E(G.prototype, q, G.prototype.valueOf), F(G, B), j[D] = !0;
            },
            5915: function(e, t, n) {
                n(6349)("matchAll");
            },
            8394: function(e, t, n) {
                n(6349)("match");
            },
            1766: function(e, t, n) {
                n(6349)("replace");
            },
            9791: function(e, t, n) {
                n(6349)("search");
            },
            9911: function(e, t, n) {
                n(6349)("species");
            },
            4315: function(e, t, n) {
                n(6349)("split");
            },
            3131: function(e, t, n) {
                n(6349)("toPrimitive");
            },
            4714: function(e, t, n) {
                n(6349)("toStringTag");
            },
            659: function(e, t, n) {
                n(6349)("unscopables");
            },
            9731: function(e, t, n) {
                n(7627);
            },
            5708: function(e, t, n) {
                n(4560);
            },
            8731: function(e, t, n) {
                n(7206);
            },
            14: function(e, t, n) {
                "use strict";
                var r = n(6887), o = n(9520), i = n(2);
                r({
                    target: "Promise",
                    stat: !0
                }, {
                    try: function(e) {
                        var t = o.f(this), n = i(e);
                        return (n.error ? t.reject : t.resolve)(n.value), t.promise;
                    }
                });
            },
            8783: function(e, t, n) {
                n(6349)("asyncDispose");
            },
            3975: function(e, t, n) {
                n(6349)("dispose");
            },
            5799: function(e, t, n) {
                n(6349)("matcher");
            },
            5414: function(e, t, n) {
                n(6349)("metadata");
            },
            6774: function(e, t, n) {
                n(6349)("observable");
            },
            620: function(e, t, n) {
                n(6349)("patternMatch");
            },
            6172: function(e, t, n) {
                n(6349)("replaceAll");
            },
            7634: function(e, t, n) {
                n(6274);
                var r = n(3281), o = n(1899), i = n(9697), a = n(2029), u = n(2077), s = n(9813)("toStringTag");
                for(var c in r){
                    var f = o[c], l = f && f.prototype;
                    l && i(l) !== s && a(l, s, c), u[c] = u.Array;
                }
            },
            5304: function(e, t, n) {
                "use strict";
                n(6274);
                var r = n(6887), o = n(626), i = n(8468), a = n(1341), u = n(7524), s = n(904), c = n(1046), f = n(5402), l = n(5743), p = n(7457), h = n(6843), d = n(9697), v = n(6059), g = n(941), y = n(9290), m = n(1887), b = n(429), k = n(2902), w = n(9813), x = o("fetch"), S = o("Headers"), T = w("iterator"), O = "URLSearchParams", A = "URLSearchParamsIterator", E = f.set, _ = f.getterFor(O), R = f.getterFor(A), P = /\+/g, j = Array(4), I = function(e) {
                    return j[e - 1] || (j[e - 1] = RegExp("((?:%[\\da-f]{2}){" + e + "})", "gi"));
                }, C = function(e) {
                    try {
                        return decodeURIComponent(e);
                    } catch (t) {
                        return e;
                    }
                }, M = function(e) {
                    var t = e.replace(P, " "), n = 4;
                    try {
                        return decodeURIComponent(t);
                    } catch (e) {
                        for(; n;)t = t.replace(I(n--), C);
                        return t;
                    }
                }, U = /[!'()~]|%20/g, F = {
                    "!": "%21",
                    "'": "%27",
                    "(": "%28",
                    ")": "%29",
                    "~": "%7E",
                    "%20": "+"
                }, N = function(e) {
                    return F[e];
                }, L = function(e) {
                    return encodeURIComponent(e).replace(U, N);
                }, D = function(e, t) {
                    if (t) for(var n, r, o = t.split("&"), i = 0; i < o.length;)(n = o[i++]).length && (r = n.split("="), e.push({
                        key: M(r.shift()),
                        value: M(r.join("="))
                    }));
                }, B = function(e) {
                    this.entries.length = 0, D(this.entries, e);
                }, q = function(e, t) {
                    if (e < t) throw TypeError("Not enough arguments");
                }, H = c(function(e, t) {
                    E(this, {
                        type: A,
                        iterator: b(_(e).entries),
                        kind: t
                    });
                }, "Iterator", function() {
                    var e = R(this), t = e.kind, n = e.iterator.next(), r = n.value;
                    return n.done || (n.value = "keys" === t ? r.key : "values" === t ? r.value : [
                        r.key,
                        r.value
                    ]), n;
                }), K = function() {
                    l(this, K, O);
                    var e, t, n, r, o, i, a, u, s, c = arguments.length > 0 ? arguments[0] : void 0, f = this, h = [];
                    if (E(f, {
                        type: O,
                        entries: h,
                        updateURL: function() {},
                        updateSearchParams: B
                    }), void 0 !== c) {
                        if (g(c)) {
                            if ("function" == typeof (e = k(c))) for(n = (t = e.call(c)).next; !(r = n.call(t)).done;){
                                if ((a = (i = (o = b(v(r.value))).next).call(o)).done || (u = i.call(o)).done || !i.call(o).done) throw TypeError("Expected sequence with length 2");
                                h.push({
                                    key: a.value + "",
                                    value: u.value + ""
                                });
                            }
                            else for(s in c)p(c, s) && h.push({
                                key: s,
                                value: c[s] + ""
                            });
                        } else D(h, "string" == typeof c ? "?" === c.charAt(0) ? c.slice(1) : c : c + "");
                    }
                }, V = K.prototype;
                u(V, {
                    append: function(e, t) {
                        q(arguments.length, 2);
                        var n = _(this);
                        n.entries.push({
                            key: e + "",
                            value: t + ""
                        }), n.updateURL();
                    },
                    delete: function(e) {
                        q(arguments.length, 1);
                        for(var t = _(this), n = t.entries, r = e + "", o = 0; o < n.length;)n[o].key === r ? n.splice(o, 1) : o++;
                        t.updateURL();
                    },
                    get: function(e) {
                        q(arguments.length, 1);
                        for(var t = _(this).entries, n = e + "", r = 0; r < t.length; r++)if (t[r].key === n) return t[r].value;
                        return null;
                    },
                    getAll: function(e) {
                        q(arguments.length, 1);
                        for(var t = _(this).entries, n = e + "", r = [], o = 0; o < t.length; o++)t[o].key === n && r.push(t[o].value);
                        return r;
                    },
                    has: function(e) {
                        q(arguments.length, 1);
                        for(var t = _(this).entries, n = e + "", r = 0; r < t.length;)if (t[r++].key === n) return !0;
                        return !1;
                    },
                    set: function(e, t) {
                        q(arguments.length, 1);
                        for(var n, r = _(this), o = r.entries, i = !1, a = e + "", u = t + "", s = 0; s < o.length; s++)(n = o[s]).key === a && (i ? o.splice(s--, 1) : (i = !0, n.value = u));
                        i || o.push({
                            key: a,
                            value: u
                        }), r.updateURL();
                    },
                    sort: function() {
                        var e, t, n, r = _(this), o = r.entries, i = o.slice();
                        for(o.length = 0, n = 0; n < i.length; n++){
                            for(e = i[n], t = 0; t < n; t++)if (o[t].key > e.key) {
                                o.splice(t, 0, e);
                                break;
                            }
                            t === n && o.push(e);
                        }
                        r.updateURL();
                    },
                    forEach: function(e) {
                        for(var t, n = _(this).entries, r = h(e, arguments.length > 1 ? arguments[1] : void 0, 3), o = 0; o < n.length;)r((t = n[o++]).value, t.key, this);
                    },
                    keys: function() {
                        return new H(this, "keys");
                    },
                    values: function() {
                        return new H(this, "values");
                    },
                    entries: function() {
                        return new H(this, "entries");
                    }
                }, {
                    enumerable: !0
                }), a(V, T, V.entries), a(V, "toString", function() {
                    for(var e, t = _(this).entries, n = [], r = 0; r < t.length;)e = t[r++], n.push(L(e.key) + "=" + L(e.value));
                    return n.join("&");
                }, {
                    enumerable: !0
                }), s(K, O), r({
                    global: !0,
                    forced: !i
                }, {
                    URLSearchParams: K
                }), i || "function" != typeof x || "function" != typeof S || r({
                    global: !0,
                    enumerable: !0,
                    forced: !0
                }, {
                    fetch: function(e) {
                        var t, n, r, o = [
                            e
                        ];
                        return arguments.length > 1 && (g(t = arguments[1]) && (n = t.body, d(n) === O && ((r = t.headers ? new S(t.headers) : new S).has("content-type") || r.set("content-type", "application/x-www-form-urlencoded;charset=UTF-8"), t = y(t, {
                            body: m(0, String(n)),
                            headers: m(0, r)
                        }))), o.push(t)), x.apply(this, o);
                    }
                }), e.exports = {
                    URLSearchParams: K,
                    getState: _
                };
            },
            3601: function(e, t, n) {
                "use strict";
                n(7971);
                var r, o = n(6887), i = n(5746), a = n(8468), u = n(1899), s = n(9938), c = n(1341), f = n(5743), l = n(7457), p = n(4420), h = n(1354), d = n(4620).codeAt, v = n(3291), g = n(904), y = n(5304), m = n(5402), b = u.URL, k = y.URLSearchParams, w = y.getState, x = m.set, S = m.getterFor("URL"), T = Math.floor, O = Math.pow, A = "Invalid scheme", E = "Invalid host", _ = "Invalid port", R = /[A-Za-z]/, P = /[\d+-.A-Za-z]/, j = /\d/, I = /^0x/i, C = /^[0-7]+$/, M = /^\d+$/, U = /^[\dA-Fa-f]+$/, F = /[\0\t\n\r #%/:<>?@[\\\]^|]/, N = /[\0\t\n\r #/:<>?@[\\\]^|]/, L = /^[\u0000-\u001F ]+|[\u0000-\u001F ]+$/g, D = /[\t\n\r]/g, B = function(e, t) {
                    var n, r, o;
                    if ("[" == t.charAt(0)) {
                        if ("]" != t.charAt(t.length - 1)) return E;
                        if (!(n = H(t.slice(1, -1)))) return E;
                        e.host = n;
                    } else if (Y(e)) {
                        if (t = v(t), F.test(t)) return E;
                        if (null === (n = q(t))) return E;
                        e.host = n;
                    } else {
                        if (N.test(t)) return E;
                        for(n = "", r = h(t), o = 0; o < r.length; o++)n += z(r[o], V);
                        e.host = n;
                    }
                }, q = function(e) {
                    var t, n, r, o, i, a, u, s = e.split(".");
                    if (s.length && "" == s[s.length - 1] && s.pop(), (t = s.length) > 4) return e;
                    for(n = [], r = 0; r < t; r++){
                        if ("" == (o = s[r])) return e;
                        if (i = 10, o.length > 1 && "0" == o.charAt(0) && (i = I.test(o) ? 16 : 8, o = o.slice(8 == i ? 1 : 2)), "" === o) a = 0;
                        else {
                            if (!(10 == i ? M : 8 == i ? C : U).test(o)) return e;
                            a = parseInt(o, i);
                        }
                        n.push(a);
                    }
                    for(r = 0; r < t; r++)if (a = n[r], r == t - 1) {
                        if (a >= O(256, 5 - t)) return null;
                    } else if (a > 255) return null;
                    for(u = n.pop(), r = 0; r < n.length; r++)u += n[r] * O(256, 3 - r);
                    return u;
                }, H = function(e) {
                    var t, n, r, o, i, a, u, s = [
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0
                    ], c = 0, f = null, l = 0, p = function() {
                        return e.charAt(l);
                    };
                    if (":" == p()) {
                        if (":" != e.charAt(1)) return;
                        l += 2, f = ++c;
                    }
                    for(; p();){
                        if (8 == c) return;
                        if (":" != p()) {
                            for(t = n = 0; n < 4 && U.test(p());)t = 16 * t + parseInt(p(), 16), l++, n++;
                            if ("." == p()) {
                                if (0 == n) return;
                                if (l -= n, c > 6) return;
                                for(r = 0; p();){
                                    if (o = null, r > 0) {
                                        if (!("." == p() && r < 4)) return;
                                        l++;
                                    }
                                    if (!j.test(p())) return;
                                    for(; j.test(p());){
                                        if (i = parseInt(p(), 10), null === o) o = i;
                                        else {
                                            if (0 == o) return;
                                            o = 10 * o + i;
                                        }
                                        if (o > 255) return;
                                        l++;
                                    }
                                    s[c] = 256 * s[c] + o, 2 != ++r && 4 != r || c++;
                                }
                                if (4 != r) return;
                                break;
                            }
                            if (":" == p()) {
                                if (l++, !p()) return;
                            } else if (p()) return;
                            s[c++] = t;
                        } else {
                            if (null !== f) return;
                            l++, f = ++c;
                        }
                    }
                    if (null !== f) for(a = c - f, c = 7; 0 != c && a > 0;)u = s[c], s[c--] = s[f + a - 1], s[f + --a] = u;
                    else if (8 != c) return;
                    return s;
                }, K = function(e) {
                    var t, n, r, o;
                    if ("number" == typeof e) {
                        for(t = [], n = 0; n < 4; n++)t.unshift(e % 256), e = T(e / 256);
                        return t.join(".");
                    }
                    if ("object" == typeof e) {
                        for(t = "", r = function(e) {
                            for(var t = null, n = 1, r = null, o = 0, i = 0; i < 8; i++)0 !== e[i] ? (o > n && (t = r, n = o), r = null, o = 0) : (null === r && (r = i), ++o);
                            return o > n && (t = r, n = o), t;
                        }(e), n = 0; n < 8; n++)o && 0 === e[n] || (o && (o = !1), r === n ? (t += n ? ":" : "::", o = !0) : (t += e[n].toString(16), n < 7 && (t += ":")));
                        return "[" + t + "]";
                    }
                    return e;
                }, V = {}, G = p({}, V, {
                    " ": 1,
                    '"': 1,
                    "<": 1,
                    ">": 1,
                    "`": 1
                }), W = p({}, G, {
                    "#": 1,
                    "?": 1,
                    "{": 1,
                    "}": 1
                }), $ = p({}, W, {
                    "/": 1,
                    ":": 1,
                    ";": 1,
                    "=": 1,
                    "@": 1,
                    "[": 1,
                    "\\": 1,
                    "]": 1,
                    "^": 1,
                    "|": 1
                }), z = function(e, t) {
                    var n = d(e, 0);
                    return n > 32 && n < 127 && !l(t, e) ? e : encodeURIComponent(e);
                }, J = {
                    ftp: 21,
                    file: null,
                    http: 80,
                    https: 443,
                    ws: 80,
                    wss: 443
                }, Y = function(e) {
                    return l(J, e.scheme);
                }, X = function(e) {
                    return "" != e.username || "" != e.password;
                }, Q = function(e) {
                    return !e.host || e.cannotBeABaseURL || "file" == e.scheme;
                }, Z = function(e, t) {
                    var n;
                    return 2 == e.length && R.test(e.charAt(0)) && (":" == (n = e.charAt(1)) || !t && "|" == n);
                }, ee = function(e) {
                    var t;
                    return e.length > 1 && Z(e.slice(0, 2)) && (2 == e.length || "/" === (t = e.charAt(2)) || "\\" === t || "?" === t || "#" === t);
                }, te = function(e) {
                    var t = e.path, n = t.length;
                    !n || "file" == e.scheme && 1 == n && Z(t[0], !0) || t.pop();
                }, ne = function(e) {
                    return "." === e || "%2e" === e.toLowerCase();
                }, re = {}, oe = {}, ie = {}, ae = {}, ue = {}, se = {}, ce = {}, fe = {}, le = {}, pe = {}, he = {}, de = {}, ve = {}, ge = {}, ye = {}, me = {}, be = {}, ke = {}, we = {}, xe = {}, Se = {}, Te = function(e, t, n, o) {
                    var i, a, u, s, c, f = n || re, p = 0, d = "", v = !1, g = !1, y = !1;
                    for(n || (e.scheme = "", e.username = "", e.password = "", e.host = null, e.port = null, e.path = [], e.query = null, e.fragment = null, e.cannotBeABaseURL = !1, t = t.replace(L, "")), t = t.replace(D, ""), i = h(t); p <= i.length;){
                        switch(a = i[p], f){
                            case re:
                                if (!a || !R.test(a)) {
                                    if (n) return A;
                                    f = ie;
                                    continue;
                                }
                                d += a.toLowerCase(), f = oe;
                                break;
                            case oe:
                                if (a && (P.test(a) || "+" == a || "-" == a || "." == a)) d += a.toLowerCase();
                                else {
                                    if (":" != a) {
                                        if (n) return A;
                                        d = "", f = ie, p = 0;
                                        continue;
                                    }
                                    if (n && (Y(e) != l(J, d) || "file" == d && (X(e) || null !== e.port) || "file" == e.scheme && !e.host)) return;
                                    if (e.scheme = d, n) return void (Y(e) && J[e.scheme] == e.port && (e.port = null));
                                    d = "", "file" == e.scheme ? f = ge : Y(e) && o && o.scheme == e.scheme ? f = ae : Y(e) ? f = fe : "/" == i[p + 1] ? (f = ue, p++) : (e.cannotBeABaseURL = !0, e.path.push(""), f = we);
                                }
                                break;
                            case ie:
                                if (!o || o.cannotBeABaseURL && "#" != a) return A;
                                if (o.cannotBeABaseURL && "#" == a) {
                                    e.scheme = o.scheme, e.path = o.path.slice(), e.query = o.query, e.fragment = "", e.cannotBeABaseURL = !0, f = Se;
                                    break;
                                }
                                f = "file" == o.scheme ? ge : se;
                                continue;
                            case ae:
                                if ("/" != a || "/" != i[p + 1]) {
                                    f = se;
                                    continue;
                                }
                                f = le, p++;
                                break;
                            case ue:
                                if ("/" == a) {
                                    f = pe;
                                    break;
                                }
                                f = ke;
                                continue;
                            case se:
                                if (e.scheme = o.scheme, a == r) e.username = o.username, e.password = o.password, e.host = o.host, e.port = o.port, e.path = o.path.slice(), e.query = o.query;
                                else if ("/" == a || "\\" == a && Y(e)) f = ce;
                                else if ("?" == a) e.username = o.username, e.password = o.password, e.host = o.host, e.port = o.port, e.path = o.path.slice(), e.query = "", f = xe;
                                else {
                                    if ("#" != a) {
                                        e.username = o.username, e.password = o.password, e.host = o.host, e.port = o.port, e.path = o.path.slice(), e.path.pop(), f = ke;
                                        continue;
                                    }
                                    e.username = o.username, e.password = o.password, e.host = o.host, e.port = o.port, e.path = o.path.slice(), e.query = o.query, e.fragment = "", f = Se;
                                }
                                break;
                            case ce:
                                if (!Y(e) || "/" != a && "\\" != a) {
                                    if ("/" != a) {
                                        e.username = o.username, e.password = o.password, e.host = o.host, e.port = o.port, f = ke;
                                        continue;
                                    }
                                    f = pe;
                                } else f = le;
                                break;
                            case fe:
                                if (f = le, "/" != a || "/" != d.charAt(p + 1)) continue;
                                p++;
                                break;
                            case le:
                                if ("/" != a && "\\" != a) {
                                    f = pe;
                                    continue;
                                }
                                break;
                            case pe:
                                if ("@" == a) {
                                    v && (d = "%40" + d), v = !0, u = h(d);
                                    for(var m = 0; m < u.length; m++){
                                        var b = u[m];
                                        if (":" != b || y) {
                                            var k = z(b, $);
                                            y ? e.password += k : e.username += k;
                                        } else y = !0;
                                    }
                                    d = "";
                                } else if (a == r || "/" == a || "?" == a || "#" == a || "\\" == a && Y(e)) {
                                    if (v && "" == d) return "Invalid authority";
                                    p -= h(d).length + 1, d = "", f = he;
                                } else d += a;
                                break;
                            case he:
                            case de:
                                if (n && "file" == e.scheme) {
                                    f = me;
                                    continue;
                                }
                                if (":" != a || g) {
                                    if (a == r || "/" == a || "?" == a || "#" == a || "\\" == a && Y(e)) {
                                        if (Y(e) && "" == d) return E;
                                        if (n && "" == d && (X(e) || null !== e.port)) return;
                                        if (s = B(e, d)) return s;
                                        if (d = "", f = be, n) return;
                                        continue;
                                    }
                                    "[" == a ? g = !0 : "]" == a && (g = !1), d += a;
                                } else {
                                    if ("" == d) return E;
                                    if (s = B(e, d)) return s;
                                    if (d = "", f = ve, n == de) return;
                                }
                                break;
                            case ve:
                                if (!j.test(a)) {
                                    if (a == r || "/" == a || "?" == a || "#" == a || "\\" == a && Y(e) || n) {
                                        if ("" != d) {
                                            var w = parseInt(d, 10);
                                            if (w > 65535) return _;
                                            e.port = Y(e) && w === J[e.scheme] ? null : w, d = "";
                                        }
                                        if (n) return;
                                        f = be;
                                        continue;
                                    }
                                    return _;
                                }
                                d += a;
                                break;
                            case ge:
                                if (e.scheme = "file", "/" == a || "\\" == a) f = ye;
                                else {
                                    if (!o || "file" != o.scheme) {
                                        f = ke;
                                        continue;
                                    }
                                    if (a == r) e.host = o.host, e.path = o.path.slice(), e.query = o.query;
                                    else if ("?" == a) e.host = o.host, e.path = o.path.slice(), e.query = "", f = xe;
                                    else {
                                        if ("#" != a) {
                                            ee(i.slice(p).join("")) || (e.host = o.host, e.path = o.path.slice(), te(e)), f = ke;
                                            continue;
                                        }
                                        e.host = o.host, e.path = o.path.slice(), e.query = o.query, e.fragment = "", f = Se;
                                    }
                                }
                                break;
                            case ye:
                                if ("/" == a || "\\" == a) {
                                    f = me;
                                    break;
                                }
                                o && "file" == o.scheme && !ee(i.slice(p).join("")) && (Z(o.path[0], !0) ? e.path.push(o.path[0]) : e.host = o.host), f = ke;
                                continue;
                            case me:
                                if (a == r || "/" == a || "\\" == a || "?" == a || "#" == a) {
                                    if (!n && Z(d)) f = ke;
                                    else if ("" == d) {
                                        if (e.host = "", n) return;
                                        f = be;
                                    } else {
                                        if (s = B(e, d)) return s;
                                        if ("localhost" == e.host && (e.host = ""), n) return;
                                        d = "", f = be;
                                    }
                                    continue;
                                }
                                d += a;
                                break;
                            case be:
                                if (Y(e)) {
                                    if (f = ke, "/" != a && "\\" != a) continue;
                                } else if (n || "?" != a) {
                                    if (n || "#" != a) {
                                        if (a != r && (f = ke, "/" != a)) continue;
                                    } else e.fragment = "", f = Se;
                                } else e.query = "", f = xe;
                                break;
                            case ke:
                                if (a == r || "/" == a || "\\" == a && Y(e) || !n && ("?" == a || "#" == a)) {
                                    if (".." === (c = (c = d).toLowerCase()) || "%2e." === c || ".%2e" === c || "%2e%2e" === c ? (te(e), "/" == a || "\\" == a && Y(e) || e.path.push("")) : ne(d) ? "/" == a || "\\" == a && Y(e) || e.path.push("") : ("file" == e.scheme && !e.path.length && Z(d) && (e.host && (e.host = ""), d = d.charAt(0) + ":"), e.path.push(d)), d = "", "file" == e.scheme && (a == r || "?" == a || "#" == a)) for(; e.path.length > 1 && "" === e.path[0];)e.path.shift();
                                    "?" == a ? (e.query = "", f = xe) : "#" == a && (e.fragment = "", f = Se);
                                } else d += z(a, W);
                                break;
                            case we:
                                "?" == a ? (e.query = "", f = xe) : "#" == a ? (e.fragment = "", f = Se) : a != r && (e.path[0] += z(a, V));
                                break;
                            case xe:
                                n || "#" != a ? a != r && ("'" == a && Y(e) ? e.query += "%27" : e.query += "#" == a ? "%23" : z(a, V)) : (e.fragment = "", f = Se);
                                break;
                            case Se:
                                a != r && (e.fragment += z(a, G));
                        }
                        p++;
                    }
                }, Oe = function(e) {
                    var t, n, r = f(this, Oe, "URL"), o = arguments.length > 1 ? arguments[1] : void 0, a = String(e), u = x(r, {
                        type: "URL"
                    });
                    if (void 0 !== o) {
                        if (o instanceof Oe) t = S(o);
                        else if (n = Te(t = {}, String(o))) throw TypeError(n);
                    }
                    if (n = Te(u, a, null, t)) throw TypeError(n);
                    var s = u.searchParams = new k, c = w(s);
                    c.updateSearchParams(u.query), c.updateURL = function() {
                        u.query = String(s) || null;
                    }, i || (r.href = Ee.call(r), r.origin = _e.call(r), r.protocol = Re.call(r), r.username = Pe.call(r), r.password = je.call(r), r.host = Ie.call(r), r.hostname = Ce.call(r), r.port = Me.call(r), r.pathname = Ue.call(r), r.search = Fe.call(r), r.searchParams = Ne.call(r), r.hash = Le.call(r));
                }, Ae = Oe.prototype, Ee = function() {
                    var e = S(this), t = e.scheme, n = e.username, r = e.password, o = e.host, i = e.port, a = e.path, u = e.query, s = e.fragment, c = t + ":";
                    return null !== o ? (c += "//", X(e) && (c += n + (r ? ":" + r : "") + "@"), c += K(o), null !== i && (c += ":" + i)) : "file" == t && (c += "//"), c += e.cannotBeABaseURL ? a[0] : a.length ? "/" + a.join("/") : "", null !== u && (c += "?" + u), null !== s && (c += "#" + s), c;
                }, _e = function() {
                    var e = S(this), t = e.scheme, n = e.port;
                    if ("blob" == t) try {
                        return new Oe(t.path[0]).origin;
                    } catch (e) {
                        return "null";
                    }
                    return "file" != t && Y(e) ? t + "://" + K(e.host) + (null !== n ? ":" + n : "") : "null";
                }, Re = function() {
                    return S(this).scheme + ":";
                }, Pe = function() {
                    return S(this).username;
                }, je = function() {
                    return S(this).password;
                }, Ie = function() {
                    var e = S(this), t = e.host, n = e.port;
                    return null === t ? "" : null === n ? K(t) : K(t) + ":" + n;
                }, Ce = function() {
                    var e = S(this).host;
                    return null === e ? "" : K(e);
                }, Me = function() {
                    var e = S(this).port;
                    return null === e ? "" : String(e);
                }, Ue = function() {
                    var e = S(this), t = e.path;
                    return e.cannotBeABaseURL ? t[0] : t.length ? "/" + t.join("/") : "";
                }, Fe = function() {
                    var e = S(this).query;
                    return e ? "?" + e : "";
                }, Ne = function() {
                    return S(this).searchParams;
                }, Le = function() {
                    var e = S(this).fragment;
                    return e ? "#" + e : "";
                }, De = function(e, t) {
                    return {
                        get: e,
                        set: t,
                        configurable: !0,
                        enumerable: !0
                    };
                };
                if (i && s(Ae, {
                    href: De(Ee, function(e) {
                        var t = S(this), n = String(e), r = Te(t, n);
                        if (r) throw TypeError(r);
                        w(t.searchParams).updateSearchParams(t.query);
                    }),
                    origin: De(_e),
                    protocol: De(Re, function(e) {
                        var t = S(this);
                        Te(t, String(e) + ":", re);
                    }),
                    username: De(Pe, function(e) {
                        var t = S(this), n = h(String(e));
                        if (!Q(t)) {
                            t.username = "";
                            for(var r = 0; r < n.length; r++)t.username += z(n[r], $);
                        }
                    }),
                    password: De(je, function(e) {
                        var t = S(this), n = h(String(e));
                        if (!Q(t)) {
                            t.password = "";
                            for(var r = 0; r < n.length; r++)t.password += z(n[r], $);
                        }
                    }),
                    host: De(Ie, function(e) {
                        var t = S(this);
                        t.cannotBeABaseURL || Te(t, String(e), he);
                    }),
                    hostname: De(Ce, function(e) {
                        var t = S(this);
                        t.cannotBeABaseURL || Te(t, String(e), de);
                    }),
                    port: De(Me, function(e) {
                        var t = S(this);
                        Q(t) || ("" == (e = String(e)) ? t.port = null : Te(t, e, ve));
                    }),
                    pathname: De(Ue, function(e) {
                        var t = S(this);
                        t.cannotBeABaseURL || (t.path = [], Te(t, e + "", be));
                    }),
                    search: De(Fe, function(e) {
                        var t = S(this);
                        "" == (e = String(e)) ? t.query = null : ("?" == e.charAt(0) && (e = e.slice(1)), t.query = "", Te(t, e, xe)), w(t.searchParams).updateSearchParams(t.query);
                    }),
                    searchParams: De(Ne),
                    hash: De(Le, function(e) {
                        var t = S(this);
                        "" != (e = String(e)) ? ("#" == e.charAt(0) && (e = e.slice(1)), t.fragment = "", Te(t, e, Se)) : t.fragment = null;
                    })
                }), c(Ae, "toJSON", function() {
                    return Ee.call(this);
                }, {
                    enumerable: !0
                }), c(Ae, "toString", function() {
                    return Ee.call(this);
                }, {
                    enumerable: !0
                }), b) {
                    var Be = b.createObjectURL, qe = b.revokeObjectURL;
                    Be && c(Oe, "createObjectURL", function(e) {
                        return Be.apply(b, arguments);
                    }), qe && c(Oe, "revokeObjectURL", function(e) {
                        return qe.apply(b, arguments);
                    });
                }
                g(Oe, "URL"), o({
                    global: !0,
                    forced: !a,
                    sham: !i
                }, {
                    URL: Oe
                });
            },
            8947: function() {},
            7698: function(e, t, n) {
                var r = n(4493);
                e.exports = r;
            },
            3363: function(e, t, n) {
                var r = n(4034);
                e.exports = r;
            },
            9216: function(e, t, n) {
                var r = n(9324);
                e.exports = r;
            },
            8065: function(e, t, n) {
                var r = n(6043);
                e.exports = r;
            },
            1955: function(e, t, n) {
                var r = n(2480);
                e.exports = r;
            },
            1577: function(e, t, n) {
                var r = n(2236);
                e.exports = r;
            },
            6279: function(e, t, n) {
                n(7634);
                var r = n(9216), o = n(9697), i = Array.prototype, a = {
                    DOMTokenList: !0,
                    NodeList: !0
                };
                e.exports = function(e) {
                    var t = e.forEach;
                    return e === i || e instanceof Array && t === i.forEach || a.hasOwnProperty(o(e)) ? r : t;
                };
            },
            9373: function(e, t, n) {
                var r = n(4570);
                e.exports = r;
            },
            1798: function(e, t, n) {
                var r = n(8287);
                e.exports = r;
            },
            2073: function(e, t, n) {
                var r = n(9601);
                e.exports = r;
            },
            8933: function(e, t, n) {
                var r = n(4426);
                e.exports = r;
            },
            7396: function(e, t, n) {
                var r = n(7702);
                e.exports = r;
            },
            1910: function(e, t, n) {
                var r = n(8171);
                e.exports = r;
            },
            6209: function(e, t, n) {
                var r = n(3081);
                e.exports = r;
            },
            3402: function(e, t, n) {
                var r = n(7699);
                e.exports = r;
            },
            9427: function(e, t, n) {
                var r = n(286);
                e.exports = r;
            },
            2857: function(e, t, n) {
                var r = n(2766);
                e.exports = r;
            },
            9534: function(e, t, n) {
                var r = n(498);
                e.exports = r;
            },
            3059: function(e, t, n) {
                var r = n(8494);
                e.exports = r;
            },
            7460: function(e, t, n) {
                var r = n(2956);
                e.exports = r;
            },
            2547: function(e, t, n) {
                var r = n(7473);
                e.exports = r;
            },
            7641: function(e, t, n) {
                var r = n(1459);
                e.exports = r;
            },
            1459: function(e, t, n) {
                n(3601), n(8947), n(5304);
                var r = n(4058);
                e.exports = r.URL;
            },
            1530: function(e, t, n) {
                "use strict";
                var r = n(8710).charAt;
                e.exports = function(e, t, n) {
                    return t + (n ? r(e, t).length : 1);
                };
            },
            9670: function(e, t, n) {
                var r = n(111);
                e.exports = function(e) {
                    if (!r(e)) throw TypeError(String(e) + " is not an object");
                    return e;
                };
            },
            1318: function(e, t, n) {
                var r = n(5656), o = n(7466), i = n(1400), a = function(e) {
                    return function(t, n, a) {
                        var u, s = r(t), c = o(s.length), f = i(a, c);
                        if (e && n != n) {
                            for(; c > f;)if ((u = s[f++]) != u) return !0;
                        } else for(; c > f; f++)if ((e || f in s) && s[f] === n) return e || f || 0;
                        return !e && -1;
                    };
                };
                e.exports = {
                    includes: a(!0),
                    indexOf: a(!1)
                };
            },
            9341: function(e, t, n) {
                "use strict";
                var r = n(7293);
                e.exports = function(e, t) {
                    var n = [][e];
                    return !!n && r(function() {
                        n.call(null, t || function() {
                            throw 1;
                        }, 1);
                    });
                };
            },
            4326: function(e) {
                var t = {}.toString;
                e.exports = function(e) {
                    return t.call(e).slice(8, -1);
                };
            },
            648: function(e, t, n) {
                var r = n(1694), o = n(4326), i = n(5112)("toStringTag"), a = "Arguments" == o(function() {
                    return arguments;
                }());
                e.exports = r ? o : function(e) {
                    var t, n, r;
                    return void 0 === e ? "Undefined" : null === e ? "Null" : "string" == typeof (n = function(e, t) {
                        try {
                            return e[t];
                        } catch (e) {}
                    }(t = Object(e), i)) ? n : a ? o(t) : "Object" == (r = o(t)) && "function" == typeof t.callee ? "Arguments" : r;
                };
            },
            9920: function(e, t, n) {
                var r = n(6656), o = n(3887), i = n(1236), a = n(3070);
                e.exports = function(e, t) {
                    for(var n = o(t), u = a.f, s = i.f, c = 0; c < n.length; c++){
                        var f = n[c];
                        r(e, f) || u(e, f, s(t, f));
                    }
                };
            },
            8880: function(e, t, n) {
                var r = n(9781), o = n(3070), i = n(9114);
                e.exports = r ? function(e, t, n) {
                    return o.f(e, t, i(1, n));
                } : function(e, t, n) {
                    return e[t] = n, e;
                };
            },
            9114: function(e) {
                e.exports = function(e, t) {
                    return {
                        enumerable: !(1 & e),
                        configurable: !(2 & e),
                        writable: !(4 & e),
                        value: t
                    };
                };
            },
            9781: function(e, t, n) {
                var r = n(7293);
                e.exports = !r(function() {
                    return 7 != Object.defineProperty({}, 1, {
                        get: function() {
                            return 7;
                        }
                    })[1];
                });
            },
            317: function(e, t, n) {
                var r = n(7854), o = n(111), i = r.document, a = o(i) && o(i.createElement);
                e.exports = function(e) {
                    return a ? i.createElement(e) : {};
                };
            },
            8113: function(e, t, n) {
                var r = n(5005);
                e.exports = r("navigator", "userAgent") || "";
            },
            7392: function(e, t, n) {
                var r, o, i = n(7854), a = n(8113), u = i.process, s = u && u.versions, c = s && s.v8;
                c ? o = (r = c.split("."))[0] < 4 ? 1 : r[0] + r[1] : a && (!(r = a.match(/Edge\/(\d+)/)) || r[1] >= 74) && (r = a.match(/Chrome\/(\d+)/)) && (o = r[1]), e.exports = o && +o;
            },
            748: function(e) {
                e.exports = [
                    "constructor",
                    "hasOwnProperty",
                    "isPrototypeOf",
                    "propertyIsEnumerable",
                    "toLocaleString",
                    "toString",
                    "valueOf"
                ];
            },
            2109: function(e, t, n) {
                var r = n(7854), o = n(1236).f, i = n(8880), a = n(1320), u = n(3505), s = n(9920), c = n(4705);
                e.exports = function(e, t) {
                    var n, f, l, p, h, d = e.target, v = e.global, g = e.stat;
                    if (n = v ? r : g ? r[d] || u(d, {}) : (r[d] || {}).prototype) for(f in t){
                        if (p = t[f], l = e.noTargetGet ? (h = o(n, f)) && h.value : n[f], !c(v ? f : d + (g ? "." : "#") + f, e.forced) && void 0 !== l) {
                            if (typeof p == typeof l) continue;
                            s(p, l);
                        }
                        (e.sham || l && l.sham) && i(p, "sham", !0), a(n, f, p, e);
                    }
                };
            },
            7293: function(e) {
                e.exports = function(e) {
                    try {
                        return !!e();
                    } catch (e) {
                        return !0;
                    }
                };
            },
            7007: function(e, t, n) {
                "use strict";
                n(4916);
                var r = n(1320), o = n(2261), i = n(7293), a = n(5112), u = n(8880), s = a("species"), c = RegExp.prototype;
                e.exports = function(e, t, n, f) {
                    var l = a(e), p = !i(function() {
                        var t = {};
                        return t[l] = function() {
                            return 7;
                        }, 7 != ""[e](t);
                    }), h = p && !i(function() {
                        var t = !1, n = /a/;
                        return "split" === e && ((n = {}).constructor = {}, n.constructor[s] = function() {
                            return n;
                        }, n.flags = "", n[l] = /./[l]), n.exec = function() {
                            return t = !0, null;
                        }, n[l](""), !t;
                    });
                    if (!p || !h || n) {
                        var d = /./[l], v = t(l, ""[e], function(e, t, n, r, i) {
                            var a = t.exec;
                            return a === o || a === c.exec ? p && !i ? {
                                done: !0,
                                value: d.call(t, n, r)
                            } : {
                                done: !0,
                                value: e.call(n, t, r)
                            } : {
                                done: !1
                            };
                        });
                        r(String.prototype, e, v[0]), r(c, l, v[1]);
                    }
                    f && u(c[l], "sham", !0);
                };
            },
            5005: function(e, t, n) {
                var r = n(857), o = n(7854), i = function(e) {
                    return "function" == typeof e ? e : void 0;
                };
                e.exports = function(e, t) {
                    return arguments.length < 2 ? i(r[e]) || i(o[e]) : r[e] && r[e][t] || o[e] && o[e][t];
                };
            },
            647: function(e, t, n) {
                var r = n(7908), o = Math.floor, i = "".replace, a = /\$([$&'`]|\d{1,2}|<[^>]*>)/g, u = /\$([$&'`]|\d{1,2})/g;
                e.exports = function(e, t, n, s, c, f) {
                    var l = n + e.length, p = s.length, h = u;
                    return void 0 !== c && (c = r(c), h = a), i.call(f, h, function(r, i) {
                        var a;
                        switch(i.charAt(0)){
                            case "$":
                                return "$";
                            case "&":
                                return e;
                            case "`":
                                return t.slice(0, n);
                            case "'":
                                return t.slice(l);
                            case "<":
                                a = c[i.slice(1, -1)];
                                break;
                            default:
                                var u = +i;
                                if (0 === u) return r;
                                if (u > p) {
                                    var f = o(u / 10);
                                    return 0 === f ? r : f <= p ? void 0 === s[f - 1] ? i.charAt(1) : s[f - 1] + i.charAt(1) : r;
                                }
                                a = s[u - 1];
                        }
                        return void 0 === a ? "" : a;
                    });
                };
            },
            7854: function(e, t, n) {
                var r = function(e) {
                    return e && e.Math == Math && e;
                };
                e.exports = r("object" == typeof globalThis && globalThis) || r("object" == typeof window && window) || r("object" == typeof self && self) || r("object" == typeof n.g && n.g) || function() {
                    return this;
                }() || Function("return this")();
            },
            6656: function(e, t, n) {
                var r = n(7908), o = {}.hasOwnProperty;
                e.exports = Object.hasOwn || function(e, t) {
                    return o.call(r(e), t);
                };
            },
            3501: function(e) {
                e.exports = {};
            },
            490: function(e, t, n) {
                var r = n(5005);
                e.exports = r("document", "documentElement");
            },
            4664: function(e, t, n) {
                var r = n(9781), o = n(7293), i = n(317);
                e.exports = !r && !o(function() {
                    return 7 != Object.defineProperty(i("div"), "a", {
                        get: function() {
                            return 7;
                        }
                    }).a;
                });
            },
            8361: function(e, t, n) {
                var r = n(7293), o = n(4326), i = "".split;
                e.exports = r(function() {
                    return !Object("z").propertyIsEnumerable(0);
                }) ? function(e) {
                    return "String" == o(e) ? i.call(e, "") : Object(e);
                } : Object;
            },
            2788: function(e, t, n) {
                var r = n(5465), o = Function.toString;
                "function" != typeof r.inspectSource && (r.inspectSource = function(e) {
                    return o.call(e);
                }), e.exports = r.inspectSource;
            },
            9909: function(e, t, n) {
                var r, o, i, a = n(8536), u = n(7854), s = n(111), c = n(8880), f = n(6656), l = n(5465), p = n(6200), h = n(3501), d = "Object already initialized", v = u.WeakMap;
                if (a || l.state) {
                    var g = l.state || (l.state = new v), y = g.get, m = g.has, b = g.set;
                    r = function(e, t) {
                        if (m.call(g, e)) throw new TypeError(d);
                        return t.facade = e, b.call(g, e, t), t;
                    }, o = function(e) {
                        return y.call(g, e) || {};
                    }, i = function(e) {
                        return m.call(g, e);
                    };
                } else {
                    var k = p("state");
                    h[k] = !0, r = function(e, t) {
                        if (f(e, k)) throw new TypeError(d);
                        return t.facade = e, c(e, k, t), t;
                    }, o = function(e) {
                        return f(e, k) ? e[k] : {};
                    }, i = function(e) {
                        return f(e, k);
                    };
                }
                e.exports = {
                    set: r,
                    get: o,
                    has: i,
                    enforce: function(e) {
                        return i(e) ? o(e) : r(e, {});
                    },
                    getterFor: function(e) {
                        return function(t) {
                            var n;
                            if (!s(t) || (n = o(t)).type !== e) throw TypeError("Incompatible receiver, " + e + " required");
                            return n;
                        };
                    }
                };
            },
            4705: function(e, t, n) {
                var r = n(7293), o = /#|\.prototype\./, i = function(e, t) {
                    var n = u[a(e)];
                    return n == c || n != s && ("function" == typeof t ? r(t) : !!t);
                }, a = i.normalize = function(e) {
                    return String(e).replace(o, ".").toLowerCase();
                }, u = i.data = {}, s = i.NATIVE = "N", c = i.POLYFILL = "P";
                e.exports = i;
            },
            111: function(e) {
                e.exports = function(e) {
                    return "object" == typeof e ? null !== e : "function" == typeof e;
                };
            },
            1913: function(e) {
                e.exports = !1;
            },
            133: function(e, t, n) {
                var r = n(7392), o = n(7293);
                e.exports = !!Object.getOwnPropertySymbols && !o(function() {
                    var e = Symbol();
                    return !String(e) || !(Object(e) instanceof Symbol) || !Symbol.sham && r && r < 41;
                });
            },
            8536: function(e, t, n) {
                var r = n(7854), o = n(2788), i = r.WeakMap;
                e.exports = "function" == typeof i && /native code/.test(o(i));
            },
            30: function(e, t, n) {
                var r, o = n(9670), i = n(6048), a = n(748), u = n(3501), s = n(490), c = n(317), f = n(6200)("IE_PROTO"), l = function() {}, p = function(e) {
                    return "<script>" + e + "</script>";
                }, h = function() {
                    try {
                        r = document.domain && new ActiveXObject("htmlfile");
                    } catch (e) {}
                    var e, t;
                    h = r ? function(e) {
                        e.write(p("")), e.close();
                        var t = e.parentWindow.Object;
                        return e = null, t;
                    }(r) : ((t = c("iframe")).style.display = "none", s.appendChild(t), t.src = String("javascript:"), (e = t.contentWindow.document).open(), e.write(p("document.F=Object")), e.close(), e.F);
                    for(var n = a.length; n--;)delete h.prototype[a[n]];
                    return h();
                };
                u[f] = !0, e.exports = Object.create || function(e, t) {
                    var n;
                    return null !== e ? (l.prototype = o(e), n = new l, l.prototype = null, n[f] = e) : n = h(), void 0 === t ? n : i(n, t);
                };
            },
            6048: function(e, t, n) {
                var r = n(9781), o = n(3070), i = n(9670), a = n(1956);
                e.exports = r ? Object.defineProperties : function(e, t) {
                    i(e);
                    for(var n, r = a(t), u = r.length, s = 0; u > s;)o.f(e, n = r[s++], t[n]);
                    return e;
                };
            },
            3070: function(e, t, n) {
                var r = n(9781), o = n(4664), i = n(9670), a = n(7593), u = Object.defineProperty;
                t.f = r ? u : function(e, t, n) {
                    if (i(e), t = a(t, !0), i(n), o) try {
                        return u(e, t, n);
                    } catch (e) {}
                    if ("get" in n || "set" in n) throw TypeError("Accessors not supported");
                    return "value" in n && (e[t] = n.value), e;
                };
            },
            1236: function(e, t, n) {
                var r = n(9781), o = n(5296), i = n(9114), a = n(5656), u = n(7593), s = n(6656), c = n(4664), f = Object.getOwnPropertyDescriptor;
                t.f = r ? f : function(e, t) {
                    if (e = a(e), t = u(t, !0), c) try {
                        return f(e, t);
                    } catch (e) {}
                    if (s(e, t)) return i(!o.f.call(e, t), e[t]);
                };
            },
            8006: function(e, t, n) {
                var r = n(6324), o = n(748).concat("length", "prototype");
                t.f = Object.getOwnPropertyNames || function(e) {
                    return r(e, o);
                };
            },
            5181: function(e, t) {
                t.f = Object.getOwnPropertySymbols;
            },
            6324: function(e, t, n) {
                var r = n(6656), o = n(5656), i = n(1318).indexOf, a = n(3501);
                e.exports = function(e, t) {
                    var n, u = o(e), s = 0, c = [];
                    for(n in u)!r(a, n) && r(u, n) && c.push(n);
                    for(; t.length > s;)r(u, n = t[s++]) && (~i(c, n) || c.push(n));
                    return c;
                };
            },
            1956: function(e, t, n) {
                var r = n(6324), o = n(748);
                e.exports = Object.keys || function(e) {
                    return r(e, o);
                };
            },
            5296: function(e, t) {
                "use strict";
                var n = {}.propertyIsEnumerable, r = Object.getOwnPropertyDescriptor, o = r && !n.call({
                    1: 2
                }, 1);
                t.f = o ? function(e) {
                    var t = r(this, e);
                    return !!t && t.enumerable;
                } : n;
            },
            288: function(e, t, n) {
                "use strict";
                var r = n(1694), o = n(648);
                e.exports = r ? ({}).toString : function() {
                    return "[object " + o(this) + "]";
                };
            },
            3887: function(e, t, n) {
                var r = n(5005), o = n(8006), i = n(5181), a = n(9670);
                e.exports = r("Reflect", "ownKeys") || function(e) {
                    var t = o.f(a(e)), n = i.f;
                    return n ? t.concat(n(e)) : t;
                };
            },
            857: function(e, t, n) {
                var r = n(7854);
                e.exports = r;
            },
            1320: function(e, t, n) {
                var r = n(7854), o = n(8880), i = n(6656), a = n(3505), u = n(2788), s = n(9909), c = s.get, f = s.enforce, l = String(String).split("String");
                (e.exports = function(e, t, n, u) {
                    var s, c = !!u && !!u.unsafe, p = !!u && !!u.enumerable, h = !!u && !!u.noTargetGet;
                    "function" == typeof n && ("string" != typeof t || i(n, "name") || o(n, "name", t), (s = f(n)).source || (s.source = l.join("string" == typeof t ? t : ""))), e !== r ? (c ? !h && e[t] && (p = !0) : delete e[t], p ? e[t] = n : o(e, t, n)) : p ? e[t] = n : a(t, n);
                })(Function.prototype, "toString", function() {
                    return "function" == typeof this && c(this).source || u(this);
                });
            },
            7651: function(e, t, n) {
                var r = n(4326), o = n(2261);
                e.exports = function(e, t) {
                    var n = e.exec;
                    if ("function" == typeof n) {
                        var i = n.call(e, t);
                        if ("object" != typeof i) throw TypeError("RegExp exec method returned something other than an Object or null");
                        return i;
                    }
                    if ("RegExp" !== r(e)) throw TypeError("RegExp#exec called on incompatible receiver");
                    return o.call(e, t);
                };
            },
            2261: function(e, t, n) {
                "use strict";
                var r, o, i = n(7066), a = n(2999), u = n(2309), s = n(30), c = n(9909).get, f = n(9441), l = n(8173), p = RegExp.prototype.exec, h = u("native-string-replace", String.prototype.replace), d = p, v = (r = /a/, o = /b*/g, p.call(r, "a"), p.call(o, "a"), 0 !== r.lastIndex || 0 !== o.lastIndex), g = a.UNSUPPORTED_Y || a.BROKEN_CARET, y = void 0 !== /()??/.exec("")[1];
                (v || y || g || f || l) && (d = function(e) {
                    var t, n, r, o, a, u, f, l = this, m = c(l), b = m.raw;
                    if (b) return b.lastIndex = l.lastIndex, t = d.call(b, e), l.lastIndex = b.lastIndex, t;
                    var k = m.groups, w = g && l.sticky, x = i.call(l), S = l.source, T = 0, O = e;
                    if (w && (-1 === (x = x.replace("y", "")).indexOf("g") && (x += "g"), O = String(e).slice(l.lastIndex), l.lastIndex > 0 && (!l.multiline || l.multiline && "\n" !== e[l.lastIndex - 1]) && (S = "(?: " + S + ")", O = " " + O, T++), n = new RegExp("^(?:" + S + ")", x)), y && (n = new RegExp("^" + S + "$(?!\\s)", x)), v && (r = l.lastIndex), o = p.call(w ? n : l, O), w ? o ? (o.input = o.input.slice(T), o[0] = o[0].slice(T), o.index = l.lastIndex, l.lastIndex += o[0].length) : l.lastIndex = 0 : v && o && (l.lastIndex = l.global ? o.index + o[0].length : r), y && o && o.length > 1 && h.call(o[0], n, function() {
                        for(a = 1; a < arguments.length - 2; a++)void 0 === arguments[a] && (o[a] = void 0);
                    }), o && k) for(o.groups = u = s(null), a = 0; a < k.length; a++)u[(f = k[a])[0]] = o[f[1]];
                    return o;
                }), e.exports = d;
            },
            7066: function(e, t, n) {
                "use strict";
                var r = n(9670);
                e.exports = function() {
                    var e = r(this), t = "";
                    return e.global && (t += "g"), e.ignoreCase && (t += "i"), e.multiline && (t += "m"), e.dotAll && (t += "s"), e.unicode && (t += "u"), e.sticky && (t += "y"), t;
                };
            },
            2999: function(e, t, n) {
                var r = n(7293), o = function(e, t) {
                    return RegExp(e, t);
                };
                t.UNSUPPORTED_Y = r(function() {
                    var e = o("a", "y");
                    return e.lastIndex = 2, null != e.exec("abcd");
                }), t.BROKEN_CARET = r(function() {
                    var e = o("^r", "gy");
                    return e.lastIndex = 2, null != e.exec("str");
                });
            },
            9441: function(e, t, n) {
                var r = n(7293);
                e.exports = r(function() {
                    var e = RegExp(".", "string".charAt(0));
                    return !(e.dotAll && e.exec("\n") && "s" === e.flags);
                });
            },
            8173: function(e, t, n) {
                var r = n(7293);
                e.exports = r(function() {
                    var e = RegExp("(?<a>b)", "string".charAt(5));
                    return "b" !== e.exec("b").groups.a || "bc" !== "b".replace(e, "$<a>c");
                });
            },
            4488: function(e) {
                e.exports = function(e) {
                    if (null == e) throw TypeError("Can't call method on " + e);
                    return e;
                };
            },
            3505: function(e, t, n) {
                var r = n(7854), o = n(8880);
                e.exports = function(e, t) {
                    try {
                        o(r, e, t);
                    } catch (n) {
                        r[e] = t;
                    }
                    return t;
                };
            },
            6200: function(e, t, n) {
                var r = n(2309), o = n(9711), i = r("keys");
                e.exports = function(e) {
                    return i[e] || (i[e] = o(e));
                };
            },
            5465: function(e, t, n) {
                var r = n(7854), o = n(3505), i = "__core-js_shared__", a = r[i] || o(i, {});
                e.exports = a;
            },
            2309: function(e, t, n) {
                var r = n(1913), o = n(5465);
                (e.exports = function(e, t) {
                    return o[e] || (o[e] = void 0 !== t ? t : {});
                })("versions", []).push({
                    version: "3.15.1",
                    mode: r ? "pure" : "global",
                    copyright: "\xa9 2021 Denis Pushkarev (zloirock.ru)"
                });
            },
            8710: function(e, t, n) {
                var r = n(9958), o = n(4488), i = function(e) {
                    return function(t, n) {
                        var i, a, u = String(o(t)), s = r(n), c = u.length;
                        return s < 0 || s >= c ? e ? "" : void 0 : (i = u.charCodeAt(s)) < 55296 || i > 56319 || s + 1 === c || (a = u.charCodeAt(s + 1)) < 56320 || a > 57343 ? e ? u.charAt(s) : i : e ? u.slice(s, s + 2) : a - 56320 + (i - 55296 << 10) + 65536;
                    };
                };
                e.exports = {
                    codeAt: i(!1),
                    charAt: i(!0)
                };
            },
            1400: function(e, t, n) {
                var r = n(9958), o = Math.max, i = Math.min;
                e.exports = function(e, t) {
                    var n = r(e);
                    return n < 0 ? o(n + t, 0) : i(n, t);
                };
            },
            5656: function(e, t, n) {
                var r = n(8361), o = n(4488);
                e.exports = function(e) {
                    return r(o(e));
                };
            },
            9958: function(e) {
                var t = Math.ceil, n = Math.floor;
                e.exports = function(e) {
                    return isNaN(e = +e) ? 0 : (e > 0 ? n : t)(e);
                };
            },
            7466: function(e, t, n) {
                var r = n(9958), o = Math.min;
                e.exports = function(e) {
                    return e > 0 ? o(r(e), 9007199254740991) : 0;
                };
            },
            7908: function(e, t, n) {
                var r = n(4488);
                e.exports = function(e) {
                    return Object(r(e));
                };
            },
            7593: function(e, t, n) {
                var r = n(111);
                e.exports = function(e, t) {
                    if (!r(e)) return e;
                    var n, o;
                    if (t && "function" == typeof (n = e.toString) && !r(o = n.call(e))) return o;
                    if ("function" == typeof (n = e.valueOf) && !r(o = n.call(e))) return o;
                    if (!t && "function" == typeof (n = e.toString) && !r(o = n.call(e))) return o;
                    throw TypeError("Can't convert object to primitive value");
                };
            },
            1694: function(e, t, n) {
                var r = {};
                r[n(5112)("toStringTag")] = "z", e.exports = "[object z]" === String(r);
            },
            9711: function(e) {
                var t = 0, n = Math.random();
                e.exports = function(e) {
                    return "Symbol(" + String(void 0 === e ? "" : e) + ")_" + (++t + n).toString(36);
                };
            },
            3307: function(e, t, n) {
                var r = n(133);
                e.exports = r && !Symbol.sham && "symbol" == typeof Symbol.iterator;
            },
            5112: function(e, t, n) {
                var r = n(7854), o = n(2309), i = n(6656), a = n(9711), u = n(133), s = n(3307), c = o("wks"), f = r.Symbol, l = s ? f : f && f.withoutSetter || a;
                e.exports = function(e) {
                    return i(c, e) && (u || "string" == typeof c[e]) || (u && i(f, e) ? c[e] = f[e] : c[e] = l("Symbol." + e)), c[e];
                };
            },
            9600: function(e, t, n) {
                "use strict";
                var r = n(2109), o = n(8361), i = n(5656), a = n(9341), u = [].join, s = o != Object, c = a("join", ",");
                r({
                    target: "Array",
                    proto: !0,
                    forced: s || !c
                }, {
                    join: function(e) {
                        return u.call(i(this), void 0 === e ? "," : e);
                    }
                });
            },
            8309: function(e, t, n) {
                var r = n(9781), o = n(3070).f, i = Function.prototype, a = i.toString, u = /^\s*function ([^ (]*)/, s = "name";
                r && !(s in i) && o(i, s, {
                    configurable: !0,
                    get: function() {
                        try {
                            return a.call(this).match(u)[1];
                        } catch (e) {
                            return "";
                        }
                    }
                });
            },
            1539: function(e, t, n) {
                var r = n(1694), o = n(1320), i = n(288);
                r || o(Object.prototype, "toString", i, {
                    unsafe: !0
                });
            },
            4916: function(e, t, n) {
                "use strict";
                var r = n(2109), o = n(2261);
                r({
                    target: "RegExp",
                    proto: !0,
                    forced: /./.exec !== o
                }, {
                    exec: o
                });
            },
            5306: function(e, t, n) {
                "use strict";
                var r = n(7007), o = n(7293), i = n(9670), a = n(7466), u = n(9958), s = n(4488), c = n(1530), f = n(647), l = n(7651), p = n(5112)("replace"), h = Math.max, d = Math.min, v = "$0" === "a".replace(/./, "$0"), g = !!/./[p] && "" === /./[p]("a", "$0");
                r("replace", function(e, t, n) {
                    var r = g ? "$" : "$0";
                    return [
                        function(e, n) {
                            var r = s(this), o = null == e ? void 0 : e[p];
                            return void 0 !== o ? o.call(e, r, n) : t.call(String(r), e, n);
                        },
                        function(e, o) {
                            if ("string" == typeof o && -1 === o.indexOf(r) && -1 === o.indexOf("$<")) {
                                var s = n(t, this, e, o);
                                if (s.done) return s.value;
                            }
                            var p = i(this), v = String(e), g = "function" == typeof o;
                            g || (o = String(o));
                            var y = p.global;
                            if (y) {
                                var m = p.unicode;
                                p.lastIndex = 0;
                            }
                            for(var b = [];;){
                                var k = l(p, v);
                                if (null === k) break;
                                if (b.push(k), !y) break;
                                "" === String(k[0]) && (p.lastIndex = c(v, a(p.lastIndex), m));
                            }
                            for(var w, x = "", S = 0, T = 0; T < b.length; T++){
                                k = b[T];
                                for(var O = String(k[0]), A = h(d(u(k.index), v.length), 0), E = [], _ = 1; _ < k.length; _++)E.push(void 0 === (w = k[_]) ? w : String(w));
                                var R = k.groups;
                                if (g) {
                                    var P = [
                                        O
                                    ].concat(E, A, v);
                                    void 0 !== R && P.push(R);
                                    var j = String(o.apply(void 0, P));
                                } else j = f(O, v, A, E, R, o);
                                A >= S && (x += v.slice(S, A) + j, S = A + O.length);
                            }
                            return x + v.slice(S);
                        }
                    ];
                }, !!o(function() {
                    var e = /./;
                    return e.exec = function() {
                        var e = [];
                        return e.groups = {
                            a: "7"
                        }, e;
                    }, "7" !== "".replace(e, "$<a>");
                }) || !v || g);
            },
            4098: function(e, t) {
                var n = "undefined" != typeof self ? self : this, r = function() {
                    function e() {
                        this.fetch = !1, this.DOMException = n.DOMException;
                    }
                    return e.prototype = n, new e;
                }();
                !function(e) {
                    !function(t) {
                        var n = "URLSearchParams" in e, r = "Symbol" in e && "iterator" in Symbol, o = "FileReader" in e && "Blob" in e && function() {
                            try {
                                return new Blob, !0;
                            } catch (e) {
                                return !1;
                            }
                        }(), i = "FormData" in e, a = "ArrayBuffer" in e;
                        if (a) var u = [
                            "[object Int8Array]",
                            "[object Uint8Array]",
                            "[object Uint8ClampedArray]",
                            "[object Int16Array]",
                            "[object Uint16Array]",
                            "[object Int32Array]",
                            "[object Uint32Array]",
                            "[object Float32Array]",
                            "[object Float64Array]"
                        ], s = ArrayBuffer.isView || function(e) {
                            return e && u.indexOf(Object.prototype.toString.call(e)) > -1;
                        };
                        function c(e) {
                            if ("string" != typeof e && (e = String(e)), /[^a-z0-9\-#$%&'*+.^_`|~]/i.test(e)) throw new TypeError("Invalid character in header field name");
                            return e.toLowerCase();
                        }
                        function f(e) {
                            return "string" != typeof e && (e = String(e)), e;
                        }
                        function l(e) {
                            var t = {
                                next: function() {
                                    var t = e.shift();
                                    return {
                                        done: void 0 === t,
                                        value: t
                                    };
                                }
                            };
                            return r && (t[Symbol.iterator] = function() {
                                return t;
                            }), t;
                        }
                        function p(e) {
                            this.map = {}, e instanceof p ? e.forEach(function(e, t) {
                                this.append(t, e);
                            }, this) : Array.isArray(e) ? e.forEach(function(e) {
                                this.append(e[0], e[1]);
                            }, this) : e && Object.getOwnPropertyNames(e).forEach(function(t) {
                                this.append(t, e[t]);
                            }, this);
                        }
                        function h(e) {
                            if (e.bodyUsed) return Promise.reject(new TypeError("Already read"));
                            e.bodyUsed = !0;
                        }
                        function d(e) {
                            return new Promise(function(t, n) {
                                e.onload = function() {
                                    t(e.result);
                                }, e.onerror = function() {
                                    n(e.error);
                                };
                            });
                        }
                        function v(e) {
                            var t = new FileReader, n = d(t);
                            return t.readAsArrayBuffer(e), n;
                        }
                        function g(e) {
                            if (e.slice) return e.slice(0);
                            var t = new Uint8Array(e.byteLength);
                            return t.set(new Uint8Array(e)), t.buffer;
                        }
                        function y() {
                            return this.bodyUsed = !1, this._initBody = function(e) {
                                var t;
                                this._bodyInit = e, e ? "string" == typeof e ? this._bodyText = e : o && Blob.prototype.isPrototypeOf(e) ? this._bodyBlob = e : i && FormData.prototype.isPrototypeOf(e) ? this._bodyFormData = e : n && URLSearchParams.prototype.isPrototypeOf(e) ? this._bodyText = e.toString() : a && o && (t = e) && DataView.prototype.isPrototypeOf(t) ? (this._bodyArrayBuffer = g(e.buffer), this._bodyInit = new Blob([
                                    this._bodyArrayBuffer
                                ])) : a && (ArrayBuffer.prototype.isPrototypeOf(e) || s(e)) ? this._bodyArrayBuffer = g(e) : this._bodyText = e = Object.prototype.toString.call(e) : this._bodyText = "", this.headers.get("content-type") || ("string" == typeof e ? this.headers.set("content-type", "text/plain;charset=UTF-8") : this._bodyBlob && this._bodyBlob.type ? this.headers.set("content-type", this._bodyBlob.type) : n && URLSearchParams.prototype.isPrototypeOf(e) && this.headers.set("content-type", "application/x-www-form-urlencoded;charset=UTF-8"));
                            }, o && (this.blob = function() {
                                var e = h(this);
                                if (e) return e;
                                if (this._bodyBlob) return Promise.resolve(this._bodyBlob);
                                if (this._bodyArrayBuffer) return Promise.resolve(new Blob([
                                    this._bodyArrayBuffer
                                ]));
                                if (this._bodyFormData) throw new Error("could not read FormData body as blob");
                                return Promise.resolve(new Blob([
                                    this._bodyText
                                ]));
                            }, this.arrayBuffer = function() {
                                return this._bodyArrayBuffer ? h(this) || Promise.resolve(this._bodyArrayBuffer) : this.blob().then(v);
                            }), this.text = function() {
                                var e, t, n, r = h(this);
                                if (r) return r;
                                if (this._bodyBlob) return e = this._bodyBlob, n = d(t = new FileReader), t.readAsText(e), n;
                                if (this._bodyArrayBuffer) return Promise.resolve(function(e) {
                                    for(var t = new Uint8Array(e), n = new Array(t.length), r = 0; r < t.length; r++)n[r] = String.fromCharCode(t[r]);
                                    return n.join("");
                                }(this._bodyArrayBuffer));
                                if (this._bodyFormData) throw new Error("could not read FormData body as text");
                                return Promise.resolve(this._bodyText);
                            }, i && (this.formData = function() {
                                return this.text().then(k);
                            }), this.json = function() {
                                return this.text().then(JSON.parse);
                            }, this;
                        }
                        p.prototype.append = function(e, t) {
                            e = c(e), t = f(t);
                            var n = this.map[e];
                            this.map[e] = n ? n + ", " + t : t;
                        }, p.prototype.delete = function(e) {
                            delete this.map[c(e)];
                        }, p.prototype.get = function(e) {
                            return e = c(e), this.has(e) ? this.map[e] : null;
                        }, p.prototype.has = function(e) {
                            return this.map.hasOwnProperty(c(e));
                        }, p.prototype.set = function(e, t) {
                            this.map[c(e)] = f(t);
                        }, p.prototype.forEach = function(e, t) {
                            for(var n in this.map)this.map.hasOwnProperty(n) && e.call(t, this.map[n], n, this);
                        }, p.prototype.keys = function() {
                            var e = [];
                            return this.forEach(function(t, n) {
                                e.push(n);
                            }), l(e);
                        }, p.prototype.values = function() {
                            var e = [];
                            return this.forEach(function(t) {
                                e.push(t);
                            }), l(e);
                        }, p.prototype.entries = function() {
                            var e = [];
                            return this.forEach(function(t, n) {
                                e.push([
                                    n,
                                    t
                                ]);
                            }), l(e);
                        }, r && (p.prototype[Symbol.iterator] = p.prototype.entries);
                        var m = [
                            "DELETE",
                            "GET",
                            "HEAD",
                            "OPTIONS",
                            "POST",
                            "PUT"
                        ];
                        function b(e, t) {
                            var n, r, o = (t = t || {}).body;
                            if (e instanceof b) {
                                if (e.bodyUsed) throw new TypeError("Already read");
                                this.url = e.url, this.credentials = e.credentials, t.headers || (this.headers = new p(e.headers)), this.method = e.method, this.mode = e.mode, this.signal = e.signal, o || null == e._bodyInit || (o = e._bodyInit, e.bodyUsed = !0);
                            } else this.url = String(e);
                            if (this.credentials = t.credentials || this.credentials || "same-origin", !t.headers && this.headers || (this.headers = new p(t.headers)), this.method = (r = (n = t.method || this.method || "GET").toUpperCase(), m.indexOf(r) > -1 ? r : n), this.mode = t.mode || this.mode || null, this.signal = t.signal || this.signal, this.referrer = null, ("GET" === this.method || "HEAD" === this.method) && o) throw new TypeError("Body not allowed for GET or HEAD requests");
                            this._initBody(o);
                        }
                        function k(e) {
                            var t = new FormData;
                            return e.trim().split("&").forEach(function(e) {
                                if (e) {
                                    var n = e.split("="), r = n.shift().replace(/\+/g, " "), o = n.join("=").replace(/\+/g, " ");
                                    t.append(decodeURIComponent(r), decodeURIComponent(o));
                                }
                            }), t;
                        }
                        function w(e, t) {
                            t || (t = {}), this.type = "default", this.status = void 0 === t.status ? 200 : t.status, this.ok = this.status >= 200 && this.status < 300, this.statusText = "statusText" in t ? t.statusText : "OK", this.headers = new p(t.headers), this.url = t.url || "", this._initBody(e);
                        }
                        b.prototype.clone = function() {
                            return new b(this, {
                                body: this._bodyInit
                            });
                        }, y.call(b.prototype), y.call(w.prototype), w.prototype.clone = function() {
                            return new w(this._bodyInit, {
                                status: this.status,
                                statusText: this.statusText,
                                headers: new p(this.headers),
                                url: this.url
                            });
                        }, w.error = function() {
                            var e = new w(null, {
                                status: 0,
                                statusText: ""
                            });
                            return e.type = "error", e;
                        };
                        var x = [
                            301,
                            302,
                            303,
                            307,
                            308
                        ];
                        w.redirect = function(e, t) {
                            if (-1 === x.indexOf(t)) throw new RangeError("Invalid status code");
                            return new w(null, {
                                status: t,
                                headers: {
                                    location: e
                                }
                            });
                        }, t.DOMException = e.DOMException;
                        try {
                            new t.DOMException;
                        } catch (e) {
                            t.DOMException = function(e, t) {
                                this.message = e, this.name = t;
                                var n = Error(e);
                                this.stack = n.stack;
                            }, t.DOMException.prototype = Object.create(Error.prototype), t.DOMException.prototype.constructor = t.DOMException;
                        }
                        function S(e, n) {
                            return new Promise(function(r, i) {
                                var a = new b(e, n);
                                if (a.signal && a.signal.aborted) return i(new t.DOMException("Aborted", "AbortError"));
                                var u = new XMLHttpRequest;
                                function s() {
                                    u.abort();
                                }
                                u.onload = function() {
                                    var e, t, n = {
                                        status: u.status,
                                        statusText: u.statusText,
                                        headers: (e = u.getAllResponseHeaders() || "", t = new p, e.replace(/\r?\n[\t ]+/g, " ").split(/\r?\n/).forEach(function(e) {
                                            var n = e.split(":"), r = n.shift().trim();
                                            if (r) {
                                                var o = n.join(":").trim();
                                                t.append(r, o);
                                            }
                                        }), t)
                                    };
                                    n.url = "responseURL" in u ? u.responseURL : n.headers.get("X-Request-URL");
                                    var o = "response" in u ? u.response : u.responseText;
                                    r(new w(o, n));
                                }, u.onerror = function() {
                                    i(new TypeError("Network request failed"));
                                }, u.ontimeout = function() {
                                    i(new TypeError("Network request failed"));
                                }, u.onabort = function() {
                                    i(new t.DOMException("Aborted", "AbortError"));
                                }, u.open(a.method, a.url, !0), "include" === a.credentials ? u.withCredentials = !0 : "omit" === a.credentials && (u.withCredentials = !1), "responseType" in u && o && (u.responseType = "blob"), a.headers.forEach(function(e, t) {
                                    u.setRequestHeader(t, e);
                                }), a.signal && (a.signal.addEventListener("abort", s), u.onreadystatechange = function() {
                                    4 === u.readyState && a.signal.removeEventListener("abort", s);
                                }), u.send(void 0 === a._bodyInit ? null : a._bodyInit);
                            });
                        }
                        S.polyfill = !0, e.fetch || (e.fetch = S, e.Headers = p, e.Request = b, e.Response = w), t.Headers = p, t.Request = b, t.Response = w, t.fetch = S, Object.defineProperty(t, "__esModule", {
                            value: !0
                        });
                    }({});
                }(r), r.fetch.ponyfill = !0, delete r.fetch.polyfill;
                var o = r;
                (t = o.fetch).default = o.fetch, t.fetch = o.fetch, t.Headers = o.Headers, t.Request = o.Request, t.Response = o.Response, e.exports = t;
            },
            6808: function(e, t, n) {
                var r, o, i;
                i = function() {
                    function e() {
                        for(var e = 0, t = {}; e < arguments.length; e++){
                            var n = arguments[e];
                            for(var r in n)t[r] = n[r];
                        }
                        return t;
                    }
                    function t(e) {
                        return e.replace(/(%[0-9A-Z]{2})+/g, decodeURIComponent);
                    }
                    return function n(r) {
                        function o() {}
                        function i(t, n, i) {
                            if ("undefined" != typeof document) {
                                "number" == typeof (i = e({
                                    path: "/"
                                }, o.defaults, i)).expires && (i.expires = new Date(1 * new Date + 864e5 * i.expires)), i.expires = i.expires ? i.expires.toUTCString() : "";
                                try {
                                    var a = JSON.stringify(n);
                                    /^[\{\[]/.test(a) && (n = a);
                                } catch (e) {}
                                n = r.write ? r.write(n, t) : encodeURIComponent(String(n)).replace(/%(23|24|26|2B|3A|3C|3E|3D|2F|3F|40|5B|5D|5E|60|7B|7D|7C)/g, decodeURIComponent), t = encodeURIComponent(String(t)).replace(/%(23|24|26|2B|5E|60|7C)/g, decodeURIComponent).replace(/[\(\)]/g, escape);
                                var u = "";
                                for(var s in i)i[s] && (u += "; " + s, !0 !== i[s] && (u += "=" + i[s].split(";")[0]));
                                return document.cookie = t + "=" + n + u;
                            }
                        }
                        function a(e, n) {
                            if ("undefined" != typeof document) {
                                for(var o = {}, i = document.cookie ? document.cookie.split("; ") : [], a = 0; a < i.length; a++){
                                    var u = i[a].split("="), s = u.slice(1).join("=");
                                    n || '"' !== s.charAt(0) || (s = s.slice(1, -1));
                                    try {
                                        var c = t(u[0]);
                                        if (s = (r.read || r)(s, c) || t(s), n) try {
                                            s = JSON.parse(s);
                                        } catch (e) {}
                                        if (o[c] = s, e === c) break;
                                    } catch (e) {}
                                }
                                return e ? o[e] : o;
                            }
                        }
                        return o.set = i, o.get = function(e) {
                            return a(e, !1);
                        }, o.getJSON = function(e) {
                            return a(e, !0);
                        }, o.remove = function(t, n) {
                            i(t, "", e(n, {
                                expires: -1
                            }));
                        }, o.defaults = {}, o.withConverter = n, o;
                    }(function() {});
                }, void 0 === (o = "function" == typeof (r = i) ? r.call(t, n, t, e) : r) || (e.exports = o), e.exports = i();
            },
            5653: function(e, t, n) {
                "use strict";
                function r(e) {
                    return r = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
                        return typeof e;
                    } : function(e) {
                        return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
                    }, r(e);
                }
                function o(e) {
                    return o = Object.setPrototypeOf ? Object.getPrototypeOf : function(e) {
                        return e.__proto__ || Object.getPrototypeOf(e);
                    }, o(e);
                }
                function i(e, t) {
                    return i = Object.setPrototypeOf || function(e, t) {
                        return e.__proto__ = t, e;
                    }, i(e, t);
                }
                function a() {
                    if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                    if (Reflect.construct.sham) return !1;
                    if ("function" == typeof Proxy) return !0;
                    try {
                        return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
                    } catch (e) {
                        return !1;
                    }
                }
                function u(e, t, n) {
                    return u = a() ? Reflect.construct : function(e, t, n) {
                        var r = [
                            null
                        ];
                        r.push.apply(r, t);
                        var o = new (Function.bind.apply(e, r));
                        return n && i(o, n.prototype), o;
                    }, u.apply(null, arguments);
                }
                function s(e) {
                    var t = "function" == typeof Map ? new Map : void 0;
                    return s = function(e) {
                        if (null === e || (n = e, -1 === Function.toString.call(n).indexOf("[native code]"))) return e;
                        var n;
                        if ("function" != typeof e) throw new TypeError("Super expression must either be null or a function");
                        if (void 0 !== t) {
                            if (t.has(e)) return t.get(e);
                            t.set(e, r);
                        }
                        function r() {
                            return u(e, arguments, o(this).constructor);
                        }
                        return r.prototype = Object.create(e.prototype, {
                            constructor: {
                                value: r,
                                enumerable: !1,
                                writable: !0,
                                configurable: !0
                            }
                        }), i(r, e);
                    }, s(e);
                }
                function c(e, t) {
                    return !t || "object" != typeof t && "function" != typeof t ? function(e) {
                        if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                        return e;
                    }(e) : t;
                }
                function f(e) {
                    return function(e) {
                        if (Array.isArray(e)) return p(e);
                    }(e) || function(e) {
                        if ("undefined" != typeof Symbol && null != e[Symbol.iterator] || null != e["@@iterator"]) return Array.from(e);
                    }(e) || l(e) || function() {
                        throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
                    }();
                }
                function l(e, t) {
                    if (e) {
                        if ("string" == typeof e) return p(e, t);
                        var n = Object.prototype.toString.call(e).slice(8, -1);
                        return "Object" === n && e.constructor && (n = e.constructor.name), "Map" === n || "Set" === n ? Array.from(e) : "Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? p(e, t) : void 0;
                    }
                }
                function p(e, t) {
                    (null == t || t > e.length) && (t = e.length);
                    for(var n = 0, r = new Array(t); n < t; n++)r[n] = e[n];
                    return r;
                }
                n.r(t), n.d(t, {
                    JSONPath: function() {
                        return y;
                    }
                });
                var h = Object.prototype.hasOwnProperty;
                function d(e, t) {
                    return (e = e.slice()).push(t), e;
                }
                function v(e, t) {
                    return (t = t.slice()).unshift(e), t;
                }
                var g = function(e) {
                    !function(e, t) {
                        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
                        e.prototype = Object.create(t && t.prototype, {
                            constructor: {
                                value: e,
                                writable: !0,
                                configurable: !0
                            }
                        }), t && i(e, t);
                    }(u, e);
                    var t, n, r = (t = u, n = a(), function() {
                        var e, r = o(t);
                        if (n) {
                            var i = o(this).constructor;
                            e = Reflect.construct(r, arguments, i);
                        } else e = r.apply(this, arguments);
                        return c(this, e);
                    });
                    function u(e) {
                        var t;
                        return function(e, t) {
                            if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
                        }(this, u), (t = r.call(this, 'JSONPath should not be called with "new" (it prevents return of (unwrapped) scalar values)')).avoidNew = !0, t.value = e, t.name = "NewError", t;
                    }
                    return u;
                }(s(Error));
                function y(e, t, n, o, i) {
                    if (!(this instanceof y)) try {
                        return new y(e, t, n, o, i);
                    } catch (e) {
                        if (!e.avoidNew) throw e;
                        return e.value;
                    }
                    "string" == typeof e && (i = o, o = n, n = t, t = e, e = null);
                    var a = e && "object" === r(e);
                    if (e = e || {}, this.json = e.json || n, this.path = e.path || t, this.resultType = e.resultType || "value", this.flatten = e.flatten || !1, this.wrap = !h.call(e, "wrap") || e.wrap, this.sandbox = e.sandbox || {}, this.preventEval = e.preventEval || !1, this.parent = e.parent || null, this.parentProperty = e.parentProperty || null, this.callback = e.callback || o || null, this.otherTypeCallback = e.otherTypeCallback || i || function() {
                        throw new TypeError("You must supply an otherTypeCallback callback option with the @other() operator.");
                    }, !1 !== e.autostart) {
                        var u = {
                            path: a ? e.path : t
                        };
                        a ? "json" in e && (u.json = e.json) : u.json = n;
                        var s = this.evaluate(u);
                        if (!s || "object" !== r(s)) throw new g(s);
                        return s;
                    }
                }
                y.prototype.evaluate = function(e, t, n, o) {
                    var i = this, a = this.parent, u = this.parentProperty, s = this.flatten, c = this.wrap;
                    if (this.currResultType = this.resultType, this.currPreventEval = this.preventEval, this.currSandbox = this.sandbox, n = n || this.callback, this.currOtherTypeCallback = o || this.otherTypeCallback, t = t || this.json, (e = e || this.path) && "object" === r(e) && !Array.isArray(e)) {
                        if (!e.path && "" !== e.path) throw new TypeError('You must supply a "path" property when providing an object argument to JSONPath.evaluate().');
                        if (!h.call(e, "json")) throw new TypeError('You must supply a "json" property when providing an object argument to JSONPath.evaluate().');
                        t = e.json, s = h.call(e, "flatten") ? e.flatten : s, this.currResultType = h.call(e, "resultType") ? e.resultType : this.currResultType, this.currSandbox = h.call(e, "sandbox") ? e.sandbox : this.currSandbox, c = h.call(e, "wrap") ? e.wrap : c, this.currPreventEval = h.call(e, "preventEval") ? e.preventEval : this.currPreventEval, n = h.call(e, "callback") ? e.callback : n, this.currOtherTypeCallback = h.call(e, "otherTypeCallback") ? e.otherTypeCallback : this.currOtherTypeCallback, a = h.call(e, "parent") ? e.parent : a, u = h.call(e, "parentProperty") ? e.parentProperty : u, e = e.path;
                    }
                    if (a = a || null, u = u || null, Array.isArray(e) && (e = y.toPathString(e)), (e || "" === e) && t) {
                        var f = y.toPathArray(e);
                        "$" === f[0] && f.length > 1 && f.shift(), this._hasParentSelector = null;
                        var l = this._trace(f, t, [
                            "$"
                        ], a, u, n).filter(function(e) {
                            return e && !e.isParentSelector;
                        });
                        return l.length ? c || 1 !== l.length || l[0].hasArrExpr ? l.reduce(function(e, t) {
                            var n = i._getPreferredOutput(t);
                            return s && Array.isArray(n) ? e = e.concat(n) : e.push(n), e;
                        }, []) : this._getPreferredOutput(l[0]) : c ? [] : void 0;
                    }
                }, y.prototype._getPreferredOutput = function(e) {
                    var t = this.currResultType;
                    switch(t){
                        case "all":
                            var n = Array.isArray(e.path) ? e.path : y.toPathArray(e.path);
                            return e.pointer = y.toPointer(n), e.path = "string" == typeof e.path ? e.path : y.toPathString(e.path), e;
                        case "value":
                        case "parent":
                        case "parentProperty":
                            return e[t];
                        case "path":
                            return y.toPathString(e[t]);
                        case "pointer":
                            return y.toPointer(e.path);
                        default:
                            throw new TypeError("Unknown result type");
                    }
                }, y.prototype._handleCallback = function(e, t, n) {
                    if (t) {
                        var r = this._getPreferredOutput(e);
                        e.path = "string" == typeof e.path ? e.path : y.toPathString(e.path), t(r, n, e);
                    }
                }, y.prototype._trace = function(e, t, n, o, i, a, u, s) {
                    var c, f = this;
                    if (!e.length) return c = {
                        path: n,
                        value: t,
                        parent: o,
                        parentProperty: i,
                        hasArrExpr: u
                    }, this._handleCallback(c, a, "value"), c;
                    var p = e[0], g = e.slice(1), y = [];
                    function m(e) {
                        Array.isArray(e) ? e.forEach(function(e) {
                            y.push(e);
                        }) : y.push(e);
                    }
                    if (("string" != typeof p || s) && t && h.call(t, p)) m(this._trace(g, t[p], d(n, p), t, p, a, u));
                    else if ("*" === p) this._walk(p, g, t, n, o, i, a, function(e, t, n, r, o, i, a, u) {
                        m(f._trace(v(e, n), r, o, i, a, u, !0, !0));
                    });
                    else if (".." === p) m(this._trace(g, t, n, o, i, a, u)), this._walk(p, g, t, n, o, i, a, function(e, t, n, o, i, a, u, s) {
                        "object" === r(o[e]) && m(f._trace(v(t, n), o[e], d(i, e), o, e, s, !0));
                    });
                    else {
                        if ("^" === p) return this._hasParentSelector = !0, {
                            path: n.slice(0, -1),
                            expr: g,
                            isParentSelector: !0
                        };
                        if ("~" === p) return c = {
                            path: d(n, p),
                            value: i,
                            parent: o,
                            parentProperty: null
                        }, this._handleCallback(c, a, "property"), c;
                        if ("$" === p) m(this._trace(g, t, n, null, null, a, u));
                        else if (/^(\x2D?[0-9]*):(\x2D?[0-9]*):?([0-9]*)$/.test(p)) m(this._slice(p, g, t, n, o, i, a));
                        else if (0 === p.indexOf("?(")) {
                            if (this.currPreventEval) throw new Error("Eval [?(expr)] prevented in JSONPath expression.");
                            this._walk(p, g, t, n, o, i, a, function(e, t, n, r, o, i, a, u) {
                                f._eval(t.replace(/^\?\(((?:[\0-\t\x0B\f\x0E-\u2027\u202A-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])*?)\)$/, "$1"), r[e], e, o, i, a) && m(f._trace(v(e, n), r, o, i, a, u, !0));
                            });
                        } else if ("(" === p[0]) {
                            if (this.currPreventEval) throw new Error("Eval [(expr)] prevented in JSONPath expression.");
                            m(this._trace(v(this._eval(p, t, n[n.length - 1], n.slice(0, -1), o, i), g), t, n, o, i, a, u));
                        } else if ("@" === p[0]) {
                            var b = !1, k = p.slice(1, -2);
                            switch(k){
                                case "scalar":
                                    t && [
                                        "object",
                                        "function"
                                    ].includes(r(t)) || (b = !0);
                                    break;
                                case "boolean":
                                case "string":
                                case "undefined":
                                case "function":
                                    r(t) === k && (b = !0);
                                    break;
                                case "integer":
                                    !Number.isFinite(t) || t % 1 || (b = !0);
                                    break;
                                case "number":
                                    Number.isFinite(t) && (b = !0);
                                    break;
                                case "nonFinite":
                                    "number" != typeof t || Number.isFinite(t) || (b = !0);
                                    break;
                                case "object":
                                    t && r(t) === k && (b = !0);
                                    break;
                                case "array":
                                    Array.isArray(t) && (b = !0);
                                    break;
                                case "other":
                                    b = this.currOtherTypeCallback(t, n, o, i);
                                    break;
                                case "null":
                                    null === t && (b = !0);
                                    break;
                                default:
                                    throw new TypeError("Unknown value type " + k);
                            }
                            if (b) return c = {
                                path: n,
                                value: t,
                                parent: o,
                                parentProperty: i
                            }, this._handleCallback(c, a, "value"), c;
                        } else if ("`" === p[0] && t && h.call(t, p.slice(1))) {
                            var w = p.slice(1);
                            m(this._trace(g, t[w], d(n, w), t, w, a, u, !0));
                        } else if (p.includes(",")) {
                            var x, S = function(e, t) {
                                var n = "undefined" != typeof Symbol && e[Symbol.iterator] || e["@@iterator"];
                                if (!n) {
                                    if (Array.isArray(e) || (n = l(e))) {
                                        n && (e = n);
                                        var r = 0, o = function() {};
                                        return {
                                            s: o,
                                            n: function() {
                                                return r >= e.length ? {
                                                    done: !0
                                                } : {
                                                    done: !1,
                                                    value: e[r++]
                                                };
                                            },
                                            e: function(e) {
                                                throw e;
                                            },
                                            f: o
                                        };
                                    }
                                    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
                                }
                                var i, a = !0, u = !1;
                                return {
                                    s: function() {
                                        n = n.call(e);
                                    },
                                    n: function() {
                                        var e = n.next();
                                        return a = e.done, e;
                                    },
                                    e: function(e) {
                                        u = !0, i = e;
                                    },
                                    f: function() {
                                        try {
                                            a || null == n.return || n.return();
                                        } finally{
                                            if (u) throw i;
                                        }
                                    }
                                };
                            }(p.split(","));
                            try {
                                for(S.s(); !(x = S.n()).done;){
                                    var T = x.value;
                                    m(this._trace(v(T, g), t, n, o, i, a, !0));
                                }
                            } catch (e) {
                                S.e(e);
                            } finally{
                                S.f();
                            }
                        } else !s && t && h.call(t, p) && m(this._trace(g, t[p], d(n, p), t, p, a, u, !0));
                    }
                    if (this._hasParentSelector) for(var O = 0; O < y.length; O++){
                        var A = y[O];
                        if (A && A.isParentSelector) {
                            var E = this._trace(A.expr, t, A.path, o, i, a, u);
                            if (Array.isArray(E)) {
                                y[O] = E[0];
                                for(var _ = E.length, R = 1; R < _; R++)O++, y.splice(O, 0, E[R]);
                            } else y[O] = E;
                        }
                    }
                    return y;
                }, y.prototype._walk = function(e, t, n, o, i, a, u, s) {
                    if (Array.isArray(n)) for(var c = n.length, f = 0; f < c; f++)s(f, e, t, n, o, i, a, u);
                    else n && "object" === r(n) && Object.keys(n).forEach(function(r) {
                        s(r, e, t, n, o, i, a, u);
                    });
                }, y.prototype._slice = function(e, t, n, r, o, i, a) {
                    if (Array.isArray(n)) {
                        var u = n.length, s = e.split(":"), c = s[2] && Number.parseInt(s[2]) || 1, f = s[0] && Number.parseInt(s[0]) || 0, l = s[1] && Number.parseInt(s[1]) || u;
                        f = f < 0 ? Math.max(0, f + u) : Math.min(u, f), l = l < 0 ? Math.max(0, l + u) : Math.min(u, l);
                        for(var p = [], h = f; h < l; h += c)this._trace(v(h, t), n, r, o, i, a, !0).forEach(function(e) {
                            p.push(e);
                        });
                        return p;
                    }
                }, y.prototype._eval = function(e, t, n, r, o, i) {
                    e.includes("@parentProperty") && (this.currSandbox._$_parentProperty = i, e = e.replace(/@parentProperty/g, "_$_parentProperty")), e.includes("@parent") && (this.currSandbox._$_parent = o, e = e.replace(/@parent/g, "_$_parent")), e.includes("@property") && (this.currSandbox._$_property = n, e = e.replace(/@property/g, "_$_property")), e.includes("@path") && (this.currSandbox._$_path = y.toPathString(r.concat([
                        n
                    ])), e = e.replace(/@path/g, "_$_path")), e.includes("@root") && (this.currSandbox._$_root = this.json, e = e.replace(/@root/g, "_$_root")), /@([\t-\r \)\.\[\xA0\u1680\u2000-\u200A\u2028\u2029\u202F\u205F\u3000\uFEFF])/.test(e) && (this.currSandbox._$_v = t, e = e.replace(/@([\t-\r \)\.\[\xA0\u1680\u2000-\u200A\u2028\u2029\u202F\u205F\u3000\uFEFF])/g, "_$_v$1"));
                    try {
                        return this.vm.runInNewContext(e, this.currSandbox);
                    } catch (t) {
                        throw console.log(t), new Error("jsonPath: " + t.message + ": " + e);
                    }
                }, y.cache = {}, y.toPathString = function(e) {
                    for(var t = e, n = t.length, r = "$", o = 1; o < n; o++)/^(~|\^|@(?:[\0-\t\x0B\f\x0E-\u2027\u202A-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])*?\(\))$/.test(t[o]) || (r += /^[\*0-9]+$/.test(t[o]) ? "[" + t[o] + "]" : "['" + t[o] + "']");
                    return r;
                }, y.toPointer = function(e) {
                    for(var t = e, n = t.length, r = "", o = 1; o < n; o++)/^(~|\^|@(?:[\0-\t\x0B\f\x0E-\u2027\u202A-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])*?\(\))$/.test(t[o]) || (r += "/" + t[o].toString().replace(/~/g, "~0").replace(/\//g, "~1"));
                    return r;
                }, y.toPathArray = function(e) {
                    var t = y.cache;
                    if (t[e]) return t[e].concat();
                    var n = [], r = e.replace(/@(?:null|boolean|number|string|integer|undefined|nonFinite|scalar|array|object|function|other)\(\)/g, ";$&;").replace(/['\[](\??\((?:[\0-\t\x0B\f\x0E-\u2027\u202A-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])*?\))['\]]/g, function(e, t) {
                        return "[#" + (n.push(t) - 1) + "]";
                    }).replace(/\[["']((?:(?!['\]])[\s\S])*)["']\]/g, function(e, t) {
                        return "['" + t.replace(/\./g, "%@%").replace(/~/g, "%%@@%%") + "']";
                    }).replace(/~/g, ";~;").replace(/["']?\.["']?(?!(?:(?!\[)[\s\S])*\])|\[["']?/g, ";").replace(/%@%/g, ".").replace(/%%@@%%/g, "~").replace(/(?:;)?(\^+)(?:;)?/g, function(e, t) {
                        return ";" + t.split("").join(";") + ";";
                    }).replace(/;;;|;;/g, ";..;").replace(/;$|'?\]|'$/g, "").split(";").map(function(e) {
                        var t = e.match(/#([0-9]+)/);
                        return t && t[1] ? n[t[1]] : e;
                    });
                    return t[e] = r, t[e].concat();
                }, y.prototype.vm = {
                    runInNewContext: function(e, t) {
                        var n = Object.keys(t), r = [];
                        !function(e, n, r) {
                            for(var o = e.length, i = 0; i < o; i++)a = e[i], "function" == typeof t[a] && n.push(e.splice(i--, 1)[0]);
                            var a;
                        }(n, r);
                        var o = n.map(function(e, n) {
                            return t[e];
                        }), i = r.reduce(function(e, n) {
                            var r = t[n].toString();
                            return /function/.test(r) || (r = "function " + r), "var " + n + "=" + r + ";" + e;
                        }, "");
                        /(["'])use strict\1/.test(e = i + e) || n.includes("arguments") || (e = "var arguments = undefined;" + e);
                        var a = (e = e.replace(/;[\t-\r \xA0\u1680\u2000-\u200A\u2028\u2029\u202F\u205F\u3000\uFEFF]*$/, "")).lastIndexOf(";"), s = a > -1 ? e.slice(0, a + 1) + " return " + e.slice(a + 1) : " return " + e;
                        return u(Function, f(n).concat([
                            s
                        ])).apply(void 0, f(o));
                    }
                };
            },
            5666: function(e) {
                var t = function(e) {
                    "use strict";
                    var t, n = Object.prototype, r = n.hasOwnProperty, o = "function" == typeof Symbol ? Symbol : {}, i = o.iterator || "@@iterator", a = o.asyncIterator || "@@asyncIterator", u = o.toStringTag || "@@toStringTag";
                    function s(e, t, n) {
                        return Object.defineProperty(e, t, {
                            value: n,
                            enumerable: !0,
                            configurable: !0,
                            writable: !0
                        }), e[t];
                    }
                    try {
                        s({}, "");
                    } catch (e) {
                        s = function(e, t, n) {
                            return e[t] = n;
                        };
                    }
                    function c(e, t, n, r) {
                        var o = t && t.prototype instanceof g ? t : g, i = Object.create(o.prototype), a = new _(r || []);
                        return i._invoke = function(e, t, n) {
                            var r = l;
                            return function(o, i) {
                                if (r === h) throw new Error("Generator is already running");
                                if (r === d) {
                                    if ("throw" === o) throw i;
                                    return P();
                                }
                                for(n.method = o, n.arg = i;;){
                                    var a = n.delegate;
                                    if (a) {
                                        var u = O(a, n);
                                        if (u) {
                                            if (u === v) continue;
                                            return u;
                                        }
                                    }
                                    if ("next" === n.method) n.sent = n._sent = n.arg;
                                    else if ("throw" === n.method) {
                                        if (r === l) throw r = d, n.arg;
                                        n.dispatchException(n.arg);
                                    } else "return" === n.method && n.abrupt("return", n.arg);
                                    r = h;
                                    var s = f(e, t, n);
                                    if ("normal" === s.type) {
                                        if (r = n.done ? d : p, s.arg === v) continue;
                                        return {
                                            value: s.arg,
                                            done: n.done
                                        };
                                    }
                                    "throw" === s.type && (r = d, n.method = "throw", n.arg = s.arg);
                                }
                            };
                        }(e, n, a), i;
                    }
                    function f(e, t, n) {
                        try {
                            return {
                                type: "normal",
                                arg: e.call(t, n)
                            };
                        } catch (e) {
                            return {
                                type: "throw",
                                arg: e
                            };
                        }
                    }
                    e.wrap = c;
                    var l = "suspendedStart", p = "suspendedYield", h = "executing", d = "completed", v = {};
                    function g() {}
                    function y() {}
                    function m() {}
                    var b = {};
                    b[i] = function() {
                        return this;
                    };
                    var k = Object.getPrototypeOf, w = k && k(k(R([])));
                    w && w !== n && r.call(w, i) && (b = w);
                    var x = m.prototype = g.prototype = Object.create(b);
                    function S(e) {
                        [
                            "next",
                            "throw",
                            "return"
                        ].forEach(function(t) {
                            s(e, t, function(e) {
                                return this._invoke(t, e);
                            });
                        });
                    }
                    function T(e, t) {
                        function n(o, i, a, u) {
                            var s = f(e[o], e, i);
                            if ("throw" !== s.type) {
                                var c = s.arg, l = c.value;
                                return l && "object" == typeof l && r.call(l, "__await") ? t.resolve(l.__await).then(function(e) {
                                    n("next", e, a, u);
                                }, function(e) {
                                    n("throw", e, a, u);
                                }) : t.resolve(l).then(function(e) {
                                    c.value = e, a(c);
                                }, function(e) {
                                    return n("throw", e, a, u);
                                });
                            }
                            u(s.arg);
                        }
                        var o;
                        this._invoke = function(e, r) {
                            function i() {
                                return new t(function(t, o) {
                                    n(e, r, t, o);
                                });
                            }
                            return o = o ? o.then(i, i) : i();
                        };
                    }
                    function O(e, n) {
                        var r = e.iterator[n.method];
                        if (r === t) {
                            if (n.delegate = null, "throw" === n.method) {
                                if (e.iterator.return && (n.method = "return", n.arg = t, O(e, n), "throw" === n.method)) return v;
                                n.method = "throw", n.arg = new TypeError("The iterator does not provide a 'throw' method");
                            }
                            return v;
                        }
                        var o = f(r, e.iterator, n.arg);
                        if ("throw" === o.type) return n.method = "throw", n.arg = o.arg, n.delegate = null, v;
                        var i = o.arg;
                        return i ? i.done ? (n[e.resultName] = i.value, n.next = e.nextLoc, "return" !== n.method && (n.method = "next", n.arg = t), n.delegate = null, v) : i : (n.method = "throw", n.arg = new TypeError("iterator result is not an object"), n.delegate = null, v);
                    }
                    function A(e) {
                        var t = {
                            tryLoc: e[0]
                        };
                        1 in e && (t.catchLoc = e[1]), 2 in e && (t.finallyLoc = e[2], t.afterLoc = e[3]), this.tryEntries.push(t);
                    }
                    function E(e) {
                        var t = e.completion || {};
                        t.type = "normal", delete t.arg, e.completion = t;
                    }
                    function _(e) {
                        this.tryEntries = [
                            {
                                tryLoc: "root"
                            }
                        ], e.forEach(A, this), this.reset(!0);
                    }
                    function R(e) {
                        if (e) {
                            var n = e[i];
                            if (n) return n.call(e);
                            if ("function" == typeof e.next) return e;
                            if (!isNaN(e.length)) {
                                var o = -1, a = function n() {
                                    for(; ++o < e.length;)if (r.call(e, o)) return n.value = e[o], n.done = !1, n;
                                    return n.value = t, n.done = !0, n;
                                };
                                return a.next = a;
                            }
                        }
                        return {
                            next: P
                        };
                    }
                    function P() {
                        return {
                            value: t,
                            done: !0
                        };
                    }
                    return y.prototype = x.constructor = m, m.constructor = y, y.displayName = s(m, u, "GeneratorFunction"), e.isGeneratorFunction = function(e) {
                        var t = "function" == typeof e && e.constructor;
                        return !!t && (t === y || "GeneratorFunction" === (t.displayName || t.name));
                    }, e.mark = function(e) {
                        return Object.setPrototypeOf ? Object.setPrototypeOf(e, m) : (e.__proto__ = m, s(e, u, "GeneratorFunction")), e.prototype = Object.create(x), e;
                    }, e.awrap = function(e) {
                        return {
                            __await: e
                        };
                    }, S(T.prototype), T.prototype[a] = function() {
                        return this;
                    }, e.AsyncIterator = T, e.async = function(t, n, r, o, i) {
                        void 0 === i && (i = Promise);
                        var a = new T(c(t, n, r, o), i);
                        return e.isGeneratorFunction(n) ? a : a.next().then(function(e) {
                            return e.done ? e.value : a.next();
                        });
                    }, S(x), s(x, u, "Generator"), x[i] = function() {
                        return this;
                    }, x.toString = function() {
                        return "[object Generator]";
                    }, e.keys = function(e) {
                        var t = [];
                        for(var n in e)t.push(n);
                        return t.reverse(), function n() {
                            for(; t.length;){
                                var r = t.pop();
                                if (r in e) return n.value = r, n.done = !1, n;
                            }
                            return n.done = !0, n;
                        };
                    }, e.values = R, _.prototype = {
                        constructor: _,
                        reset: function(e) {
                            if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(E), !e) for(var n in this)"t" === n.charAt(0) && r.call(this, n) && !isNaN(+n.slice(1)) && (this[n] = t);
                        },
                        stop: function() {
                            this.done = !0;
                            var e = this.tryEntries[0].completion;
                            if ("throw" === e.type) throw e.arg;
                            return this.rval;
                        },
                        dispatchException: function(e) {
                            if (this.done) throw e;
                            var n = this;
                            function o(r, o) {
                                return u.type = "throw", u.arg = e, n.next = r, o && (n.method = "next", n.arg = t), !!o;
                            }
                            for(var i = this.tryEntries.length - 1; i >= 0; --i){
                                var a = this.tryEntries[i], u = a.completion;
                                if ("root" === a.tryLoc) return o("end");
                                if (a.tryLoc <= this.prev) {
                                    var s = r.call(a, "catchLoc"), c = r.call(a, "finallyLoc");
                                    if (s && c) {
                                        if (this.prev < a.catchLoc) return o(a.catchLoc, !0);
                                        if (this.prev < a.finallyLoc) return o(a.finallyLoc);
                                    } else if (s) {
                                        if (this.prev < a.catchLoc) return o(a.catchLoc, !0);
                                    } else {
                                        if (!c) throw new Error("try statement without catch or finally");
                                        if (this.prev < a.finallyLoc) return o(a.finallyLoc);
                                    }
                                }
                            }
                        },
                        abrupt: function(e, t) {
                            for(var n = this.tryEntries.length - 1; n >= 0; --n){
                                var o = this.tryEntries[n];
                                if (o.tryLoc <= this.prev && r.call(o, "finallyLoc") && this.prev < o.finallyLoc) {
                                    var i = o;
                                    break;
                                }
                            }
                            i && ("break" === e || "continue" === e) && i.tryLoc <= t && t <= i.finallyLoc && (i = null);
                            var a = i ? i.completion : {};
                            return a.type = e, a.arg = t, i ? (this.method = "next", this.next = i.finallyLoc, v) : this.complete(a);
                        },
                        complete: function(e, t) {
                            if ("throw" === e.type) throw e.arg;
                            return "break" === e.type || "continue" === e.type ? this.next = e.arg : "return" === e.type ? (this.rval = this.arg = e.arg, this.method = "return", this.next = "end") : "normal" === e.type && t && (this.next = t), v;
                        },
                        finish: function(e) {
                            for(var t = this.tryEntries.length - 1; t >= 0; --t){
                                var n = this.tryEntries[t];
                                if (n.finallyLoc === e) return this.complete(n.completion, n.afterLoc), E(n), v;
                            }
                        },
                        catch: function(e) {
                            for(var t = this.tryEntries.length - 1; t >= 0; --t){
                                var n = this.tryEntries[t];
                                if (n.tryLoc === e) {
                                    var r = n.completion;
                                    if ("throw" === r.type) {
                                        var o = r.arg;
                                        E(n);
                                    }
                                    return o;
                                }
                            }
                            throw new Error("illegal catch attempt");
                        },
                        delegateYield: function(e, n, r) {
                            return this.delegate = {
                                iterator: R(e),
                                resultName: n,
                                nextLoc: r
                            }, "next" === this.method && (this.arg = t), v;
                        }
                    }, e;
                }(e.exports);
                try {
                    regeneratorRuntime = t;
                } catch (e) {
                    Function("r", "regeneratorRuntime = r")(t);
                }
            },
            4279: function(e) {
                function t() {}
                t.prototype = {
                    on: function(e, t, n) {
                        var r = this.e || (this.e = {});
                        return (r[e] || (r[e] = [])).push({
                            fn: t,
                            ctx: n
                        }), this;
                    },
                    once: function(e, t, n) {
                        var r = this;
                        function o() {
                            r.off(e, o), t.apply(n, arguments);
                        }
                        return o._ = t, this.on(e, o, n);
                    },
                    emit: function(e) {
                        for(var t = [].slice.call(arguments, 1), n = ((this.e || (this.e = {}))[e] || []).slice(), r = 0, o = n.length; r < o; r++)n[r].fn.apply(n[r].ctx, t);
                        return this;
                    },
                    off: function(e, t) {
                        var n = this.e || (this.e = {}), r = n[e], o = [];
                        if (r && t) for(var i = 0, a = r.length; i < a; i++)r[i].fn !== t && r[i].fn._ !== t && o.push(r[i]);
                        return o.length ? n[e] = o : delete n[e], this;
                    }
                }, e.exports = t;
            },
            9148: function() {}
        }, t = {};
        function n(r) {
            var o = t[r];
            if (void 0 !== o) return o.exports;
            var i = t[r] = {
                exports: {}
            };
            return e[r].call(i.exports, i, i.exports, n), i.exports;
        }
        n.n = function(e) {
            var t = e && e.__esModule ? function() {
                return e.default;
            } : function() {
                return e;
            };
            return n.d(t, {
                a: t
            }), t;
        }, n.d = function(e, t) {
            for(var r in t)n.o(t, r) && !n.o(e, r) && Object.defineProperty(e, r, {
                enumerable: !0,
                get: t[r]
            });
        }, n.g = function() {
            if ("object" == typeof globalThis) return globalThis;
            try {
                return this || new Function("return this")();
            } catch (e) {
                if ("object" == typeof window) return window;
            }
        }(), n.o = function(e, t) {
            return Object.prototype.hasOwnProperty.call(e, t);
        }, n.r = function(e) {
            "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
                value: "Module"
            }), Object.defineProperty(e, "__esModule", {
                value: !0
            });
        };
        var r = {};
        return function() {
            "use strict";
            n.r(r), n.d(r, {
                ACCESS_TOKEN_STORAGE_KEY: function() {
                    return oe;
                },
                AuthApiError: function() {
                    return y;
                },
                AuthPollStopError: function() {
                    return m;
                },
                AuthSdkError: function() {
                    return b;
                },
                AuthStateManager: function() {
                    return Yn;
                },
                AuthTransaction: function() {
                    return Ie;
                },
                AuthenticatorKey: function() {
                    return dt;
                },
                CACHE_STORAGE_NAME: function() {
                    return Q;
                },
                DEFAULT_CACHE_DURATION: function() {
                    return $;
                },
                DEFAULT_CODE_CHALLENGE_METHOD: function() {
                    return fe;
                },
                DEFAULT_MAX_CLOCK_SKEW: function() {
                    return W;
                },
                DEFAULT_POLLING_DELAY: function() {
                    return G;
                },
                EVENT_ADDED: function() {
                    return Dn;
                },
                EVENT_ERROR: function() {
                    return qn;
                },
                EVENT_EXPIRED: function() {
                    return Nn;
                },
                EVENT_REMOVED: function() {
                    return Bn;
                },
                EVENT_RENEWED: function() {
                    return Ln;
                },
                IDX_API_VERSION: function() {
                    return le;
                },
                IDX_RESPONSE_STORAGE_NAME: function() {
                    return re;
                },
                ID_TOKEN_STORAGE_KEY: function() {
                    return ie;
                },
                INITIAL_AUTH_STATE: function() {
                    return $n;
                },
                IdxFeature: function() {
                    return vt;
                },
                IdxStatus: function() {
                    return ht;
                },
                MAX_VERIFIER_LENGTH: function() {
                    return ce;
                },
                MIN_VERIFIER_LENGTH: function() {
                    return se;
                },
                OAuthError: function() {
                    return k;
                },
                ORIGINAL_URI_STORAGE_NAME: function() {
                    return ne;
                },
                OktaAuth: function() {
                    return Yo;
                },
                PKCE_STORAGE_NAME: function() {
                    return Z;
                },
                REDIRECT_NONCE_COOKIE_NAME: function() {
                    return Y;
                },
                REDIRECT_OAUTH_PARAMS_NAME: function() {
                    return z;
                },
                REDIRECT_STATE_COOKIE_NAME: function() {
                    return J;
                },
                REFERRER_PATH_STORAGE_KEY: function() {
                    return ue;
                },
                REFRESH_TOKEN_STORAGE_KEY: function() {
                    return ae;
                },
                SHARED_TRANSACTION_STORAGE_NAME: function() {
                    return te;
                },
                STATE_TOKEN_KEY_NAME: function() {
                    return V;
                },
                TOKEN_STORAGE_NAME: function() {
                    return X;
                },
                TRANSACTION_STORAGE_NAME: function() {
                    return ee;
                },
                TokenManager: function() {
                    return Hn;
                },
                TransactionState: function() {
                    return Be;
                },
                addListener: function() {
                    return nt;
                },
                addPostMessageListener: function() {
                    return at;
                },
                addStateToken: function() {
                    return Ae;
                },
                bind: function() {
                    return I;
                },
                buildAuthorizeParams: function() {
                    return Je;
                },
                clone: function() {
                    return U;
                },
                convertTokenParamsToOAuthParams: function() {
                    return ze;
                },
                crypto: function() {
                    return e;
                },
                decodeToken: function() {
                    return tn;
                },
                delay: function() {
                    return Pe;
                },
                deprecate: function() {
                    return Tn;
                },
                deprecateWrap: function() {
                    return On;
                },
                exchangeCodeForTokens: function() {
                    return rn;
                },
                extend: function() {
                    return C;
                },
                find: function() {
                    return N;
                },
                genRandomString: function() {
                    return Re;
                },
                generateNonce: function() {
                    return st;
                },
                generateState: function() {
                    return ut;
                },
                getConsole: function() {
                    return xn;
                },
                getDefaultTokenParams: function() {
                    return Et;
                },
                getHashOrSearch: function() {
                    return Ft;
                },
                getKey: function() {
                    return tt;
                },
                getLink: function() {
                    return L;
                },
                getNativeConsole: function() {
                    return wn;
                },
                getOAuthBaseUrl: function() {
                    return ft;
                },
                getOAuthDomain: function() {
                    return lt;
                },
                getOAuthUrls: function() {
                    return pt;
                },
                getPollFn: function() {
                    return je;
                },
                getStateToken: function() {
                    return Ee;
                },
                getToken: function() {
                    return un;
                },
                getUserInfo: function() {
                    return dn;
                },
                getWellKnown: function() {
                    return et;
                },
                getWithPopup: function() {
                    return vn;
                },
                getWithRedirect: function() {
                    return gn;
                },
                getWithoutPrompt: function() {
                    return sn;
                },
                handleOAuthResponse: function() {
                    return an;
                },
                hasAuthorizationCode: function() {
                    return jt;
                },
                hasErrorInUrl: function() {
                    return Ct;
                },
                hasInteractionCode: function() {
                    return It;
                },
                hasTokensInHash: function() {
                    return Pt;
                },
                introspect: function() {
                    return Ne;
                },
                isAbsoluteUrl: function() {
                    return me;
                },
                isAccessToken: function() {
                    return Xt;
                },
                isAuthApiError: function() {
                    return w;
                },
                isAuthorizationCodeError: function() {
                    return Rt;
                },
                isCodeFlow: function() {
                    return Ut;
                },
                isCustomAuthTransactionMeta: function() {
                    return zt;
                },
                isEmailVerifyCallback: function() {
                    return Rn;
                },
                isFunction: function() {
                    return ge;
                },
                isIDToken: function() {
                    return Qt;
                },
                isIdxTransactionMeta: function() {
                    return $t;
                },
                isInteractionRequired: function() {
                    return Lt;
                },
                isInteractionRequiredError: function() {
                    return _t;
                },
                isLoginRedirect: function() {
                    return Nt;
                },
                isNumber: function() {
                    return ve;
                },
                isOAuthTransactionMeta: function() {
                    return Gt;
                },
                isObject: function() {
                    return de;
                },
                isPKCETransactionMeta: function() {
                    return Wt;
                },
                isPromise: function() {
                    return ye;
                },
                isRedirectUri: function() {
                    return Mt;
                },
                isRefreshToken: function() {
                    return Zt;
                },
                isRefreshTokenError: function() {
                    return qt;
                },
                isSameRefreshToken: function() {
                    return Bt;
                },
                isString: function() {
                    return he;
                },
                isToken: function() {
                    return Yt;
                },
                isTransactionMeta: function() {
                    return Jt;
                },
                isoToUTCString: function() {
                    return _e;
                },
                loadFrame: function() {
                    return ot;
                },
                loadPopup: function() {
                    return it;
                },
                omit: function() {
                    return F;
                },
                parseEmailVerifyCallback: function() {
                    return Pn;
                },
                parseFromUrl: function() {
                    return kn;
                },
                pkce: function() {
                    return He;
                },
                postRefreshToken: function() {
                    return Ze;
                },
                postToTokenEndpoint: function() {
                    return Qe;
                },
                postToTransaction: function() {
                    return De;
                },
                prepareTokenParams: function() {
                    return Dt;
                },
                removeListener: function() {
                    return rt;
                },
                removeNils: function() {
                    return M;
                },
                removeTrailingSlash: function() {
                    return xe;
                },
                renewToken: function() {
                    return pn;
                },
                renewTokens: function() {
                    return hn;
                },
                renewTokensWithRefresh: function() {
                    return cn;
                },
                resumeTransaction: function() {
                    return Fe;
                },
                revokeToken: function() {
                    return nn;
                },
                toAbsoluteUrl: function() {
                    return be;
                },
                toQueryString: function() {
                    return we;
                },
                toRelativeUrl: function() {
                    return ke;
                },
                transactionExists: function() {
                    return Le;
                },
                transactionStatus: function() {
                    return Ue;
                },
                urlParamsToObject: function() {
                    return Ht;
                },
                validateClaims: function() {
                    return Kt;
                },
                validateToken: function() {
                    return en;
                },
                verifyToken: function() {
                    return on;
                },
                warn: function() {
                    return Sn;
                }
            });
            var e = {};
            n.r(e), n.d(e, {
                atob: function() {
                    return x;
                },
                base64ToBase64Url: function() {
                    return A;
                },
                base64UrlDecode: function() {
                    return P;
                },
                base64UrlToBase64: function() {
                    return E;
                },
                base64UrlToString: function() {
                    return _;
                },
                btoa: function() {
                    return S;
                },
                getOidcHash: function() {
                    return j;
                },
                stringToBase64Url: function() {
                    return O;
                },
                stringToBuffer: function() {
                    return R;
                },
                verifyToken: function() {
                    return D;
                },
                webcrypto: function() {
                    return T;
                }
            });
            var t = {};
            n.r(t), n.d(t, {
                ACCESS_TOKEN_STORAGE_KEY: function() {
                    return oe;
                },
                CACHE_STORAGE_NAME: function() {
                    return Q;
                },
                DEFAULT_CACHE_DURATION: function() {
                    return $;
                },
                DEFAULT_CODE_CHALLENGE_METHOD: function() {
                    return fe;
                },
                DEFAULT_MAX_CLOCK_SKEW: function() {
                    return W;
                },
                DEFAULT_POLLING_DELAY: function() {
                    return G;
                },
                IDX_API_VERSION: function() {
                    return le;
                },
                IDX_RESPONSE_STORAGE_NAME: function() {
                    return re;
                },
                ID_TOKEN_STORAGE_KEY: function() {
                    return ie;
                },
                MAX_VERIFIER_LENGTH: function() {
                    return ce;
                },
                MIN_VERIFIER_LENGTH: function() {
                    return se;
                },
                ORIGINAL_URI_STORAGE_NAME: function() {
                    return ne;
                },
                PKCE_STORAGE_NAME: function() {
                    return Z;
                },
                REDIRECT_NONCE_COOKIE_NAME: function() {
                    return Y;
                },
                REDIRECT_OAUTH_PARAMS_NAME: function() {
                    return z;
                },
                REDIRECT_STATE_COOKIE_NAME: function() {
                    return J;
                },
                REFERRER_PATH_STORAGE_KEY: function() {
                    return ue;
                },
                REFRESH_TOKEN_STORAGE_KEY: function() {
                    return ae;
                },
                SHARED_TRANSACTION_STORAGE_NAME: function() {
                    return te;
                },
                STATE_TOKEN_KEY_NAME: function() {
                    return V;
                },
                TOKEN_STORAGE_NAME: function() {
                    return X;
                },
                TRANSACTION_STORAGE_NAME: function() {
                    return ee;
                }
            });
            var o = {};
            n.r(o), n.d(o, {
                getUserAgent: function() {
                    return bt;
                },
                hasTextEncoder: function() {
                    return St;
                },
                isBrowser: function() {
                    return yt;
                },
                isFingerprintSupported: function() {
                    return kt;
                },
                isHTTPS: function() {
                    return Ot;
                },
                isIE11OrLess: function() {
                    return mt;
                },
                isLocalhost: function() {
                    return At;
                },
                isPKCESupported: function() {
                    return Tt;
                },
                isPopupPostMessageSupported: function() {
                    return wt;
                },
                isTokenVerifySupported: function() {
                    return xt;
                }
            });
            var i = {};
            function a(e, t) {
                if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
            }
            function u(e, t) {
                return u = Object.setPrototypeOf || function(e, t) {
                    return e.__proto__ = t, e;
                }, u(e, t);
            }
            function s(e, t) {
                if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
                e.prototype = Object.create(t && t.prototype, {
                    constructor: {
                        value: e,
                        writable: !0,
                        configurable: !0
                    }
                }), t && u(e, t);
            }
            function c(e) {
                return c = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
                    return typeof e;
                } : function(e) {
                    return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
                }, c(e);
            }
            function f(e) {
                if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                return e;
            }
            function l(e, t) {
                return !t || "object" !== c(t) && "function" != typeof t ? f(e) : t;
            }
            function p(e) {
                return p = Object.setPrototypeOf ? Object.getPrototypeOf : function(e) {
                    return e.__proto__ || Object.getPrototypeOf(e);
                }, p(e);
            }
            function h() {
                if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                if (Reflect.construct.sham) return !1;
                if ("function" == typeof Proxy) return !0;
                try {
                    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
                } catch (e) {
                    return !1;
                }
            }
            function d(e, t, n) {
                return d = h() ? Reflect.construct : function(e, t, n) {
                    var r = [
                        null
                    ];
                    r.push.apply(r, t);
                    var o = new (Function.bind.apply(e, r));
                    return n && u(o, n.prototype), o;
                }, d.apply(null, arguments);
            }
            function v(e) {
                var t = "function" == typeof Map ? new Map : void 0;
                return v = function(e) {
                    if (null === e || (n = e, -1 === Function.toString.call(n).indexOf("[native code]"))) return e;
                    var n;
                    if ("function" != typeof e) throw new TypeError("Super expression must either be null or a function");
                    if (void 0 !== t) {
                        if (t.has(e)) return t.get(e);
                        t.set(e, r);
                    }
                    function r() {
                        return d(e, arguments, p(this).constructor);
                    }
                    return r.prototype = Object.create(e.prototype, {
                        constructor: {
                            value: r,
                            enumerable: !1,
                            writable: !0,
                            configurable: !0
                        }
                    }), u(r, e);
                }, v(e);
            }
            n.r(i), n.d(i, {
                AuthenticatorEnrollmentData: function() {
                    return fo;
                },
                AuthenticatorVerificationData: function() {
                    return co;
                },
                ChallengeAuthenticator: function() {
                    return zr;
                },
                ChallengePoll: function() {
                    return Jr;
                },
                EnrollAuthenticator: function() {
                    return Gr;
                },
                EnrollPoll: function() {
                    return $r;
                },
                EnrollProfile: function() {
                    return Xr;
                },
                Identify: function() {
                    return Qr;
                },
                ReEnrollAuthenticator: function() {
                    return Zr;
                },
                RedirectIdp: function() {
                    return eo;
                },
                Remediator: function() {
                    return Fr;
                },
                ResetAuthenticator: function() {
                    return Yr;
                },
                SelectAuthenticatorAuthenticate: function() {
                    return io;
                },
                SelectAuthenticatorEnroll: function() {
                    return ao;
                },
                SelectEnrollProfile: function() {
                    return uo;
                },
                Skip: function() {
                    return lo;
                }
            });
            var g = function(e) {
                s(o, e);
                var t, n, r = (t = o, n = function() {
                    if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                    if (Reflect.construct.sham) return !1;
                    if ("function" == typeof Proxy) return !0;
                    try {
                        return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
                    } catch (e) {
                        return !1;
                    }
                }(), function() {
                    var e, r = p(t);
                    if (n) {
                        var o = p(this).constructor;
                        e = Reflect.construct(r, arguments, o);
                    } else e = r.apply(this, arguments);
                    return l(this, e);
                });
                function o(e) {
                    var t;
                    return a(this, o), t = r.call(this, e), Object.setPrototypeOf(f(t), (this instanceof o ? this.constructor : void 0).prototype), t;
                }
                return o;
            }(v(Error));
            var y = function(e) {
                s(o, e);
                var t, n, r = (t = o, n = function() {
                    if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                    if (Reflect.construct.sham) return !1;
                    if ("function" == typeof Proxy) return !0;
                    try {
                        return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
                    } catch (e) {
                        return !1;
                    }
                }(), function() {
                    var e, r = p(t);
                    if (n) {
                        var o = p(this).constructor;
                        e = Reflect.construct(r, arguments, o);
                    } else e = r.apply(this, arguments);
                    return l(this, e);
                });
                function o(e, t) {
                    var n;
                    a(this, o);
                    var i = e.errorSummary;
                    return (n = r.call(this, i)).name = "AuthApiError", n.errorSummary = e.errorSummary, n.errorCode = e.errorCode, n.errorLink = e.errorLink, n.errorId = e.errorId, n.errorCauses = e.errorCauses, t && (n.xhr = t), n;
                }
                return o;
            }(g);
            var m = function(e) {
                s(o, e);
                var t, n, r = (t = o, n = function() {
                    if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                    if (Reflect.construct.sham) return !1;
                    if ("function" == typeof Proxy) return !0;
                    try {
                        return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
                    } catch (e) {
                        return !1;
                    }
                }(), function() {
                    var e, r = p(t);
                    if (n) {
                        var o = p(this).constructor;
                        e = Reflect.construct(r, arguments, o);
                    } else e = r.apply(this, arguments);
                    return l(this, e);
                });
                function o() {
                    return a(this, o), r.call(this, "The poll was stopped by the sdk");
                }
                return o;
            }(g);
            var b = function(e) {
                s(o, e);
                var t, n, r = (t = o, n = function() {
                    if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                    if (Reflect.construct.sham) return !1;
                    if ("function" == typeof Proxy) return !0;
                    try {
                        return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
                    } catch (e) {
                        return !1;
                    }
                }(), function() {
                    var e, r = p(t);
                    if (n) {
                        var o = p(this).constructor;
                        e = Reflect.construct(r, arguments, o);
                    } else e = r.apply(this, arguments);
                    return l(this, e);
                });
                function o(e, t) {
                    var n;
                    return a(this, o), (n = r.call(this, e)).name = "AuthSdkError", n.errorCode = "INTERNAL", n.errorSummary = e, n.errorLink = "INTERNAL", n.errorId = "INTERNAL", n.errorCauses = [], t && (n.xhr = t), n;
                }
                return o;
            }(g);
            var k = function(e) {
                s(o, e);
                var t, n, r = (t = o, n = function() {
                    if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                    if (Reflect.construct.sham) return !1;
                    if ("function" == typeof Proxy) return !0;
                    try {
                        return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
                    } catch (e) {
                        return !1;
                    }
                }(), function() {
                    var e, r = p(t);
                    if (n) {
                        var o = p(this).constructor;
                        e = Reflect.construct(r, arguments, o);
                    } else e = r.apply(this, arguments);
                    return l(this, e);
                });
                function o(e, t) {
                    var n;
                    return a(this, o), (n = r.call(this, t)).name = "OAuthError", n.errorCode = e, n.errorSummary = t, n;
                }
                return o;
            }(g);
            function w(e) {
                return e instanceof y;
            }
            var x = function(e) {
                return atob(e);
            }, S = function(e) {
                return btoa(e);
            }, T = "undefined" == typeof crypto ? null : crypto;
            function O(e) {
                return A(S(e));
            }
            function A(e) {
                return e.replace(/\+/g, "-").replace(/\//g, "_").replace(/=+$/, "");
            }
            function E(e) {
                return e.replace(/-/g, "+").replace(/_/g, "/");
            }
            function _(e) {
                var t = E(e);
                switch(t.length % 4){
                    case 0:
                        break;
                    case 2:
                        t += "==";
                        break;
                    case 3:
                        t += "=";
                        break;
                    default:
                        throw new b("Not a valid Base64Url");
                }
                var n = x(t);
                try {
                    return decodeURIComponent(escape(n));
                } catch (e) {
                    return n;
                }
            }
            function R(e) {
                for(var t = new Uint8Array(e.length), n = 0; n < e.length; n++)t[n] = e.charCodeAt(n);
                return t;
            }
            function P(e) {
                return x(E(e));
            }
            function j(e) {
                var t = (new TextEncoder).encode(e);
                return T.subtle.digest("SHA-256", t).then(function(e) {
                    var t = new Uint8Array(e).slice(0, 16);
                    return O(String.fromCharCode.apply(null, t));
                });
            }
            function I(e, t) {
                var n = Array.prototype.slice.call(arguments, 2);
                return function() {
                    var r = Array.prototype.slice.call(arguments);
                    return r = n.concat(r), e.apply(t, r);
                };
            }
            function C() {
                var e = arguments[0], t = [].slice.call(arguments, 1);
                return t.forEach(function(t) {
                    for(var n in t)Object.prototype.hasOwnProperty.call(t, n) && void 0 !== t[n] && (e[n] = t[n]);
                }), e;
            }
            function M(e) {
                var t = {};
                for(var n in e)if (Object.prototype.hasOwnProperty.call(e, n)) {
                    var r = e[n];
                    null != r && (t[n] = r);
                }
                return t;
            }
            function U(e) {
                if (e) {
                    var t = JSON.stringify(e);
                    if (t) return JSON.parse(t);
                }
                return e;
            }
            function F(e) {
                for(var t = {}, n = arguments.length, r = new Array(n > 1 ? n - 1 : 0), o = 1; o < n; o++)r[o - 1] = arguments[o];
                for(var i in e)Object.prototype.hasOwnProperty.call(e, i) && -1 == r.indexOf(i) && (t[i] = e[i]);
                return U(t);
            }
            function N(e, t) {
                for(var n = e.length; n--;){
                    var r = e[n], o = !0;
                    for(var i in t)if (Object.prototype.hasOwnProperty.call(t, i) && r[i] !== t[i]) {
                        o = !1;
                        break;
                    }
                    if (o) return r;
                }
            }
            function L(e, t, n) {
                if (e && e._links) {
                    var r = U(e._links[t]);
                    return r && r.name && n ? r.name === n ? r : void 0 : r;
                }
            }
            function D(e, t) {
                t = U(t);
                var n = {
                    name: "RSASSA-PKCS1-v1_5",
                    hash: {
                        name: "SHA-256"
                    }
                };
                return delete t.use, T.subtle.importKey("jwk", t, n, !0, [
                    "verify"
                ]).then(function(t) {
                    var r = e.split("."), o = R(r[0] + "." + r[1]), i = R(P(r[2]));
                    return T.subtle.verify(n, t, i, o);
                });
            }
            function B(e, t) {
                for(var n = 0; n < t.length; n++){
                    var r = t[n];
                    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
                }
            }
            function q(e, t, n) {
                return t && B(e.prototype, t), n && B(e, n), e;
            }
            var H = n(7757), K = n.n(H), V = "oktaStateToken", G = 500, W = 300, $ = 86400, z = "okta-oauth-redirect-params", J = "okta-oauth-state", Y = "okta-oauth-nonce", X = "okta-token-storage", Q = "okta-cache-storage", Z = "okta-pkce-storage", ee = "okta-transaction-storage", te = "okta-shared-transaction-storage", ne = "okta-original-uri-storage", re = "okta-idx-response-storage", oe = "accessToken", ie = "idToken", ae = "refreshToken", ue = "referrerPath", se = 43, ce = 128, fe = "S256", le = "1.0.0";
            function pe(e, t, n) {
                e.options.headers = e.options.headers || {}, e.options.headers[t] = n;
            }
            function he(e) {
                return "[object String]" === Object.prototype.toString.call(e);
            }
            function de(e) {
                return "[object Object]" === Object.prototype.toString.call(e);
            }
            function ve(e) {
                return "[object Number]" === Object.prototype.toString.call(e);
            }
            function ge(e) {
                return !!e && "[object Function]" === ({}).toString.call(e);
            }
            function ye(e) {
                return e && e.finally && "function" == typeof e.finally;
            }
            function me(e) {
                return /^(?:[a-z]+:)?\/\//i.test(e);
            }
            function be() {
                var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : "", t = arguments.length > 1 ? arguments[1] : void 0;
                return me(e) ? e : (t = xe(t), "/" === e[0] ? "".concat(t).concat(e) : "".concat(t, "/").concat(e));
            }
            function ke() {
                var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : "", t = arguments.length > 1 ? arguments[1] : void 0;
                return me(e) && (e = e.substring(t.length)), "/" === e[0] ? e : "/".concat(e);
            }
            function we(e) {
                var t = [];
                if (null !== e) for(var n in e)Object.prototype.hasOwnProperty.call(e, n) && void 0 !== e[n] && null !== e[n] && t.push(n + "=" + encodeURIComponent(e[n]));
                return t.length ? "?" + t.join("&") : "";
            }
            function xe(e) {
                if (e) {
                    var t = e.replace(/^\s+|\s+$/gm, "");
                    return t.replace(/\/+$/, "");
                }
            }
            function Se(e, t) {
                var n = (t = t || {}).url, r = t.method, o = t.args, i = t.saveAuthnState, a = t.accessToken, u = !0 === t.withCredentials, s = e.options.storageUtil.storage, f = e.storageManager.getHttpCache(e.options.cookies);
                if (t.cacheResponse) {
                    var l = f.getStorage()[n];
                    if (l && Date.now() / 1e3 < l.expiresAt) return Promise.resolve(l.response);
                }
                var p = e._oktaUserAgent.getHttpHeader(), h = Object.assign({
                    Accept: "application/json",
                    "Content-Type": "application/json"
                }, p);
                Object.assign(h, e.options.headers, t.headers), h = M(h), a && he(a) && (h.Authorization = "Bearer " + a);
                var d, v, g = {
                    headers: h,
                    data: o || void 0,
                    withCredentials: u
                };
                return e.options.httpRequestClient(r, n, g).then(function(r) {
                    return (v = r.responseText) && he(v) && (v = JSON.parse(v)) && "object" === c(v) && !v.headers && (v.headers = r.headers), i && (v.stateToken || s.delete(V)), v && v.stateToken && v.expiresAt && s.set(V, v.stateToken, v.expiresAt, e.options.cookies), v && t.cacheResponse && f.updateStorage(n, {
                        expiresAt: Math.floor(Date.now() / 1e3) + $,
                        response: v
                    }), v;
                }).catch(function(t) {
                    var n = t.responseText || {};
                    if (he(n)) try {
                        n = JSON.parse(n);
                    } catch (e) {
                        n = {
                            errorSummary: "Unknown error"
                        };
                    }
                    throw t.status >= 500 && (n.errorSummary = "Unknown error"), e.options.transformErrorXHR && (t = e.options.transformErrorXHR(U(t))), "E0000011" === (d = new y(n, t)).errorCode && s.delete(V), d;
                });
            }
            function Te(e, t, n) {
                var r = {
                    url: t = me(t) ? t : e.getIssuerOrigin() + t,
                    method: "GET"
                };
                return Object.assign(r, n), Se(e, r);
            }
            function Oe(e, t, n, r) {
                var o = {
                    url: t = me(t) ? t : e.getIssuerOrigin() + t,
                    method: "POST",
                    args: n,
                    saveAuthnState: !0
                };
                return Object.assign(o, r), Se(e, o);
            }
            function Ae(e, t) {
                var n = {};
                return Object.assign(n, t), !n.stateToken && e.stateToken && (n.stateToken = e.stateToken), n;
            }
            function Ee(e) {
                return Ae(e);
            }
            function _e(e) {
                var t = e.match(/\d+/g), n = Date.UTC(t[0], t[1] - 1, t[2], t[3], t[4], t[5]);
                return new Date(n).toUTCString();
            }
            function Re(e) {
                for(var t = "abcdefghijklnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789", n = "", r = 0, o = t.length; r < e; ++r)n += t[Math.floor(Math.random() * o)];
                return n;
            }
            function Pe(e) {
                return new Promise(function(t) {
                    setTimeout(t, e);
                });
            }
            function je(e, t, n) {
                return function(r) {
                    var o, i, a, u;
                    ve(r) ? o = r : de(r) && (o = r.delay, i = r.rememberDevice, a = r.autoPush, u = r.transactionCallBack), o || 0 === o || (o = G);
                    var s = L(t, "next", "poll");
                    n.isPolling = !0;
                    var c = 0;
                    return (function r() {
                        return n.isPolling ? (function() {
                            var n = {};
                            if ("function" == typeof a) try {
                                n.autoPush = !!a();
                            } catch (e) {
                                return Promise.reject(new b("AutoPush resulted in an error."));
                            }
                            else null != a && (n.autoPush = !!a);
                            if ("function" == typeof i) try {
                                n.rememberDevice = !!i();
                            } catch (e) {
                                return Promise.reject(new b("RememberDevice resulted in an error."));
                            }
                            else null != i && (n.rememberDevice = !!i);
                            var r = s.href + we(n);
                            return Oe(e, r, Ee(t), {
                                saveAuthnState: !1,
                                withCredentials: !0
                            });
                        })().then(function(t) {
                            if (c = 0, t.factorResult && "WAITING" === t.factorResult) {
                                if (!n.isPolling) throw new m;
                                return "function" == typeof u && u(t), Pe(o).then(r);
                            }
                            return n.isPolling = !1, new Ie(e, t);
                        }).catch(function(e) {
                            if (e.xhr && (0 === e.xhr.status || 429 === e.xhr.status) && c <= 4) {
                                var t = 1e3 * Math.pow(2, c);
                                return c++, Pe(t).then(r);
                            }
                            throw e;
                        }) : Promise.reject(new m);
                    })().catch(function(e) {
                        throw n.isPolling = !1, e;
                    });
                };
            }
            var Ie = function e(t) {
                var n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : null;
                if (a(this, e), n) {
                    if (this.data = n, this.data.interactionHandle) return void (this.status = n.status);
                    Object.assign(this, Me(t, n, n, {})), delete this.stateToken, "RECOVERY_CHALLENGE" !== n.status || n._links || (this.cancel = function() {
                        return Promise.resolve(new e(t));
                    });
                }
            };
            function Ce(e, t, n, r, o) {
                if (Array.isArray(r)) return function(i, a) {
                    if (!i) throw new b("Must provide a link name");
                    var u = N(r, {
                        name: i
                    });
                    if (!u) throw new b("No link found for that name");
                    return Ce(e, t, n, u, o)(a);
                };
                if (r.hints && r.hints.allow && 1 === r.hints.allow.length) switch(r.hints.allow[0]){
                    case "GET":
                        return function() {
                            return Te(e, r.href, {
                                withCredentials: !0
                            });
                        };
                    case "POST":
                        return function(i) {
                            o && o.isPolling && (o.isPolling = !1);
                            var a = Ae(t, i);
                            "MFA_ENROLL" !== t.status && "FACTOR_ENROLL" !== t.status || Object.assign(a, {
                                factorType: n.factorType,
                                provider: n.provider
                            });
                            var u = {}, s = a.autoPush;
                            if (void 0 !== s) {
                                if ("function" == typeof s) try {
                                    u.autoPush = !!s();
                                } catch (e) {
                                    return Promise.reject(new b("AutoPush resulted in an error."));
                                }
                                else null !== s && (u.autoPush = !!s);
                                a = F(a, "autoPush");
                            }
                            var c = a.rememberDevice;
                            if (void 0 !== c) {
                                if ("function" == typeof c) try {
                                    u.rememberDevice = !!c();
                                } catch (e) {
                                    return Promise.reject(new b("RememberDevice resulted in an error."));
                                }
                                else null !== c && (u.rememberDevice = !!c);
                                a = F(a, "rememberDevice");
                            } else a.profile && void 0 !== a.profile.updatePhone && (a.profile.updatePhone && (u.updatePhone = !0), a.profile = F(a.profile, "updatePhone"));
                            var f = r.href + we(u);
                            return De(e, f, a);
                        };
                }
            }
            function Me(e, t, n, r) {
                if (n = U(n = n || t), Array.isArray(n)) {
                    for(var o = [], i = 0, a = n.length; i < a; i++)o.push(Me(e, t, n[i], r));
                    return o;
                }
                var u = n._embedded || {};
                for(var s in u)Object.prototype.hasOwnProperty.call(u, s) && (de(u[s]) || Array.isArray(u[s])) && (u[s] = Me(e, t, u[s], r));
                var c = function(e, t, n, r) {
                    var o = {};
                    for(var i in n._links)if (Object.prototype.hasOwnProperty.call(n._links, i)) {
                        var a = n._links[i];
                        if ("next" === i && (i = a.name), a.type) o[i] = a;
                        else if ("poll" === i) o.poll = je(e, t, r);
                        else {
                            var u = Ce(e, t, n, a, r);
                            u && (o[i] = u);
                        }
                    }
                    return o;
                }(e, t, n, r);
                return Object.assign(u, c), n = F(n, "_embedded", "_links"), Object.assign(n, u), n;
            }
            function Ue(e, t) {
                return t = Ae(e, t), Oe(e, e.getIssuerOrigin() + "/api/v1/authn", t, {
                    withCredentials: !0
                });
            }
            function Fe(e, t) {
                if (!t || !t.stateToken) {
                    var n = e.tx.exists._get(V);
                    if (!n) return Promise.reject(new b("No transaction to resume"));
                    t = {
                        stateToken: n
                    };
                }
                return e.tx.status(t).then(function(t) {
                    return new Ie(e, t);
                });
            }
            function Ne(e, t) {
                if (!t || !t.stateToken) {
                    var n = e.tx.exists._get(V);
                    if (!n) return Promise.reject(new b("No transaction to evaluate"));
                    t = {
                        stateToken: n
                    };
                }
                return (function(e, t) {
                    return t = Ae(e, t), Oe(e, e.getIssuerOrigin() + "/api/v1/authn/introspect", t, {
                        withCredentials: !0
                    });
                })(e, t).then(function(t) {
                    return new Ie(e, t);
                });
            }
            function Le(e) {
                return !!e.tx.exists._get(V);
            }
            function De(e, t, n, r) {
                return r = Object.assign({
                    withCredentials: !0
                }, r), Oe(e, t, n, r).then(function(t) {
                    return new Ie(e, t);
                });
            }
            var Be = function e() {
                a(this, e);
            };
            function qe(e) {
                return ("0" + e.toString(16)).substr(-2);
            }
            var He = {
                DEFAULT_CODE_CHALLENGE_METHOD: fe,
                generateVerifier: function(e) {
                    var t = e || "";
                    return t.length < se && (t += function(e) {
                        var t = new Uint8Array(Math.ceil(e / 2));
                        return T.getRandomValues(t), Array.from(t, qe).join("").slice(0, e);
                    }(se - t.length)), encodeURIComponent(t).slice(0, ce);
                },
                computeChallenge: function(e) {
                    var t = (new TextEncoder).encode(e);
                    return T.subtle.digest("SHA-256", t).then(function(e) {
                        return O(String.fromCharCode.apply(null, new Uint8Array(e)));
                    });
                }
            };
            function Ke(e) {
                return e.session.get().then(function(e) {
                    return "ACTIVE" === e.status;
                }).catch(function() {
                    return !1;
                });
            }
            function Ve(e) {
                return Te(e, "/api/v1/sessions/me", {
                    withCredentials: !0
                }).then(function(t) {
                    var n = F(t, "_links");
                    return n.refresh = function() {
                        return Oe(e, L(t, "refresh").href, {}, {
                            withCredentials: !0
                        });
                    }, n.user = function() {
                        return Te(e, L(t, "user").href, {
                            withCredentials: !0
                        });
                    }, n;
                }).catch(function() {
                    return {
                        status: "INACTIVE"
                    };
                });
            }
            function Ge(e) {
                return Se(e, {
                    url: e.getIssuerOrigin() + "/api/v1/sessions/me",
                    method: "DELETE",
                    withCredentials: !0
                });
            }
            function We(e) {
                return Oe(e, "/api/v1/sessions/me/lifecycle/refresh", {}, {
                    withCredentials: !0
                });
            }
            function $e(e, t, n) {
                n = n || window.location.href, window.location.assign(e.getIssuerOrigin() + "/login/sessionCookieRedirect" + we({
                    checkAccountSetupComplete: !0,
                    token: t,
                    redirectUrl: n
                }));
            }
            function ze(e) {
                if (!e.clientId) throw new b("A clientId must be specified in the OktaAuth constructor to get a token");
                if (he(e.responseType) && -1 !== e.responseType.indexOf(" ")) throw new b("Multiple OAuth responseTypes must be defined as an array");
                var t = {
                    client_id: e.clientId,
                    code_challenge: e.codeChallenge,
                    code_challenge_method: e.codeChallengeMethod,
                    display: e.display,
                    idp: e.idp,
                    idp_scope: e.idpScope,
                    login_hint: e.loginHint,
                    max_age: e.maxAge,
                    nonce: e.nonce,
                    prompt: e.prompt,
                    redirect_uri: e.redirectUri,
                    response_mode: e.responseMode,
                    response_type: e.responseType,
                    sessionToken: e.sessionToken,
                    state: e.state
                };
                if (t = M(t), [
                    "idp_scope",
                    "response_type"
                ].forEach(function(e) {
                    Array.isArray(t[e]) && (t[e] = t[e].join(" "));
                }), -1 !== e.responseType.indexOf("id_token") && -1 === e.scopes.indexOf("openid")) throw new b("openid scope must be specified in the scopes argument when requesting an id_token");
                return t.scope = e.scopes.join(" "), t;
            }
            function Je(e) {
                var t = ze(e);
                return we(Object.assign(Object.assign({}, t), e.extraParams && Object.assign({}, e.extraParams)));
            }
            function Ye(e, t) {
                (null == t || t > e.length) && (t = e.length);
                for(var n = 0, r = new Array(t); n < t; n++)r[n] = e[n];
                return r;
            }
            function Xe(e, t) {
                if (e) {
                    if ("string" == typeof e) return Ye(e, t);
                    var n = Object.prototype.toString.call(e).slice(8, -1);
                    return "Object" === n && e.constructor && (n = e.constructor.name), "Map" === n || "Set" === n ? Array.from(e) : "Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? Ye(e, t) : void 0;
                }
            }
            function Qe(e, t, n) {
                !function(e) {
                    if (!e.clientId) throw new b("A clientId must be specified in the OktaAuth constructor to get a token");
                    if (!e.redirectUri) throw new b("The redirectUri passed to /authorize must also be passed to /token");
                    if (!e.authorizationCode && !e.interactionCode) throw new b("An authorization code (returned from /authorize) must be passed to /token");
                    if (!e.codeVerifier) throw new b('The "codeVerifier" (generated and saved by your app) must be passed to /token');
                }(t);
                var r = function(e, t) {
                    var n = M({
                        client_id: t.clientId,
                        redirect_uri: t.redirectUri,
                        grant_type: t.interactionCode ? "interaction_code" : "authorization_code",
                        code_verifier: t.codeVerifier
                    });
                    t.interactionCode ? n.interaction_code = t.interactionCode : t.authorizationCode && (n.code = t.authorizationCode);
                    var r = e.options.clientSecret;
                    return r && (n.client_secret = r), we(n).slice(1);
                }(e, t);
                return Se(e, {
                    url: n.tokenUrl,
                    method: "POST",
                    args: r,
                    headers: {
                        "Content-Type": "application/x-www-form-urlencoded"
                    }
                });
            }
            function Ze(e, t, n) {
                return Se(e, {
                    url: n.tokenUrl,
                    method: "POST",
                    headers: {
                        "Content-Type": "application/x-www-form-urlencoded"
                    },
                    args: Object.entries({
                        client_id: t.clientId,
                        grant_type: "refresh_token",
                        scope: n.scopes.join(" "),
                        refresh_token: n.refreshToken
                    }).map(function(e) {
                        var t, n, r = (n = 2, function(e) {
                            if (Array.isArray(e)) return e;
                        }(t = e) || function(e, t) {
                            var n = null == e ? null : "undefined" != typeof Symbol && e[Symbol.iterator] || e["@@iterator"];
                            if (null != n) {
                                var r, o, i = [], a = !0, u = !1;
                                try {
                                    for(n = n.call(e); !(a = (r = n.next()).done) && (i.push(r.value), !t || i.length !== t); a = !0);
                                } catch (e) {
                                    u = !0, o = e;
                                } finally{
                                    try {
                                        a || null == n.return || n.return();
                                    } finally{
                                        if (u) throw o;
                                    }
                                }
                                return i;
                            }
                        }(t, n) || Xe(t, n) || function() {
                            throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
                        }()), o = r[0], i = r[1];
                        return o + "=" + encodeURIComponent(i);
                    }).join("&")
                });
            }
            function et(e, t) {
                return Te(e, (t || e.options.issuer) + "/.well-known/openid-configuration", {
                    cacheResponse: !0
                });
            }
            function tt(e, t, n) {
                var r = e.storageManager.getHttpCache(e.options.cookies);
                return et(e, t).then(function(t) {
                    var o = t.jwks_uri, i = r.getStorage()[o];
                    if (i && Date.now() / 1e3 < i.expiresAt) {
                        var a = N(i.response.keys, {
                            kid: n
                        });
                        if (a) return a;
                    }
                    return r.clearStorage(o), Te(e, o, {
                        cacheResponse: !0
                    }).then(function(e) {
                        var t = N(e.keys, {
                            kid: n
                        });
                        if (t) return t;
                        throw new b("The key id, " + n + ", was not found in the server's keys");
                    });
                });
            }
            function nt(e, t, n) {
                e.addEventListener ? e.addEventListener(t, n) : e.attachEvent("on" + t, n);
            }
            function rt(e, t, n) {
                e.removeEventListener ? e.removeEventListener(t, n) : e.detachEvent("on" + t, n);
            }
            function ot(e) {
                var t = document.createElement("iframe");
                return t.style.display = "none", t.src = e, document.body.appendChild(t);
            }
            function it(e, t) {
                var n = t.popupTitle || "External Identity Provider User Authentication";
                return window.open(e, n, "toolbar=no, scrollbars=yes, resizable=yes, top=100, left=500, width=600, height=600");
            }
            function at(e, t, n) {
                var r, o;
                return new Promise(function(i, a) {
                    r = function(t) {
                        if (t.data && t.data.state === n) return t.origin !== e.getIssuerOrigin() ? a(new b("The request does not match client configuration")) : void i(t.data);
                    }, nt(window, "message", r), o = setTimeout(function() {
                        a(new b("OAuth flow timed out"));
                    }, t || 12e4);
                }).finally(function() {
                    clearTimeout(o), rt(window, "message", r);
                });
            }
            function ut() {
                return Re(64);
            }
            function st() {
                return Re(64);
            }
            function ct(e) {
                var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {}, n = xe(t.issuer) || e.options.issuer;
                return n;
            }
            function ft(e) {
                var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {}, n = ct(e, t), r = n.indexOf("/oauth2") > 0 ? n : n + "/oauth2";
                return r;
            }
            function lt(e) {
                var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {}, n = ct(e, t), r = n.split("/oauth2")[0];
                return r;
            }
            function pt(e, t) {
                if (arguments.length > 2) throw new b('As of version 3.0, "getOAuthUrls" takes only a single set of options');
                var n = xe((t = t || {}).authorizeUrl) || e.options.authorizeUrl, r = ct(e, t), o = xe(t.userinfoUrl) || e.options.userinfoUrl, i = xe(t.tokenUrl) || e.options.tokenUrl, a = xe(t.logoutUrl) || e.options.logoutUrl, u = xe(t.revokeUrl) || e.options.revokeUrl, s = ft(e, t);
                return {
                    issuer: r,
                    authorizeUrl: n = n || s + "/v1/authorize",
                    userinfoUrl: o = o || s + "/v1/userinfo",
                    tokenUrl: i = i || s + "/v1/token",
                    revokeUrl: u = u || s + "/v1/revoke",
                    logoutUrl: a = a || s + "/v1/logout"
                };
            }
            var ht, dt, vt, gt = /windows phone|iemobile|wpdesktop/i;
            function yt() {
                return "undefined" != typeof document && "undefined" != typeof window;
            }
            function mt() {
                return yt() && !!document.documentMode && document.documentMode <= 11;
            }
            function bt() {
                return navigator.userAgent;
            }
            function kt() {
                var e = bt();
                return e && !gt.test(e);
            }
            function wt() {
                if (!yt()) return !1;
                var e = document.documentMode && document.documentMode < 10;
                return !(!window.postMessage || e);
            }
            function xt() {
                return null != T && void 0 !== T.subtle && "undefined" != typeof Uint8Array;
            }
            function St() {
                return "undefined" != typeof TextEncoder;
            }
            function Tt() {
                return xt() && St();
            }
            function Ot() {
                return !!yt() && "https:" === window.location.protocol;
            }
            function At() {
                return yt() && "localhost" === window.location.hostname;
            }
            function Et(e) {
                var t = e.options, n = t.pkce, r = t.clientId, o = t.redirectUri, i = t.responseType, a = t.responseMode, u = t.scopes, s = t.state, c = t.ignoreSignature, f = yt() ? window.location.href : void 0;
                return M({
                    pkce: n,
                    clientId: r,
                    redirectUri: o || f,
                    responseType: i || [
                        "token",
                        "id_token"
                    ],
                    responseMode: a,
                    state: s || ut(),
                    nonce: st(),
                    scopes: u || [
                        "openid",
                        "email"
                    ],
                    ignoreSignature: c
                });
            }
            function _t(e) {
                return "OAuthError" === e.name && "interaction_required" === e.errorCode;
            }
            function Rt(e, t) {
                if ("AuthApiError" !== t.name) return !1;
                var n = t.xhr, r = null == n ? void 0 : n.responseJSON;
                return e.options.pkce && "invalid_grant" === (null == r ? void 0 : r.error);
            }
            function Pt(e) {
                return /((id|access)_token=)/i.test(e);
            }
            function jt(e) {
                return /(code=)/i.test(e);
            }
            function It(e) {
                return /(interaction_code=)/i.test(e);
            }
            function Ct(e) {
                return /(error=)/i.test(e) || /(error_description)/i.test(e);
            }
            function Mt(e, t) {
                var n = t.options;
                return e && 0 === e.indexOf(n.redirectUri);
            }
            function Ut(e) {
                return e.pkce || "code" === e.responseType || "query" === e.responseMode;
            }
            function Ft(e) {
                return Ut(e) && "fragment" !== e.responseMode ? window.location.search : window.location.hash;
            }
            function Nt(e) {
                if (!Mt(window.location.href, e)) return !1;
                var t = Ut(e.options), n = Ft(e.options);
                return !!Ct(n) || (t ? jt(n) || It(n) : Pt(window.location.hash));
            }
            function Lt(e, t) {
                if (!t) {
                    if (!Nt(e)) return !1;
                    t = Ft(e.options);
                }
                return /(error=interaction_required)/i.test(t);
            }
            function Dt(e, t) {
                var n = Et(e);
                if (!1 === (t = Object.assign({}, n, U(t))).pkce) return Promise.resolve(t);
                if (!e.features.isPKCESupported()) {
                    var r = "PKCE requires a modern browser with encryption support running in a secure context.";
                    return e.features.isHTTPS() || (r += "\nThe current page is not being served with HTTPS protocol. PKCE requires secure HTTPS protocol."), e.features.hasTextEncoder() || (r += '\n"TextEncoder" is not defined. To use PKCE, you may need to include a polyfill/shim for this browser.'), Promise.reject(new b(r));
                }
                return t.codeChallengeMethod || (t.codeChallengeMethod = fe), t.responseType = "code", et(e, null).then(function(e) {
                    if (-1 === (e.code_challenge_methods_supported || []).indexOf(t.codeChallengeMethod)) throw new b("Invalid code_challenge_method");
                }).then(function() {
                    return t.codeVerifier || (t.codeVerifier = He.generateVerifier()), He.computeChallenge(t.codeVerifier);
                }).then(function(e) {
                    var n = U(t) || {};
                    return Object.assign(n, t, {
                        codeChallenge: e
                    }), n;
                });
            }
            function Bt(e, t) {
                return e.refreshToken === t.refreshToken;
            }
            function qt(e) {
                return !(!w(e) || !e.xhr || !e.xhr.responseJSON || "invalid_grant" !== e.xhr.responseJSON.error);
            }
            function Ht(e) {
                var t = /\+/g, n = /([^&=]+)=?([^&]*)/g, r = e || "";
                "#" === r.charAt(0) && "/" === r.charAt(1) && (r = r.substring(2)), "#" !== r.charAt(0) && "?" !== r.charAt(0) || (r = r.substring(1));
                for(var o, i = {}; o = n.exec(r);){
                    var a = o[1], u = o[2];
                    i[a] = "id_token" === a || "access_token" === a || "code" === a ? u : decodeURIComponent(u.replace(t, " "));
                }
                return i;
            }
            function Kt(e, t, n) {
                var r = n.clientId, o = n.issuer, i = n.nonce;
                if (!t || !o || !r) throw new b("The jwt, iss, and aud arguments are all required");
                if (i && t.nonce !== i) throw new b("OAuth flow response nonce doesn't match request nonce");
                var a = Math.floor(Date.now() / 1e3);
                if (t.iss !== o) throw new b("The issuer [" + t.iss + "] does not match [" + o + "]");
                if (t.aud !== r) throw new b("The audience [" + t.aud + "] does not match [" + r + "]");
                if (t.iat > t.exp) throw new b("The JWT expired before it was issued");
                if (!e.options.ignoreLifetime) {
                    if (a - e.options.maxClockSkew > t.exp) throw new b("The JWT expired and is no longer valid");
                    if (t.iat > a + e.options.maxClockSkew) throw new b("The JWT was issued in the future");
                }
            }
            function Vt(e) {
                return !(!e || "object" !== c(e) || 0 === Object.values(e).length);
            }
            function Gt(e) {
                return !(!Vt(e) || !e.redirectUri && !e.responseType);
            }
            function Wt(e) {
                return !!Gt(e) && !!e.codeVerifier;
            }
            function $t(e) {
                return !!Wt(e) && !!e.interactionHandle;
            }
            function zt(e) {
                return !!Vt(e) && void 0 === Object.values(e).find(function(e) {
                    return "string" != typeof e;
                });
            }
            function Jt(e) {
                return !(!Gt(e) && !zt(e));
            }
            function Yt(e) {
                return !!(e && (e.accessToken || e.idToken || e.refreshToken) && Array.isArray(e.scopes));
            }
            function Xt(e) {
                return e && e.accessToken;
            }
            function Qt(e) {
                return e && e.idToken;
            }
            function Zt(e) {
                return e && e.refreshToken;
            }
            function en(e, t) {
                if (!Qt(e) && !Xt(e) && !Zt(e)) throw new b("Token must be an Object with scopes, expiresAt, and one of: an idToken, accessToken, or refreshToken property");
                if ("accessToken" === t && !Xt(e)) throw new b("invalid accessToken");
                if ("idToken" === t && !Qt(e)) throw new b("invalid idToken");
                if ("refreshToken" === t && !Zt(e)) throw new b("invalid refreshToken");
            }
            function tn(e) {
                var t, n = e.split(".");
                try {
                    t = {
                        header: JSON.parse(_(n[0])),
                        payload: JSON.parse(_(n[1])),
                        signature: n[2]
                    };
                } catch (e) {
                    throw new b("Malformed token");
                }
                return t;
            }
            function nn(e, t) {
                return Promise.resolve().then(function() {
                    var n, r;
                    if (t && (n = t.accessToken, r = t.refreshToken), !n && !r) throw new b("A valid access or refresh token object is required");
                    var o = e.options.clientId, i = e.options.clientSecret;
                    if (!o) throw new b("A clientId must be specified in the OktaAuth constructor to revoke a token");
                    var a = pt(e).revokeUrl, u = we({
                        token_type_hint: r ? "refresh_token" : "access_token",
                        token: r || n
                    }).slice(1), s = S(i ? "".concat(o, ":").concat(i) : o);
                    return Oe(e, a, u, {
                        headers: {
                            "Content-Type": "application/x-www-form-urlencoded",
                            Authorization: "Basic " + s
                        }
                    });
                });
            }
            function rn(e, t, n) {
                n = n || pt(e, t);
                var r = t = Object.assign({}, Et(e), U(t)), o = r.authorizationCode, i = r.interactionCode, a = r.codeVerifier, u = r.clientId, s = r.redirectUri, c = r.scopes, f = r.ignoreSignature, l = r.state;
                return Qe(e, {
                    clientId: u,
                    redirectUri: s,
                    authorizationCode: o,
                    interactionCode: i,
                    codeVerifier: a
                }, n).then(function(t) {
                    var r = [
                        "token"
                    ];
                    return -1 !== c.indexOf("openid") && r.push("id_token"), an(e, {
                        clientId: u,
                        redirectUri: s,
                        scopes: c,
                        responseType: r,
                        ignoreSignature: f
                    }, t, n).then(function(e) {
                        return e.code = o, e.state = l, e;
                    });
                }).finally(function() {
                    e.transactionManager.clear();
                });
            }
            !function(e) {
                e.SUCCESS = "SUCCESS", e.PENDING = "PENDING", e.FAILURE = "FAILURE", e.TERMINAL = "TERMINAL", e.CANCELED = "CANCELED";
            }(ht || (ht = {})), function(e) {
                e.OKTA_PASSWORD = "okta_password", e.OKTA_EMAIL = "okta_email", e.PHONE_NUMBER = "phone_number", e.GOOGLE_AUTHENTICATOR = "google_otp", e.SECURITY_QUESTION = "security_question", e.OKTA_VERIFY = "okta_verify";
            }(dt || (dt = {})), function(e) {
                e[e.PASSWORD_RECOVERY = 0] = "PASSWORD_RECOVERY", e[e.REGISTRATION = 1] = "REGISTRATION", e[e.SOCIAL_IDP = 2] = "SOCIAL_IDP";
            }(vt || (vt = {}));
            function on(e, t, n) {
                var r, o, i, a;
                return r = this, o = void 0, i = void 0, a = K().mark(function r() {
                    var o, i, a, u, s, c;
                    return K().wrap(function(r) {
                        for(;;)switch(r.prev = r.next){
                            case 0:
                                if (t && t.idToken) {
                                    r.next = 2;
                                    break;
                                }
                                throw new b("Only idTokens may be verified");
                            case 2:
                                return o = tn(t.idToken), i = (null == n ? void 0 : n.issuer) || e.options.issuer, r.next = 6, et(e, i);
                            case 6:
                                if (a = r.sent, u = a.issuer, s = Object.assign({
                                    clientId: e.options.clientId,
                                    ignoreSignature: e.options.ignoreSignature
                                }, n, {
                                    issuer: u
                                }), Kt(e, o.payload, s), 1 != s.ignoreSignature && e.features.isTokenVerifySupported()) {
                                    r.next = 12;
                                    break;
                                }
                                return r.abrupt("return", t);
                            case 12:
                                return r.next = 14, tt(e, t.issuer, o.header.kid);
                            case 14:
                                return c = r.sent, r.next = 17, D(t.idToken, c);
                            case 17:
                                if (r.sent) {
                                    r.next = 20;
                                    break;
                                }
                                throw new b("The token signature is not valid");
                            case 20:
                                if (!(n && n.accessToken && t.claims.at_hash)) {
                                    r.next = 26;
                                    break;
                                }
                                return r.next = 23, j(n.accessToken);
                            case 23:
                                if (r.sent === t.claims.at_hash) {
                                    r.next = 26;
                                    break;
                                }
                                throw new b("Token hash verification failed");
                            case 26:
                                return r.abrupt("return", t);
                            case 27:
                            case "end":
                                return r.stop();
                        }
                    }, r);
                }), new (i || (i = Promise))(function(e, t) {
                    function n(e) {
                        try {
                            s(a.next(e));
                        } catch (e) {
                            t(e);
                        }
                    }
                    function u(e) {
                        try {
                            s(a.throw(e));
                        } catch (e) {
                            t(e);
                        }
                    }
                    function s(t) {
                        var r;
                        t.done ? e(t.value) : (r = t.value, r instanceof i ? r : new i(function(e) {
                            e(r);
                        })).then(n, u);
                    }
                    s((a = a.apply(r, o || [])).next());
                });
            }
            function an(e, t, n, r) {
                if (!1 !== e.options.pkce && (n.code || n.interaction_code)) return rn(e, Object.assign({}, t, {
                    authorizationCode: n.code,
                    interactionCode: n.interaction_code
                }), r);
                t = t || Et(e), r = r || pt(e, t);
                var o, i = t.responseType;
                Array.isArray(i) || (i = [
                    i
                ]), o = n.scope ? n.scope.split(" ") : U(t.scopes);
                var a = t.clientId || e.options.clientId;
                return Promise.resolve().then(function() {
                    !function(e, t) {
                        if (e.error || e.error_description) throw new k(e.error, e.error_description);
                        if (e.state !== t.state) throw new b("OAuth flow response state doesn't match request state");
                    }(n, t);
                }).then(function() {
                    var i = {}, u = n.expires_in, s = n.token_type, c = n.access_token, f = n.id_token, l = n.refresh_token, p = Math.floor(Date.now() / 1e3);
                    if (c) {
                        var h = e.token.decode(c);
                        i.accessToken = {
                            accessToken: c,
                            claims: h.payload,
                            expiresAt: Number(u) + p,
                            tokenType: s,
                            scopes: o,
                            authorizeUrl: r.authorizeUrl,
                            userinfoUrl: r.userinfoUrl
                        };
                    }
                    if (l && (i.refreshToken = {
                        refreshToken: l,
                        expiresAt: Number(u) + p,
                        scopes: o,
                        tokenUrl: r.tokenUrl,
                        authorizeUrl: r.authorizeUrl,
                        issuer: r.issuer
                    }), f) {
                        var d = e.token.decode(f), v = {
                            idToken: f,
                            claims: d.payload,
                            expiresAt: d.payload.exp - d.payload.iat + p,
                            scopes: o,
                            authorizeUrl: r.authorizeUrl,
                            issuer: r.issuer,
                            clientId: a
                        }, g = {
                            clientId: a,
                            issuer: r.issuer,
                            nonce: t.nonce,
                            accessToken: c
                        };
                        return void 0 !== t.ignoreSignature && (g.ignoreSignature = t.ignoreSignature), on(e, v, g).then(function() {
                            return i.idToken = v, i;
                        });
                    }
                    return i;
                }).then(function(e) {
                    if (-1 !== i.indexOf("token") && !e.accessToken) throw new b('Unable to parse OAuth flow response: response type "token" was requested but "access_token" was not returned.');
                    if (-1 !== i.indexOf("id_token") && !e.idToken) throw new b('Unable to parse OAuth flow response: response type "id_token" was requested but "id_token" was not returned.');
                    return {
                        tokens: e,
                        state: n.state,
                        code: n.code
                    };
                });
            }
            function un(e, t) {
                if (arguments.length > 2) return Promise.reject(new b('As of version 3.0, "getToken" takes only a single set of options'));
                var n = (t = t || {}).popupWindow;
                return t.popupWindow = void 0, Dt(e, t).then(function(r) {
                    var o, i;
                    switch(t.sessionToken ? Object.assign(r, {
                        prompt: "none",
                        responseMode: "okta_post_message",
                        display: null
                    }) : t.idp && Object.assign(r, {
                        display: "popup"
                    }), i = pt(e, r), o = (t.codeVerifier ? i.tokenUrl : i.authorizeUrl) + Je(r), r.sessionToken || null === r.display ? "IFRAME" : "popup" === r.display ? "POPUP" : "IMPLICIT"){
                        case "IFRAME":
                            var a = at(e, t.timeout, r.state), u = ot(o);
                            return a.then(function(t) {
                                return an(e, r, t, i);
                            }).finally(function() {
                                document.body.contains(u) && u.parentElement.removeChild(u);
                            });
                        case "POPUP":
                            var s;
                            if ("okta_post_message" === r.responseMode) {
                                if (!e.features.isPopupPostMessageSupported()) throw new b("This browser doesn't have full postMessage support");
                                s = at(e, t.timeout, r.state);
                            }
                            return n && n.location.assign(o), new Promise(function(e, t) {
                                var r = setInterval(function() {
                                    n && !n.closed || (clearInterval(r), t(new b("Unable to parse OAuth flow response")));
                                }, 100);
                                s.then(function(t) {
                                    clearInterval(r), e(t);
                                }).catch(function(e) {
                                    clearInterval(r), t(e);
                                });
                            }).then(function(t) {
                                return an(e, r, t, i);
                            }).finally(function() {
                                n && !n.closed && n.close();
                            });
                        default:
                            throw new b("The full page redirect flow is not supported");
                    }
                });
            }
            function sn(e, t) {
                return arguments.length > 2 ? Promise.reject(new b('As of version 3.0, "getWithoutPrompt" takes only a single set of options')) : (t = U(t) || {}, Object.assign(t, {
                    prompt: "none",
                    responseMode: "okta_post_message",
                    display: null
                }), un(e, t));
            }
            function cn(e, t, n) {
                var r, o, i, a;
                return r = this, o = void 0, i = void 0, a = K().mark(function r() {
                    var o, i, a, u, s, c, f;
                    return K().wrap(function(r) {
                        for(;;)switch(r.prev = r.next){
                            case 0:
                                if (o = e.options.clientId) {
                                    r.next = 3;
                                    break;
                                }
                                throw new b("A clientId must be specified in the OktaAuth constructor to renew tokens");
                            case 3:
                                return i = Object.assign({}, t, {
                                    clientId: o
                                }), r.next = 6, Ze(e, i, n);
                            case 6:
                                return a = r.sent, u = pt(e, t), r.next = 10, an(e, i, a, u);
                            case 10:
                                return s = r.sent, c = s.tokens, (f = c.refreshToken) && !Bt(f, n) && e.tokenManager.updateRefreshToken(f), r.abrupt("return", c);
                            case 15:
                            case "end":
                                return r.stop();
                        }
                    }, r);
                }), new (i || (i = Promise))(function(e, t) {
                    function n(e) {
                        try {
                            s(a.next(e));
                        } catch (e) {
                            t(e);
                        }
                    }
                    function u(e) {
                        try {
                            s(a.throw(e));
                        } catch (e) {
                            t(e);
                        }
                    }
                    function s(t) {
                        var r;
                        t.done ? e(t.value) : (r = t.value, r instanceof i ? r : new i(function(e) {
                            e(r);
                        })).then(n, u);
                    }
                    s((a = a.apply(r, o || [])).next());
                });
            }
            function fn() {
                throw new b("Renew must be passed a token with an array of scopes and an accessToken or idToken");
            }
            function ln(e, t) {
                return Qt(e) ? t.idToken : Xt(e) ? t.accessToken : void fn();
            }
            function pn(e, t) {
                var n, r, o, i;
                return n = this, r = void 0, o = void 0, i = K().mark(function n() {
                    var r, o, i, a, u, s;
                    return K().wrap(function(n) {
                        for(;;)switch(n.prev = n.next){
                            case 0:
                                if (Qt(t) || Xt(t) || fn(), !(r = e.tokenManager.getTokensSync()).refreshToken) {
                                    n.next = 7;
                                    break;
                                }
                                return n.next = 5, cn(e, {
                                    scopes: t.scopes
                                }, r.refreshToken);
                            case 5:
                                return r = n.sent, n.abrupt("return", ln(t, r));
                            case 7:
                                return o = e.options.pkce ? "code" : Xt(t) ? "token" : "id_token", i = t.scopes, a = t.authorizeUrl, u = t.userinfoUrl, s = t.issuer, n.abrupt("return", sn(e, {
                                    responseType: o,
                                    scopes: i,
                                    authorizeUrl: a,
                                    userinfoUrl: u,
                                    issuer: s
                                }).then(function(e) {
                                    return ln(t, e.tokens);
                                }));
                            case 10:
                            case "end":
                                return n.stop();
                        }
                    }, n);
                }), new (o || (o = Promise))(function(e, t) {
                    function a(e) {
                        try {
                            s(i.next(e));
                        } catch (e) {
                            t(e);
                        }
                    }
                    function u(e) {
                        try {
                            s(i.throw(e));
                        } catch (e) {
                            t(e);
                        }
                    }
                    function s(t) {
                        var n;
                        t.done ? e(t.value) : (n = t.value, n instanceof o ? n : new o(function(e) {
                            e(n);
                        })).then(a, u);
                    }
                    s((i = i.apply(n, r || [])).next());
                });
            }
            function hn(e, t) {
                var n, r, o, i;
                return n = this, r = void 0, o = void 0, i = K().mark(function n() {
                    var r, o, i, a, u, s, c, f, l;
                    return K().wrap(function(n) {
                        for(;;)switch(n.prev = n.next){
                            case 0:
                                if (!(r = e.tokenManager.getTokensSync()).refreshToken) {
                                    n.next = 3;
                                    break;
                                }
                                return n.abrupt("return", cn(e, t, r.refreshToken));
                            case 3:
                                if (r.accessToken || r.idToken) {
                                    n.next = 5;
                                    break;
                                }
                                throw new b("renewTokens() was called but there is no existing token");
                            case 5:
                                if (o = r.accessToken || {}, i = r.idToken || {}, a = o.scopes || i.scopes) {
                                    n.next = 10;
                                    break;
                                }
                                throw new b("renewTokens: invalid tokens: could not read scopes");
                            case 10:
                                if (u = o.authorizeUrl || i.authorizeUrl) {
                                    n.next = 13;
                                    break;
                                }
                                throw new b("renewTokens: invalid tokens: could not read authorizeUrl");
                            case 13:
                                return s = o.userinfoUrl || e.options.userinfoUrl, c = i.issuer || e.options.issuer, t = Object.assign({
                                    scopes: a,
                                    authorizeUrl: u,
                                    userinfoUrl: s,
                                    issuer: c
                                }, t), e.options.pkce ? t.responseType = "code" : (f = Et(e), l = f.responseType, t.responseType = l), n.abrupt("return", sn(e, t).then(function(e) {
                                    return e.tokens;
                                }));
                            case 18:
                            case "end":
                                return n.stop();
                        }
                    }, n);
                }), new (o || (o = Promise))(function(e, t) {
                    function a(e) {
                        try {
                            s(i.next(e));
                        } catch (e) {
                            t(e);
                        }
                    }
                    function u(e) {
                        try {
                            s(i.throw(e));
                        } catch (e) {
                            t(e);
                        }
                    }
                    function s(t) {
                        var n;
                        t.done ? e(t.value) : (n = t.value, n instanceof o ? n : new o(function(e) {
                            e(n);
                        })).then(a, u);
                    }
                    s((i = i.apply(n, r || [])).next());
                });
            }
            function dn(e, t, n) {
                var r, o, i, a;
                return r = this, o = void 0, i = void 0, a = K().mark(function r() {
                    return K().wrap(function(r) {
                        for(;;)switch(r.prev = r.next){
                            case 0:
                                if (t) {
                                    r.next = 4;
                                    break;
                                }
                                return r.next = 3, e.tokenManager.getTokens();
                            case 3:
                                t = r.sent.accessToken;
                            case 4:
                                if (n) {
                                    r.next = 8;
                                    break;
                                }
                                return r.next = 7, e.tokenManager.getTokens();
                            case 7:
                                n = r.sent.idToken;
                            case 8:
                                if (t && Xt(t)) {
                                    r.next = 10;
                                    break;
                                }
                                return r.abrupt("return", Promise.reject(new b("getUserInfo requires an access token object")));
                            case 10:
                                if (n && Qt(n)) {
                                    r.next = 12;
                                    break;
                                }
                                return r.abrupt("return", Promise.reject(new b("getUserInfo requires an ID token object")));
                            case 12:
                                return r.abrupt("return", Se(e, {
                                    url: t.userinfoUrl,
                                    method: "GET",
                                    accessToken: t.accessToken
                                }).then(function(e) {
                                    return e.sub === n.claims.sub ? e : Promise.reject(new b("getUserInfo request was rejected due to token mismatch"));
                                }).catch(function(e) {
                                    var t;
                                    if (e.xhr && (401 === e.xhr.status || 403 === e.xhr.status) && (e.xhr.headers && ge(e.xhr.headers.get) && e.xhr.headers.get("WWW-Authenticate") ? t = e.xhr.headers.get("WWW-Authenticate") : ge(e.xhr.getResponseHeader) && (t = e.xhr.getResponseHeader("WWW-Authenticate")), t)) {
                                        var n = t.match(/error="(.*?)"/) || [], r = t.match(/error_description="(.*?)"/) || [], o = n[1], i = r[1];
                                        o && i && (e = new k(o, i));
                                    }
                                    throw e;
                                }));
                            case 13:
                            case "end":
                                return r.stop();
                        }
                    }, r);
                }), new (i || (i = Promise))(function(e, t) {
                    function n(e) {
                        try {
                            s(a.next(e));
                        } catch (e) {
                            t(e);
                        }
                    }
                    function u(e) {
                        try {
                            s(a.throw(e));
                        } catch (e) {
                            t(e);
                        }
                    }
                    function s(t) {
                        var r;
                        t.done ? e(t.value) : (r = t.value, r instanceof i ? r : new i(function(e) {
                            e(r);
                        })).then(n, u);
                    }
                    s((a = a.apply(r, o || [])).next());
                });
            }
            function vn(e, t) {
                if (arguments.length > 2) return Promise.reject(new b('As of version 3.0, "getWithPopup" takes only a single set of options'));
                var n = it("/", t);
                return t = U(t) || {}, Object.assign(t, {
                    display: "popup",
                    responseMode: "okta_post_message",
                    popupWindow: n
                }), un(e, t);
            }
            function gn(e, t) {
                return arguments.length > 2 ? Promise.reject(new b('As of version 3.0, "getWithRedirect" takes only a single set of options')) : (t = U(t) || {}, Dt(e, t).then(function(n) {
                    var r = pt(e, t), o = r.authorizeUrl + Je(n), i = {
                        issuer: e.options.issuer,
                        responseType: n.responseType,
                        state: n.state,
                        nonce: n.nonce,
                        scopes: n.scopes,
                        clientId: n.clientId,
                        urls: r,
                        ignoreSignature: n.ignoreSignature,
                        redirectUri: n.redirectUri,
                        codeVerifier: n.codeVerifier,
                        codeChallenge: n.codeChallenge,
                        codeChallengeMethod: n.codeChallengeMethod
                    };
                    e.transactionManager.save(i, {
                        oauth: !0
                    }), e.token.getWithRedirect._setLocation(o);
                }));
            }
            function yn(e) {
                var t = e.options.pkce ? "query" : "fragment";
                return e.options.responseMode || t;
            }
            function mn(e, t) {
                var n, r = (t = he(t = t || {}) ? {
                    url: t
                } : t).url, o = t.responseMode || yn(e), i = e.token.parseFromUrl._getLocation();
                if (!(n = "query" === o ? r ? r.substring(r.indexOf("?")) : i.search : r ? r.substring(r.indexOf("#")) : i.hash)) throw new b("Unable to parse a token from the url");
                return Ht(n);
            }
            function bn(e, t) {
                "query" === (t.responseMode || yn(e)) ? function(e) {
                    var t = e.token.parseFromUrl._getHistory(), n = e.token.parseFromUrl._getDocument(), r = e.token.parseFromUrl._getLocation();
                    t && t.replaceState ? t.replaceState(null, n.title, r.pathname + r.hash) : r.search = "";
                }(e) : function(e) {
                    var t = e.token.parseFromUrl._getHistory(), n = e.token.parseFromUrl._getDocument(), r = e.token.parseFromUrl._getLocation();
                    t && t.replaceState ? t.replaceState(null, n.title, r.pathname + r.search) : r.hash = "";
                }(e);
            }
            function kn(e, t) {
                var n, r, o, i;
                return n = this, r = void 0, o = void 0, i = K().mark(function n() {
                    var r, o, i, a;
                    return K().wrap(function(n) {
                        for(;;)switch(n.prev = n.next){
                            case 0:
                                if (t = he(t = t || {}) ? {
                                    url: t
                                } : t, r = mn(e, t), o = r.state, i = e.transactionManager.load({
                                    oauth: !0,
                                    pkce: e.options.pkce,
                                    state: o
                                })) {
                                    n.next = 7;
                                    break;
                                }
                                return n.abrupt("return", Promise.reject(new b("Unable to retrieve OAuth redirect params from storage")));
                            case 7:
                                return a = i.urls, delete i.urls, t.url || bn(e, t), n.abrupt("return", an(e, i, r, a).catch(function(t) {
                                    throw _t(t) || e.transactionManager.clear({
                                        state: o
                                    }), t;
                                }).then(function(t) {
                                    return e.transactionManager.clear({
                                        state: o
                                    }), t;
                                }));
                            case 11:
                            case "end":
                                return n.stop();
                        }
                    }, n);
                }), new (o || (o = Promise))(function(e, t) {
                    function a(e) {
                        try {
                            s(i.next(e));
                        } catch (e) {
                            t(e);
                        }
                    }
                    function u(e) {
                        try {
                            s(i.throw(e));
                        } catch (e) {
                            t(e);
                        }
                    }
                    function s(t) {
                        var n;
                        t.done ? e(t.value) : (n = t.value, n instanceof o ? n : new o(function(e) {
                            e(n);
                        })).then(a, u);
                    }
                    s((i = i.apply(n, r || [])).next());
                });
            }
            function wn() {
                return "undefined" != typeof window ? window.console : "undefined" != typeof console ? console : void 0;
            }
            function xn() {
                var e = wn();
                return e && e.log ? e : {
                    log: function() {},
                    warn: function() {},
                    group: function() {},
                    groupEnd: function() {}
                };
            }
            function Sn(e) {
                xn().warn("[okta-auth-sdk] WARN: " + e);
            }
            function Tn(e) {
                xn().warn("[okta-auth-sdk] DEPRECATION: " + e);
            }
            function On(e, t) {
                return function() {
                    return Tn(e), t.apply(null, arguments);
                };
            }
            var An = n(6808), En = {
                getHttpCache: function() {
                    return null;
                },
                getPKCEStorage: function() {
                    return null;
                },
                browserHasLocalStorage: function() {
                    try {
                        var e = En.getLocalStorage();
                        return En.testStorage(e);
                    } catch (e) {
                        return !1;
                    }
                },
                browserHasSessionStorage: function() {
                    try {
                        var e = En.getSessionStorage();
                        return En.testStorage(e);
                    } catch (e) {
                        return !1;
                    }
                },
                testStorageType: function(e) {
                    var t = !1;
                    switch(e){
                        case "sessionStorage":
                            t = En.browserHasSessionStorage();
                            break;
                        case "localStorage":
                            t = En.browserHasLocalStorage();
                            break;
                        case "cookie":
                        case "memory":
                            t = !0;
                            break;
                        default:
                            t = !1;
                    }
                    return t;
                },
                getStorageByType: function(e, t) {
                    var n = null;
                    switch(e){
                        case "sessionStorage":
                            n = En.getSessionStorage();
                            break;
                        case "localStorage":
                            n = En.getLocalStorage();
                            break;
                        case "cookie":
                            n = En.getCookieStorage(t);
                            break;
                        case "memory":
                            n = En.getInMemoryStorage();
                            break;
                        default:
                            throw new b("Unrecognized storage option: ".concat(e));
                    }
                    return n;
                },
                findStorageType: function(e) {
                    var t, n;
                    return t = (e = e.slice()).shift(), (n = e.length ? e[0] : null) ? En.testStorageType(t) ? t : (Sn("This browser doesn't support ".concat(t, ". Switching to ").concat(n, ".")), En.findStorageType(e)) : t;
                },
                getLocalStorage: function() {
                    return localStorage;
                },
                getSessionStorage: function() {
                    return sessionStorage;
                },
                getCookieStorage: function(e) {
                    var t = e.secure, n = e.sameSite, r = e.sessionCookie;
                    if (void 0 === t || void 0 === n) throw new b('getCookieStorage: "secure" and "sameSite" options must be provided');
                    var o = {
                        getItem: En.storage.get,
                        setItem: function(e, o) {
                            var i = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : "2200-01-01T00:00:00.000Z";
                            i = r ? null : i, En.storage.set(e, o, i, {
                                secure: t,
                                sameSite: n
                            });
                        },
                        removeItem: function(e) {
                            En.storage.delete(e);
                        }
                    };
                    return e.useMultipleCookies ? {
                        getItem: function(e) {
                            var t = o.getItem(), n = {};
                            return Object.keys(t).forEach(function(r) {
                                0 === r.indexOf(e) && (n[r.replace("".concat(e, "_"), "")] = JSON.parse(t[r]));
                            }), JSON.stringify(n);
                        },
                        setItem: function(e, t) {
                            var n = JSON.parse(this.getItem(e));
                            t = JSON.parse(t), Object.keys(t).forEach(function(r) {
                                var i = e + "_" + r, a = JSON.stringify(t[r]);
                                o.setItem(i, a), delete n[r];
                            }), Object.keys(n).forEach(function(t) {
                                o.removeItem(e + "_" + t);
                            });
                        },
                        removeItem: function(e) {
                            var t = JSON.parse(this.getItem(e));
                            Object.keys(t).forEach(function(t) {
                                o.removeItem(e + "_" + t);
                            });
                        }
                    } : o;
                },
                inMemoryStore: {},
                getInMemoryStorage: function() {
                    var e = this;
                    return {
                        getItem: function(t) {
                            return e.inMemoryStore[t];
                        },
                        setItem: function(t, n) {
                            e.inMemoryStore[t] = n;
                        }
                    };
                },
                testStorage: function(e) {
                    var t = "okta-test-storage";
                    try {
                        return e.setItem(t, t), e.removeItem(t), !0;
                    } catch (e) {
                        return !1;
                    }
                },
                storage: {
                    set: function(e, t, n, r) {
                        var o = r.sameSite, i = r.secure;
                        if (void 0 === i || void 0 === o) throw new b('storage.set: "secure" and "sameSite" options must be provided');
                        var a = {
                            path: r.path || "/",
                            secure: i,
                            sameSite: o
                        };
                        return Date.parse(n) && (a.expires = new Date(n)), An.set(e, t, a), En.storage.get(e);
                    },
                    get: function(e) {
                        return An.get(e);
                    },
                    delete: function(e) {
                        return An.remove(e, {
                            path: "/"
                        });
                    }
                }
            }, _n = En;
            function Rn(e) {
                return /(stateTokenExternalId=)/i.test(e) && /(state=)/i.test(e);
            }
            function Pn(e) {
                return Ht(e);
            }
            function jn(e) {
                var t = (e = e || {}).scopes;
                if (t && !Array.isArray(t)) throw new b('scopes must be a array of strings. Required usage: new OktaAuth({scopes: ["openid", "email"]})');
                var n = e.issuer;
                if (!n) throw new b('No issuer passed to constructor. Required usage: new OktaAuth({issuer: "https://{yourOktaDomain}.com/oauth2/{authServerId}"})');
                if (!new RegExp("^http?s?://.+").test(e.issuer)) throw new b('Issuer must be a valid URL. Required usage: new OktaAuth({issuer: "https://{yourOktaDomain}.com/oauth2/{authServerId}"})');
                if (-1 !== n.indexOf("-admin.")) throw new b('Issuer URL passed to constructor contains "-admin" in subdomain. Required usage: new OktaAuth({issuer: "https://{yourOktaDomain}.com})');
            }
            function In(e, t) {
                var n = e.userAgent || {};
                return n.value ? n.value : n.template ? n.template.replace("$OKTA_AUTH_JS", t) : t;
            }
            var Cn = function() {
                function e(t) {
                    a(this, e), this.localOffset = parseInt(t || 0);
                }
                return q(e, [
                    {
                        key: "now",
                        value: function() {
                            return (Date.now() + this.localOffset) / 1e3;
                        }
                    }
                ], [
                    {
                        key: "create",
                        value: function() {
                            return new e(0);
                        }
                    }
                ]), e;
            }(), Mn = function() {
                function e(t) {
                    var n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
                    a(this, e), this.tokenManager = t, this.options = n;
                }
                return q(e, [
                    {
                        key: "start",
                        value: function() {
                            var e = this, t = [];
                            this.onTokenExpiredHandler = function(n) {
                                if (e.options.autoRenew) {
                                    if (function(e) {
                                        var t = !1;
                                        if (e.push(Date.now()), e.length >= 10) {
                                            var n = e.shift();
                                            t = e[e.length - 1] - n < 3e4;
                                        }
                                        return t;
                                    }(t)) {
                                        var r = new b("Too many token renew requests");
                                        e.tokenManager.emitError(r);
                                    } else e.tokenManager.renew(n).catch(function() {});
                                } else e.options.autoRemove && e.tokenManager.remove(n);
                            }, this.tokenManager.on(Nn, this.onTokenExpiredHandler), this.tokenManager.setExpireEventTimeoutAll(), this.options.syncStorage && yt() && (this.storageListener = function(t) {
                                var n = t.key, r = t.newValue, o = t.oldValue;
                                (!n || n === e.options.storageKey && r !== o) && (e.syncTimeout = setTimeout(function() {
                                    return e.tokenManager.resetExpireEventTimeoutAll(), void e.tokenManager.emitEventsForCrossTabsStorageUpdate(r, o);
                                }, e.options._storageEventDelay));
                            }, window.addEventListener("storage", this.storageListener));
                        }
                    },
                    {
                        key: "stop",
                        value: function() {
                            this.tokenManager.clearExpireEventTimeoutAll(), this.tokenManager.off(Nn, this.onTokenExpiredHandler), this.options.syncStorage && yt() && (window.removeEventListener("storage", this.storageListener), clearTimeout(this.syncTimeout));
                        }
                    }
                ]), e;
            }(), Un = function(e, t, n, r) {
                return new (n || (n = Promise))(function(o, i) {
                    function a(e) {
                        try {
                            s(r.next(e));
                        } catch (e) {
                            i(e);
                        }
                    }
                    function u(e) {
                        try {
                            s(r.throw(e));
                        } catch (e) {
                            i(e);
                        }
                    }
                    function s(e) {
                        var t;
                        e.done ? o(e.value) : (t = e.value, t instanceof n ? t : new n(function(e) {
                            e(t);
                        })).then(a, u);
                    }
                    s((r = r.apply(e, t || [])).next());
                });
            }, Fn = {
                autoRenew: !0,
                autoRemove: !0,
                clearPendingRemoveTokens: !0,
                storage: void 0,
                expireEarlySeconds: 30,
                storageKey: X,
                syncStorage: !0,
                _storageEventDelay: 0
            }, Nn = "expired", Ln = "renewed", Dn = "added", Bn = "removed", qn = "error", Hn = function() {
                function e(t) {
                    var n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
                    if (a(this, e), this.sdk = t, this.emitter = t.emitter, !this.emitter) throw new b("Emitter should be initialized before TokenManager");
                    n = Object.assign({}, Fn, M(n)), mt() && (n._storageEventDelay = n._storageEventDelay || 1e3), At() || (n.expireEarlySeconds = Fn.expireEarlySeconds), this.options = n;
                    var r = M({
                        storageKey: n.storageKey,
                        secure: n.secure
                    });
                    "object" === c(n.storage) ? r.storageProvider = n.storage : n.storage && (r.storageType = n.storage), this.storage = t.storageManager.getTokenStorage(r), this.clock = Cn.create(), this.state = {
                        expireTimeouts: {},
                        renewPromise: null
                    }, this.on = this.emitter.on.bind(this.emitter), this.off = this.emitter.off.bind(this.emitter);
                }
                return q(e, [
                    {
                        key: "start",
                        value: function() {
                            this.service && this.stop(), this.options.clearPendingRemoveTokens && this.clearPendingRemoveTokens(), this.service = new Mn(this, this.getOptions()), this.service.start();
                        }
                    },
                    {
                        key: "stop",
                        value: function() {
                            this.service && (this.service.stop(), this.service = null);
                        }
                    },
                    {
                        key: "getOptions",
                        value: function() {
                            return U(this.options);
                        }
                    },
                    {
                        key: "getExpireTime",
                        value: function(e) {
                            return e.expiresAt - this.options.expireEarlySeconds;
                        }
                    },
                    {
                        key: "hasExpired",
                        value: function(e) {
                            return this.getExpireTime(e) <= this.clock.now();
                        }
                    },
                    {
                        key: "emitExpired",
                        value: function(e, t) {
                            this.emitter.emit(Nn, e, t);
                        }
                    },
                    {
                        key: "emitRenewed",
                        value: function(e, t, n) {
                            this.emitter.emit(Ln, e, t, n);
                        }
                    },
                    {
                        key: "emitAdded",
                        value: function(e, t) {
                            this.emitter.emit(Dn, e, t);
                        }
                    },
                    {
                        key: "emitRemoved",
                        value: function(e, t) {
                            this.emitter.emit(Bn, e, t);
                        }
                    },
                    {
                        key: "emitError",
                        value: function(e) {
                            this.emitter.emit(qn, e);
                        }
                    },
                    {
                        key: "emitEventsForCrossTabsStorageUpdate",
                        value: function(e, t) {
                            var n = this, r = this.getTokensFromStorageValue(t), o = this.getTokensFromStorageValue(e);
                            Object.keys(o).forEach(function(e) {
                                var t = r[e], i = o[e];
                                JSON.stringify(t) !== JSON.stringify(i) && n.emitAdded(e, i);
                            }), Object.keys(r).forEach(function(e) {
                                var t = r[e];
                                o[e] || n.emitRemoved(e, t);
                            });
                        }
                    },
                    {
                        key: "clearExpireEventTimeout",
                        value: function(e) {
                            clearTimeout(this.state.expireTimeouts[e]), delete this.state.expireTimeouts[e], this.state.renewPromise = null;
                        }
                    },
                    {
                        key: "clearExpireEventTimeoutAll",
                        value: function() {
                            var e = this.state.expireTimeouts;
                            for(var t in e)Object.prototype.hasOwnProperty.call(e, t) && this.clearExpireEventTimeout(t);
                        }
                    },
                    {
                        key: "setExpireEventTimeout",
                        value: function(e, t) {
                            var n = this;
                            if (!Zt(t)) {
                                var r = this.getExpireTime(t), o = 1e3 * Math.max(r - this.clock.now(), 0);
                                this.clearExpireEventTimeout(e);
                                var i = setTimeout(function() {
                                    n.emitExpired(e, t);
                                }, o);
                                this.state.expireTimeouts[e] = i;
                            }
                        }
                    },
                    {
                        key: "setExpireEventTimeoutAll",
                        value: function() {
                            var e = this.storage.getStorage();
                            for(var t in e)if (Object.prototype.hasOwnProperty.call(e, t)) {
                                var n = e[t];
                                this.setExpireEventTimeout(t, n);
                            }
                        }
                    },
                    {
                        key: "resetExpireEventTimeoutAll",
                        value: function() {
                            this.clearExpireEventTimeoutAll(), this.setExpireEventTimeoutAll();
                        }
                    },
                    {
                        key: "add",
                        value: function(e, t) {
                            var n = this.storage.getStorage();
                            en(t), n[e] = t, this.storage.setStorage(n), this.emitAdded(e, t), this.setExpireEventTimeout(e, t);
                        }
                    },
                    {
                        key: "getSync",
                        value: function(e) {
                            return this.storage.getStorage()[e];
                        }
                    },
                    {
                        key: "get",
                        value: function(e) {
                            return Un(this, void 0, void 0, K().mark(function t() {
                                return K().wrap(function(t) {
                                    for(;;)switch(t.prev = t.next){
                                        case 0:
                                            return t.abrupt("return", this.getSync(e));
                                        case 1:
                                        case "end":
                                            return t.stop();
                                    }
                                }, t, this);
                            }));
                        }
                    },
                    {
                        key: "getTokensSync",
                        value: function() {
                            var e = {}, t = this.storage.getStorage();
                            return Object.keys(t).forEach(function(n) {
                                var r = t[n];
                                Xt(r) ? e.accessToken = r : Qt(r) ? e.idToken = r : Zt(r) && (e.refreshToken = r);
                            }), e;
                        }
                    },
                    {
                        key: "getTokens",
                        value: function() {
                            return Un(this, void 0, void 0, K().mark(function e() {
                                return K().wrap(function(e) {
                                    for(;;)switch(e.prev = e.next){
                                        case 0:
                                            return e.abrupt("return", this.getTokensSync());
                                        case 1:
                                        case "end":
                                            return e.stop();
                                    }
                                }, e, this);
                            }));
                        }
                    },
                    {
                        key: "getStorageKeyByType",
                        value: function(e) {
                            var t = this.storage.getStorage();
                            return Object.keys(t).filter(function(n) {
                                var r = t[n];
                                return Xt(r) && "accessToken" === e || Qt(r) && "idToken" === e || Zt(r) && "refreshToken" === e;
                            })[0];
                        }
                    },
                    {
                        key: "getTokenType",
                        value: function(e) {
                            if (Xt(e)) return "accessToken";
                            if (Qt(e)) return "idToken";
                            if (Zt(e)) return "refreshToken";
                            throw new b("Unknown token type");
                        }
                    },
                    {
                        key: "setTokens",
                        value: function(e, t, n, r) {
                            var o = this, i = function(e, i) {
                                var a = o.getTokenType(i);
                                "accessToken" === a ? t && t(e, i) : "idToken" === a ? n && n(e, i) : "refreshToken" === a && r && r(e, i);
                            }, a = function(e, t) {
                                o.emitAdded(e, t), o.setExpireEventTimeout(e, t), i(e, t);
                            }, u = function(e, t) {
                                o.clearExpireEventTimeout(e), o.emitRemoved(e, t), i(e, t);
                            }, s = [
                                "idToken",
                                "accessToken",
                                "refreshToken"
                            ], c = this.getTokensSync();
                            s.forEach(function(t) {
                                var n = e[t];
                                n && en(n, t);
                            });
                            var f = s.reduce(function(t, n) {
                                var r = e[n];
                                return r && (t[o.getStorageKeyByType(n) || n] = r), t;
                            }, {});
                            this.storage.setStorage(f), s.forEach(function(t) {
                                var n, r, s, f = e[t], l = c[t], p = o.getStorageKeyByType(t) || t;
                                f && l ? (u(p, l), a(p, f), n = p, r = f, s = l, o.emitRenewed(n, r, s), o.clearExpireEventTimeout(n), o.setExpireEventTimeout(n, r), i(n, r)) : f ? a(p, f) : l && u(p, l);
                            });
                        }
                    },
                    {
                        key: "remove",
                        value: function(e) {
                            this.clearExpireEventTimeout(e);
                            var t = this.storage.getStorage(), n = t[e];
                            delete t[e], this.storage.setStorage(t), this.emitRemoved(e, n);
                        }
                    },
                    {
                        key: "renewToken",
                        value: function(e) {
                            return Un(this, void 0, void 0, K().mark(function t() {
                                return K().wrap(function(t) {
                                    for(;;)switch(t.prev = t.next){
                                        case 0:
                                            return t.abrupt("return", this.sdk.token.renew(e));
                                        case 1:
                                        case "end":
                                            return t.stop();
                                    }
                                }, t, this);
                            }));
                        }
                    },
                    {
                        key: "validateToken",
                        value: function(e) {
                            return en(e);
                        }
                    },
                    {
                        key: "renew",
                        value: function(e) {
                            var t = this;
                            if (this.state.renewPromise) return this.state.renewPromise;
                            try {
                                var n = this.getSync(e);
                                if (!n) throw new b("The tokenManager has no token for the key: " + e);
                            } catch (e) {
                                return Promise.reject(e);
                            }
                            return this.clearExpireEventTimeout(e), this.state.renewPromise = this.sdk.token.renewTokens().then(function(e) {
                                return t.setTokens(e), e[t.getTokenType(n)];
                            }).catch(function(n) {
                                throw (qt(n) || "OAuthError" === n.name || "AuthSdkError" === n.name) && t.remove(e), n.tokenKey = e, t.emitError(n), n;
                            }).finally(function() {
                                t.state.renewPromise = null;
                            }), this.state.renewPromise;
                        }
                    },
                    {
                        key: "clear",
                        value: function() {
                            this.clearExpireEventTimeoutAll(), this.storage.clearStorage();
                        }
                    },
                    {
                        key: "clearPendingRemoveTokens",
                        value: function() {
                            var e = this, t = this.getTokensSync();
                            Object.keys(t).forEach(function(n) {
                                t[n].pendingRemove && e.remove(n);
                            });
                        }
                    },
                    {
                        key: "getTokensFromStorageValue",
                        value: function(e) {
                            var t;
                            try {
                                t = JSON.parse(e) || {};
                            } catch (e) {
                                t = {};
                            }
                            return t;
                        }
                    },
                    {
                        key: "updateRefreshToken",
                        value: function(e) {
                            var t = this.getStorageKeyByType("refreshToken") || ae, n = this.storage.getStorage();
                            en(e), n[t] = e, this.storage.setStorage(n);
                        }
                    },
                    {
                        key: "addPendingRemoveFlags",
                        value: function() {
                            var e = this.getTokensSync();
                            Object.keys(e).forEach(function(t) {
                                e[t].pendingRemove = !0;
                            }), this.setTokens(e);
                        }
                    }
                ]), e;
            }(), Kn = function() {
                function e() {
                    a(this, e), this.queue = [], this.running = !1;
                }
                return q(e, [
                    {
                        key: "push",
                        value: function(e, t) {
                            for(var n = this, r = arguments.length, o = new Array(r > 2 ? r - 2 : 0), i = 2; i < r; i++)o[i - 2] = arguments[i];
                            return new Promise(function(r, i) {
                                n.queue.push({
                                    method: e,
                                    thisObject: t,
                                    args: o,
                                    resolve: r,
                                    reject: i
                                }), n.run();
                            });
                        }
                    },
                    {
                        key: "run",
                        value: function() {
                            var e = this;
                            if (!this.running && 0 !== this.queue.length) {
                                this.running = !0;
                                var t = this.queue.shift(), n = t.method.apply(t.thisObject, t.args);
                                ye(n) ? n.then(t.resolve, t.reject).finally(function() {
                                    e.running = !1, e.run();
                                }) : (t.resolve(n), this.running = !1, this.run());
                            }
                        }
                    }
                ]), e;
            }(), Vn = Kn;
            function Gn(e, t) {
                var n, r, o;
                return t = t || {}, kt() ? new Promise(function(i, a) {
                    (r = document.createElement("iframe")).style.display = "none", o = function(t) {
                        if (t && t.data && t.origin === e.getIssuerOrigin()) {
                            try {
                                var n = JSON.parse(t.data);
                            } catch (e) {
                                return;
                            }
                            if (n) return "FingerprintAvailable" === n.type ? i(n.fingerprint) : void ("FingerprintServiceReady" === n.type && t.source.postMessage(JSON.stringify({
                                type: "GetFingerprint"
                            }), t.origin));
                        }
                    }, nt(window, "message", o), r.src = e.getIssuerOrigin() + "/auth/services/devicefingerprint", document.body.appendChild(r), n = setTimeout(function() {
                        a(new b("Fingerprinting timed out"));
                    }, t.timeout || 15e3);
                }).finally(function() {
                    clearTimeout(n), rt(window, "message", o), document.body.contains(r) && r.parentElement.removeChild(r);
                }) : Promise.reject(new b("Fingerprinting is not supported on this device"));
            }
            var Wn = n(3615), $n = null, zn = {
                updateAuthStatePromise: null,
                canceledTimes: 0
            }, Jn = "authStateChange", Yn = function() {
                function e(t) {
                    var n = this;
                    if (a(this, e), !t.emitter) throw new b("Emitter should be initialized before AuthStateManager");
                    this._sdk = t, this._pending = Object.assign({}, zn), this._authState = $n, this._logOptions = {}, t.tokenManager.on(Dn, function(e, t) {
                        n._setLogOptions({
                            event: Dn,
                            key: e,
                            token: t
                        }), n.updateAuthState();
                    }), t.tokenManager.on(Bn, function(e, t) {
                        n._setLogOptions({
                            event: Bn,
                            key: e,
                            token: t
                        }), n.updateAuthState();
                    });
                }
                return q(e, [
                    {
                        key: "_setLogOptions",
                        value: function(e) {
                            this._logOptions = e;
                        }
                    },
                    {
                        key: "getAuthState",
                        value: function() {
                            return this._authState;
                        }
                    },
                    {
                        key: "getPreviousAuthState",
                        value: function() {
                            return this._prevAuthState;
                        }
                    },
                    {
                        key: "updateAuthState",
                        value: function() {
                            var e, t, n, r;
                            return e = this, t = void 0, n = void 0, r = K().mark(function e() {
                                var t, n, r, o, i, a, u, s = this;
                                return K().wrap(function(e) {
                                    for(;;)switch(e.prev = e.next){
                                        case 0:
                                            if (t = this._sdk.options, n = t.transformAuthState, r = t.devMode, o = function(e) {
                                                var t = s._logOptions, n = t.event, r = t.key, o = t.token;
                                                xn().group("OKTA-AUTH-JS:updateAuthState: Event:".concat(n, " Status:").concat(e)), xn().log(r, o), xn().log("Current authState", s._authState), xn().groupEnd(), s._logOptions = {};
                                            }, i = function(e) {
                                                var t, n;
                                                n = e, (t = s._authState) && t.isAuthenticated === n.isAuthenticated && JSON.stringify(t.idToken) === JSON.stringify(n.idToken) && JSON.stringify(t.accessToken) === JSON.stringify(n.accessToken) && t.error === n.error ? r && o("unchanged") : (s._prevAuthState = s._authState, s._authState = e, s._sdk.emitter.emit(Jn, Object.assign({}, e)), r && o("emitted"));
                                            }, a = function e(t) {
                                                return s._pending.updateAuthStatePromise.then(function() {
                                                    var n = s._pending.updateAuthStatePromise;
                                                    return n && n !== t ? e(n) : s.getAuthState();
                                                });
                                            }, !this._pending.updateAuthStatePromise) {
                                                e.next = 11;
                                                break;
                                            }
                                            if (!(this._pending.canceledTimes >= 10)) {
                                                e.next = 10;
                                                break;
                                            }
                                            return r && o("terminated"), e.abrupt("return", a(this._pending.updateAuthStatePromise));
                                        case 10:
                                            this._pending.updateAuthStatePromise.cancel();
                                        case 11:
                                            return u = new Wn(function(e, t, a) {
                                                a.shouldReject = !1, a(function() {
                                                    s._pending.updateAuthStatePromise = null, s._pending.canceledTimes = s._pending.canceledTimes + 1, r && o("canceled");
                                                });
                                                var c = function(t) {
                                                    u.isCanceled ? e() : (i(t), e(), s._pending = Object.assign({}, zn));
                                                };
                                                s._sdk.isAuthenticated().then(function() {
                                                    if (u.isCanceled) e();
                                                    else {
                                                        var t = s._sdk.tokenManager.getTokensSync(), r = t.accessToken, o = t.idToken, i = t.refreshToken, a = {
                                                            accessToken: r,
                                                            idToken: o,
                                                            refreshToken: i,
                                                            isAuthenticated: !(!r || !o)
                                                        };
                                                        (n ? n(s._sdk, a) : Promise.resolve(a)).then(function(e) {
                                                            return c(e);
                                                        }).catch(function(e) {
                                                            return c({
                                                                accessToken: r,
                                                                idToken: o,
                                                                refreshToken: i,
                                                                isAuthenticated: !1,
                                                                error: e
                                                            });
                                                        });
                                                    }
                                                });
                                            }), this._pending.updateAuthStatePromise = u, e.abrupt("return", a(u));
                                        case 14:
                                        case "end":
                                            return e.stop();
                                    }
                                }, e, this);
                            }), new (n || (n = Promise))(function(o, i) {
                                function a(e) {
                                    try {
                                        s(r.next(e));
                                    } catch (e) {
                                        i(e);
                                    }
                                }
                                function u(e) {
                                    try {
                                        s(r.throw(e));
                                    } catch (e) {
                                        i(e);
                                    }
                                }
                                function s(e) {
                                    var t;
                                    e.done ? o(e.value) : (t = e.value, t instanceof n ? t : new n(function(e) {
                                        e(t);
                                    })).then(a, u);
                                }
                                s((r = r.apply(e, t || [])).next());
                            });
                        }
                    },
                    {
                        key: "subscribe",
                        value: function(e) {
                            this._sdk.emitter.on(Jn, e);
                        }
                    },
                    {
                        key: "unsubscribe",
                        value: function(e) {
                            this._sdk.emitter.off(Jn, e);
                        }
                    }
                ]), e;
            }(), Xn = function() {
                function e(t, n) {
                    if (a(this, e), !t) throw new b('"storage" is required');
                    if ("string" != typeof n || !n.length) throw new b('"storageName" is required');
                    this.storageName = n, this.storageProvider = t;
                }
                return q(e, [
                    {
                        key: "getItem",
                        value: function(e) {
                            return this.getStorage()[e];
                        }
                    },
                    {
                        key: "setItem",
                        value: function(e, t) {
                            return this.updateStorage(e, t);
                        }
                    },
                    {
                        key: "removeItem",
                        value: function(e) {
                            return this.clearStorage(e);
                        }
                    },
                    {
                        key: "getStorage",
                        value: function() {
                            var e = this.storageProvider.getItem(this.storageName);
                            e = e || "{}";
                            try {
                                return JSON.parse(e);
                            } catch (e) {
                                throw new b("Unable to parse storage string: " + this.storageName);
                            }
                        }
                    },
                    {
                        key: "setStorage",
                        value: function(e) {
                            try {
                                var t = e ? JSON.stringify(e) : "{}";
                                this.storageProvider.setItem(this.storageName, t);
                            } catch (e) {
                                throw new b("Unable to set storage: " + this.storageName);
                            }
                        }
                    },
                    {
                        key: "clearStorage",
                        value: function(e) {
                            if (e) {
                                var t = this.getStorage();
                                delete t[e], this.setStorage(t);
                            } else this.storageProvider.removeItem ? this.storageProvider.removeItem(this.storageName) : this.setStorage();
                        }
                    },
                    {
                        key: "updateStorage",
                        value: function(e, t) {
                            var n = this.getStorage();
                            n[e] = t, this.setStorage(n);
                        }
                    }
                ]), e;
            }();
            function Qn(e) {
                yt() || e.storageProvider || e.storageProvider || Sn("Memory storage can only support simple single user use case on server side, please provide custom storageProvider or storageKey if advanced scenarios need to be supported.");
            }
            var Zn = function() {
                function e(t, n, r) {
                    a(this, e), this.storageManagerOptions = t, this.cookieOptions = n, this.storageUtil = r;
                }
                return q(e, [
                    {
                        key: "getOptionsForSection",
                        value: function(e, t) {
                            return Object.assign({}, this.storageManagerOptions[e], t);
                        }
                    },
                    {
                        key: "getStorage",
                        value: function(e) {
                            if ((e = Object.assign({}, this.cookieOptions, e)).storageProvider) return e.storageProvider;
                            var t = e, n = t.storageType, r = t.storageTypes;
                            if ("sessionStorage" === n && (e.sessionCookie = !0), n && r) {
                                var o = r.indexOf(n);
                                o >= 0 && (r = r.slice(o), n = null);
                            }
                            return n || (n = this.storageUtil.findStorageType(r)), this.storageUtil.getStorageByType(n, e);
                        }
                    },
                    {
                        key: "getTransactionStorage",
                        value: function(e) {
                            Qn(e = this.getOptionsForSection("transaction", e));
                            var t = this.getStorage(e), n = e.storageKey || ee;
                            return new Xn(t, n);
                        }
                    },
                    {
                        key: "getSharedTansactionStorage",
                        value: function(e) {
                            Qn(e = this.getOptionsForSection("shared-transaction", e));
                            var t = this.getStorage(e), n = e.storageKey || te;
                            return new Xn(t, n);
                        }
                    },
                    {
                        key: "getOriginalUriStorage",
                        value: function(e) {
                            Qn(e = this.getOptionsForSection("original-uri", e));
                            var t = this.getStorage(e), n = e.storageKey || ne;
                            return new Xn(t, n);
                        }
                    },
                    {
                        key: "getIdxResponseStorage",
                        value: function(e) {
                            var t;
                            if (yt()) try {
                                t = this.storageUtil.getStorageByType("memory", e);
                            } catch (e) {
                                Sn("No response storage found, you may want to provide custom implementation for intermediate idx responses to optimize the network traffic");
                            }
                            else {
                                var n = this.getTransactionStorage(e);
                                n && (t = {
                                    getItem: function(e) {
                                        var t = n.getStorage();
                                        return t && t[e] ? t[e] : null;
                                    },
                                    setItem: function(e, t) {
                                        var r = n.getStorage();
                                        if (!r) throw new b("Transaction has been cleared, failed to save idxState");
                                        r[e] = t, n.setStorage(r);
                                    },
                                    removeItem: function(e) {
                                        var t = n.getStorage();
                                        t && (delete t[e], n.setStorage(t));
                                    }
                                });
                            }
                            return t ? new Xn(t, re) : null;
                        }
                    },
                    {
                        key: "getTokenStorage",
                        value: function(e) {
                            Qn(e = this.getOptionsForSection("token", e));
                            var t = this.getStorage(e), n = e.storageKey || X;
                            return new Xn(t, n);
                        }
                    },
                    {
                        key: "getHttpCache",
                        value: function(e) {
                            e = this.getOptionsForSection("cache", e);
                            var t = this.getStorage(e), n = e.storageKey || Q;
                            return new Xn(t, n);
                        }
                    },
                    {
                        key: "getLegacyPKCEStorage",
                        value: function(e) {
                            e = this.getOptionsForSection("legacy-pkce", e);
                            var t = this.getStorage(e), n = e.storageKey || Z;
                            return new Xn(t, n);
                        }
                    },
                    {
                        key: "getLegacyOAuthParamsStorage",
                        value: function(e) {
                            e = this.getOptionsForSection("legacy-oauth-params", e);
                            var t = this.getStorage(e), n = e.storageKey || z;
                            return new Xn(t, n);
                        }
                    }
                ]), e;
            }();
            function er(e) {
                return e && e.version;
            }
            function tr(e) {
                var t = e.getSharedTansactionStorage(), n = t.getStorage();
                Object.keys(n).forEach(function(e) {
                    var t = n[e];
                    Date.now() - t.dateCreated > 18e5 && delete n[e];
                }), t.setStorage(n);
            }
            function nr(e, t, n) {
                var r = e.getSharedTansactionStorage(), o = r.getStorage();
                o[t] = {
                    dateCreated: Date.now(),
                    transaction: n
                }, r.setStorage(o);
            }
            function rr(e, t) {
                var n = e.getSharedTansactionStorage().getStorage()[t];
                return n && n.transaction && Jt(n.transaction) ? n.transaction : null;
            }
            function or(e, t) {
                var n = e.getSharedTansactionStorage(), r = n.getStorage();
                delete r[t], n.setStorage(r);
            }
            var ir = function() {
                function e(t) {
                    a(this, e), this.storageManager = t.storageManager, this.legacyWidgetSupport = !1 !== t.legacyWidgetSupport, this.saveNonceCookie = !1 !== t.saveNonceCookie, this.saveStateCookie = !1 !== t.saveStateCookie, this.saveParamsCookie = !1 !== t.saveParamsCookie, this.enableSharedStorage = !1 !== t.enableSharedStorage, this.options = t;
                }
                return q(e, [
                    {
                        key: "clear",
                        value: function() {
                            var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {}, t = this.storageManager.getTransactionStorage(), n = t.getStorage();
                            if (t.clearStorage(), this.clearIdxResponse(), this.enableSharedStorage && e.clearSharedStorage) {
                                var r = e.state || (null == n ? void 0 : n.state);
                                r && or(this.storageManager, r);
                            }
                            this.legacyWidgetSupport && (e.oauth && this.clearLegacyOAuthParams(), e.pkce && this.clearLegacyPKCE());
                        }
                    },
                    {
                        key: "save",
                        value: function(e) {
                            var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {}, n = this.storageManager.getTransactionStorage(), r = n.getStorage();
                            if (Jt(r) && !t.muteWarning && Sn("a saved auth transaction exists in storage. This may indicate another auth flow is already in progress."), n.setStorage(e), this.enableSharedStorage && e.state && nr(this.storageManager, e.state, e), t.oauth && (this.saveNonceCookie || this.saveStateCookie || this.saveParamsCookie)) {
                                var o = this.storageManager.getStorage({
                                    storageType: "cookie"
                                });
                                if (this.saveParamsCookie) {
                                    var i = e.responseType, a = e.state, u = e.nonce, s = e.scopes, c = e.clientId, f = e.urls, l = e.ignoreSignature, p = {
                                        responseType: i,
                                        state: a,
                                        nonce: u,
                                        scopes: s,
                                        clientId: c,
                                        urls: f,
                                        ignoreSignature: l
                                    };
                                    o.setItem(z, JSON.stringify(p), null);
                                }
                                this.saveNonceCookie && e.nonce && o.setItem(Y, e.nonce, null), this.saveStateCookie && e.state && o.setItem(J, e.state, null);
                            }
                        }
                    },
                    {
                        key: "exists",
                        value: function() {
                            var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
                            try {
                                var t = this.load(e);
                                return !!t;
                            } catch (e) {
                                return !1;
                            }
                        }
                    },
                    {
                        key: "load",
                        value: function() {
                            var e, t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
                            if (this.enableSharedStorage && t.state && (tr(this.storageManager), Jt(e = rr(this.storageManager, t.state)))) return e;
                            var n = this.storageManager.getTransactionStorage();
                            if (Jt(e = n.getStorage())) return e;
                            if (!this.legacyWidgetSupport) return null;
                            if (t.oauth) try {
                                var r = this.loadLegacyOAuthParams();
                                Object.assign(e, r);
                            } finally{
                                this.clearLegacyOAuthParams();
                            }
                            if (t.pkce) try {
                                var o = this.loadLegacyPKCE();
                                Object.assign(e, o);
                            } finally{
                                this.clearLegacyPKCE();
                            }
                            return Jt(e) ? e : null;
                        }
                    },
                    {
                        key: "clearLegacyPKCE",
                        value: function() {
                            this.storageManager.storageUtil.testStorageType("localStorage") && this.storageManager.getLegacyPKCEStorage({
                                storageType: "localStorage"
                            }).clearStorage(), this.storageManager.storageUtil.testStorageType("sessionStorage") && this.storageManager.getLegacyPKCEStorage({
                                storageType: "sessionStorage"
                            }).clearStorage();
                        }
                    },
                    {
                        key: "loadLegacyPKCE",
                        value: function() {
                            var e;
                            if (this.storageManager.storageUtil.testStorageType("localStorage") && (e = this.storageManager.getLegacyPKCEStorage({
                                storageType: "localStorage"
                            }).getStorage()) && e.codeVerifier) return e;
                            if (this.storageManager.storageUtil.testStorageType("sessionStorage") && (e = this.storageManager.getLegacyPKCEStorage({
                                storageType: "sessionStorage"
                            }).getStorage()) && e.codeVerifier) return e;
                            throw new b("Could not load PKCE codeVerifier from storage. This may indicate the auth flow has already completed or multiple auth flows are executing concurrently.", null);
                        }
                    },
                    {
                        key: "clearLegacyOAuthParams",
                        value: function() {
                            this.storageManager.storageUtil.testStorageType("sessionStorage") && this.storageManager.getLegacyOAuthParamsStorage({
                                storageType: "sessionStorage"
                            }).clearStorage(), this.storageManager.storageUtil.testStorageType("cookie") && this.storageManager.getLegacyOAuthParamsStorage({
                                storageType: "cookie"
                            }).clearStorage();
                        }
                    },
                    {
                        key: "loadLegacyOAuthParams",
                        value: function() {
                            var e;
                            if (this.storageManager.storageUtil.testStorageType("sessionStorage") && (e = this.storageManager.getLegacyOAuthParamsStorage({
                                storageType: "sessionStorage"
                            }).getStorage()), Gt(e)) return e;
                            if (this.storageManager.storageUtil.testStorageType("cookie") && (e = this.storageManager.getLegacyOAuthParamsStorage({
                                storageType: "cookie"
                            }).getStorage()), Gt(e)) return e;
                            throw new b("Unable to retrieve OAuth redirect params from storage");
                        }
                    },
                    {
                        key: "saveIdxResponse",
                        value: function(e) {
                            var t = this.storageManager.getIdxResponseStorage();
                            t && t.setStorage(e);
                        }
                    },
                    {
                        key: "loadIdxResponse",
                        value: function() {
                            var e = this.storageManager.getIdxResponseStorage();
                            if (!e) return null;
                            var t = e.getStorage();
                            return er(t) ? t : null;
                        }
                    },
                    {
                        key: "clearIdxResponse",
                        value: function() {
                            var e = this.storageManager.getIdxResponseStorage();
                            null == e || e.clearStorage();
                        }
                    }
                ]), e;
            }(), ar = n(4098), ur = n.n(ar);
            function sr(e, t) {
                (null == t || t > e.length) && (t = e.length);
                for(var n = 0, r = new Array(t); n < t; n++)r[n] = e[n];
                return r;
            }
            var cr = function(e, t, r) {
                var o = r.data, i = r.headers || {};
                "application/json" === (i["Content-Type"] || i["content-type"] || "") && o && "string" != typeof o && (o = JSON.stringify(o));
                var a = (n.g.fetch || ur())(t, {
                    method: e,
                    headers: r.headers,
                    body: o,
                    credentials: r.withCredentials ? "include" : "omit"
                });
                return a.finally || (a = Promise.resolve(a)), a.then(function(e) {
                    var t = !e.ok, n = e.status;
                    return (function(e) {
                        return e.headers.get("Content-Type") && e.headers.get("Content-Type").toLowerCase().indexOf("application/json") >= 0 ? e.json().catch(function(e) {
                            return {
                                error: e,
                                errorSummary: "Could not parse server response"
                            };
                        }) : e.text();
                    })(e).then(function(t) {
                        return function(e, t, n) {
                            var r, o = "object" === c(t), i = {}, a = function(e, t) {
                                var n = "undefined" != typeof Symbol && e[Symbol.iterator] || e["@@iterator"];
                                if (!n) {
                                    if (Array.isArray(e) || (n = function(e, t) {
                                        if (e) {
                                            if ("string" == typeof e) return sr(e, t);
                                            var n = Object.prototype.toString.call(e).slice(8, -1);
                                            return "Object" === n && e.constructor && (n = e.constructor.name), "Map" === n || "Set" === n ? Array.from(e) : "Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? sr(e, t) : void 0;
                                        }
                                    }(e)) || t && e && "number" == typeof e.length) {
                                        n && (e = n);
                                        var r = 0, o = function() {};
                                        return {
                                            s: o,
                                            n: function() {
                                                return r >= e.length ? {
                                                    done: !0
                                                } : {
                                                    done: !1,
                                                    value: e[r++]
                                                };
                                            },
                                            e: function(e) {
                                                throw e;
                                            },
                                            f: o
                                        };
                                    }
                                    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
                                }
                                var i, a = !0, u = !1;
                                return {
                                    s: function() {
                                        n = n.call(e);
                                    },
                                    n: function() {
                                        var e = n.next();
                                        return a = e.done, e;
                                    },
                                    e: function(e) {
                                        u = !0, i = e;
                                    },
                                    f: function() {
                                        try {
                                            a || null == n.return || n.return();
                                        } finally{
                                            if (u) throw i;
                                        }
                                    }
                                };
                            }(n.headers.entries());
                            try {
                                for(a.s(); !(r = a.n()).done;){
                                    var u = r.value;
                                    i[u[0]] = u[1];
                                }
                            } catch (e) {
                                a.e(e);
                            } finally{
                                a.f();
                            }
                            var s = {
                                responseText: o ? JSON.stringify(t) : t,
                                status: e,
                                headers: i
                            };
                            return o && (s.responseType = "json", s.responseJSON = t), s;
                        }(n, t, e);
                    }).then(function(e) {
                        var n;
                        if (t || (null === (n = e.responseJSON) || void 0 === n ? void 0 : n.error)) throw e;
                        return e;
                    });
                });
            }, fr = n(9148), lr = "function" == typeof fr ? new fr : null, pr = function() {
                function e(t) {
                    a(this, e), this.nodeCache = t;
                }
                return q(e, [
                    {
                        key: "set",
                        value: function(e, t, n) {
                            if (Date.parse(n)) {
                                var r = (Date.parse(n) - Date.now()) / 1e3;
                                this.nodeCache.set(e, t, r);
                            } else this.nodeCache.set(e, t);
                            return this.get(e);
                        }
                    },
                    {
                        key: "get",
                        value: function(e) {
                            return this.nodeCache.get(e);
                        }
                    },
                    {
                        key: "delete",
                        value: function(e) {
                            return this.nodeCache.del(e);
                        }
                    }
                ]), e;
            }(), hr = new (function() {
                function e(t) {
                    a(this, e), this.nodeCache = t, this.storage = new pr(t);
                }
                return q(e, [
                    {
                        key: "testStorageType",
                        value: function(e) {
                            var t = !1;
                            return "memory" === e && (t = !0), t;
                        }
                    },
                    {
                        key: "getStorageByType",
                        value: function(e) {
                            if ("memory" !== e) throw new b("Unrecognized storage option: ".concat(e));
                            return this.getStorage();
                        }
                    },
                    {
                        key: "findStorageType",
                        value: function() {
                            return "memory";
                        }
                    },
                    {
                        key: "getHttpCache",
                        value: function() {
                            return null;
                        }
                    },
                    {
                        key: "getStorage",
                        value: function() {
                            var e = this;
                            return {
                                getItem: this.nodeCache.get,
                                setItem: function(t, n) {
                                    e.nodeCache.set(t, n, "2200-01-01T00:00:00.000Z");
                                }
                            };
                        }
                    }
                ]), e;
            }())(lr), dr = {
                token: {
                    storageTypes: [
                        "localStorage",
                        "sessionStorage",
                        "cookie"
                    ],
                    useMultipleCookies: !0
                },
                cache: {
                    storageTypes: [
                        "localStorage",
                        "sessionStorage",
                        "cookie"
                    ]
                },
                transaction: {
                    storageTypes: [
                        "sessionStorage",
                        "localStorage",
                        "cookie"
                    ]
                },
                "shared-transaction": {
                    storageTypes: [
                        "localStorage"
                    ]
                },
                "original-uri": {
                    storageTypes: [
                        "localStorage"
                    ]
                }
            }, vr = {
                token: {
                    storageTypes: [
                        "memory"
                    ]
                },
                cache: {
                    storageTypes: [
                        "memory"
                    ]
                },
                transaction: {
                    storageTypes: [
                        "memory"
                    ]
                }
            };
            function gr() {
                var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {}, t = arguments.length > 1 ? arguments[1] : void 0, n = e.cookies || {};
                return void 0 === n.secure && (n.secure = t), void 0 === n.sameSite && (n.sameSite = n.secure ? "none" : "lax"), n.secure && !t && (Sn('The current page is not being served with the HTTPS protocol.\nFor security reasons, we strongly recommend using HTTPS.\nIf you cannot use HTTPS, set "cookies.secure" option to false.'), n.secure = !1), "none" !== n.sameSite || n.secure || (n.sameSite = "lax"), n;
            }
            function yr() {
                var e = yt() ? _n : hr, t = yt() ? dr : vr, n = !!yt();
                return {
                    devMode: !1,
                    httpRequestClient: cr,
                    storageUtil: e,
                    storageManager: t,
                    transactionManager: {
                        enableSharedStorage: n
                    }
                };
            }
            function mr(e, t) {
                return Object.assign({}, e, M(t), {
                    storageManager: Object.assign({}, e.storageManager, t.storageManager),
                    transactionManager: Object.assign({}, e.transactionManager, t.transactionManager)
                });
            }
            var br = n(6760), kr = n.n(br), wr = function(e, t, n, r) {
                return new (n || (n = Promise))(function(o, i) {
                    function a(e) {
                        try {
                            s(r.next(e));
                        } catch (e) {
                            i(e);
                        }
                    }
                    function u(e) {
                        try {
                            s(r.throw(e));
                        } catch (e) {
                            i(e);
                        }
                    }
                    function s(e) {
                        var t;
                        e.done ? o(e.value) : (t = e.value, t instanceof n ? t : new n(function(e) {
                            e(t);
                        })).then(a, u);
                    }
                    s((r = r.apply(e, t || [])).next());
                });
            };
            function xr(e, t) {
                return wr(this, void 0, void 0, K().mark(function n() {
                    var r, o, i, a, u, s, c, f, l, p, h, d, v, g, y, m, b;
                    return K().wrap(function(n) {
                        for(;;)switch(n.prev = n.next){
                            case 0:
                                return n.next = 2, e.token.prepareTokenParams(t);
                            case 2:
                                return r = n.sent, o = r.pkce, i = r.clientId, a = r.redirectUri, u = r.responseType, s = r.responseMode, c = r.scopes, f = r.state, l = r.nonce, p = r.ignoreSignature, h = r.codeVerifier, d = r.codeChallengeMethod, v = r.codeChallenge, g = pt(e, r), y = e.idx.getFlow() || "default", m = e.options.issuer, b = {
                                    flow: y,
                                    issuer: m,
                                    pkce: o,
                                    clientId: i,
                                    redirectUri: a,
                                    responseType: u,
                                    responseMode: s,
                                    scopes: c,
                                    state: f,
                                    nonce: l,
                                    urls: g,
                                    ignoreSignature: p,
                                    codeVerifier: h,
                                    codeChallengeMethod: d,
                                    codeChallenge: v
                                }, n.abrupt("return", b);
                            case 9:
                            case "end":
                                return n.stop();
                        }
                    }, n);
                }));
            }
            function Sr(e, t) {
                if (e.transactionManager.exists(t)) {
                    var n = e.transactionManager.load(t);
                    if (Er(e, n) && n.interactionHandle) return !0;
                }
                return !1;
            }
            function Tr(e, t) {
                var n = (null == t ? void 0 : t.state) || e.options.state, r = e.transactionManager.load({
                    state: n
                });
                if (r && Er(e, r)) return r;
            }
            function Or(e, t) {
                return wr(this, void 0, void 0, K().mark(function n() {
                    var r;
                    return K().wrap(function(n) {
                        for(;;)switch(n.prev = n.next){
                            case 0:
                                if (!e.transactionManager.exists(t)) {
                                    n.next = 5;
                                    break;
                                }
                                if (!(r = Tr(e, t))) {
                                    n.next = 4;
                                    break;
                                }
                                return n.abrupt("return", r);
                            case 4:
                                Sn("Saved transaction meta does not match the current configuration. This may indicate that two apps are sharing a storage key.");
                            case 5:
                                return n.abrupt("return", xr(e, t));
                            case 6:
                            case "end":
                                return n.stop();
                        }
                    }, n);
                }));
            }
            function Ar(e, t) {
                e.transactionManager.save(t, {
                    muteWarning: !0
                });
            }
            function Er(e, t) {
                if ([
                    "issuer",
                    "clientId",
                    "redirectUri"
                ].some(function(n) {
                    return e.options[n] !== t[n];
                })) return !1;
                var n = e.options, r = n.flow, o = n.state;
                return !(o && o !== t.state || r && "default" !== r && "proceed" !== r && r !== t.flow);
            }
            var _r = function(e, t, n, r) {
                return new (n || (n = Promise))(function(o, i) {
                    function a(e) {
                        try {
                            s(r.next(e));
                        } catch (e) {
                            i(e);
                        }
                    }
                    function u(e) {
                        try {
                            s(r.throw(e));
                        } catch (e) {
                            i(e);
                        }
                    }
                    function s(e) {
                        var t;
                        e.done ? o(e.value) : (t = e.value, t instanceof n ? t : new n(function(e) {
                            e(t);
                        })).then(a, u);
                    }
                    s((r = r.apply(e, t || [])).next());
                });
            };
            function Rr(e) {
                return {
                    meta: e,
                    interactionHandle: e.interactionHandle,
                    state: e.state
                };
            }
            function Pr(e) {
                var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
                return _r(this, void 0, void 0, K().mark(function n() {
                    var r, o, i, a, u, s, c, f, l, p;
                    return K().wrap(function(n) {
                        for(;;)switch(n.prev = n.next){
                            case 0:
                                return r = t.state || e.options.state, n.next = 3, Or(e, {
                                    state: r
                                });
                            case 3:
                                if (!(o = n.sent).interactionHandle) {
                                    n.next = 6;
                                    break;
                                }
                                return n.abrupt("return", Rr(o));
                            case 6:
                                return i = o.codeChallenge, a = o.codeChallengeMethod, u = e.options, s = u.clientId, c = u.redirectUri, r = r || o.state, f = t.scopes || e.options.scopes || o.scopes, l = t.activationToken, p = ft(e), n.abrupt("return", kr().interact({
                                    clientId: s,
                                    baseUrl: p,
                                    scopes: f,
                                    state: r,
                                    redirectUri: c,
                                    codeChallenge: i,
                                    codeChallengeMethod: a,
                                    activationToken: l
                                }).then(function(t) {
                                    var n = Object.assign(Object.assign({}, o), {
                                        interactionHandle: t,
                                        state: r,
                                        scopes: f
                                    });
                                    return Ar(e, n), Rr(n);
                                }));
                            case 13:
                            case "end":
                                return n.stop();
                        }
                    }, n);
                }));
            }
            function jr(e, t) {
                var n, r, o, i;
                return n = this, r = void 0, o = void 0, i = K().mark(function n() {
                    var r, o, i;
                    return K().wrap(function(n) {
                        for(;;)switch(n.prev = n.next){
                            case 0:
                                if (!t.stateTokenExternalId && (r = e.transactionManager.loadIdxResponse()), r) {
                                    n.next = 18;
                                    break;
                                }
                                return o = le, i = lt(e), n.prev = 5, n.next = 8, kr().introspect(Object.assign({
                                    domain: i,
                                    version: o
                                }, t));
                            case 8:
                                r = n.sent, n.next = 18;
                                break;
                            case 11:
                                if (n.prev = 11, n.t0 = n.catch(5), !er(n.t0)) {
                                    n.next = 17;
                                    break;
                                }
                                r = n.t0, n.next = 18;
                                break;
                            case 17:
                                throw n.t0;
                            case 18:
                                return n.abrupt("return", kr().makeIdxState(r));
                            case 19:
                            case "end":
                                return n.stop();
                        }
                    }, n, null, [
                        [
                            5,
                            11
                        ]
                    ]);
                }), new (o || (o = Promise))(function(e, t) {
                    function a(e) {
                        try {
                            s(i.next(e));
                        } catch (e) {
                            t(e);
                        }
                    }
                    function u(e) {
                        try {
                            s(i.throw(e));
                        } catch (e) {
                            t(e);
                        }
                    }
                    function s(t) {
                        var n;
                        t.done ? e(t.value) : (n = t.value, n instanceof o ? n : new o(function(e) {
                            e(n);
                        })).then(a, u);
                    }
                    s((i = i.apply(n, r || [])).next());
                });
            }
            function Ir(e) {
                return function(e) {
                    if (Array.isArray(e)) return Ye(e);
                }(e) || function(e) {
                    if ("undefined" != typeof Symbol && null != e[Symbol.iterator] || null != e["@@iterator"]) return Array.from(e);
                }(e) || Xe(e) || function() {
                    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
                }();
            }
            function Cr(e) {
                return e.charAt(0).toUpperCase() + e.substring(1);
            }
            function Mr(e) {
                return e.value.find(function(e) {
                    return "authenticator" === e.name;
                });
            }
            function Ur(e, t) {
                (null == t || t > e.length) && (t = e.length);
                for(var n = 0, r = new Array(t); n < t; n++)r[n] = e[n];
                return r;
            }
            var Fr = function() {
                function e(t) {
                    var n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
                    a(this, e), this.values = Object.assign({}, n), this.formatAuthenticators(), this.remediation = t;
                }
                return q(e, [
                    {
                        key: "formatAuthenticators",
                        value: function() {
                            var e = this;
                            this.values.authenticators = this.values.authenticators || [], this.values.authenticator && (this.values.authenticators.some(function(t) {
                                return "string" == typeof t ? t === e.values.authenticator : t.key === e.values.authenticator;
                            }) || this.values.authenticators.push({
                                key: this.values.authenticator
                            })), this.values.authenticators = this.values.authenticators.map(function(e) {
                                return "string" == typeof e ? {
                                    key: e
                                } : e;
                            }), this.values.authenticatorsData = this.values.authenticators.reduce(function(e, t) {
                                return "object" === c(t) && Object.keys(t).length > 1 && e.push(t), e;
                            }, this.values.authenticatorsData || []);
                        }
                    },
                    {
                        key: "getName",
                        value: function() {
                            return this.remediation.name;
                        }
                    },
                    {
                        key: "canRemediate",
                        value: function() {
                            var e = this;
                            return !!this.map && !this.remediation.value.reduce(function(e, t) {
                                return t.required && e.push(t.name), e;
                            }, []).find(function(t) {
                                return !e.hasData(t);
                            });
                        }
                    },
                    {
                        key: "getData",
                        value: function(e) {
                            var t = this;
                            if (!e) {
                                var n = this.remediation.value.map(function(e) {
                                    return e.name;
                                }).reduce(function(e, n) {
                                    return e[n] = t.getData(n), e;
                                }, {});
                                return n;
                            }
                            if ("function" == typeof this["map".concat(Cr(e))]) return this["map".concat(Cr(e))](this.remediation.value.find(function(t) {
                                return t.name === e;
                            }));
                            if (!this.map) return this.values[e];
                            var r = this.map[e];
                            if (!r) return this.values[e];
                            for(var o = 0; o < r.length; o++){
                                var i = this.values[r[o]];
                                if (i) return i;
                            }
                        }
                    },
                    {
                        key: "hasData",
                        value: function(e) {
                            var t = this.getData(e);
                            return "object" === c(t) ? !!Object.keys(t).find(function(e) {
                                return !!t[e];
                            }) : !!t;
                        }
                    },
                    {
                        key: "getNextStep",
                        value: function(e) {
                            var t = this.getName(), n = this.getInputs(), r = this.getAuthenticator(), o = null == r ? void 0 : r.type;
                            return Object.assign(Object.assign({
                                name: t,
                                inputs: n
                            }, o && {
                                type: o
                            }), r && {
                                authenticator: r
                            });
                        }
                    },
                    {
                        key: "getInputs",
                        value: function() {
                            var e = this;
                            return this.map ? Object.keys(this.map).reduce(function(t, n) {
                                var r, o = e.remediation.value.find(function(e) {
                                    return e.name === n;
                                });
                                if (!o) return t;
                                var i = e.map[n], a = o.type;
                                if ("function" == typeof e["getInput".concat(Cr(n))]) r = e["getInput".concat(Cr(n))](o);
                                else if ("object" !== a) {
                                    var u;
                                    (u = 1 === i.length ? i[0] : i.find(function(t) {
                                        return Object.keys(e.values).includes(t);
                                    })) && (r = Object.assign(Object.assign({}, o), {
                                        name: u
                                    }));
                                }
                                if (!r) throw new b("Missing custom getInput".concat(Cr(n), " method in Remediator: ").concat(e.getName()));
                                return Array.isArray(r) ? r.forEach(function(e) {
                                    return t.push(e);
                                }) : t.push(r), t;
                            }, []) : [];
                        }
                    },
                    {
                        key: "getValuesAfterProceed",
                        value: function() {
                            var e, t = function(e, t) {
                                var n = "undefined" != typeof Symbol && e[Symbol.iterator] || e["@@iterator"];
                                if (!n) {
                                    if (Array.isArray(e) || (n = function(e, t) {
                                        if (e) {
                                            if ("string" == typeof e) return Ur(e, t);
                                            var n = Object.prototype.toString.call(e).slice(8, -1);
                                            return "Object" === n && e.constructor && (n = e.constructor.name), "Map" === n || "Set" === n ? Array.from(e) : "Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? Ur(e, t) : void 0;
                                        }
                                    }(e)) || t && e && "number" == typeof e.length) {
                                        n && (e = n);
                                        var r = 0, o = function() {};
                                        return {
                                            s: o,
                                            n: function() {
                                                return r >= e.length ? {
                                                    done: !0
                                                } : {
                                                    done: !1,
                                                    value: e[r++]
                                                };
                                            },
                                            e: function(e) {
                                                throw e;
                                            },
                                            f: o
                                        };
                                    }
                                    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
                                }
                                var i, a = !0, u = !1;
                                return {
                                    s: function() {
                                        n = n.call(e);
                                    },
                                    n: function() {
                                        var e = n.next();
                                        return a = e.done, e;
                                    },
                                    e: function(e) {
                                        u = !0, i = e;
                                    },
                                    f: function() {
                                        try {
                                            a || null == n.return || n.return();
                                        } finally{
                                            if (u) throw i;
                                        }
                                    }
                                };
                            }(this.getInputs());
                            try {
                                for(t.s(); !(e = t.n()).done;){
                                    var n = e.value;
                                    delete this.values[n.name];
                                }
                            } catch (e) {
                                t.e(e);
                            } finally{
                                t.f();
                            }
                            return this.values;
                        }
                    },
                    {
                        key: "getAuthenticator",
                        value: function() {
                            var e;
                            return null === (e = this.remediation.relatesTo) || void 0 === e ? void 0 : e.value;
                        }
                    }
                ], [
                    {
                        key: "getMessages",
                        value: function(e) {
                            var t, n;
                            if (e.value) return null === (n = null === (t = e.value[0]) || void 0 === t ? void 0 : t.form) || void 0 === n ? void 0 : n.value.reduce(function(e, t) {
                                return t.messages && (e = [].concat(Ir(e), Ir(t.messages.value))), e;
                            }, []);
                        }
                    }
                ]), e;
            }(), Nr = function e(t) {
                a(this, e), this.meta = t;
            };
            var Lr = function(e) {
                s(o, e);
                var t, n, r = (t = o, n = function() {
                    if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                    if (Reflect.construct.sham) return !1;
                    if ("function" == typeof Proxy) return !0;
                    try {
                        return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
                    } catch (e) {
                        return !1;
                    }
                }(), function() {
                    var e, r = p(t);
                    if (n) {
                        var o = p(this).constructor;
                        e = Reflect.construct(r, arguments, o);
                    } else e = r.apply(this, arguments);
                    return l(this, e);
                });
                function o() {
                    return a(this, o), r.apply(this, arguments);
                }
                return q(o, [
                    {
                        key: "canVerify",
                        value: function(e) {
                            return !!e.verificationCode;
                        }
                    },
                    {
                        key: "mapCredentials",
                        value: function(e) {
                            return {
                                passcode: e.verificationCode
                            };
                        }
                    },
                    {
                        key: "getInputs",
                        value: function(e) {
                            var t;
                            return Object.assign(Object.assign({}, null === (t = e.form) || void 0 === t ? void 0 : t.value[0]), {
                                name: "verificationCode",
                                type: "string",
                                required: e.required
                            });
                        }
                    }
                ]), o;
            }(Nr);
            var Dr = function(e) {
                s(o, e);
                var t, n, r = (t = o, n = function() {
                    if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                    if (Reflect.construct.sham) return !1;
                    if ("function" == typeof Proxy) return !0;
                    try {
                        return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
                    } catch (e) {
                        return !1;
                    }
                }(), function() {
                    var e, r = p(t);
                    if (n) {
                        var o = p(this).constructor;
                        e = Reflect.construct(r, arguments, o);
                    } else e = r.apply(this, arguments);
                    return l(this, e);
                });
                function o() {
                    return a(this, o), r.apply(this, arguments);
                }
                return q(o, [
                    {
                        key: "mapCredentials",
                        value: function(e) {
                            return {
                                totp: e.verificationCode
                            };
                        }
                    }
                ]), o;
            }(Lr);
            var Br = function(e) {
                s(o, e);
                var t, n, r = (t = o, n = function() {
                    if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                    if (Reflect.construct.sham) return !1;
                    if ("function" == typeof Proxy) return !0;
                    try {
                        return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
                    } catch (e) {
                        return !1;
                    }
                }(), function() {
                    var e, r = p(t);
                    if (n) {
                        var o = p(this).constructor;
                        e = Reflect.construct(r, arguments, o);
                    } else e = r.apply(this, arguments);
                    return l(this, e);
                });
                function o() {
                    return a(this, o), r.apply(this, arguments);
                }
                return q(o, [
                    {
                        key: "canVerify",
                        value: function(e) {
                            return !!e.password;
                        }
                    },
                    {
                        key: "mapCredentials",
                        value: function(e) {
                            return {
                                passcode: e.password
                            };
                        }
                    },
                    {
                        key: "getInputs",
                        value: function(e) {
                            var t;
                            return Object.assign(Object.assign({}, null === (t = e.form) || void 0 === t ? void 0 : t.value[0]), {
                                name: "password",
                                type: "string",
                                required: e.required
                            });
                        }
                    }
                ]), o;
            }(Nr);
            var qr = function(e) {
                s(o, e);
                var t, n, r = (t = o, n = function() {
                    if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                    if (Reflect.construct.sham) return !1;
                    if ("function" == typeof Proxy) return !0;
                    try {
                        return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
                    } catch (e) {
                        return !1;
                    }
                }(), function() {
                    var e, r = p(t);
                    if (n) {
                        var o = p(this).constructor;
                        e = Reflect.construct(r, arguments, o);
                    } else e = r.apply(this, arguments);
                    return l(this, e);
                });
                function o() {
                    return a(this, o), r.apply(this, arguments);
                }
                return q(o, [
                    {
                        key: "canVerify",
                        value: function(e) {
                            var t = e.questionKey, n = e.question, r = e.answer;
                            return t && r || n && r;
                        }
                    },
                    {
                        key: "mapCredentials",
                        value: function(e) {
                            var t = e.questionKey, n = e.question;
                            return {
                                questionKey: n ? "custom" : t,
                                question: n,
                                answer: e.answer
                            };
                        }
                    },
                    {
                        key: "getInputs",
                        value: function() {
                            return [
                                {
                                    name: "questionKey",
                                    type: "string",
                                    require: !0
                                },
                                {
                                    name: "question",
                                    type: "string",
                                    label: "Create a security question"
                                },
                                {
                                    name: "answer",
                                    type: "string",
                                    label: "Answer",
                                    required: !0
                                }
                            ];
                        }
                    }
                ]), o;
            }(Nr);
            var Hr = function(e) {
                s(o, e);
                var t, n, r = (t = o, n = function() {
                    if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                    if (Reflect.construct.sham) return !1;
                    if ("function" == typeof Proxy) return !0;
                    try {
                        return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
                    } catch (e) {
                        return !1;
                    }
                }(), function() {
                    var e, r = p(t);
                    if (n) {
                        var o = p(this).constructor;
                        e = Reflect.construct(r, arguments, o);
                    } else e = r.apply(this, arguments);
                    return l(this, e);
                });
                function o() {
                    return a(this, o), r.apply(this, arguments);
                }
                return q(o, [
                    {
                        key: "canVerify",
                        value: function(e) {
                            return e.answer;
                        }
                    },
                    {
                        key: "mapCredentials",
                        value: function(e) {
                            return {
                                questionKey: this.meta.contextualData.enrolledQuestion.questionKey,
                                answer: e.answer
                            };
                        }
                    },
                    {
                        key: "getInputs",
                        value: function() {
                            return [
                                {
                                    name: "answer",
                                    type: "string",
                                    label: "Answer",
                                    required: !0
                                }
                            ];
                        }
                    }
                ]), o;
            }(Nr);
            function Kr(e) {
                var t = e.relatesTo, n = (t = void 0 === t ? {} : t).value;
                switch(n.key){
                    case dt.OKTA_PASSWORD:
                        return new Br(n);
                    case dt.SECURITY_QUESTION:
                        return n.contextualData.enrolledQuestion ? new Hr(n) : new qr(n);
                    case dt.OKTA_VERIFY:
                        return new Dr(n);
                    default:
                        return new Lr(n);
                }
            }
            var Vr = function(e) {
                s(o, e);
                var t, n, r = (t = o, n = function() {
                    if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                    if (Reflect.construct.sham) return !1;
                    if ("function" == typeof Proxy) return !0;
                    try {
                        return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
                    } catch (e) {
                        return !1;
                    }
                }(), function() {
                    var e, r = p(t);
                    if (n) {
                        var o = p(this).constructor;
                        e = Reflect.construct(r, arguments, o);
                    } else e = r.apply(this, arguments);
                    return l(this, e);
                });
                function o(e) {
                    var t, n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
                    return a(this, o), (t = r.call(this, e, n)).map = {
                        credentials: []
                    }, t.authenticator = Kr(e), t;
                }
                return q(o, [
                    {
                        key: "canRemediate",
                        value: function() {
                            return this.authenticator.canVerify(this.values);
                        }
                    },
                    {
                        key: "mapCredentials",
                        value: function() {
                            return this.authenticator.mapCredentials(this.values);
                        }
                    },
                    {
                        key: "getInputCredentials",
                        value: function(e) {
                            return this.authenticator.getInputs(e);
                        }
                    }
                ]), o;
            }(Fr);
            var Gr = function(e) {
                s(o, e);
                var t, n, r = (t = o, n = function() {
                    if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                    if (Reflect.construct.sham) return !1;
                    if ("function" == typeof Proxy) return !0;
                    try {
                        return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
                    } catch (e) {
                        return !1;
                    }
                }(), function() {
                    var e, r = p(t);
                    if (n) {
                        var o = p(this).constructor;
                        e = Reflect.construct(r, arguments, o);
                    } else e = r.apply(this, arguments);
                    return l(this, e);
                });
                function o() {
                    return a(this, o), r.apply(this, arguments);
                }
                return o;
            }(Vr);
            function Wr(e, t, n) {
                return t in e ? Object.defineProperty(e, t, {
                    value: n,
                    enumerable: !0,
                    configurable: !0,
                    writable: !0
                }) : e[t] = n, e;
            }
            Gr.remediationName = "enroll-authenticator";
            var $r = function(e) {
                s(o, e);
                var t, n, r = (t = o, n = function() {
                    if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                    if (Reflect.construct.sham) return !1;
                    if ("function" == typeof Proxy) return !0;
                    try {
                        return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
                    } catch (e) {
                        return !1;
                    }
                }(), function() {
                    var e, r = p(t);
                    if (n) {
                        var o = p(this).constructor;
                        e = Reflect.construct(r, arguments, o);
                    } else e = r.apply(this, arguments);
                    return l(this, e);
                });
                function o() {
                    return a(this, o), r.apply(this, arguments);
                }
                return q(o, [
                    {
                        key: "canRemediate",
                        value: function() {
                            return Boolean(this.values.startPolling);
                        }
                    },
                    {
                        key: "getNextStep",
                        value: function(e) {
                            var t = this.getName(), n = this.getAuthenticator();
                            return !n && (null == e ? void 0 : e.currentAuthenticator) && (n = e.currentAuthenticator.value), {
                                name: t,
                                authenticator: n,
                                poll: {
                                    required: !0,
                                    refresh: this.remediation.refresh
                                }
                            };
                        }
                    },
                    {
                        key: "getValuesAfterProceed",
                        value: function() {
                            var e = this;
                            return Object.keys(this.values).filter(function(e) {
                                return "startPolling" !== e;
                            }).reduce(function(t, n) {
                                return Object.assign(Object.assign({}, t), Wr({}, n, e.values[n]));
                            }, {});
                        }
                    }
                ]), o;
            }(Fr);
            $r.remediationName = "enroll-poll";
            var zr = function(e) {
                s(o, e);
                var t, n, r = (t = o, n = function() {
                    if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                    if (Reflect.construct.sham) return !1;
                    if ("function" == typeof Proxy) return !0;
                    try {
                        return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
                    } catch (e) {
                        return !1;
                    }
                }(), function() {
                    var e, r = p(t);
                    if (n) {
                        var o = p(this).constructor;
                        e = Reflect.construct(r, arguments, o);
                    } else e = r.apply(this, arguments);
                    return l(this, e);
                });
                function o() {
                    return a(this, o), r.apply(this, arguments);
                }
                return o;
            }(Vr);
            zr.remediationName = "challenge-authenticator";
            var Jr = function(e) {
                s(o, e);
                var t, n, r = (t = o, n = function() {
                    if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                    if (Reflect.construct.sham) return !1;
                    if ("function" == typeof Proxy) return !0;
                    try {
                        return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
                    } catch (e) {
                        return !1;
                    }
                }(), function() {
                    var e, r = p(t);
                    if (n) {
                        var o = p(this).constructor;
                        e = Reflect.construct(r, arguments, o);
                    } else e = r.apply(this, arguments);
                    return l(this, e);
                });
                function o() {
                    return a(this, o), r.apply(this, arguments);
                }
                return o;
            }($r);
            Jr.remediationName = "challenge-poll";
            var Yr = function(e) {
                s(o, e);
                var t, n, r = (t = o, n = function() {
                    if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                    if (Reflect.construct.sham) return !1;
                    if ("function" == typeof Proxy) return !0;
                    try {
                        return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
                    } catch (e) {
                        return !1;
                    }
                }(), function() {
                    var e, r = p(t);
                    if (n) {
                        var o = p(this).constructor;
                        e = Reflect.construct(r, arguments, o);
                    } else e = r.apply(this, arguments);
                    return l(this, e);
                });
                function o() {
                    return a(this, o), r.apply(this, arguments);
                }
                return o;
            }(Vr);
            Yr.remediationName = "reset-authenticator";
            var Xr = function(e) {
                s(o, e);
                var t, n, r = (t = o, n = function() {
                    if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                    if (Reflect.construct.sham) return !1;
                    if ("function" == typeof Proxy) return !0;
                    try {
                        return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
                    } catch (e) {
                        return !1;
                    }
                }(), function() {
                    var e, r = p(t);
                    if (n) {
                        var o = p(this).constructor;
                        e = Reflect.construct(r, arguments, o);
                    } else e = r.apply(this, arguments);
                    return l(this, e);
                });
                function o() {
                    var e;
                    return a(this, o), (e = r.apply(this, arguments)).map = {
                        userProfile: []
                    }, e;
                }
                return q(o, [
                    {
                        key: "canRemediate",
                        value: function() {
                            var e = this.getData().userProfile;
                            return this.remediation.value.find(function(e) {
                                return "userProfile" === e.name;
                            }).form.value.reduce(function(t, n) {
                                return n.required && (t = t && !!e[n.name]), t;
                            }, !0);
                        }
                    },
                    {
                        key: "mapUserProfile",
                        value: function(e) {
                            var t = this;
                            return e.form.value.map(function(e) {
                                return e.name;
                            }).reduce(function(e, n) {
                                return t.values[n] ? Object.assign(Object.assign({}, e), Wr({}, n, t.values[n])) : e;
                            }, {});
                        }
                    },
                    {
                        key: "getInputUserProfile",
                        value: function(e) {
                            return Ir(e.form.value);
                        }
                    },
                    {
                        key: "getErrorMessages",
                        value: function(e) {
                            return e.value[0].form.value.reduce(function(e, t) {
                                return t.messages && e.push(t.messages.value[0].message), e;
                            }, []);
                        }
                    }
                ]), o;
            }(Fr);
            Xr.remediationName = "enroll-profile";
            var Qr = function(e) {
                s(o, e);
                var t, n, r = (t = o, n = function() {
                    if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                    if (Reflect.construct.sham) return !1;
                    if ("function" == typeof Proxy) return !0;
                    try {
                        return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
                    } catch (e) {
                        return !1;
                    }
                }(), function() {
                    var e, r = p(t);
                    if (n) {
                        var o = p(this).constructor;
                        e = Reflect.construct(r, arguments, o);
                    } else e = r.apply(this, arguments);
                    return l(this, e);
                });
                function o() {
                    var e;
                    return a(this, o), (e = r.apply(this, arguments)).map = {
                        identifier: [
                            "username"
                        ],
                        credentials: [],
                        rememberMe: [
                            "rememberMe"
                        ]
                    }, e;
                }
                return q(o, [
                    {
                        key: "canRemediate",
                        value: function() {
                            return !!this.getData().identifier;
                        }
                    },
                    {
                        key: "mapCredentials",
                        value: function() {
                            return {
                                passcode: this.values.password
                            };
                        }
                    },
                    {
                        key: "getInputCredentials",
                        value: function(e) {
                            return Object.assign(Object.assign({}, e.form.value[0]), {
                                name: "password",
                                required: e.required
                            });
                        }
                    }
                ]), o;
            }(Fr);
            Qr.remediationName = "identify";
            var Zr = function(e) {
                s(o, e);
                var t, n, r = (t = o, n = function() {
                    if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                    if (Reflect.construct.sham) return !1;
                    if ("function" == typeof Proxy) return !0;
                    try {
                        return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
                    } catch (e) {
                        return !1;
                    }
                }(), function() {
                    var e, r = p(t);
                    if (n) {
                        var o = p(this).constructor;
                        e = Reflect.construct(r, arguments, o);
                    } else e = r.apply(this, arguments);
                    return l(this, e);
                });
                function o() {
                    var e;
                    return a(this, o), (e = r.apply(this, arguments)).map = {
                        credentials: []
                    }, e;
                }
                return q(o, [
                    {
                        key: "mapCredentials",
                        value: function() {
                            return {
                                passcode: this.values.newPassword
                            };
                        }
                    },
                    {
                        key: "getInputCredentials",
                        value: function(e) {
                            var t = "password" === this.getAuthenticator().type ? "newPassword" : "verificationCode";
                            return Object.assign(Object.assign({}, e.form.value[0]), {
                                name: t
                            });
                        }
                    }
                ]), o;
            }(Fr);
            Zr.remediationName = "reenroll-authenticator";
            var eo = function(e) {
                s(o, e);
                var t, n, r = (t = o, n = function() {
                    if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                    if (Reflect.construct.sham) return !1;
                    if ("function" == typeof Proxy) return !0;
                    try {
                        return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
                    } catch (e) {
                        return !1;
                    }
                }(), function() {
                    var e, r = p(t);
                    if (n) {
                        var o = p(this).constructor;
                        e = Reflect.construct(r, arguments, o);
                    } else e = r.apply(this, arguments);
                    return l(this, e);
                });
                function o() {
                    return a(this, o), r.apply(this, arguments);
                }
                return q(o, [
                    {
                        key: "canRemediate",
                        value: function() {
                            return !1;
                        }
                    },
                    {
                        key: "getNextStep",
                        value: function() {
                            var e = this.remediation;
                            return {
                                name: e.name,
                                type: e.type,
                                idp: e.idp,
                                href: e.href
                            };
                        }
                    }
                ]), o;
            }(Fr);
            function to(e, t, n) {
                return to = "undefined" != typeof Reflect && Reflect.get ? Reflect.get : function(e, t, n) {
                    var r = function(e, t) {
                        for(; !Object.prototype.hasOwnProperty.call(e, t) && null !== (e = p(e)););
                        return e;
                    }(e, t);
                    if (r) {
                        var o = Object.getOwnPropertyDescriptor(r, t);
                        return o.get ? o.get.call(n) : o.value;
                    }
                }, to(e, t, n || e);
            }
            function no(e, t) {
                (null == t || t > e.length) && (t = e.length);
                for(var n = 0, r = new Array(t); n < t; n++)r[n] = e[n];
                return r;
            }
            function ro(e, t) {
                var n, r, o = function(e, t) {
                    var n = "undefined" != typeof Symbol && e[Symbol.iterator] || e["@@iterator"];
                    if (!n) {
                        if (Array.isArray(e) || (n = function(e, t) {
                            if (e) {
                                if ("string" == typeof e) return no(e, t);
                                var n = Object.prototype.toString.call(e).slice(8, -1);
                                return "Object" === n && e.constructor && (n = e.constructor.name), "Map" === n || "Set" === n ? Array.from(e) : "Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? no(e, t) : void 0;
                            }
                        }(e)) || t && e && "number" == typeof e.length) {
                            n && (e = n);
                            var r = 0, o = function() {};
                            return {
                                s: o,
                                n: function() {
                                    return r >= e.length ? {
                                        done: !0
                                    } : {
                                        done: !1,
                                        value: e[r++]
                                    };
                                },
                                e: function(e) {
                                    throw e;
                                },
                                f: o
                            };
                        }
                        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
                    }
                    var i, a = !0, u = !1;
                    return {
                        s: function() {
                            n = n.call(e);
                        },
                        n: function() {
                            var e = n.next();
                            return a = e.done, e;
                        },
                        e: function(e) {
                            u = !0, i = e;
                        },
                        f: function() {
                            try {
                                a || null == n.return || n.return();
                            } finally{
                                if (u) throw i;
                            }
                        }
                    };
                }(e);
                try {
                    var i = function() {
                        var e = r.value;
                        if (n = t.find(function(t) {
                            return t.relatesTo.key === e.key;
                        })) return "break";
                    };
                    for(o.s(); !(r = o.n()).done && "break" !== i(););
                } catch (e) {
                    o.e(e);
                } finally{
                    o.f();
                }
                return n;
            }
            eo.remediationName = "redirect-idp";
            var oo = function(e) {
                s(o, e);
                var t, n, r = (t = o, n = function() {
                    if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                    if (Reflect.construct.sham) return !1;
                    if ("function" == typeof Proxy) return !0;
                    try {
                        return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
                    } catch (e) {
                        return !1;
                    }
                }(), function() {
                    var e, r = p(t);
                    if (n) {
                        var o = p(this).constructor;
                        e = Reflect.construct(r, arguments, o);
                    } else e = r.apply(this, arguments);
                    return l(this, e);
                });
                function o() {
                    var e;
                    return a(this, o), (e = r.apply(this, arguments)).map = {
                        authenticator: []
                    }, e;
                }
                return q(o, [
                    {
                        key: "canRemediate",
                        value: function() {
                            var e = this.values.authenticators, t = Mr(this.remediation).options;
                            return !(!e || !e.length || !ro(e, t));
                        }
                    },
                    {
                        key: "getNextStep",
                        value: function() {
                            var e = to(p(o.prototype), "getNextStep", this).call(this), t = Mr(this.remediation).options.map(function(e) {
                                return {
                                    label: e.label,
                                    value: e.relatesTo.key
                                };
                            });
                            return Object.assign(Object.assign({}, e), {
                                options: t
                            });
                        }
                    },
                    {
                        key: "mapAuthenticator",
                        value: function(e) {
                            var t = ro(this.values.authenticators, e.options);
                            return this.selectedAuthenticator = t.relatesTo, {
                                id: null == t ? void 0 : t.value.form.value.find(function(e) {
                                    return "id" === e.name;
                                }).value
                            };
                        }
                    },
                    {
                        key: "getInputAuthenticator",
                        value: function() {
                            return {
                                name: "authenticator",
                                key: "string"
                            };
                        }
                    },
                    {
                        key: "getValuesAfterProceed",
                        value: function() {
                            var e = this;
                            this.values = to(p(o.prototype), "getValuesAfterProceed", this).call(this);
                            var t = this.values.authenticators.filter(function(t) {
                                return t.key !== e.selectedAuthenticator.key;
                            });
                            return Object.assign(Object.assign({}, this.values), {
                                authenticators: t
                            });
                        }
                    }
                ]), o;
            }(Fr);
            var io = function(e) {
                s(o, e);
                var t, n, r = (t = o, n = function() {
                    if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                    if (Reflect.construct.sham) return !1;
                    if ("function" == typeof Proxy) return !0;
                    try {
                        return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
                    } catch (e) {
                        return !1;
                    }
                }(), function() {
                    var e, r = p(t);
                    if (n) {
                        var o = p(this).constructor;
                        e = Reflect.construct(r, arguments, o);
                    } else e = r.apply(this, arguments);
                    return l(this, e);
                });
                function o(e) {
                    var t, n, i = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
                    a(this, o), t = r.call(this, e, i);
                    var u = null === (n = Mr(e).options) || void 0 === n ? void 0 : n.some(function(e) {
                        return e.relatesTo.key === dt.OKTA_PASSWORD;
                    });
                    return u && ("recoverPassword" === t.values.flow || t.values.password) && (t.values.authenticators = [].concat(Ir(t.values.authenticators), [
                        {
                            key: dt.OKTA_PASSWORD
                        }
                    ])), t;
                }
                return o;
            }(oo);
            io.remediationName = "select-authenticator-authenticate";
            var ao = function(e) {
                s(o, e);
                var t, n, r = (t = o, n = function() {
                    if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                    if (Reflect.construct.sham) return !1;
                    if ("function" == typeof Proxy) return !0;
                    try {
                        return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
                    } catch (e) {
                        return !1;
                    }
                }(), function() {
                    var e, r = p(t);
                    if (n) {
                        var o = p(this).constructor;
                        e = Reflect.construct(r, arguments, o);
                    } else e = r.apply(this, arguments);
                    return l(this, e);
                });
                function o() {
                    return a(this, o), r.apply(this, arguments);
                }
                return o;
            }(oo);
            ao.remediationName = "select-authenticator-enroll";
            var uo = function(e) {
                s(o, e);
                var t, n, r = (t = o, n = function() {
                    if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                    if (Reflect.construct.sham) return !1;
                    if ("function" == typeof Proxy) return !0;
                    try {
                        return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
                    } catch (e) {
                        return !1;
                    }
                }(), function() {
                    var e, r = p(t);
                    if (n) {
                        var o = p(this).constructor;
                        e = Reflect.construct(r, arguments, o);
                    } else e = r.apply(this, arguments);
                    return l(this, e);
                });
                function o() {
                    return a(this, o), r.apply(this, arguments);
                }
                return q(o, [
                    {
                        key: "canRemediate",
                        value: function() {
                            return !0;
                        }
                    }
                ]), o;
            }(Fr);
            uo.remediationName = "select-enroll-profile";
            var so = function(e) {
                s(o, e);
                var t, n, r = (t = o, n = function() {
                    if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                    if (Reflect.construct.sham) return !1;
                    if ("function" == typeof Proxy) return !0;
                    try {
                        return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
                    } catch (e) {
                        return !1;
                    }
                }(), function() {
                    var e, r = p(t);
                    if (n) {
                        var o = p(this).constructor;
                        e = Reflect.construct(r, arguments, o);
                    } else e = r.apply(this, arguments);
                    return l(this, e);
                });
                function o(e) {
                    var t, n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
                    return a(this, o), (t = r.call(this, e, n)).map = {
                        authenticator: []
                    }, t.authenticator = t.getAuthenticator(), t.formatAuthenticatorData(), t;
                }
                return q(o, [
                    {
                        key: "formatAuthenticatorData",
                        value: function() {
                            var e = this;
                            if (this.getAuthenticatorData()) this.values.authenticatorsData = this.values.authenticatorsData.map(function(t) {
                                return t.key === e.authenticator.key ? e.mapAuthenticatorDataFromValues(t) : t;
                            });
                            else {
                                var t = this.mapAuthenticatorDataFromValues();
                                t && this.values.authenticatorsData.push(t);
                            }
                        }
                    },
                    {
                        key: "getAuthenticatorData",
                        value: function() {
                            var e = this;
                            return this.values.authenticatorsData.find(function(t) {
                                return t.key === e.authenticator.key;
                            });
                        }
                    },
                    {
                        key: "canRemediate",
                        value: function() {
                            var e = this;
                            return this.values.authenticatorsData.some(function(t) {
                                return t.key === e.authenticator.key;
                            });
                        }
                    },
                    {
                        key: "getNextStep",
                        value: function() {
                            var e = to(p(o.prototype), "getNextStep", this).call(this), t = this.getMethodTypes();
                            return Object.assign(Object.assign({}, e), t && {
                                options: t
                            });
                        }
                    },
                    {
                        key: "mapAuthenticatorDataFromValues",
                        value: function(e) {
                            var t = this.values.methodType, n = Object.assign(Object.assign({
                                key: this.authenticator.key
                            }, e && e), t && {
                                methodType: t
                            });
                            return n.methodType ? n : null;
                        }
                    },
                    {
                        key: "getAuthenticatorFromRemediation",
                        value: function() {
                            return this.remediation.value.find(function(e) {
                                return "authenticator" === e.name;
                            });
                        }
                    },
                    {
                        key: "getMethodTypes",
                        value: function() {
                            var e;
                            return null === (e = this.getAuthenticatorFromRemediation().form.value.find(function(e) {
                                return "methodType" === e.name;
                            })) || void 0 === e ? void 0 : e.options;
                        }
                    },
                    {
                        key: "getValuesAfterProceed",
                        value: function() {
                            var e = this;
                            this.values = to(p(o.prototype), "getValuesAfterProceed", this).call(this);
                            var t = this.values.authenticatorsData.filter(function(t) {
                                return t.key !== e.authenticator.key;
                            });
                            return Object.assign(Object.assign({}, this.values), {
                                authenticatorsData: t
                            });
                        }
                    }
                ]), o;
            }(Fr);
            var co = function(e) {
                s(o, e);
                var t, n, r = (t = o, n = function() {
                    if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                    if (Reflect.construct.sham) return !1;
                    if ("function" == typeof Proxy) return !0;
                    try {
                        return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
                    } catch (e) {
                        return !1;
                    }
                }(), function() {
                    var e, r = p(t);
                    if (n) {
                        var o = p(this).constructor;
                        e = Reflect.construct(r, arguments, o);
                    } else e = r.apply(this, arguments);
                    return l(this, e);
                });
                function o() {
                    return a(this, o), r.apply(this, arguments);
                }
                return q(o, [
                    {
                        key: "mapAuthenticator",
                        value: function() {
                            var e, t = this.getAuthenticatorData(), n = this.getAuthenticatorFromRemediation();
                            return {
                                id: n.form.value.find(function(e) {
                                    return "id" === e.name;
                                }).value,
                                enrollmentId: null === (e = n.form.value.find(function(e) {
                                    return "enrollmentId" === e.name;
                                })) || void 0 === e ? void 0 : e.value,
                                methodType: t.methodType
                            };
                        }
                    },
                    {
                        key: "getInputAuthenticator",
                        value: function() {
                            var e = this.getAuthenticatorFromRemediation(), t = e.form.value.find(function(e) {
                                return "methodType" === e.name;
                            });
                            return t && t.options ? {
                                name: "methodType",
                                type: "string",
                                required: !0
                            } : Ir(e.form.value);
                        }
                    }
                ]), o;
            }(so);
            co.remediationName = "authenticator-verification-data";
            var fo = function(e) {
                s(o, e);
                var t, n, r = (t = o, n = function() {
                    if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                    if (Reflect.construct.sham) return !1;
                    if ("function" == typeof Proxy) return !0;
                    try {
                        return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
                    } catch (e) {
                        return !1;
                    }
                }(), function() {
                    var e, r = p(t);
                    if (n) {
                        var o = p(this).constructor;
                        e = Reflect.construct(r, arguments, o);
                    } else e = r.apply(this, arguments);
                    return l(this, e);
                });
                function o() {
                    return a(this, o), r.apply(this, arguments);
                }
                return q(o, [
                    {
                        key: "mapAuthenticator",
                        value: function() {
                            var e = this.getAuthenticatorData();
                            return {
                                id: Mr(this.remediation).form.value.find(function(e) {
                                    return "id" === e.name;
                                }).value,
                                methodType: e.methodType,
                                phoneNumber: e.phoneNumber
                            };
                        }
                    },
                    {
                        key: "getInputAuthenticator",
                        value: function() {
                            return [
                                {
                                    name: "methodType",
                                    type: "string",
                                    required: !0
                                },
                                {
                                    name: "phoneNumber",
                                    type: "string",
                                    required: !0,
                                    label: "Phone Number"
                                }
                            ];
                        }
                    },
                    {
                        key: "mapAuthenticatorDataFromValues",
                        value: function(e) {
                            e = to(p(o.prototype), "mapAuthenticatorDataFromValues", this).call(this, e);
                            var t = this.values.phoneNumber;
                            return (e = Object.assign(Object.assign({}, e && e), t && {
                                phoneNumber: t
                            })).phoneNumber && e.methodType ? e : null;
                        }
                    }
                ]), o;
            }(so);
            fo.remediationName = "authenticator-enrollment-data";
            var lo = function(e) {
                s(o, e);
                var t, n, r = (t = o, n = function() {
                    if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                    if (Reflect.construct.sham) return !1;
                    if ("function" == typeof Proxy) return !0;
                    try {
                        return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
                    } catch (e) {
                        return !1;
                    }
                }(), function() {
                    var e, r = p(t);
                    if (n) {
                        var o = p(this).constructor;
                        e = Reflect.construct(r, arguments, o);
                    } else e = r.apply(this, arguments);
                    return l(this, e);
                });
                function o() {
                    var e;
                    return a(this, o), (e = r.apply(this, arguments)).map = {
                        skip: [
                            "skip"
                        ]
                    }, e;
                }
                return q(o, [
                    {
                        key: "canRemediate",
                        value: function() {
                            return !!this.values.skip;
                        }
                    }
                ]), o;
            }(Fr);
            function po(e, t) {
                var n = "undefined" != typeof Symbol && e[Symbol.iterator] || e["@@iterator"];
                if (!n) {
                    if (Array.isArray(e) || (n = function(e, t) {
                        if (e) {
                            if ("string" == typeof e) return ho(e, t);
                            var n = Object.prototype.toString.call(e).slice(8, -1);
                            return "Object" === n && e.constructor && (n = e.constructor.name), "Map" === n || "Set" === n ? Array.from(e) : "Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? ho(e, t) : void 0;
                        }
                    }(e)) || t && e && "number" == typeof e.length) {
                        n && (e = n);
                        var r = 0, o = function() {};
                        return {
                            s: o,
                            n: function() {
                                return r >= e.length ? {
                                    done: !0
                                } : {
                                    done: !1,
                                    value: e[r++]
                                };
                            },
                            e: function(e) {
                                throw e;
                            },
                            f: o
                        };
                    }
                    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
                }
                var i, a = !0, u = !1;
                return {
                    s: function() {
                        n = n.call(e);
                    },
                    n: function() {
                        var e = n.next();
                        return a = e.done, e;
                    },
                    e: function(e) {
                        u = !0, i = e;
                    },
                    f: function() {
                        try {
                            a || null == n.return || n.return();
                        } finally{
                            if (u) throw i;
                        }
                    }
                };
            }
            function ho(e, t) {
                (null == t || t > e.length) && (t = e.length);
                for(var n = 0, r = new Array(t); n < t; n++)r[n] = e[n];
                return r;
            }
            lo.remediationName = "skip";
            function vo(e, t, n) {
                var r, o, i = n.remediators, a = [], u = po(e);
                try {
                    for(u.s(); !(o = u.n()).done;){
                        var s = o.value;
                        if (Object.keys(i).includes(s.name)) {
                            if ((r = new (0, i[s.name])(s, t)).canRemediate()) return r;
                            a.push(r);
                        }
                    }
                } catch (e) {
                    u.e(e);
                } finally{
                    u.f();
                }
                return a[0];
            }
            function go(e) {
                var t = e.neededToProceed, n = e.interactionCode;
                return !t.length && !n;
            }
            function yo(e) {
                var t, n = [], r = e.rawIdxState, o = e.neededToProceed, i = null === (t = r.messages) || void 0 === t ? void 0 : t.value.map(function(e) {
                    return e;
                });
                i && (n = [].concat(Ir(n), Ir(i)));
                var a, u = po(o);
                try {
                    for(u.s(); !(a = u.n()).done;){
                        var s = a.value, c = Fr.getMessages(s);
                        c && (n = [].concat(Ir(n), Ir(c)));
                    }
                } catch (e) {
                    u.e(e);
                } finally{
                    u.f();
                }
                return n;
            }
            function mo(e, t) {
                var n = e.getNextStep(t.context), r = function(e) {
                    return e.neededToProceed.some(function(e) {
                        return "skip" === e.name;
                    });
                }(t), o = function(e) {
                    return Object.keys(e.actions).some(function(e) {
                        return e.includes("resend");
                    });
                }(t);
                return Object.assign(Object.assign(Object.assign({}, n), r && {
                    canSkip: r
                }), o && {
                    canResend: o
                });
            }
            function bo(e, t) {
                var n, r = (n = e) && er(n.rawIdxState) ? e : null;
                if (!r) throw e;
                var o = go(r), i = yo(r);
                if (o) return {
                    terminal: o,
                    messages: i
                };
                var a = t && mo(t, r);
                return Object.assign({
                    messages: i
                }, a && {
                    nextStep: a
                });
            }
            function ko(e, t) {
                return Object.keys(t.actions).find(function(t) {
                    return !!e.resend && t.includes("-resend");
                });
            }
            function wo(e) {
                return e.resend = void 0, e;
            }
            function xo(e, t, n) {
                var r, o, i, a;
                return r = this, o = void 0, i = void 0, a = K().mark(function r() {
                    var o, i, a, u, s, c, f, l, p, h, d, v, g, y, m, k, w;
                    return K().wrap(function(r) {
                        for(;;)switch(r.prev = r.next){
                            case 0:
                                if (i = (o = e).neededToProceed, a = o.interactionCode, u = n.remediators, !a) {
                                    r.next = 4;
                                    break;
                                }
                                return r.abrupt("return", {
                                    idxResponse: e
                                });
                            case 4:
                                if (s = go(e), c = yo(e), !s) {
                                    r.next = 8;
                                    break;
                                }
                                return r.abrupt("return", {
                                    terminal: s,
                                    messages: c
                                });
                            case 8:
                                if (f = vo(i, t, n)) {
                                    r.next = 11;
                                    break;
                                }
                                throw new b("\n      No remediation can match current flow, check policy settings in your org.\n      Remediations: [".concat(i.reduce(function(e, t) {
                                    return e ? e + " ," + t.name : t.name;
                                }, ""), "]\n    "));
                            case 11:
                                if (!c.length) {
                                    r.next = 14;
                                    break;
                                }
                                return l = mo(f, e), r.abrupt("return", {
                                    nextStep: l,
                                    messages: c
                                });
                            case 14:
                                if (p = ko(t, e), !(h = [].concat(Ir(n.actions || []), Ir(p && [
                                    p
                                ] || [])))) {
                                    r.next = 46;
                                    break;
                                }
                                d = po(h), r.prev = 18, d.s();
                            case 20:
                                if ((v = d.n()).done) {
                                    r.next = 38;
                                    break;
                                }
                                if (g = v.value, y = wo(t), "function" != typeof e.actions[g]) {
                                    r.next = 36;
                                    break;
                                }
                                return r.prev = 24, r.next = 27, e.actions[g]();
                            case 27:
                                e = r.sent, r.next = 33;
                                break;
                            case 30:
                                return r.prev = 30, r.t0 = r.catch(24), r.abrupt("return", bo(r.t0, u));
                            case 33:
                                if ("cancel" !== g) {
                                    r.next = 35;
                                    break;
                                }
                                return r.abrupt("return", {
                                    canceled: !0
                                });
                            case 35:
                                return r.abrupt("return", xo(e, y, n));
                            case 36:
                                r.next = 20;
                                break;
                            case 38:
                                r.next = 43;
                                break;
                            case 40:
                                r.prev = 40, r.t1 = r.catch(18), d.e(r.t1);
                            case 43:
                                return r.prev = 43, d.f(), r.finish(43);
                            case 46:
                                if (f.canRemediate()) {
                                    r.next = 49;
                                    break;
                                }
                                return m = mo(f, e), r.abrupt("return", {
                                    idxResponse: e,
                                    nextStep: m
                                });
                            case 49:
                                return k = f.getName(), w = f.getData(), r.prev = 51, r.next = 54, e.proceed(k, w);
                            case 54:
                                return e = r.sent, t = f.getValuesAfterProceed(), r.abrupt("return", xo(e, t, n));
                            case 59:
                                return r.prev = 59, r.t2 = r.catch(51), r.abrupt("return", bo(r.t2, f));
                            case 62:
                            case "end":
                                return r.stop();
                        }
                    }, r, null, [
                        [
                            18,
                            40,
                            43,
                            46
                        ],
                        [
                            24,
                            30
                        ],
                        [
                            51,
                            59
                        ]
                    ]);
                }), new (i || (i = Promise))(function(e, t) {
                    function n(e) {
                        try {
                            s(a.next(e));
                        } catch (e) {
                            t(e);
                        }
                    }
                    function u(e) {
                        try {
                            s(a.throw(e));
                        } catch (e) {
                            t(e);
                        }
                    }
                    function s(t) {
                        var r;
                        t.done ? e(t.value) : (r = t.value, r instanceof i ? r : new i(function(e) {
                            e(r);
                        })).then(n, u);
                    }
                    s((a = a.apply(r, o || [])).next());
                });
            }
            function So(e, t) {
                (null == t || t > e.length) && (t = e.length);
                for(var n = 0, r = new Array(t); n < t; n++)r[n] = e[n];
                return r;
            }
            var To = function(e, t, n, r) {
                return new (n || (n = Promise))(function(o, i) {
                    function a(e) {
                        try {
                            s(r.next(e));
                        } catch (e) {
                            i(e);
                        }
                    }
                    function u(e) {
                        try {
                            s(r.throw(e));
                        } catch (e) {
                            i(e);
                        }
                    }
                    function s(e) {
                        var t;
                        e.done ? o(e.value) : (t = e.value, t instanceof n ? t : new n(function(e) {
                            e(t);
                        })).then(a, u);
                    }
                    s((r = r.apply(e, t || [])).next());
                });
            };
            function Oo(e) {
                var t = [], n = e.actions, r = e.neededToProceed;
                return n["currentAuthenticator-recover"] && t.push(vt.PASSWORD_RECOVERY), r.some(function(e) {
                    return "select-enroll-profile" === e.name;
                }) && t.push(vt.REGISTRATION), r.some(function(e) {
                    return "redirect-idp" === e.name;
                }) && t.push(vt.SOCIAL_IDP), t;
            }
            function Ao(e) {
                var t, n = [], r = Object.values(i).reduce(function(e, t) {
                    return t.remediationName && (e[t.remediationName] = t), e;
                }, {}), o = function(e, t) {
                    var n = "undefined" != typeof Symbol && e[Symbol.iterator] || e["@@iterator"];
                    if (!n) {
                        if (Array.isArray(e) || (n = function(e, t) {
                            if (e) {
                                if ("string" == typeof e) return So(e, t);
                                var n = Object.prototype.toString.call(e).slice(8, -1);
                                return "Object" === n && e.constructor && (n = e.constructor.name), "Map" === n || "Set" === n ? Array.from(e) : "Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? So(e, t) : void 0;
                            }
                        }(e)) || t && e && "number" == typeof e.length) {
                            n && (e = n);
                            var r = 0, o = function() {};
                            return {
                                s: o,
                                n: function() {
                                    return r >= e.length ? {
                                        done: !0
                                    } : {
                                        done: !1,
                                        value: e[r++]
                                    };
                                },
                                e: function(e) {
                                    throw e;
                                },
                                f: o
                            };
                        }
                        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
                    }
                    var i, a = !0, u = !1;
                    return {
                        s: function() {
                            n = n.call(e);
                        },
                        n: function() {
                            var e = n.next();
                            return a = e.done, e;
                        },
                        e: function(e) {
                            u = !0, i = e;
                        },
                        f: function() {
                            try {
                                a || null == n.return || n.return();
                            } finally{
                                if (u) throw i;
                            }
                        }
                    };
                }(e);
                try {
                    for(o.s(); !(t = o.n()).done;){
                        var a = t.value, u = r[a.name];
                        if (u) {
                            var s = new u(a);
                            n.push(s.getNextStep());
                        }
                    }
                } catch (e) {
                    o.e(e);
                } finally{
                    o.f();
                }
                return n;
            }
            function Eo(e) {
                var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
                return To(this, void 0, void 0, K().mark(function n() {
                    var r, o, i, a, u, s, c, f, l, p, h, d, v, g, y, m, b, k, w, x, S, T, O, A, E, _, R, P, j, I;
                    return K().wrap(function(n) {
                        for(;;)switch(n.prev = n.next){
                            case 0:
                                if (f = ht.PENDING, l = !1, n.prev = 2, v = t.flow, g = t.stateTokenExternalId, y = t.state, v && e.idx.setFlow(v), d = Tr(e, {
                                    state: y
                                }), (h = null == d ? void 0 : d.interactionHandle) || g) {
                                    n.next = 14;
                                    break;
                                }
                                return e.transactionManager.clear(), n.next = 11, Pr(e, t);
                            case 11:
                                m = n.sent, h = m.interactionHandle, d = m.meta;
                            case 14:
                                return n.next = 16, jr(e, {
                                    interactionHandle: h,
                                    stateTokenExternalId: g
                                });
                            case 16:
                                if (p = n.sent, t.remediators || t.actions) {
                                    n.next = 23;
                                    break;
                                }
                                u = d, s = Oo(p), c = Ao(p.neededToProceed), n.next = 48;
                                break;
                            case 23:
                                return b = Object.assign(Object.assign({}, t), {
                                    stateHandle: p.rawIdxState.stateHandle
                                }), n.next = 26, xo(p, b, t);
                            case 26:
                                if (k = n.sent, w = k.idxResponse, x = k.nextStep, S = k.terminal, T = k.canceled, O = k.messages, i = O, (o = x) && w && e.transactionManager.saveIdxResponse(w.rawIdxState), S && (f = ht.TERMINAL, l = !0), !T) {
                                    n.next = 41;
                                    break;
                                }
                                f = ht.CANCELED, l = !0, n.next = 48;
                                break;
                            case 41:
                                if (!(null == w ? void 0 : w.interactionCode)) {
                                    n.next = 48;
                                    break;
                                }
                                return E = (A = d).clientId, _ = A.codeVerifier, R = A.ignoreSignature, P = A.redirectUri, j = A.urls, I = A.scopes, n.next = 45, e.token.exchangeCodeForTokens({
                                    interactionCode: w.interactionCode,
                                    clientId: E,
                                    codeVerifier: _,
                                    ignoreSignature: R,
                                    redirectUri: P,
                                    scopes: I
                                }, j);
                            case 45:
                                r = n.sent, f = ht.SUCCESS, l = !0;
                            case 48:
                                n.next = 55;
                                break;
                            case 50:
                                n.prev = 50, n.t0 = n.catch(2), a = n.t0, f = ht.FAILURE, l = !0;
                            case 55:
                                return l && e.transactionManager.clear(), n.abrupt("return", Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({
                                    _idxResponse: p,
                                    status: f
                                }, u && {
                                    meta: u
                                }), s && {
                                    enabledFeatures: s
                                }), c && {
                                    availableSteps: c
                                }), r && {
                                    tokens: r.tokens
                                }), o && {
                                    nextStep: o
                                }), i && {
                                    messages: i
                                }), a && {
                                    error: a
                                }));
                            case 57:
                            case "end":
                                return n.stop();
                        }
                    }, n, null, [
                        [
                            2,
                            50
                        ]
                    ]);
                }));
            }
            var _o = {
                identify: Qr,
                "select-authenticator-authenticate": io,
                "select-authenticator-enroll": ao,
                "authenticator-enrollment-data": fo,
                "authenticator-verification-data": co,
                "enroll-authenticator": Gr,
                "challenge-authenticator": zr,
                "challenge-poll": Jr,
                "reenroll-authenticator": Zr,
                "enroll-poll": $r,
                "redirect-idp": eo,
                skip: lo
            }, Ro = {
                identify: Qr,
                "identify-recovery": Qr,
                "select-authenticator-authenticate": io,
                "challenge-authenticator": zr,
                "authenticator-verification-data": co,
                "reset-authenticator": Yr,
                "reenroll-authenticator": Zr
            }, Po = {
                "select-enroll-profile": uo,
                "enroll-profile": Xr,
                "authenticator-enrollment-data": fo,
                "select-authenticator-enroll": ao,
                "enroll-poll": $r,
                "enroll-authenticator": Gr,
                skip: lo
            };
            function jo(e) {
                var t, n, r = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "proceed";
                switch(r){
                    case "register":
                    case "signup":
                    case "enrollProfile":
                        t = Po;
                        break;
                    case "recoverPassword":
                    case "resetPassword":
                        t = Ro, n = [
                            "currentAuthenticator-recover",
                            "currentAuthenticatorEnrollment-recover"
                        ];
                        break;
                    default:
                        t = _o;
                }
                return {
                    flow: r,
                    remediators: t,
                    actions: n
                };
            }
            function Io(e, t) {
                var n, r, o, i;
                return n = this, r = void 0, o = void 0, i = K().mark(function n() {
                    var r;
                    return K().wrap(function(n) {
                        for(;;)switch(n.prev = n.next){
                            case 0:
                                return r = jo(e, "authenticate"), n.abrupt("return", Eo(e, Object.assign(Object.assign({}, t), r)));
                            case 2:
                            case "end":
                                return n.stop();
                        }
                    }, n);
                }), new (o || (o = Promise))(function(e, t) {
                    function a(e) {
                        try {
                            s(i.next(e));
                        } catch (e) {
                            t(e);
                        }
                    }
                    function u(e) {
                        try {
                            s(i.throw(e));
                        } catch (e) {
                            t(e);
                        }
                    }
                    function s(t) {
                        var n;
                        t.done ? e(t.value) : (n = t.value, n instanceof o ? n : new o(function(e) {
                            e(n);
                        })).then(a, u);
                    }
                    s((i = i.apply(n, r || [])).next());
                });
            }
            function Co(e, t) {
                var n, r, o, i;
                return n = this, r = void 0, o = void 0, i = K().mark(function n() {
                    var r, o;
                    return K().wrap(function(n) {
                        for(;;)switch(n.prev = n.next){
                            case 0:
                                return r = e.transactionManager.load(), o = jo(e, r.flow), n.abrupt("return", Eo(e, Object.assign(Object.assign(Object.assign({}, t), o), {
                                    actions: [
                                        "cancel"
                                    ]
                                })));
                            case 3:
                            case "end":
                                return n.stop();
                        }
                    }, n);
                }), new (o || (o = Promise))(function(e, t) {
                    function a(e) {
                        try {
                            s(i.next(e));
                        } catch (e) {
                            t(e);
                        }
                    }
                    function u(e) {
                        try {
                            s(i.throw(e));
                        } catch (e) {
                            t(e);
                        }
                    }
                    function s(t) {
                        var n;
                        t.done ? e(t.value) : (n = t.value, n instanceof o ? n : new o(function(e) {
                            e(n);
                        })).then(a, u);
                    }
                    s((i = i.apply(n, r || [])).next());
                });
            }
            var Mo = function(e, t, n, r) {
                return new (n || (n = Promise))(function(o, i) {
                    function a(e) {
                        try {
                            s(r.next(e));
                        } catch (e) {
                            i(e);
                        }
                    }
                    function u(e) {
                        try {
                            s(r.throw(e));
                        } catch (e) {
                            i(e);
                        }
                    }
                    function s(e) {
                        var t;
                        e.done ? o(e.value) : (t = e.value, t instanceof n ? t : new n(function(e) {
                            e(t);
                        })).then(a, u);
                    }
                    s((r = r.apply(e, t || [])).next());
                });
            };
            function Uo(e, t) {
                return !!Tr(e, t);
            }
            function Fo(e) {
                var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
                return Mo(this, void 0, void 0, K().mark(function n() {
                    var r, o, i, a;
                    return K().wrap(function(n) {
                        for(;;)switch(n.prev = n.next){
                            case 0:
                                if (r = t.stateTokenExternalId, o = t.state, (i = Tr(e, {
                                    state: o
                                })) || r) {
                                    n.next = 4;
                                    break;
                                }
                                throw new b("Unable to proceed: saved transaction could not be loaded");
                            case 4:
                                return a = jo(e, null == i ? void 0 : i.flow), n.abrupt("return", Eo(e, Object.assign(Object.assign({}, t), a)));
                            case 6:
                            case "end":
                                return n.stop();
                        }
                    }, n);
                }));
            }
            var No = function(e, t, n, r) {
                return new (n || (n = Promise))(function(o, i) {
                    function a(e) {
                        try {
                            s(r.next(e));
                        } catch (e) {
                            i(e);
                        }
                    }
                    function u(e) {
                        try {
                            s(r.throw(e));
                        } catch (e) {
                            i(e);
                        }
                    }
                    function s(e) {
                        var t;
                        e.done ? o(e.value) : (t = e.value, t instanceof n ? t : new n(function(e) {
                            e(t);
                        })).then(a, u);
                    }
                    s((r = r.apply(e, t || [])).next());
                });
            };
            function Lo(e) {
                var t, n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
                return No(this, void 0, void 0, K().mark(function r() {
                    var o, i, a;
                    return K().wrap(function(r) {
                        for(;;)switch(r.prev = r.next){
                            case 0:
                                return r.next = 2, Fo(e, {
                                    startPolling: !0
                                });
                            case 2:
                                if (o = r.sent, i = Tr(e), (null == (a = null === (t = null == i ? void 0 : i.remediations) || void 0 === t ? void 0 : t.find(function(e) {
                                    return e.includes("poll");
                                })) ? void 0 : a.length) || Sn("No polling remediations available at the current IDX flow stage"), !Number.isInteger(n.refresh)) {
                                    r.next = 8;
                                    break;
                                }
                                return r.abrupt("return", new Promise(function(t, r) {
                                    setTimeout(function() {
                                        var n, i;
                                        return No(this, void 0, void 0, K().mark(function a() {
                                            var u;
                                            return K().wrap(function(a) {
                                                for(;;)switch(a.prev = a.next){
                                                    case 0:
                                                        try {
                                                            u = null === (i = null === (n = o.nextStep) || void 0 === n ? void 0 : n.poll) || void 0 === i ? void 0 : i.refresh, t(u ? Lo(e, {
                                                                refresh: u
                                                            }) : o);
                                                        } catch (e) {
                                                            r(e);
                                                        }
                                                    case 1:
                                                    case "end":
                                                        return a.stop();
                                                }
                                            }, a);
                                        }));
                                    }, n.refresh);
                                }));
                            case 8:
                                return r.abrupt("return", o);
                            case 9:
                            case "end":
                                return r.stop();
                        }
                    }, r);
                }));
            }
            var Do = function(e, t, n, r) {
                return new (n || (n = Promise))(function(o, i) {
                    function a(e) {
                        try {
                            s(r.next(e));
                        } catch (e) {
                            i(e);
                        }
                    }
                    function u(e) {
                        try {
                            s(r.throw(e));
                        } catch (e) {
                            i(e);
                        }
                    }
                    function s(e) {
                        var t;
                        e.done ? o(e.value) : (t = e.value, t instanceof n ? t : new n(function(e) {
                            e(t);
                        })).then(a, u);
                    }
                    s((r = r.apply(e, t || [])).next());
                });
            };
            function Bo(e) {
                var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
                return Do(this, void 0, void 0, K().mark(function n() {
                    return K().wrap(function(n) {
                        for(;;)switch(n.prev = n.next){
                            case 0:
                                return e.transactionManager.clear(), n.abrupt("return", Eo(e, t));
                            case 2:
                            case "end":
                                return n.stop();
                        }
                    }, n);
                }));
            }
            var qo = function(e, t, n, r) {
                return new (n || (n = Promise))(function(o, i) {
                    function a(e) {
                        try {
                            s(r.next(e));
                        } catch (e) {
                            i(e);
                        }
                    }
                    function u(e) {
                        try {
                            s(r.throw(e));
                        } catch (e) {
                            i(e);
                        }
                    }
                    function s(e) {
                        var t;
                        e.done ? o(e.value) : (t = e.value, t instanceof n ? t : new n(function(e) {
                            e(t);
                        })).then(a, u);
                    }
                    s((r = r.apply(e, t || [])).next());
                });
            };
            function Ho(e) {
                var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
                return qo(this, void 0, void 0, K().mark(function n() {
                    var r, o, i, a, u, s;
                    return K().wrap(function(n) {
                        for(;;)switch(n.prev = n.next){
                            case 0:
                                if (Sr(e)) {
                                    n.next = 12;
                                    break;
                                }
                                return n.next = 3, Bo(e, Object.assign({
                                    flow: "register"
                                }, t));
                            case 3:
                                if (r = n.sent, o = r.enabledFeatures, i = r.availableSteps, t.activationToken || !o || o.includes(vt.REGISTRATION)) {
                                    n.next = 9;
                                    break;
                                }
                                return a = new b("Registration is not supported based on your current org configuration."), n.abrupt("return", {
                                    status: ht.FAILURE,
                                    error: a
                                });
                            case 9:
                                if (!t.activationToken || !(null == i ? void 0 : i.some(function(e) {
                                    return "identify" === e.name;
                                }))) {
                                    n.next = 12;
                                    break;
                                }
                                return u = new b("activationToken is not supported based on your current org configuration."), n.abrupt("return", {
                                    status: ht.FAILURE,
                                    error: u
                                });
                            case 12:
                                return s = jo(e, "register"), n.abrupt("return", Eo(e, Object.assign(Object.assign({}, t), s)));
                            case 14:
                            case "end":
                                return n.stop();
                        }
                    }, n);
                }));
            }
            function Ko(e, t) {
                var n, r, o, i;
                return n = this, r = void 0, o = void 0, i = K().mark(function n() {
                    var r;
                    return K().wrap(function(n) {
                        for(;;)switch(n.prev = n.next){
                            case 0:
                                return r = jo(e, "recoverPassword"), n.abrupt("return", Eo(e, Object.assign(Object.assign({}, t), r)));
                            case 2:
                            case "end":
                                return n.stop();
                        }
                    }, n);
                }), new (o || (o = Promise))(function(e, t) {
                    function a(e) {
                        try {
                            s(i.next(e));
                        } catch (e) {
                            t(e);
                        }
                    }
                    function u(e) {
                        try {
                            s(i.throw(e));
                        } catch (e) {
                            t(e);
                        }
                    }
                    function s(t) {
                        var n;
                        t.done ? e(t.value) : (n = t.value, n instanceof o ? n : new o(function(e) {
                            e(n);
                        })).then(a, u);
                    }
                    s((i = i.apply(n, r || [])).next());
                });
            }
            function Vo(e, t) {
                var n, r, o, i;
                return n = this, r = void 0, o = void 0, i = K().mark(function n() {
                    var r, o, i, a, u, s, c, f, l, p;
                    return K().wrap(function(n) {
                        for(;;)switch(n.prev = n.next){
                            case 0:
                                if (r = e.transactionManager.load()) {
                                    n.next = 3;
                                    break;
                                }
                                throw new b("No transaction data was found in storage");
                            case 3:
                                if (o = r.codeVerifier, i = r.state, a = new URL(t), u = a.searchParams, s = u.get("state"), c = u.get("interaction_code"), !(f = u.get("error"))) {
                                    n.next = 10;
                                    break;
                                }
                                throw new k(f, u.get("error_description"));
                            case 10:
                                if (s === i) {
                                    n.next = 12;
                                    break;
                                }
                                throw new b("State in redirect uri does not match with transaction state");
                            case 12:
                                if (c) {
                                    n.next = 14;
                                    break;
                                }
                                throw new b("Unable to parse interaction_code from the url");
                            case 14:
                                return n.next = 16, e.token.exchangeCodeForTokens({
                                    interactionCode: c,
                                    codeVerifier: o
                                });
                            case 16:
                                l = n.sent, p = l.tokens, e.tokenManager.setTokens(p);
                            case 19:
                            case "end":
                                return n.stop();
                        }
                    }, n);
                }), new (o || (o = Promise))(function(e, t) {
                    function a(e) {
                        try {
                            s(i.next(e));
                        } catch (e) {
                            t(e);
                        }
                    }
                    function u(e) {
                        try {
                            s(i.throw(e));
                        } catch (e) {
                            t(e);
                        }
                    }
                    function s(t) {
                        var n;
                        t.done ? e(t.value) : (n = t.value, n instanceof o ? n : new o(function(e) {
                            e(n);
                        })).then(a, u);
                    }
                    s((i = i.apply(n, r || [])).next());
                });
            }
            var Go = function() {
                function e() {
                    a(this, e), this.environments = [
                        "okta-auth-js/".concat("5.11.0")
                    ];
                }
                return q(e, [
                    {
                        key: "addEnvironment",
                        value: function(e) {
                            this.environments.push(e);
                        }
                    },
                    {
                        key: "getHttpHeader",
                        value: function() {
                            return this.maybeAddNodeEnvironment(), {
                                "X-Okta-User-Agent-Extended": this.environments.join(" ")
                            };
                        }
                    },
                    {
                        key: "getVersion",
                        value: function() {
                            return "5.11.0";
                        }
                    },
                    {
                        key: "maybeAddNodeEnvironment",
                        value: function() {
                            if (!yt() && $63dbe9146d5df2e6$exports && $63dbe9146d5df2e6$exports.versions) {
                                var e = $63dbe9146d5df2e6$exports.versions.node;
                                this.environments.push("nodejs/".concat(e));
                            }
                        }
                    }
                ]), e;
            }(), Wo = function(e, t, n, r) {
                return new (n || (n = Promise))(function(o, i) {
                    function a(e) {
                        try {
                            s(r.next(e));
                        } catch (e) {
                            i(e);
                        }
                    }
                    function u(e) {
                        try {
                            s(r.throw(e));
                        } catch (e) {
                            i(e);
                        }
                    }
                    function s(e) {
                        var t;
                        e.done ? o(e.value) : (t = e.value, t instanceof n ? t : new n(function(e) {
                            e(t);
                        })).then(a, u);
                    }
                    s((r = r.apply(e, t || [])).next());
                });
            }, $o = function(e, t) {
                var n = {};
                for(var r in e)Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
                if (null != e && "function" == typeof Object.getOwnPropertySymbols) {
                    var o = 0;
                    for(r = Object.getOwnPropertySymbols(e); o < r.length; o++)t.indexOf(r[o]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[o]) && (n[r[o]] = e[r[o]]);
                }
                return n;
            }, zo = n(4279), Jo = function() {
                function e(t) {
                    var n = this;
                    a(this, e);
                    var r = this.options = function() {
                        var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
                        return jn(e), M({
                            issuer: xe((e = mr(yr(), e)).issuer),
                            tokenUrl: xe(e.tokenUrl),
                            authorizeUrl: xe(e.authorizeUrl),
                            userinfoUrl: xe(e.userinfoUrl),
                            revokeUrl: xe(e.revokeUrl),
                            logoutUrl: xe(e.logoutUrl),
                            clientId: e.clientId,
                            redirectUri: e.redirectUri,
                            state: e.state,
                            scopes: e.scopes,
                            postLogoutRedirectUri: e.postLogoutRedirectUri,
                            responseMode: e.responseMode,
                            responseType: e.responseType,
                            pkce: !1 !== e.pkce,
                            useInteractionCodeFlow: e.useInteractionCodeFlow,
                            httpRequestClient: e.httpRequestClient,
                            transformErrorXHR: e.transformErrorXHR,
                            transformAuthState: e.transformAuthState,
                            restoreOriginalUri: e.restoreOriginalUri,
                            storageUtil: e.storageUtil,
                            headers: e.headers,
                            devMode: !!e.devMode,
                            storageManager: e.storageManager,
                            transactionManager: e.transactionManager,
                            cookies: yt() ? gr(e, Ot()) : e.cookies,
                            ignoreSignature: !!e.ignoreSignature,
                            clientSecret: e.clientSecret
                        });
                    }(t);
                    this.storageManager = new Zn(r.storageManager, r.cookies, r.storageUtil), this.transactionManager = new ir(Object.assign({
                        storageManager: this.storageManager
                    }, r.transactionManager)), this._oktaUserAgent = new Go, this.tx = {
                        status: Ue.bind(null, this),
                        resume: Fe.bind(null, this),
                        exists: Object.assign(Le.bind(null, this), {
                            _get: function(e) {
                                return r.storageUtil.storage.get(e);
                            }
                        }),
                        introspect: Ne.bind(null, this)
                    }, this.pkce = {
                        DEFAULT_CODE_CHALLENGE_METHOD: He.DEFAULT_CODE_CHALLENGE_METHOD,
                        generateVerifier: He.generateVerifier,
                        computeChallenge: He.computeChallenge
                    }, Object.assign(this.options.storageUtil, {
                        getPKCEStorage: this.storageManager.getLegacyPKCEStorage.bind(this.storageManager),
                        getHttpCache: this.storageManager.getHttpCache.bind(this.storageManager)
                    }), this._pending = {
                        handleLogin: !1
                    }, yt() ? (this.options = Object.assign(this.options, {
                        redirectUri: be(t.redirectUri, window.location.origin)
                    }), this.userAgent = In(t, "okta-auth-js/".concat("5.11.0"))) : this.userAgent = In(t, "okta-auth-js-server/".concat("5.11.0")), t.maxClockSkew || 0 === t.maxClockSkew ? this.options.maxClockSkew = t.maxClockSkew : this.options.maxClockSkew = W, this.options.ignoreLifetime = !!t.ignoreLifetime, this.session = {
                        close: Ge.bind(null, this),
                        exists: Ke.bind(null, this),
                        get: Ve.bind(null, this),
                        refresh: We.bind(null, this),
                        setCookieAndRedirect: $e.bind(null, this)
                    }, this._tokenQueue = new Vn, this.token = {
                        prepareTokenParams: Dt.bind(null, this),
                        exchangeCodeForTokens: rn.bind(null, this),
                        getWithoutPrompt: sn.bind(null, this),
                        getWithPopup: vn.bind(null, this),
                        getWithRedirect: gn.bind(null, this),
                        parseFromUrl: kn.bind(null, this),
                        decode: tn,
                        revoke: nn.bind(null, this),
                        renew: pn.bind(null, this),
                        renewTokensWithRefresh: cn.bind(null, this),
                        renewTokens: hn.bind(null, this),
                        getUserInfo: dn.bind(null, this),
                        verify: on.bind(null, this),
                        isLoginRedirect: Nt.bind(null, this)
                    };
                    var o, i, u = [
                        "decode",
                        "isLoginRedirect"
                    ];
                    Object.keys(this.token).forEach(function(e) {
                        if (!(u.indexOf(e) >= 0)) {
                            var t = n.token[e];
                            n.token[e] = Vn.prototype.push.bind(n._tokenQueue, t, null);
                        }
                    }), Object.assign(this.token.getWithRedirect, {
                        _setLocation: function(e) {
                            window.location = e;
                        }
                    }), Object.assign(this.token.parseFromUrl, {
                        _getHistory: function() {
                            return window.history;
                        },
                        _getLocation: function() {
                            return window.location;
                        },
                        _getDocument: function() {
                            return window.document;
                        }
                    }), this.idx = {
                        interact: Pr.bind(null, this),
                        introspect: jr.bind(null, this),
                        authenticate: Io.bind(null, this),
                        register: Ho.bind(null, this),
                        poll: Lo.bind(null, this),
                        proceed: Fo.bind(null, this),
                        cancel: Co.bind(null, this),
                        recoverPassword: Ko.bind(null, this),
                        handleInteractionCodeRedirect: Vo.bind(null, this),
                        startTransaction: Bo.bind(null, this),
                        setFlow: function(e) {
                            n.options.flow = e;
                        },
                        getFlow: function() {
                            return n.options.flow;
                        },
                        canProceed: Uo.bind(null, this)
                    }, i = this, o = function(e) {
                        var t = i._oktaUserAgent.getHttpHeader(), n = Object.assign(Object.assign({}, t), i.options.headers);
                        Object.keys(n).forEach(function(t) {
                            e.headers[t] = n[t];
                        });
                    }, kr().client.interceptors.request.use(o), this.http = {
                        setRequestHeader: pe.bind(null, this)
                    }, this.fingerprint = Gn.bind(null, this), this.emitter = new zo, this.tokenManager = new Hn(this, t.tokenManager), this.authStateManager = new Yn(this);
                }
                return q(e, [
                    {
                        key: "start",
                        value: function() {
                            this.tokenManager.start(), this.token.isLoginRedirect() || this.authStateManager.updateAuthState();
                        }
                    },
                    {
                        key: "stop",
                        value: function() {
                            this.tokenManager.stop();
                        }
                    },
                    {
                        key: "setHeaders",
                        value: function(e) {
                            this.options.headers = Object.assign({}, this.options.headers, e);
                        }
                    },
                    {
                        key: "isInteractionRequired",
                        value: function(e) {
                            return Lt(this, e);
                        }
                    },
                    {
                        key: "isInteractionRequiredError",
                        value: function(e) {
                            return _t(e);
                        }
                    },
                    {
                        key: "isEmailVerifyCallback",
                        value: function(e) {
                            return Rn(e);
                        }
                    },
                    {
                        key: "parseEmailVerifyCallback",
                        value: function(e) {
                            return Pn(e);
                        }
                    },
                    {
                        key: "signIn",
                        value: function(e) {
                            return Wo(this, void 0, void 0, K().mark(function t() {
                                return K().wrap(function(t) {
                                    for(;;)switch(t.prev = t.next){
                                        case 0:
                                            return t.abrupt("return", this.signInWithCredentials(e));
                                        case 1:
                                        case "end":
                                            return t.stop();
                                    }
                                }, t, this);
                            }));
                        }
                    },
                    {
                        key: "signInWithCredentials",
                        value: function(e) {
                            return Wo(this, void 0, void 0, K().mark(function t() {
                                var n, r = this;
                                return K().wrap(function(t) {
                                    for(;;)switch(t.prev = t.next){
                                        case 0:
                                            if (e = U(e || {}), n = function(t) {
                                                return delete e.sendFingerprint, De(r, "/api/v1/authn", e, t);
                                            }, e.sendFingerprint) {
                                                t.next = 4;
                                                break;
                                            }
                                            return t.abrupt("return", n());
                                        case 4:
                                            return t.abrupt("return", this.fingerprint().then(function(e) {
                                                return n({
                                                    headers: {
                                                        "X-Device-Fingerprint": e
                                                    }
                                                });
                                            }));
                                        case 5:
                                        case "end":
                                            return t.stop();
                                    }
                                }, t, this);
                            }));
                        }
                    },
                    {
                        key: "signInWithRedirect",
                        value: function() {
                            var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
                            return Wo(this, void 0, void 0, K().mark(function t() {
                                var n, r, o;
                                return K().wrap(function(t) {
                                    for(;;)switch(t.prev = t.next){
                                        case 0:
                                            if (n = e.originalUri, r = $o(e, [
                                                "originalUri"
                                            ]), !this._pending.handleLogin) {
                                                t.next = 3;
                                                break;
                                            }
                                            return t.abrupt("return");
                                        case 3:
                                            return this._pending.handleLogin = !0, t.prev = 4, n && this.setOriginalUri(n), o = Object.assign({
                                                scopes: this.options.scopes || [
                                                    "openid",
                                                    "email",
                                                    "profile"
                                                ]
                                            }, r), t.next = 9, this.token.getWithRedirect(o);
                                        case 9:
                                            return t.prev = 9, this._pending.handleLogin = !1, t.finish(9);
                                        case 12:
                                        case "end":
                                            return t.stop();
                                    }
                                }, t, this, [
                                    [
                                        4,
                                        ,
                                        9,
                                        12
                                    ]
                                ]);
                            }));
                        }
                    },
                    {
                        key: "closeSession",
                        value: function() {
                            var e = this;
                            return this.session.close().then(function() {
                                return Wo(e, void 0, void 0, K().mark(function e() {
                                    return K().wrap(function(e) {
                                        for(;;)switch(e.prev = e.next){
                                            case 0:
                                                this.tokenManager.clear();
                                            case 1:
                                            case "end":
                                                return e.stop();
                                        }
                                    }, e, this);
                                }));
                            }).catch(function(e) {
                                if ("AuthApiError" === e.name && "E0000007" === e.errorCode) return null;
                                throw e;
                            });
                        }
                    },
                    {
                        key: "revokeAccessToken",
                        value: function(e) {
                            return Wo(this, void 0, void 0, K().mark(function t() {
                                var n;
                                return K().wrap(function(t) {
                                    for(;;)switch(t.prev = t.next){
                                        case 0:
                                            if (e) {
                                                t.next = 6;
                                                break;
                                            }
                                            return t.next = 3, this.tokenManager.getTokens();
                                        case 3:
                                            e = t.sent.accessToken, n = this.tokenManager.getStorageKeyByType("accessToken"), this.tokenManager.remove(n);
                                        case 6:
                                            if (e) {
                                                t.next = 8;
                                                break;
                                            }
                                            return t.abrupt("return", Promise.resolve(null));
                                        case 8:
                                            return t.abrupt("return", this.token.revoke(e));
                                        case 9:
                                        case "end":
                                            return t.stop();
                                    }
                                }, t, this);
                            }));
                        }
                    },
                    {
                        key: "revokeRefreshToken",
                        value: function(e) {
                            return Wo(this, void 0, void 0, K().mark(function t() {
                                var n;
                                return K().wrap(function(t) {
                                    for(;;)switch(t.prev = t.next){
                                        case 0:
                                            if (e) {
                                                t.next = 6;
                                                break;
                                            }
                                            return t.next = 3, this.tokenManager.getTokens();
                                        case 3:
                                            e = t.sent.refreshToken, n = this.tokenManager.getStorageKeyByType("refreshToken"), this.tokenManager.remove(n);
                                        case 6:
                                            if (e) {
                                                t.next = 8;
                                                break;
                                            }
                                            return t.abrupt("return", Promise.resolve(null));
                                        case 8:
                                            return t.abrupt("return", this.token.revoke(e));
                                        case 9:
                                        case "end":
                                            return t.stop();
                                    }
                                }, t, this);
                            }));
                        }
                    },
                    {
                        key: "getSignOutRedirectUrl",
                        value: function() {
                            var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {}, t = e.idToken, n = e.postLogoutRedirectUri, r = e.state;
                            if (t || (t = this.tokenManager.getTokensSync().idToken), !t) return "";
                            n || (n = this.options.postLogoutRedirectUri);
                            var o = pt(this).logoutUrl, i = t.idToken, a = o + "?id_token_hint=" + encodeURIComponent(i);
                            return n && (a += "&post_logout_redirect_uri=" + encodeURIComponent(n)), r && (a += "&state=" + encodeURIComponent(r)), a;
                        }
                    },
                    {
                        key: "signOut",
                        value: function(e) {
                            return Wo(this, void 0, void 0, K().mark(function t() {
                                var n, r, o, i, a, u, s, c;
                                return K().wrap(function(t) {
                                    for(;;)switch(t.prev = t.next){
                                        case 0:
                                            if (e = Object.assign({}, e), n = window.location.origin, r = window.location.href, o = e.postLogoutRedirectUri || this.options.postLogoutRedirectUri || n, i = e.accessToken, a = e.refreshToken, u = !1 !== e.revokeAccessToken, (s = !1 !== e.revokeRefreshToken) && void 0 === a && (a = this.tokenManager.getTokensSync().refreshToken), u && void 0 === i && (i = this.tokenManager.getTokensSync().accessToken), e.idToken || (e.idToken = this.tokenManager.getTokensSync().idToken), !s || !a) {
                                                t.next = 14;
                                                break;
                                            }
                                            return t.next = 14, this.revokeRefreshToken(a);
                                        case 14:
                                            if (!u || !i) {
                                                t.next = 17;
                                                break;
                                            }
                                            return t.next = 17, this.revokeAccessToken(i);
                                        case 17:
                                            if (c = this.getSignOutRedirectUrl(Object.assign(Object.assign({}, e), {
                                                postLogoutRedirectUri: o
                                            }))) {
                                                t.next = 22;
                                                break;
                                            }
                                            return t.abrupt("return", this.closeSession().then(function() {
                                                o === r ? window.location.reload() : window.location.assign(o);
                                            }));
                                        case 22:
                                            e.clearTokensAfterRedirect ? this.tokenManager.addPendingRemoveFlags() : this.tokenManager.clear(), window.location.assign(c);
                                        case 24:
                                        case "end":
                                            return t.stop();
                                    }
                                }, t, this);
                            }));
                        }
                    },
                    {
                        key: "webfinger",
                        value: function(e) {
                            return Te(this, "/.well-known/webfinger" + we(e), {
                                headers: {
                                    Accept: "application/jrd+json"
                                }
                            });
                        }
                    },
                    {
                        key: "isAuthenticated",
                        value: function() {
                            return Wo(this, void 0, void 0, K().mark(function e() {
                                var t, n, r, o, i, a;
                                return K().wrap(function(e) {
                                    for(;;)switch(e.prev = e.next){
                                        case 0:
                                            if (t = this.tokenManager.getTokensSync(), n = t.accessToken, r = t.idToken, o = this.tokenManager.getOptions(), i = o.autoRenew, a = o.autoRemove, !n || !this.tokenManager.hasExpired(n)) {
                                                e.next = 16;
                                                break;
                                            }
                                            if (n = null, !i) {
                                                e.next = 15;
                                                break;
                                            }
                                            return e.prev = 5, e.next = 8, this.tokenManager.renew("accessToken");
                                        case 8:
                                            n = e.sent, e.next = 13;
                                            break;
                                        case 11:
                                            e.prev = 11, e.t0 = e.catch(5);
                                        case 13:
                                            e.next = 16;
                                            break;
                                        case 15:
                                            a && this.tokenManager.remove("accessToken");
                                        case 16:
                                            if (!r || !this.tokenManager.hasExpired(r)) {
                                                e.next = 30;
                                                break;
                                            }
                                            if (r = null, !i) {
                                                e.next = 29;
                                                break;
                                            }
                                            return e.prev = 19, e.next = 22, this.tokenManager.renew("idToken");
                                        case 22:
                                            r = e.sent, e.next = 27;
                                            break;
                                        case 25:
                                            e.prev = 25, e.t1 = e.catch(19);
                                        case 27:
                                            e.next = 30;
                                            break;
                                        case 29:
                                            a && this.tokenManager.remove("idToken");
                                        case 30:
                                            return e.abrupt("return", !(!n || !r));
                                        case 31:
                                        case "end":
                                            return e.stop();
                                    }
                                }, e, this, [
                                    [
                                        5,
                                        11
                                    ],
                                    [
                                        19,
                                        25
                                    ]
                                ]);
                            }));
                        }
                    },
                    {
                        key: "getUser",
                        value: function() {
                            return Wo(this, void 0, void 0, K().mark(function e() {
                                var t, n, r;
                                return K().wrap(function(e) {
                                    for(;;)switch(e.prev = e.next){
                                        case 0:
                                            return t = this.tokenManager.getTokensSync(), n = t.idToken, r = t.accessToken, e.abrupt("return", this.token.getUserInfo(r, n));
                                        case 2:
                                        case "end":
                                            return e.stop();
                                    }
                                }, e, this);
                            }));
                        }
                    },
                    {
                        key: "getIdToken",
                        value: function() {
                            var e = this.tokenManager.getTokensSync().idToken;
                            return e ? e.idToken : void 0;
                        }
                    },
                    {
                        key: "getAccessToken",
                        value: function() {
                            var e = this.tokenManager.getTokensSync().accessToken;
                            return e ? e.accessToken : void 0;
                        }
                    },
                    {
                        key: "getRefreshToken",
                        value: function() {
                            var e = this.tokenManager.getTokensSync().refreshToken;
                            return e ? e.refreshToken : void 0;
                        }
                    },
                    {
                        key: "storeTokensFromRedirect",
                        value: function() {
                            return Wo(this, void 0, void 0, K().mark(function e() {
                                var t, n;
                                return K().wrap(function(e) {
                                    for(;;)switch(e.prev = e.next){
                                        case 0:
                                            return e.next = 2, this.token.parseFromUrl();
                                        case 2:
                                            t = e.sent, n = t.tokens, this.tokenManager.setTokens(n);
                                        case 5:
                                        case "end":
                                            return e.stop();
                                    }
                                }, e, this);
                            }));
                        }
                    },
                    {
                        key: "setOriginalUri",
                        value: function(e, t) {
                            _n.getSessionStorage().setItem(ue, e), (t = t || this.options.state) && this.storageManager.getOriginalUriStorage().setItem(t, e);
                        }
                    },
                    {
                        key: "getOriginalUri",
                        value: function(e) {
                            if (e = e || this.options.state) {
                                var t = this.storageManager.getOriginalUriStorage().getItem(e);
                                if (t) return t;
                            }
                            var n = _n.getSessionStorage();
                            return n ? n.getItem(ue) : void 0;
                        }
                    },
                    {
                        key: "removeOriginalUri",
                        value: function(e) {
                            _n.getSessionStorage().removeItem(ue), (e = e || this.options.state) && this.storageManager.getOriginalUriStorage().removeItem(e);
                        }
                    },
                    {
                        key: "isLoginRedirect",
                        value: function() {
                            return Nt(this);
                        }
                    },
                    {
                        key: "handleLoginRedirect",
                        value: function(e, t) {
                            return Wo(this, void 0, void 0, K().mark(function n() {
                                var r, o, i;
                                return K().wrap(function(n) {
                                    for(;;)switch(n.prev = n.next){
                                        case 0:
                                            if (r = this.options.state, !e) {
                                                n.next = 6;
                                                break;
                                            }
                                            this.tokenManager.setTokens(e), t = t || this.getOriginalUri(this.options.state), n.next = 17;
                                            break;
                                        case 6:
                                            if (!this.isLoginRedirect()) {
                                                n.next = 16;
                                                break;
                                            }
                                            return n.next = 9, mn(this, {});
                                        case 9:
                                            return o = n.sent, r = o.state, t = t || this.getOriginalUri(r), n.next = 14, this.storeTokensFromRedirect();
                                        case 14:
                                            n.next = 17;
                                            break;
                                        case 16:
                                            return n.abrupt("return");
                                        case 17:
                                            return n.next = 19, this.authStateManager.updateAuthState();
                                        case 19:
                                            if (this.removeOriginalUri(r), !(i = this.options.restoreOriginalUri)) {
                                                n.next = 26;
                                                break;
                                            }
                                            return n.next = 24, i(this, t);
                                        case 24:
                                            n.next = 27;
                                            break;
                                        case 26:
                                            window.location.replace(t);
                                        case 27:
                                        case "end":
                                            return n.stop();
                                    }
                                }, n, this);
                            }));
                        }
                    },
                    {
                        key: "isPKCE",
                        value: function() {
                            return !!this.options.pkce;
                        }
                    },
                    {
                        key: "hasResponseType",
                        value: function(e) {
                            return Array.isArray(this.options.responseType) && this.options.responseType.length ? this.options.responseType.indexOf(e) >= 0 : this.options.responseType === e;
                        }
                    },
                    {
                        key: "isAuthorizationCodeFlow",
                        value: function() {
                            return this.hasResponseType("code");
                        }
                    },
                    {
                        key: "getIssuerOrigin",
                        value: function() {
                            return this.options.issuer.split("/oauth2/")[0];
                        }
                    },
                    {
                        key: "forgotPassword",
                        value: function(e) {
                            return De(this, "/api/v1/authn/recovery/password", e);
                        }
                    },
                    {
                        key: "unlockAccount",
                        value: function(e) {
                            return De(this, "/api/v1/authn/recovery/unlock", e);
                        }
                    },
                    {
                        key: "verifyRecoveryToken",
                        value: function(e) {
                            return De(this, "/api/v1/authn/recovery/token", e);
                        }
                    }
                ]), e;
            }();
            Jo.features = Jo.prototype.features = o, Object.assign(Jo, {
                constants: t,
                isInteractionRequiredError: _t
            });
            var Yo = Jo;
        }(), r;
    }();
});


function $69261e61bbefcc8e$export$f27f0b46d04f41cb(OAuthConfig) {
    $69261e61bbefcc8e$var$doValidation();
    this.OAuthConfig = OAuthConfig;
    const myMemoryStore = {};
    const storageProvider = {
        getItem: function(key) {
            // custom get
            console.info(`Getting ${key} from memory store. No Op`);
            return myMemoryStore[key];
        },
        setItem: function(key, val) {
            // custom set
            console.info(`NOT Setting ${key} in memory store.`);
        // myMemoryStore[key] = val;
        },
        // optional
        removeItem: function(key) {
            console.info(`removing item ${key} from memory store. No OP.`);
            delete myMemoryStore[key];
        }
    };
    this.OAuthConfig.storageManager = {
        token: {
            storageProvider: storageProvider
        }
    };
    this.authClient = new (0, $c0c5a1734783046e$exports.OktaAuth)(this.OAuthConfig);
    // this.authClient.start();
    this.login = async ()=>{
        if (this.authClient.isLoginRedirect()) // Parse token from redirect url
        return await this.parseTokenFromURL();
        else // Attempt to retrieve ID Token from Token Manager
        return await this.getTokenWithRedirect();
    };
    this.logout = async ()=>{
        await this.authClient.signOut();
    // this.authClient.stop();
    };
    this.parseTokenFromURL = async ()=>{
        const data = await this.authClient.token.parseFromUrl();
        const { idToken: idToken , accessToken: accessToken , refreshToken: refreshToken  } = data.tokens;
        // Store parsed token in Token Manager
        this.authClient.tokenManager.add("idToken", idToken);
        this.authClient.tokenManager.add("accessToken", accessToken);
        this.authClient.tokenManager.add("refreshToken", refreshToken);
        return {
            idToken: idToken,
            accessToken: accessToken,
            refreshToken: refreshToken
        };
    // this.authClient.token.parseFromUrl().then((data) => {
    // });
    };
    this.getTokenWithRedirect = async ()=>{
        const idToken = await this.authClient.tokenManager.get("idToken");
        const accessToken = await this.authClient.tokenManager.get("accessToken");
        const refreshToken = await this.authClient.tokenManager.get("refreshToken");
        if (idToken && accessToken && refreshToken) // also check for refresh token?
        return {
            idToken: idToken,
            accessToken: accessToken,
            refreshToken: refreshToken
        };
        else // You're not logged in, you need a sessionToken
        await this.authClient.token.getWithRedirect({
            scopes: [
                "openid",
                "email",
                "profile",
                "offline_access"
            ]
        }); // need to pass in idp parameter?
    // this.authClient.tokenManager.get("idToken").then((idToken) => {
    //   if (idToken) {
    //     console.log(`Hi ${idToken.claims.email}!`); // TODO : return a token here??
    //   } else {
    //   }
    // });
    };
    this.getAccessToken = ()=>{
        this.authClient.tokenManager.get("accessToken").then((accesToken)=>{
            return accesToken;
        });
    };
    this.isLoggedIn = async ()=>{
        let isLoggedIn = false;
        // await this.authClient.authStateManager.updateAuthState();
        isLoggedIn = await this.authClient.isAuthenticated();
        return isLoggedIn;
    };
    this.getClient = ()=>this.authClient;
}
function $69261e61bbefcc8e$var$doValidation() {
    if (!(0, $c0c5a1734783046e$exports.OktaAuth).features.isPKCESupported()) throw new Error("Your browser needs to be upgraded to support the OAuth authentication!");
}


function $76e3cae290f74ce7$export$d0d24bcc82916a99(OAuthConfig) {
    let authClient = null;
    const OAuthType = OAuthConfig.OAuthType;
    switch(OAuthType){
        case (0, $faa2ca7f56fbc6f0$export$4128a78c9389121b).Okta:
            authClient = new (0, $69261e61bbefcc8e$export$f27f0b46d04f41cb)(OAuthConfig);
            break;
        default:
            break;
    }
    return authClient;
}



function $36b0160b69c700e9$export$2e2bcd8739ae039(message) {
    this.message = message;
    this.stack = new Error().stack;
}
$36b0160b69c700e9$export$2e2bcd8739ae039.prototype = Object.create(Error.prototype);
$36b0160b69c700e9$export$2e2bcd8739ae039.prototype.name = "ManagedException";
$36b0160b69c700e9$export$2e2bcd8739ae039.prototype.isManagedException = true;
function $36b0160b69c700e9$export$611a7f3f5246b347(message = "common.errorHTTPSRequired") {
    this.message = message;
    this.stack = new Error().stack;
}
$36b0160b69c700e9$export$611a7f3f5246b347.prototype = Object.create($36b0160b69c700e9$export$2e2bcd8739ae039.prototype);
$36b0160b69c700e9$export$611a7f3f5246b347.prototype.name = "InsecureContextException";
function $36b0160b69c700e9$export$e8f9872b14f86ef1(message = "common.errorBrowserOutdated") {
    this.message = message;
    this.stack = new Error().stack;
}
$36b0160b69c700e9$export$e8f9872b14f86ef1.prototype = Object.create($36b0160b69c700e9$export$2e2bcd8739ae039.prototype);
$36b0160b69c700e9$export$e8f9872b14f86ef1.prototype.name = "OutdatedBrowserException";


function $afc0f64f9ee75755$export$734a2c99e8d09925(openIdConfigs) {
    $afc0f64f9ee75755$var$checkConfigStructure(openIdConfigs);
    this.openIdConfigs = openIdConfigs;
    // this.authClient = createOAuthClient(this.openIdConfigs);
    this.logger = new (0, $1c5d27fb6ee3c0b3$export$2e2bcd8739ae039)();
    this.authClients = {};
    this.getAuthClient = (clientId)=>{
        if (!this.authClients[clientId]) {
            const config = $afc0f64f9ee75755$var$findConfigByClientId(openIdConfigs, clientId);
            if (!config) throw new Error(`No configuration found for the specified clientId ${clientId}`);
            this.authClients[clientId] = (0, $76e3cae290f74ce7$export$d0d24bcc82916a99)(config);
        }
        return this.authClients[clientId];
    };
    this.login = async (clientId)=>{
        try {
            const tokens = await this.getAuthClient(clientId).login();
            localStorage.setItem("fcLogInOpenId", clientId);
            return tokens;
        } catch (error) {
            (0, $1c5d27fb6ee3c0b3$export$2e2bcd8739ae039).info(`Error occurred while loggin with the OAuth API : ${JSON.stringify(error)}`);
            if (error.xhr?.responseJSON?.error) throw new Error(`${error.xhr.responseJSON.error} : ${error.xhr.responseJSON.error_description}`);
            else throw error;
        }
    };
    this.getAccessToken = (clientId)=>this.getAuthClient(clientId).getAccessToken();
    this.isLoggedIn = async (clientId)=>await this.getAuthClient(clientId).isLoggedIn();
    this.logout = async ()=>{
        const loggedInClientId = localStorage.getItem("fcLogInOpenId");
        if (loggedInClientId) await this.getAuthClient(loggedInClientId).logout();
        else // attempt logout on each available authclient.
        Object.values(this.authClients).forEach(async (authclient1)=>await safeLogout(authclient1));
    };
    this.isOIDCRedirect = (clientId)=>{
        const config = $afc0f64f9ee75755$var$findConfigByClientId(this.openIdConfigs, clientId);
        const currentURL = window.location.toString();
        const containsRedirectURI = currentURL.indexOf(config.redirectUri) === 0;
        const hashOrSearch = $afc0f64f9ee75755$var$getHashOrSearch(config);
        return containsRedirectURI && !$afc0f64f9ee75755$var$hasFCErrorInUrl(hashOrSearch) && ($afc0f64f9ee75755$var$hasOpenIdErrorInUrl(hashOrSearch) || $afc0f64f9ee75755$var$hasAuthorizationCode(hashOrSearch));
    };
    this.safeLogout = async (authClient)=>{
        try {
            await authClient.logout();
        } catch (error) {
            this.logger(`Error trying to logout from client: ${authclient.OAuthConfig.clientId}. Error : ${error}`);
        }
    };
}
function $afc0f64f9ee75755$var$findConfigByClientId(openIdConfigs, clientId) {
    return openIdConfigs.find((config)=>config.clientId === clientId);
}
function $afc0f64f9ee75755$var$getHashOrSearch(OAuthConfig) {
    // var codeFlow = isCodeFlow(options); it's always code flow
    var useQuery = OAuthConfig?.responseMode !== "fragment";
    return useQuery ? window.location.search : window.location.hash;
}
function $afc0f64f9ee75755$var$hasOpenIdErrorInUrl(hashOrSearch) {
    return /(error=)/i.test(hashOrSearch) || /(error_description)/i.test(hashOrSearch);
}
function $afc0f64f9ee75755$var$hasFCErrorInUrl(hashOrSearch) {
    return /(fcerr=)/i.test(hashOrSearch);
}
function $afc0f64f9ee75755$var$hasAuthorizationCode(hashOrSearch) {
    return /(code=)/i.test(hashOrSearch);
}
function $afc0f64f9ee75755$var$checkConfigStructure(openIdConfigs) {
    if (!Array.isArray(openIdConfigs)) throw new Error("Please check the OpenID configurations in the loginPageConfig.js. It should be an array!");
    const configIds = openIdConfigs.map((config)=>config.clientId);
    if (configIds.length !== new Set(configIds).size) throw new Error("Please check the OpenID configurations in the loginPageConfig.js. A unique clientId must be specified for each openID server.");
    openIdConfigs.forEach((config)=>$afc0f64f9ee75755$var$doValidation(config));
}
function $afc0f64f9ee75755$var$doValidation(OAuthConfig) {
    $afc0f64f9ee75755$var$validateOAuthConfig(OAuthConfig);
    if (!$afc0f64f9ee75755$var$isBrowserContextSecure()) throw new (0, $36b0160b69c700e9$export$611a7f3f5246b347)();
    if (!$afc0f64f9ee75755$var$isPKCESupportedBytheBrowser()) throw new (0, $36b0160b69c700e9$export$e8f9872b14f86ef1)();
}
/**
 * Validates whether the provided OAuthConfig is valid.
 */ function $afc0f64f9ee75755$var$validateOAuthConfig(OAuthConfig) {
    const OAuthConfigError = "OAuth Configuration error: ";
    if (!OAuthConfig) throw new Error(`${OAuthConfigError} OAuth Configuration object is missing.`);
    const OAuthType = OAuthConfig.OAuthType;
    if (!OAuthType || !Object.values((0, $faa2ca7f56fbc6f0$export$4128a78c9389121b)).includes(OAuthType)) throw new Error(`${OAuthConfigError} Supplied OAuthType is not valid.`);
    // More validation to come
    if (!OAuthConfig.issuer) throw new Error(`${OAuthConfigError} Value for OAuth issuer is required.`);
    if (!OAuthConfig.clientId) throw new Error(`${OAuthConfigError} value for OAuth ClientId is required.`);
    if (!OAuthConfig.redirectUri) throw new Error(`${OAuthConfigError} value for OAuth redirectUri is required.`);
    if (!OAuthConfig.signoutRedirectUri) throw new Error(`${OAuthConfigError} value for OAuth signoutRedirectUri is required.`);
}
function $afc0f64f9ee75755$var$isBrowserContextSecure() {
    return window.isSecureContext || window.location.protocol === "https:";
}
function $afc0f64f9ee75755$var$isPKCESupportedBytheBrowser() {
    // According to the documentation on Okta JS, browsers need Crypto.sublte
    // and TextEncoder functionality
    const isCryptoSupported = typeof crypto !== "undefined" && crypto !== null && typeof crypto.subtle !== "undefined" && typeof Uint8Array !== "undefined";
    const hasTextEncoder = typeof TextEncoder !== "undefined";
    return isCryptoSupported && hasTextEncoder;
}




class $9fbfcff99571b238$export$2e2bcd8739ae039 {
    static storage = {
        transferAgent: {
            properties: {
                // Holds the amount of launches the user has initiated
                launches: "manualTALaunches",
                // Holds the amount of downloads the user has initiated
                downloads: "manualTADownloads"
            },
            /**
       * Get or set the amount of launches the user has initiated.
       *
       * @param  attempts {number} The new amount of launches that were initiated.
       * @return          {number} The current amount of launches that were initiated. If attempts parameter is
       *                           provided, it will return that number.
       */ launches: function(attempts) {
                return $9fbfcff99571b238$export$2e2bcd8739ae039.storage.transferAgent.persist($9fbfcff99571b238$export$2e2bcd8739ae039.storage.transferAgent.properties.launches, attempts);
            },
            /**
       * Get or set the amount of downloads the user has initiated.
       *
       * @param  attempts {number} The new amount of downloads that were initiated.
       * @return          {number} The current amount of downloads that were initiated. If attempts parameter is
       *                           provided, it will return that number.
       */ downloads: function(attempts) {
                return $9fbfcff99571b238$export$2e2bcd8739ae039.storage.transferAgent.persist($9fbfcff99571b238$export$2e2bcd8739ae039.storage.transferAgent.properties.downloads, attempts);
            },
            /**
       * Get or set a number persistence property.
       *
       * @param  property {string} The name of the persistence property to modify/retrieve.
       * @param  value    {number} The new value of the persistence property.
       * @return          {number} The current value of the persistence property. If the value parameter is
       *                           provided, it will return that number.
       */ persist: function(property, value) {
                var currentValue;
                if (value !== undefined) window.localStorage.setItem(property, value);
                currentValue = window.localStorage.getItem(property);
                if (currentValue !== null) currentValue = parseInt(currentValue);
                return currentValue;
            },
            /**
       * Forget amount of launches and downloads for TA by the user.
       */ reset: function() {
                window.localStorage.removeItem($9fbfcff99571b238$export$2e2bcd8739ae039.storage.transferAgent.properties.launches);
                window.localStorage.removeItem($9fbfcff99571b238$export$2e2bcd8739ae039.storage.transferAgent.properties.downloads);
            }
        }
    };
}









const $5164b71a901e55cc$export$3e5dac20ecd3882d = ()=>{
    if ($(".modal-upgradeAgent").find("#noShowCheckbox").is(":checked")) {
        (0, $e9be7d47ea4c0662$export$2e2bcd8739ae039).localConfig.declineUpgrade = (0, $e9be7d47ea4c0662$export$2e2bcd8739ae039).state.currentVersion;
        $.cookie("filecatalystLocalConfig", JSON.stringify((0, $e9be7d47ea4c0662$export$2e2bcd8739ae039).localConfig));
    }
};



class $1eca2a76dbd7310b$export$2e2bcd8739ae039 {
    static remoteServersProvided = ()=>{
        let provided = true;
        let remoteNodes = (0, $e836a774916461d1$export$54560c9971bc9b02)();
        for(let key in remoteNodes){
            let serverConf = remoteNodes[key];
            if (serverConf.pgpMessage.length <= 0) {
                if (serverConf.remoteServer.length <= 0) {
                    provided = false;
                    break;
                }
            }
        }
        return provided;
    };
    static versionCheck = (executeAfterVersionCheck, executeOnUpgradeIgnored)=>{
        let successHandler = function(data) {
            (0, $e9be7d47ea4c0662$export$2e2bcd8739ae039).state.currentVersion = JSON.stringify(data);
            (0, $64215f38d6524554$export$2e2bcd8739ae039).apiChecks(data);
            //update the service status of TA
            if ((0, $e9be7d47ea4c0662$export$2e2bcd8739ae039).available.serviceStatus) (0, $64215f38d6524554$export$2e2bcd8739ae039).checkRunningAsService((0, $64215f38d6524554$export$2e2bcd8739ae039).runningAsServiceStatusGetSet);
            if ((0, $e9be7d47ea4c0662$export$2e2bcd8739ae039).localConfig.declineUpgrade !== (0, $e9be7d47ea4c0662$export$2e2bcd8739ae039).state.currentVersion) {
                if ((0, $64215f38d6524554$export$2e2bcd8739ae039).compareVersion(data, (0, $e9be7d47ea4c0662$export$2e2bcd8739ae039).version) < 0) (0, $b4498450c1e534ee$export$2e2bcd8739ae039).upgrade(executeAfterVersionCheck, executeOnUpgradeIgnored);
                else executeAfterVersionCheck();
            } else executeAfterVersionCheck();
        };
        (0, $e9be7d47ea4c0662$export$2e2bcd8739ae039).getVersionAjax(successHandler);
    };
    static afterTaConfirmed = (executeAfterVersionCheck = ()=>true, upgradeIgnored = (0, $5164b71a901e55cc$export$3e5dac20ecd3882d))=>{
        // pg.launcher has to exist. If it doesn't, none of this works anyhow.
        (0, $f43e938a8b65a516$export$2e2bcd8739ae039).setLocal("ta_found", "true");
        (0, $e9be7d47ea4c0662$export$2e2bcd8739ae039).state.applicationLaunched = true;
        // Check version
        // **** important: versionCheck is a gatekeeper! It will continue initialization
        // **** once user has downloaded or declined!
        $1eca2a76dbd7310b$export$2e2bcd8739ae039.versionCheck(executeAfterVersionCheck, upgradeIgnored);
    };
}



class $c07b7ff6aaef734d$export$2e2bcd8739ae039 {
    static hooks = {
        launch: undefined,
        launchFailed: undefined,
        download: undefined,
        downloadImage: undefined,
        manualUpdate: undefined
    };
    /**
   * Download modal. This is meant to be shown when the transfer agent is being downloaded. It will show different
   * download screenshots to make sure people know where to find their download from the browser.
   *
   * @param {method} callback
   */ static manualDownload = (isUpgrade, callback)=>{
        let downloadImage = new Image();
        let downloadImageURL = "../../images/";
        let downloadImageURLLarge = "../../images/";
        let downloadImageStartSmall = '<img id="image-manualDownload" alt="' + (0, $01f9c2ffd7693c68$export$2e2bcd8739ae039).t("webDeployment.manualDownloadTitle") + '" src="';
        let downloadImageStartLarge = '<img alt="' + (0, $01f9c2ffd7693c68$export$2e2bcd8739ae039).t("webDeployment.manualDownloadTitle") + '" src="';
        let downloadImageEnd = '" />';
        switch(Browser.info().name){
            case "chrome":
                downloadImageURL += "download_chrome_small.png";
                downloadImageURLLarge += "download_chrome_large.png";
                break;
            case "firefox":
                downloadImageURL += "download_firefox_small.png";
                downloadImageURLLarge += "download_firefox_large.png";
                break;
            case "ie":
                downloadImageURL += "download_ie_small.png";
                downloadImageURLLarge += "download_ie_large.png";
                break;
            case "edge":
                downloadImageURL += "download_edge_small.png";
                downloadImageURLLarge += "download_edge_large.png";
                break;
            case "safari":
                downloadImageURL += "download_safari_small.png";
                downloadImageURLLarge += "download_safari_large.png";
                break;
            default:
                downloadImageURL = "";
                downloadImageURLLarge = "";
                downloadImageStartSmall = "";
                downloadImageStartLarge = "";
                downloadImageEnd = "";
        }
        downloadImage.src = downloadImageURL;
        if (callback !== undefined) downloadImage.addEventListener("load", function() {
            callback();
        });
        $c07b7ff6aaef734d$export$2e2bcd8739ae039.hooks.download = $c07b7ff6aaef734d$export$2e2bcd8739ae039.dialog({
            message: isUpgrade ? (0, $01f9c2ffd7693c68$export$2e2bcd8739ae039).t("webDeployment.manualDownloadMsg") : (0, $01f9c2ffd7693c68$export$2e2bcd8739ae039).t("webDeployment.manualDownloadMsgForUpgrade") + "<br /><br />" + (0, $01f9c2ffd7693c68$export$2e2bcd8739ae039).t("common.installDocIntro") + '<a href="' + (0, $64215f38d6524554$export$2e2bcd8739ae039).getLinkForOS("installDoc") + '" id="revealDoc" target="_blank">' + (0, $01f9c2ffd7693c68$export$2e2bcd8739ae039).t("common.installDocDescription") + "</a><br /><br />" + downloadImageStartSmall + downloadImageURL + downloadImageEnd,
            title: (0, $01f9c2ffd7693c68$export$2e2bcd8739ae039).t("webDeployment.manualDownloadTitle"),
            className: "modal-manualDownload",
            closeButton: false,
            buttons: {}
        });
        $("#image-manualDownload").on("click", function() {
            // Open a larger dialog with a larger view of the image.
            $c07b7ff6aaef734d$export$2e2bcd8739ae039.hooks.downloadImage = $c07b7ff6aaef734d$export$2e2bcd8739ae039.dialog({
                message: downloadImageStartLarge + downloadImageURLLarge + downloadImageEnd,
                className: "modal-manualDownloadImage"
            });
            $(".modal-manualDownloadImage img").on("click", function() {
                $c07b7ff6aaef734d$export$2e2bcd8739ae039.hooks.downloadImage.modal("hide");
            });
        });
        (0, $64215f38d6524554$export$2e2bcd8739ae039).state.refreshWarning = true;
    };
    static handlers = {
        download: ()=>{
            if ($c07b7ff6aaef734d$export$2e2bcd8739ae039.hooks.launch !== undefined) $c07b7ff6aaef734d$export$2e2bcd8739ae039.hooks.launch.modal("hide");
            if ($c07b7ff6aaef734d$export$2e2bcd8739ae039.hooks.launchFailed !== undefined) $c07b7ff6aaef734d$export$2e2bcd8739ae039.hooks.launchFailed.modal("hide");
            if ($c07b7ff6aaef734d$export$2e2bcd8739ae039.hooks.manualUpdate !== undefined) $c07b7ff6aaef734d$export$2e2bcd8739ae039.hooks.manualUpdate.modal("hide");
            (0, $f43e938a8b65a516$export$2e2bcd8739ae039).pollHeartbeat().then(()=>{
                $c07b7ff6aaef734d$export$2e2bcd8739ae039.hooks.download.modal("hide");
                $c07b7ff6aaef734d$export$2e2bcd8739ae039.spinnerScreen(false, "waiting");
                window.location.reload(); // This may be incorrect?? How to let the React App know to reload?
            }).catch((err)=>{
                $c07b7ff6aaef734d$export$2e2bcd8739ae039.hooks.download.modal("hide");
                $c07b7ff6aaef734d$export$2e2bcd8739ae039.spinnerScreen(false, "waiting");
                // needs a time buffer or will collide with closing
                // dialogs. In theory, could instead listen to the close
                // event on outstanding dialogs.
                setTimeout(function() {
                    $c07b7ff6aaef734d$export$2e2bcd8739ae039.launchFailed();
                }, 500);
            });
            $c07b7ff6aaef734d$export$2e2bcd8739ae039.manualDownload(false, function() {
                // Make sure the download of the application happens after the modal loads (Safari-specific issue):
                window.location = (0, $64215f38d6524554$export$2e2bcd8739ae039).getLinkForOS("download");
            });
            $c07b7ff6aaef734d$export$2e2bcd8739ae039.spinnerScreen(true, "waiting");
            return false;
        }
    };
    static screenSpinnerQueue = [];
    static spinnerScreen = (makeVisible, type)=>{
        (0, $01f9c2ffd7693c68$export$2d3542df2a1993a).then(()=>{
            let $spinContainer = $(".spinContainer");
            let $spinBack = $(".spinBack");
            if (typeof makeVisible === "undefined") makeVisible = true;
            if (typeof makeVisible === "string") {
                type = makeVisible;
                makeVisible = true;
            }
            if (makeVisible) {
                if ($spinContainer.length <= 0) {
                    $spinContainer = $('<div class="spinContainer"/>');
                    $spinBack = $('<div class="spinBack modal-backdrop in"/>');
                    $spinBack.appendTo($spinContainer);
                    $spinBack.after('<div class="spinnerWidget"><div class="spinner"></div></div>');
                    $spinContainer.appendTo("body");
                } // only record and append new text instance if one doesn't already exist
                if ($c07b7ff6aaef734d$export$2e2bcd8739ae039.screenSpinnerQueue.indexOf(type) === -1) {
                    $c07b7ff6aaef734d$export$2e2bcd8739ae039.screenSpinnerQueue.push(type);
                    let titleSpinner = (0, $01f9c2ffd7693c68$export$2e2bcd8739ae039).t("common.spinner." + type);
                    if (titleSpinner === "") titleSpinner = "Loading Resources";
                    $spinContainer.find(".spinner").after('<div class="spinnerText ' + type + '">' + titleSpinner + "</div>");
                }
            } else {
                $spinContainer.find("." + type).remove();
                let typePos = $c07b7ff6aaef734d$export$2e2bcd8739ae039.screenSpinnerQueue.indexOf(type);
                if (~typePos) $c07b7ff6aaef734d$export$2e2bcd8739ae039.screenSpinnerQueue.splice(typePos, 1);
                if ($c07b7ff6aaef734d$export$2e2bcd8739ae039.screenSpinnerQueue.length <= 0) $spinContainer.remove();
            }
        });
    };
    static alert = (msg)=>{
        return bootbox.dialog({
            className: "fc-ta-dialog",
            message: msg,
            buttons: {
                ok: {
                    label: "OK",
                    callback: function() {}
                }
            }
        });
    };
    static dialog = (message, opts)=>{
        let modal = undefined;
        if (typeof message === "object" && typeof opts === "undefined") opts = message;
        if (typeof opts === "undefined") modal = $c07b7ff6aaef734d$export$2e2bcd8739ae039.alert(message);
        else {
            if (typeof opts.message === "undefined" || opts.message === null || opts.message === "") opts.message = message;
            // sanity check for existing identical dialog
            if (opts.className) {
                let $dialog = $("." + opts.className);
                if ($dialog.length > 0) {
                    let $body = $dialog.find(".modal-body>div");
                    if ($body.find(".dialogWarning").length <= 0) $body.prepend('<p class="alert alert-danger dialogWarning"><em>' + (0, $01f9c2ffd7693c68$export$2e2bcd8739ae039).t("common.retryDialogMsg") + "</em></p>");
                    else {
                        let $numWarns = $body.find(".dialogRepeats");
                        if ($numWarns.length <= 0) $body.find(".dialogWarning").prepend('(<span class="dialogRepeats">2</span>)');
                        else {
                            let currentVal = parseInt($numWarns.text());
                            currentVal++;
                            $numWarns.text(currentVal);
                        }
                    }
                } else {
                    opts.className += " fc-ta-dialog";
                    modal = bootbox.dialog(opts);
                }
            }
        }
        // Returning reference to the modal we've created, so we don't have to look for it later.
        // Since this happens every time the modal is opened, the hook is self-updating.
        return modal;
    };
    static launchFailed = ()=>{
        let uniqueClass = "modal-launchFailed";
        let bodyMessage = '<p class="large-font-paragraph">' + (0, $01f9c2ffd7693c68$export$2e2bcd8739ae039).t("common.warningLaunchFailed") + "</p>";
        if ((0, $64215f38d6524554$export$2e2bcd8739ae039).detectOS() === "linux") bodyMessage = '<p class="large-font-paragraph">' + (0, $01f9c2ffd7693c68$export$2e2bcd8739ae039).t("common.warningLaunchFailedLinux").replace("__refresh__", (0, $01f9c2ffd7693c68$export$2e2bcd8739ae039).t("common.launchFailRefreshButton")) + "</p>";
        else {
            bodyMessage += '<ul id="advancedOptionsSteps">';
            bodyMessage += "<li>" + (0, $01f9c2ffd7693c68$export$2e2bcd8739ae039).t("common.warningLaunchFailedReason1") + "</li>";
            bodyMessage += "<li>" + (0, $01f9c2ffd7693c68$export$2e2bcd8739ae039).t("common.warningLaunchFailedReason2") + "</li>";
            bodyMessage += "<li>" + (0, $01f9c2ffd7693c68$export$2e2bcd8739ae039).t("common.warningLaunchFailedReason3") + "</li>";
            bodyMessage += "<li>" + (0, $01f9c2ffd7693c68$export$2e2bcd8739ae039).t("common.warningLaunchFailedReason4") + "</li>";
            bodyMessage += "</ul>";
        }
        bodyMessage += '<a class="collapsed" data-toggle="collapse" href="#advancedLaunch" aria-expanded="false" aria-controls="advancedLaunch">';
        bodyMessage += (0, $01f9c2ffd7693c68$export$2e2bcd8739ae039).t("common.manualLaunchAdvancedLabel") + ' <span class="caret"></span></a>';
        bodyMessage += '<div class="panel-collapse collapse" id="advancedLaunch"><div class="well">';
        bodyMessage += '<form class="form-horizontal"><div class="control-group"><fieldset><div class="control-group"><label class="control-label" for="portValue">' + (0, $01f9c2ffd7693c68$export$2e2bcd8739ae039).t("common.portNotFoundFieldLabel") + "</label>" + "&nbsp;&nbsp;" + '<input id="portValueRenew" name="portValueRenew" type="text" class="input-xlarge" value="' + (0, $64215f38d6524554$export$2e2bcd8739ae039).getPortToListen() + '"></div></fieldset></div></form></div></div>';
        $c07b7ff6aaef734d$export$2e2bcd8739ae039.spinnerScreen(false, "heartbeat");
        $c07b7ff6aaef734d$export$2e2bcd8739ae039.spinnerScreen(false, "launch");
        let dialogOptions = {
            message: bodyMessage,
            title: (0, $01f9c2ffd7693c68$export$2e2bcd8739ae039).t("common.agentNotFoundTitle"),
            className: uniqueClass,
            buttons: {
                download: {
                    label: (0, $01f9c2ffd7693c68$export$2e2bcd8739ae039).t("common.warningLaunchFailedReason1Link"),
                    className: "btn-link btn-sm",
                    callback: $c07b7ff6aaef734d$export$2e2bcd8739ae039.handlers.download
                },
                applyNewPort: {
                    label: (0, $01f9c2ffd7693c68$export$2e2bcd8739ae039).t("common.applyNewPort") + '&nbsp;&nbsp;<i class="fa fa-check" aria-hidden="true"></i>',
                    className: "btn-warning btn-refresh btn-sm",
                    callback: function() {
                        (0, $64215f38d6524554$export$2e2bcd8739ae039).setPortToListen($("#portValueRenew").val());
                        window.location.reload(true);
                        return false;
                    }
                },
                refresh: {
                    label: (0, $01f9c2ffd7693c68$export$2e2bcd8739ae039).t("common.launchFailRefreshButton") + '&nbsp;&nbsp;<i class="fa fa-refresh"></i>',
                    className: "btn-success btn-refresh btn-sm",
                    callback: function() {
                        location.reload();
                        return false;
                    }
                }
            }
        };
        // If we haven't downloaded before, reset the localStorage.
        if ((0, $9fbfcff99571b238$export$2e2bcd8739ae039).storage.transferAgent.downloads() < 1) (0, $64215f38d6524554$export$2e2bcd8739ae039).localStorageConfiguration.resetLocalStorage("filecatalystLocalConfig");
        bootbox.hideAll();
        $c07b7ff6aaef734d$export$2e2bcd8739ae039.hooks.launchFailed = $c07b7ff6aaef734d$export$2e2bcd8739ae039.dialog(dialogOptions);
    };
    static download = (isUpgrade, executeAfterVersionCheck = ()=>true, upgradeIgnored = (0, $5164b71a901e55cc$export$3e5dac20ecd3882d))=>{
        (0, $e9be7d47ea4c0662$export$2e2bcd8739ae039).clearModals();
        // Start checking for heartbeat, but without launch. The installation
        // process, when successful and when selected by user, will do the launch.
        // Default duration is set in http_launcher.js
        if (!isUpgrade) (0, $f43e938a8b65a516$export$2e2bcd8739ae039).pollHeartbeat().then(function() {
            // AfterTA confirmed takes in executeAfterVersionCheck and executeIfUpgradeIgnored.
            // But if you are dpwnloadinf the TA you'd be downloading the latest one so default behaviour is okay.
            (0, $1eca2a76dbd7310b$export$2e2bcd8739ae039).afterTaConfirmed(executeAfterVersionCheck, upgradeIgnored);
            $c07b7ff6aaef734d$export$2e2bcd8739ae039.taLaunchVisualCleanup();
        }).catch(function() {
            $(".modal-manualDownload").modal("hide");
            $c07b7ff6aaef734d$export$2e2bcd8739ae039.launchFailed();
        // or see if there is a "installation timed out" type dialog
        });
        // Show the download modal.
        $c07b7ff6aaef734d$export$2e2bcd8739ae039.manualDownload(isUpgrade, function() {
            // Make sure the download of the application happens _after_ the modal loads (Safari-specific issue).
            // this is accomplished by sending the redirect as a callback to the manualDownload dialog:
            window.location = (0, $64215f38d6524554$export$2e2bcd8739ae039).getLinkForOS("download");
        });
        $c07b7ff6aaef734d$export$2e2bcd8739ae039.spinnerScreen(true, "waiting");
        return false;
    };
    static upgrade = (onEscape = ()=>true, onIgnore = ()=>true)=>{
        // create an interactive dialog for when TransferAgent is not detected
        let uniqueClass = "modal-upgradeAgent";
        let bodyMessage = "<p>" + (0, $01f9c2ffd7693c68$export$2e2bcd8739ae039).t("webDeployment.upgradeJSisNewer") + ' <a href="#" onclick="javascript: window.location.reload(true);">' + '<i class="fa fa-refresh"></i></a>' + "</p>";
        bodyMessage += '<p><form class="form-horizontal"><div class="control-group"><label class="checkbox" for="noShowCheckbox"><input type="checkbox" name="checkboxes" id="noShowCheckbox">' + (0, $01f9c2ffd7693c68$export$2e2bcd8739ae039).t("webDeployment.doNotShowAgainCheckbox") + "</label>" + "</div>" + "</form></p>";
        let dialogOptions = {
            message: bodyMessage,
            title: (0, $01f9c2ffd7693c68$export$2e2bcd8739ae039).t("webDeployment.upgradeTitle"),
            className: uniqueClass,
            onEscape: onEscape,
            buttons: {
                download: {
                    label: (0, $01f9c2ffd7693c68$export$2e2bcd8739ae039).t("webDeployment.agentNotFoundButtonDownload") + "&nbsp;&nbsp;" + (0, $e9be7d47ea4c0662$export$2e2bcd8739ae039).icon[(0, $e9be7d47ea4c0662$export$2e2bcd8739ae039).icon.currentset].download,
                    className: "btn-info btn-download",
                    callback: ()=>$c07b7ff6aaef734d$export$2e2bcd8739ae039.download(true, onEscape, onIgnore)
                },
                ignore: {
                    label: (0, $01f9c2ffd7693c68$export$2e2bcd8739ae039).t("webDeployment.upgradeButtonIgnore") + "&nbsp;&nbsp;" + (0, $e9be7d47ea4c0662$export$2e2bcd8739ae039).icon[(0, $e9be7d47ea4c0662$export$2e2bcd8739ae039).icon.currentset].remove,
                    className: "btn-danger btn-cancel",
                    callback: onIgnore
                }
            }
        };
        (0, $e9be7d47ea4c0662$export$2e2bcd8739ae039).dialog.hooks.upgrade = $c07b7ff6aaef734d$export$2e2bcd8739ae039.dialog(dialogOptions);
    };
    // AfterTA confirmed takes in executeAfterVersionCheck and executeIfUpgradeIgnored.
    // if used from anywhere else but the login page. This call needs to be modiffied to take in
    // executeAfterVersionCheck and executeIfUpgradeIgnored so it can be passed to afterTaConfirmed.
    static launch = (executeAfterVersionCheck = ()=>true, upgradeIgnored = (0, $5164b71a901e55cc$export$3e5dac20ecd3882d))=>{
        $c07b7ff6aaef734d$export$2e2bcd8739ae039.spinnerScreen(true, "heartbeat");
        // use the HTTP_Launcher instance to launch. If this has not
        // been initialized, we will fail. Need a way to check for status.
        // The user is confirming that they have installed TA, so whether
        // they are correct or not, reduce the default polling length to 20s
        (0, $f43e938a8b65a516$export$2e2bcd8739ae039).launch().pollHeartbeat(20000).then(function() {
            (0, $1eca2a76dbd7310b$export$2e2bcd8739ae039).afterTaConfirmed(executeAfterVersionCheck, upgradeIgnored);
            $c07b7ff6aaef734d$export$2e2bcd8739ae039.taLaunchVisualCleanup();
        }).catch(function() {
            // if it didn't work, show dialog again
            $c07b7ff6aaef734d$export$2e2bcd8739ae039.manualLaunch(executeAfterVersionCheck, upgradeIgnored);
        }).finally(function() {
            // no matter what, stop the spinner
            $c07b7ff6aaef734d$export$2e2bcd8739ae039.spinnerScreen(false, "heartbeat");
        });
        (0, $e9be7d47ea4c0662$export$2e2bcd8739ae039).dialog.hooks.launch.modal("hide");
        // Don't close the modal. It is to be closed by the next successful heartbeat/poll.
        return false;
    };
    static manualLaunch = (executeAfterVersionCheck = ()=>true, upgradeIgnored = (0, $5164b71a901e55cc$export$3e5dac20ecd3882d))=>{
        let isLinux = (0, $64215f38d6524554$export$2e2bcd8739ae039).detectOS() === "linux";
        let taPort = (0, $f43e938a8b65a516$export$2e2bcd8739ae039).getLocal("port");
        let dialogVisible = $(".modal-manualLaunch").length > 0 ? true : false;
        let browser = Browser.info().name;
        let uniqueClass = "modal-manualLaunch";
        let bodyMessage = "<p>" + makeLaunchMsg() + "</p>";
        if ($(".modal-manualDownload").length > 0) // Our download modal is opened, so don't show the first one again.
        return;
        /**
     * Assemble launch message.
     */ function makeLaunchMsg() {
            let initMsg = (0, $01f9c2ffd7693c68$export$2e2bcd8739ae039).t("webDeployment.manualLaunchMsg");
            // store links that may get used;
            let tryLink = '<a href="#" id="launchTryAgain">' + (0, $01f9c2ffd7693c68$export$2e2bcd8739ae039).t("webDeployment.manualLaunchTryAgain") + "</a>";
            let downLink = '<a href="#" id="launchDownload">' + (0, $01f9c2ffd7693c68$export$2e2bcd8739ae039).t("webDeployment.manualLaunchDownload") + "</a>";
            let installGuideLink = '<a href="' + (0, $64215f38d6524554$export$2e2bcd8739ae039).getLinkForOS("installDoc") + '" id="revealDoc" target="_blank">' + (0, $01f9c2ffd7693c68$export$2e2bcd8739ae039).t("common.installDocDescription") + "</a>";
            // select an appropriate manual launch message
            if (isLinux) initMsg = (0, $01f9c2ffd7693c68$export$2e2bcd8739ae039).t("webDeployment.manualLaunchMsgLinux");
            let msg = initMsg.replace("__tryAgain__", tryLink).replace("__download__", downLink);
            msg += "<p>" + (0, $01f9c2ffd7693c68$export$2e2bcd8739ae039).t("common.installDocIntro") + installGuideLink + "</p>";
            //wire up the click handlers.
            $(document).on("click", "#launchTryAgain", function(e) {
                e.preventDefault();
                $c07b7ff6aaef734d$export$2e2bcd8739ae039.launch(executeAfterVersionCheck, upgradeIgnored);
            });
            $(document).off("click", "#launchDownload");
            $(document).on("click", "#launchDownload", function(e) {
                e.preventDefault();
                $c07b7ff6aaef734d$export$2e2bcd8739ae039.download(false, executeAfterVersionCheck, upgradeIgnored);
            });
            $(document).off("change", "#portValue");
            $(document).on("change", "#portValue", function() {
                (0, $64215f38d6524554$export$2e2bcd8739ae039).setPortToListen($(this).val());
            });
            return msg;
        }
        if (!dialogVisible) {
            // create an interactive dialog for manually configuring the TransferAgent
            if (browser === "ie" || browser === "edge") bodyMessage += "<p>" + (0, $01f9c2ffd7693c68$export$2e2bcd8739ae039).t("webDeployment.internetExplorerConfig") + "</p>";
            bodyMessage += '<a data-toggle="collapse" href="#advancedLaunch" aria-expanded="false" aria-controls="advancedLaunch">' + (0, $01f9c2ffd7693c68$export$2e2bcd8739ae039).t("webDeployment.manualLaunchAdvancedLabel") + ' <span class="caret"></span></a>' + '<div class="collapse" id="advancedLaunch"><div class="well"><form class="form-horizontal"><fieldset>' + '<div class="control-group"><label class="control-label" for="portValue">' + (0, $01f9c2ffd7693c68$export$2e2bcd8739ae039).t("webDeployment.portNotFoundFieldLabel") + "</label>&nbsp;&nbsp;" + '<input id="portValue" name="portValue" type="text" class="input-xlarge" value="' + taPort + '"></div>' + "</fieldset></form></div></div>";
            let dialogOptions = {
                message: bodyMessage,
                title: (0, $01f9c2ffd7693c68$export$2e2bcd8739ae039).t("webDeployment.manualLaunchTitle"),
                className: uniqueClass,
                closeButton: false,
                buttons: {}
            };
            // We don't show the launch button on Linux.
            if (!isLinux) dialogOptions.buttons.launch = {
                label: (0, $01f9c2ffd7693c68$export$2e2bcd8739ae039).t("webDeployment.manualLaunchButton"),
                className: "btn-link btn-confirm",
                callback: ()=>{
                    $c07b7ff6aaef734d$export$2e2bcd8739ae039.launch(executeAfterVersionCheck, upgradeIgnored);
                }
            };
            dialogOptions.buttons.download = {
                label: (0, $01f9c2ffd7693c68$export$2e2bcd8739ae039).t("webDeployment.agentNotFoundButtonDownload") + "&nbsp;&nbsp;" + (0, $e9be7d47ea4c0662$export$2e2bcd8739ae039).icon[(0, $e9be7d47ea4c0662$export$2e2bcd8739ae039).icon.currentset].download,
                className: "btn-success btn-download",
                callback: ()=>$c07b7ff6aaef734d$export$2e2bcd8739ae039.download(false, executeAfterVersionCheck, upgradeIgnored)
            };
            (0, $e9be7d47ea4c0662$export$2e2bcd8739ae039).dialog.hooks.launch = $c07b7ff6aaef734d$export$2e2bcd8739ae039.dialog(dialogOptions);
        }
    };
    static taLaunchVisualCleanup = ()=>{
        $(".help-anchor").attr("href", (0, $e9be7d47ea4c0662$export$2e2bcd8739ae039).baseUrl("help", undefined, true) + "help/TransferAgent/help.html#webui");
        $(".modal-manualLaunch").modal("hide");
        $(".modal-manualDownload").modal("hide");
        $c07b7ff6aaef734d$export$2e2bcd8739ae039.spinnerScreen(false, "heartbeat");
        $c07b7ff6aaef734d$export$2e2bcd8739ae039.spinnerScreen(false, "waiting");
        $c07b7ff6aaef734d$export$2e2bcd8739ae039.spinnerScreen(false, "initializing");
    };
    static growl = (message, placeHolderMap, options)=>{
        (0, $01f9c2ffd7693c68$export$2d3542df2a1993a).then(()=>{
            const translatedMessage = (0, $01f9c2ffd7693c68$export$2e2bcd8739ae039).t(`${message}`, placeHolderMap);
            console.log(`Translated message is : ${translatedMessage}`);
            $.notify({
                message: translatedMessage
            }, {
                ...options
            });
        });
    };
}


let $377959a7b0bd1524$var$oAuthAPIInstance = undefined;
try {
    $377959a7b0bd1524$var$oAuthAPIInstance = new (0, $afc0f64f9ee75755$export$734a2c99e8d09925)(OAuthConfigs);
} catch (error) {
    if (error.isManagedException && $377959a7b0bd1524$export$44dd05193c17ce84(OAuthConfigs)) (0, $c07b7ff6aaef734d$export$2e2bcd8739ae039).growl(error.message, {
        feature: "OpenID Authentication"
    }, {
        type: "danger",
        delay: 0
    });
    console.error(`Ran into errors while creating OAuthAPI instance. ${error}`);
}
function $377959a7b0bd1524$export$44dd05193c17ce84(OAuthConfigs1) {
    return OAuthConfigs1.some((oAuthObj)=>!_.isEmpty(oAuthObj.clientId));
}
var $377959a7b0bd1524$export$2e2bcd8739ae039 = $377959a7b0bd1524$var$oAuthAPIInstance;



var $glDqU = parcelRequire("glDqU");
function $e836a774916461d1$export$54560c9971bc9b02() {
    if ($e836a774916461d1$var$useLoginConfig()) return remoteNodes;
    else return pg?.config?.remoteNodes;
}
function $e836a774916461d1$export$7ceeb2067f6edf7f() {
    if ($e836a774916461d1$var$useLoginConfig()) return remoteNodes?.server1;
    else return pg?.config?.remoteNodes?.server1;
}
function $e836a774916461d1$export$b8c7477dd561ed36() {
    if ($e836a774916461d1$var$useLoginConfig()) return localHostproxy;
    else return pg?.config?.proxy;
}
function $e836a774916461d1$export$e5c213ebaabfe93a() {
    if ($e836a774916461d1$var$useLoginConfig()) return localAgent;
    else return pg?.config?.localAgent;
}
function $e836a774916461d1$var$useLoginConfig() {
    return (0, $377959a7b0bd1524$export$44dd05193c17ce84)(OAuthConfigs) || !(0, $glDqU.isEmpty)(remoteNodes?.server1.remoteServer);
}


/**
 * Create a URL needed by the HTTP_Launcher constructor, then
 * create the launcher.
 */ let $a1d35d9d46ea887a$var$localAgent = (0, $e836a774916461d1$export$e5c213ebaabfe93a)();
let $a1d35d9d46ea887a$export$235b59c0b6725bc2 = $a1d35d9d46ea887a$var$localAgent.ssl == true ? "https://" : "http://";
$a1d35d9d46ea887a$export$235b59c0b6725bc2 += $a1d35d9d46ea887a$var$localAgent.host + ":" + $a1d35d9d46ea887a$var$localAgent.portDefault;


"use strict";
/* ---------------------------------------------------IMPORTS IN WAITING------------------------------------------------------
 *                                (functions that SHOULD by all rights be imported modules)                                 */ // generate a (usually) 9-digit string of numbers and letters
// https://gist.github.com/gordonbrander/2230317
const $2180970a0cc820db$var$uniqueID = function(prefix = "_") {
    return prefix + Math.random().toString(36).substr(2, 9);
};
// simple sanity-checker. Other types of "objects" to not stringify to [object Object],
// for example arrays are typeof "object" but do not pass this check.
const $2180970a0cc820db$var$isPlainObject = function(obj) {
    return Object.prototype.toString.call(obj) === "[object Object]";
};
// Promise.any polyfill
// https://github.com/ungap/promise-any
var $2180970a0cc820db$var$any = (Promise.any || function($1) {
    return new Promise(function(D, E, A, L) {
        A = [];
        L = $1.map(function($1, i) {
            return Promise.resolve($1).then(D, function(O) {
                return (A[i] = O, --L) || E({
                    errors: A
                });
            });
        }).length;
    });
}).bind(Promise);
class $2180970a0cc820db$export$2e2bcd8739ae039 {
    /**
   *
   * @param {Array.<String>}  urls        - An array of URL strings for the launcher to test heartbeat on.
   * @param {Object}          proxy       - Object literal configuring the fallback proxy (for when localhost not available)
   *                                        NOTE: a future refactor could normalize and use fake overloading to utilize array of proxies.
   * @param {Object}          pollConfig  - Plain object of config params to control polling mechanism (graceTime, maxTime, preferProxy)
   */ constructor(urls, proxy, pollConfig){
        // sanity check urls for being an array; when single url, a string is permitted
        if (typeof urls === "string") urls = [
            urls
        ];
        // store the values passed in from the constructor call and eliminate undefined error on them
        this.urls = urls || [];
        this.proxy = proxy || {};
        this.pollConfig = pollConfig || {};
        this.basePath = "";
        // other properties that we are going to keep track of or use during launch process
        this.heartbeatStartTime = null;
        this.foundHeartbeat = false;
        this.protocolHandlerURL = "filecatalyst://localhost";
        this.launchErrors = new Set();
        // prepare an internal state object with defaults, mainly for retrieving from localStorage
        this.defaultProperties = {
            ta_found: false,
            port: this.getDefaultPort()
        };
        // establish proxy defaults and then merge them with values passed in
        const proxyDefaults = {
            proxyID: this.getLocal("proxyID") || $2180970a0cc820db$var$uniqueID(),
            proxyHost: "",
            proxyPort: 8080,
            proxySSL: false,
            proxyPath: "/servlet/atmosphere"
        };
        // if we have supplied a proxy, replace the empty object with a merged
        // proxy + defaults object.
        if ($2180970a0cc820db$var$isPlainObject(this.proxy)) this.proxy = Object.assign(proxyDefaults, this.proxy);
        // establish polling options and then merge them with values passed in
        // if isCentral is not explicitly passed in, we check for existence of nodeID
        // within a centralNewHost object if one is found. This is potentially stomped by
        // passed-in config object
        const pollConfigDefaults = {
            graceTime: 2000,
            maxTime: 60000,
            preferProxy: false,
            isCentral: function() {
                return typeof centralNewHost !== "undefined" && centralNewHost.nodeID.length > 0;
            }()
        };
        if ($2180970a0cc820db$var$isPlainObject(this.pollConfig)) this.pollConfig = Object.assign(pollConfigDefaults, this.pollConfig);
        /**
     * updateProtocolHandlerURL builds, stores (this.protocolHandlerURL) and returns a URL
     * for initializing the protocol handler. Must check for valid proxy values before
     * bothering; otherwise the protocolHandlerURL stays in default mode and is returned.
     *
     * This is defined in the constructor because we need it for construction.
     *
     * @param {Object} [proxyParams] - Optionally pass in new proxy parameters to update the
     *                                 protocol handler URL. If not supplied, use the ones
     *                                 from when object was constructed.
     */ this.updateProtocolHandlerURL = function(proxyParams) {
            // cache the instance object to crush scope confusion of "this" for utilities
            const myself = this;
            // merge incoming proxy paramaters into the ones stored in the instance.
            // Note that Object.assign updates the target (myself.proxy) and returns it
            let proxy = Object.assign(myself.proxy, proxyParams);
            // only paramaterize the proxy if one exists.
            if (myself._validProxy(proxy)) {
                let url = myself.protocolHandlerURL + "?";
                // we need to append the term "websocket" to proxyPath
                let proxyCopy = Object.assign({}, proxy);
                proxyCopy.proxyPath += proxyCopy.proxyPath.charAt(proxyCopy.proxyPath.length - 1) == "/" ? "" : "/";
                proxyCopy.proxyPath += "websocket";
                // proxyCopy is updated; supply it as query string
                url += new URLSearchParams(proxyCopy).toString();
                // update the stored URL in case we need it again
                myself.protocolHandlerURL = url;
            }
            // might as well return the updated URL as well
            return myself.protocolHandlerURL;
        };
        // for a proxy to be valid, it must have a hostname and port.
        this._validProxy = function(proxy = this.proxy) {
            let valid = true;
            if (typeof proxy.proxyHost !== "string" || typeof proxy.proxyPort !== "number" || proxy.proxyPath.length <= 0) valid = false;
            return valid;
        };
        // conditionally run the update method, which may produce a new protocolHandlerURL
        if (this._validProxy()) this.updateProtocolHandlerURL(this.proxy);
    }
    // ----------------------- end constructor -------------------------
    // ----------------------- UTILITIES -------------------------------
    /**
   * A setter for the TransferAgent launcher properties. We use localStorage with a stringified object
   * stored at ta_properties as the source of truth. All setting and getting goes through this localStorage
   * entry.
   *
   * The method is defined in the constructor because we need it during construction.
   * @param {String}  key     - A key for a property to store within ta_properties in localStorage
   * @param {String}  value   - The value for the key being stored within ta_properties
   */ setLocal(key, value) {
        // use localStorage as the source of truth, or grab defaults
        let properties = JSON.parse(localStorage.getItem("ta_properties")) || this.defaultProperties;
        properties = properties ? properties : {};
        // merge in the defaults; worst-case scenario, this is redundant.
        properties = this.defaultProperties ? Object.assign(this.defaultProperties, properties) : properties;
        // if we have passed in a key/value, we need to update the local object
        // before storing it. Otherwise, just store the current object
        if (typeof key === "string" && typeof value !== "undefined") properties[key] = value;
        // store the memory object, whether it was modified or not
        localStorage.setItem("ta_properties", JSON.stringify(properties));
        // might as well return a copy of the properties
        return properties;
    }
    /**
   * A getter for the TransferAgent launcher properties, using localStorage entry "ta_properties", which
   * is treated as the source of truth. Will either dig out a particular value based on key, or return all
   * of ta_properties.
   *
   * The method is defined in the constructor because we need it during construction.
   *
   * @param {String}  key -   The key used to find a value stored within ta_properties. If not provided,
   *                          will retrieve all of ta_properties from localStorage
   */ getLocal(key) {
        var props = localStorage.getItem("ta_properties");
        props = JSON.parse(props);
        // if JSON didn't parse, we still have the defaults
        if (props === null) props = this.defaultProperties;
        // if there is no key, return all of the properties
        if (typeof key === "undefined") return props;
        else // return the keyed property (will simply be undefined if nonexistant)
        return props[key];
    }
    /**
   * Checks to see if the context is that of the tray application then pick default port based on current URL.
   * @returns Returns the default port.
   */ getDefaultPort() {
        let defaultPort = 12680;
        if (this.isTrayApp()) {
            const trayPort = location.port || (location.protocol === "https:" ? "443" : "80");
            defaultPort = isNaN(parseInt(trayPort, 10)) ? 12680 : parseInt(trayPort, 10);
            // we now have the up to date port so go ahead and override the one in localStore, which may not be the correct port anymore
            // because user may have changes the port TA runs on.
            this.setLocal("port", defaultPort);
        }
        return defaultPort;
    }
    /**
   *
   * @returns Parsed port number from @urls if any of the urls come from the tray application.
   */ isTrayApp() {
        return document.getElementsByTagName("body")[0].getAttribute("data-apptype") === "bundled-with-ta";
    }
    /**
   * We juggle X# of URLs (usually two) at a given time. Since the entire
   * purpose of the HTTP_Launcher is to know whether to fall back from
   * localhost or not, we need to know if a URL being used is "localhost"
   *
   * @param {String} url - True if a given URL contains our "localhost" domain,
   *                       which is expected to be localhost.filecatalyst.net
   */ _urlIsLocalhost(url) {
        return url.toLowerCase().indexOf(this.local.hostname) >= 0;
    }
    /**
   * A successful heartbeat check means that we know what our base path for
   * REST calls should be; make this available to the app using HTTP_Launcher
   *
   * @param {String} url - a candidate for updating the successful heartbeat URL
   */ _updatebasePath(url) {
        let performUpdate = false;
        // no brainer... if we don't have one, update. If this hasn't yet been
        // replaced, it ALSO means it was the fastest one to return, so go ahead
        // and update.
        if (this.basePath == "") performUpdate = true;
        // if we prefer proxy and we actually get one, let's store it!
        if (this.pollConfig.preferProxy == true && this._validProxy() && !this._urlIsLocalhost(url)) performUpdate = true;
        if (performUpdate == true) {
            // we don't need the full heartbeat endpoint, just
            // the base URL, so strip out the extra stuff
            url = url.replace("/rs/agent/heartbeat", "");
            this.basePath = url;
            console.info(`Update the base path to ${this.basePath}`);
        }
    }
    /**
   * Returns true when maxTime milliseconds have passed since launch
   *
   * @param {Number} durationOverride  -  When called with a number passed in, we explicitly set the
   *                                      duration to be considered "timed out"; otherwise it uses configured
   *                                      maxTime value.
   */ _timedOut(durationOverride) {
        let timedOut = false;
        const targetInterval = durationOverride || this.pollConfig.maxTime;
        const now = Date.now();
        const gap = now - this.heartbeatStartTime;
        if (gap >= targetInterval) timedOut = true;
        return timedOut;
    }
    /**
   * Based on a "base" URL, append the rest of the path required to reach
   * a REST endpoint for a heartbeat check.
   *
   * @param {String} base - the scheme, domain, port, and path which serve
   *                        as a prefix to the REST endpoint
   */ _buildHeartbeatURL(base) {
        // normalize base to have trailing slash
        if (base.substr(-1) !== "/") base += "/";
        // This was needed because we no longer pass 'local' URL as its own
        // config object; yet, the user may update ports.
        if (base.indexOf("localhost") >= 0 || base.indexOf("127.0.0.1") >= 0) {
            let url = new URL(base);
            url.port = this.getLocal("port");
            base = url.toString();
        }
        return base + "rs/agent/heartbeat";
    }
    /**
   * Returns the proxy endpoint for a heartbeat check.
   */ _buildProxyHeartbeatURL() {
        let base = "";
        // proxy was already stored during construction. Let's store it in a variable.
        let proxy = this.proxy;
        if (this._validProxy()) {
            // auto-detect scheme from window.location. In the case where this CREATES
            // an invalid scheme, we're no worse off because the browser wouldn't have
            // allowed it anyhow. (if your proxy is HTTP but your app is HTTPS, you're out of luck)
            let scheme = window.location.protocol + "//";
            // find out if we need to append a slash to the path or not
            let pathAppend = proxy.proxyPath.charAt(proxy.proxyPath.length - 1) == "/" ? "" : "/";
            pathAppend += "proxy/";
            base += scheme + proxy.proxyHost + ":" + proxy.proxyPort + "/" + proxy.proxyPath + pathAppend + proxy.proxyID;
        }
        return this._buildHeartbeatURL(base);
    }
    /**
   * Returns a list of available heartbeats. Sometimes it is only one, but we
   * normalize to list for internal consistency.
   */ _heartbeatURLs() {
        let heartbeats = this.urls.map((url)=>this._buildHeartbeatURL(url));
        // If there was no proxy submitted during construction, we don't need
        // to invoke a protocol handler with proxy ID.
        if (this._validProxy()) {
            this.setLocal("proxyID", this.proxy.proxyID);
            heartbeats.push(this._buildProxyHeartbeatURL());
        }
        return heartbeats;
    }
    // --------------------- public methods and ASYNC functions ----------------------
    /**
   * Invoking the protocol handler is done at least once, when the constructor is
   * run. However, this also intended as a public method in case we need to
   * invoke it again from the application.
   */ invokeProtocolHandler() {
        try {
            // use an existing iFrame if possible.
            var iFrame = $("#hiddenIframe");
            if (iFrame.length <= 0) iFrame = $('<iframe id="hiddenIframe" src="about:blank" style="display:none"></iframe>').appendTo("body");
            // updating the src attribute triggers the protocol handler to be called, similarly to if
            // a user had clicked a protocol handler-enabled link.
            iFrame.attr("src", "about:blank");
            iFrame.attr("src", this.protocolHandlerURL);
        } catch (e) {
            console.error(e);
        // need to move this to a failure callback
        //pg.ui.spinnerScreen(false, 'connecting');
        }
    }
    launch() {
        this.launchErrors.clear();
        // so, launching is the very very wrong thing to do if this is run from
        // within Central. So, let's foil any accidental attempts (ie. the app can't
        // be expected to remember EVERYTHING)
        if (this.pollConfig.isCentral === false) this.invokeProtocolHandler();
        // return instance for chaining
        return this;
    }
    /**
   * _checkEndpoint is a wrapping function, encapsulating the actual "fetch"
   * operation for a single REST URL (ie. heartbeat). It contains a polling interval method,
   * a while loop for polling until conditions are met, and ultimately handles a
   * "grace period" (ie. giving proxy a chance to succeed) before returning results
   * to the checkEndpoints wrapper.
   *
   * @param {String} url - the full URL to be checked for heartbeat
   */ async _checkEndpoint(url, duration) {
        // cache the object's scope
        const myself = this;
        /**
     *
     * @param {Number} ms - A number representing how many milliseconds to
     *                      wait before resolving a promise. Used to create
     *                      polling delays.
     */ function wait(ms = 1000) {
            return new Promise((resolve)=>{
                setTimeout(resolve, ms);
            });
        }
        /**
     * The actual polling functionality. It calls the fetch, which is
     * either successful or not. The results are analyzed and returned
     * or thrown to a try/catch block running in a loop.
     */ async function pollingFunction() {
            let result;
            // perform the fetch itself
            try {
                result = await fetch(url, {
                    cache: "no-store"
                });
            } catch (err) {
                result = err;
            }
            // analyse the results of the fetch and return or throw.
            if (result && result.ok == true) {
                myself.setLocal("ta_found", "true");
                myself.foundDuringPoll = true;
                myself._updatebasePath(result.url);
                return result;
            } else {
                let entry = result.toString();
                // in the case of networking errors, the result is
                // an unresolved Promise or Response.
                if (entry.startsWith("[") && entry.endsWith("]")) entry = "unresolved error";
                myself.launchErrors.add(entry);
                throw result;
            }
        }
        let whileResult = "No results returned";
        // keep firing until condition is met. Do not throw from the catch
        // block, but hold onto it until after while loop.
        while(myself.foundDuringPoll === false && myself._timedOut(duration) == false)try {
            await wait(); // possibly an unecessary delay. Re-write candidate.
            let value = await pollingFunction();
            whileResult = {
                value: value
            };
        } catch (reason) {
            whileResult = {
                reason: reason
            };
        }
        // the while loop has completed, but we may still need to wait for the graceTime
        // before returning or throwing. This only happens for:
        // 1. proxy configured; 2. proxy is preferred; 3. current URL is localhost.
        if (myself._validProxy() == true && myself.pollConfig.preferProxy == true && myself._urlIsLocalhost(url)) await wait(myself.pollConfig.graceTime);
        // the optional wait is over, so let's either throw or return to complete the promise
        if (whileResult.reason) throw whileResult.reason;
        return whileResult.value;
    }
    /**
   * This wrapper around _checkEndpoint is necessary so that we can listen for "any"
   * promises being resolved. "any" is preferred to "all" because "all" would required failing
   * URLs to fully time out. "any" allows a successful attempt to return to the main application.
   *
   * @param {Array} urls - An array of one or more strings representing full URLs to check
   *                       for successful response
   */ async checkEndpoints(urls, duration) {
        const promises = [];
        for (let url of urls)promises.push(this._checkEndpoint(url, duration));
        // return the Promise so that it can be resolved at the level
        // of the caller instead of here.
        return await Promise.any(promises);
    }
    /**
   * This is the entry point from the application using HTTP_Launcher. After creating a new
   * HTTP_Launcher, the application can chain a ".then(result)" handler for success or a
   * ".catch(result)" handler for errors. The result object passed up contains the successful
   * base path for REST calls, or a Set of errors for why the operation failed.
   *
   * @param {Number} duration - The length of time this particular attempt at launching
   *                            should take. Serves as an override for default time
   *                            NOTE: a value of zero can be used to indicate doing
   *                            a "quick check"
   */ async pollHeartbeat(duration) {
        const myself = this;
        this.heartbeatStartTime = Date.now();
        this.foundDuringPoll = false;
        // we will always at least try localhost; a proxy will still take effect if attempts fail
        const heartbeats = this._heartbeatURLs();
        let result;
        // invoke the "heartbeats" wrapper. The try/catch block allows us to listen for
        // the resolution or rejection of the chain of Promises being made. However, we
        // only store them, we do not return/throw further YET.
        try {
            result = await myself.checkEndpoints(heartbeats, duration);
        } catch (e) {
            result = e;
        }
        // analyse the results of the heartbeat checks, and return a success or throw an error.
        // This is consumed by the application that is using HTTP_Launcher.
        if (result.ok) return result;
        else throw myself.launchErrors;
    }
    // this defied aliasing launch() or getHeartbeats() wholesale, so some parts are identical
    async quickCheck() {
        let myself = this;
        var urls = myself._heartbeatURLs();
        let promiseList = [];
        for (let url of urls)promiseList.push(fetch(url, {
            cache: "no-store"
        }));
        let response = await Promise.any(promiseList);
        // analyse the results of the heartbeat checks, and return a success or throw an error.
        // This is consumed by the application that is using HTTP_Launcher.
        if (response && response.ok == true) {
            myself.setLocal("ta_found", true);
            myself._updatebasePath(response.url);
            return response;
        } else throw response;
    }
}



const $f43e938a8b65a516$var$ta_launcher = new (0, $2180970a0cc820db$export$2e2bcd8739ae039)((0, $a1d35d9d46ea887a$export$235b59c0b6725bc2), (0, $e836a774916461d1$export$b8c7477dd561ed36)());
var $f43e938a8b65a516$export$2e2bcd8739ae039 = $f43e938a8b65a516$var$ta_launcher;


class $e9be7d47ea4c0662$export$2e2bcd8739ae039 {
    static centralNewHost = {
        //protocol - > ftp://, http://, https://
        protocol: "",
        //IP -> 256.256.256.256
        ip: document.location.hostname,
        //PORT -> 8080
        port: "",
        //nodeID - > 1485858158858
        nodeID: 0,
        //authorization encoded
        credentials: ""
    };
    static available = {
        statusViaGet: undefined,
        serviceStatus: undefined
    };
    /**
   * A malleable object storing a number of quasi-global (within the PG namespace
   * but publicly accessible) flags and application states
   *
   * @type {object}
   * @memberOf pg
   * @property {integer} detectRequests - stores a count of requests made by pg.rest.connect
   * @property {integer} confirmAttempts - stores a count of number of times a 'confirm' dialog has appeared
   */ static state = {
        detectRequests: 0,
        confirmAttempts: 0,
        validCreds: null,
        pollHeartbeat: true,
        dontThrowConnectionError: false,
        lastErrorConnectionMessage: "",
        requestingConnection: false,
        //added this flag to avoid pg.init.remoteFiles() been called twice (provoking two connection request)
        remoteFilesIntialRequest: false,
        //added this flag to avoid pg.init.localFiles() been called twice (provoking two connection request)
        localFilesIntialRequest: false,
        // REST CALL rs/agent/serviceStatus -> serviceRunning save info. (default false)
        isRunningAsService: false,
        currentVersion: 0,
        applicationLaunched: false
    };
    static localConfig = {
        declineUpgrade: undefined
    };
    static version = "3.8.5 3 85";
    static dialog = {
        hooks: {
            upgrade: undefined,
            launch: undefined,
            launchFailed: undefined
        }
    };
    static clearModals = ()=>{
        Object.entries($e9be7d47ea4c0662$export$2e2bcd8739ae039.dialog.hooks).forEach((item)=>{
            if (item && item.modal) item.modal("hide");
        });
    };
    /**
   * An object containing two predefined icon sets (using Font Awesome and the Glyphicons included in Bootstrap3),
   * as well as a string defining which set to use and a getter for returning the requested icon from the current set.
   *
   * @type {object}
   * @memberOf pg
   * @property {string} currentset - a string found in pg.config.webapp.iconSet.
   * @property {object} fontawesome - HTML (strings with classes) to render Font Awesome icons
   * @property {object} glyphicons - HTML (strings with classes) to render Bootstrap3 glyphicons halflings
   * @property {function} get - returns an icon from the current set matching the passed key
   */ static icon = {
        currentset: pg.config.webapp.iconSet ? pg.config.webapp.iconSet : "fontawesome",
        fontawesome: {
            default: '<i class="fa fa-question-circle"></i>',
            directory: '<i class="fa fa-folder"></i>',
            file: '<i class="fa fa-file-o"></i>',
            upload: '<i class="fa fa-upload"></i>',
            download: '<i class="fa fa-download"></i>',
            checkedbox: '<i class="fa fa-check-square-o"></i>',
            uncheckedbox: '<i class="fa fa-square-o"></i>',
            trash: '<i class="fa fa-trash-o"></i>',
            levelup: '<i class="fa fa-level-up"></i>',
            settings: '<i class="fa fa-gears"></i>',
            more: '<i class="fa fa-plus-square-o"></i>',
            less: '<i class="fa fa-minus-square-o"></i>',
            addqueue: '<i class="fa fa-arrow-circle-right"></i>',
            envelope: '<i class="fa fa-envelope"></i>',
            ok: '<i class="fa fa-check"></i>',
            remove: '<i class="fa fa-times"></i>',
            repeat: '<i class="fa fa-repeat"></i>',
            refresh: '<i class="fa fa-refresh"></i>',
            spinner: '<i class="fa fa-spinner fa-spin"></i>',
            home: '<i class="fa fa-home"></i>',
            desktop: '<i class="fa fa-desktop"></i>',
            documents: '<i class="fa fa-files-o"></i>',
            downloads: '<i class="fa fa-download"></i>'
        },
        /**
     * Returns requested icon markup as a string
     *
     * @memberOf pg.icon
     * @param {string} icon - a valid property (key) of the current icon set object. See
     * pg.icon.fontawesome or pg.icon.glyphicons for a sample list
     * @returns {string}
     */ get: function(icon) {
            let set = $e9be7d47ea4c0662$export$2e2bcd8739ae039.icon[$e9be7d47ea4c0662$export$2e2bcd8739ae039.icon.currentset];
            let theicon = set[icon];
            return theicon;
        }
    };
    static initialization = ()=>{
        // allow icons to be defined in the configuration.js file (or elsewhere) with
        // an object named pg.config.webapp.customIcons
        if (typeof (pg?.config.customIcons !== "undefined")) $.extend($e9be7d47ea4c0662$export$2e2bcd8739ae039.icon, pg.config.customIcons);
    };
    // use of Port is deprecated by HTTP Launcher,
    // but logic not updated yet, and we need the param because a call still uses helpUrl.
    static baseUrl = (service, port, helpUrl)=>{
        port = port || (0, $f43e938a8b65a516$export$2e2bcd8739ae039).getLocal("port");
        if (typeof service === "object") {
            let node = service;
            let key = node.connectionKey;
            if (key === "local") service = "transferRev1";
            else // for now, the service is always transfer
            // the else block is reserved for future changes
            service = "transferRev1";
        }
        // sanitize the service input as much as possible
        service = service.trim();
        let serviceArray = service.split("/");
        for(let en = 0; en < serviceArray.length; en++)serviceArray[en] = encodeURIComponent(serviceArray[en]);
        service = serviceArray.join("/");
        console.log(`computed service is ${service}`);
        let filesUrls = [
            "local",
            "remote",
            "transferRev1",
            "transferRev1/cancel",
            "local/filter"
        ];
        let agentUrls = [
            "config",
            "heartbeat",
            "status",
            "version",
            "connect",
            "reveal",
            "register",
            "serviceStatus"
        ];
        if ($.inArray(service, filesUrls) >= 0) service = "files/" + service;
        else if ($.inArray(service, agentUrls) >= 0) service = "agent/" + service;
        let url = (0, $f43e938a8b65a516$export$2e2bcd8739ae039).basePath;
        console.log(`Base path from ta_launcher is ${url}`);
        try {
            //for central use -> protocol + ip + + ":" + port + "/rs/nodes/" + nodeID + "/ta"
            if (parseInt($e9be7d47ea4c0662$export$2e2bcd8739ae039.centralNewHost.nodeID) > 0) url = centralNewHost.protocol + centralNewHost.ip + ":" + centralNewHost.port + "/rs/nodes/" + centralNewHost.nodeID + "/ta/";
        } catch (e) {
            console.log(e);
            console.trace(e);
        }
        if (helpUrl !== undefined) {
            // Check again because I cannot change the core function without change other kind of use of TA deployment
            // - Dirceu Nazareth
            if (parseInt($e9be7d47ea4c0662$export$2e2bcd8739ae039.centralNewHost.nodeID) > 0) return url;
            else return url + "/";
        }
        if (typeof service !== "undefined" && $e9be7d47ea4c0662$export$2e2bcd8739ae039.centralNewHost.nodeID === 0) url += "/rs/" + service;
        else url += service;
        return url;
    };
    static getVersionAjax = (successHandler, errorHandler)=>{
        let data = {
            requester: "TransferAgent Deployment " + $e9be7d47ea4c0662$export$2e2bcd8739ae039.version
        };
        let url = $e9be7d47ea4c0662$export$2e2bcd8739ae039.baseUrl("version");
        $.ajax({
            url: url,
            type: "GET",
            async: true,
            data: data,
            success: function(data) {
                successHandler(data);
            },
            error: function(xhr, opts, error) {
                if (typeof errorHandler === "undefined") console.error(error);
                else errorHandler(xhr, opts, error);
            },
            statusCode: {
                0: function(xhr) {
                // override default status code 0 behaviour
                }
            }
        });
    };
}
$e9be7d47ea4c0662$export$2e2bcd8739ae039.initialization();




class $64215f38d6524554$export$2e2bcd8739ae039 {
    static state = {
        detectRequests: 0,
        confirmAttempts: 0,
        validCreds: null,
        launchAttempted: false,
        refreshWarning: false,
        busyHeartBeat: false,
        tryProxy: false,
        proxyResult: ""
    };
    static detectOS = ()=>{
        let os = "linux";
        let agent = navigator.userAgent || ""; // if undefined, make an empty string which will result in Linux/Other
        agent = agent.toLowerCase();
        if (agent.indexOf("mac") > -1) os = "mac";
        else if (agent.indexOf("windows") > -1) os = "windows";
        return os;
    };
    static launcherInitialized = ()=>{
        if (typeof (0, $f43e938a8b65a516$export$2e2bcd8739ae039) == "undefined") return false;
        return true;
    };
    static localStorageConfiguration = {
        saveItem: function(itemName, itemValue) {
            tempObj = {};
            //hardcode up to we have a definition about how cookies should work for filecalyst clients.
            tempObj.expires = 365;
            itemValue.objectStamp = true;
            if (typeof itemValue === "string") $.cookie(itemName, itemValue, tempObj);
            else $.cookie(itemName, JSON.stringify(itemValue), tempObj);
        },
        getItem: function(itemName) {
            try {
                return JSON.parse($.cookie(itemName));
            } catch (e) {
                console.warn("itemName: " + itemName, "cookie: " + $.cookie(itemName), e);
                return null;
            }
        },
        insertProperty: function(itemName, propertyName, propertyValue) {
            let verifyItem = $64215f38d6524554$export$2e2bcd8739ae039.localStorageConfiguration.getItem(itemName);
            if (verifyItem !== null) {
                let tempObject = {};
                if (typeof verifyItem === "string") tempObject = JSON.parse(verifyItem);
                else tempObject = verifyItem;
                if (tempObject !== undefined && typeof tempObject === "object" && tempObject !== null) {
                    tempObject[propertyName] = propertyValue;
                    $64215f38d6524554$export$2e2bcd8739ae039.localStorageConfiguration.saveItem(itemName, tempObject);
                    return true;
                } else return false;
            } else return null;
        },
        resetLocalStorage: function(itemName) {
            $.cookie(itemName, null);
        }
    };
    static getPortToListen = ()=>{
        let savedConfig = $64215f38d6524554$export$2e2bcd8739ae039.localStorageConfiguration.getItem("filecatalystTAPortValue");
        if (savedConfig !== null && !$.isEmptyObject(savedConfig)) return $64215f38d6524554$export$2e2bcd8739ae039.localStorageConfiguration.getItem("filecatalystTAPortValue");
        else return localAgent.portDefault;
    };
    static setPortToListen = (port)=>{
        if ($64215f38d6524554$export$2e2bcd8739ae039.launcherInitialized() == false) throw new Error("Cannot update the listener port without HTTP Launcher initialized.");
        port = parseInt(port);
        (0, $f43e938a8b65a516$export$2e2bcd8739ae039).setLocal("port", port);
    };
    static getLinkForOS = (kindOfLink, os)=>{
        let parentDir = "";
        let linkMap = {
            installDoc: {
                windows: (0, $01f9c2ffd7693c68$export$2e2bcd8739ae039).t("webDeployment.docWindowsLocation"),
                mac: (0, $01f9c2ffd7693c68$export$2e2bcd8739ae039).t("webDeployment.docMacLocation"),
                linux: (0, $01f9c2ffd7693c68$export$2e2bcd8739ae039).t("webDeployment.docLinuxLocation")
            },
            download: {
                windows: pg.config.links.installWindowsLocation,
                mac: pg.config.links.installMacLocation,
                linux: pg.config.links.installLinuxLocation
            }
        };
        // although this function should usually be called without passing in an os,
        // you are able to explicitly pass "Windows", "Mac", or "Linux" to bypass detection.
        // let's normalize the case:
        if (typeof os === "string") os = os.toLowerCase();
        // if the kindOfLink ("download" or "installDoc") is not provided, assume we are
        // after the installDoc
        kindOfLink = kindOfLink ? kindOfLink : "installDoc";
        // TODO: Make a unified path structure that we won't have to worry about.
        // Hacky fix when using weblink. No other folder will trigger this (unless they also have a weblinkDataDiv ID.)
        if ($("#webLinkInfo").length > 0 && kindOfLink === "installDoc") parentDir = "../";
        // TODO: Make a unified path structure that we won't have to worry about.
        // Hacky fix when using Express from Deployment. No other folder will trigger this
        // (unless they also have a .deployment-version.ta-express-deployed-app CSS selection)
        if (($64215f38d6524554$var$isDeployedExpressApp() || $64215f38d6524554$var$isFCLoginPage()) && kindOfLink === "installDoc") parentDir = "../../";
        // only detect if os is not explicitly passed in with the params
        if (typeof os === "undefined" || os !== "mac" && os !== "windows" && os !== "linux") os = $64215f38d6524554$export$2e2bcd8739ae039.detectOS();
        // set the link with best-known results
        return parentDir + linkMap[kindOfLink][os];
    };
    /**
   * Checks to see if the application needs to be updated.
   *
   * @param  {Object}     transferAgentVersion
   *                                         The object containing the version data we're checking as retrieved from
   *                                         the TA.
   * @param  {string}     webApplicationVersion
   *                                         The version string reported by the web application as a basis of
   *                                         comparison to the TransferAgent itself.
   * @return {number|NaN}                    The result of the version check. Is -1 when the version given is older
   *                                         than the current version. Is 1 when the version given is newer than the
   *                                         current version. Is 0 when the version given is the same as the current
   *                                         version. It is NaN if the version given is invalid.
   */ static compareVersion = (transferAgentVersion, webApplicationVersion)=>{
        //check if the user declined the upgrade for this version.
        if (localStorage.getItem("webLink.VersionFoundWhenUserDeclinedUpdate") === webApplicationVersion) return;
        let intCurrentFile = 0;
        let fileVersionArray = [];
        let dataVersionArray = [];
        let versionDepth = 0;
        let result = NaN;
        //current version in this file
        let splitFileVersion = webApplicationVersion.split(" ");
        if (splitFileVersion[0] === "Enterprise") {
            let tempStatus = splitFileVersion[2];
            splitFileVersion = splitFileVersion[1].replace("v", "").split(".");
            splitFileVersion = [
                splitFileVersion[0] + "." + splitFileVersion[1],
                tempStatus,
                splitFileVersion[2]
            ];
        }
        // Make arrays out of version strings:
        fileVersionArray = splitFileVersion[0].split(".");
        dataVersionArray = transferAgentVersion.version.split(".");
        // Make sure the arrays are the same length
        versionDepth = fileVersionArray.length;
        if (dataVersionArray.length > versionDepth) versionDepth = dataVersionArray.length;
        // Converting legacy status version name to status version number
        try {
            intCurrentFile = parseInt(splitFileVersion[1]);
            if (isNaN(intCurrentFile)) switch(splitFileVersion[1].toUpperCase()){
                case "ALPHA":
                    intCurrentFile = 1;
                    break;
                case "BETA":
                    intCurrentFile = 2;
                    break;
                case "PRODUCTION":
                case "ENTERPRISE":
                    intCurrentFile = 3;
                    break;
                default:
                    intCurrentFile = 0;
            }
        } catch (e) {
            intCurrentFile = 0;
        }
        // Add the status version number to the arrays.
        fileVersionArray[versionDepth] = intCurrentFile;
        dataVersionArray[versionDepth] = transferAgentVersion.statusInt;
        // Add the build version number to the arrays.
        fileVersionArray.push(parseInt(splitFileVersion[2]));
        dataVersionArray.push(transferAgentVersion.build);
        // Go through each version number and see how they compare
        $.each(fileVersionArray, function(index, currentValue) {
            // We sanitize each value into a good integer
            let fileVersionNumber = parseInt(currentValue) || 0;
            let dataVersionNumber = parseInt(dataVersionArray[index]) || 0;
            // If the file version is larger than the version we passed to this function
            if (fileVersionNumber > dataVersionNumber) {
                result = -1;
                return false;
            // If the file version is smaller than the version we passed to this function
            } else if (fileVersionNumber < dataVersionNumber) {
                result = 1;
                return false;
            // If the file version is the same as the version we passed to this function
            } else result = 0;
        });
        // Return the results of our comparison.
        return result;
    };
    /**
   * Stores the introduction of new or changed API methods
   *
   * @param {string} taVersion
   */ static apiChecks = (taVersion)=>{
        (0, $e9be7d47ea4c0662$export$2e2bcd8739ae039).available.statusViaGet = $64215f38d6524554$export$2e2bcd8739ae039.compareVersion(taVersion, "3.6 Beta 5") >= 0 ? true : false;
        (0, $e9be7d47ea4c0662$export$2e2bcd8739ae039).available.serviceStatus = $64215f38d6524554$export$2e2bcd8739ae039.compareVersion(taVersion, "3.7 Beta 1") >= 0 ? true : false;
    };
    static checkRunningAsService = (successCallback, errorCallback)=>{
        let url = (0, $e9be7d47ea4c0662$export$2e2bcd8739ae039).baseUrl("serviceStatus");
        $.ajax({
            url: url,
            type: "GET",
            dataType: "json",
            success: function(data) {
                if (successCallback) successCallback(data);
            },
            error: function(xhr) {
                if (errorCallback) errorCallback(xhr);
            }
        });
    };
    static runningAsServiceStatusGetSet = (data)=>{
        if (data) (0, $e9be7d47ea4c0662$export$2e2bcd8739ae039).state.isRunningAsService = typeof data.isServiceRunning !== "undefined" ? data.isServiceRunning : data.serviceRunning;
        else return (0, $e9be7d47ea4c0662$export$2e2bcd8739ae039).state.isRunningAsService;
    };
}
function $64215f38d6524554$var$isDeployedExpressApp() {
    return $(".deployment-version.ta-express-deployed-app").length > 0;
}
function $64215f38d6524554$var$isFCLoginPage() {
    return $(".fcloginpage").length > 0;
}







class $b4498450c1e534ee$export$2e2bcd8739ae039 {
    static hooks = {
        launch: undefined,
        launchFailed: undefined,
        download: undefined,
        downloadImage: undefined,
        manualUpdate: undefined
    };
    /**
   * Download modal. This is meant to be shown when the transfer agent is being downloaded. It will show different
   * download screenshots to make sure people know where to find their download from the browser.
   *
   * @param {method} callback
   */ static manualDownload = (isUpgrade, callback)=>{
        let downloadImage = new Image();
        let downloadImageURL = "../../images/";
        let downloadImageURLLarge = "../../images/";
        let downloadImageStartSmall = '<img id="image-manualDownload" alt="' + (0, $01f9c2ffd7693c68$export$2e2bcd8739ae039).t("webDeployment.manualDownloadTitle") + '" src="';
        let downloadImageStartLarge = '<img alt="' + (0, $01f9c2ffd7693c68$export$2e2bcd8739ae039).t("webDeployment.manualDownloadTitle") + '" src="';
        let downloadImageEnd = '" />';
        switch(Browser.info().name){
            case "chrome":
                downloadImageURL += "download_chrome_small.png";
                downloadImageURLLarge += "download_chrome_large.png";
                break;
            case "firefox":
                downloadImageURL += "download_firefox_small.png";
                downloadImageURLLarge += "download_firefox_large.png";
                break;
            case "ie":
                downloadImageURL += "download_ie_small.png";
                downloadImageURLLarge += "download_ie_large.png";
                break;
            case "edge":
                downloadImageURL += "download_edge_small.png";
                downloadImageURLLarge += "download_edge_large.png";
                break;
            case "safari":
                downloadImageURL += "download_safari_small.png";
                downloadImageURLLarge += "download_safari_large.png";
                break;
            default:
                downloadImageURL = "";
                downloadImageURLLarge = "";
                downloadImageStartSmall = "";
                downloadImageStartLarge = "";
                downloadImageEnd = "";
        }
        downloadImage.src = downloadImageURL;
        if (callback !== undefined) downloadImage.addEventListener("load", function() {
            callback();
        });
        $b4498450c1e534ee$export$2e2bcd8739ae039.hooks.download = $b4498450c1e534ee$export$2e2bcd8739ae039.dialog({
            message: isUpgrade ? (0, $01f9c2ffd7693c68$export$2e2bcd8739ae039).t("webDeployment.manualDownloadMsg") : (0, $01f9c2ffd7693c68$export$2e2bcd8739ae039).t("webDeployment.manualDownloadMsgForUpgrade") + "<br /><br />" + (0, $01f9c2ffd7693c68$export$2e2bcd8739ae039).t("common.installDocIntro") + '<a href="' + (0, $64215f38d6524554$export$2e2bcd8739ae039).getLinkForOS("installDoc") + '" id="revealDoc" target="_blank">' + (0, $01f9c2ffd7693c68$export$2e2bcd8739ae039).t("common.installDocDescription") + "</a><br /><br />" + downloadImageStartSmall + downloadImageURL + downloadImageEnd,
            title: (0, $01f9c2ffd7693c68$export$2e2bcd8739ae039).t("webDeployment.manualDownloadTitle"),
            className: "modal-manualDownload",
            closeButton: false,
            buttons: {}
        });
        $("#image-manualDownload").on("click", function() {
            // Open a larger dialog with a larger view of the image.
            $b4498450c1e534ee$export$2e2bcd8739ae039.hooks.downloadImage = $b4498450c1e534ee$export$2e2bcd8739ae039.dialog({
                message: downloadImageStartLarge + downloadImageURLLarge + downloadImageEnd,
                className: "modal-manualDownloadImage"
            });
            $(".modal-manualDownloadImage img").on("click", function() {
                $b4498450c1e534ee$export$2e2bcd8739ae039.hooks.downloadImage.modal("hide");
            });
        });
        (0, $64215f38d6524554$export$2e2bcd8739ae039).state.refreshWarning = true;
    };
    static handlers = {
        download: ()=>{
            if ($b4498450c1e534ee$export$2e2bcd8739ae039.hooks.launch !== undefined) $b4498450c1e534ee$export$2e2bcd8739ae039.hooks.launch.modal("hide");
            if ($b4498450c1e534ee$export$2e2bcd8739ae039.hooks.launchFailed !== undefined) $b4498450c1e534ee$export$2e2bcd8739ae039.hooks.launchFailed.modal("hide");
            if ($b4498450c1e534ee$export$2e2bcd8739ae039.hooks.manualUpdate !== undefined) $b4498450c1e534ee$export$2e2bcd8739ae039.hooks.manualUpdate.modal("hide");
            (0, $f43e938a8b65a516$export$2e2bcd8739ae039).pollHeartbeat().then(()=>{
                $b4498450c1e534ee$export$2e2bcd8739ae039.hooks.download.modal("hide");
                $b4498450c1e534ee$export$2e2bcd8739ae039.spinnerScreen(false, "waiting");
                window.location.reload(); // This may be incorrect?? How to let the React App know to reload?
            }).catch((err)=>{
                $b4498450c1e534ee$export$2e2bcd8739ae039.hooks.download.modal("hide");
                $b4498450c1e534ee$export$2e2bcd8739ae039.spinnerScreen(false, "waiting");
                // needs a time buffer or will collide with closing
                // dialogs. In theory, could instead listen to the close
                // event on outstanding dialogs.
                setTimeout(function() {
                    $b4498450c1e534ee$export$2e2bcd8739ae039.launchFailed();
                }, 500);
            });
            $b4498450c1e534ee$export$2e2bcd8739ae039.manualDownload(false, function() {
                // Make sure the download of the application happens after the modal loads (Safari-specific issue):
                window.location = (0, $64215f38d6524554$export$2e2bcd8739ae039).getLinkForOS("download");
            });
            $b4498450c1e534ee$export$2e2bcd8739ae039.spinnerScreen(true, "waiting");
            return false;
        }
    };
    static screenSpinnerQueue = [];
    static spinnerScreen = (makeVisible, type)=>{
        (0, $01f9c2ffd7693c68$export$2d3542df2a1993a).then(()=>{
            let $spinContainer = $(".spinContainer");
            let $spinBack = $(".spinBack");
            if (typeof makeVisible === "undefined") makeVisible = true;
            if (typeof makeVisible === "string") {
                type = makeVisible;
                makeVisible = true;
            }
            if (makeVisible) {
                if ($spinContainer.length <= 0) {
                    $spinContainer = $('<div class="spinContainer"/>');
                    $spinBack = $('<div class="spinBack modal-backdrop in"/>');
                    $spinBack.appendTo($spinContainer);
                    $spinBack.after('<div class="spinnerWidget"><div class="spinner"></div></div>');
                    $spinContainer.appendTo("body");
                } // only record and append new text instance if one doesn't already exist
                if ($b4498450c1e534ee$export$2e2bcd8739ae039.screenSpinnerQueue.indexOf(type) === -1) {
                    $b4498450c1e534ee$export$2e2bcd8739ae039.screenSpinnerQueue.push(type);
                    let titleSpinner = (0, $01f9c2ffd7693c68$export$2e2bcd8739ae039).t("common.spinner." + type);
                    if (titleSpinner === "") titleSpinner = "Loading Resources";
                    $spinContainer.find(".spinner").after('<div class="spinnerText ' + type + '">' + titleSpinner + "</div>");
                }
            } else {
                $spinContainer.find("." + type).remove();
                let typePos = $b4498450c1e534ee$export$2e2bcd8739ae039.screenSpinnerQueue.indexOf(type);
                if (~typePos) $b4498450c1e534ee$export$2e2bcd8739ae039.screenSpinnerQueue.splice(typePos, 1);
                if ($b4498450c1e534ee$export$2e2bcd8739ae039.screenSpinnerQueue.length <= 0) $spinContainer.remove();
            }
        });
    };
    static alert = (msg)=>{
        return bootbox.dialog({
            className: "fc-ta-dialog",
            message: msg,
            buttons: {
                ok: {
                    label: "OK",
                    callback: function() {}
                }
            }
        });
    };
    static dialog = (message, opts)=>{
        let modal = undefined;
        if (typeof message === "object" && typeof opts === "undefined") opts = message;
        if (typeof opts === "undefined") modal = $b4498450c1e534ee$export$2e2bcd8739ae039.alert(message);
        else {
            if (typeof opts.message === "undefined" || opts.message === null || opts.message === "") opts.message = message;
            // sanity check for existing identical dialog
            if (opts.className) {
                let $dialog = $("." + opts.className);
                if ($dialog.length > 0) {
                    let $body = $dialog.find(".modal-body>div");
                    if ($body.find(".dialogWarning").length <= 0) $body.prepend('<p class="alert alert-danger dialogWarning"><em>' + (0, $01f9c2ffd7693c68$export$2e2bcd8739ae039).t("common.retryDialogMsg") + "</em></p>");
                    else {
                        let $numWarns = $body.find(".dialogRepeats");
                        if ($numWarns.length <= 0) $body.find(".dialogWarning").prepend('(<span class="dialogRepeats">2</span>)');
                        else {
                            let currentVal = parseInt($numWarns.text());
                            currentVal++;
                            $numWarns.text(currentVal);
                        }
                    }
                } else {
                    opts.className += " fc-ta-dialog";
                    modal = bootbox.dialog(opts);
                }
            }
        }
        // Returning reference to the modal we've created, so we don't have to look for it later.
        // Since this happens every time the modal is opened, the hook is self-updating.
        return modal;
    };
    static launchFailed = ()=>{
        let uniqueClass = "modal-launchFailed";
        let bodyMessage = '<p class="large-font-paragraph">' + (0, $01f9c2ffd7693c68$export$2e2bcd8739ae039).t("common.warningLaunchFailed") + "</p>";
        if ((0, $64215f38d6524554$export$2e2bcd8739ae039).detectOS() === "linux") bodyMessage = '<p class="large-font-paragraph">' + (0, $01f9c2ffd7693c68$export$2e2bcd8739ae039).t("common.warningLaunchFailedLinux").replace("__refresh__", (0, $01f9c2ffd7693c68$export$2e2bcd8739ae039).t("common.launchFailRefreshButton")) + "</p>";
        else {
            bodyMessage += '<ul id="advancedOptionsSteps">';
            bodyMessage += "<li>" + (0, $01f9c2ffd7693c68$export$2e2bcd8739ae039).t("common.warningLaunchFailedReason1") + "</li>";
            bodyMessage += "<li>" + (0, $01f9c2ffd7693c68$export$2e2bcd8739ae039).t("common.warningLaunchFailedReason2") + "</li>";
            bodyMessage += "<li>" + (0, $01f9c2ffd7693c68$export$2e2bcd8739ae039).t("common.warningLaunchFailedReason3") + "</li>";
            bodyMessage += "<li>" + (0, $01f9c2ffd7693c68$export$2e2bcd8739ae039).t("common.warningLaunchFailedReason4") + "</li>";
            bodyMessage += "</ul>";
        }
        bodyMessage += '<a class="collapsed" data-toggle="collapse" href="#advancedLaunch" aria-expanded="false" aria-controls="advancedLaunch">';
        bodyMessage += (0, $01f9c2ffd7693c68$export$2e2bcd8739ae039).t("common.manualLaunchAdvancedLabel") + ' <span class="caret"></span></a>';
        bodyMessage += '<div class="panel-collapse collapse" id="advancedLaunch"><div class="well">';
        bodyMessage += '<form class="form-horizontal"><div class="control-group"><fieldset><div class="control-group"><label class="control-label" for="portValue">' + (0, $01f9c2ffd7693c68$export$2e2bcd8739ae039).t("common.portNotFoundFieldLabel") + "</label>" + "&nbsp;&nbsp;" + '<input id="portValueRenew" name="portValueRenew" type="text" class="input-xlarge" value="' + (0, $64215f38d6524554$export$2e2bcd8739ae039).getPortToListen() + '"></div></fieldset></div></form></div></div>';
        $b4498450c1e534ee$export$2e2bcd8739ae039.spinnerScreen(false, "heartbeat");
        $b4498450c1e534ee$export$2e2bcd8739ae039.spinnerScreen(false, "launch");
        let dialogOptions = {
            message: bodyMessage,
            title: (0, $01f9c2ffd7693c68$export$2e2bcd8739ae039).t("common.agentNotFoundTitle"),
            className: uniqueClass,
            buttons: {
                download: {
                    label: (0, $01f9c2ffd7693c68$export$2e2bcd8739ae039).t("common.warningLaunchFailedReason1Link"),
                    className: "btn-link btn-sm",
                    callback: $b4498450c1e534ee$export$2e2bcd8739ae039.handlers.download
                },
                applyNewPort: {
                    label: (0, $01f9c2ffd7693c68$export$2e2bcd8739ae039).t("common.applyNewPort") + '&nbsp;&nbsp;<i class="fa fa-check" aria-hidden="true"></i>',
                    className: "btn-warning btn-refresh btn-sm",
                    callback: function() {
                        (0, $64215f38d6524554$export$2e2bcd8739ae039).setPortToListen($("#portValueRenew").val());
                        window.location.reload(true);
                        return false;
                    }
                },
                refresh: {
                    label: (0, $01f9c2ffd7693c68$export$2e2bcd8739ae039).t("common.launchFailRefreshButton") + '&nbsp;&nbsp;<i class="fa fa-refresh"></i>',
                    className: "btn-success btn-refresh btn-sm",
                    callback: function() {
                        location.reload();
                        return false;
                    }
                }
            }
        };
        // If we haven't downloaded before, reset the localStorage.
        if ((0, $9fbfcff99571b238$export$2e2bcd8739ae039).storage.transferAgent.downloads() < 1) (0, $64215f38d6524554$export$2e2bcd8739ae039).localStorageConfiguration.resetLocalStorage("filecatalystLocalConfig");
        bootbox.hideAll();
        $b4498450c1e534ee$export$2e2bcd8739ae039.hooks.launchFailed = $b4498450c1e534ee$export$2e2bcd8739ae039.dialog(dialogOptions);
    };
    static download = (isUpgrade, executeAfterVersionCheck = ()=>true, upgradeIgnored = (0, $5164b71a901e55cc$export$3e5dac20ecd3882d))=>{
        (0, $e9be7d47ea4c0662$export$2e2bcd8739ae039).clearModals();
        // Start checking for heartbeat, but without launch. The installation
        // process, when successful and when selected by user, will do the launch.
        // Default duration is set in http_launcher.js
        if (!isUpgrade) (0, $f43e938a8b65a516$export$2e2bcd8739ae039).pollHeartbeat().then(function() {
            // AfterTA confirmed takes in executeAfterVersionCheck and executeIfUpgradeIgnored.
            // But if you are dpwnloadinf the TA you'd be downloading the latest one so default behaviour is okay.
            (0, $1eca2a76dbd7310b$export$2e2bcd8739ae039).afterTaConfirmed(executeAfterVersionCheck, upgradeIgnored);
            $b4498450c1e534ee$export$2e2bcd8739ae039.taLaunchVisualCleanup();
        }).catch(function() {
            $(".modal-manualDownload").modal("hide");
            $b4498450c1e534ee$export$2e2bcd8739ae039.launchFailed();
        // or see if there is a "installation timed out" type dialog
        });
        // Show the download modal.
        $b4498450c1e534ee$export$2e2bcd8739ae039.manualDownload(isUpgrade, function() {
            // Make sure the download of the application happens _after_ the modal loads (Safari-specific issue).
            // this is accomplished by sending the redirect as a callback to the manualDownload dialog:
            window.location = (0, $64215f38d6524554$export$2e2bcd8739ae039).getLinkForOS("download");
        });
        $b4498450c1e534ee$export$2e2bcd8739ae039.spinnerScreen(true, "waiting");
        return false;
    };
    static upgrade = (onEscape = ()=>true, onIgnore = ()=>true)=>{
        // create an interactive dialog for when TransferAgent is not detected
        let uniqueClass = "modal-upgradeAgent";
        let bodyMessage = "<p>" + (0, $01f9c2ffd7693c68$export$2e2bcd8739ae039).t("webDeployment.upgradeJSisNewer") + ' <a href="#" onclick="javascript: window.location.reload(true);">' + '<i class="fa fa-refresh"></i></a>' + "</p>";
        bodyMessage += '<p><form class="form-horizontal"><div class="control-group"><label class="checkbox" for="noShowCheckbox"><input type="checkbox" name="checkboxes" id="noShowCheckbox">' + (0, $01f9c2ffd7693c68$export$2e2bcd8739ae039).t("webDeployment.doNotShowAgainCheckbox") + "</label>" + "</div>" + "</form></p>";
        let dialogOptions = {
            message: bodyMessage,
            title: (0, $01f9c2ffd7693c68$export$2e2bcd8739ae039).t("webDeployment.upgradeTitle"),
            className: uniqueClass,
            onEscape: onEscape,
            buttons: {
                download: {
                    label: (0, $01f9c2ffd7693c68$export$2e2bcd8739ae039).t("webDeployment.agentNotFoundButtonDownload") + "&nbsp;&nbsp;" + (0, $e9be7d47ea4c0662$export$2e2bcd8739ae039).icon[(0, $e9be7d47ea4c0662$export$2e2bcd8739ae039).icon.currentset].download,
                    className: "btn-info btn-download",
                    callback: ()=>$b4498450c1e534ee$export$2e2bcd8739ae039.download(true, onEscape, onIgnore)
                },
                ignore: {
                    label: (0, $01f9c2ffd7693c68$export$2e2bcd8739ae039).t("webDeployment.upgradeButtonIgnore") + "&nbsp;&nbsp;" + (0, $e9be7d47ea4c0662$export$2e2bcd8739ae039).icon[(0, $e9be7d47ea4c0662$export$2e2bcd8739ae039).icon.currentset].remove,
                    className: "btn-danger btn-cancel",
                    callback: onIgnore
                }
            }
        };
        (0, $e9be7d47ea4c0662$export$2e2bcd8739ae039).dialog.hooks.upgrade = $b4498450c1e534ee$export$2e2bcd8739ae039.dialog(dialogOptions);
    };
    // AfterTA confirmed takes in executeAfterVersionCheck and executeIfUpgradeIgnored.
    // if used from anywhere else but the login page. This call needs to be modiffied to take in
    // executeAfterVersionCheck and executeIfUpgradeIgnored so it can be passed to afterTaConfirmed.
    static launch = (executeAfterVersionCheck = ()=>true, upgradeIgnored = (0, $5164b71a901e55cc$export$3e5dac20ecd3882d))=>{
        $b4498450c1e534ee$export$2e2bcd8739ae039.spinnerScreen(true, "heartbeat");
        // use the HTTP_Launcher instance to launch. If this has not
        // been initialized, we will fail. Need a way to check for status.
        // The user is confirming that they have installed TA, so whether
        // they are correct or not, reduce the default polling length to 20s
        (0, $f43e938a8b65a516$export$2e2bcd8739ae039).launch().pollHeartbeat(20000).then(function() {
            (0, $1eca2a76dbd7310b$export$2e2bcd8739ae039).afterTaConfirmed(executeAfterVersionCheck, upgradeIgnored);
            $b4498450c1e534ee$export$2e2bcd8739ae039.taLaunchVisualCleanup();
        }).catch(function() {
            // if it didn't work, show dialog again
            $b4498450c1e534ee$export$2e2bcd8739ae039.manualLaunch(executeAfterVersionCheck, upgradeIgnored);
        }).finally(function() {
            // no matter what, stop the spinner
            $b4498450c1e534ee$export$2e2bcd8739ae039.spinnerScreen(false, "heartbeat");
        });
        (0, $e9be7d47ea4c0662$export$2e2bcd8739ae039).dialog.hooks.launch.modal("hide");
        // Don't close the modal. It is to be closed by the next successful heartbeat/poll.
        return false;
    };
    static manualLaunch = (executeAfterVersionCheck = ()=>true, upgradeIgnored = (0, $5164b71a901e55cc$export$3e5dac20ecd3882d))=>{
        let isLinux = (0, $64215f38d6524554$export$2e2bcd8739ae039).detectOS() === "linux";
        let taPort = (0, $f43e938a8b65a516$export$2e2bcd8739ae039).getLocal("port");
        let dialogVisible = $(".modal-manualLaunch").length > 0 ? true : false;
        let browser = Browser.info().name;
        let uniqueClass = "modal-manualLaunch";
        let bodyMessage = "<p>" + makeLaunchMsg() + "</p>";
        if ($(".modal-manualDownload").length > 0) // Our download modal is opened, so don't show the first one again.
        return;
        /**
     * Assemble launch message.
     */ function makeLaunchMsg() {
            let initMsg = (0, $01f9c2ffd7693c68$export$2e2bcd8739ae039).t("webDeployment.manualLaunchMsg");
            // store links that may get used;
            let tryLink = '<a href="#" id="launchTryAgain">' + (0, $01f9c2ffd7693c68$export$2e2bcd8739ae039).t("webDeployment.manualLaunchTryAgain") + "</a>";
            let downLink = '<a href="#" id="launchDownload">' + (0, $01f9c2ffd7693c68$export$2e2bcd8739ae039).t("webDeployment.manualLaunchDownload") + "</a>";
            let installGuideLink = '<a href="' + (0, $64215f38d6524554$export$2e2bcd8739ae039).getLinkForOS("installDoc") + '" id="revealDoc" target="_blank">' + (0, $01f9c2ffd7693c68$export$2e2bcd8739ae039).t("common.installDocDescription") + "</a>";
            // select an appropriate manual launch message
            if (isLinux) initMsg = (0, $01f9c2ffd7693c68$export$2e2bcd8739ae039).t("webDeployment.manualLaunchMsgLinux");
            let msg = initMsg.replace("__tryAgain__", tryLink).replace("__download__", downLink);
            msg += "<p>" + (0, $01f9c2ffd7693c68$export$2e2bcd8739ae039).t("common.installDocIntro") + installGuideLink + "</p>";
            //wire up the click handlers.
            $(document).on("click", "#launchTryAgain", function(e) {
                e.preventDefault();
                $b4498450c1e534ee$export$2e2bcd8739ae039.launch(executeAfterVersionCheck, upgradeIgnored);
            });
            $(document).off("click", "#launchDownload");
            $(document).on("click", "#launchDownload", function(e) {
                e.preventDefault();
                $b4498450c1e534ee$export$2e2bcd8739ae039.download(false, executeAfterVersionCheck, upgradeIgnored);
            });
            $(document).off("change", "#portValue");
            $(document).on("change", "#portValue", function() {
                (0, $64215f38d6524554$export$2e2bcd8739ae039).setPortToListen($(this).val());
            });
            return msg;
        }
        if (!dialogVisible) {
            // create an interactive dialog for manually configuring the TransferAgent
            if (browser === "ie" || browser === "edge") bodyMessage += "<p>" + (0, $01f9c2ffd7693c68$export$2e2bcd8739ae039).t("webDeployment.internetExplorerConfig") + "</p>";
            bodyMessage += '<a data-toggle="collapse" href="#advancedLaunch" aria-expanded="false" aria-controls="advancedLaunch">' + (0, $01f9c2ffd7693c68$export$2e2bcd8739ae039).t("webDeployment.manualLaunchAdvancedLabel") + ' <span class="caret"></span></a>' + '<div class="collapse" id="advancedLaunch"><div class="well"><form class="form-horizontal"><fieldset>' + '<div class="control-group"><label class="control-label" for="portValue">' + (0, $01f9c2ffd7693c68$export$2e2bcd8739ae039).t("webDeployment.portNotFoundFieldLabel") + "</label>&nbsp;&nbsp;" + '<input id="portValue" name="portValue" type="text" class="input-xlarge" value="' + taPort + '"></div>' + "</fieldset></form></div></div>";
            let dialogOptions = {
                message: bodyMessage,
                title: (0, $01f9c2ffd7693c68$export$2e2bcd8739ae039).t("webDeployment.manualLaunchTitle"),
                className: uniqueClass,
                closeButton: false,
                buttons: {}
            };
            // We don't show the launch button on Linux.
            if (!isLinux) dialogOptions.buttons.launch = {
                label: (0, $01f9c2ffd7693c68$export$2e2bcd8739ae039).t("webDeployment.manualLaunchButton"),
                className: "btn-link btn-confirm",
                callback: ()=>{
                    $b4498450c1e534ee$export$2e2bcd8739ae039.launch(executeAfterVersionCheck, upgradeIgnored);
                }
            };
            dialogOptions.buttons.download = {
                label: (0, $01f9c2ffd7693c68$export$2e2bcd8739ae039).t("webDeployment.agentNotFoundButtonDownload") + "&nbsp;&nbsp;" + (0, $e9be7d47ea4c0662$export$2e2bcd8739ae039).icon[(0, $e9be7d47ea4c0662$export$2e2bcd8739ae039).icon.currentset].download,
                className: "btn-success btn-download",
                callback: ()=>$b4498450c1e534ee$export$2e2bcd8739ae039.download(false, executeAfterVersionCheck, upgradeIgnored)
            };
            (0, $e9be7d47ea4c0662$export$2e2bcd8739ae039).dialog.hooks.launch = $b4498450c1e534ee$export$2e2bcd8739ae039.dialog(dialogOptions);
        }
    };
    static taLaunchVisualCleanup = ()=>{
        $(".help-anchor").attr("href", (0, $e9be7d47ea4c0662$export$2e2bcd8739ae039).baseUrl("help", undefined, true) + "help/TransferAgent/help.html#webui");
        $(".modal-manualLaunch").modal("hide");
        $(".modal-manualDownload").modal("hide");
        $b4498450c1e534ee$export$2e2bcd8739ae039.spinnerScreen(false, "heartbeat");
        $b4498450c1e534ee$export$2e2bcd8739ae039.spinnerScreen(false, "waiting");
        $b4498450c1e534ee$export$2e2bcd8739ae039.spinnerScreen(false, "initializing");
    };
    static growl = (message, placeHolderMap, options)=>{
        (0, $01f9c2ffd7693c68$export$2d3542df2a1993a).then(()=>{
            const translatedMessage = (0, $01f9c2ffd7693c68$export$2e2bcd8739ae039).t(`${message}`, placeHolderMap);
            console.log(`Translated message is : ${translatedMessage}`);
            $.notify({
                message: translatedMessage
            }, {
                ...options
            });
        });
    };
}


const $27aaab216feba4f8$export$cc60198cc811316 = function(params, collectedParams) {
    // clone the original params to avoid permanently destroying them
    let clonedParams = Object.assign({}, params);
    // Order of importance logic is in reverse.
    // 3rd - use configured credentials (if no pgpMessage, cleartext will be priority)
    // 2nd - back end itself will prioritize pgpMessage if present (no change needed)
    // 1st - if creds are collected from login form, prioritize by mutating params
    //       and ALSO deleting a pgpMessage value if present.
    if (typeof collectedParams == "object" && typeof collectedParams.username == "string") {
        clonedParams.username = collectedParams.username;
        clonedParams.password = collectedParams.password;
        clonedParams.pgpMessage.length = 0;
    }
    // return a likely-to-not-work param set if "valid", but warn via console.
    if (clonedParams.username.length == 0 && clonedParams.password.length == 0 && clonedParams.pgpMessage.length == 0) console.error("params collected for connection contain empty values and likely will not work.");
    return clonedParams;
};
const $27aaab216feba4f8$export$fd0d43738e43f2fa = (tokens, connectParams, openIDConfig)=>{
    const { idToken: idToken  } = tokens.idToken;
    const { accessToken: accessToken  } = tokens.accessToken;
    const { refreshToken: refreshToken  } = tokens.refreshToken;
    const { nonce: nonce  } = tokens;
    const filteredParams = Object.fromEntries(Object.entries(connectParams).filter(([_, v])=>v != null && v !== ""));
    return {
        nonce: nonce,
        idToken: idToken,
        accessToken: accessToken,
        refreshToken: refreshToken,
        refreshURI: openIDConfig.refreshUri,
        clientID: openIDConfig.clientId,
        ...filteredParams
    };
};
const $27aaab216feba4f8$export$d5cfc818341ecdd0 = async (basePath, queryStringParams)=>{
    let responseData = undefined;
    try {
        (0, $b4498450c1e534ee$export$2e2bcd8739ae039).spinnerScreen(true, "connecting");
        responseData = await $27aaab216feba4f8$export$64605811ab45167f(basePath + "/rs/agent/connect", queryStringParams);
        return {
            connectionKey: responseData?.connectionKey,
            error: responseData.reason?.text
        };
    } catch (error) {
        console.error(`abstract connect error : ${error}`);
        return {
            error: error.message,
            connectionKey: undefined
        };
    } finally{
        (0, $b4498450c1e534ee$export$2e2bcd8739ae039).spinnerScreen(false, "connecting");
    }
};
const $27aaab216feba4f8$export$58a8096b2082cb12 = (key)=>{
    // first store the connection key in the local storage
    if (key) {
        (0, $b4498450c1e534ee$export$2e2bcd8739ae039).spinnerScreen(true, "redirecting");
        window.localStorage.setItem((0, $5cdc329eeebd56d0$export$1a988e7317c65621).connectionkey, key);
        window.location = (0, $820877bea407f5fe$export$2e2bcd8739ae039).getRedirectPage();
    } else {
        const errorMessage = "Missing connectionkey while trying to redirect to express page! ";
        (0, $1c5d27fb6ee3c0b3$export$2e2bcd8739ae039).info(errorMessage);
        throw new Error(errorMessage);
    }
};
async function $27aaab216feba4f8$export$64605811ab45167f(url, params) {
    url = new URL(url);
    url.search = new URLSearchParams(params).toString();
    // later, will be conditionally modified before finally being passed into the Ajax call
    let fetchOptions = {
        method: "GET",
        cache: "no-cache"
    };
    // if there is a pgpMessage present, switch type to POST, which the TransferAgent
    // will recognize as being the REST call for use with pgpMessage
    if (typeof params.pgpMessage !== "undefined") {
        if (params.pgpMessage.length > 0) {
            // pgpMessage can come in as an array of strings (one per line of the message)
            if ($.isArray(params.pgpMessage)) params.pgpMessage = params.pgpMessage.join("\n");
            // could pgpMessage be popped out after processing?
            params.MungedConnectionRequest = params.pgpMessage;
            fetchOptions.method = "POST";
            fetchOptions.headers = {
                "Content-Type": "application/json"
            };
            fetchOptions.body = JSON.stringify(params);
        }
    }
    const response = await fetch(url, fetchOptions);
    console.info(`got a response to connect call`);
    return response.json();
}
async function $27aaab216feba4f8$export$f852e4624167b535(basePath, testLogin = "false") {
    let connectionKey = localStorage.getItem((0, $5cdc329eeebd56d0$export$1a988e7317c65621).connectionkey);
    (0, $1c5d27fb6ee3c0b3$export$2e2bcd8739ae039).info(`checking if connection key ${connectionKey} is valid`);
    if (connectionKey) try {
        const response = await fetch(`${basePath}/rs/agent/connect/${connectionKey}?testLogin=${testLogin}`);
        (0, $1c5d27fb6ee3c0b3$export$2e2bcd8739ae039).debug(`response for validating connection key : ${response.statusText}`);
        return response.ok;
    } catch (err) {
        (0, $1c5d27fb6ee3c0b3$export$2e2bcd8739ae039).info(`Error occured while checking for valid connection key : ${err}`);
    }
    return false;
}






var $glDqU = parcelRequire("glDqU");


function $dddf3c342e27f73e$export$e0140f228bdc8762({ basePath: basePath , errorMessage: errorMessage  }) {
    const [fcUserName, setUserName] = (0, $acw62.useState)("");
    const [fcPassword, setPassword] = (0, $acw62.useState)("");
    const [errorVisible, setErrorVisible] = (0, $acw62.useState)(!(0, $glDqU.isEmpty)(errorMessage));
    const [errorText, setErrorText] = (0, $acw62.useState)(errorMessage);
    console.info(`Logon component initializing`);
    const login = async (e)=>{
        e.preventDefault();
        (0, $1c5d27fb6ee3c0b3$export$2e2bcd8739ae039).info(`Logging in with standard mechanism for user : ${fcUserName}`);
        // capture form values and merge them with existing config
        const collected = {
            username: fcUserName,
            password: fcPassword
        };
        const params = (0, $27aaab216feba4f8$export$cc60198cc811316)((0, $e836a774916461d1$export$7ceeb2067f6edf7f)(), collected);
        try {
            let connectionResult = await (0, $27aaab216feba4f8$export$d5cfc818341ecdd0)(basePath, params);
            if (typeof connectionResult?.connectionKey == "string") (0, $27aaab216feba4f8$export$58a8096b2082cb12)(connectionResult.connectionKey);
            else {
                setErrorText(connectionResult.error);
                setErrorVisible(true);
            }
        } catch (error) {
            console.error(`error caught : ${error.message}`);
            setErrorText(error.message);
            setErrorVisible(true);
        }
    };
    const getOAuthLoginBtn = (config)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
            className: config.buttonClass,
            onClick: handleOpenIDLogin(config),
            children: config.buttonLabel
        }, config.clientId);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        class: "col-xs-6 col-xs-offset-3",
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
            id: "loginPanel",
            class: "panel panel-default",
            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                class: "panel-body",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                        className: "center-block",
                        id: "logo",
                        src: "./images/filecatalyst_small.png"
                    }),
                    errorVisible && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        class: "alert alert-danger",
                        id: "errorBox",
                        children: errorText
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("form", {
                        id: "fc_login",
                        onSubmit: login,
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "form-group",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                        htmlFor: "username",
                                        children: (0, $01f9c2ffd7693c68$export$2e2bcd8739ae039).t("common.userNameLabel")
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                        type: "text",
                                        className: "form-control",
                                        id: "username",
                                        name: "username",
                                        placeholder: "Username",
                                        onInput: (e)=>setUserName(e.target.value)
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "form-group",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                        htmlFor: "password",
                                        children: (0, $01f9c2ffd7693c68$export$2e2bcd8739ae039).t("common.passwordLabel")
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                        type: "password",
                                        className: "form-control",
                                        id: "password",
                                        name: "password",
                                        placeholder: "Password",
                                        onInput: (e)=>setPassword(e.target.value)
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                    className: "btn btn-primary btn-block",
                                    id: "fcSubmit",
                                    type: "submit",
                                    children: (0, $01f9c2ffd7693c68$export$2e2bcd8739ae039).t("common.signIn")
                                })
                            }),
                            (0, $377959a7b0bd1524$export$2e2bcd8739ae039) && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                class: "text-center divider",
                                children: "OR"
                            }),
                            (0, $377959a7b0bd1524$export$2e2bcd8739ae039) && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                children: OAuthConfigs.map((config)=>getOAuthLoginBtn(config))
                            })
                        ]
                    })
                ]
            })
        })
    });
    function handleOpenIDLogin(config) {
        return (e)=>{
            e.preventDefault();
            window.sessionStorage.setItem((0, $5cdc329eeebd56d0$export$1a988e7317c65621).oidcClientId, config.clientId);
            (0, $377959a7b0bd1524$export$2e2bcd8739ae039).login(config.clientId).catch((error)=>{
                setErrorText($dddf3c342e27f73e$var$extractOAuthAPIErrorMessage(error));
                setErrorVisible(true);
            });
        };
    }
}
function $dddf3c342e27f73e$var$extractOAuthAPIErrorMessage(error) {
    if (error?.message) return error.name?.includes("AuthSdkError") || error.name.includes("AuthApiError") ? (0, $01f9c2ffd7693c68$export$2e2bcd8739ae039).t("common.oauth.apiError", {
        errMsg: error.message
    }) : error.message;
    else return (0, $01f9c2ffd7693c68$export$2e2bcd8739ae039).t("common.oauth.emptyError");
}













var $glDqU = parcelRequire("glDqU");

function $4c8cda5d2c6d1d8b$export$86fbec116b87613f() {
    console.log(`App being initialized...`);
    const [showLoginForm, setShowLoginForm] = (0, $acw62.useState)(false);
    const loginError = (0, $acw62.useRef)("");
    (0, $acw62.useEffect)(()=>{
        async function startupSequence() {
            await (0, $01f9c2ffd7693c68$export$2d3542df2a1993a);
            try {
                if ((0, $1eca2a76dbd7310b$export$2e2bcd8739ae039).remoteServersProvided()) {
                    // show a spinner prior to this process
                    (0, $b4498450c1e534ee$export$2e2bcd8739ae039).spinnerScreen(true, "heartbeat");
                    $4c8cda5d2c6d1d8b$var$setFCLoginPath();
                    await (0, $f43e938a8b65a516$export$2e2bcd8739ae039).quickCheck();
                    (0, $1eca2a76dbd7310b$export$2e2bcd8739ae039).afterTaConfirmed(()=>true, (0, $5164b71a901e55cc$export$3e5dac20ecd3882d));
                    (0, $b4498450c1e534ee$export$2e2bcd8739ae039).taLaunchVisualCleanup();
                    // this should not throw any error otherwise
                    // it's just gonna vbe considered a quickCheck fail in the catch block
                    await startLogin();
                } else (0, $b4498450c1e534ee$export$2e2bcd8739ae039).dialog((0, $01f9c2ffd7693c68$export$2e2bcd8739ae039).t("webDeployment.errorRemoteNotConfiguredMsg"));
            } catch (error) {
                const found = (0, $f43e938a8b65a516$export$2e2bcd8739ae039).getLocal("ta_found") == true || (0, $f43e938a8b65a516$export$2e2bcd8739ae039).getLocal("ta_found") == "true";
                console.info("quickCheck failed, moving to launch: " + error);
                console.info("initiating Launch process");
                if (found) await launchProcess();
                else (0, $b4498450c1e534ee$export$2e2bcd8739ae039).manualLaunch(()=>{
                    setShowLoginForm(true);
                }, ()=>{
                    (0, $5164b71a901e55cc$export$3e5dac20ecd3882d)();
                    setShowLoginForm(true);
                });
                return;
            } finally{
                (0, $b4498450c1e534ee$export$2e2bcd8739ae039).spinnerScreen(false, "heartbeat");
            }
        }
        startupSequence();
    }, []);
    const launchProcess = async ()=>{
        (0, $f43e938a8b65a516$export$2e2bcd8739ae039).launch();
        (0, $f43e938a8b65a516$export$2e2bcd8739ae039).pollHeartbeat().then(async function() {
            (0, $1eca2a76dbd7310b$export$2e2bcd8739ae039).afterTaConfirmed(()=>true, (0, $5164b71a901e55cc$export$3e5dac20ecd3882d)); // If they have valid PGP/ connectionkey, won't get chance to upgrade???
            (0, $b4498450c1e534ee$export$2e2bcd8739ae039).taLaunchVisualCleanup();
            await startLogin();
        }).catch(function() {
            (0, $b4498450c1e534ee$export$2e2bcd8739ae039).launchFailed();
        });
    };
    const startLogin = async ()=>{
        console.log("Found a TA; time to start logging in");
        try {
            await attemptAutomaticLogin();
        } catch (error) {
            (0, $1c5d27fb6ee3c0b3$export$2e2bcd8739ae039).info(`Error occurred while trying to log the user in ${JSON.stringify(error)}`);
            displayFormWithError(error.toString());
        }
    };
    const attemptAutomaticLogin = async ()=>{
        (0, $820877bea407f5fe$export$2e2bcd8739ae039).parseQueryStringForRedirectTo();
        if (await (0, $27aaab216feba4f8$export$f852e4624167b535)((0, $f43e938a8b65a516$export$2e2bcd8739ae039).basePath, true)) (0, $27aaab216feba4f8$export$58a8096b2082cb12)(window.localStorage.getItem((0, $5cdc329eeebd56d0$export$1a988e7317c65621).connectionkey));
        else window.localStorage.removeItem((0, $5cdc329eeebd56d0$export$1a988e7317c65621).connectionkey);
        //
        // alias for convenience
        const remoteSiteConfig = (0, $e836a774916461d1$export$7ceeb2067f6edf7f)();
        const cliendIdLogginIn = window.sessionStorage.getItem((0, $5cdc329eeebd56d0$export$1a988e7317c65621).oidcClientId);
        if (cliendIdLogginIn && (0, $377959a7b0bd1524$export$2e2bcd8739ae039)?.isOIDCRedirect(cliendIdLogginIn)) {
            let tokens = await (0, $377959a7b0bd1524$export$2e2bcd8739ae039).login(cliendIdLogginIn);
            const openIDConfig = (0, $820877bea407f5fe$export$2e2bcd8739ae039).findConfigByClientId(OAuthConfigs, cliendIdLogginIn);
            tokens = {
                nonce: (0, $820877bea407f5fe$export$2e2bcd8739ae039).getCookieVal((0, $5cdc329eeebd56d0$export$1a988e7317c65621).nonceCookieName(openIDConfig)),
                ...tokens
            };
            const mergedConfig = (0, $27aaab216feba4f8$export$fd0d43738e43f2fa)(tokens, remoteSiteConfig, openIDConfig);
            // time to fire connect request
            let connectionResult = await (0, $27aaab216feba4f8$export$d5cfc818341ecdd0)((0, $f43e938a8b65a516$export$2e2bcd8739ae039).basePath, mergedConfig);
            if (typeof connectionResult?.connectionKey == "string") (0, $27aaab216feba4f8$export$58a8096b2082cb12)(connectionResult.connectionKey);
            else displayFormWithError(connectionResult.error);
        } else {
            window.sessionStorage.removeItem((0, $5cdc329eeebd56d0$export$1a988e7317c65621).oidcClientId);
            if (remoteSiteConfig.username.length > 0 || remoteSiteConfig.pgpMessage.length > 0) {
                let connectionResult = await (0, $27aaab216feba4f8$export$d5cfc818341ecdd0)((0, $f43e938a8b65a516$export$2e2bcd8739ae039).basePath, remoteSiteConfig);
                if (typeof connectionResult?.connectionKey == "string") (0, $27aaab216feba4f8$export$58a8096b2082cb12)(connectionResult.connectionKey);
                else displayFormWithError(connectionResult.error);
            } else {
                const currentURL = new URL(window.location);
                const errorString = currentURL.searchParams.get((0, $5cdc329eeebd56d0$export$1a988e7317c65621).fcerrorparam);
                if ((0, $glDqU.isEmpty)(errorString)) setShowLoginForm(true);
                else displayFormWithError(errorString);
            }
        }
    };
    const displayFormWithError = (possibleErrorText)=>{
        loginError.current = possibleErrorText;
        setShowLoginForm(true);
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).StrictMode, {
            children: showLoginForm && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $dddf3c342e27f73e$export$e0140f228bdc8762), {
                errorMessage: loginError.current,
                basePath: (0, $f43e938a8b65a516$export$2e2bcd8739ae039).basePath
            })
        })
    });
}
function $4c8cda5d2c6d1d8b$var$setFCLoginPath() {
    const fcloginPagePath = window.location.origin + window.location.pathname;
    window.sessionStorage.setItem((0, $5cdc329eeebd56d0$export$1a988e7317c65621).fcloginPagePath, fcloginPagePath);
}


"use strict";
const $35da740d59af89ba$var$app = document.getElementById("app");
(0, (/*@__PURE__*/$parcel$interopDefault($11492dca620dcaa5$exports))).render(/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4c8cda5d2c6d1d8b$export$86fbec116b87613f), {}), $35da740d59af89ba$var$app);


//# sourceMappingURL=fclogin.js.map
